/**
 * @description browser polyfill
 * @author wangfupeng
 */
var _a$4;
// @ts-nocheck
// 必须是浏览器环境
if (typeof global === 'undefined') {
    // 检查 IE 浏览器
    if ('ActiveXObject' in window) {
        var info = '抱歉，wangEditor V5+ 版本开始，不在支持 IE 浏览器';
        info += '\n Sorry, wangEditor V5+ versions do not support IE browser.';
        console.error(info);
    }
    globalThisPolyfill();
    AggregateErrorPolyfill();
}
else if (global && ((_a$4 = global.navigator) === null || _a$4 === void 0 ? void 0 : _a$4.userAgent.match('QQBrowser'))) {
    // 兼容 QQ 浏览器 AggregateError 报错
    globalThisPolyfill();
    AggregateErrorPolyfill();
}
function globalThisPolyfill() {
    // 部分浏览器不支持 globalThis
    if (typeof globalThis === 'undefined') {
        // @ts-ignore
        window.globalThis = window;
    }
}
function AggregateErrorPolyfill() {
    if (typeof AggregateError === 'undefined') {
        window.AggregateError = function (errors, msg) {
            var err = new Error(msg);
            err.errors = errors;
            return err;
        };
    }
}

/**
 * @description node polyfill
 * @author wangfupeng
 */
// @ts-nocheck
// 必须是 node 环境
if (typeof global === 'object') {
    // 用于 nodejs ，避免报错
    var globalProperty = Object.getOwnPropertyDescriptor(global, 'window');
    // global.window 为空则直接写入
    // 部分框架下已经定义了global.window且是不可写属性
    if (!global.window || globalProperty.set) {
        global.window = global;
        global.requestAnimationFrame = function () { };
        global.navigator = {
            userAgent: '',
        };
        global.location = {
            hostname: '0.0.0.0',
            port: 0,
            protocol: 'http:',
        };
        global.btoa = function () { };
        global.crypto = {
            getRandomValues: function (buffer) {
                return nodeCrypto.randomFillSync(buffer);
            },
        };
    }
    if (global.document != null) {
        // SSR 环境下可能会报错 （issue 4409）
        if (global.document.getElementsByTagName == null) {
            global.document.getElementsByTagName = function () { return []; };
        }
    }
}

/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject$5(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject(o) {
  var ctor,prot;

  if (isObject$5(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (ctor === undefined) return true;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObject$5(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}

function n(n){for(var t=arguments.length,r=Array(t>1?t-1:0),e=1;e<t;e++)r[e-1]=arguments[e];{var i=Y$6[n],o=i?"function"==typeof i?i.apply(null,r):i:"unknown error nr: "+n;throw Error("[Immer] "+o)}}function t(n){return !!n&&!!n[Q$6]}function r(n){return !!n&&(function(n){if(!n||"object"!=typeof n)return !1;var t=Object.getPrototypeOf(n);if(null===t)return !0;var r=Object.hasOwnProperty.call(t,"constructor")&&t.constructor;return r===Object||"function"==typeof r&&Function.toString.call(r)===Z$6}(n)||Array.isArray(n)||!!n[L$5]||!!n.constructor[L$5]||s(n)||v$2(n))}function i(n,t,r){void 0===r&&(r=!1),0===o(n)?(r?Object.keys:nn$7)(n).forEach((function(e){r&&"symbol"==typeof e||t(e,n[e],n);})):n.forEach((function(r,e){return t(e,r,n)}));}function o(n){var t=n[Q$6];return t?t.i>3?t.i-4:t.i:Array.isArray(n)?1:s(n)?2:v$2(n)?3:0}function u$1(n,t){return 2===o(n)?n.has(t):Object.prototype.hasOwnProperty.call(n,t)}function a(n,t){return 2===o(n)?n.get(t):n[t]}function f$2(n,t,r){var e=o(n);2===e?n.set(t,r):3===e?(n.delete(t),n.add(r)):n[t]=r;}function c$1(n,t){return n===t?0!==n||1/n==1/t:n!=n&&t!=t}function s(n){return X$6&&n instanceof Map}function v$2(n){return q$6&&n instanceof Set}function p$3(n){return n.o||n.t}function l$1(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var t=tn$7(n);delete t[Q$6];for(var r=nn$7(t),e=0;e<r.length;e++){var i=r[e],o=t[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(t[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]});}return Object.create(Object.getPrototypeOf(n),t)}function d$3(n,e){return void 0===e&&(e=!1),y$3(n)||t(n)||!r(n)?n:(o(n)>1&&(n.set=n.add=n.clear=n.delete=h$4),Object.freeze(n),e&&i(n,(function(n,t){return d$3(t,!0)}),!0),n)}function h$4(){n(2);}function y$3(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b$3(t){var r=rn$7[t];return r||n(18,t),r}function _$6(){return U$6||n(0),U$6}function j$5(n,t){t&&(b$3("Patches"),n.u=[],n.s=[],n.v=t);}function O$5(n){g$3(n),n.p.forEach(S$4),n.p=null;}function g$3(n){n===U$6&&(U$6=n.l);}function w$3(n){return U$6={p:[],l:U$6,h:n,m:!0,_:0}}function S$4(n){var t=n[Q$6];0===t.i||1===t.i?t.j():t.O=!0;}function P$5(t,e){e._=e.p.length;var i=e.p[0],o=void 0!==t&&t!==i;return e.h.g||b$3("ES5").S(e,t,o),o?(i[Q$6].P&&(O$5(e),n(4)),r(t)&&(t=M$4(e,t),e.l||x$4(e,t)),e.u&&b$3("Patches").M(i[Q$6],t,e.u,e.s)):t=M$4(e,i,[]),O$5(e),e.u&&e.v(e.u,e.s),t!==H$5?t:void 0}function M$4(n,t,r){if(y$3(t))return t;var e=t[Q$6];if(!e)return i(t,(function(i,o){return A$5(n,e,t,i,o,r)}),!0),t;if(e.A!==n)return t;if(!e.P)return x$4(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l$1(e.k):e.o;i(3===e.i?new Set(o):o,(function(t,i){return A$5(n,e,o,t,i,r)})),x$4(n,o,!1),r&&n.u&&b$3("Patches").R(e,r,n.u,n.s);}return e.o}function A$5(e,i,o,a,c,s){if(c===o&&n(5),t(c)){var v=M$4(e,c,s&&i&&3!==i.i&&!u$1(i.D,a)?s.concat(a):void 0);if(f$2(o,a,v),!t(v))return;e.m=!1;}if(r(c)&&!y$3(c)){if(!e.h.F&&e._<1)return;M$4(e,c),i&&i.A.l||x$4(e,c);}}function x$4(n,t,r){void 0===r&&(r=!1),n.h.F&&n.m&&d$3(t,r);}function z$5(n,t){var r=n[Q$6];return (r?p$3(r):n)[t]}function I$5(n,t){if(t in n)for(var r=Object.getPrototypeOf(n);r;){var e=Object.getOwnPropertyDescriptor(r,t);if(e)return e;r=Object.getPrototypeOf(r);}}function k$5(n){n.P||(n.P=!0,n.l&&k$5(n.l));}function E$4(n){n.o||(n.o=l$1(n.t));}function R$5(n,t,r){var e=s(t)?b$3("MapSet").N(t,r):v$2(t)?b$3("MapSet").T(t,r):n.g?function(n,t){var r=Array.isArray(n),e={i:r?1:0,A:t?t.A:_$6(),P:!1,I:!1,D:{},l:t,t:n,k:null,o:null,j:null,C:!1},i=e,o=en$7;r&&(i=[e],o=on$8);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(t,r):b$3("ES5").J(t,r);return (r?r.A:_$6()).p.push(e),e}function D$5(e){return t(e)||n(22,e),function n(t){if(!r(t))return t;var e,u=t[Q$6],c=o(t);if(u){if(!u.P&&(u.i<4||!b$3("ES5").K(u)))return u.t;u.I=!0,e=F$5(t,c),u.I=!1;}else e=F$5(t,c);return i(e,(function(t,r){u&&a(u.t,t)===r||f$2(e,t,n(r));})),3===c?new Set(e):e}(e)}function F$5(n,t){switch(t){case 2:return new Map(n);case 3:return Array.from(n)}return l$1(n)}var G$6,U$6,W$6="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X$6="undefined"!=typeof Map,q$6="undefined"!=typeof Set,B$5="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H$5=W$6?Symbol.for("immer-nothing"):((G$6={})["immer-nothing"]=!0,G$6),L$5=W$6?Symbol.for("immer-draftable"):"__$immer_draftable",Q$6=W$6?Symbol.for("immer-state"):"__$immer_state",Y$6={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return "Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return "Unsupported patch operation: "+n},18:function(n){return "The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return "'current' expects a draft, got: "+n},23:function(n){return "'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z$6=""+Object.prototype.constructor,nn$7="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,tn$7=Object.getOwnPropertyDescriptors||function(n){var t={};return nn$7(n).forEach((function(r){t[r]=Object.getOwnPropertyDescriptor(n,r);})),t},rn$7={},en$7={get:function(n,t){if(t===Q$6)return n;var e=p$3(n);if(!u$1(e,t))return function(n,t,r){var e,i=I$5(t,r);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,t);var i=e[t];return n.I||!r(i)?i:i===z$5(n.t,t)?(E$4(n),n.o[t]=R$5(n.A.h,i,n)):i},has:function(n,t){return t in p$3(n)},ownKeys:function(n){return Reflect.ownKeys(p$3(n))},set:function(n,t,r){var e=I$5(p$3(n),t);if(null==e?void 0:e.set)return e.set.call(n.k,r),!0;if(!n.P){var i=z$5(p$3(n),t),o=null==i?void 0:i[Q$6];if(o&&o.t===r)return n.o[t]=r,n.D[t]=!1,!0;if(c$1(r,i)&&(void 0!==r||u$1(n.t,t)))return !0;E$4(n),k$5(n);}return n.o[t]===r&&"number"!=typeof r&&(void 0!==r||t in n.o)||(n.o[t]=r,n.D[t]=!0,!0)},deleteProperty:function(n,t){return void 0!==z$5(n.t,t)||t in n.t?(n.D[t]=!1,E$4(n),k$5(n)):delete n.D[t],n.o&&delete n.o[t],!0},getOwnPropertyDescriptor:function(n,t){var r=p$3(n),e=Reflect.getOwnPropertyDescriptor(r,t);return e?{writable:!0,configurable:1!==n.i||"length"!==t,enumerable:e.enumerable,value:r[t]}:e},defineProperty:function(){n(11);},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12);}},on$8={};i(en$7,(function(n,t){on$8[n]=function(){return arguments[0]=arguments[0][0],t.apply(this,arguments)};})),on$8.deleteProperty=function(t,r){return isNaN(parseInt(r))&&n(13),en$7.deleteProperty.call(this,t[0],r)},on$8.set=function(t,r,e){return "length"!==r&&isNaN(parseInt(r))&&n(14),en$7.set.call(this,t[0],r,e,t[0])};var un$7=function(){function e(t){var e=this;this.g=B$5,this.F=!0,this.produce=function(t,i,o){if("function"==typeof t&&"function"!=typeof i){var u=i;i=t;var a=e;return function(n){var t=this;void 0===n&&(n=u);for(var r=arguments.length,e=Array(r>1?r-1:0),o=1;o<r;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var r;return (r=i).call.apply(r,[t,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),r(t)){var c=w$3(e),s=R$5(e,t,void 0),v=!0;try{f=i(s),v=!1;}finally{v?O$5(c):g$3(c);}return "undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j$5(c,o),P$5(n,c)}),(function(n){throw O$5(c),n})):(j$5(c,o),P$5(f,c))}if(!t||"object"!=typeof t){if((f=i(t))===H$5)return;return void 0===f&&(f=t),e.F&&d$3(f,!0),f}n(21,t);},this.produceWithPatches=function(n,t){return "function"==typeof n?function(t){for(var r=arguments.length,i=Array(r>1?r-1:0),o=1;o<r;o++)i[o-1]=arguments[o];return e.produceWithPatches(t,(function(t){return n.apply(void 0,[t].concat(i))}))}:[e.produce(n,t,(function(n,t){r=n,i=t;})),r,i];var r,i;},"boolean"==typeof(null==t?void 0:t.useProxies)&&this.setUseProxies(t.useProxies),"boolean"==typeof(null==t?void 0:t.autoFreeze)&&this.setAutoFreeze(t.autoFreeze);}var i=e.prototype;return i.createDraft=function(e){r(e)||n(8),t(e)&&(e=D$5(e));var i=w$3(this),o=R$5(this,e,void 0);return o[Q$6].C=!0,g$3(i),o},i.finishDraft=function(t,r){var e=t&&t[Q$6];(e&&e.C||n(9),e.I&&n(10));var i=e.A;return j$5(i,r),P$5(void 0,i)},i.setAutoFreeze=function(n){this.F=n;},i.setUseProxies=function(t){t&&!B$5&&n(20),this.g=t;},i.applyPatches=function(n,r){var e;for(e=r.length-1;e>=0;e--){var i=r[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(r=r.slice(e+1));var o=b$3("Patches").$;return t(n)?o(n,r):this.produce(n,(function(n){return o(n,r)}))},e}(),an$7=new un$7,fn$7=an$7.produce;an$7.produceWithPatches.bind(an$7);an$7.setAutoFreeze.bind(an$7);an$7.setUseProxies.bind(an$7);an$7.applyPatches.bind(an$7);var ln$7=an$7.createDraft.bind(an$7),dn$7=an$7.finishDraft.bind(an$7);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DIRTY_PATHS = new WeakMap();
var FLUSHING = new WeakMap();
var NORMALIZING = new WeakMap();
var PATH_REFS = new WeakMap();
var POINT_REFS = new WeakMap();
var RANGE_REFS = new WeakMap();

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Create a new Slate `Editor` object.
 */

var createEditor$1 = () => {
  var editor = {
    children: [],
    operations: [],
    selection: null,
    marks: null,
    isInline: () => false,
    isVoid: () => false,
    onChange: () => {},
    apply: op => {
      for (var ref of Editor.pathRefs(editor)) {
        PathRef.transform(ref, op);
      }

      for (var _ref of Editor.pointRefs(editor)) {
        PointRef.transform(_ref, op);
      }

      for (var _ref2 of Editor.rangeRefs(editor)) {
        RangeRef.transform(_ref2, op);
      }

      var set = new Set();
      var dirtyPaths = [];

      var add = path => {
        if (path) {
          var key = path.join(',');

          if (!set.has(key)) {
            set.add(key);
            dirtyPaths.push(path);
          }
        }
      };

      var oldDirtyPaths = DIRTY_PATHS.get(editor) || [];
      var newDirtyPaths = getDirtyPaths(op);

      for (var path of oldDirtyPaths) {
        var newPath = Path.transform(path, op);
        add(newPath);
      }

      for (var _path of newDirtyPaths) {
        add(_path);
      }

      DIRTY_PATHS.set(editor, dirtyPaths);
      Transforms.transform(editor, op);
      editor.operations.push(op);
      Editor.normalize(editor); // Clear any formats applied to the cursor if the selection changes.

      if (op.type === 'set_selection') {
        editor.marks = null;
      }

      if (!FLUSHING.get(editor)) {
        FLUSHING.set(editor, true);
        Promise.resolve().then(() => {
          FLUSHING.set(editor, false);
          editor.onChange();
          editor.operations = [];
        });
      }
    },
    addMark: (key, value) => {
      var {
        selection
      } = editor;

      if (selection) {
        if (Range.isExpanded(selection)) {
          Transforms.setNodes(editor, {
            [key]: value
          }, {
            match: Text.isText,
            split: true
          });
        } else {
          var marks = _objectSpread$9(_objectSpread$9({}, Editor.marks(editor) || {}), {}, {
            [key]: value
          });

          editor.marks = marks;

          if (!FLUSHING.get(editor)) {
            editor.onChange();
          }
        }
      }
    },
    deleteBackward: unit => {
      var {
        selection
      } = editor;

      if (selection && Range.isCollapsed(selection)) {
        Transforms.delete(editor, {
          unit,
          reverse: true
        });
      }
    },
    deleteForward: unit => {
      var {
        selection
      } = editor;

      if (selection && Range.isCollapsed(selection)) {
        Transforms.delete(editor, {
          unit
        });
      }
    },
    deleteFragment: direction => {
      var {
        selection
      } = editor;

      if (selection && Range.isExpanded(selection)) {
        Transforms.delete(editor, {
          reverse: direction === 'backward'
        });
      }
    },
    getFragment: () => {
      var {
        selection
      } = editor;

      if (selection) {
        return Node$1.fragment(editor, selection);
      }

      return [];
    },
    insertBreak: () => {
      Transforms.splitNodes(editor, {
        always: true
      });
    },
    insertFragment: fragment => {
      Transforms.insertFragment(editor, fragment);
    },
    insertNode: node => {
      Transforms.insertNodes(editor, node);
    },
    insertText: text => {
      var {
        selection,
        marks
      } = editor;

      if (selection) {
        if (marks) {
          var node = _objectSpread$9({
            text
          }, marks);

          Transforms.insertNodes(editor, node);
        } else {
          Transforms.insertText(editor, text);
        }

        editor.marks = null;
      }
    },
    normalizeNode: entry => {
      var [node, path] = entry; // There are no core normalizations for text nodes.

      if (Text.isText(node)) {
        return;
      } // Ensure that block and inline nodes have at least one text child.


      if (Element$1.isElement(node) && node.children.length === 0) {
        var child = {
          text: ''
        };
        Transforms.insertNodes(editor, child, {
          at: path.concat(0),
          voids: true
        });
        return;
      } // Determine whether the node should have block or inline children.


      var shouldHaveInlines = Editor.isEditor(node) ? false : Element$1.isElement(node) && (editor.isInline(node) || node.children.length === 0 || Text.isText(node.children[0]) || editor.isInline(node.children[0])); // Since we'll be applying operations while iterating, keep track of an
      // index that accounts for any added/removed nodes.

      var n = 0;

      for (var i = 0; i < node.children.length; i++, n++) {
        var currentNode = Node$1.get(editor, path);
        if (Text.isText(currentNode)) continue;
        var _child = node.children[i];
        var prev = currentNode.children[n - 1];
        var isLast = i === node.children.length - 1;
        var isInlineOrText = Text.isText(_child) || Element$1.isElement(_child) && editor.isInline(_child); // Only allow block nodes in the top-level children and parent blocks
        // that only contain block nodes. Similarly, only allow inline nodes in
        // other inline nodes, or parent blocks that only contain inlines and
        // text.

        if (isInlineOrText !== shouldHaveInlines) {
          Transforms.removeNodes(editor, {
            at: path.concat(n),
            voids: true
          });
          n--;
        } else if (Element$1.isElement(_child)) {
          // Ensure that inline nodes are surrounded by text nodes.
          if (editor.isInline(_child)) {
            if (prev == null || !Text.isText(prev)) {
              var newChild = {
                text: ''
              };
              Transforms.insertNodes(editor, newChild, {
                at: path.concat(n),
                voids: true
              });
              n++;
            } else if (isLast) {
              var _newChild = {
                text: ''
              };
              Transforms.insertNodes(editor, _newChild, {
                at: path.concat(n + 1),
                voids: true
              });
              n++;
            }
          }
        } else {
          // Merge adjacent text nodes that are empty or match.
          if (prev != null && Text.isText(prev)) {
            if (Text.equals(_child, prev, {
              loose: true
            })) {
              Transforms.mergeNodes(editor, {
                at: path.concat(n),
                voids: true
              });
              n--;
            } else if (prev.text === '') {
              Transforms.removeNodes(editor, {
                at: path.concat(n - 1),
                voids: true
              });
              n--;
            } else if (_child.text === '') {
              Transforms.removeNodes(editor, {
                at: path.concat(n),
                voids: true
              });
              n--;
            }
          }
        }
      }
    },
    removeMark: key => {
      var {
        selection
      } = editor;

      if (selection) {
        if (Range.isExpanded(selection)) {
          Transforms.unsetNodes(editor, key, {
            match: Text.isText,
            split: true
          });
        } else {
          var marks = _objectSpread$9({}, Editor.marks(editor) || {});

          delete marks[key];
          editor.marks = marks;

          if (!FLUSHING.get(editor)) {
            editor.onChange();
          }
        }
      }
    }
  };
  return editor;
};
/**
 * Get the "dirty" paths generated from an operation.
 */

var getDirtyPaths = op => {
  switch (op.type) {
    case 'insert_text':
    case 'remove_text':
    case 'set_node':
      {
        var {
          path
        } = op;
        return Path.levels(path);
      }

    case 'insert_node':
      {
        var {
          node,
          path: _path2
        } = op;
        var levels = Path.levels(_path2);
        var descendants = Text.isText(node) ? [] : Array.from(Node$1.nodes(node), _ref3 => {
          var [, p] = _ref3;
          return _path2.concat(p);
        });
        return [...levels, ...descendants];
      }

    case 'merge_node':
      {
        var {
          path: _path3
        } = op;
        var ancestors = Path.ancestors(_path3);
        var previousPath = Path.previous(_path3);
        return [...ancestors, previousPath];
      }

    case 'move_node':
      {
        var {
          path: _path4,
          newPath
        } = op;

        if (Path.equals(_path4, newPath)) {
          return [];
        }

        var oldAncestors = [];
        var newAncestors = [];

        for (var ancestor of Path.ancestors(_path4)) {
          var p = Path.transform(ancestor, op);
          oldAncestors.push(p);
        }

        for (var _ancestor of Path.ancestors(newPath)) {
          var _p = Path.transform(_ancestor, op);

          newAncestors.push(_p);
        }

        var newParent = newAncestors[newAncestors.length - 1];
        var newIndex = newPath[newPath.length - 1];
        var resultPath = newParent.concat(newIndex);
        return [...oldAncestors, ...newAncestors, resultPath];
      }

    case 'remove_node':
      {
        var {
          path: _path5
        } = op;

        var _ancestors = Path.ancestors(_path5);

        return [..._ancestors];
      }

    case 'split_node':
      {
        var {
          path: _path6
        } = op;

        var _levels = Path.levels(_path6);

        var nextPath = Path.next(_path6);
        return [..._levels, nextPath];
      }

    default:
      {
        return [];
      }
  }
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

// Character (grapheme cluster) boundaries are determined according to
// the default grapheme cluster boundary specification, extended grapheme clusters variant[1].
//
// References:
//
// [1] https://www.unicode.org/reports/tr29/#Default_Grapheme_Cluster_Table
// [2] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakProperty.txt
// [3] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.html
// [4] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.txt

/**
 * Get the distance to the end of the first character in a string of text.
 */
var getCharacterDistance = function getCharacterDistance(str) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isLTR = !isRTL;
  var codepoints = isRTL ? codepointsIteratorRTL(str) : str;
  var left = CodepointType.None;
  var right = CodepointType.None;
  var distance = 0; // Evaluation of these conditions are deferred.

  var gb11 = null; // Is GB11 applicable?

  var gb12Or13 = null; // Is GB12 or GB13 applicable?

  for (var char of codepoints) {
    var code = char.codePointAt(0);
    if (!code) break;
    var type = getCodepointType(char, code);
    [left, right] = isLTR ? [right, type] : [type, left];

    if (intersects(left, CodepointType.ZWJ) && intersects(right, CodepointType.ExtPict)) {
      if (isLTR) {
        gb11 = endsWithEmojiZWJ(str.substring(0, distance));
      } else {
        gb11 = endsWithEmojiZWJ(str.substring(0, str.length - distance));
      }

      if (!gb11) break;
    }

    if (intersects(left, CodepointType.RI) && intersects(right, CodepointType.RI)) {
      if (gb12Or13 !== null) {
        gb12Or13 = !gb12Or13;
      } else {
        if (isLTR) {
          gb12Or13 = true;
        } else {
          gb12Or13 = endsWithOddNumberOfRIs(str.substring(0, str.length - distance));
        }
      }

      if (!gb12Or13) break;
    }

    if (left !== CodepointType.None && right !== CodepointType.None && isBoundaryPair(left, right)) {
      break;
    }

    distance += char.length;
  }

  return distance || 1;
};
var SPACE = /\s/;
var PUNCTUATION = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
var CHAMELEON = /['\u2018\u2019]/;
/**
 * Get the distance to the end of the first word in a string of text.
 */

var getWordDistance = function getWordDistance(text) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var dist = 0;
  var started = false;

  while (text.length > 0) {
    var charDist = getCharacterDistance(text, isRTL);
    var [char, remaining] = splitByCharacterDistance(text, charDist, isRTL);

    if (isWordCharacter(char, remaining, isRTL)) {
      started = true;
      dist += charDist;
    } else if (!started) {
      dist += charDist;
    } else {
      break;
    }

    text = remaining;
  }

  return dist;
};
/**
 * Split a string in two parts at a given distance starting from the end when
 * `isRTL` is set to `true`.
 */

var splitByCharacterDistance = (str, dist, isRTL) => {
  if (isRTL) {
    var at = str.length - dist;
    return [str.slice(at, str.length), str.slice(0, at)];
  }

  return [str.slice(0, dist), str.slice(dist)];
};
/**
 * Check if a character is a word character. The `remaining` argument is used
 * because sometimes you must read subsequent characters to truly determine it.
 */

var isWordCharacter = function isWordCharacter(char, remaining) {
  var isRTL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (SPACE.test(char)) {
    return false;
  } // Chameleons count as word characters as long as they're in a word, so
  // recurse to see if the next one is a word character or not.


  if (CHAMELEON.test(char)) {
    var charDist = getCharacterDistance(remaining, isRTL);
    var [nextChar, nextRemaining] = splitByCharacterDistance(remaining, charDist, isRTL);

    if (isWordCharacter(nextChar, nextRemaining, isRTL)) {
      return true;
    }
  }

  if (PUNCTUATION.test(char)) {
    return false;
  }

  return true;
};
/**
 * Iterate on codepoints from right to left.
 */


var codepointsIteratorRTL = function* codepointsIteratorRTL(str) {
  var end = str.length - 1;

  for (var i = 0; i < str.length; i++) {
    var char1 = str.charAt(end - i);

    if (isLowSurrogate(char1.charCodeAt(0))) {
      var char2 = str.charAt(end - i - 1);

      if (isHighSurrogate(char2.charCodeAt(0))) {
        yield char2 + char1;
        i++;
        continue;
      }
    }

    yield char1;
  }
};
/**
 * Is `charCode` a high surrogate.
 *
 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
 */

var isHighSurrogate = charCode => {
  return charCode >= 0xd800 && charCode <= 0xdbff;
};
/**
 * Is `charCode` a low surrogate.
 *
 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
 */


var isLowSurrogate = charCode => {
  return charCode >= 0xdc00 && charCode <= 0xdfff;
};

var CodepointType;

(function (CodepointType) {
  CodepointType[CodepointType["None"] = 0] = "None";
  CodepointType[CodepointType["Extend"] = 1] = "Extend";
  CodepointType[CodepointType["ZWJ"] = 2] = "ZWJ";
  CodepointType[CodepointType["RI"] = 4] = "RI";
  CodepointType[CodepointType["Prepend"] = 8] = "Prepend";
  CodepointType[CodepointType["SpacingMark"] = 16] = "SpacingMark";
  CodepointType[CodepointType["L"] = 32] = "L";
  CodepointType[CodepointType["V"] = 64] = "V";
  CodepointType[CodepointType["T"] = 128] = "T";
  CodepointType[CodepointType["LV"] = 256] = "LV";
  CodepointType[CodepointType["LVT"] = 512] = "LVT";
  CodepointType[CodepointType["ExtPict"] = 1024] = "ExtPict";
  CodepointType[CodepointType["Any"] = 2048] = "Any";
})(CodepointType || (CodepointType = {}));

var reExtend = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/;
var rePrepend = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/;
var reSpacingMark = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/;
var reL = /^[\u1100-\u115F\uA960-\uA97C]$/;
var reV = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/;
var reT = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/;
var reLV = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/;
var reLVT = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/;
var reExtPict = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/;

var getCodepointType = (char, code) => {
  var type = CodepointType.Any;

  if (char.search(reExtend) !== -1) {
    type |= CodepointType.Extend;
  }

  if (code === 0x200d) {
    type |= CodepointType.ZWJ;
  }

  if (code >= 0x1f1e6 && code <= 0x1f1ff) {
    type |= CodepointType.RI;
  }

  if (char.search(rePrepend) !== -1) {
    type |= CodepointType.Prepend;
  }

  if (char.search(reSpacingMark) !== -1) {
    type |= CodepointType.SpacingMark;
  }

  if (char.search(reL) !== -1) {
    type |= CodepointType.L;
  }

  if (char.search(reV) !== -1) {
    type |= CodepointType.V;
  }

  if (char.search(reT) !== -1) {
    type |= CodepointType.T;
  }

  if (char.search(reLV) !== -1) {
    type |= CodepointType.LV;
  }

  if (char.search(reLVT) !== -1) {
    type |= CodepointType.LVT;
  }

  if (char.search(reExtPict) !== -1) {
    type |= CodepointType.ExtPict;
  }

  return type;
};

function intersects(x, y) {
  return (x & y) !== 0;
}

var NonBoundaryPairs = [// GB6
[CodepointType.L, CodepointType.L | CodepointType.V | CodepointType.LV | CodepointType.LVT], // GB7
[CodepointType.LV | CodepointType.V, CodepointType.V | CodepointType.T], // GB8
[CodepointType.LVT | CodepointType.T, CodepointType.T], // GB9
[CodepointType.Any, CodepointType.Extend | CodepointType.ZWJ], // GB9a
[CodepointType.Any, CodepointType.SpacingMark], // GB9b
[CodepointType.Prepend, CodepointType.Any], // GB11
[CodepointType.ZWJ, CodepointType.ExtPict], // GB12 and GB13
[CodepointType.RI, CodepointType.RI]];

function isBoundaryPair(left, right) {
  return NonBoundaryPairs.findIndex(r => intersects(left, r[0]) && intersects(right, r[1])) === -1;
}

var endingEmojiZWJ = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/;

var endsWithEmojiZWJ = str => {
  return str.search(endingEmojiZWJ) !== -1;
};

var endingRIs = /(?:\uD83C[\uDDE6-\uDDFF])+$/g;

var endsWithOddNumberOfRIs = str => {
  var match = str.match(endingRIs);

  if (match === null) {
    return false;
  } else {
    // A RI is represented by a surrogate pair.
    var numRIs = match[0].length / 2;
    return numRIs % 2 === 1;
  }
};

/**
 * Shared the function with isElementType utility
 */

var isElement$1 = value => {
  return isPlainObject(value) && Node$1.isNodeList(value.children) && !Editor.isEditor(value);
};

var Element$1 = {
  /**
   * Check if a value implements the 'Ancestor' interface.
   */
  isAncestor(value) {
    return isPlainObject(value) && Node$1.isNodeList(value.children);
  },

  /**
   * Check if a value implements the `Element` interface.
   */
  isElement: isElement$1,

  /**
   * Check if a value is an array of `Element` objects.
   */
  isElementList(value) {
    return Array.isArray(value) && value.every(val => Element$1.isElement(val));
  },

  /**
   * Check if a set of props is a partial of Element.
   */
  isElementProps(props) {
    return props.children !== undefined;
  },

  /**
   * Check if a value implements the `Element` interface and has elementKey with selected value.
   * Default it check to `type` key value
   */
  isElementType: function isElementType(value, elementVal) {
    var elementKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'type';
    return isElement$1(value) && value[elementKey] === elementVal;
  },

  /**
   * Check if an element matches set of properties.
   *
   * Note: this checks custom properties, and it does not ensure that any
   * children are equivalent.
   */
  matches(element, props) {
    for (var key in props) {
      if (key === 'children') {
        continue;
      }

      if (element[key] !== props[key]) {
        return false;
      }
    }

    return true;
  }

};

var _excluded$4 = ["text"],
    _excluded2$3 = ["text"];

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var IS_EDITOR_CACHE = new WeakMap();
var Editor = {
  /**
   * Get the ancestor above a location in the document.
   */
  above(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      voids = false,
      mode = 'lowest',
      at = editor.selection,
      match
    } = options;

    if (!at) {
      return;
    }

    var path = Editor.path(editor, at);
    var reverse = mode === 'lowest';

    for (var [n, p] of Editor.levels(editor, {
      at: path,
      voids,
      match,
      reverse
    })) {
      if (!Text.isText(n) && !Path.equals(path, p)) {
        return [n, p];
      }
    }
  },

  /**
   * Add a custom property to the leaf text nodes in the current selection.
   *
   * If the selection is currently collapsed, the marks will be added to the
   * `editor.marks` property instead, and applied when text is inserted next.
   */
  addMark(editor, key, value) {
    editor.addMark(key, value);
  },

  /**
   * Get the point after a location.
   */
  after(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var anchor = Editor.point(editor, at, {
      edge: 'end'
    });
    var focus = Editor.end(editor, []);
    var range = {
      anchor,
      focus
    };
    var {
      distance = 1
    } = options;
    var d = 0;
    var target;

    for (var p of Editor.positions(editor, _objectSpread$8(_objectSpread$8({}, options), {}, {
      at: range
    }))) {
      if (d > distance) {
        break;
      }

      if (d !== 0) {
        target = p;
      }

      d++;
    }

    return target;
  },

  /**
   * Get the point before a location.
   */
  before(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var anchor = Editor.start(editor, []);
    var focus = Editor.point(editor, at, {
      edge: 'start'
    });
    var range = {
      anchor,
      focus
    };
    var {
      distance = 1
    } = options;
    var d = 0;
    var target;

    for (var p of Editor.positions(editor, _objectSpread$8(_objectSpread$8({}, options), {}, {
      at: range,
      reverse: true
    }))) {
      if (d > distance) {
        break;
      }

      if (d !== 0) {
        target = p;
      }

      d++;
    }

    return target;
  },

  /**
   * Delete content in the editor backward from the current selection.
   */
  deleteBackward(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      unit = 'character'
    } = options;
    editor.deleteBackward(unit);
  },

  /**
   * Delete content in the editor forward from the current selection.
   */
  deleteForward(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      unit = 'character'
    } = options;
    editor.deleteForward(unit);
  },

  /**
   * Delete the content in the current selection.
   */
  deleteFragment(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      direction = 'forward'
    } = options;
    editor.deleteFragment(direction);
  },

  /**
   * Get the start and end points of a location.
   */
  edges(editor, at) {
    return [Editor.start(editor, at), Editor.end(editor, at)];
  },

  /**
   * Get the end point of a location.
   */
  end(editor, at) {
    return Editor.point(editor, at, {
      edge: 'end'
    });
  },

  /**
   * Get the first node at a location.
   */
  first(editor, at) {
    var path = Editor.path(editor, at, {
      edge: 'start'
    });
    return Editor.node(editor, path);
  },

  /**
   * Get the fragment at a location.
   */
  fragment(editor, at) {
    var range = Editor.range(editor, at);
    var fragment = Node$1.fragment(editor, range);
    return fragment;
  },

  /**
   * Check if a node has block children.
   */
  hasBlocks(editor, element) {
    return element.children.some(n => Editor.isBlock(editor, n));
  },

  /**
   * Check if a node has inline and text children.
   */
  hasInlines(editor, element) {
    return element.children.some(n => Text.isText(n) || Editor.isInline(editor, n));
  },

  /**
   * Check if a node has text children.
   */
  hasTexts(editor, element) {
    return element.children.every(n => Text.isText(n));
  },

  /**
   * Insert a block break at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertBreak(editor) {
    editor.insertBreak();
  },

  /**
   * Insert a fragment at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertFragment(editor, fragment) {
    editor.insertFragment(fragment);
  },

  /**
   * Insert a node at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertNode(editor, node) {
    editor.insertNode(node);
  },

  /**
   * Insert text at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertText(editor, text) {
    editor.insertText(text);
  },

  /**
   * Check if a value is a block `Element` object.
   */
  isBlock(editor, value) {
    return Element$1.isElement(value) && !editor.isInline(value);
  },

  /**
   * Check if a value is an `Editor` object.
   */
  isEditor(value) {
    if (!isPlainObject(value)) return false;
    var cachedIsEditor = IS_EDITOR_CACHE.get(value);

    if (cachedIsEditor !== undefined) {
      return cachedIsEditor;
    }

    var isEditor = typeof value.addMark === 'function' && typeof value.apply === 'function' && typeof value.deleteBackward === 'function' && typeof value.deleteForward === 'function' && typeof value.deleteFragment === 'function' && typeof value.insertBreak === 'function' && typeof value.insertFragment === 'function' && typeof value.insertNode === 'function' && typeof value.insertText === 'function' && typeof value.isInline === 'function' && typeof value.isVoid === 'function' && typeof value.normalizeNode === 'function' && typeof value.onChange === 'function' && typeof value.removeMark === 'function' && (value.marks === null || isPlainObject(value.marks)) && (value.selection === null || Range.isRange(value.selection)) && Node$1.isNodeList(value.children) && Operation.isOperationList(value.operations);
    IS_EDITOR_CACHE.set(value, isEditor);
    return isEditor;
  },

  /**
   * Check if a point is the end point of a location.
   */
  isEnd(editor, point, at) {
    var end = Editor.end(editor, at);
    return Point.equals(point, end);
  },

  /**
   * Check if a point is an edge of a location.
   */
  isEdge(editor, point, at) {
    return Editor.isStart(editor, point, at) || Editor.isEnd(editor, point, at);
  },

  /**
   * Check if an element is empty, accounting for void nodes.
   */
  isEmpty(editor, element) {
    var {
      children
    } = element;
    var [first] = children;
    return children.length === 0 || children.length === 1 && Text.isText(first) && first.text === '' && !editor.isVoid(element);
  },

  /**
   * Check if a value is an inline `Element` object.
   */
  isInline(editor, value) {
    return Element$1.isElement(value) && editor.isInline(value);
  },

  /**
   * Check if the editor is currently normalizing after each operation.
   */
  isNormalizing(editor) {
    var isNormalizing = NORMALIZING.get(editor);
    return isNormalizing === undefined ? true : isNormalizing;
  },

  /**
   * Check if a point is the start point of a location.
   */
  isStart(editor, point, at) {
    // PERF: If the offset isn't `0` we know it's not the start.
    if (point.offset !== 0) {
      return false;
    }

    var start = Editor.start(editor, at);
    return Point.equals(point, start);
  },

  /**
   * Check if a value is a void `Element` object.
   */
  isVoid(editor, value) {
    return Element$1.isElement(value) && editor.isVoid(value);
  },

  /**
   * Get the last node at a location.
   */
  last(editor, at) {
    var path = Editor.path(editor, at, {
      edge: 'end'
    });
    return Editor.node(editor, path);
  },

  /**
   * Get the leaf text node at a location.
   */
  leaf(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var path = Editor.path(editor, at, options);
    var node = Node$1.leaf(editor, path);
    return [node, path];
  },

  /**
   * Iterate through all of the levels at a location.
   */
  *levels(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      at = editor.selection,
      reverse = false,
      voids = false
    } = options;
    var {
      match
    } = options;

    if (match == null) {
      match = () => true;
    }

    if (!at) {
      return;
    }

    var levels = [];
    var path = Editor.path(editor, at);

    for (var [n, p] of Node$1.levels(editor, path)) {
      if (!match(n, p)) {
        continue;
      }

      levels.push([n, p]);

      if (!voids && Editor.isVoid(editor, n)) {
        break;
      }
    }

    if (reverse) {
      levels.reverse();
    }

    yield* levels;
  },

  /**
   * Get the marks that would be added to text at the current selection.
   */
  marks(editor) {
    var {
      marks,
      selection
    } = editor;

    if (!selection) {
      return null;
    }

    if (marks) {
      return marks;
    }

    if (Range.isExpanded(selection)) {
      var [match] = Editor.nodes(editor, {
        match: Text.isText
      });

      if (match) {
        var [_node] = match;

        var _rest = _objectWithoutProperties(_node, _excluded$4);

        return _rest;
      } else {
        return {};
      }
    }

    var {
      anchor
    } = selection;
    var {
      path
    } = anchor;
    var [node] = Editor.leaf(editor, path);

    if (anchor.offset === 0) {
      var prev = Editor.previous(editor, {
        at: path,
        match: Text.isText
      });
      var block = Editor.above(editor, {
        match: n => Editor.isBlock(editor, n)
      });

      if (prev && block) {
        var [prevNode, prevPath] = prev;
        var [, blockPath] = block;

        if (Path.isAncestor(blockPath, prevPath)) {
          node = prevNode;
        }
      }
    }

    var rest = _objectWithoutProperties(node, _excluded2$3);

    return rest;
  },

  /**
   * Get the matching node in the branch of the document after a location.
   */
  next(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      mode = 'lowest',
      voids = false
    } = options;
    var {
      match,
      at = editor.selection
    } = options;

    if (!at) {
      return;
    }

    var pointAfterLocation = Editor.after(editor, at, {
      voids
    });
    if (!pointAfterLocation) return;
    var [, to] = Editor.last(editor, []);
    var span = [pointAfterLocation.path, to];

    if (Path.isPath(at) && at.length === 0) {
      throw new Error("Cannot get the next node from the root node!");
    }

    if (match == null) {
      if (Path.isPath(at)) {
        var [parent] = Editor.parent(editor, at);

        match = n => parent.children.includes(n);
      } else {
        match = () => true;
      }
    }

    var [next] = Editor.nodes(editor, {
      at: span,
      match,
      mode,
      voids
    });
    return next;
  },

  /**
   * Get the node at a location.
   */
  node(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var path = Editor.path(editor, at, options);
    var node = Node$1.get(editor, path);
    return [node, path];
  },

  /**
   * Iterate through all of the nodes in the Editor.
   */
  *nodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      at = editor.selection,
      mode = 'all',
      universal = false,
      reverse = false,
      voids = false
    } = options;
    var {
      match
    } = options;

    if (!match) {
      match = () => true;
    }

    if (!at) {
      return;
    }

    var from;
    var to;

    if (Span.isSpan(at)) {
      from = at[0];
      to = at[1];
    } else {
      var first = Editor.path(editor, at, {
        edge: 'start'
      });
      var last = Editor.path(editor, at, {
        edge: 'end'
      });
      from = reverse ? last : first;
      to = reverse ? first : last;
    }

    var nodeEntries = Node$1.nodes(editor, {
      reverse,
      from,
      to,
      pass: _ref => {
        var [n] = _ref;
        return voids ? false : Editor.isVoid(editor, n);
      }
    });
    var matches = [];
    var hit;

    for (var [node, path] of nodeEntries) {
      var isLower = hit && Path.compare(path, hit[1]) === 0; // In highest mode any node lower than the last hit is not a match.

      if (mode === 'highest' && isLower) {
        continue;
      }

      if (!match(node, path)) {
        // If we've arrived at a leaf text node that is not lower than the last
        // hit, then we've found a branch that doesn't include a match, which
        // means the match is not universal.
        if (universal && !isLower && Text.isText(node)) {
          return;
        } else {
          continue;
        }
      } // If there's a match and it's lower than the last, update the hit.


      if (mode === 'lowest' && isLower) {
        hit = [node, path];
        continue;
      } // In lowest mode we emit the last hit, once it's guaranteed lowest.


      var emit = mode === 'lowest' ? hit : [node, path];

      if (emit) {
        if (universal) {
          matches.push(emit);
        } else {
          yield emit;
        }
      }

      hit = [node, path];
    } // Since lowest is always emitting one behind, catch up at the end.


    if (mode === 'lowest' && hit) {
      if (universal) {
        matches.push(hit);
      } else {
        yield hit;
      }
    } // Universal defers to ensure that the match occurs in every branch, so we
    // yield all of the matches after iterating.


    if (universal) {
      yield* matches;
    }
  },

  /**
   * Normalize any dirty objects in the editor.
   */
  normalize(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      force = false
    } = options;

    var getDirtyPaths = editor => {
      return DIRTY_PATHS.get(editor) || [];
    };

    if (!Editor.isNormalizing(editor)) {
      return;
    }

    if (force) {
      var allPaths = Array.from(Node$1.nodes(editor), _ref2 => {
        var [, p] = _ref2;
        return p;
      });
      DIRTY_PATHS.set(editor, allPaths);
    }

    if (getDirtyPaths(editor).length === 0) {
      return;
    }

    Editor.withoutNormalizing(editor, () => {
      /*
        Fix dirty elements with no children.
        editor.normalizeNode() does fix this, but some normalization fixes also require it to work.
        Running an initial pass avoids the catch-22 race condition.
      */
      for (var dirtyPath of getDirtyPaths(editor)) {
        if (Node$1.has(editor, dirtyPath)) {
          var entry = Editor.node(editor, dirtyPath);
          var [node, _] = entry;
          /*
            The default normalizer inserts an empty text node in this scenario, but it can be customised.
            So there is some risk here.
                       As long as the normalizer only inserts child nodes for this case it is safe to do in any order;
            by definition adding children to an empty node can't cause other paths to change.
          */

          if (Element$1.isElement(node) && node.children.length === 0) {
            editor.normalizeNode(entry);
          }
        }
      }

      var max = getDirtyPaths(editor).length * 42; // HACK: better way?

      var m = 0;

      while (getDirtyPaths(editor).length !== 0) {
        if (m > max) {
          throw new Error("\n            Could not completely normalize the editor after ".concat(max, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state.\n          "));
        }

        var _dirtyPath = getDirtyPaths(editor).pop(); // If the node doesn't exist in the tree, it does not need to be normalized.


        if (Node$1.has(editor, _dirtyPath)) {
          var _entry = Editor.node(editor, _dirtyPath);

          editor.normalizeNode(_entry);
        }

        m++;
      }
    });
  },

  /**
   * Get the parent node of a location.
   */
  parent(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var path = Editor.path(editor, at, options);
    var parentPath = Path.parent(path);
    var entry = Editor.node(editor, parentPath);
    return entry;
  },

  /**
   * Get the path of a location.
   */
  path(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      depth,
      edge
    } = options;

    if (Path.isPath(at)) {
      if (edge === 'start') {
        var [, firstPath] = Node$1.first(editor, at);
        at = firstPath;
      } else if (edge === 'end') {
        var [, lastPath] = Node$1.last(editor, at);
        at = lastPath;
      }
    }

    if (Range.isRange(at)) {
      if (edge === 'start') {
        at = Range.start(at);
      } else if (edge === 'end') {
        at = Range.end(at);
      } else {
        at = Path.common(at.anchor.path, at.focus.path);
      }
    }

    if (Point.isPoint(at)) {
      at = at.path;
    }

    if (depth != null) {
      at = at.slice(0, depth);
    }

    return at;
  },

  hasPath(editor, path) {
    return Node$1.has(editor, path);
  },

  /**
   * Create a mutable ref for a `Path` object, which will stay in sync as new
   * operations are applied to the editor.
   */
  pathRef(editor, path) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      affinity = 'forward'
    } = options;
    var ref = {
      current: path,
      affinity,

      unref() {
        var {
          current
        } = ref;
        var pathRefs = Editor.pathRefs(editor);
        pathRefs.delete(ref);
        ref.current = null;
        return current;
      }

    };
    var refs = Editor.pathRefs(editor);
    refs.add(ref);
    return ref;
  },

  /**
   * Get the set of currently tracked path refs of the editor.
   */
  pathRefs(editor) {
    var refs = PATH_REFS.get(editor);

    if (!refs) {
      refs = new Set();
      PATH_REFS.set(editor, refs);
    }

    return refs;
  },

  /**
   * Get the start or end point of a location.
   */
  point(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      edge = 'start'
    } = options;

    if (Path.isPath(at)) {
      var path;

      if (edge === 'end') {
        var [, lastPath] = Node$1.last(editor, at);
        path = lastPath;
      } else {
        var [, firstPath] = Node$1.first(editor, at);
        path = firstPath;
      }

      var node = Node$1.get(editor, path);

      if (!Text.isText(node)) {
        throw new Error("Cannot get the ".concat(edge, " point in the node at path [").concat(at, "] because it has no ").concat(edge, " text node."));
      }

      return {
        path,
        offset: edge === 'end' ? node.text.length : 0
      };
    }

    if (Range.isRange(at)) {
      var [start, end] = Range.edges(at);
      return edge === 'start' ? start : end;
    }

    return at;
  },

  /**
   * Create a mutable ref for a `Point` object, which will stay in sync as new
   * operations are applied to the editor.
   */
  pointRef(editor, point) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      affinity = 'forward'
    } = options;
    var ref = {
      current: point,
      affinity,

      unref() {
        var {
          current
        } = ref;
        var pointRefs = Editor.pointRefs(editor);
        pointRefs.delete(ref);
        ref.current = null;
        return current;
      }

    };
    var refs = Editor.pointRefs(editor);
    refs.add(ref);
    return ref;
  },

  /**
   * Get the set of currently tracked point refs of the editor.
   */
  pointRefs(editor) {
    var refs = POINT_REFS.get(editor);

    if (!refs) {
      refs = new Set();
      POINT_REFS.set(editor, refs);
    }

    return refs;
  },

  /**
   * Return all the positions in `at` range where a `Point` can be placed.
   *
   * By default, moves forward by individual offsets at a time, but
   * the `unit` option can be used to to move by character, word, line, or block.
   *
   * The `reverse` option can be used to change iteration direction.
   *
   * Note: By default void nodes are treated as a single point and iteration
   * will not happen inside their content unless you pass in true for the
   * `voids` option, then iteration will occur.
   */
  *positions(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      at = editor.selection,
      unit = 'offset',
      reverse = false,
      voids = false
    } = options;

    if (!at) {
      return;
    }
    /**
     * Algorithm notes:
     *
     * Each step `distance` is dynamic depending on the underlying text
     * and the `unit` specified.  Each step, e.g., a line or word, may
     * span multiple text nodes, so we iterate through the text both on
     * two levels in step-sync:
     *
     * `leafText` stores the text on a text leaf level, and is advanced
     * through using the counters `leafTextOffset` and `leafTextRemaining`.
     *
     * `blockText` stores the text on a block level, and is shortened
     * by `distance` every time it is advanced.
     *
     * We only maintain a window of one blockText and one leafText because
     * a block node always appears before all of its leaf nodes.
     */


    var range = Editor.range(editor, at);
    var [start, end] = Range.edges(range);
    var first = reverse ? end : start;
    var isNewBlock = false;
    var blockText = '';
    var distance = 0; // Distance for leafText to catch up to blockText.

    var leafTextRemaining = 0;
    var leafTextOffset = 0; // Iterate through all nodes in range, grabbing entire textual content
    // of block nodes in blockText, and text nodes in leafText.
    // Exploits the fact that nodes are sequenced in such a way that we first
    // encounter the block node, then all of its text nodes, so when iterating
    // through the blockText and leafText we just need to remember a window of
    // one block node and leaf node, respectively.

    for (var [node, path] of Editor.nodes(editor, {
      at,
      reverse,
      voids
    })) {
      /*
       * ELEMENT NODE - Yield position(s) for voids, collect blockText for blocks
       */
      if (Element$1.isElement(node)) {
        // Void nodes are a special case, so by default we will always
        // yield their first point. If the `voids` option is set to true,
        // then we will iterate over their content.
        if (!voids && editor.isVoid(node)) {
          yield Editor.start(editor, path);
          continue;
        } // Inline element nodes are ignored as they don't themselves
        // contribute to `blockText` or `leafText` - their parent and
        // children do.


        if (editor.isInline(node)) continue; // Block element node - set `blockText` to its text content.

        if (Editor.hasInlines(editor, node)) {
          // We always exhaust block nodes before encountering a new one:
          //   console.assert(blockText === '',
          //     `blockText='${blockText}' - `+
          //     `not exhausted before new block node`, path)
          // Ensure range considered is capped to `range`, in the
          // start/end edge cases where block extends beyond range.
          // Equivalent to this, but presumably more performant:
          //   blockRange = Editor.range(editor, ...Editor.edges(editor, path))
          //   blockRange = Range.intersection(range, blockRange) // intersect
          //   blockText = Editor.string(editor, blockRange, { voids })
          var e = Path.isAncestor(path, end.path) ? end : Editor.end(editor, path);
          var s = Path.isAncestor(path, start.path) ? start : Editor.start(editor, path);
          blockText = Editor.string(editor, {
            anchor: s,
            focus: e
          }, {
            voids
          });
          isNewBlock = true;
        }
      }
      /*
       * TEXT LEAF NODE - Iterate through text content, yielding
       * positions every `distance` offset according to `unit`.
       */


      if (Text.isText(node)) {
        var isFirst = Path.equals(path, first.path); // Proof that we always exhaust text nodes before encountering a new one:
        //   console.assert(leafTextRemaining <= 0,
        //     `leafTextRemaining=${leafTextRemaining} - `+
        //     `not exhausted before new leaf text node`, path)
        // Reset `leafText` counters for new text node.

        if (isFirst) {
          leafTextRemaining = reverse ? first.offset : node.text.length - first.offset;
          leafTextOffset = first.offset; // Works for reverse too.
        } else {
          leafTextRemaining = node.text.length;
          leafTextOffset = reverse ? leafTextRemaining : 0;
        } // Yield position at the start of node (potentially).


        if (isFirst || isNewBlock || unit === 'offset') {
          yield {
            path,
            offset: leafTextOffset
          };
          isNewBlock = false;
        } // Yield positions every (dynamically calculated) `distance` offset.


        while (true) {
          // If `leafText` has caught up with `blockText` (distance=0),
          // and if blockText is exhausted, break to get another block node,
          // otherwise advance blockText forward by the new `distance`.
          if (distance === 0) {
            if (blockText === '') break;
            distance = calcDistance(blockText, unit, reverse); // Split the string at the previously found distance and use the
            // remaining string for the next iteration.

            blockText = splitByCharacterDistance(blockText, distance, reverse)[1];
          } // Advance `leafText` by the current `distance`.


          leafTextOffset = reverse ? leafTextOffset - distance : leafTextOffset + distance;
          leafTextRemaining = leafTextRemaining - distance; // If `leafText` is exhausted, break to get a new leaf node
          // and set distance to the overflow amount, so we'll (maybe)
          // catch up to blockText in the next leaf text node.

          if (leafTextRemaining < 0) {
            distance = -leafTextRemaining;
            break;
          } // Successfully walked `distance` offsets through `leafText`
          // to catch up with `blockText`, so we can reset `distance`
          // and yield this position in this node.


          distance = 0;
          yield {
            path,
            offset: leafTextOffset
          };
        }
      }
    } // Proof that upon completion, we've exahusted both leaf and block text:
    //   console.assert(leafTextRemaining <= 0, "leafText wasn't exhausted")
    //   console.assert(blockText === '', "blockText wasn't exhausted")
    // Helper:
    // Return the distance in offsets for a step of size `unit` on given string.


    function calcDistance(text, unit, reverse) {
      if (unit === 'character') {
        return getCharacterDistance(text, reverse);
      } else if (unit === 'word') {
        return getWordDistance(text, reverse);
      } else if (unit === 'line' || unit === 'block') {
        return text.length;
      }

      return 1;
    }
  },

  /**
   * Get the matching node in the branch of the document before a location.
   */
  previous(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      mode = 'lowest',
      voids = false
    } = options;
    var {
      match,
      at = editor.selection
    } = options;

    if (!at) {
      return;
    }

    var pointBeforeLocation = Editor.before(editor, at, {
      voids
    });

    if (!pointBeforeLocation) {
      return;
    }

    var [, to] = Editor.first(editor, []); // The search location is from the start of the document to the path of
    // the point before the location passed in

    var span = [pointBeforeLocation.path, to];

    if (Path.isPath(at) && at.length === 0) {
      throw new Error("Cannot get the previous node from the root node!");
    }

    if (match == null) {
      if (Path.isPath(at)) {
        var [parent] = Editor.parent(editor, at);

        match = n => parent.children.includes(n);
      } else {
        match = () => true;
      }
    }

    var [previous] = Editor.nodes(editor, {
      reverse: true,
      at: span,
      match,
      mode,
      voids
    });
    return previous;
  },

  /**
   * Get a range of a location.
   */
  range(editor, at, to) {
    if (Range.isRange(at) && !to) {
      return at;
    }

    var start = Editor.start(editor, at);
    var end = Editor.end(editor, to || at);
    return {
      anchor: start,
      focus: end
    };
  },

  /**
   * Create a mutable ref for a `Range` object, which will stay in sync as new
   * operations are applied to the editor.
   */
  rangeRef(editor, range) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      affinity = 'forward'
    } = options;
    var ref = {
      current: range,
      affinity,

      unref() {
        var {
          current
        } = ref;
        var rangeRefs = Editor.rangeRefs(editor);
        rangeRefs.delete(ref);
        ref.current = null;
        return current;
      }

    };
    var refs = Editor.rangeRefs(editor);
    refs.add(ref);
    return ref;
  },

  /**
   * Get the set of currently tracked range refs of the editor.
   */
  rangeRefs(editor) {
    var refs = RANGE_REFS.get(editor);

    if (!refs) {
      refs = new Set();
      RANGE_REFS.set(editor, refs);
    }

    return refs;
  },

  /**
   * Remove a custom property from all of the leaf text nodes in the current
   * selection.
   *
   * If the selection is currently collapsed, the removal will be stored on
   * `editor.marks` and applied to the text inserted next.
   */
  removeMark(editor, key) {
    editor.removeMark(key);
  },

  /**
   * Manually set if the editor should currently be normalizing.
   *
   * Note: Using this incorrectly can leave the editor in an invalid state.
   *
   */
  setNormalizing(editor, isNormalizing) {
    NORMALIZING.set(editor, isNormalizing);
  },

  /**
   * Get the start point of a location.
   */
  start(editor, at) {
    return Editor.point(editor, at, {
      edge: 'start'
    });
  },

  /**
   * Get the text string content of a location.
   *
   * Note: by default the text of void nodes is considered to be an empty
   * string, regardless of content, unless you pass in true for the voids option
   */
  string(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      voids = false
    } = options;
    var range = Editor.range(editor, at);
    var [start, end] = Range.edges(range);
    var text = '';

    for (var [node, path] of Editor.nodes(editor, {
      at: range,
      match: Text.isText,
      voids
    })) {
      var t = node.text;

      if (Path.equals(path, end.path)) {
        t = t.slice(0, end.offset);
      }

      if (Path.equals(path, start.path)) {
        t = t.slice(start.offset);
      }

      text += t;
    }

    return text;
  },

  /**
   * Convert a range into a non-hanging one.
   */
  unhangRange(editor, range) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      voids = false
    } = options;
    var [start, end] = Range.edges(range); // PERF: exit early if we can guarantee that the range isn't hanging.

    if (start.offset !== 0 || end.offset !== 0 || Range.isCollapsed(range)) {
      return range;
    }

    var endBlock = Editor.above(editor, {
      at: end,
      match: n => Editor.isBlock(editor, n)
    });
    var blockPath = endBlock ? endBlock[1] : [];
    var first = Editor.start(editor, []);
    var before = {
      anchor: first,
      focus: end
    };
    var skip = true;

    for (var [node, path] of Editor.nodes(editor, {
      at: before,
      match: Text.isText,
      reverse: true,
      voids
    })) {
      if (skip) {
        skip = false;
        continue;
      }

      if (node.text !== '' || Path.isBefore(path, blockPath)) {
        end = {
          path,
          offset: node.text.length
        };
        break;
      }
    }

    return {
      anchor: start,
      focus: end
    };
  },

  /**
   * Match a void node in the current branch of the editor.
   */
  void(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Editor.above(editor, _objectSpread$8(_objectSpread$8({}, options), {}, {
      match: n => Editor.isVoid(editor, n)
    }));
  },

  /**
   * Call a function, deferring normalization until after it completes.
   */
  withoutNormalizing(editor, fn) {
    var value = Editor.isNormalizing(editor);
    Editor.setNormalizing(editor, false);

    try {
      fn();
    } finally {
      Editor.setNormalizing(editor, value);
    }

    Editor.normalize(editor);
  }

};

var Location = {
  /**
   * Check if a value implements the `Location` interface.
   */
  isLocation(value) {
    return Path.isPath(value) || Point.isPoint(value) || Range.isRange(value);
  }

};
var Span = {
  /**
   * Check if a value implements the `Span` interface.
   */
  isSpan(value) {
    return Array.isArray(value) && value.length === 2 && value.every(Path.isPath);
  }

};

var _excluded$3 = ["children"],
    _excluded2$2 = ["text"];
var IS_NODE_LIST_CACHE = new WeakMap();
var Node$1 = {
  /**
   * Get the node at a specific path, asserting that it's an ancestor node.
   */
  ancestor(root, path) {
    var node = Node$1.get(root, path);

    if (Text.isText(node)) {
      throw new Error("Cannot get the ancestor node at path [".concat(path, "] because it refers to a text node instead: ").concat(node));
    }

    return node;
  },

  /**
   * Return a generator of all the ancestor nodes above a specific path.
   *
   * By default the order is bottom-up, from lowest to highest ancestor in
   * the tree, but you can pass the `reverse: true` option to go top-down.
   */
  *ancestors(root, path) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    for (var p of Path.ancestors(path, options)) {
      var n = Node$1.ancestor(root, p);
      var entry = [n, p];
      yield entry;
    }
  },

  /**
   * Get the child of a node at a specific index.
   */
  child(root, index) {
    if (Text.isText(root)) {
      throw new Error("Cannot get the child of a text node: ".concat(JSON.stringify(root)));
    }

    var c = root.children[index];

    if (c == null) {
      throw new Error("Cannot get child at index `".concat(index, "` in node: ").concat(JSON.stringify(root)));
    }

    return c;
  },

  /**
   * Iterate over the children of a node at a specific path.
   */
  *children(root, path) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      reverse = false
    } = options;
    var ancestor = Node$1.ancestor(root, path);
    var {
      children
    } = ancestor;
    var index = reverse ? children.length - 1 : 0;

    while (reverse ? index >= 0 : index < children.length) {
      var child = Node$1.child(ancestor, index);
      var childPath = path.concat(index);
      yield [child, childPath];
      index = reverse ? index - 1 : index + 1;
    }
  },

  /**
   * Get an entry for the common ancesetor node of two paths.
   */
  common(root, path, another) {
    var p = Path.common(path, another);
    var n = Node$1.get(root, p);
    return [n, p];
  },

  /**
   * Get the node at a specific path, asserting that it's a descendant node.
   */
  descendant(root, path) {
    var node = Node$1.get(root, path);

    if (Editor.isEditor(node)) {
      throw new Error("Cannot get the descendant node at path [".concat(path, "] because it refers to the root editor node instead: ").concat(node));
    }

    return node;
  },

  /**
   * Return a generator of all the descendant node entries inside a root node.
   */
  *descendants(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var [node, path] of Node$1.nodes(root, options)) {
      if (path.length !== 0) {
        // NOTE: we have to coerce here because checking the path's length does
        // guarantee that `node` is not a `Editor`, but TypeScript doesn't know.
        yield [node, path];
      }
    }
  },

  /**
   * Return a generator of all the element nodes inside a root node. Each iteration
   * will return an `ElementEntry` tuple consisting of `[Element, Path]`. If the
   * root node is an element it will be included in the iteration as well.
   */
  *elements(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var [node, path] of Node$1.nodes(root, options)) {
      if (Element$1.isElement(node)) {
        yield [node, path];
      }
    }
  },

  /**
   * Extract props from a Node.
   */
  extractProps(node) {
    if (Element$1.isAncestor(node)) {
      var properties = _objectWithoutProperties(node, _excluded$3);

      return properties;
    } else {
      var properties = _objectWithoutProperties(node, _excluded2$2);

      return properties;
    }
  },

  /**
   * Get the first node entry in a root node from a path.
   */
  first(root, path) {
    var p = path.slice();
    var n = Node$1.get(root, p);

    while (n) {
      if (Text.isText(n) || n.children.length === 0) {
        break;
      } else {
        n = n.children[0];
        p.push(0);
      }
    }

    return [n, p];
  },

  /**
   * Get the sliced fragment represented by a range inside a root node.
   */
  fragment(root, range) {
    if (Text.isText(root)) {
      throw new Error("Cannot get a fragment starting from a root text node: ".concat(JSON.stringify(root)));
    }

    var newRoot = fn$7({
      children: root.children
    }, r => {
      var [start, end] = Range.edges(range);
      var nodeEntries = Node$1.nodes(r, {
        reverse: true,
        pass: _ref => {
          var [, path] = _ref;
          return !Range.includes(range, path);
        }
      });

      for (var [, path] of nodeEntries) {
        if (!Range.includes(range, path)) {
          var parent = Node$1.parent(r, path);
          var index = path[path.length - 1];
          parent.children.splice(index, 1);
        }

        if (Path.equals(path, end.path)) {
          var leaf = Node$1.leaf(r, path);
          leaf.text = leaf.text.slice(0, end.offset);
        }

        if (Path.equals(path, start.path)) {
          var _leaf = Node$1.leaf(r, path);

          _leaf.text = _leaf.text.slice(start.offset);
        }
      }

      if (Editor.isEditor(r)) {
        r.selection = null;
      }
    });
    return newRoot.children;
  },

  /**
   * Get the descendant node referred to by a specific path. If the path is an
   * empty array, it refers to the root node itself.
   */
  get(root, path) {
    var node = root;

    for (var i = 0; i < path.length; i++) {
      var p = path[i];

      if (Text.isText(node) || !node.children[p]) {
        throw new Error("Cannot find a descendant at path [".concat(path, "] in node: ").concat(JSON.stringify(root)));
      }

      node = node.children[p];
    }

    return node;
  },

  /**
   * Check if a descendant node exists at a specific path.
   */
  has(root, path) {
    var node = root;

    for (var i = 0; i < path.length; i++) {
      var p = path[i];

      if (Text.isText(node) || !node.children[p]) {
        return false;
      }

      node = node.children[p];
    }

    return true;
  },

  /**
   * Check if a value implements the `Node` interface.
   */
  isNode(value) {
    return Text.isText(value) || Element$1.isElement(value) || Editor.isEditor(value);
  },

  /**
   * Check if a value is a list of `Node` objects.
   */
  isNodeList(value) {
    if (!Array.isArray(value)) {
      return false;
    }

    var cachedResult = IS_NODE_LIST_CACHE.get(value);

    if (cachedResult !== undefined) {
      return cachedResult;
    }

    var isNodeList = value.every(val => Node$1.isNode(val));
    IS_NODE_LIST_CACHE.set(value, isNodeList);
    return isNodeList;
  },

  /**
   * Get the last node entry in a root node from a path.
   */
  last(root, path) {
    var p = path.slice();
    var n = Node$1.get(root, p);

    while (n) {
      if (Text.isText(n) || n.children.length === 0) {
        break;
      } else {
        var i = n.children.length - 1;
        n = n.children[i];
        p.push(i);
      }
    }

    return [n, p];
  },

  /**
   * Get the node at a specific path, ensuring it's a leaf text node.
   */
  leaf(root, path) {
    var node = Node$1.get(root, path);

    if (!Text.isText(node)) {
      throw new Error("Cannot get the leaf node at path [".concat(path, "] because it refers to a non-leaf node: ").concat(node));
    }

    return node;
  },

  /**
   * Return a generator of the in a branch of the tree, from a specific path.
   *
   * By default the order is top-down, from lowest to highest node in the tree,
   * but you can pass the `reverse: true` option to go bottom-up.
   */
  *levels(root, path) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    for (var p of Path.levels(path, options)) {
      var n = Node$1.get(root, p);
      yield [n, p];
    }
  },

  /**
   * Check if a node matches a set of props.
   */
  matches(node, props) {
    return Element$1.isElement(node) && Element$1.isElementProps(props) && Element$1.matches(node, props) || Text.isText(node) && Text.isTextProps(props) && Text.matches(node, props);
  },

  /**
   * Return a generator of all the node entries of a root node. Each entry is
   * returned as a `[Node, Path]` tuple, with the path referring to the node's
   * position inside the root node.
   */
  *nodes(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      pass,
      reverse = false
    } = options;
    var {
      from = [],
      to
    } = options;
    var visited = new Set();
    var p = [];
    var n = root;

    while (true) {
      if (to && (reverse ? Path.isBefore(p, to) : Path.isAfter(p, to))) {
        break;
      }

      if (!visited.has(n)) {
        yield [n, p];
      } // If we're allowed to go downward and we haven't descended yet, do.


      if (!visited.has(n) && !Text.isText(n) && n.children.length !== 0 && (pass == null || pass([n, p]) === false)) {
        visited.add(n);
        var nextIndex = reverse ? n.children.length - 1 : 0;

        if (Path.isAncestor(p, from)) {
          nextIndex = from[p.length];
        }

        p = p.concat(nextIndex);
        n = Node$1.get(root, p);
        continue;
      } // If we're at the root and we can't go down, we're done.


      if (p.length === 0) {
        break;
      } // If we're going forward...


      if (!reverse) {
        var newPath = Path.next(p);

        if (Node$1.has(root, newPath)) {
          p = newPath;
          n = Node$1.get(root, p);
          continue;
        }
      } // If we're going backward...


      if (reverse && p[p.length - 1] !== 0) {
        var _newPath = Path.previous(p);

        p = _newPath;
        n = Node$1.get(root, p);
        continue;
      } // Otherwise we're going upward...


      p = Path.parent(p);
      n = Node$1.get(root, p);
      visited.add(n);
    }
  },

  /**
   * Get the parent of a node at a specific path.
   */
  parent(root, path) {
    var parentPath = Path.parent(path);
    var p = Node$1.get(root, parentPath);

    if (Text.isText(p)) {
      throw new Error("Cannot get the parent of path [".concat(path, "] because it does not exist in the root."));
    }

    return p;
  },

  /**
   * Get the concatenated text string of a node's content.
   *
   * Note that this will not include spaces or line breaks between block nodes.
   * It is not a user-facing string, but a string for performing offset-related
   * computations for a node.
   */
  string(node) {
    if (Text.isText(node)) {
      return node.text;
    } else {
      return node.children.map(Node$1.string).join('');
    }
  },

  /**
   * Return a generator of all leaf text nodes in a root node.
   */
  *texts(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var [node, path] of Node$1.nodes(root, options)) {
      if (Text.isText(node)) {
        yield [node, path];
      }
    }
  }

};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Operation = {
  /**
   * Check of a value is a `NodeOperation` object.
   */
  isNodeOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith('_node');
  },

  /**
   * Check of a value is an `Operation` object.
   */
  isOperation(value) {
    if (!isPlainObject(value)) {
      return false;
    }

    switch (value.type) {
      case 'insert_node':
        return Path.isPath(value.path) && Node$1.isNode(value.node);

      case 'insert_text':
        return typeof value.offset === 'number' && typeof value.text === 'string' && Path.isPath(value.path);

      case 'merge_node':
        return typeof value.position === 'number' && Path.isPath(value.path) && isPlainObject(value.properties);

      case 'move_node':
        return Path.isPath(value.path) && Path.isPath(value.newPath);

      case 'remove_node':
        return Path.isPath(value.path) && Node$1.isNode(value.node);

      case 'remove_text':
        return typeof value.offset === 'number' && typeof value.text === 'string' && Path.isPath(value.path);

      case 'set_node':
        return Path.isPath(value.path) && isPlainObject(value.properties) && isPlainObject(value.newProperties);

      case 'set_selection':
        return value.properties === null && Range.isRange(value.newProperties) || value.newProperties === null && Range.isRange(value.properties) || isPlainObject(value.properties) && isPlainObject(value.newProperties);

      case 'split_node':
        return Path.isPath(value.path) && typeof value.position === 'number' && isPlainObject(value.properties);

      default:
        return false;
    }
  },

  /**
   * Check if a value is a list of `Operation` objects.
   */
  isOperationList(value) {
    return Array.isArray(value) && value.every(val => Operation.isOperation(val));
  },

  /**
   * Check of a value is a `SelectionOperation` object.
   */
  isSelectionOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith('_selection');
  },

  /**
   * Check of a value is a `TextOperation` object.
   */
  isTextOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith('_text');
  },

  /**
   * Invert an operation, returning a new operation that will exactly undo the
   * original when applied.
   */
  inverse(op) {
    switch (op.type) {
      case 'insert_node':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'remove_node'
          });
        }

      case 'insert_text':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'remove_text'
          });
        }

      case 'merge_node':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'split_node',
            path: Path.previous(op.path)
          });
        }

      case 'move_node':
        {
          var {
            newPath,
            path
          } = op; // PERF: in this case the move operation is a no-op anyways.

          if (Path.equals(newPath, path)) {
            return op;
          } // If the move happens completely within a single parent the path and
          // newPath are stable with respect to each other.


          if (Path.isSibling(path, newPath)) {
            return _objectSpread$7(_objectSpread$7({}, op), {}, {
              path: newPath,
              newPath: path
            });
          } // If the move does not happen within a single parent it is possible
          // for the move to impact the true path to the location where the node
          // was removed from and where it was inserted. We have to adjust for this
          // and find the original path. We can accomplish this (only in non-sibling)
          // moves by looking at the impact of the move operation on the node
          // after the original move path.


          var inversePath = Path.transform(path, op);
          var inverseNewPath = Path.transform(Path.next(path), op);
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            path: inversePath,
            newPath: inverseNewPath
          });
        }

      case 'remove_node':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'insert_node'
          });
        }

      case 'remove_text':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'insert_text'
          });
        }

      case 'set_node':
        {
          var {
            properties,
            newProperties
          } = op;
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            properties: newProperties,
            newProperties: properties
          });
        }

      case 'set_selection':
        {
          var {
            properties: _properties,
            newProperties: _newProperties
          } = op;

          if (_properties == null) {
            return _objectSpread$7(_objectSpread$7({}, op), {}, {
              properties: _newProperties,
              newProperties: null
            });
          } else if (_newProperties == null) {
            return _objectSpread$7(_objectSpread$7({}, op), {}, {
              properties: null,
              newProperties: _properties
            });
          } else {
            return _objectSpread$7(_objectSpread$7({}, op), {}, {
              properties: _newProperties,
              newProperties: _properties
            });
          }
        }

      case 'split_node':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'merge_node',
            path: Path.next(op.path)
          });
        }
    }
  }

};

var Path = {
  /**
   * Get a list of ancestor paths for a given path.
   *
   * The paths are sorted from deepest to shallowest ancestor. However, if the
   * `reverse: true` option is passed, they are reversed.
   */
  ancestors(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      reverse = false
    } = options;
    var paths = Path.levels(path, options);

    if (reverse) {
      paths = paths.slice(1);
    } else {
      paths = paths.slice(0, -1);
    }

    return paths;
  },

  /**
   * Get the common ancestor path of two paths.
   */
  common(path, another) {
    var common = [];

    for (var i = 0; i < path.length && i < another.length; i++) {
      var av = path[i];
      var bv = another[i];

      if (av !== bv) {
        break;
      }

      common.push(av);
    }

    return common;
  },

  /**
   * Compare a path to another, returning an integer indicating whether the path
   * was before, at, or after the other.
   *
   * Note: Two paths of unequal length can still receive a `0` result if one is
   * directly above or below the other. If you want exact matching, use
   * [[Path.equals]] instead.
   */
  compare(path, another) {
    var min = Math.min(path.length, another.length);

    for (var i = 0; i < min; i++) {
      if (path[i] < another[i]) return -1;
      if (path[i] > another[i]) return 1;
    }

    return 0;
  },

  /**
   * Check if a path ends after one of the indexes in another.
   */
  endsAfter(path, another) {
    var i = path.length - 1;
    var as = path.slice(0, i);
    var bs = another.slice(0, i);
    var av = path[i];
    var bv = another[i];
    return Path.equals(as, bs) && av > bv;
  },

  /**
   * Check if a path ends at one of the indexes in another.
   */
  endsAt(path, another) {
    var i = path.length;
    var as = path.slice(0, i);
    var bs = another.slice(0, i);
    return Path.equals(as, bs);
  },

  /**
   * Check if a path ends before one of the indexes in another.
   */
  endsBefore(path, another) {
    var i = path.length - 1;
    var as = path.slice(0, i);
    var bs = another.slice(0, i);
    var av = path[i];
    var bv = another[i];
    return Path.equals(as, bs) && av < bv;
  },

  /**
   * Check if a path is exactly equal to another.
   */
  equals(path, another) {
    return path.length === another.length && path.every((n, i) => n === another[i]);
  },

  /**
   * Check if the path of previous sibling node exists
   */
  hasPrevious(path) {
    return path[path.length - 1] > 0;
  },

  /**
   * Check if a path is after another.
   */
  isAfter(path, another) {
    return Path.compare(path, another) === 1;
  },

  /**
   * Check if a path is an ancestor of another.
   */
  isAncestor(path, another) {
    return path.length < another.length && Path.compare(path, another) === 0;
  },

  /**
   * Check if a path is before another.
   */
  isBefore(path, another) {
    return Path.compare(path, another) === -1;
  },

  /**
   * Check if a path is a child of another.
   */
  isChild(path, another) {
    return path.length === another.length + 1 && Path.compare(path, another) === 0;
  },

  /**
   * Check if a path is equal to or an ancestor of another.
   */
  isCommon(path, another) {
    return path.length <= another.length && Path.compare(path, another) === 0;
  },

  /**
   * Check if a path is a descendant of another.
   */
  isDescendant(path, another) {
    return path.length > another.length && Path.compare(path, another) === 0;
  },

  /**
   * Check if a path is the parent of another.
   */
  isParent(path, another) {
    return path.length + 1 === another.length && Path.compare(path, another) === 0;
  },

  /**
   * Check is a value implements the `Path` interface.
   */
  isPath(value) {
    return Array.isArray(value) && (value.length === 0 || typeof value[0] === 'number');
  },

  /**
   * Check if a path is a sibling of another.
   */
  isSibling(path, another) {
    if (path.length !== another.length) {
      return false;
    }

    var as = path.slice(0, -1);
    var bs = another.slice(0, -1);
    var al = path[path.length - 1];
    var bl = another[another.length - 1];
    return al !== bl && Path.equals(as, bs);
  },

  /**
   * Get a list of paths at every level down to a path. Note: this is the same
   * as `Path.ancestors`, but including the path itself.
   *
   * The paths are sorted from shallowest to deepest. However, if the `reverse:
   * true` option is passed, they are reversed.
   */
  levels(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      reverse = false
    } = options;
    var list = [];

    for (var i = 0; i <= path.length; i++) {
      list.push(path.slice(0, i));
    }

    if (reverse) {
      list.reverse();
    }

    return list;
  },

  /**
   * Given a path, get the path to the next sibling node.
   */
  next(path) {
    if (path.length === 0) {
      throw new Error("Cannot get the next path of a root path [".concat(path, "], because it has no next index."));
    }

    var last = path[path.length - 1];
    return path.slice(0, -1).concat(last + 1);
  },

  /**
   * Given a path, return a new path referring to the parent node above it.
   */
  parent(path) {
    if (path.length === 0) {
      throw new Error("Cannot get the parent path of the root path [".concat(path, "]."));
    }

    return path.slice(0, -1);
  },

  /**
   * Given a path, get the path to the previous sibling node.
   */
  previous(path) {
    if (path.length === 0) {
      throw new Error("Cannot get the previous path of a root path [".concat(path, "], because it has no previous index."));
    }

    var last = path[path.length - 1];

    if (last <= 0) {
      throw new Error("Cannot get the previous path of a first child path [".concat(path, "] because it would result in a negative index."));
    }

    return path.slice(0, -1).concat(last - 1);
  },

  /**
   * Get a path relative to an ancestor.
   */
  relative(path, ancestor) {
    if (!Path.isAncestor(ancestor, path) && !Path.equals(path, ancestor)) {
      throw new Error("Cannot get the relative path of [".concat(path, "] inside ancestor [").concat(ancestor, "], because it is not above or equal to the path."));
    }

    return path.slice(ancestor.length);
  },

  /**
   * Transform a path by an operation.
   */
  transform(path, operation) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return fn$7(path, p => {
      var {
        affinity = 'forward'
      } = options; // PERF: Exit early if the operation is guaranteed not to have an effect.

      if (!path || (path === null || path === void 0 ? void 0 : path.length) === 0) {
        return;
      }

      if (p === null) {
        return null;
      }

      switch (operation.type) {
        case 'insert_node':
          {
            var {
              path: op
            } = operation;

            if (Path.equals(op, p) || Path.endsBefore(op, p) || Path.isAncestor(op, p)) {
              p[op.length - 1] += 1;
            }

            break;
          }

        case 'remove_node':
          {
            var {
              path: _op
            } = operation;

            if (Path.equals(_op, p) || Path.isAncestor(_op, p)) {
              return null;
            } else if (Path.endsBefore(_op, p)) {
              p[_op.length - 1] -= 1;
            }

            break;
          }

        case 'merge_node':
          {
            var {
              path: _op2,
              position
            } = operation;

            if (Path.equals(_op2, p) || Path.endsBefore(_op2, p)) {
              p[_op2.length - 1] -= 1;
            } else if (Path.isAncestor(_op2, p)) {
              p[_op2.length - 1] -= 1;
              p[_op2.length] += position;
            }

            break;
          }

        case 'split_node':
          {
            var {
              path: _op3,
              position: _position
            } = operation;

            if (Path.equals(_op3, p)) {
              if (affinity === 'forward') {
                p[p.length - 1] += 1;
              } else if (affinity === 'backward') ; else {
                return null;
              }
            } else if (Path.endsBefore(_op3, p)) {
              p[_op3.length - 1] += 1;
            } else if (Path.isAncestor(_op3, p) && path[_op3.length] >= _position) {
              p[_op3.length - 1] += 1;
              p[_op3.length] -= _position;
            }

            break;
          }

        case 'move_node':
          {
            var {
              path: _op4,
              newPath: onp
            } = operation; // If the old and new path are the same, it's a no-op.

            if (Path.equals(_op4, onp)) {
              return;
            }

            if (Path.isAncestor(_op4, p) || Path.equals(_op4, p)) {
              var copy = onp.slice();

              if (Path.endsBefore(_op4, onp) && _op4.length < onp.length) {
                copy[_op4.length - 1] -= 1;
              }

              return copy.concat(p.slice(_op4.length));
            } else if (Path.isSibling(_op4, onp) && (Path.isAncestor(onp, p) || Path.equals(onp, p))) {
              if (Path.endsBefore(_op4, p)) {
                p[_op4.length - 1] -= 1;
              } else {
                p[_op4.length - 1] += 1;
              }
            } else if (Path.endsBefore(onp, p) || Path.equals(onp, p) || Path.isAncestor(onp, p)) {
              if (Path.endsBefore(_op4, p)) {
                p[_op4.length - 1] -= 1;
              }

              p[onp.length - 1] += 1;
            } else if (Path.endsBefore(_op4, p)) {
              if (Path.equals(onp, p)) {
                p[onp.length - 1] += 1;
              }

              p[_op4.length - 1] -= 1;
            }

            break;
          }
      }
    });
  }

};

var PathRef = {
  /**
   * Transform the path ref's current value by an operation.
   */
  transform(ref, op) {
    var {
      current,
      affinity
    } = ref;

    if (current == null) {
      return;
    }

    var path = Path.transform(current, op, {
      affinity
    });
    ref.current = path;

    if (path == null) {
      ref.unref();
    }
  }

};

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Point = {
  /**
   * Compare a point to another, returning an integer indicating whether the
   * point was before, at, or after the other.
   */
  compare(point, another) {
    var result = Path.compare(point.path, another.path);

    if (result === 0) {
      if (point.offset < another.offset) return -1;
      if (point.offset > another.offset) return 1;
      return 0;
    }

    return result;
  },

  /**
   * Check if a point is after another.
   */
  isAfter(point, another) {
    return Point.compare(point, another) === 1;
  },

  /**
   * Check if a point is before another.
   */
  isBefore(point, another) {
    return Point.compare(point, another) === -1;
  },

  /**
   * Check if a point is exactly equal to another.
   */
  equals(point, another) {
    // PERF: ensure the offsets are equal first since they are cheaper to check.
    return point.offset === another.offset && Path.equals(point.path, another.path);
  },

  /**
   * Check if a value implements the `Point` interface.
   */
  isPoint(value) {
    return isPlainObject(value) && typeof value.offset === 'number' && Path.isPath(value.path);
  },

  /**
   * Transform a point by an operation.
   */
  transform(point, op) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return fn$7(point, p => {
      if (p === null) {
        return null;
      }

      var {
        affinity = 'forward'
      } = options;
      var {
        path,
        offset
      } = p;

      switch (op.type) {
        case 'insert_node':
        case 'move_node':
          {
            p.path = Path.transform(path, op, options);
            break;
          }

        case 'insert_text':
          {
            if (Path.equals(op.path, path) && op.offset <= offset) {
              p.offset += op.text.length;
            }

            break;
          }

        case 'merge_node':
          {
            if (Path.equals(op.path, path)) {
              p.offset += op.position;
            }

            p.path = Path.transform(path, op, options);
            break;
          }

        case 'remove_text':
          {
            if (Path.equals(op.path, path) && op.offset <= offset) {
              p.offset -= Math.min(offset - op.offset, op.text.length);
            }

            break;
          }

        case 'remove_node':
          {
            if (Path.equals(op.path, path) || Path.isAncestor(op.path, path)) {
              return null;
            }

            p.path = Path.transform(path, op, options);
            break;
          }

        case 'split_node':
          {
            if (Path.equals(op.path, path)) {
              if (op.position === offset && affinity == null) {
                return null;
              } else if (op.position < offset || op.position === offset && affinity === 'forward') {
                p.offset -= op.position;
                p.path = Path.transform(path, op, _objectSpread$6(_objectSpread$6({}, options), {}, {
                  affinity: 'forward'
                }));
              }
            } else {
              p.path = Path.transform(path, op, options);
            }

            break;
          }
      }
    });
  }

};

var PointRef = {
  /**
   * Transform the point ref's current value by an operation.
   */
  transform(ref, op) {
    var {
      current,
      affinity
    } = ref;

    if (current == null) {
      return;
    }

    var point = Point.transform(current, op, {
      affinity
    });
    ref.current = point;

    if (point == null) {
      ref.unref();
    }
  }

};

var _excluded$2 = ["anchor", "focus"];

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Range = {
  /**
   * Get the start and end points of a range, in the order in which they appear
   * in the document.
   */
  edges(range) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      reverse = false
    } = options;
    var {
      anchor,
      focus
    } = range;
    return Range.isBackward(range) === reverse ? [anchor, focus] : [focus, anchor];
  },

  /**
   * Get the end point of a range.
   */
  end(range) {
    var [, end] = Range.edges(range);
    return end;
  },

  /**
   * Check if a range is exactly equal to another.
   */
  equals(range, another) {
    return Point.equals(range.anchor, another.anchor) && Point.equals(range.focus, another.focus);
  },

  /**
   * Check if a range includes a path, a point or part of another range.
   */
  includes(range, target) {
    if (Range.isRange(target)) {
      if (Range.includes(range, target.anchor) || Range.includes(range, target.focus)) {
        return true;
      }

      var [rs, re] = Range.edges(range);
      var [ts, te] = Range.edges(target);
      return Point.isBefore(rs, ts) && Point.isAfter(re, te);
    }

    var [start, end] = Range.edges(range);
    var isAfterStart = false;
    var isBeforeEnd = false;

    if (Point.isPoint(target)) {
      isAfterStart = Point.compare(target, start) >= 0;
      isBeforeEnd = Point.compare(target, end) <= 0;
    } else {
      isAfterStart = Path.compare(target, start.path) >= 0;
      isBeforeEnd = Path.compare(target, end.path) <= 0;
    }

    return isAfterStart && isBeforeEnd;
  },

  /**
   * Get the intersection of a range with another.
   */
  intersection(range, another) {
    var rest = _objectWithoutProperties(range, _excluded$2);

    var [s1, e1] = Range.edges(range);
    var [s2, e2] = Range.edges(another);
    var start = Point.isBefore(s1, s2) ? s2 : s1;
    var end = Point.isBefore(e1, e2) ? e1 : e2;

    if (Point.isBefore(end, start)) {
      return null;
    } else {
      return _objectSpread$5({
        anchor: start,
        focus: end
      }, rest);
    }
  },

  /**
   * Check if a range is backward, meaning that its anchor point appears in the
   * document _after_ its focus point.
   */
  isBackward(range) {
    var {
      anchor,
      focus
    } = range;
    return Point.isAfter(anchor, focus);
  },

  /**
   * Check if a range is collapsed, meaning that both its anchor and focus
   * points refer to the exact same position in the document.
   */
  isCollapsed(range) {
    var {
      anchor,
      focus
    } = range;
    return Point.equals(anchor, focus);
  },

  /**
   * Check if a range is expanded.
   *
   * This is the opposite of [[Range.isCollapsed]] and is provided for legibility.
   */
  isExpanded(range) {
    return !Range.isCollapsed(range);
  },

  /**
   * Check if a range is forward.
   *
   * This is the opposite of [[Range.isBackward]] and is provided for legibility.
   */
  isForward(range) {
    return !Range.isBackward(range);
  },

  /**
   * Check if a value implements the [[Range]] interface.
   */
  isRange(value) {
    return isPlainObject(value) && Point.isPoint(value.anchor) && Point.isPoint(value.focus);
  },

  /**
   * Iterate through all of the point entries in a range.
   */
  *points(range) {
    yield [range.anchor, 'anchor'];
    yield [range.focus, 'focus'];
  },

  /**
   * Get the start point of a range.
   */
  start(range) {
    var [start] = Range.edges(range);
    return start;
  },

  /**
   * Transform a range by an operation.
   */
  transform(range, op) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return fn$7(range, r => {
      if (r === null) {
        return null;
      }

      var {
        affinity = 'inward'
      } = options;
      var affinityAnchor;
      var affinityFocus;

      if (affinity === 'inward') {
        // If the range is collapsed, make sure to use the same affinity to
        // avoid the two points passing each other and expanding in the opposite
        // direction
        var isCollapsed = Range.isCollapsed(r);

        if (Range.isForward(r)) {
          affinityAnchor = 'forward';
          affinityFocus = isCollapsed ? affinityAnchor : 'backward';
        } else {
          affinityAnchor = 'backward';
          affinityFocus = isCollapsed ? affinityAnchor : 'forward';
        }
      } else if (affinity === 'outward') {
        if (Range.isForward(r)) {
          affinityAnchor = 'backward';
          affinityFocus = 'forward';
        } else {
          affinityAnchor = 'forward';
          affinityFocus = 'backward';
        }
      } else {
        affinityAnchor = affinity;
        affinityFocus = affinity;
      }

      var anchor = Point.transform(r.anchor, op, {
        affinity: affinityAnchor
      });
      var focus = Point.transform(r.focus, op, {
        affinity: affinityFocus
      });

      if (!anchor || !focus) {
        return null;
      }

      r.anchor = anchor;
      r.focus = focus;
    });
  }

};

var RangeRef = {
  /**
   * Transform the range ref's current value by an operation.
   */
  transform(ref, op) {
    var {
      current,
      affinity
    } = ref;

    if (current == null) {
      return;
    }

    var path = Range.transform(current, op, {
      affinity
    });
    ref.current = path;

    if (path == null) {
      ref.unref();
    }
  }

};

/*
  Custom deep equal comparison for Slate nodes.

  We don't need general purpose deep equality;
  Slate only supports plain values, Arrays, and nested objects.
  Complex values nested inside Arrays are not supported.

  Slate objects are designed to be serialised, so
  missing keys are deliberately normalised to undefined.
 */

var isDeepEqual = (node, another) => {
  for (var key in node) {
    var a = node[key];
    var b = another[key];

    if (isPlainObject(a) && isPlainObject(b)) {
      if (!isDeepEqual(a, b)) return false;
    } else if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;

      for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }
    } else if (a !== b) {
      return false;
    }
  }
  /*
    Deep object equality is only necessary in one direction; in the reverse direction
    we are only looking for keys that are missing.
    As above, undefined keys are normalised to missing.
  */


  for (var _key in another) {
    if (node[_key] === undefined && another[_key] !== undefined) {
      return false;
    }
  }

  return true;
};

var _excluded$1 = ["text"],
    _excluded2$1 = ["anchor", "focus"];

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Text = {
  /**
   * Check if two text nodes are equal.
   *
   * When loose is set, the text is not compared. This is
   * used to check whether sibling text nodes can be merged.
   */
  equals(text, another) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      loose = false
    } = options;

    function omitText(obj) {
      var rest = _objectWithoutProperties(obj, _excluded$1);

      return rest;
    }

    return isDeepEqual(loose ? omitText(text) : text, loose ? omitText(another) : another);
  },

  /**
   * Check if a value implements the `Text` interface.
   */
  isText(value) {
    return isPlainObject(value) && typeof value.text === 'string';
  },

  /**
   * Check if a value is a list of `Text` objects.
   */
  isTextList(value) {
    return Array.isArray(value) && value.every(val => Text.isText(val));
  },

  /**
   * Check if some props are a partial of Text.
   */
  isTextProps(props) {
    return props.text !== undefined;
  },

  /**
   * Check if an text matches set of properties.
   *
   * Note: this is for matching custom properties, and it does not ensure that
   * the `text` property are two nodes equal.
   */
  matches(text, props) {
    for (var key in props) {
      if (key === 'text') {
        continue;
      }

      if (!text.hasOwnProperty(key) || text[key] !== props[key]) {
        return false;
      }
    }

    return true;
  },

  /**
   * Get the leaves for a text node given decorations.
   */
  decorations(node, decorations) {
    var leaves = [_objectSpread$4({}, node)];

    for (var dec of decorations) {
      var rest = _objectWithoutProperties(dec, _excluded2$1);

      var [start, end] = Range.edges(dec);
      var next = [];
      var o = 0;

      for (var leaf of leaves) {
        var {
          length
        } = leaf.text;
        var offset = o;
        o += length; // If the range encompases the entire leaf, add the range.

        if (start.offset <= offset && end.offset >= o) {
          Object.assign(leaf, rest);
          next.push(leaf);
          continue;
        } // If the range expanded and match the leaf, or starts after, or ends before it, continue.


        if (start.offset !== end.offset && (start.offset === o || end.offset === offset) || start.offset > o || end.offset < offset || end.offset === offset && offset !== 0) {
          next.push(leaf);
          continue;
        } // Otherwise we need to split the leaf, at the start, end, or both,
        // and add the range to the middle intersecting section. Do the end
        // split first since we don't need to update the offset that way.


        var middle = leaf;
        var before = void 0;
        var after = void 0;

        if (end.offset < o) {
          var off = end.offset - offset;
          after = _objectSpread$4(_objectSpread$4({}, middle), {}, {
            text: middle.text.slice(off)
          });
          middle = _objectSpread$4(_objectSpread$4({}, middle), {}, {
            text: middle.text.slice(0, off)
          });
        }

        if (start.offset > offset) {
          var _off = start.offset - offset;

          before = _objectSpread$4(_objectSpread$4({}, middle), {}, {
            text: middle.text.slice(0, _off)
          });
          middle = _objectSpread$4(_objectSpread$4({}, middle), {}, {
            text: middle.text.slice(_off)
          });
        }

        Object.assign(middle, rest);

        if (before) {
          next.push(before);
        }

        next.push(middle);

        if (after) {
          next.push(after);
        }
      }

      leaves = next;
    }

    return leaves;
  }

};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var applyToDraft = (editor, selection, op) => {
  switch (op.type) {
    case 'insert_node':
      {
        var {
          path,
          node
        } = op;
        var parent = Node$1.parent(editor, path);
        var index = path[path.length - 1];

        if (index > parent.children.length) {
          throw new Error("Cannot apply an \"insert_node\" operation at path [".concat(path, "] because the destination is past the end of the node."));
        }

        parent.children.splice(index, 0, node);

        if (selection) {
          for (var [point, key] of Range.points(selection)) {
            selection[key] = Point.transform(point, op);
          }
        }

        break;
      }

    case 'insert_text':
      {
        var {
          path: _path,
          offset,
          text
        } = op;
        if (text.length === 0) break;

        var _node = Node$1.leaf(editor, _path);

        var before = _node.text.slice(0, offset);

        var after = _node.text.slice(offset);

        _node.text = before + text + after;

        if (selection) {
          for (var [_point, _key] of Range.points(selection)) {
            selection[_key] = Point.transform(_point, op);
          }
        }

        break;
      }

    case 'merge_node':
      {
        var {
          path: _path2
        } = op;

        var _node2 = Node$1.get(editor, _path2);

        var prevPath = Path.previous(_path2);
        var prev = Node$1.get(editor, prevPath);

        var _parent = Node$1.parent(editor, _path2);

        var _index = _path2[_path2.length - 1];

        if (Text.isText(_node2) && Text.isText(prev)) {
          prev.text += _node2.text;
        } else if (!Text.isText(_node2) && !Text.isText(prev)) {
          prev.children.push(..._node2.children);
        } else {
          throw new Error("Cannot apply a \"merge_node\" operation at path [".concat(_path2, "] to nodes of different interfaces: ").concat(_node2, " ").concat(prev));
        }

        _parent.children.splice(_index, 1);

        if (selection) {
          for (var [_point2, _key2] of Range.points(selection)) {
            selection[_key2] = Point.transform(_point2, op);
          }
        }

        break;
      }

    case 'move_node':
      {
        var {
          path: _path3,
          newPath
        } = op;

        if (Path.isAncestor(_path3, newPath)) {
          throw new Error("Cannot move a path [".concat(_path3, "] to new path [").concat(newPath, "] because the destination is inside itself."));
        }

        var _node3 = Node$1.get(editor, _path3);

        var _parent2 = Node$1.parent(editor, _path3);

        var _index2 = _path3[_path3.length - 1]; // This is tricky, but since the `path` and `newPath` both refer to
        // the same snapshot in time, there's a mismatch. After either
        // removing the original position, the second step's path can be out
        // of date. So instead of using the `op.newPath` directly, we
        // transform `op.path` to ascertain what the `newPath` would be after
        // the operation was applied.

        _parent2.children.splice(_index2, 1);

        var truePath = Path.transform(_path3, op);
        var newParent = Node$1.get(editor, Path.parent(truePath));
        var newIndex = truePath[truePath.length - 1];
        newParent.children.splice(newIndex, 0, _node3);

        if (selection) {
          for (var [_point3, _key3] of Range.points(selection)) {
            selection[_key3] = Point.transform(_point3, op);
          }
        }

        break;
      }

    case 'remove_node':
      {
        var {
          path: _path4
        } = op;
        var _index3 = _path4[_path4.length - 1];

        var _parent3 = Node$1.parent(editor, _path4);

        _parent3.children.splice(_index3, 1); // Transform all of the points in the value, but if the point was in the
        // node that was removed we need to update the range or remove it.


        if (selection) {
          for (var [_point4, _key4] of Range.points(selection)) {
            var result = Point.transform(_point4, op);

            if (selection != null && result != null) {
              selection[_key4] = result;
            } else {
              var _prev = void 0;

              var next = void 0;

              for (var [n, p] of Node$1.texts(editor)) {
                if (Path.compare(p, _path4) === -1) {
                  _prev = [n, p];
                } else {
                  next = [n, p];
                  break;
                }
              }

              var preferNext = false;

              if (_prev && next) {
                if (Path.equals(next[1], _path4)) {
                  preferNext = !Path.hasPrevious(next[1]);
                } else {
                  preferNext = Path.common(_prev[1], _path4).length < Path.common(next[1], _path4).length;
                }
              }

              if (_prev && !preferNext) {
                _point4.path = _prev[1];
                _point4.offset = _prev[0].text.length;
              } else if (next) {
                _point4.path = next[1];
                _point4.offset = 0;
              } else {
                selection = null;
              }
            }
          }
        }

        break;
      }

    case 'remove_text':
      {
        var {
          path: _path5,
          offset: _offset,
          text: _text
        } = op;
        if (_text.length === 0) break;

        var _node4 = Node$1.leaf(editor, _path5);

        var _before = _node4.text.slice(0, _offset);

        var _after = _node4.text.slice(_offset + _text.length);

        _node4.text = _before + _after;

        if (selection) {
          for (var [_point5, _key5] of Range.points(selection)) {
            selection[_key5] = Point.transform(_point5, op);
          }
        }

        break;
      }

    case 'set_node':
      {
        var {
          path: _path6,
          properties,
          newProperties
        } = op;

        if (_path6.length === 0) {
          throw new Error("Cannot set properties on the root node!");
        }

        var _node5 = Node$1.get(editor, _path6);

        for (var _key6 in newProperties) {
          if (_key6 === 'children' || _key6 === 'text') {
            throw new Error("Cannot set the \"".concat(_key6, "\" property of nodes!"));
          }

          var value = newProperties[_key6];

          if (value == null) {
            delete _node5[_key6];
          } else {
            _node5[_key6] = value;
          }
        } // properties that were previously defined, but are now missing, must be deleted


        for (var _key7 in properties) {
          if (!newProperties.hasOwnProperty(_key7)) {
            delete _node5[_key7];
          }
        }

        break;
      }

    case 'set_selection':
      {
        var {
          newProperties: _newProperties
        } = op;

        if (_newProperties == null) {
          selection = _newProperties;
        } else {
          if (selection == null) {
            if (!Range.isRange(_newProperties)) {
              throw new Error("Cannot apply an incomplete \"set_selection\" operation properties ".concat(JSON.stringify(_newProperties), " when there is no current selection."));
            }

            selection = _objectSpread$3({}, _newProperties);
          }

          for (var _key8 in _newProperties) {
            var _value = _newProperties[_key8];

            if (_value == null) {
              if (_key8 === 'anchor' || _key8 === 'focus') {
                throw new Error("Cannot remove the \"".concat(_key8, "\" selection property"));
              }

              delete selection[_key8];
            } else {
              selection[_key8] = _value;
            }
          }
        }

        break;
      }

    case 'split_node':
      {
        var {
          path: _path7,
          position,
          properties: _properties
        } = op;

        if (_path7.length === 0) {
          throw new Error("Cannot apply a \"split_node\" operation at path [".concat(_path7, "] because the root node cannot be split."));
        }

        var _node6 = Node$1.get(editor, _path7);

        var _parent4 = Node$1.parent(editor, _path7);

        var _index4 = _path7[_path7.length - 1];
        var newNode;

        if (Text.isText(_node6)) {
          var _before2 = _node6.text.slice(0, position);

          var _after2 = _node6.text.slice(position);

          _node6.text = _before2;
          newNode = _objectSpread$3(_objectSpread$3({}, _properties), {}, {
            text: _after2
          });
        } else {
          var _before3 = _node6.children.slice(0, position);

          var _after3 = _node6.children.slice(position);

          _node6.children = _before3;
          newNode = _objectSpread$3(_objectSpread$3({}, _properties), {}, {
            children: _after3
          });
        }

        _parent4.children.splice(_index4 + 1, 0, newNode);

        if (selection) {
          for (var [_point6, _key9] of Range.points(selection)) {
            selection[_key9] = Point.transform(_point6, op);
          }
        }

        break;
      }
  }

  return selection;
};

var GeneralTransforms = {
  /**
   * Transform the editor by an operation.
   */
  transform(editor, op) {
    editor.children = ln$7(editor.children);
    var selection = editor.selection && ln$7(editor.selection);

    try {
      selection = applyToDraft(editor, selection, op);
    } finally {
      editor.children = dn$7(editor.children);

      if (selection) {
        editor.selection = t(selection) ? dn$7(selection) : selection;
      } else {
        editor.selection = null;
      }
    }
  }

};

var _excluded = ["text"],
    _excluded2 = ["children"];

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var NodeTransforms = {
  /**
   * Insert nodes at a specific location in the Editor.
   */
  insertNodes(editor, nodes) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        hanging = false,
        voids = false,
        mode = 'lowest'
      } = options;
      var {
        at,
        match,
        select
      } = options;

      if (Node$1.isNode(nodes)) {
        nodes = [nodes];
      }

      if (nodes.length === 0) {
        return;
      }

      var [node] = nodes; // By default, use the selection as the target location. But if there is
      // no selection, insert at the end of the document since that is such a
      // common use case when inserting from a non-selected state.

      if (!at) {
        if (editor.selection) {
          at = editor.selection;
        } else if (editor.children.length > 0) {
          at = Editor.end(editor, []);
        } else {
          at = [0];
        }

        select = true;
      }

      if (select == null) {
        select = false;
      }

      if (Range.isRange(at)) {
        if (!hanging) {
          at = Editor.unhangRange(editor, at);
        }

        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var [, end] = Range.edges(at);
          var pointRef = Editor.pointRef(editor, end);
          Transforms.delete(editor, {
            at
          });
          at = pointRef.unref();
        }
      }

      if (Point.isPoint(at)) {
        if (match == null) {
          if (Text.isText(node)) {
            match = n => Text.isText(n);
          } else if (editor.isInline(node)) {
            match = n => Text.isText(n) || Editor.isInline(editor, n);
          } else {
            match = n => Editor.isBlock(editor, n);
          }
        }

        var [entry] = Editor.nodes(editor, {
          at: at.path,
          match,
          mode,
          voids
        });

        if (entry) {
          var [, _matchPath] = entry;
          var pathRef = Editor.pathRef(editor, _matchPath);
          var isAtEnd = Editor.isEnd(editor, at, _matchPath);
          Transforms.splitNodes(editor, {
            at,
            match,
            mode,
            voids
          });
          var path = pathRef.unref();
          at = isAtEnd ? Path.next(path) : path;
        } else {
          return;
        }
      }

      var parentPath = Path.parent(at);
      var index = at[at.length - 1];

      if (!voids && Editor.void(editor, {
        at: parentPath
      })) {
        return;
      }

      for (var _node of nodes) {
        var _path = parentPath.concat(index);

        index++;
        editor.apply({
          type: 'insert_node',
          path: _path,
          node: _node
        });
        at = Path.next(at);
      }

      at = Path.previous(at);

      if (select) {
        var point = Editor.end(editor, at);

        if (point) {
          Transforms.select(editor, point);
        }
      }
    });
  },

  /**
   * Lift nodes at a specific location upwards in the document tree, splitting
   * their parent in two if necessary.
   */
  liftNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        at = editor.selection,
        mode = 'lowest',
        voids = false
      } = options;
      var {
        match
      } = options;

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : n => Editor.isBlock(editor, n);
      }

      if (!at) {
        return;
      }

      var matches = Editor.nodes(editor, {
        at,
        match,
        mode,
        voids
      });
      var pathRefs = Array.from(matches, _ref => {
        var [, p] = _ref;
        return Editor.pathRef(editor, p);
      });

      for (var pathRef of pathRefs) {
        var path = pathRef.unref();

        if (path.length < 2) {
          throw new Error("Cannot lift node at a path [".concat(path, "] because it has a depth of less than `2`."));
        }

        var parentNodeEntry = Editor.node(editor, Path.parent(path));
        var [parent, parentPath] = parentNodeEntry;
        var index = path[path.length - 1];
        var {
          length
        } = parent.children;

        if (length === 1) {
          var toPath = Path.next(parentPath);
          Transforms.moveNodes(editor, {
            at: path,
            to: toPath,
            voids
          });
          Transforms.removeNodes(editor, {
            at: parentPath,
            voids
          });
        } else if (index === 0) {
          Transforms.moveNodes(editor, {
            at: path,
            to: parentPath,
            voids
          });
        } else if (index === length - 1) {
          var _toPath = Path.next(parentPath);

          Transforms.moveNodes(editor, {
            at: path,
            to: _toPath,
            voids
          });
        } else {
          var splitPath = Path.next(path);

          var _toPath2 = Path.next(parentPath);

          Transforms.splitNodes(editor, {
            at: splitPath,
            voids
          });
          Transforms.moveNodes(editor, {
            at: path,
            to: _toPath2,
            voids
          });
        }
      }
    });
  },

  /**
   * Merge a node at a location with the previous node of the same depth,
   * removing any empty containing nodes after the merge if necessary.
   */
  mergeNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        match,
        at = editor.selection
      } = options;
      var {
        hanging = false,
        voids = false,
        mode = 'lowest'
      } = options;

      if (!at) {
        return;
      }

      if (match == null) {
        if (Path.isPath(at)) {
          var [parent] = Editor.parent(editor, at);

          match = n => parent.children.includes(n);
        } else {
          match = n => Editor.isBlock(editor, n);
        }
      }

      if (!hanging && Range.isRange(at)) {
        at = Editor.unhangRange(editor, at);
      }

      if (Range.isRange(at)) {
        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var [, end] = Range.edges(at);
          var pointRef = Editor.pointRef(editor, end);
          Transforms.delete(editor, {
            at
          });
          at = pointRef.unref();

          if (options.at == null) {
            Transforms.select(editor, at);
          }
        }
      }

      var [current] = Editor.nodes(editor, {
        at,
        match,
        voids,
        mode
      });
      var prev = Editor.previous(editor, {
        at,
        match,
        voids,
        mode
      });

      if (!current || !prev) {
        return;
      }

      var [node, path] = current;
      var [prevNode, prevPath] = prev;

      if (path.length === 0 || prevPath.length === 0) {
        return;
      }

      var newPath = Path.next(prevPath);
      var commonPath = Path.common(path, prevPath);
      var isPreviousSibling = Path.isSibling(path, prevPath);
      var levels = Array.from(Editor.levels(editor, {
        at: path
      }), _ref2 => {
        var [n] = _ref2;
        return n;
      }).slice(commonPath.length).slice(0, -1); // Determine if the merge will leave an ancestor of the path empty as a
      // result, in which case we'll want to remove it after merging.

      var emptyAncestor = Editor.above(editor, {
        at: path,
        mode: 'highest',
        match: n => levels.includes(n) && hasSingleChildNest(editor, n)
      });
      var emptyRef = emptyAncestor && Editor.pathRef(editor, emptyAncestor[1]);
      var properties;
      var position; // Ensure that the nodes are equivalent, and figure out what the position
      // and extra properties of the merge will be.

      if (Text.isText(node) && Text.isText(prevNode)) {
        var rest = _objectWithoutProperties(node, _excluded);

        position = prevNode.text.length;
        properties = rest;
      } else if (Element$1.isElement(node) && Element$1.isElement(prevNode)) {
        var rest = _objectWithoutProperties(node, _excluded2);

        position = prevNode.children.length;
        properties = rest;
      } else {
        throw new Error("Cannot merge the node at path [".concat(path, "] with the previous sibling because it is not the same kind: ").concat(JSON.stringify(node), " ").concat(JSON.stringify(prevNode)));
      } // If the node isn't already the next sibling of the previous node, move
      // it so that it is before merging.


      if (!isPreviousSibling) {
        Transforms.moveNodes(editor, {
          at: path,
          to: newPath,
          voids
        });
      } // If there was going to be an empty ancestor of the node that was merged,
      // we remove it from the tree.


      if (emptyRef) {
        Transforms.removeNodes(editor, {
          at: emptyRef.current,
          voids
        });
      } // If the target node that we're merging with is empty, remove it instead
      // of merging the two. This is a common rich text editor behavior to
      // prevent losing formatting when deleting entire nodes when you have a
      // hanging selection.
      // if prevNode is first child in parent,don't remove it.


      if (Element$1.isElement(prevNode) && Editor.isEmpty(editor, prevNode) || Text.isText(prevNode) && prevNode.text === '' && prevPath[prevPath.length - 1] !== 0) {
        Transforms.removeNodes(editor, {
          at: prevPath,
          voids
        });
      } else {
        editor.apply({
          type: 'merge_node',
          path: newPath,
          position,
          properties
        });
      }

      if (emptyRef) {
        emptyRef.unref();
      }
    });
  },

  /**
   * Move the nodes at a location to a new location.
   */
  moveNodes(editor, options) {
    Editor.withoutNormalizing(editor, () => {
      var {
        to,
        at = editor.selection,
        mode = 'lowest',
        voids = false
      } = options;
      var {
        match
      } = options;

      if (!at) {
        return;
      }

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : n => Editor.isBlock(editor, n);
      }

      var toRef = Editor.pathRef(editor, to);
      var targets = Editor.nodes(editor, {
        at,
        match,
        mode,
        voids
      });
      var pathRefs = Array.from(targets, _ref3 => {
        var [, p] = _ref3;
        return Editor.pathRef(editor, p);
      });

      for (var pathRef of pathRefs) {
        var path = pathRef.unref();
        var newPath = toRef.current;

        if (path.length !== 0) {
          editor.apply({
            type: 'move_node',
            path,
            newPath
          });
        }

        if (toRef.current && Path.isSibling(newPath, path) && Path.isAfter(newPath, path)) {
          // When performing a sibling move to a later index, the path at the destination is shifted
          // to before the insertion point instead of after. To ensure our group of nodes are inserted
          // in the correct order we increment toRef to account for that
          toRef.current = Path.next(toRef.current);
        }
      }

      toRef.unref();
    });
  },

  /**
   * Remove the nodes at a specific location in the document.
   */
  removeNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        hanging = false,
        voids = false,
        mode = 'lowest'
      } = options;
      var {
        at = editor.selection,
        match
      } = options;

      if (!at) {
        return;
      }

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : n => Editor.isBlock(editor, n);
      }

      if (!hanging && Range.isRange(at)) {
        at = Editor.unhangRange(editor, at);
      }

      var depths = Editor.nodes(editor, {
        at,
        match,
        mode,
        voids
      });
      var pathRefs = Array.from(depths, _ref4 => {
        var [, p] = _ref4;
        return Editor.pathRef(editor, p);
      });

      for (var pathRef of pathRefs) {
        var path = pathRef.unref();

        if (path) {
          var [node] = Editor.node(editor, path);
          editor.apply({
            type: 'remove_node',
            path,
            node
          });
        }
      }
    });
  },

  /**
   * Set new properties on the nodes at a location.
   */
  setNodes(editor, props) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        match,
        at = editor.selection
      } = options;
      var {
        hanging = false,
        mode = 'lowest',
        split = false,
        voids = false
      } = options;

      if (!at) {
        return;
      }

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : n => Editor.isBlock(editor, n);
      }

      if (!hanging && Range.isRange(at)) {
        at = Editor.unhangRange(editor, at);
      }

      if (split && Range.isRange(at)) {
        if (Range.isCollapsed(at) && Editor.leaf(editor, at.anchor)[0].text.length > 0) {
          // If the range is collapsed in a non-empty node and 'split' is true, there's nothing to
          // set that won't get normalized away
          return;
        }

        var rangeRef = Editor.rangeRef(editor, at, {
          affinity: 'inward'
        });
        var [start, end] = Range.edges(at);
        var splitMode = mode === 'lowest' ? 'lowest' : 'highest';
        var endAtEndOfNode = Editor.isEnd(editor, end, end.path);
        Transforms.splitNodes(editor, {
          at: end,
          match,
          mode: splitMode,
          voids,
          always: !endAtEndOfNode
        });
        var startAtStartOfNode = Editor.isStart(editor, start, start.path);
        Transforms.splitNodes(editor, {
          at: start,
          match,
          mode: splitMode,
          voids,
          always: !startAtStartOfNode
        });
        at = rangeRef.unref();

        if (options.at == null) {
          Transforms.select(editor, at);
        }
      }

      for (var [node, path] of Editor.nodes(editor, {
        at,
        match,
        mode,
        voids
      })) {
        var properties = {};
        var newProperties = {}; // You can't set properties on the editor node.

        if (path.length === 0) {
          continue;
        }

        var hasChanges = false;

        for (var k in props) {
          if (k === 'children' || k === 'text') {
            continue;
          }

          if (props[k] !== node[k]) {
            hasChanges = true; // Omit new properties from the old properties list

            if (node.hasOwnProperty(k)) properties[k] = node[k]; // Omit properties that have been removed from the new properties list

            if (props[k] != null) newProperties[k] = props[k];
          }
        }

        if (hasChanges) {
          editor.apply({
            type: 'set_node',
            path,
            properties,
            newProperties
          });
        }
      }
    });
  },

  /**
   * Split the nodes at a specific location.
   */
  splitNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        mode = 'lowest',
        voids = false
      } = options;
      var {
        match,
        at = editor.selection,
        height = 0,
        always = false
      } = options;

      if (match == null) {
        match = n => Editor.isBlock(editor, n);
      }

      if (Range.isRange(at)) {
        at = deleteRange(editor, at);
      } // If the target is a path, the default height-skipping and position
      // counters need to account for us potentially splitting at a non-leaf.


      if (Path.isPath(at)) {
        var path = at;
        var point = Editor.point(editor, path);
        var [parent] = Editor.parent(editor, path);

        match = n => n === parent;

        height = point.path.length - path.length + 1;
        at = point;
        always = true;
      }

      if (!at) {
        return;
      }

      var beforeRef = Editor.pointRef(editor, at, {
        affinity: 'backward'
      });
      var [highest] = Editor.nodes(editor, {
        at,
        match,
        mode,
        voids
      });

      if (!highest) {
        return;
      }

      var voidMatch = Editor.void(editor, {
        at,
        mode: 'highest'
      });
      var nudge = 0;

      if (!voids && voidMatch) {
        var [voidNode, voidPath] = voidMatch;

        if (Element$1.isElement(voidNode) && editor.isInline(voidNode)) {
          var after = Editor.after(editor, voidPath);

          if (!after) {
            var text = {
              text: ''
            };
            var afterPath = Path.next(voidPath);
            Transforms.insertNodes(editor, text, {
              at: afterPath,
              voids
            });
            after = Editor.point(editor, afterPath);
          }

          at = after;
          always = true;
        }

        var siblingHeight = at.path.length - voidPath.length;
        height = siblingHeight + 1;
        always = true;
      }

      var afterRef = Editor.pointRef(editor, at);
      var depth = at.path.length - height;
      var [, highestPath] = highest;
      var lowestPath = at.path.slice(0, depth);
      var position = height === 0 ? at.offset : at.path[depth] + nudge;

      for (var [node, _path2] of Editor.levels(editor, {
        at: lowestPath,
        reverse: true,
        voids
      })) {
        var split = false;

        if (_path2.length < highestPath.length || _path2.length === 0 || !voids && Editor.isVoid(editor, node)) {
          break;
        }

        var _point = beforeRef.current;
        var isEnd = Editor.isEnd(editor, _point, _path2);

        if (always || !beforeRef || !Editor.isEdge(editor, _point, _path2)) {
          split = true;
          var properties = Node$1.extractProps(node);
          editor.apply({
            type: 'split_node',
            path: _path2,
            position,
            properties
          });
        }

        position = _path2[_path2.length - 1] + (split || isEnd ? 1 : 0);
      }

      if (options.at == null) {
        var _point2 = afterRef.current || Editor.end(editor, []);

        Transforms.select(editor, _point2);
      }

      beforeRef.unref();
      afterRef.unref();
    });
  },

  /**
   * Unset properties on the nodes at a location.
   */
  unsetNodes(editor, props) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!Array.isArray(props)) {
      props = [props];
    }

    var obj = {};

    for (var key of props) {
      obj[key] = null;
    }

    Transforms.setNodes(editor, obj, options);
  },

  /**
   * Unwrap the nodes at a location from a parent node, splitting the parent if
   * necessary to ensure that only the content in the range is unwrapped.
   */
  unwrapNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        mode = 'lowest',
        split = false,
        voids = false
      } = options;
      var {
        at = editor.selection,
        match
      } = options;

      if (!at) {
        return;
      }

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : n => Editor.isBlock(editor, n);
      }

      if (Path.isPath(at)) {
        at = Editor.range(editor, at);
      }

      var rangeRef = Range.isRange(at) ? Editor.rangeRef(editor, at) : null;
      var matches = Editor.nodes(editor, {
        at,
        match,
        mode,
        voids
      });
      var pathRefs = Array.from(matches, _ref5 => {
        var [, p] = _ref5;
        return Editor.pathRef(editor, p);
      } // unwrapNode will call liftNode which does not support splitting the node when nested.
      // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
      // that wrap target node. So we reverse the order.
      ).reverse();

      var _loop = function _loop(pathRef) {
        var path = pathRef.unref();
        var [node] = Editor.node(editor, path);
        var range = Editor.range(editor, path);

        if (split && rangeRef) {
          range = Range.intersection(rangeRef.current, range);
        }

        Transforms.liftNodes(editor, {
          at: range,
          match: n => Element$1.isAncestor(node) && node.children.includes(n),
          voids
        });
      };

      for (var pathRef of pathRefs) {
        _loop(pathRef);
      }

      if (rangeRef) {
        rangeRef.unref();
      }
    });
  },

  /**
   * Wrap the nodes at a location in a new container node, splitting the edges
   * of the range first to ensure that only the content in the range is wrapped.
   */
  wrapNodes(editor, element) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        mode = 'lowest',
        split = false,
        voids = false
      } = options;
      var {
        match,
        at = editor.selection
      } = options;

      if (!at) {
        return;
      }

      if (match == null) {
        if (Path.isPath(at)) {
          match = matchPath(editor, at);
        } else if (editor.isInline(element)) {
          match = n => Editor.isInline(editor, n) || Text.isText(n);
        } else {
          match = n => Editor.isBlock(editor, n);
        }
      }

      if (split && Range.isRange(at)) {
        var [start, end] = Range.edges(at);
        var rangeRef = Editor.rangeRef(editor, at, {
          affinity: 'inward'
        });
        Transforms.splitNodes(editor, {
          at: end,
          match,
          voids
        });
        Transforms.splitNodes(editor, {
          at: start,
          match,
          voids
        });
        at = rangeRef.unref();

        if (options.at == null) {
          Transforms.select(editor, at);
        }
      }

      var roots = Array.from(Editor.nodes(editor, {
        at,
        match: editor.isInline(element) ? n => Editor.isBlock(editor, n) : n => Editor.isEditor(n),
        mode: 'lowest',
        voids
      }));

      for (var [, rootPath] of roots) {
        var a = Range.isRange(at) ? Range.intersection(at, Editor.range(editor, rootPath)) : at;

        if (!a) {
          continue;
        }

        var matches = Array.from(Editor.nodes(editor, {
          at: a,
          match,
          mode,
          voids
        }));

        if (matches.length > 0) {
          var _ret = function () {
            var [first] = matches;
            var last = matches[matches.length - 1];
            var [, firstPath] = first;
            var [, lastPath] = last;

            if (firstPath.length === 0 && lastPath.length === 0) {
              // if there's no matching parent - usually means the node is an editor - don't do anything
              return "continue";
            }

            var commonPath = Path.equals(firstPath, lastPath) ? Path.parent(firstPath) : Path.common(firstPath, lastPath);
            var range = Editor.range(editor, firstPath, lastPath);
            var commonNodeEntry = Editor.node(editor, commonPath);
            var [commonNode] = commonNodeEntry;
            var depth = commonPath.length + 1;
            var wrapperPath = Path.next(lastPath.slice(0, depth));

            var wrapper = _objectSpread$2(_objectSpread$2({}, element), {}, {
              children: []
            });

            Transforms.insertNodes(editor, wrapper, {
              at: wrapperPath,
              voids
            });
            Transforms.moveNodes(editor, {
              at: range,
              match: n => Element$1.isAncestor(commonNode) && commonNode.children.includes(n),
              to: wrapperPath.concat(0),
              voids
            });
          }();

          if (_ret === "continue") continue;
        }
      }
    });
  }

};

var hasSingleChildNest = (editor, node) => {
  if (Element$1.isElement(node)) {
    var element = node;

    if (Editor.isVoid(editor, node)) {
      return true;
    } else if (element.children.length === 1) {
      return hasSingleChildNest(editor, element.children[0]);
    } else {
      return false;
    }
  } else if (Editor.isEditor(node)) {
    return false;
  } else {
    return true;
  }
};
/**
 * Convert a range into a point by deleting it's content.
 */


var deleteRange = (editor, range) => {
  if (Range.isCollapsed(range)) {
    return range.anchor;
  } else {
    var [, end] = Range.edges(range);
    var pointRef = Editor.pointRef(editor, end);
    Transforms.delete(editor, {
      at: range
    });
    return pointRef.unref();
  }
};

var matchPath = (editor, path) => {
  var [node] = Editor.node(editor, path);
  return n => n === node;
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var SelectionTransforms = {
  /**
   * Collapse the selection.
   */
  collapse(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      edge = 'anchor'
    } = options;
    var {
      selection
    } = editor;

    if (!selection) {
      return;
    } else if (edge === 'anchor') {
      Transforms.select(editor, selection.anchor);
    } else if (edge === 'focus') {
      Transforms.select(editor, selection.focus);
    } else if (edge === 'start') {
      var [start] = Range.edges(selection);
      Transforms.select(editor, start);
    } else if (edge === 'end') {
      var [, end] = Range.edges(selection);
      Transforms.select(editor, end);
    }
  },

  /**
   * Unset the selection.
   */
  deselect(editor) {
    var {
      selection
    } = editor;

    if (selection) {
      editor.apply({
        type: 'set_selection',
        properties: selection,
        newProperties: null
      });
    }
  },

  /**
   * Move the selection's point forward or backward.
   */
  move(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      selection
    } = editor;
    var {
      distance = 1,
      unit = 'character',
      reverse = false
    } = options;
    var {
      edge = null
    } = options;

    if (!selection) {
      return;
    }

    if (edge === 'start') {
      edge = Range.isBackward(selection) ? 'focus' : 'anchor';
    }

    if (edge === 'end') {
      edge = Range.isBackward(selection) ? 'anchor' : 'focus';
    }

    var {
      anchor,
      focus
    } = selection;
    var opts = {
      distance,
      unit
    };
    var props = {};

    if (edge == null || edge === 'anchor') {
      var point = reverse ? Editor.before(editor, anchor, opts) : Editor.after(editor, anchor, opts);

      if (point) {
        props.anchor = point;
      }
    }

    if (edge == null || edge === 'focus') {
      var _point = reverse ? Editor.before(editor, focus, opts) : Editor.after(editor, focus, opts);

      if (_point) {
        props.focus = _point;
      }
    }

    Transforms.setSelection(editor, props);
  },

  /**
   * Set the selection to a new value.
   */
  select(editor, target) {
    var {
      selection
    } = editor;
    target = Editor.range(editor, target);

    if (selection) {
      Transforms.setSelection(editor, target);
      return;
    }

    if (!Range.isRange(target)) {
      throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(JSON.stringify(target)));
    }

    editor.apply({
      type: 'set_selection',
      properties: selection,
      newProperties: target
    });
  },

  /**
   * Set new properties on one of the selection's points.
   */
  setPoint(editor, props) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      selection
    } = editor;
    var {
      edge = 'both'
    } = options;

    if (!selection) {
      return;
    }

    if (edge === 'start') {
      edge = Range.isBackward(selection) ? 'focus' : 'anchor';
    }

    if (edge === 'end') {
      edge = Range.isBackward(selection) ? 'anchor' : 'focus';
    }

    var {
      anchor,
      focus
    } = selection;
    var point = edge === 'anchor' ? anchor : focus;
    Transforms.setSelection(editor, {
      [edge === 'anchor' ? 'anchor' : 'focus']: _objectSpread$1(_objectSpread$1({}, point), props)
    });
  },

  /**
   * Set new properties on the selection.
   */
  setSelection(editor, props) {
    var {
      selection
    } = editor;
    var oldProps = {};
    var newProps = {};

    if (!selection) {
      return;
    }

    for (var k in props) {
      if (k === 'anchor' && props.anchor != null && !Point.equals(props.anchor, selection.anchor) || k === 'focus' && props.focus != null && !Point.equals(props.focus, selection.focus) || k !== 'anchor' && k !== 'focus' && props[k] !== selection[k]) {
        oldProps[k] = selection[k];
        newProps[k] = props[k];
      }
    }

    if (Object.keys(oldProps).length > 0) {
      editor.apply({
        type: 'set_selection',
        properties: oldProps,
        newProperties: newProps
      });
    }
  }

};

var TextTransforms = {
  /**
   * Delete content in the editor.
   */
  delete(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        reverse = false,
        unit = 'character',
        distance = 1,
        voids = false
      } = options;
      var {
        at = editor.selection,
        hanging = false
      } = options;

      if (!at) {
        return;
      }

      if (Range.isRange(at) && Range.isCollapsed(at)) {
        at = at.anchor;
      }

      if (Point.isPoint(at)) {
        var furthestVoid = Editor.void(editor, {
          at,
          mode: 'highest'
        });

        if (!voids && furthestVoid) {
          var [, voidPath] = furthestVoid;
          at = voidPath;
        } else {
          var opts = {
            unit,
            distance
          };
          var target = reverse ? Editor.before(editor, at, opts) || Editor.start(editor, []) : Editor.after(editor, at, opts) || Editor.end(editor, []);
          at = {
            anchor: at,
            focus: target
          };
          hanging = true;
        }
      }

      if (Path.isPath(at)) {
        Transforms.removeNodes(editor, {
          at,
          voids
        });
        return;
      }

      if (Range.isCollapsed(at)) {
        return;
      }

      if (!hanging) {
        var [, _end] = Range.edges(at);
        var endOfDoc = Editor.end(editor, []);

        if (!Point.equals(_end, endOfDoc)) {
          at = Editor.unhangRange(editor, at, {
            voids
          });
        }
      }

      var [start, end] = Range.edges(at);
      var startBlock = Editor.above(editor, {
        match: n => Editor.isBlock(editor, n),
        at: start,
        voids
      });
      var endBlock = Editor.above(editor, {
        match: n => Editor.isBlock(editor, n),
        at: end,
        voids
      });
      var isAcrossBlocks = startBlock && endBlock && !Path.equals(startBlock[1], endBlock[1]);
      var isSingleText = Path.equals(start.path, end.path);
      var startVoid = voids ? null : Editor.void(editor, {
        at: start,
        mode: 'highest'
      });
      var endVoid = voids ? null : Editor.void(editor, {
        at: end,
        mode: 'highest'
      }); // If the start or end points are inside an inline void, nudge them out.

      if (startVoid) {
        var before = Editor.before(editor, start);

        if (before && startBlock && Path.isAncestor(startBlock[1], before.path)) {
          start = before;
        }
      }

      if (endVoid) {
        var after = Editor.after(editor, end);

        if (after && endBlock && Path.isAncestor(endBlock[1], after.path)) {
          end = after;
        }
      } // Get the highest nodes that are completely inside the range, as well as
      // the start and end nodes.


      var matches = [];
      var lastPath;

      for (var entry of Editor.nodes(editor, {
        at,
        voids
      })) {
        var [node, path] = entry;

        if (lastPath && Path.compare(path, lastPath) === 0) {
          continue;
        }

        if (!voids && Editor.isVoid(editor, node) || !Path.isCommon(path, start.path) && !Path.isCommon(path, end.path)) {
          matches.push(entry);
          lastPath = path;
        }
      }

      var pathRefs = Array.from(matches, _ref => {
        var [, p] = _ref;
        return Editor.pathRef(editor, p);
      });
      var startRef = Editor.pointRef(editor, start);
      var endRef = Editor.pointRef(editor, end);

      if (!isSingleText && !startVoid) {
        var _point = startRef.current;
        var [_node] = Editor.leaf(editor, _point);
        var {
          path: _path
        } = _point;
        var {
          offset
        } = start;

        var text = _node.text.slice(offset);

        if (text.length > 0) editor.apply({
          type: 'remove_text',
          path: _path,
          offset,
          text
        });
      }

      for (var pathRef of pathRefs) {
        var _path2 = pathRef.unref();

        Transforms.removeNodes(editor, {
          at: _path2,
          voids
        });
      }

      if (!endVoid) {
        var _point2 = endRef.current;
        var [_node2] = Editor.leaf(editor, _point2);
        var {
          path: _path3
        } = _point2;

        var _offset = isSingleText ? start.offset : 0;

        var _text = _node2.text.slice(_offset, end.offset);

        if (_text.length > 0) editor.apply({
          type: 'remove_text',
          path: _path3,
          offset: _offset,
          text: _text
        });
      }

      if (!isSingleText && isAcrossBlocks && endRef.current && startRef.current) {
        Transforms.mergeNodes(editor, {
          at: endRef.current,
          hanging: true,
          voids
        });
      }

      var point = reverse ? startRef.unref() || endRef.unref() : endRef.unref() || startRef.unref();

      if (options.at == null && point) {
        Transforms.select(editor, point);
      }
    });
  },

  /**
   * Insert a fragment at a specific location in the editor.
   */
  insertFragment(editor, fragment) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        hanging = false,
        voids = false
      } = options;
      var {
        at = editor.selection
      } = options;

      if (!fragment.length) {
        return;
      }

      if (!at) {
        return;
      } else if (Range.isRange(at)) {
        if (!hanging) {
          at = Editor.unhangRange(editor, at);
        }

        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var [, end] = Range.edges(at);

          if (!voids && Editor.void(editor, {
            at: end
          })) {
            return;
          }

          var pointRef = Editor.pointRef(editor, end);
          Transforms.delete(editor, {
            at
          });
          at = pointRef.unref();
        }
      } else if (Path.isPath(at)) {
        at = Editor.start(editor, at);
      }

      if (!voids && Editor.void(editor, {
        at
      })) {
        return;
      } // If the insert point is at the edge of an inline node, move it outside
      // instead since it will need to be split otherwise.


      var inlineElementMatch = Editor.above(editor, {
        at,
        match: n => Editor.isInline(editor, n),
        mode: 'highest',
        voids
      });

      if (inlineElementMatch) {
        var [, _inlinePath] = inlineElementMatch;

        if (Editor.isEnd(editor, at, _inlinePath)) {
          var after = Editor.after(editor, _inlinePath);
          at = after;
        } else if (Editor.isStart(editor, at, _inlinePath)) {
          var before = Editor.before(editor, _inlinePath);
          at = before;
        }
      }

      var blockMatch = Editor.above(editor, {
        match: n => Editor.isBlock(editor, n),
        at,
        voids
      });
      var [, blockPath] = blockMatch;
      var isBlockStart = Editor.isStart(editor, at, blockPath);
      var isBlockEnd = Editor.isEnd(editor, at, blockPath);
      var isBlockEmpty = isBlockStart && isBlockEnd;
      var mergeStart = !isBlockStart || isBlockStart && isBlockEnd;
      var mergeEnd = !isBlockEnd;
      var [, firstPath] = Node$1.first({
        children: fragment
      }, []);
      var [, lastPath] = Node$1.last({
        children: fragment
      }, []);
      var matches = [];

      var matcher = _ref2 => {
        var [n, p] = _ref2;
        var isRoot = p.length === 0;

        if (isRoot) {
          return false;
        }

        if (isBlockEmpty) {
          return true;
        }

        if (mergeStart && Path.isAncestor(p, firstPath) && Element$1.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) {
          return false;
        }

        if (mergeEnd && Path.isAncestor(p, lastPath) && Element$1.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) {
          return false;
        }

        return true;
      };

      for (var entry of Node$1.nodes({
        children: fragment
      }, {
        pass: matcher
      })) {
        if (matcher(entry)) {
          matches.push(entry);
        }
      }

      var starts = [];
      var middles = [];
      var ends = [];
      var starting = true;
      var hasBlocks = false;

      for (var [node] of matches) {
        if (Element$1.isElement(node) && !editor.isInline(node)) {
          starting = false;
          hasBlocks = true;
          middles.push(node);
        } else if (starting) {
          starts.push(node);
        } else {
          ends.push(node);
        }
      }

      var [inlineMatch] = Editor.nodes(editor, {
        at,
        match: n => Text.isText(n) || Editor.isInline(editor, n),
        mode: 'highest',
        voids
      });
      var [, inlinePath] = inlineMatch;
      var isInlineStart = Editor.isStart(editor, at, inlinePath);
      var isInlineEnd = Editor.isEnd(editor, at, inlinePath);
      var middleRef = Editor.pathRef(editor, isBlockEnd ? Path.next(blockPath) : blockPath);
      var endRef = Editor.pathRef(editor, isInlineEnd ? Path.next(inlinePath) : inlinePath);
      var blockPathRef = Editor.pathRef(editor, blockPath);
      Transforms.splitNodes(editor, {
        at,
        match: n => hasBlocks ? Editor.isBlock(editor, n) : Text.isText(n) || Editor.isInline(editor, n),
        mode: hasBlocks ? 'lowest' : 'highest',
        voids
      });
      var startRef = Editor.pathRef(editor, !isInlineStart || isInlineStart && isInlineEnd ? Path.next(inlinePath) : inlinePath);
      Transforms.insertNodes(editor, starts, {
        at: startRef.current,
        match: n => Text.isText(n) || Editor.isInline(editor, n),
        mode: 'highest',
        voids
      });

      if (isBlockEmpty && middles.length) {
        Transforms.delete(editor, {
          at: blockPathRef.unref(),
          voids
        });
      }

      Transforms.insertNodes(editor, middles, {
        at: middleRef.current,
        match: n => Editor.isBlock(editor, n),
        mode: 'lowest',
        voids
      });
      Transforms.insertNodes(editor, ends, {
        at: endRef.current,
        match: n => Text.isText(n) || Editor.isInline(editor, n),
        mode: 'highest',
        voids
      });

      if (!options.at) {
        var path;

        if (ends.length > 0) {
          path = Path.previous(endRef.current);
        } else if (middles.length > 0) {
          path = Path.previous(middleRef.current);
        } else {
          path = Path.previous(startRef.current);
        }

        var _end2 = Editor.end(editor, path);

        Transforms.select(editor, _end2);
      }

      startRef.unref();
      middleRef.unref();
      endRef.unref();
    });
  },

  /**
   * Insert a string of text in the Editor.
   */
  insertText(editor, text) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        voids = false
      } = options;
      var {
        at = editor.selection
      } = options;

      if (!at) {
        return;
      }

      if (Path.isPath(at)) {
        at = Editor.range(editor, at);
      }

      if (Range.isRange(at)) {
        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var end = Range.end(at);

          if (!voids && Editor.void(editor, {
            at: end
          })) {
            return;
          }

          var pointRef = Editor.pointRef(editor, end);
          Transforms.delete(editor, {
            at,
            voids
          });
          at = pointRef.unref();
          Transforms.setSelection(editor, {
            anchor: at,
            focus: at
          });
        }
      }

      if (!voids && Editor.void(editor, {
        at
      })) {
        return;
      }

      var {
        path,
        offset
      } = at;
      if (text.length > 0) editor.apply({
        type: 'insert_text',
        path,
        offset,
        text
      });
    });
  }

};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Transforms = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, GeneralTransforms), NodeTransforms), SelectionTransforms), TextTransforms);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    funcTag$1 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20f0',
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral$1 = '[' + rsAstralRange$1 + ']',
    rsCombo$1 = '[' + rsComboMarksRange$1 + rsComboSymbolsRange$1 + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$1 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$1 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsSymbol$1 = '(?:' + [rsNonAstral$1 + rsCombo$1 + '?', rsCombo$1, rsRegional$1, rsSurrPair$1, rsAstral$1].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode$1 = RegExp(rsFitz$1 + '(?=' + rsFitz$1 + ')|' + rsSymbol$1 + rsSeq$1, 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode$1 = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboMarksRange$1 + rsComboSymbolsRange$1 + rsVarRange$1 + ']');

/** Detect free variable `global` from Node.js. */
var freeGlobal$3 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$3 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$3 = freeGlobal$3 || freeSelf$3 || Function('return this')();

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray$1(string) {
  return string.split('');
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$1(string) {
  return reHasUnicode$1.test(string);
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg$1(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string)
    ? unicodeToArray$1(string)
    : asciiToArray$1(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode$1) || [];
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$4 = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root$3['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$4 = objectProto$4.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol$2 = root$3.Symbol,
    iteratorSymbol = Symbol$2 ? Symbol$2.iterator : undefined,
    propertyIsEnumerable$1 = objectProto$4.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg$1(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root$3, 'DataView'),
    Map$1 = getNative(root$3, 'Map'),
    Promise$1 = getNative(root$3, 'Promise'),
    Set$1 = getNative(root$3, 'Set'),
    WeakMap$1 = getNative(root$3, 'WeakMap');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$1(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray$1(value) || isArguments$1(value))
    ? baseTimes$1(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$2.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex$1(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString$4.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject$4(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction$1(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype$1(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map$1 && getTag(new Map$1) != mapTag) ||
    (Promise$1 && getTag(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag(new Set$1) != setTag) ||
    (WeakMap$1 && getTag(new WeakMap$1) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString$4.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$1(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length &&
    (typeof value == 'number' || reIsUint$1.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$1(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments$1(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject$1(value) && hasOwnProperty$2.call(value, 'callee') &&
    (!propertyIsEnumerable$1.call(value, 'callee') || objectToString$4.call(value) == argsTag$1);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$1(value) {
  return value != null && isLength$1(value.length) && !isFunction$1(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject$1(value) {
  return isObjectLike$4(value) && isArrayLike$1(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject$4(value) ? objectToString$4.call(value) : '';
  return tag == funcTag$1 || tag == genTag$1;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$1(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$4(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$4(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray$1(value) && isObjectLike$4(value) && objectToString$4.call(value) == stringTag);
}

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike$1(value)) {
    return isString(value) ? stringToArray$1(value) : copyArray(value);
  }
  if (iteratorSymbol && value[iteratorSymbol]) {
    return iteratorToArray(value[iteratorSymbol]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object ? baseValues(object, keys$1(object)) : [];
}

var lodash_toarray = toArray;

/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */
/* eslint-disable no-param-reassign */
function isObject$3(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target, src) {
    if (target === void 0) { target = {}; }
    if (src === void 0) { src = {}; }
    Object.keys(src).forEach(function (key) {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject$3(src[key]) &&
            isObject$3(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

var ssrDocument = {
    body: {},
    addEventListener: function () { },
    removeEventListener: function () { },
    activeElement: {
        blur: function () { },
        nodeName: '',
    },
    querySelector: function () {
        return null;
    },
    querySelectorAll: function () {
        return [];
    },
    getElementById: function () {
        return null;
    },
    createEvent: function () {
        return {
            initEvent: function () { },
        };
    },
    createElement: function () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function () { },
            getElementsByTagName: function () {
                return [];
            },
        };
    },
    createElementNS: function () {
        return {};
    },
    importNode: function () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}

var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState: function () { },
        pushState: function () { },
        go: function () { },
        back: function () { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function () { },
    removeEventListener: function () { },
    getComputedStyle: function () {
        return {
            getPropertyValue: function () {
                return '';
            },
        };
    },
    Image: function () { },
    Date: function () { },
    screen: {},
    setTimeout: function () { },
    clearTimeout: function () { },
    matchMedia: function () {
        return {};
    },
    requestAnimationFrame: function (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function (id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}

/**
 * Dom7 3.0.0
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/* eslint-disable no-proto */
function makeReactive(obj) {
  var proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get: function get() {
      return proto;
    },
    set: function set(value) {
      proto.__proto__ = value;
    }
  });
}

var Dom7 = /*#__PURE__*/function (_Array) {
  _inheritsLoose(Dom7, _Array);

  function Dom7(items) {
    var _this;

    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
    makeReactive(_assertThisInitialized(_this));
    return _this;
  }

  return Dom7;
}( /*#__PURE__*/_wrapNativeSuper(Array));

function arrayFlat(arr) {
  if (arr === void 0) {
    arr = [];
  }

  var res = [];
  arr.forEach(function (el) {
    if (Array.isArray(el)) {
      res.push.apply(res, arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  var uniqueArray = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, function (match, group) {
    return group.toUpperCase();
  });
}

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  var a = [];
  var res = context.querySelectorAll(selector);

  for (var i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $$6(selector, context) {
  var window = getWindow();
  var document = getDocument();
  var arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    var html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      var toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      var tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$$6.fn = Dom7.prototype;

function addClass() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList;

    (_el$classList = el.classList).add.apply(_el$classList, classNames);
  });
  return this;
}

function removeClass() {
  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classes[_key2] = arguments[_key2];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList2;

    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
  });
  return this;
}

function hasClass() {
  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    classes[_key4] = arguments[_key4];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  return arrayFilter(this, function (el) {
    return classNames.filter(function (className) {
      return el.classList.contains(className);
    }).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function dataset() {
  var el = this[0];
  if (!el) return undefined;
  var dataset = {}; // eslint-disable-line

  if (el.dataset) {
    for (var dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (var i = 0; i < el.attributes.length; i += 1) {
      var _attr = el.attributes[i];

      if (_attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
      }
    }
  }

  for (var key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }

  return dataset;
}

function val(value) {
  if (typeof value === 'undefined') {
    // get value
    var el = this[0];
    if (!el) return undefined;

    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
      var values = [];

      for (var i = 0; i < el.selectedOptions.length; i += 1) {
        values.push(el.selectedOptions[i].value);
      }

      return values;
    }

    return el.value;
  } // set value


  for (var _i = 0; _i < this.length; _i += 1) {
    var _el = this[_i];

    if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === 'select') {
      for (var j = 0; j < _el.options.length; j += 1) {
        _el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
      }
    } else {
      _el.value = value;
    }
  }

  return this;
}

function on$7() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($$6(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $$6(target).parents(); // eslint-disable-line


      for (var k = 0; k < _parents.length; k += 1) {
        if ($$6(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  var events = eventType.split(' ');
  var j;

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });

        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  var events = eventType.split(' ');

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function width() {
  var window = getWindow();

  if (this[0] === window) {
    return window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}

function height() {
  var window = getWindow();

  if (this[0] === window) {
    return window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    var window = getWindow();
    var document = getDocument();
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window ? window.scrollY : el.scrollTop;
    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function hide() {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }

  return this;
}

function show() {
  var window = getWindow();

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.style.display === 'none') {
      el.style.display = '';
    }

    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }

  return this;
}

function css(props, value) {
  var window = getWindow();
  var i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach(function (el, index) {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  var result = arrayFilter(this, callback);
  return $$6(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is$2(selector) {
  var window = getWindow();
  var document = getDocument();
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $$6(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function append() {
  var newChild;
  var document = getDocument();

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function prepend(newChild) {
  var document = getDocument();
  var i;
  var j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($$6(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $$6(parents);
}

function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($$6(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }

      _parent = _parent.parentNode;
    }
  }

  return $$6(parents);
}

function find(selector) {
  var foundElements = [];

  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);

    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $$6(foundElements);
}

function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].children;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector || $$6(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $$6(children);
}

function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

function empty() {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.nodeType === 1) {
      for (var j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }

      el.textContent = '';
    }
  }

  return this;
}

var noTrigger = 'resize scroll'.split(' ');

function shortcut(name) {
  function eventHandler() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'undefined') {
      for (var i = 0; i < this.length; i += 1) {
        if (noTrigger.indexOf(name) < 0) {
          if (name in this[i]) this[i][name]();else {
            $$6(this[i]).trigger(name);
          }
        }
      }

      return this;
    }

    return this.on.apply(this, [name].concat(args));
  }

  return eventHandler;
}

var click = shortcut('click');
var focus = shortcut('focus');

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$3.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$3 = objectProto$3.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$1.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$1.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$3;

  return value === proto;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _([1, 2]).forEach(function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, typeof iteratee == 'function' ? iteratee : identity);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty$1.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString$3.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike$3(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject$2(value) ? objectToString$3.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$2(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$3(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var lodash_foreach = forEach;

{
  if (
    typeof navigator !== 'undefined' &&
    navigator.product === 'ReactNative' &&
    typeof crypto === 'undefined'
  ) {
    throw new Error(
      'React Native does not have a built-in secure random generator. ' +
        'If you don’t need unpredictable IDs use `nanoid/non-secure`. ' +
        'For secure IDs, import `react-native-get-random-values` ' +
        'before Nano ID.'
    )
  }
  if (typeof msCrypto !== 'undefined' && typeof crypto === 'undefined') {
    throw new Error(
      'Import file with `if (!window.crypto) window.crypto = window.msCrypto`' +
        ' before importing Nano ID to fix IE 11 support'
    )
  }
  if (typeof crypto === 'undefined') {
    throw new Error(
      'Your browser does not have secure random generator. ' +
        'If you don’t need unpredictable IDs, you can use nanoid/non-secure.'
    )
  }
}
let nanoid$3 = (size = 21) => {
  let id = '';
  let bytes = crypto.getRandomValues(new Uint8Array(size));
  while (size--) {
    let byte = bytes[size] & 63;
    if (byte < 36) {
      id += byte.toString(36);
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase();
    } else if (byte < 63) {
      id += '_';
    } else {
      id += '-';
    }
  }
  return id
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal$2 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$2 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal$2 || freeSelf$2 || Function('return this')();

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$2.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin$1 = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root$2.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$2(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  if (isObject$1(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$2(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$2(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$2(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$2(value) && objectToString$2.call(value) == symbolTag$2);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$2(value)) {
    return NAN$1;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

var lodash_throttle = throttle;

function createElement(tagName, options) {
    return document.createElement(tagName, options);
}
function createElementNS(namespaceURI, qualifiedName, options) {
    return document.createElementNS(namespaceURI, qualifiedName, options);
}
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(elm) {
    return elm.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function getTextContent(node) {
    return node.textContent;
}
function isElement(node) {
    return node.nodeType === 1;
}
function isText(node) {
    return node.nodeType === 3;
}
function isComment(node) {
    return node.nodeType === 8;
}
const htmlDomApi = {
    createElement,
    createElementNS,
    createTextNode,
    createComment,
    insertBefore,
    removeChild,
    appendChild,
    parentNode,
    nextSibling,
    tagName,
    setTextContent,
    getTextContent,
    isElement,
    isText,
    isComment,
};

function vnode(sel, data, children, text, elm) {
    const key = data === undefined ? undefined : data.key;
    return { sel, data, children, text, elm, key };
}

const array = Array.isArray;
function primitive(s) {
    return typeof s === "string" ||
        typeof s === "number" ||
        s instanceof String ||
        s instanceof Number;
}

function isUndef(s) {
    return s === undefined;
}
function isDef(s) {
    return s !== undefined;
}
const emptyNode = vnode("", {}, [], undefined, undefined);
function sameVnode(vnode1, vnode2) {
    var _a, _b;
    const isSameKey = vnode1.key === vnode2.key;
    const isSameIs = ((_a = vnode1.data) === null || _a === void 0 ? void 0 : _a.is) === ((_b = vnode2.data) === null || _b === void 0 ? void 0 : _b.is);
    const isSameSel = vnode1.sel === vnode2.sel;
    return isSameSel && isSameKey && isSameIs;
}
function isVnode(vnode) {
    return vnode.sel !== undefined;
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var _a;
    const map = {};
    for (let i = beginIdx; i <= endIdx; ++i) {
        const key = (_a = children[i]) === null || _a === void 0 ? void 0 : _a.key;
        if (key !== undefined) {
            map[key] = i;
        }
    }
    return map;
}
const hooks = [
    "create",
    "update",
    "remove",
    "destroy",
    "pre",
    "post",
];
function init(modules, domApi) {
    const cbs = {
        create: [],
        update: [],
        remove: [],
        destroy: [],
        pre: [],
        post: [],
    };
    const api = domApi !== undefined ? domApi : htmlDomApi;
    for (const hook of hooks) {
        for (const module of modules) {
            const currentHook = module[hook];
            if (currentHook !== undefined) {
                cbs[hook].push(currentHook);
            }
        }
    }
    function emptyNodeAt(elm) {
        const id = elm.id ? "#" + elm.id : "";
        // elm.className doesn't return a string when elm is an SVG element inside a shadowRoot.
        // https://stackoverflow.com/questions/29454340/detecting-classname-of-svganimatedstring
        const classes = elm.getAttribute("class");
        const c = classes ? "." + classes.split(" ").join(".") : "";
        return vnode(api.tagName(elm).toLowerCase() + id + c, {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        return function rmCb() {
            if (--listeners === 0) {
                const parent = api.parentNode(childElm);
                api.removeChild(parent, childElm);
            }
        };
    }
    function createElm(vnode, insertedVnodeQueue) {
        var _a, _b;
        let i;
        let data = vnode.data;
        if (data !== undefined) {
            const init = (_a = data.hook) === null || _a === void 0 ? void 0 : _a.init;
            if (isDef(init)) {
                init(vnode);
                data = vnode.data;
            }
        }
        const children = vnode.children;
        const sel = vnode.sel;
        if (sel === "!") {
            if (isUndef(vnode.text)) {
                vnode.text = "";
            }
            vnode.elm = api.createComment(vnode.text);
        }
        else if (sel !== undefined) {
            // Parse selector
            const hashIdx = sel.indexOf("#");
            const dotIdx = sel.indexOf(".", hashIdx);
            const hash = hashIdx > 0 ? hashIdx : sel.length;
            const dot = dotIdx > 0 ? dotIdx : sel.length;
            const tag = hashIdx !== -1 || dotIdx !== -1
                ? sel.slice(0, Math.min(hash, dot))
                : sel;
            const elm = (vnode.elm =
                isDef(data) && isDef((i = data.ns))
                    ? api.createElementNS(i, tag, data)
                    : api.createElement(tag, data));
            if (hash < dot)
                elm.setAttribute("id", sel.slice(hash + 1, dot));
            if (dotIdx > 0)
                elm.setAttribute("class", sel.slice(dot + 1).replace(/\./g, " "));
            for (i = 0; i < cbs.create.length; ++i)
                cbs.create[i](emptyNode, vnode);
            if (array(children)) {
                for (i = 0; i < children.length; ++i) {
                    const ch = children[i];
                    if (ch != null) {
                        api.appendChild(elm, createElm(ch, insertedVnodeQueue));
                    }
                }
            }
            else if (primitive(vnode.text)) {
                api.appendChild(elm, api.createTextNode(vnode.text));
            }
            const hook = vnode.data.hook;
            if (isDef(hook)) {
                (_b = hook.create) === null || _b === void 0 ? void 0 : _b.call(hook, emptyNode, vnode);
                if (hook.insert) {
                    insertedVnodeQueue.push(vnode);
                }
            }
        }
        else {
            vnode.elm = api.createTextNode(vnode.text);
        }
        return vnode.elm;
    }
    function addVnodes(parentElm, before, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for (; startIdx <= endIdx; ++startIdx) {
            const ch = vnodes[startIdx];
            if (ch != null) {
                api.insertBefore(parentElm, createElm(ch, insertedVnodeQueue), before);
            }
        }
    }
    function invokeDestroyHook(vnode) {
        var _a, _b;
        const data = vnode.data;
        if (data !== undefined) {
            (_b = (_a = data === null || data === void 0 ? void 0 : data.hook) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a, vnode);
            for (let i = 0; i < cbs.destroy.length; ++i)
                cbs.destroy[i](vnode);
            if (vnode.children !== undefined) {
                for (let j = 0; j < vnode.children.length; ++j) {
                    const child = vnode.children[j];
                    if (child != null && typeof child !== "string") {
                        invokeDestroyHook(child);
                    }
                }
            }
        }
    }
    function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
        var _a, _b;
        for (; startIdx <= endIdx; ++startIdx) {
            let listeners;
            let rm;
            const ch = vnodes[startIdx];
            if (ch != null) {
                if (isDef(ch.sel)) {
                    invokeDestroyHook(ch);
                    listeners = cbs.remove.length + 1;
                    rm = createRmCb(ch.elm, listeners);
                    for (let i = 0; i < cbs.remove.length; ++i)
                        cbs.remove[i](ch, rm);
                    const removeHook = (_b = (_a = ch === null || ch === void 0 ? void 0 : ch.data) === null || _a === void 0 ? void 0 : _a.hook) === null || _b === void 0 ? void 0 : _b.remove;
                    if (isDef(removeHook)) {
                        removeHook(ch, rm);
                    }
                    else {
                        rm();
                    }
                }
                else {
                    // Text node
                    api.removeChild(parentElm, ch.elm);
                }
            }
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue) {
        let oldStartIdx = 0;
        let newStartIdx = 0;
        let oldEndIdx = oldCh.length - 1;
        let oldStartVnode = oldCh[0];
        let oldEndVnode = oldCh[oldEndIdx];
        let newEndIdx = newCh.length - 1;
        let newStartVnode = newCh[0];
        let newEndVnode = newCh[newEndIdx];
        let oldKeyToIdx;
        let idxInOld;
        let elmToMove;
        let before;
        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
            if (oldStartVnode == null) {
                oldStartVnode = oldCh[++oldStartIdx]; // Vnode might have been moved left
            }
            else if (oldEndVnode == null) {
                oldEndVnode = oldCh[--oldEndIdx];
            }
            else if (newStartVnode == null) {
                newStartVnode = newCh[++newStartIdx];
            }
            else if (newEndVnode == null) {
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else if (sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldStartVnode.elm, api.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else {
                if (oldKeyToIdx === undefined) {
                    oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                }
                idxInOld = oldKeyToIdx[newStartVnode.key];
                if (isUndef(idxInOld)) {
                    // New element
                    api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                }
                else {
                    elmToMove = oldCh[idxInOld];
                    if (elmToMove.sel !== newStartVnode.sel) {
                        api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    }
                    else {
                        patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
                        oldCh[idxInOld] = undefined;
                        api.insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
                    }
                }
                newStartVnode = newCh[++newStartIdx];
            }
        }
        if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
            if (oldStartIdx > oldEndIdx) {
                before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
                addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
            }
            else {
                removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
            }
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue) {
        var _a, _b, _c, _d, _e;
        const hook = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.hook;
        (_b = hook === null || hook === void 0 ? void 0 : hook.prepatch) === null || _b === void 0 ? void 0 : _b.call(hook, oldVnode, vnode);
        const elm = (vnode.elm = oldVnode.elm);
        const oldCh = oldVnode.children;
        const ch = vnode.children;
        if (oldVnode === vnode)
            return;
        if (vnode.data !== undefined) {
            for (let i = 0; i < cbs.update.length; ++i)
                cbs.update[i](oldVnode, vnode);
            (_d = (_c = vnode.data.hook) === null || _c === void 0 ? void 0 : _c.update) === null || _d === void 0 ? void 0 : _d.call(_c, oldVnode, vnode);
        }
        if (isUndef(vnode.text)) {
            if (isDef(oldCh) && isDef(ch)) {
                if (oldCh !== ch)
                    updateChildren(elm, oldCh, ch, insertedVnodeQueue);
            }
            else if (isDef(ch)) {
                if (isDef(oldVnode.text))
                    api.setTextContent(elm, "");
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            }
            else if (isDef(oldCh)) {
                removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            }
            else if (isDef(oldVnode.text)) {
                api.setTextContent(elm, "");
            }
        }
        else if (oldVnode.text !== vnode.text) {
            if (isDef(oldCh)) {
                removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            }
            api.setTextContent(elm, vnode.text);
        }
        (_e = hook === null || hook === void 0 ? void 0 : hook.postpatch) === null || _e === void 0 ? void 0 : _e.call(hook, oldVnode, vnode);
    }
    return function patch(oldVnode, vnode) {
        let i, elm, parent;
        const insertedVnodeQueue = [];
        for (i = 0; i < cbs.pre.length; ++i)
            cbs.pre[i]();
        if (!isVnode(oldVnode)) {
            oldVnode = emptyNodeAt(oldVnode);
        }
        if (sameVnode(oldVnode, vnode)) {
            patchVnode(oldVnode, vnode, insertedVnodeQueue);
        }
        else {
            elm = oldVnode.elm;
            parent = api.parentNode(elm);
            createElm(vnode, insertedVnodeQueue);
            if (parent !== null) {
                api.insertBefore(parent, vnode.elm, api.nextSibling(elm));
                removeVnodes(parent, [oldVnode], 0, 0);
            }
        }
        for (i = 0; i < insertedVnodeQueue.length; ++i) {
            insertedVnodeQueue[i].data.hook.insert(insertedVnodeQueue[i]);
        }
        for (i = 0; i < cbs.post.length; ++i)
            cbs.post[i]();
        return vnode;
    };
}

function addNS(data, children, sel) {
    data.ns = "http://www.w3.org/2000/svg";
    if (sel !== "foreignObject" && children !== undefined) {
        for (let i = 0; i < children.length; ++i) {
            const childData = children[i].data;
            if (childData !== undefined) {
                addNS(childData, children[i].children, children[i].sel);
            }
        }
    }
}
function h$3(sel, b, c) {
    let data = {};
    let children;
    let text;
    let i;
    if (c !== undefined) {
        if (b !== null) {
            data = b;
        }
        if (array(c)) {
            children = c;
        }
        else if (primitive(c)) {
            text = c.toString();
        }
        else if (c && c.sel) {
            children = [c];
        }
    }
    else if (b !== undefined && b !== null) {
        if (array(b)) {
            children = b;
        }
        else if (primitive(b)) {
            text = b.toString();
        }
        else if (b && b.sel) {
            children = [b];
        }
        else {
            data = b;
        }
    }
    if (children !== undefined) {
        for (i = 0; i < children.length; ++i) {
            if (primitive(children[i]))
                children[i] = vnode(undefined, undefined, undefined, children[i], undefined);
        }
    }
    if (sel[0] === "s" &&
        sel[1] === "v" &&
        sel[2] === "g" &&
        (sel.length === 3 || sel[3] === "." || sel[3] === "#")) {
        addNS(data, children, sel);
    }
    return vnode(sel, data, children, text, undefined);
}

const xlinkNS = "http://www.w3.org/1999/xlink";
const xmlNS = "http://www.w3.org/XML/1998/namespace";
const colonChar = 58;
const xChar = 120;
function updateAttrs(oldVnode, vnode) {
    let key;
    const elm = vnode.elm;
    let oldAttrs = oldVnode.data.attrs;
    let attrs = vnode.data.attrs;
    if (!oldAttrs && !attrs)
        return;
    if (oldAttrs === attrs)
        return;
    oldAttrs = oldAttrs || {};
    attrs = attrs || {};
    // update modified attributes, add new attributes
    for (key in attrs) {
        const cur = attrs[key];
        const old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) {
                elm.setAttribute(key, "");
            }
            else if (cur === false) {
                elm.removeAttribute(key);
            }
            else {
                if (key.charCodeAt(0) !== xChar) {
                    elm.setAttribute(key, cur);
                }
                else if (key.charCodeAt(3) === colonChar) {
                    // Assume xml namespace
                    elm.setAttributeNS(xmlNS, key, cur);
                }
                else if (key.charCodeAt(5) === colonChar) {
                    // Assume xlink namespace
                    elm.setAttributeNS(xlinkNS, key, cur);
                }
                else {
                    elm.setAttribute(key, cur);
                }
            }
        }
    }
    // remove removed attributes
    // use `in` operator since the previous `for` iteration uses it (.i.e. add even attributes with undefined value)
    // the other option is to remove all attributes with value == undefined
    for (key in oldAttrs) {
        if (!(key in attrs)) {
            elm.removeAttribute(key);
        }
    }
}
const attributesModule = {
    create: updateAttrs,
    update: updateAttrs,
};

function updateClass(oldVnode, vnode) {
    let cur;
    let name;
    const elm = vnode.elm;
    let oldClass = oldVnode.data.class;
    let klass = vnode.data.class;
    if (!oldClass && !klass)
        return;
    if (oldClass === klass)
        return;
    oldClass = oldClass || {};
    klass = klass || {};
    for (name in oldClass) {
        if (oldClass[name] && !Object.prototype.hasOwnProperty.call(klass, name)) {
            // was `true` and now not provided
            elm.classList.remove(name);
        }
    }
    for (name in klass) {
        cur = klass[name];
        if (cur !== oldClass[name]) {
            elm.classList[cur ? "add" : "remove"](name);
        }
    }
}
const classModule = { create: updateClass, update: updateClass };

const CAPS_REGEX = /[A-Z]/g;
function updateDataset(oldVnode, vnode) {
    const elm = vnode.elm;
    let oldDataset = oldVnode.data.dataset;
    let dataset = vnode.data.dataset;
    let key;
    if (!oldDataset && !dataset)
        return;
    if (oldDataset === dataset)
        return;
    oldDataset = oldDataset || {};
    dataset = dataset || {};
    const d = elm.dataset;
    for (key in oldDataset) {
        if (!dataset[key]) {
            if (d) {
                if (key in d) {
                    delete d[key];
                }
            }
            else {
                elm.removeAttribute("data-" + key.replace(CAPS_REGEX, "-$&").toLowerCase());
            }
        }
    }
    for (key in dataset) {
        if (oldDataset[key] !== dataset[key]) {
            if (d) {
                d[key] = dataset[key];
            }
            else {
                elm.setAttribute("data-" + key.replace(CAPS_REGEX, "-$&").toLowerCase(), dataset[key]);
            }
        }
    }
}
const datasetModule = {
    create: updateDataset,
    update: updateDataset,
};

function invokeHandler(handler, vnode, event) {
    if (typeof handler === "function") {
        // call function handler
        handler.call(vnode, event, vnode);
    }
    else if (typeof handler === "object") {
        // call multiple handlers
        for (let i = 0; i < handler.length; i++) {
            invokeHandler(handler[i], vnode, event);
        }
    }
}
function handleEvent(event, vnode) {
    const name = event.type;
    const on = vnode.data.on;
    // call event handler(s) if exists
    if (on && on[name]) {
        invokeHandler(on[name], vnode, event);
    }
}
function createListener() {
    return function handler(event) {
        handleEvent(event, handler.vnode);
    };
}
function updateEventListeners(oldVnode, vnode) {
    const oldOn = oldVnode.data.on;
    const oldListener = oldVnode.listener;
    const oldElm = oldVnode.elm;
    const on = vnode && vnode.data.on;
    const elm = (vnode && vnode.elm);
    let name;
    // optimization for reused immutable handlers
    if (oldOn === on) {
        return;
    }
    // remove existing listeners which no longer used
    if (oldOn && oldListener) {
        // if element changed or deleted we remove all existing listeners unconditionally
        if (!on) {
            for (name in oldOn) {
                // remove listener if element was changed or existing listeners removed
                oldElm.removeEventListener(name, oldListener, false);
            }
        }
        else {
            for (name in oldOn) {
                // remove listener if existing listener removed
                if (!on[name]) {
                    oldElm.removeEventListener(name, oldListener, false);
                }
            }
        }
    }
    // add new listeners which has not already attached
    if (on) {
        // reuse existing listener or create new
        const listener = (vnode.listener =
            oldVnode.listener || createListener());
        // update vnode for listener
        listener.vnode = vnode;
        // if element changed or added we add all needed listeners unconditionally
        if (!oldOn) {
            for (name in on) {
                // add listener if element was changed or new listeners added
                elm.addEventListener(name, listener, false);
            }
        }
        else {
            for (name in on) {
                // add listener if new listener added
                if (!oldOn[name]) {
                    elm.addEventListener(name, listener, false);
                }
            }
        }
    }
}
const eventListenersModule = {
    create: updateEventListeners,
    update: updateEventListeners,
    destroy: updateEventListeners,
};

function updateProps(oldVnode, vnode) {
    let key;
    let cur;
    let old;
    const elm = vnode.elm;
    let oldProps = oldVnode.data.props;
    let props = vnode.data.props;
    if (!oldProps && !props)
        return;
    if (oldProps === props)
        return;
    oldProps = oldProps || {};
    props = props || {};
    for (key in props) {
        cur = props[key];
        old = oldProps[key];
        if (old !== cur && (key !== "value" || elm[key] !== cur)) {
            elm[key] = cur;
        }
    }
}
const propsModule = { create: updateProps, update: updateProps };

// Bindig `requestAnimationFrame` like this fixes a bug in IE/Edge. See #360 and #409.
const raf = (typeof window !== "undefined" &&
    window.requestAnimationFrame.bind(window)) ||
    setTimeout;
const nextFrame = function (fn) {
    raf(function () {
        raf(fn);
    });
};
let reflowForced = false;
function setNextFrame(obj, prop, val) {
    nextFrame(function () {
        obj[prop] = val;
    });
}
function updateStyle(oldVnode, vnode) {
    let cur;
    let name;
    const elm = vnode.elm;
    let oldStyle = oldVnode.data.style;
    let style = vnode.data.style;
    if (!oldStyle && !style)
        return;
    if (oldStyle === style)
        return;
    oldStyle = oldStyle || {};
    style = style || {};
    const oldHasDel = "delayed" in oldStyle;
    for (name in oldStyle) {
        if (!style[name]) {
            if (name[0] === "-" && name[1] === "-") {
                elm.style.removeProperty(name);
            }
            else {
                elm.style[name] = "";
            }
        }
    }
    for (name in style) {
        cur = style[name];
        if (name === "delayed" && style.delayed) {
            for (const name2 in style.delayed) {
                cur = style.delayed[name2];
                if (!oldHasDel || cur !== oldStyle.delayed[name2]) {
                    setNextFrame(elm.style, name2, cur);
                }
            }
        }
        else if (name !== "remove" && cur !== oldStyle[name]) {
            if (name[0] === "-" && name[1] === "-") {
                elm.style.setProperty(name, cur);
            }
            else {
                elm.style[name] = cur;
            }
        }
    }
}
function applyDestroyStyle(vnode) {
    let style;
    let name;
    const elm = vnode.elm;
    const s = vnode.data.style;
    if (!s || !(style = s.destroy))
        return;
    for (name in style) {
        elm.style[name] = style[name];
    }
}
function applyRemoveStyle(vnode, rm) {
    const s = vnode.data.style;
    if (!s || !s.remove) {
        rm();
        return;
    }
    if (!reflowForced) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        vnode.elm.offsetLeft;
        reflowForced = true;
    }
    let name;
    const elm = vnode.elm;
    let i = 0;
    const style = s.remove;
    let amount = 0;
    const applied = [];
    for (name in style) {
        applied.push(name);
        elm.style[name] = style[name];
    }
    const compStyle = getComputedStyle(elm);
    const props = compStyle["transition-property"].split(", ");
    for (; i < props.length; ++i) {
        if (applied.indexOf(props[i]) !== -1)
            amount++;
    }
    elm.addEventListener("transitionend", function (ev) {
        if (ev.target === elm)
            --amount;
        if (amount === 0)
            rm();
    });
}
function forceReflow() {
    reflowForced = false;
}
const styleModule = {
    pre: forceReflow,
    create: updateStyle,
    update: updateStyle,
    destroy: applyDestroyStyle,
    remove: applyRemoveStyle,
};

/* eslint-disable @typescript-eslint/no-namespace, import/export */
function flattenAndFilter(children, flattened) {
    for (const child of children) {
        // filter out falsey children, except 0 since zero can be a valid value e.g inside a chart
        if (child !== undefined &&
            child !== null &&
            child !== false &&
            child !== "") {
            if (Array.isArray(child)) {
                flattenAndFilter(child, flattened);
            }
            else if (typeof child === "string" ||
                typeof child === "number" ||
                typeof child === "boolean") {
                flattened.push(vnode(undefined, undefined, undefined, String(child), undefined));
            }
            else {
                flattened.push(child);
            }
        }
    }
    return flattened;
}
/**
 * jsx/tsx compatible factory function
 * see: https://www.typescriptlang.org/docs/handbook/jsx.html#factory-functions
 */
function jsx(tag, data, ...children) {
    const flatChildren = flattenAndFilter(children, []);
    if (typeof tag === "function") {
        // tag is a function component
        return tag(data, flatChildren);
    }
    else {
        if (flatChildren.length === 1 &&
            !flatChildren[0].sel &&
            flatChildren[0].text) {
            // only child is a simple text node, pass as text for a simpler vtree
            return h$3(tag, data, flatChildren[0].text);
        }
        else {
            return h$3(tag, data, flatChildren);
        }
    }
}
(function (jsx) {
})(jsx || (jsx = {}));

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsAstral = '[' + rsAstralRange + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$1.toString;

/** Built-in value references. */
var Symbol$1 = root$1.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

var lodash_camelcase = camelCase;

/**
 * Constants.
 */

var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);

var MODIFIERS = {
  alt: 'altKey',
  control: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};

var ALIASES = {
  add: '+',
  break: 'pause',
  cmd: 'meta',
  command: 'meta',
  ctl: 'control',
  ctrl: 'control',
  del: 'delete',
  down: 'arrowdown',
  esc: 'escape',
  ins: 'insert',
  left: 'arrowleft',
  mod: IS_MAC ? 'meta' : 'control',
  opt: 'alt',
  option: 'alt',
  return: 'enter',
  right: 'arrowright',
  space: ' ',
  spacebar: ' ',
  up: 'arrowup',
  win: 'meta',
  windows: 'meta'
};

var CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  ' ': 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  '\'': 222
};

for (var f$1 = 1; f$1 < 20; f$1++) {
  CODES['f' + f$1] = 111 + f$1;
}

/**
 * Is hotkey?
 */

function isHotkey(hotkey, options, event) {
  if (options && !('byKey' in options)) {
    event = options;
    options = null;
  }

  if (!Array.isArray(hotkey)) {
    hotkey = [hotkey];
  }

  var array = hotkey.map(function (string) {
    return parseHotkey(string, options);
  });
  var check = function check(e) {
    return array.some(function (object) {
      return compareHotkey(object, e);
    });
  };
  var ret = event == null ? check : check(event);
  return ret;
}

function isKeyHotkey(hotkey, event) {
  return isHotkey(hotkey, { byKey: true }, event);
}

/**
 * Parse.
 */

function parseHotkey(hotkey, options) {
  var byKey = options && options.byKey;
  var ret = {};

  // Special case to handle the `+` key since we use it as a separator.
  hotkey = hotkey.replace('++', '+add');
  var values = hotkey.split('+');
  var length = values.length;

  // Ensure that all the modifiers are set to false unless the hotkey has them.

  for (var k in MODIFIERS) {
    ret[MODIFIERS[k]] = false;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;

      var optional = value.endsWith('?') && value.length > 1;

      if (optional) {
        value = value.slice(0, -1);
      }

      var name = toKeyName(value);
      var modifier = MODIFIERS[name];

      if (value.length > 1 && !modifier && !ALIASES[value] && !CODES[name]) {
        throw new TypeError('Unknown modifier: "' + value + '"');
      }

      if (length === 1 || !modifier) {
        if (byKey) {
          ret.key = name;
        } else {
          ret.which = toKeyCode(value);
        }
      }

      if (modifier) {
        ret[modifier] = optional ? null : true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
}

/**
 * Compare.
 */

function compareHotkey(object, event) {
  for (var key in object) {
    var expected = object[key];
    var actual = void 0;

    if (expected == null) {
      continue;
    }

    if (key === 'key' && event.key != null) {
      actual = event.key.toLowerCase();
    } else if (key === 'which') {
      actual = expected === 91 && event.which === 93 ? 91 : event.which;
    } else {
      actual = event[key];
    }

    if (actual == null && expected === false) {
      continue;
    }

    if (actual !== expected) {
      return false;
    }
  }

  return true;
}

/**
 * Utils.
 */

function toKeyCode(name) {
  name = toKeyName(name);
  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
  return code;
}

function toKeyName(name) {
  name = name.toLowerCase();
  name = ALIASES[name] || name;
  return name;
}
var isHotkey_1 = isHotkey;
var isKeyHotkey_1 = isKeyHotkey;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce$1;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

var lodash_clonedeep = createCommonjsModule(function (module, exports) {
/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;
});

var hasProperty = function has(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
};

var _apply;

function _classPrivateFieldLooseBase$8(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id$a = 0;

function _classPrivateFieldLooseKey$8(name) { return "__private_" + id$a++ + "_" + name; }



function insertReplacement(source, rx, replacement) {
  const newParts = [];
  source.forEach(chunk => {
    // When the source contains multiple placeholders for interpolation,
    // we should ignore chunks that are not strings, because those
    // can be JSX objects and will be otherwise incorrectly turned into strings.
    // Without this condition we’d get this: [object Object] hello [object Object] my <button>
    if (typeof chunk !== 'string') {
      return newParts.push(chunk);
    }

    return rx[Symbol.split](chunk).forEach((raw, i, list) => {
      if (raw !== '') {
        newParts.push(raw);
      } // Interlace with the `replacement` value


      if (i < list.length - 1) {
        newParts.push(replacement);
      }
    });
  });
  return newParts;
}
/**
 * Takes a string with placeholder variables like `%{smart_count} file selected`
 * and replaces it with values from options `{smart_count: 5}`
 *
 * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
 * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
 *
 * @param {string} phrase that needs interpolation, with placeholders
 * @param {object} options with values that will be used to replace placeholders
 * @returns {any[]} interpolated
 */


function interpolate(phrase, options) {
  const dollarRegex = /\$/g;
  const dollarBillsYall = '$$$$';
  let interpolated = [phrase];
  if (options == null) return interpolated;

  for (const arg of Object.keys(options)) {
    if (arg !== '_') {
      // Ensure replacement value is escaped to prevent special $-prefixed
      // regex replace tokens. the "$$$$" is needed because each "$" needs to
      // be escaped with "$" itself, and we need two in the resulting output.
      let replacement = options[arg];

      if (typeof replacement === 'string') {
        replacement = dollarRegex[Symbol.replace](replacement, dollarBillsYall);
      } // We create a new `RegExp` each time instead of using a more-efficient
      // string replace so that the same argument can be replaced multiple times
      // in the same phrase.


      interpolated = insertReplacement(interpolated, new RegExp(`%\\{${arg}\\}`, 'g'), replacement);
    }
  }

  return interpolated;
}
/**
 * Translates strings with interpolation & pluralization support.
 * Extensible with custom dictionaries and pluralization functions.
 *
 * Borrows heavily from and inspired by Polyglot https://github.com/airbnb/polyglot.js,
 * basically a stripped-down version of it. Differences: pluralization functions are not hardcoded
 * and can be easily added among with dictionaries, nested objects are used for pluralization
 * as opposed to `||||` delimeter
 *
 * Usage example: `translator.translate('files_chosen', {smart_count: 3})`
 */


var Translator_1 = (_apply = /*#__PURE__*/_classPrivateFieldLooseKey$8("apply"), class Translator {
  /**
   * @param {object|Array<object>} locales - locale or list of locales.
   */
  constructor(locales) {
    Object.defineProperty(this, _apply, {
      value: _apply2
    });
    this.locale = {
      strings: {},

      pluralize(n) {
        if (n === 1) {
          return 0;
        }

        return 1;
      }

    };

    if (Array.isArray(locales)) {
      locales.forEach(_classPrivateFieldLooseBase$8(this, _apply)[_apply], this);
    } else {
      _classPrivateFieldLooseBase$8(this, _apply)[_apply](locales);
    }
  }

  /**
   * Public translate method
   *
   * @param {string} key
   * @param {object} options with values that will be used later to replace placeholders in string
   * @returns {string} translated (and interpolated)
   */
  translate(key, options) {
    return this.translateArray(key, options).join('');
  }
  /**
   * Get a translation and return the translated and interpolated parts as an array.
   *
   * @param {string} key
   * @param {object} options with values that will be used to replace placeholders
   * @returns {Array} The translated and interpolated parts, in order.
   */


  translateArray(key, options) {
    if (!hasProperty(this.locale.strings, key)) {
      throw new Error(`missing string: ${key}`);
    }

    const string = this.locale.strings[key];
    const hasPluralForms = typeof string === 'object';

    if (hasPluralForms) {
      if (options && typeof options.smart_count !== 'undefined') {
        const plural = this.locale.pluralize(options.smart_count);
        return interpolate(string[plural], options);
      }

      throw new Error('Attempted to use a string with plural forms, but no value was given for %{smart_count}');
    }

    return interpolate(string, options);
  }

});

function _apply2(locale) {
  if (!(locale != null && locale.strings)) {
    return;
  }

  const prevLocale = this.locale;
  this.locale = { ...prevLocale,
    strings: { ...prevLocale.strings,
      ...locale.strings
    }
  };
  this.locale.pluralize = locale.pluralize || prevLocale.pluralize;
}

/**
* Create an event emitter with namespaces
* @name createNamespaceEmitter
* @example
* var emitter = require('./index')()
*
* emitter.on('*', function () {
*   console.log('all events emitted', this.event)
* })
*
* emitter.on('example', function () {
*   console.log('example event emitted')
* })
*/
var namespaceEmitter = function createNamespaceEmitter () {
  var emitter = {};
  var _fns = emitter._fns = {};

  /**
  * Emit an event. Optionally namespace the event. Handlers are fired in the order in which they were added with exact matches taking precedence. Separate the namespace and event with a `:`
  * @name emit
  * @param {String} event – the name of the event, with optional namespace
  * @param {...*} data – up to 6 arguments that are passed to the event listener
  * @example
  * emitter.emit('example')
  * emitter.emit('demo:test')
  * emitter.emit('data', { example: true}, 'a string', 1)
  */
  emitter.emit = function emit (event, arg1, arg2, arg3, arg4, arg5, arg6) {
    var toEmit = getListeners(event);

    if (toEmit.length) {
      emitAll(event, toEmit, [arg1, arg2, arg3, arg4, arg5, arg6]);
    }
  };

  /**
  * Create en event listener.
  * @name on
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.on('example', function () {})
  * emitter.on('demo', function () {})
  */
  emitter.on = function on (event, fn) {
    if (!_fns[event]) {
      _fns[event] = [];
    }

    _fns[event].push(fn);
  };

  /**
  * Create en event listener that fires once.
  * @name once
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.once('example', function () {})
  * emitter.once('demo', function () {})
  */
  emitter.once = function once (event, fn) {
    function one () {
      fn.apply(this, arguments);
      emitter.off(event, one);
    }
    this.on(event, one);
  };

  /**
  * Stop listening to an event. Stop all listeners on an event by only passing the event name. Stop a single listener by passing that event handler as a callback.
  * You must be explicit about what will be unsubscribed: `emitter.off('demo')` will unsubscribe an `emitter.on('demo')` listener,
  * `emitter.off('demo:example')` will unsubscribe an `emitter.on('demo:example')` listener
  * @name off
  * @param {String} event
  * @param {Function} [fn] – the specific handler
  * @example
  * emitter.off('example')
  * emitter.off('demo', function () {})
  */
  emitter.off = function off (event, fn) {
    var keep = [];

    if (event && fn) {
      var fns = this._fns[event];
      var i = 0;
      var l = fns ? fns.length : 0;

      for (i; i < l; i++) {
        if (fns[i] !== fn) {
          keep.push(fns[i]);
        }
      }
    }

    keep.length ? this._fns[event] = keep : delete this._fns[event];
  };

  function getListeners (e) {
    var out = _fns[e] ? _fns[e] : [];
    var idx = e.indexOf(':');
    var args = (idx === -1) ? [e] : [e.substring(0, idx), e.substring(idx + 1)];

    var keys = Object.keys(_fns);
    var i = 0;
    var l = keys.length;

    for (i; i < l; i++) {
      var key = keys[i];
      if (key === '*') {
        out = out.concat(_fns[key]);
      }

      if (args.length === 2 && args[0] === key) {
        out = out.concat(_fns[key]);
        break
      }
    }

    return out
  }

  function emitAll (e, fns, args) {
    var i = 0;
    var l = fns.length;

    for (i; i < l; i++) {
      if (!fns[i]) break
      fns[i].event = e;
      fns[i].apply(fns[i], args);
    }
  }

  return emitter
};

let urlAlphabet$1 =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
var urlAlphabet_1 = { urlAlphabet: urlAlphabet$1 };

let { urlAlphabet } = urlAlphabet_1;
{
  if (
    typeof navigator !== 'undefined' &&
    navigator.product === 'ReactNative' &&
    typeof crypto === 'undefined'
  ) {
    throw new Error(
      'React Native does not have a built-in secure random generator. ' +
        'If you don’t need unpredictable IDs use `nanoid/non-secure`. ' +
        'For secure IDs, import `react-native-get-random-values` ' +
        'before Nano ID.'
    )
  }
  if (typeof msCrypto !== 'undefined' && typeof crypto === 'undefined') {
    throw new Error(
      'Import file with `if (!window.crypto) window.crypto = window.msCrypto`' +
        ' before importing Nano ID to fix IE 11 support'
    )
  }
  if (typeof crypto === 'undefined') {
    throw new Error(
      'Your browser does not have secure random generator. ' +
        'If you don’t need unpredictable IDs, you can use nanoid/non-secure.'
    )
  }
}
let random = bytes => crypto.getRandomValues(new Uint8Array(bytes));
let customRandom = (alphabet, size, getRandom) => {
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1;
  let step = -~((1.6 * mask * size) / alphabet.length);
  return () => {
    let id = '';
    while (true) {
      let bytes = getRandom(step);
      let j = step;
      while (j--) {
        id += alphabet[bytes[j] & mask] || '';
        if (id.length === size) return id
      }
    }
  }
};
let customAlphabet = (alphabet, size) => customRandom(alphabet, size, random);
let nanoid$2 = (size = 21) => {
  let id = '';
  let bytes = crypto.getRandomValues(new Uint8Array(size));
  while (size--) {
    let byte = bytes[size] & 63;
    if (byte < 36) {
      id += byte.toString(36);
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase();
    } else if (byte < 63) {
      id += '_';
    } else {
      id += '-';
    }
  }
  return id
};
var index_browser = { nanoid: nanoid$2, customAlphabet, customRandom, urlAlphabet, random };

// Adapted from https://github.com/Flet/prettier-bytes/
// Changing 1000 bytes to 1024, so we can keep uppercase KB vs kB
// ISC License (c) Dan Flettre https://github.com/Flet/prettier-bytes/blob/master/LICENSE
var prettierBytes = function prettierBytes (num) {
  if (typeof num !== 'number' || isNaN(num)) {
    throw new TypeError('Expected a number, got ' + typeof num)
  }

  var neg = num < 0;
  var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B'
  }

  var exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
  num = Number(num / Math.pow(1024, exponent));
  var unit = units[exponent];

  if (num >= 10 || num % 1 === 0) {
    // Do not show decimals when the number is two-digit, or if the number has no
    // decimal component.
    return (neg ? '-' : '') + num.toFixed(0) + ' ' + unit
  } else {
    return (neg ? '-' : '') + num.toFixed(1) + ' ' + unit
  }
};

/* jshint node: true */

/**
  # wildcard

  Very simple wildcard matching, which is designed to provide the same
  functionality that is found in the
  [eve](https://github.com/adobe-webplatform/eve) eventing library.

  ## Usage

  It works with strings:

  <<< examples/strings.js

  Arrays:

  <<< examples/arrays.js

  Objects (matching against keys):

  <<< examples/objects.js

  While the library works in Node, if you are are looking for file-based
  wildcard matching then you should have a look at:

  <https://github.com/isaacs/node-glob>
**/

function WildcardMatcher(text, separator) {
  this.text = text = text || '';
  this.hasWild = ~text.indexOf('*');
  this.separator = separator;
  this.parts = text.split(separator);
}

WildcardMatcher.prototype.match = function(input) {
  var matches = true;
  var parts = this.parts;
  var ii;
  var partsCount = parts.length;
  var testParts;

  if (typeof input == 'string' || input instanceof String) {
    if (!this.hasWild && this.text != input) {
      matches = false;
    } else {
      testParts = (input || '').split(this.separator);
      for (ii = 0; matches && ii < partsCount; ii++) {
        if (parts[ii] === '*')  {
          continue;
        } else if (ii < testParts.length) {
          matches = parts[ii] === testParts[ii];
        } else {
          matches = false;
        }
      }

      // If matches, then return the component parts
      matches = matches && testParts;
    }
  }
  else if (typeof input.splice == 'function') {
    matches = [];

    for (ii = input.length; ii--; ) {
      if (this.match(input[ii])) {
        matches[matches.length] = input[ii];
      }
    }
  }
  else if (typeof input == 'object') {
    matches = {};

    for (var key in input) {
      if (this.match(key)) {
        matches[key] = input[key];
      }
    }
  }

  return matches;
};

var wildcard = function(text, test, separator) {
  var matcher = new WildcardMatcher(text, separator || /[\/\.]/);
  if (typeof test != 'undefined') {
    return matcher.match(test);
  }

  return matcher;
};

var reMimePartSplit = /[\/\+\.]/;

/**
  # mime-match

  A simple function to checker whether a target mime type matches a mime-type
  pattern (e.g. image/jpeg matches image/jpeg OR image/*).

  ## Example Usage

  <<< example.js

**/
var mimeMatch = function(target, pattern) {
  function test(pattern) {
    var result = wildcard(pattern, target, reMimePartSplit);

    // ensure that we have a valid mime type (should have two parts)
    return result && result.length >= 2;
  }

  return pattern ? test(pattern.split(';')[0]) : test;
};

function _classPrivateFieldLooseBase$7(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id$9 = 0;

function _classPrivateFieldLooseKey$7(name) { return "__private_" + id$9++ + "_" + name; }

var _publish = /*#__PURE__*/_classPrivateFieldLooseKey$7("publish");

/**
 * Default store that keeps state in a simple object.
 */
class DefaultStore {
  constructor() {
    Object.defineProperty(this, _publish, {
      value: _publish2
    });
    this.state = {};
    this.callbacks = [];
  }

  getState() {
    return this.state;
  }

  setState(patch) {
    const prevState = { ...this.state
    };
    const nextState = { ...this.state,
      ...patch
    };
    this.state = nextState;

    _classPrivateFieldLooseBase$7(this, _publish)[_publish](prevState, nextState, patch);
  }

  subscribe(listener) {
    this.callbacks.push(listener);
    return () => {
      // Remove the listener.
      this.callbacks.splice(this.callbacks.indexOf(listener), 1);
    };
  }

}

function _publish2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  this.callbacks.forEach(listener => {
    listener(...args);
  });
}

DefaultStore.VERSION = "2.0.3";

var lib$3 = function defaultStore() {
  return new DefaultStore();
};

/**
 * Takes a full filename string and returns an object {name, extension}
 *
 * @param {string} fullFileName
 * @returns {object} {name, extension}
 */
var getFileNameAndExtension = function getFileNameAndExtension(fullFileName) {
  const lastDot = fullFileName.lastIndexOf('.'); // these count as no extension: "no-dot", "trailing-dot."

  if (lastDot === -1 || lastDot === fullFileName.length - 1) {
    return {
      name: fullFileName,
      extension: undefined
    };
  }

  return {
    name: fullFileName.slice(0, lastDot),
    extension: fullFileName.slice(lastDot + 1)
  };
};

// ___Why not add the mime-types package?
//    It's 19.7kB gzipped, and we only need mime types for well-known extensions (for file previews).
// ___Where to take new extensions from?
//    https://github.com/jshttp/mime-db/blob/master/db.json
var mimeTypes = {
  md: 'text/markdown',
  markdown: 'text/markdown',
  mp4: 'video/mp4',
  mp3: 'audio/mp3',
  svg: 'image/svg+xml',
  jpg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  heic: 'image/heic',
  heif: 'image/heif',
  yaml: 'text/yaml',
  yml: 'text/yaml',
  csv: 'text/csv',
  tsv: 'text/tab-separated-values',
  tab: 'text/tab-separated-values',
  avi: 'video/x-msvideo',
  mks: 'video/x-matroska',
  mkv: 'video/x-matroska',
  mov: 'video/quicktime',
  doc: 'application/msword',
  docm: 'application/vnd.ms-word.document.macroenabled.12',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  dot: 'application/msword',
  dotm: 'application/vnd.ms-word.template.macroenabled.12',
  dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  xla: 'application/vnd.ms-excel',
  xlam: 'application/vnd.ms-excel.addin.macroenabled.12',
  xlc: 'application/vnd.ms-excel',
  xlf: 'application/x-xliff+xml',
  xlm: 'application/vnd.ms-excel',
  xls: 'application/vnd.ms-excel',
  xlsb: 'application/vnd.ms-excel.sheet.binary.macroenabled.12',
  xlsm: 'application/vnd.ms-excel.sheet.macroenabled.12',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xlt: 'application/vnd.ms-excel',
  xltm: 'application/vnd.ms-excel.template.macroenabled.12',
  xltx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  xlw: 'application/vnd.ms-excel',
  txt: 'text/plain',
  text: 'text/plain',
  conf: 'text/plain',
  log: 'text/plain',
  pdf: 'application/pdf',
  zip: 'application/zip',
  '7z': 'application/x-7z-compressed',
  rar: 'application/x-rar-compressed',
  tar: 'application/x-tar',
  gz: 'application/gzip',
  dmg: 'application/x-apple-diskimage'
};

var getFileType = function getFileType(file) {
  var _getFileNameAndExtens;

  if (file.type) return file.type;
  const fileExtension = file.name ? (_getFileNameAndExtens = getFileNameAndExtension(file.name).extension) == null ? void 0 : _getFileNameAndExtens.toLowerCase() : null;

  if (fileExtension && fileExtension in mimeTypes) {
    // else, see if we can map extension to a mime type
    return mimeTypes[fileExtension];
  } // if all fails, fall back to a generic byte stream type


  return 'application/octet-stream';
};

function encodeCharacter(character) {
  return character.charCodeAt(0).toString(32);
}

function encodeFilename(name) {
  let suffix = '';
  return name.replace(/[^A-Z0-9]/ig, character => {
    suffix += `-${encodeCharacter(character)}`;
    return '/';
  }) + suffix;
}
/**
 * Takes a file object and turns it into fileID, by converting file.name to lowercase,
 * removing extra characters and adding type, size and lastModified
 *
 * @param {object} file
 * @returns {string} the fileID
 */


var generateFileID = function generateFileID(file) {
  // It's tempting to do `[items].filter(Boolean).join('-')` here, but that
  // is slower! simple string concatenation is fast
  let id = 'uppy';

  if (typeof file.name === 'string') {
    id += `-${encodeFilename(file.name.toLowerCase())}`;
  }

  if (file.type !== undefined) {
    id += `-${file.type}`;
  }

  if (file.meta && typeof file.meta.relativePath === 'string') {
    id += `-${encodeFilename(file.meta.relativePath.toLowerCase())}`;
  }

  if (file.data.size !== undefined) {
    id += `-${file.data.size}`;
  }

  if (file.data.lastModified !== undefined) {
    id += `-${file.data.lastModified}`;
  }

  return id;
};

// Edge 15.x does not fire 'progress' events on uploads.
// See https://github.com/transloadit/uppy/issues/945
// And https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12224510/
var supportsUploadProgress = function supportsUploadProgress(userAgent) {
  // Allow passing in userAgent for tests
  if (userAgent == null) {
    userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : null;
  } // Assume it works because basically everything supports progress events.


  if (!userAgent) return true;
  const m = /Edge\/(\d+\.\d+)/.exec(userAgent);
  if (!m) return true;
  const edgeVersion = m[1];
  let [major, minor] = edgeVersion.split('.');
  major = parseInt(major, 10);
  minor = parseInt(minor, 10); // Worked before:
  // Edge 40.15063.0.0
  // Microsoft EdgeHTML 15.15063

  if (major < 15 || major === 15 && minor < 15063) {
    return true;
  } // Fixed in:
  // Microsoft EdgeHTML 18.18218


  if (major > 18 || major === 18 && minor >= 18218) {
    return true;
  } // other versions don't work.


  return false;
};

var getFileName = function getFileName(fileType, fileDescriptor) {
  if (fileDescriptor.name) {
    return fileDescriptor.name;
  }

  if (fileType.split('/')[0] === 'image') {
    return `${fileType.split('/')[0]}.${fileType.split('/')[1]}`;
  }

  return 'noname';
};

/**
 * Adds zero to strings shorter than two characters.
 *
 * @param {number} number
 * @returns {string}
 */
function pad(number) {
  return number < 10 ? `0${number}` : number.toString();
}
/**
 * Returns a timestamp in the format of `hours:minutes:seconds`
 */


var getTimeStamp = function getTimeStamp() {
  const date = new Date();
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  return `${hours}:${minutes}:${seconds}`;
};

/* eslint-disable no-console */
 // Swallow all logs, except errors.
// default if logger is not set or debug: false


const justErrorsLogger$1 = {
  debug: () => {},
  warn: () => {},
  error: function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return console.error(`[Uppy] [${getTimeStamp()}]`, ...args);
  }
}; // Print logs to console with namespace + timestamp,
// set by logger: Uppy.debugLogger or debug: true

const debugLogger$2 = {
  debug: function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return console.debug(`[Uppy] [${getTimeStamp()}]`, ...args);
  },
  warn: function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return console.warn(`[Uppy] [${getTimeStamp()}]`, ...args);
  },
  error: function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return console.error(`[Uppy] [${getTimeStamp()}]`, ...args);
  }
};
var loggers = {
  justErrorsLogger: justErrorsLogger$1,
  debugLogger: debugLogger$2
};

var locale$1 = {
  strings: {
    addBulkFilesFailed: {
      0: 'Failed to add %{smart_count} file due to an internal error',
      1: 'Failed to add %{smart_count} files due to internal errors'
    },
    youCanOnlyUploadX: {
      0: 'You can only upload %{smart_count} file',
      1: 'You can only upload %{smart_count} files'
    },
    youHaveToAtLeastSelectX: {
      0: 'You have to select at least %{smart_count} file',
      1: 'You have to select at least %{smart_count} files'
    },
    exceedsSize: '%{file} exceeds maximum allowed size of %{size}',
    missingRequiredMetaField: 'Missing required meta fields',
    missingRequiredMetaFieldOnFile: 'Missing required meta fields in %{fileName}',
    inferiorSize: 'This file is smaller than the allowed size of %{size}',
    youCanOnlyUploadFileTypes: 'You can only upload: %{types}',
    noMoreFilesAllowed: 'Cannot add more files',
    noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
    companionError: 'Connection with Companion failed',
    authAborted: 'Authentication aborted',
    companionUnauthorizeHint: 'To unauthorize to your %{provider} account, please go to %{url}',
    failedToUpload: 'Failed to upload %{file}',
    noInternetConnection: 'No Internet connection',
    connectedToInternet: 'Connected to the Internet',
    // Strings for remote providers
    noFilesFound: 'You have no files or folders here',
    selectX: {
      0: 'Select %{smart_count}',
      1: 'Select %{smart_count}'
    },
    allFilesFromFolderNamed: 'All files from folder %{name}',
    openFolderNamed: 'Open folder %{name}',
    cancel: 'Cancel',
    logOut: 'Log out',
    filter: 'Filter',
    resetFilter: 'Reset filter',
    loading: 'Loading...',
    authenticateWithTitle: 'Please authenticate with %{pluginName} to select files',
    authenticateWith: 'Connect to %{pluginName}',
    signInWithGoogle: 'Sign in with Google',
    searchImages: 'Search for images',
    enterTextToSearch: 'Enter text to search for images',
    backToSearch: 'Back to Search',
    emptyFolderAdded: 'No files were added from empty folder',
    folderAlreadyAdded: 'The folder "%{folder}" was already added',
    folderAdded: {
      0: 'Added %{smart_count} file from %{folder}',
      1: 'Added %{smart_count} files from %{folder}'
    }
  }
};

var require$$0 = index_browser;

/* global AggregateError */

let _Symbol$for$1, _Symbol$for2$1;

function _classPrivateFieldLooseBase$6(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id$8 = 0;

function _classPrivateFieldLooseKey$6(name) { return "__private_" + id$8++ + "_" + name; }





const {
  nanoid: nanoid$1
} = require$$0;



















const {
  justErrorsLogger,
  debugLogger: debugLogger$1
} = loggers;

 // Exported from here.


class RestrictionError extends Error {
  constructor() {
    super(...arguments);
    this.isRestriction = true;
  }

}

if (typeof AggregateError === 'undefined') {
  // eslint-disable-next-line no-global-assign
  globalThis.AggregateError = class AggregateError extends Error {
    constructor(errors, message) {
      super(message);
      this.errors = errors;
    }

  };
}

class AggregateRestrictionError extends AggregateError {
  constructor() {
    super(...arguments);
    this.isRestriction = true;
  }

}
/**
 * Uppy Core module.
 * Manages plugins, state updates, acts as an event bus,
 * adds/removes files and metadata.
 */


var _plugins = /*#__PURE__*/_classPrivateFieldLooseKey$6("plugins");

var _storeUnsubscribe = /*#__PURE__*/_classPrivateFieldLooseKey$6("storeUnsubscribe");

var _emitter$2 = /*#__PURE__*/_classPrivateFieldLooseKey$6("emitter");

var _preProcessors = /*#__PURE__*/_classPrivateFieldLooseKey$6("preProcessors");

var _uploaders = /*#__PURE__*/_classPrivateFieldLooseKey$6("uploaders");

var _postProcessors = /*#__PURE__*/_classPrivateFieldLooseKey$6("postProcessors");

var _checkRestrictions = /*#__PURE__*/_classPrivateFieldLooseKey$6("checkRestrictions");

var _checkMinNumberOfFiles = /*#__PURE__*/_classPrivateFieldLooseKey$6("checkMinNumberOfFiles");

var _checkRequiredMetaFieldsOnFile = /*#__PURE__*/_classPrivateFieldLooseKey$6("checkRequiredMetaFieldsOnFile");

var _checkRequiredMetaFields = /*#__PURE__*/_classPrivateFieldLooseKey$6("checkRequiredMetaFields");

var _showOrLogErrorAndThrow = /*#__PURE__*/_classPrivateFieldLooseKey$6("showOrLogErrorAndThrow");

var _assertNewUploadAllowed = /*#__PURE__*/_classPrivateFieldLooseKey$6("assertNewUploadAllowed");

var _checkAndCreateFileStateObject = /*#__PURE__*/_classPrivateFieldLooseKey$6("checkAndCreateFileStateObject");

var _startIfAutoProceed = /*#__PURE__*/_classPrivateFieldLooseKey$6("startIfAutoProceed");

var _addListeners = /*#__PURE__*/_classPrivateFieldLooseKey$6("addListeners");

var _updateOnlineStatus = /*#__PURE__*/_classPrivateFieldLooseKey$6("updateOnlineStatus");

var _createUpload = /*#__PURE__*/_classPrivateFieldLooseKey$6("createUpload");

var _getUpload = /*#__PURE__*/_classPrivateFieldLooseKey$6("getUpload");

var _removeUpload = /*#__PURE__*/_classPrivateFieldLooseKey$6("removeUpload");

var _runUpload = /*#__PURE__*/_classPrivateFieldLooseKey$6("runUpload");

_Symbol$for$1 = Symbol.for('uppy test: getPlugins');
_Symbol$for2$1 = Symbol.for('uppy test: createUpload');

class Uppy {
  // eslint-disable-next-line global-require

  /** @type {Record<string, BasePlugin[]>} */

  /**
   * Instantiate Uppy
   *
   * @param {object} opts — Uppy options
   */
  constructor(_opts) {
    Object.defineProperty(this, _runUpload, {
      value: _runUpload2
    });
    Object.defineProperty(this, _removeUpload, {
      value: _removeUpload2
    });
    Object.defineProperty(this, _getUpload, {
      value: _getUpload2
    });
    Object.defineProperty(this, _createUpload, {
      value: _createUpload2
    });
    Object.defineProperty(this, _addListeners, {
      value: _addListeners2
    });
    Object.defineProperty(this, _startIfAutoProceed, {
      value: _startIfAutoProceed2
    });
    Object.defineProperty(this, _checkAndCreateFileStateObject, {
      value: _checkAndCreateFileStateObject2
    });
    Object.defineProperty(this, _assertNewUploadAllowed, {
      value: _assertNewUploadAllowed2
    });
    Object.defineProperty(this, _showOrLogErrorAndThrow, {
      value: _showOrLogErrorAndThrow2
    });
    Object.defineProperty(this, _checkRequiredMetaFields, {
      value: _checkRequiredMetaFields2
    });
    Object.defineProperty(this, _checkRequiredMetaFieldsOnFile, {
      value: _checkRequiredMetaFieldsOnFile2
    });
    Object.defineProperty(this, _checkMinNumberOfFiles, {
      value: _checkMinNumberOfFiles2
    });
    Object.defineProperty(this, _checkRestrictions, {
      value: _checkRestrictions2
    });
    Object.defineProperty(this, _plugins, {
      writable: true,
      value: Object.create(null)
    });
    Object.defineProperty(this, _storeUnsubscribe, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _emitter$2, {
      writable: true,
      value: namespaceEmitter()
    });
    Object.defineProperty(this, _preProcessors, {
      writable: true,
      value: new Set()
    });
    Object.defineProperty(this, _uploaders, {
      writable: true,
      value: new Set()
    });
    Object.defineProperty(this, _postProcessors, {
      writable: true,
      value: new Set()
    });
    Object.defineProperty(this, _updateOnlineStatus, {
      writable: true,
      value: this.updateOnlineStatus.bind(this)
    });
    this.defaultLocale = locale$1;
    const defaultOptions = {
      id: 'uppy',
      autoProceed: false,

      /**
       * @deprecated The method should not be used
       */
      allowMultipleUploads: true,
      allowMultipleUploadBatches: true,
      debug: false,
      restrictions: {
        maxFileSize: null,
        minFileSize: null,
        maxTotalFileSize: null,
        maxNumberOfFiles: null,
        minNumberOfFiles: null,
        allowedFileTypes: null,
        requiredMetaFields: []
      },
      meta: {},
      onBeforeFileAdded: currentFile => currentFile,
      onBeforeUpload: files => files,
      store: lib$3(),
      logger: justErrorsLogger,
      infoTimeout: 5000
    }; // Merge default options with the ones set by user,
    // making sure to merge restrictions too

    this.opts = { ...defaultOptions,
      ..._opts,
      restrictions: { ...defaultOptions.restrictions,
        ...(_opts && _opts.restrictions)
      }
    }; // Support debug: true for backwards-compatability, unless logger is set in opts
    // opts instead of this.opts to avoid comparing objects — we set logger: justErrorsLogger in defaultOptions

    if (_opts && _opts.logger && _opts.debug) {
      this.log('You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.', 'warning');
    } else if (_opts && _opts.debug) {
      this.opts.logger = debugLogger$1;
    }

    this.log(`Using Core v${this.constructor.VERSION}`);

    if (this.opts.restrictions.allowedFileTypes && this.opts.restrictions.allowedFileTypes !== null && !Array.isArray(this.opts.restrictions.allowedFileTypes)) {
      throw new TypeError('`restrictions.allowedFileTypes` must be an array');
    }

    this.i18nInit(); // ___Why throttle at 500ms?
    //    - We must throttle at >250ms for superfocus in Dashboard to work well
    //    (because animation takes 0.25s, and we want to wait for all animations to be over before refocusing).
    //    [Practical Check]: if thottle is at 100ms, then if you are uploading a file,
    //    and click 'ADD MORE FILES', - focus won't activate in Firefox.
    //    - We must throttle at around >500ms to avoid performance lags.
    //    [Practical Check] Firefox, try to upload a big file for a prolonged period of time. Laptop will start to heat up.

    this.calculateProgress = lodash_throttle(this.calculateProgress.bind(this), 500, {
      leading: true,
      trailing: true
    });
    this.store = this.opts.store;
    this.setState({
      plugins: {},
      files: {},
      currentUploads: {},
      allowNewUpload: true,
      capabilities: {
        uploadProgress: supportsUploadProgress(),
        individualCancellation: true,
        resumableUploads: false
      },
      totalProgress: 0,
      meta: { ...this.opts.meta
      },
      info: [],
      recoveredState: null
    });
    _classPrivateFieldLooseBase$6(this, _storeUnsubscribe)[_storeUnsubscribe] = this.store.subscribe((prevState, nextState, patch) => {
      this.emit('state-update', prevState, nextState, patch);
      this.updateAll(nextState);
    }); // Exposing uppy object on window for debugging and testing

    if (this.opts.debug && typeof window !== 'undefined') {
      window[this.opts.id] = this;
    }

    _classPrivateFieldLooseBase$6(this, _addListeners)[_addListeners]();
  }

  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _classPrivateFieldLooseBase$6(this, _emitter$2)[_emitter$2].emit(event, ...args);
  }

  on(event, callback) {
    _classPrivateFieldLooseBase$6(this, _emitter$2)[_emitter$2].on(event, callback);

    return this;
  }

  once(event, callback) {
    _classPrivateFieldLooseBase$6(this, _emitter$2)[_emitter$2].once(event, callback);

    return this;
  }

  off(event, callback) {
    _classPrivateFieldLooseBase$6(this, _emitter$2)[_emitter$2].off(event, callback);

    return this;
  }
  /**
   * Iterate on all plugins and run `update` on them.
   * Called each time state changes.
   *
   */


  updateAll(state) {
    this.iteratePlugins(plugin => {
      plugin.update(state);
    });
  }
  /**
   * Updates state with a patch
   *
   * @param {object} patch {foo: 'bar'}
   */


  setState(patch) {
    this.store.setState(patch);
  }
  /**
   * Returns current state.
   *
   * @returns {object}
   */


  getState() {
    return this.store.getState();
  }
  /**
   * Back compat for when uppy.state is used instead of uppy.getState().
   *
   * @deprecated
   */


  get state() {
    // Here, state is a non-enumerable property.
    return this.getState();
  }
  /**
   * Shorthand to set state for a specific file.
   */


  setFileState(fileID, state) {
    if (!this.getState().files[fileID]) {
      throw new Error(`Can’t set state for ${fileID} (the file could have been removed)`);
    }

    this.setState({
      files: { ...this.getState().files,
        [fileID]: { ...this.getState().files[fileID],
          ...state
        }
      }
    });
  }

  i18nInit() {
    const translator = new Translator_1([this.defaultLocale, this.opts.locale]);
    this.i18n = translator.translate.bind(translator);
    this.i18nArray = translator.translateArray.bind(translator);
    this.locale = translator.locale;
  }

  setOptions(newOpts) {
    this.opts = { ...this.opts,
      ...newOpts,
      restrictions: { ...this.opts.restrictions,
        ...(newOpts && newOpts.restrictions)
      }
    };

    if (newOpts.meta) {
      this.setMeta(newOpts.meta);
    }

    this.i18nInit();

    if (newOpts.locale) {
      this.iteratePlugins(plugin => {
        plugin.setOptions();
      });
    } // Note: this is not the preact `setState`, it's an internal function that has the same name.


    this.setState(); // so that UI re-renders with new options
  }

  resetProgress() {
    const defaultProgress = {
      percentage: 0,
      bytesUploaded: 0,
      uploadComplete: false,
      uploadStarted: null
    };
    const files = { ...this.getState().files
    };
    const updatedFiles = {};
    Object.keys(files).forEach(fileID => {
      const updatedFile = { ...files[fileID]
      };
      updatedFile.progress = { ...updatedFile.progress,
        ...defaultProgress
      };
      updatedFiles[fileID] = updatedFile;
    });
    this.setState({
      files: updatedFiles,
      totalProgress: 0
    });
    this.emit('reset-progress');
  }

  addPreProcessor(fn) {
    _classPrivateFieldLooseBase$6(this, _preProcessors)[_preProcessors].add(fn);
  }

  removePreProcessor(fn) {
    return _classPrivateFieldLooseBase$6(this, _preProcessors)[_preProcessors].delete(fn);
  }

  addPostProcessor(fn) {
    _classPrivateFieldLooseBase$6(this, _postProcessors)[_postProcessors].add(fn);
  }

  removePostProcessor(fn) {
    return _classPrivateFieldLooseBase$6(this, _postProcessors)[_postProcessors].delete(fn);
  }

  addUploader(fn) {
    _classPrivateFieldLooseBase$6(this, _uploaders)[_uploaders].add(fn);
  }

  removeUploader(fn) {
    return _classPrivateFieldLooseBase$6(this, _uploaders)[_uploaders].delete(fn);
  }

  setMeta(data) {
    const updatedMeta = { ...this.getState().meta,
      ...data
    };
    const updatedFiles = { ...this.getState().files
    };
    Object.keys(updatedFiles).forEach(fileID => {
      updatedFiles[fileID] = { ...updatedFiles[fileID],
        meta: { ...updatedFiles[fileID].meta,
          ...data
        }
      };
    });
    this.log('Adding metadata:');
    this.log(data);
    this.setState({
      meta: updatedMeta,
      files: updatedFiles
    });
  }

  setFileMeta(fileID, data) {
    const updatedFiles = { ...this.getState().files
    };

    if (!updatedFiles[fileID]) {
      this.log('Was trying to set metadata for a file that has been removed: ', fileID);
      return;
    }

    const newMeta = { ...updatedFiles[fileID].meta,
      ...data
    };
    updatedFiles[fileID] = { ...updatedFiles[fileID],
      meta: newMeta
    };
    this.setState({
      files: updatedFiles
    });
  }
  /**
   * Get a file object.
   *
   * @param {string} fileID The ID of the file object to return.
   */


  getFile(fileID) {
    return this.getState().files[fileID];
  }
  /**
   * Get all files in an array.
   */


  getFiles() {
    const {
      files
    } = this.getState();
    return Object.values(files);
  }

  getObjectOfFilesPerState() {
    const {
      files: filesObject,
      totalProgress,
      error
    } = this.getState();
    const files = Object.values(filesObject);
    const inProgressFiles = files.filter(_ref => {
      let {
        progress
      } = _ref;
      return !progress.uploadComplete && progress.uploadStarted;
    });
    const newFiles = files.filter(file => !file.progress.uploadStarted);
    const startedFiles = files.filter(file => file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess);
    const uploadStartedFiles = files.filter(file => file.progress.uploadStarted);
    const pausedFiles = files.filter(file => file.isPaused);
    const completeFiles = files.filter(file => file.progress.uploadComplete);
    const erroredFiles = files.filter(file => file.error);
    const inProgressNotPausedFiles = inProgressFiles.filter(file => !file.isPaused);
    const processingFiles = files.filter(file => file.progress.preprocess || file.progress.postprocess);
    return {
      newFiles,
      startedFiles,
      uploadStartedFiles,
      pausedFiles,
      completeFiles,
      erroredFiles,
      inProgressFiles,
      inProgressNotPausedFiles,
      processingFiles,
      isUploadStarted: uploadStartedFiles.length > 0,
      isAllComplete: totalProgress === 100 && completeFiles.length === files.length && processingFiles.length === 0,
      isAllErrored: !!error && erroredFiles.length === files.length,
      isAllPaused: inProgressFiles.length !== 0 && pausedFiles.length === inProgressFiles.length,
      isUploadInProgress: inProgressFiles.length > 0,
      isSomeGhost: files.some(file => file.isGhost)
    };
  }
  /**
   * A public wrapper for _checkRestrictions — checks if a file passes a set of restrictions.
   * For use in UI pluigins (like Providers), to disallow selecting files that won’t pass restrictions.
   *
   * @param {object} file object to check
   * @param {Array} [files] array to check maxNumberOfFiles and maxTotalFileSize
   * @returns {object} { result: true/false, reason: why file didn’t pass restrictions }
   */


  validateRestrictions(file, files) {
    try {
      _classPrivateFieldLooseBase$6(this, _checkRestrictions)[_checkRestrictions](file, files);

      return {
        result: true
      };
    } catch (err) {
      return {
        result: false,
        reason: err.message
      };
    }
  }
  /**
   * Check if file passes a set of restrictions set in options: maxFileSize, minFileSize,
   * maxNumberOfFiles and allowedFileTypes.
   *
   * @param {object} file object to check
   * @param {Array} [files] array to check maxNumberOfFiles and maxTotalFileSize
   * @private
   */


  checkIfFileAlreadyExists(fileID) {
    const {
      files
    } = this.getState();

    if (files[fileID] && !files[fileID].isGhost) {
      return true;
    }

    return false;
  }
  /**
   * Create a file state object based on user-provided `addFile()` options.
   *
   * Note this is extremely side-effectful and should only be done when a file state object
   * will be added to state immediately afterward!
   *
   * The `files` value is passed in because it may be updated by the caller without updating the store.
   */


  /**
   * Add a new file to `state.files`. This will run `onBeforeFileAdded`,
   * try to guess file type in a clever way, check file against restrictions,
   * and start an upload if `autoProceed === true`.
   *
   * @param {object} file object to add
   * @returns {string} id for the added file
   */
  addFile(file) {
    _classPrivateFieldLooseBase$6(this, _assertNewUploadAllowed)[_assertNewUploadAllowed](file);

    const {
      files
    } = this.getState();

    let newFile = _classPrivateFieldLooseBase$6(this, _checkAndCreateFileStateObject)[_checkAndCreateFileStateObject](files, file); // Users are asked to re-select recovered files without data,
    // and to keep the progress, meta and everthing else, we only replace said data


    if (files[newFile.id] && files[newFile.id].isGhost) {
      newFile = { ...files[newFile.id],
        data: file.data,
        isGhost: false
      };
      this.log(`Replaced the blob in the restored ghost file: ${newFile.name}, ${newFile.id}`);
    }

    this.setState({
      files: { ...files,
        [newFile.id]: newFile
      }
    });
    this.emit('file-added', newFile);
    this.emit('files-added', [newFile]);
    this.log(`Added file: ${newFile.name}, ${newFile.id}, mime type: ${newFile.type}`);

    _classPrivateFieldLooseBase$6(this, _startIfAutoProceed)[_startIfAutoProceed]();

    return newFile.id;
  }
  /**
   * Add multiple files to `state.files`. See the `addFile()` documentation.
   *
   * If an error occurs while adding a file, it is logged and the user is notified.
   * This is good for UI plugins, but not for programmatic use.
   * Programmatic users should usually still use `addFile()` on individual files.
   */


  addFiles(fileDescriptors) {
    _classPrivateFieldLooseBase$6(this, _assertNewUploadAllowed)[_assertNewUploadAllowed](); // create a copy of the files object only once


    const files = { ...this.getState().files
    };
    const newFiles = [];
    const errors = [];

    for (let i = 0; i < fileDescriptors.length; i++) {
      try {
        let newFile = _classPrivateFieldLooseBase$6(this, _checkAndCreateFileStateObject)[_checkAndCreateFileStateObject](files, fileDescriptors[i]); // Users are asked to re-select recovered files without data,
        // and to keep the progress, meta and everthing else, we only replace said data


        if (files[newFile.id] && files[newFile.id].isGhost) {
          newFile = { ...files[newFile.id],
            data: fileDescriptors[i].data,
            isGhost: false
          };
          this.log(`Replaced blob in a ghost file: ${newFile.name}, ${newFile.id}`);
        }

        files[newFile.id] = newFile;
        newFiles.push(newFile);
      } catch (err) {
        if (!err.isRestriction) {
          errors.push(err);
        }
      }
    }

    this.setState({
      files
    });
    newFiles.forEach(newFile => {
      this.emit('file-added', newFile);
    });
    this.emit('files-added', newFiles);

    if (newFiles.length > 5) {
      this.log(`Added batch of ${newFiles.length} files`);
    } else {
      Object.keys(newFiles).forEach(fileID => {
        this.log(`Added file: ${newFiles[fileID].name}\n id: ${newFiles[fileID].id}\n type: ${newFiles[fileID].type}`);
      });
    }

    if (newFiles.length > 0) {
      _classPrivateFieldLooseBase$6(this, _startIfAutoProceed)[_startIfAutoProceed]();
    }

    if (errors.length > 0) {
      let message = 'Multiple errors occurred while adding files:\n';
      errors.forEach(subError => {
        message += `\n * ${subError.message}`;
      });
      this.info({
        message: this.i18n('addBulkFilesFailed', {
          smart_count: errors.length
        }),
        details: message
      }, 'error', this.opts.infoTimeout);

      if (typeof AggregateError === 'function') {
        throw new AggregateError(errors, message);
      } else {
        const err = new Error(message);
        err.errors = errors;
        throw err;
      }
    }
  }

  removeFiles(fileIDs, reason) {
    const {
      files,
      currentUploads
    } = this.getState();
    const updatedFiles = { ...files
    };
    const updatedUploads = { ...currentUploads
    };
    const removedFiles = Object.create(null);
    fileIDs.forEach(fileID => {
      if (files[fileID]) {
        removedFiles[fileID] = files[fileID];
        delete updatedFiles[fileID];
      }
    }); // Remove files from the `fileIDs` list in each upload.

    function fileIsNotRemoved(uploadFileID) {
      return removedFiles[uploadFileID] === undefined;
    }

    Object.keys(updatedUploads).forEach(uploadID => {
      const newFileIDs = currentUploads[uploadID].fileIDs.filter(fileIsNotRemoved); // Remove the upload if no files are associated with it anymore.

      if (newFileIDs.length === 0) {
        delete updatedUploads[uploadID];
        return;
      }

      updatedUploads[uploadID] = { ...currentUploads[uploadID],
        fileIDs: newFileIDs
      };
    });
    const stateUpdate = {
      currentUploads: updatedUploads,
      files: updatedFiles
    }; // If all files were removed - allow new uploads,
    // and clear recoveredState

    if (Object.keys(updatedFiles).length === 0) {
      stateUpdate.allowNewUpload = true;
      stateUpdate.error = null;
      stateUpdate.recoveredState = null;
    }

    this.setState(stateUpdate);
    this.calculateTotalProgress();
    const removedFileIDs = Object.keys(removedFiles);
    removedFileIDs.forEach(fileID => {
      this.emit('file-removed', removedFiles[fileID], reason);
    });

    if (removedFileIDs.length > 5) {
      this.log(`Removed ${removedFileIDs.length} files`);
    } else {
      this.log(`Removed files: ${removedFileIDs.join(', ')}`);
    }
  }

  removeFile(fileID, reason) {
    if (reason === void 0) {
      reason = null;
    }

    this.removeFiles([fileID], reason);
  }

  pauseResume(fileID) {
    if (!this.getState().capabilities.resumableUploads || this.getFile(fileID).uploadComplete) {
      return undefined;
    }

    const wasPaused = this.getFile(fileID).isPaused || false;
    const isPaused = !wasPaused;
    this.setFileState(fileID, {
      isPaused
    });
    this.emit('upload-pause', fileID, isPaused);
    return isPaused;
  }

  pauseAll() {
    const updatedFiles = { ...this.getState().files
    };
    const inProgressUpdatedFiles = Object.keys(updatedFiles).filter(file => {
      return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
    });
    inProgressUpdatedFiles.forEach(file => {
      const updatedFile = { ...updatedFiles[file],
        isPaused: true
      };
      updatedFiles[file] = updatedFile;
    });
    this.setState({
      files: updatedFiles
    });
    this.emit('pause-all');
  }

  resumeAll() {
    const updatedFiles = { ...this.getState().files
    };
    const inProgressUpdatedFiles = Object.keys(updatedFiles).filter(file => {
      return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
    });
    inProgressUpdatedFiles.forEach(file => {
      const updatedFile = { ...updatedFiles[file],
        isPaused: false,
        error: null
      };
      updatedFiles[file] = updatedFile;
    });
    this.setState({
      files: updatedFiles
    });
    this.emit('resume-all');
  }

  retryAll() {
    const updatedFiles = { ...this.getState().files
    };
    const filesToRetry = Object.keys(updatedFiles).filter(file => {
      return updatedFiles[file].error;
    });
    filesToRetry.forEach(file => {
      const updatedFile = { ...updatedFiles[file],
        isPaused: false,
        error: null
      };
      updatedFiles[file] = updatedFile;
    });
    this.setState({
      files: updatedFiles,
      error: null
    });
    this.emit('retry-all', filesToRetry);

    if (filesToRetry.length === 0) {
      return Promise.resolve({
        successful: [],
        failed: []
      });
    }

    const uploadID = _classPrivateFieldLooseBase$6(this, _createUpload)[_createUpload](filesToRetry, {
      forceAllowNewUpload: true // create new upload even if allowNewUpload: false

    });

    return _classPrivateFieldLooseBase$6(this, _runUpload)[_runUpload](uploadID);
  }

  cancelAll() {
    this.emit('cancel-all');
    const {
      files
    } = this.getState();
    const fileIDs = Object.keys(files);

    if (fileIDs.length) {
      this.removeFiles(fileIDs, 'cancel-all');
    }

    this.setState({
      totalProgress: 0,
      error: null,
      recoveredState: null
    });
  }

  retryUpload(fileID) {
    this.setFileState(fileID, {
      error: null,
      isPaused: false
    });
    this.emit('upload-retry', fileID);

    const uploadID = _classPrivateFieldLooseBase$6(this, _createUpload)[_createUpload]([fileID], {
      forceAllowNewUpload: true // create new upload even if allowNewUpload: false

    });

    return _classPrivateFieldLooseBase$6(this, _runUpload)[_runUpload](uploadID);
  }

  reset() {
    this.cancelAll();
  }

  logout() {
    this.iteratePlugins(plugin => {
      if (plugin.provider && plugin.provider.logout) {
        plugin.provider.logout();
      }
    });
  }

  calculateProgress(file, data) {
    if (!this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file.id}`);
      return;
    } // bytesTotal may be null or zero; in that case we can't divide by it


    const canHavePercentage = Number.isFinite(data.bytesTotal) && data.bytesTotal > 0;
    this.setFileState(file.id, {
      progress: { ...this.getFile(file.id).progress,
        bytesUploaded: data.bytesUploaded,
        bytesTotal: data.bytesTotal,
        percentage: canHavePercentage ? Math.round(data.bytesUploaded / data.bytesTotal * 100) : 0
      }
    });
    this.calculateTotalProgress();
  }

  calculateTotalProgress() {
    // calculate total progress, using the number of files currently uploading,
    // multiplied by 100 and the summ of individual progress of each file
    const files = this.getFiles();
    const inProgress = files.filter(file => {
      return file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess;
    });

    if (inProgress.length === 0) {
      this.emit('progress', 0);
      this.setState({
        totalProgress: 0
      });
      return;
    }

    const sizedFiles = inProgress.filter(file => file.progress.bytesTotal != null);
    const unsizedFiles = inProgress.filter(file => file.progress.bytesTotal == null);

    if (sizedFiles.length === 0) {
      const progressMax = inProgress.length * 100;
      const currentProgress = unsizedFiles.reduce((acc, file) => {
        return acc + file.progress.percentage;
      }, 0);
      const totalProgress = Math.round(currentProgress / progressMax * 100);
      this.setState({
        totalProgress
      });
      return;
    }

    let totalSize = sizedFiles.reduce((acc, file) => {
      return acc + file.progress.bytesTotal;
    }, 0);
    const averageSize = totalSize / sizedFiles.length;
    totalSize += averageSize * unsizedFiles.length;
    let uploadedSize = 0;
    sizedFiles.forEach(file => {
      uploadedSize += file.progress.bytesUploaded;
    });
    unsizedFiles.forEach(file => {
      uploadedSize += averageSize * (file.progress.percentage || 0) / 100;
    });
    let totalProgress = totalSize === 0 ? 0 : Math.round(uploadedSize / totalSize * 100); // hot fix, because:
    // uploadedSize ended up larger than totalSize, resulting in 1325% total

    if (totalProgress > 100) {
      totalProgress = 100;
    }

    this.setState({
      totalProgress
    });
    this.emit('progress', totalProgress);
  }
  /**
   * Registers listeners for all global actions, like:
   * `error`, `file-removed`, `upload-progress`
   */


  updateOnlineStatus() {
    const online = typeof window.navigator.onLine !== 'undefined' ? window.navigator.onLine : true;

    if (!online) {
      this.emit('is-offline');
      this.info(this.i18n('noInternetConnection'), 'error', 0);
      this.wasOffline = true;
    } else {
      this.emit('is-online');

      if (this.wasOffline) {
        this.emit('back-online');
        this.info(this.i18n('connectedToInternet'), 'success', 3000);
        this.wasOffline = false;
      }
    }
  }

  getID() {
    return this.opts.id;
  }
  /**
   * Registers a plugin with Core.
   *
   * @param {object} Plugin object
   * @param {object} [opts] object with options to be passed to Plugin
   * @returns {object} self for chaining
   */
  // eslint-disable-next-line no-shadow


  use(Plugin, opts) {
    if (typeof Plugin !== 'function') {
      const msg = `Expected a plugin class, but got ${Plugin === null ? 'null' : typeof Plugin}.` + ' Please verify that the plugin was imported and spelled correctly.';
      throw new TypeError(msg);
    } // Instantiate


    const plugin = new Plugin(this, opts);
    const pluginId = plugin.id;

    if (!pluginId) {
      throw new Error('Your plugin must have an id');
    }

    if (!plugin.type) {
      throw new Error('Your plugin must have a type');
    }

    const existsPluginAlready = this.getPlugin(pluginId);

    if (existsPluginAlready) {
      const msg = `Already found a plugin named '${existsPluginAlready.id}'. ` + `Tried to use: '${pluginId}'.\n` + 'Uppy plugins must have unique `id` options. See https://uppy.io/docs/plugins/#id.';
      throw new Error(msg);
    }

    if (Plugin.VERSION) {
      this.log(`Using ${pluginId} v${Plugin.VERSION}`);
    }

    if (plugin.type in _classPrivateFieldLooseBase$6(this, _plugins)[_plugins]) {
      _classPrivateFieldLooseBase$6(this, _plugins)[_plugins][plugin.type].push(plugin);
    } else {
      _classPrivateFieldLooseBase$6(this, _plugins)[_plugins][plugin.type] = [plugin];
    }

    plugin.install();
    return this;
  }
  /**
   * Find one Plugin by name.
   *
   * @param {string} id plugin id
   * @returns {BasePlugin|undefined}
   */


  getPlugin(id) {
    for (const plugins of Object.values(_classPrivateFieldLooseBase$6(this, _plugins)[_plugins])) {
      const foundPlugin = plugins.find(plugin => plugin.id === id);
      if (foundPlugin != null) return foundPlugin;
    }

    return undefined;
  }

  [_Symbol$for$1](type) {
    return _classPrivateFieldLooseBase$6(this, _plugins)[_plugins][type];
  }
  /**
   * Iterate through all `use`d plugins.
   *
   * @param {Function} method that will be run on each plugin
   */


  iteratePlugins(method) {
    Object.values(_classPrivateFieldLooseBase$6(this, _plugins)[_plugins]).flat(1).forEach(method);
  }
  /**
   * Uninstall and remove a plugin.
   *
   * @param {object} instance The plugin instance to remove.
   */


  removePlugin(instance) {
    this.log(`Removing plugin ${instance.id}`);
    this.emit('plugin-remove', instance);

    if (instance.uninstall) {
      instance.uninstall();
    }

    const list = _classPrivateFieldLooseBase$6(this, _plugins)[_plugins][instance.type]; // list.indexOf failed here, because Vue3 converted the plugin instance
    // to a Proxy object, which failed the strict comparison test:
    // obj !== objProxy


    const index = list.findIndex(item => item.id === instance.id);

    if (index !== -1) {
      list.splice(index, 1);
    }

    const state = this.getState();
    const updatedState = {
      plugins: { ...state.plugins,
        [instance.id]: undefined
      }
    };
    this.setState(updatedState);
  }
  /**
   * Uninstall all plugins and close down this Uppy instance.
   */


  close() {
    this.log(`Closing Uppy instance ${this.opts.id}: removing all files and uninstalling plugins`);
    this.reset();

    _classPrivateFieldLooseBase$6(this, _storeUnsubscribe)[_storeUnsubscribe]();

    this.iteratePlugins(plugin => {
      this.removePlugin(plugin);
    });

    if (typeof window !== 'undefined' && window.removeEventListener) {
      window.removeEventListener('online', _classPrivateFieldLooseBase$6(this, _updateOnlineStatus)[_updateOnlineStatus]);
      window.removeEventListener('offline', _classPrivateFieldLooseBase$6(this, _updateOnlineStatus)[_updateOnlineStatus]);
    }
  }

  hideInfo() {
    const {
      info
    } = this.getState();
    this.setState({
      info: info.slice(1)
    });
    this.emit('info-hidden');
  }
  /**
   * Set info message in `state.info`, so that UI plugins like `Informer`
   * can display the message.
   *
   * @param {string | object} message Message to be displayed by the informer
   * @param {string} [type]
   * @param {number} [duration]
   */


  info(message, type, duration) {
    if (type === void 0) {
      type = 'info';
    }

    if (duration === void 0) {
      duration = 3000;
    }

    const isComplexMessage = typeof message === 'object';
    this.setState({
      info: [...this.getState().info, {
        type,
        message: isComplexMessage ? message.message : message,
        details: isComplexMessage ? message.details : null
      }]
    });
    setTimeout(() => this.hideInfo(), duration);
    this.emit('info-visible');
  }
  /**
   * Passes messages to a function, provided in `opts.logger`.
   * If `opts.logger: Uppy.debugLogger` or `opts.debug: true`, logs to the browser console.
   *
   * @param {string|object} message to log
   * @param {string} [type] optional `error` or `warning`
   */


  log(message, type) {
    const {
      logger
    } = this.opts;

    switch (type) {
      case 'error':
        logger.error(message);
        break;

      case 'warning':
        logger.warn(message);
        break;

      default:
        logger.debug(message);
        break;
    }
  }
  /**
   * Restore an upload by its ID.
   */


  restore(uploadID) {
    this.log(`Core: attempting to restore upload "${uploadID}"`);

    if (!this.getState().currentUploads[uploadID]) {
      _classPrivateFieldLooseBase$6(this, _removeUpload)[_removeUpload](uploadID);

      return Promise.reject(new Error('Nonexistent upload'));
    }

    return _classPrivateFieldLooseBase$6(this, _runUpload)[_runUpload](uploadID);
  }
  /**
   * Create an upload for a bunch of files.
   *
   * @param {Array<string>} fileIDs File IDs to include in this upload.
   * @returns {string} ID of this upload.
   */


  [_Symbol$for2$1]() {
    return _classPrivateFieldLooseBase$6(this, _createUpload)[_createUpload](...arguments);
  }

  /**
   * Add data to an upload's result object.
   *
   * @param {string} uploadID The ID of the upload.
   * @param {object} data Data properties to add to the result object.
   */
  addResultData(uploadID, data) {
    if (!_classPrivateFieldLooseBase$6(this, _getUpload)[_getUpload](uploadID)) {
      this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
      return;
    }

    const {
      currentUploads
    } = this.getState();
    const currentUpload = { ...currentUploads[uploadID],
      result: { ...currentUploads[uploadID].result,
        ...data
      }
    };
    this.setState({
      currentUploads: { ...currentUploads,
        [uploadID]: currentUpload
      }
    });
  }
  /**
   * Remove an upload, eg. if it has been canceled or completed.
   *
   * @param {string} uploadID The ID of the upload.
   */


  /**
   * Start an upload for all the files that are not currently being uploaded.
   *
   * @returns {Promise}
   */
  upload() {
    var _classPrivateFieldLoo;

    if (!((_classPrivateFieldLoo = _classPrivateFieldLooseBase$6(this, _plugins)[_plugins].uploader) != null && _classPrivateFieldLoo.length)) {
      this.log('No uploader type plugins are used', 'warning');
    }

    let {
      files
    } = this.getState();
    const onBeforeUploadResult = this.opts.onBeforeUpload(files);

    if (onBeforeUploadResult === false) {
      return Promise.reject(new Error('Not starting the upload because onBeforeUpload returned false'));
    }

    if (onBeforeUploadResult && typeof onBeforeUploadResult === 'object') {
      files = onBeforeUploadResult; // Updating files in state, because uploader plugins receive file IDs,
      // and then fetch the actual file object from state

      this.setState({
        files
      });
    }

    return Promise.resolve().then(() => {
      _classPrivateFieldLooseBase$6(this, _checkMinNumberOfFiles)[_checkMinNumberOfFiles](files);

      _classPrivateFieldLooseBase$6(this, _checkRequiredMetaFields)[_checkRequiredMetaFields](files);
    }).catch(err => {
      _classPrivateFieldLooseBase$6(this, _showOrLogErrorAndThrow)[_showOrLogErrorAndThrow](err);
    }).then(() => {
      const {
        currentUploads
      } = this.getState(); // get a list of files that are currently assigned to uploads

      const currentlyUploadingFiles = Object.values(currentUploads).flatMap(curr => curr.fileIDs);
      const waitingFileIDs = [];
      Object.keys(files).forEach(fileID => {
        const file = this.getFile(fileID); // if the file hasn't started uploading and hasn't already been assigned to an upload..

        if (!file.progress.uploadStarted && currentlyUploadingFiles.indexOf(fileID) === -1) {
          waitingFileIDs.push(file.id);
        }
      });

      const uploadID = _classPrivateFieldLooseBase$6(this, _createUpload)[_createUpload](waitingFileIDs);

      return _classPrivateFieldLooseBase$6(this, _runUpload)[_runUpload](uploadID);
    }).catch(err => {
      _classPrivateFieldLooseBase$6(this, _showOrLogErrorAndThrow)[_showOrLogErrorAndThrow](err, {
        showInformer: false
      });
    });
  }

}

function _checkRestrictions2(file, files) {
  if (files === void 0) {
    files = this.getFiles();
  }

  const {
    maxFileSize,
    minFileSize,
    maxTotalFileSize,
    maxNumberOfFiles,
    allowedFileTypes
  } = this.opts.restrictions;

  if (maxNumberOfFiles) {
    if (files.length + 1 > maxNumberOfFiles) {
      throw new RestrictionError(`${this.i18n('youCanOnlyUploadX', {
        smart_count: maxNumberOfFiles
      })}`);
    }
  }

  if (allowedFileTypes) {
    const isCorrectFileType = allowedFileTypes.some(type => {
      // check if this is a mime-type
      if (type.indexOf('/') > -1) {
        if (!file.type) return false;
        return mimeMatch(file.type.replace(/;.*?$/, ''), type);
      } // otherwise this is likely an extension


      if (type[0] === '.' && file.extension) {
        return file.extension.toLowerCase() === type.substr(1).toLowerCase();
      }

      return false;
    });

    if (!isCorrectFileType) {
      const allowedFileTypesString = allowedFileTypes.join(', ');
      throw new RestrictionError(this.i18n('youCanOnlyUploadFileTypes', {
        types: allowedFileTypesString
      }));
    }
  } // We can't check maxTotalFileSize if the size is unknown.


  if (maxTotalFileSize && file.size != null) {
    let totalFilesSize = 0;
    totalFilesSize += file.size;
    files.forEach(f => {
      totalFilesSize += f.size;
    });

    if (totalFilesSize > maxTotalFileSize) {
      throw new RestrictionError(this.i18n('exceedsSize', {
        size: prettierBytes(maxTotalFileSize),
        file: file.name
      }));
    }
  } // We can't check maxFileSize if the size is unknown.


  if (maxFileSize && file.size != null) {
    if (file.size > maxFileSize) {
      throw new RestrictionError(this.i18n('exceedsSize', {
        size: prettierBytes(maxFileSize),
        file: file.name
      }));
    }
  } // We can't check minFileSize if the size is unknown.


  if (minFileSize && file.size != null) {
    if (file.size < minFileSize) {
      throw new RestrictionError(this.i18n('inferiorSize', {
        size: prettierBytes(minFileSize)
      }));
    }
  }
}

function _checkMinNumberOfFiles2(files) {
  const {
    minNumberOfFiles
  } = this.opts.restrictions;

  if (Object.keys(files).length < minNumberOfFiles) {
    throw new RestrictionError(`${this.i18n('youHaveToAtLeastSelectX', {
      smart_count: minNumberOfFiles
    })}`);
  }
}

function _checkRequiredMetaFieldsOnFile2(file) {
  const {
    requiredMetaFields
  } = this.opts.restrictions;
  const {
    hasOwnProperty
  } = Object.prototype;
  const errors = [];
  const missingFields = [];

  for (let i = 0; i < requiredMetaFields.length; i++) {
    if (!hasOwnProperty.call(file.meta, requiredMetaFields[i]) || file.meta[requiredMetaFields[i]] === '') {
      const err = new RestrictionError(`${this.i18n('missingRequiredMetaFieldOnFile', {
        fileName: file.name
      })}`);
      errors.push(err);
      missingFields.push(requiredMetaFields[i]);

      _classPrivateFieldLooseBase$6(this, _showOrLogErrorAndThrow)[_showOrLogErrorAndThrow](err, {
        file,
        showInformer: false,
        throwErr: false
      });
    }
  }

  this.setFileState(file.id, {
    missingRequiredMetaFields: missingFields
  });
  return errors;
}

function _checkRequiredMetaFields2(files) {
  const errors = Object.keys(files).flatMap(fileID => {
    const file = this.getFile(fileID);
    return _classPrivateFieldLooseBase$6(this, _checkRequiredMetaFieldsOnFile)[_checkRequiredMetaFieldsOnFile](file);
  });

  if (errors.length) {
    throw new AggregateRestrictionError(errors, `${this.i18n('missingRequiredMetaField')}`);
  }
}

function _showOrLogErrorAndThrow2(err, _temp) {
  let {
    showInformer = true,
    file = null,
    throwErr = true
  } = _temp === void 0 ? {} : _temp;
  const message = typeof err === 'object' ? err.message : err;
  const details = typeof err === 'object' && err.details ? err.details : ''; // Restriction errors should be logged, but not as errors,
  // as they are expected and shown in the UI.

  let logMessageWithDetails = message;

  if (details) {
    logMessageWithDetails += ` ${details}`;
  }

  if (err.isRestriction) {
    this.log(logMessageWithDetails);
    this.emit('restriction-failed', file, err);
  } else {
    this.log(logMessageWithDetails, 'error');
  } // Sometimes informer has to be shown manually by the developer,
  // for example, in `onBeforeFileAdded`.


  if (showInformer) {
    this.info({
      message,
      details
    }, 'error', this.opts.infoTimeout);
  }

  if (throwErr) {
    throw typeof err === 'object' ? err : new Error(err);
  }
}

function _assertNewUploadAllowed2(file) {
  const {
    allowNewUpload
  } = this.getState();

  if (allowNewUpload === false) {
    _classPrivateFieldLooseBase$6(this, _showOrLogErrorAndThrow)[_showOrLogErrorAndThrow](new RestrictionError(this.i18n('noMoreFilesAllowed')), {
      file
    });
  }
}

function _checkAndCreateFileStateObject2(files, fileDescriptor) {
  const fileType = getFileType(fileDescriptor);
  const fileName = getFileName(fileType, fileDescriptor);
  const fileExtension = getFileNameAndExtension(fileName).extension;
  const isRemote = Boolean(fileDescriptor.isRemote);
  const fileID = generateFileID({ ...fileDescriptor,
    type: fileType
  });

  if (this.checkIfFileAlreadyExists(fileID)) {
    const error = new RestrictionError(this.i18n('noDuplicates', {
      fileName
    }));

    _classPrivateFieldLooseBase$6(this, _showOrLogErrorAndThrow)[_showOrLogErrorAndThrow](error, {
      file: fileDescriptor
    });
  }

  const meta = fileDescriptor.meta || {};
  meta.name = fileName;
  meta.type = fileType; // `null` means the size is unknown.

  const size = Number.isFinite(fileDescriptor.data.size) ? fileDescriptor.data.size : null;
  let newFile = {
    source: fileDescriptor.source || '',
    id: fileID,
    name: fileName,
    extension: fileExtension || '',
    meta: { ...this.getState().meta,
      ...meta
    },
    type: fileType,
    data: fileDescriptor.data,
    progress: {
      percentage: 0,
      bytesUploaded: 0,
      bytesTotal: size,
      uploadComplete: false,
      uploadStarted: null
    },
    size,
    isRemote,
    remote: fileDescriptor.remote || '',
    preview: fileDescriptor.preview
  };
  const onBeforeFileAddedResult = this.opts.onBeforeFileAdded(newFile, files);

  if (onBeforeFileAddedResult === false) {
    // Don’t show UI info for this error, as it should be done by the developer
    _classPrivateFieldLooseBase$6(this, _showOrLogErrorAndThrow)[_showOrLogErrorAndThrow](new RestrictionError('Cannot add the file because onBeforeFileAdded returned false.'), {
      showInformer: false,
      fileDescriptor
    });
  } else if (typeof onBeforeFileAddedResult === 'object' && onBeforeFileAddedResult !== null) {
    newFile = onBeforeFileAddedResult;
  }

  try {
    const filesArray = Object.keys(files).map(i => files[i]);

    _classPrivateFieldLooseBase$6(this, _checkRestrictions)[_checkRestrictions](newFile, filesArray);
  } catch (err) {
    _classPrivateFieldLooseBase$6(this, _showOrLogErrorAndThrow)[_showOrLogErrorAndThrow](err, {
      file: newFile
    });
  }

  return newFile;
}

function _startIfAutoProceed2() {
  if (this.opts.autoProceed && !this.scheduledAutoProceed) {
    this.scheduledAutoProceed = setTimeout(() => {
      this.scheduledAutoProceed = null;
      this.upload().catch(err => {
        if (!err.isRestriction) {
          this.log(err.stack || err.message || err);
        }
      });
    }, 4);
  }
}

function _addListeners2() {
  /**
   * @param {Error} error
   * @param {object} [file]
   * @param {object} [response]
   */
  const errorHandler = (error, file, response) => {
    let errorMsg = error.message || 'Unknown error';

    if (error.details) {
      errorMsg += ` ${error.details}`;
    }

    this.setState({
      error: errorMsg
    });

    if (file != null && file.id in this.getState().files) {
      this.setFileState(file.id, {
        error: errorMsg,
        response
      });
    }
  };

  this.on('error', errorHandler);
  this.on('upload-error', (file, error, response) => {
    errorHandler(error, file, response);

    if (typeof error === 'object' && error.message) {
      const newError = new Error(error.message);
      newError.details = error.message;

      if (error.details) {
        newError.details += ` ${error.details}`;
      }

      newError.message = this.i18n('failedToUpload', {
        file: file.name
      });

      _classPrivateFieldLooseBase$6(this, _showOrLogErrorAndThrow)[_showOrLogErrorAndThrow](newError, {
        throwErr: false
      });
    } else {
      _classPrivateFieldLooseBase$6(this, _showOrLogErrorAndThrow)[_showOrLogErrorAndThrow](error, {
        throwErr: false
      });
    }
  });
  this.on('upload', () => {
    this.setState({
      error: null
    });
  });
  this.on('upload-started', file => {
    if (!this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file.id}`);
      return;
    }

    this.setFileState(file.id, {
      progress: {
        uploadStarted: Date.now(),
        uploadComplete: false,
        percentage: 0,
        bytesUploaded: 0,
        bytesTotal: file.size
      }
    });
  });
  this.on('upload-progress', this.calculateProgress);
  this.on('upload-success', (file, uploadResp) => {
    if (!this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file.id}`);
      return;
    }

    const currentProgress = this.getFile(file.id).progress;
    this.setFileState(file.id, {
      progress: { ...currentProgress,
        postprocess: _classPrivateFieldLooseBase$6(this, _postProcessors)[_postProcessors].size > 0 ? {
          mode: 'indeterminate'
        } : null,
        uploadComplete: true,
        percentage: 100,
        bytesUploaded: currentProgress.bytesTotal
      },
      response: uploadResp,
      uploadURL: uploadResp.uploadURL,
      isPaused: false
    }); // Remote providers sometimes don't tell us the file size,
    // but we can know how many bytes we uploaded once the upload is complete.

    if (file.size == null) {
      this.setFileState(file.id, {
        size: uploadResp.bytesUploaded || currentProgress.bytesTotal
      });
    }

    this.calculateTotalProgress();
  });
  this.on('preprocess-progress', (file, progress) => {
    if (!this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file.id}`);
      return;
    }

    this.setFileState(file.id, {
      progress: { ...this.getFile(file.id).progress,
        preprocess: progress
      }
    });
  });
  this.on('preprocess-complete', file => {
    if (!this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file.id}`);
      return;
    }

    const files = { ...this.getState().files
    };
    files[file.id] = { ...files[file.id],
      progress: { ...files[file.id].progress
      }
    };
    delete files[file.id].progress.preprocess;
    this.setState({
      files
    });
  });
  this.on('postprocess-progress', (file, progress) => {
    if (!this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file.id}`);
      return;
    }

    this.setFileState(file.id, {
      progress: { ...this.getState().files[file.id].progress,
        postprocess: progress
      }
    });
  });
  this.on('postprocess-complete', file => {
    if (!this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file.id}`);
      return;
    }

    const files = { ...this.getState().files
    };
    files[file.id] = { ...files[file.id],
      progress: { ...files[file.id].progress
      }
    };
    delete files[file.id].progress.postprocess;
    this.setState({
      files
    });
  });
  this.on('restored', () => {
    // Files may have changed--ensure progress is still accurate.
    this.calculateTotalProgress();
  });
  this.on('dashboard:file-edit-complete', file => {
    if (file) {
      _classPrivateFieldLooseBase$6(this, _checkRequiredMetaFieldsOnFile)[_checkRequiredMetaFieldsOnFile](file);
    }
  }); // show informer if offline

  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('online', _classPrivateFieldLooseBase$6(this, _updateOnlineStatus)[_updateOnlineStatus]);
    window.addEventListener('offline', _classPrivateFieldLooseBase$6(this, _updateOnlineStatus)[_updateOnlineStatus]);
    setTimeout(_classPrivateFieldLooseBase$6(this, _updateOnlineStatus)[_updateOnlineStatus], 3000);
  }
}

function _createUpload2(fileIDs, opts) {
  if (opts === void 0) {
    opts = {};
  }

  // uppy.retryAll sets this to true — when retrying we want to ignore `allowNewUpload: false`
  const {
    forceAllowNewUpload = false
  } = opts;
  const {
    allowNewUpload,
    currentUploads
  } = this.getState();

  if (!allowNewUpload && !forceAllowNewUpload) {
    throw new Error('Cannot create a new upload: already uploading.');
  }

  const uploadID = nanoid$1();
  this.emit('upload', {
    id: uploadID,
    fileIDs
  });
  this.setState({
    allowNewUpload: this.opts.allowMultipleUploadBatches !== false && this.opts.allowMultipleUploads !== false,
    currentUploads: { ...currentUploads,
      [uploadID]: {
        fileIDs,
        step: 0,
        result: {}
      }
    }
  });
  return uploadID;
}

function _getUpload2(uploadID) {
  const {
    currentUploads
  } = this.getState();
  return currentUploads[uploadID];
}

function _removeUpload2(uploadID) {
  const currentUploads = { ...this.getState().currentUploads
  };
  delete currentUploads[uploadID];
  this.setState({
    currentUploads
  });
}

async function _runUpload2(uploadID) {
  let {
    currentUploads
  } = this.getState();
  let currentUpload = currentUploads[uploadID];
  const restoreStep = currentUpload.step || 0;
  const steps = [..._classPrivateFieldLooseBase$6(this, _preProcessors)[_preProcessors], ..._classPrivateFieldLooseBase$6(this, _uploaders)[_uploaders], ..._classPrivateFieldLooseBase$6(this, _postProcessors)[_postProcessors]];

  try {
    for (let step = restoreStep; step < steps.length; step++) {
      if (!currentUpload) {
        break;
      }

      const fn = steps[step];
      const updatedUpload = { ...currentUpload,
        step
      };
      this.setState({
        currentUploads: { ...currentUploads,
          [uploadID]: updatedUpload
        }
      }); // TODO give this the `updatedUpload` object as its only parameter maybe?
      // Otherwise when more metadata may be added to the upload this would keep getting more parameters

      await fn(updatedUpload.fileIDs, uploadID); // Update currentUpload value in case it was modified asynchronously.

      currentUploads = this.getState().currentUploads;
      currentUpload = currentUploads[uploadID];
    }
  } catch (err) {
    this.emit('error', err);

    _classPrivateFieldLooseBase$6(this, _removeUpload)[_removeUpload](uploadID);

    throw err;
  } // Set result data.


  if (currentUpload) {
    // Mark postprocessing step as complete if necessary; this addresses a case where we might get
    // stuck in the postprocessing UI while the upload is fully complete.
    // If the postprocessing steps do not do any work, they may not emit postprocessing events at
    // all, and never mark the postprocessing as complete. This is fine on its own but we
    // introduced code in the @uppy/core upload-success handler to prepare postprocessing progress
    // state if any postprocessors are registered. That is to avoid a "flash of completed state"
    // before the postprocessing plugins can emit events.
    //
    // So, just in case an upload with postprocessing plugins *has* completed *without* emitting
    // postprocessing completion, we do it instead.
    currentUpload.fileIDs.forEach(fileID => {
      const file = this.getFile(fileID);

      if (file && file.progress.postprocess) {
        this.emit('postprocess-complete', file);
      }
    });
    const files = currentUpload.fileIDs.map(fileID => this.getFile(fileID));
    const successful = files.filter(file => !file.error);
    const failed = files.filter(file => file.error);
    await this.addResultData(uploadID, {
      successful,
      failed,
      uploadID
    }); // Update currentUpload value in case it was modified asynchronously.

    currentUploads = this.getState().currentUploads;
    currentUpload = currentUploads[uploadID];
  } // Emit completion events.
  // This is in a separate function so that the `currentUploads` variable
  // always refers to the latest state. In the handler right above it refers
  // to an outdated object without the `.result` property.


  let result;

  if (currentUpload) {
    result = currentUpload.result;
    this.emit('complete', result);

    _classPrivateFieldLooseBase$6(this, _removeUpload)[_removeUpload](uploadID);
  }

  if (result == null) {
    this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
  }

  return result;
}

Uppy.VERSION = "2.1.3";
var Uppy_1$1 = Uppy;

var preact = createCommonjsModule(function (module, exports) {
var n,l,u,t,i,r,o,f,e={},c=[],s=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function a(n,l){for(var u in l)n[u]=l[u];return n}function v(n){var l=n.parentNode;l&&l.removeChild(n);}function h(l,u,t){var i,r,o,f={};for(o in u)"key"==o?i=u[o]:"ref"==o?r=u[o]:f[o]=u[o];if(arguments.length>2&&(f.children=arguments.length>3?n.call(arguments,2):t),"function"==typeof l&&null!=l.defaultProps)for(o in l.defaultProps)void 0===f[o]&&(f[o]=l.defaultProps[o]);return p(l,f,i,r,null)}function p(n,t,i,r,o){var f={type:n,props:t,key:i,ref:r,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:null==o?++u:o};return null==o&&null!=l.vnode&&l.vnode(f),f}function y(n){return n.children}function d(n,l){this.props=n,this.context=l;}function _(n,l){if(null==l)return n.__?_(n.__,n.__.__k.indexOf(n)+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return "function"==typeof n.type?_(n):null}function k(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return k(n)}}function x(n){(!n.__d&&(n.__d=!0)&&i.push(n)&&!b.__r++||o!==l.debounceRendering)&&((o=l.debounceRendering)||r)(b);}function b(){for(var n;b.__r=i.length;)n=i.sort(function(n,l){return n.__v.__b-l.__v.__b}),i=[],n.some(function(n){var l,u,t,i,r,o;n.__d&&(r=(i=(l=n).__v).__e,(o=l.__P)&&(u=[],(t=a({},i)).__v=i.__v+1,I(o,i,t,l.__n,void 0!==o.ownerSVGElement,null!=i.__h?[r]:null,u,null==r?_(i):r,i.__h),T(u,i),i.__e!=r&&k(i)));});}function m(n,l,u,t,i,r,o,f,s,a){var v,h,d,k,x,b,m,A=t&&t.__k||c,P=A.length;for(u.__k=[],v=0;v<l.length;v++)if(null!=(k=u.__k[v]=null==(k=l[v])||"boolean"==typeof k?null:"string"==typeof k||"number"==typeof k||"bigint"==typeof k?p(null,k,null,null,k):Array.isArray(k)?p(y,{children:k},null,null,null):k.__b>0?p(k.type,k.props,k.key,null,k.__v):k)){if(k.__=u,k.__b=u.__b+1,null===(d=A[v])||d&&k.key==d.key&&k.type===d.type)A[v]=void 0;else for(h=0;h<P;h++){if((d=A[h])&&k.key==d.key&&k.type===d.type){A[h]=void 0;break}d=null;}I(n,k,d=d||e,i,r,o,f,s,a),x=k.__e,(h=k.ref)&&d.ref!=h&&(m||(m=[]),d.ref&&m.push(d.ref,null,k),m.push(h,k.__c||x,k)),null!=x?(null==b&&(b=x),"function"==typeof k.type&&k.__k===d.__k?k.__d=s=g(k,s,n):s=w(n,k,d,A,x,s),"function"==typeof u.type&&(u.__d=s)):s&&d.__e==s&&s.parentNode!=n&&(s=_(d));}for(u.__e=b,v=P;v--;)null!=A[v]&&("function"==typeof u.type&&null!=A[v].__e&&A[v].__e==u.__d&&(u.__d=_(t,v+1)),L(A[v],A[v]));if(m)for(v=0;v<m.length;v++)z(m[v],m[++v],m[++v]);}function g(n,l,u){for(var t,i=n.__k,r=0;i&&r<i.length;r++)(t=i[r])&&(t.__=n,l="function"==typeof t.type?g(t,l,u):w(u,t,t,i,t.__e,l));return l}function w(n,l,u,t,i,r){var o,f,e;if(void 0!==l.__d)o=l.__d,l.__d=void 0;else if(null==u||i!=r||null==i.parentNode)n:if(null==r||r.parentNode!==n)n.appendChild(i),o=null;else {for(f=r,e=0;(f=f.nextSibling)&&e<t.length;e+=2)if(f==i)break n;n.insertBefore(i,r),o=r;}return void 0!==o?o:i.nextSibling}function A(n,l,u,t,i){var r;for(r in u)"children"===r||"key"===r||r in l||C(n,r,null,u[r],t);for(r in l)i&&"function"!=typeof l[r]||"children"===r||"key"===r||"value"===r||"checked"===r||u[r]===l[r]||C(n,r,l[r],u[r],t);}function P(n,l,u){"-"===l[0]?n.setProperty(l,u):n[l]=null==u?"":"number"!=typeof u||s.test(l)?u:u+"px";}function C(n,l,u,t,i){var r;n:if("style"===l)if("string"==typeof u)n.style.cssText=u;else {if("string"==typeof t&&(n.style.cssText=t=""),t)for(l in t)u&&l in u||P(n.style,l,"");if(u)for(l in u)t&&u[l]===t[l]||P(n.style,l,u[l]);}else if("o"===l[0]&&"n"===l[1])r=l!==(l=l.replace(/Capture$/,"")),l=l.toLowerCase()in n?l.toLowerCase().slice(2):l.slice(2),n.l||(n.l={}),n.l[l+r]=u,u?t||n.addEventListener(l,r?H:$,r):n.removeEventListener(l,r?H:$,r);else if("dangerouslySetInnerHTML"!==l){if(i)l=l.replace(/xlink[H:h]/,"h").replace(/sName$/,"s");else if("href"!==l&&"list"!==l&&"form"!==l&&"tabIndex"!==l&&"download"!==l&&l in n)try{n[l]=null==u?"":u;break n}catch(n){}"function"==typeof u||(null!=u&&(!1!==u||"a"===l[0]&&"r"===l[1])?n.setAttribute(l,u):n.removeAttribute(l));}}function $(n){this.l[n.type+!1](l.event?l.event(n):n);}function H(n){this.l[n.type+!0](l.event?l.event(n):n);}function I(n,u,t,i,r,o,f,e,c){var s,v,h,p,_,k,x,b,g,w,A,P=u.type;if(void 0!==u.constructor)return null;null!=t.__h&&(c=t.__h,e=u.__e=t.__e,u.__h=null,o=[e]),(s=l.__b)&&s(u);try{n:if("function"==typeof P){if(b=u.props,g=(s=P.contextType)&&i[s.__c],w=s?g?g.props.value:s.__:i,t.__c?x=(v=u.__c=t.__c).__=v.__E:("prototype"in P&&P.prototype.render?u.__c=v=new P(b,w):(u.__c=v=new d(b,w),v.constructor=P,v.render=M),g&&g.sub(v),v.props=b,v.state||(v.state={}),v.context=w,v.__n=i,h=v.__d=!0,v.__h=[]),null==v.__s&&(v.__s=v.state),null!=P.getDerivedStateFromProps&&(v.__s==v.state&&(v.__s=a({},v.__s)),a(v.__s,P.getDerivedStateFromProps(b,v.__s))),p=v.props,_=v.state,h)null==P.getDerivedStateFromProps&&null!=v.componentWillMount&&v.componentWillMount(),null!=v.componentDidMount&&v.__h.push(v.componentDidMount);else {if(null==P.getDerivedStateFromProps&&b!==p&&null!=v.componentWillReceiveProps&&v.componentWillReceiveProps(b,w),!v.__e&&null!=v.shouldComponentUpdate&&!1===v.shouldComponentUpdate(b,v.__s,w)||u.__v===t.__v){v.props=b,v.state=v.__s,u.__v!==t.__v&&(v.__d=!1),v.__v=u,u.__e=t.__e,u.__k=t.__k,u.__k.forEach(function(n){n&&(n.__=u);}),v.__h.length&&f.push(v);break n}null!=v.componentWillUpdate&&v.componentWillUpdate(b,v.__s,w),null!=v.componentDidUpdate&&v.__h.push(function(){v.componentDidUpdate(p,_,k);});}v.context=w,v.props=b,v.state=v.__s,(s=l.__r)&&s(u),v.__d=!1,v.__v=u,v.__P=n,s=v.render(v.props,v.state,v.context),v.state=v.__s,null!=v.getChildContext&&(i=a(a({},i),v.getChildContext())),h||null==v.getSnapshotBeforeUpdate||(k=v.getSnapshotBeforeUpdate(p,_)),A=null!=s&&s.type===y&&null==s.key?s.props.children:s,m(n,Array.isArray(A)?A:[A],u,t,i,r,o,f,e,c),v.base=u.__e,u.__h=null,v.__h.length&&f.push(v),x&&(v.__E=v.__=null),v.__e=!1;}else null==o&&u.__v===t.__v?(u.__k=t.__k,u.__e=t.__e):u.__e=j(t.__e,u,t,i,r,o,f,c);(s=l.diffed)&&s(u);}catch(n){u.__v=null,(c||null!=o)&&(u.__e=e,u.__h=!!c,o[o.indexOf(e)]=null),l.__e(n,u,t);}}function T(n,u){l.__c&&l.__c(u,n),n.some(function(u){try{n=u.__h,u.__h=[],n.some(function(n){n.call(u);});}catch(n){l.__e(n,u.__v);}});}function j(l,u,t,i,r,o,f,c){var s,a,h,p=t.props,y=u.props,d=u.type,k=0;if("svg"===d&&(r=!0),null!=o)for(;k<o.length;k++)if((s=o[k])&&"setAttribute"in s==!!d&&(d?s.localName===d:3===s.nodeType)){l=s,o[k]=null;break}if(null==l){if(null===d)return document.createTextNode(y);l=r?document.createElementNS("http://www.w3.org/2000/svg",d):document.createElement(d,y.is&&y),o=null,c=!1;}if(null===d)p===y||c&&l.data===y||(l.data=y);else {if(o=o&&n.call(l.childNodes),a=(p=t.props||e).dangerouslySetInnerHTML,h=y.dangerouslySetInnerHTML,!c){if(null!=o)for(p={},k=0;k<l.attributes.length;k++)p[l.attributes[k].name]=l.attributes[k].value;(h||a)&&(h&&(a&&h.__html==a.__html||h.__html===l.innerHTML)||(l.innerHTML=h&&h.__html||""));}if(A(l,y,p,r,c),h)u.__k=[];else if(k=u.props.children,m(l,Array.isArray(k)?k:[k],u,t,i,r&&"foreignObject"!==d,o,f,o?o[0]:t.__k&&_(t,0),c),null!=o)for(k=o.length;k--;)null!=o[k]&&v(o[k]);c||("value"in y&&void 0!==(k=y.value)&&(k!==p.value||k!==l.value||"progress"===d&&!k)&&C(l,"value",k,p.value,!1),"checked"in y&&void 0!==(k=y.checked)&&k!==l.checked&&C(l,"checked",k,p.checked,!1));}return l}function z(n,u,t){try{"function"==typeof n?n(u):n.current=u;}catch(n){l.__e(n,t);}}function L(n,u,t){var i,r;if(l.unmount&&l.unmount(n),(i=n.ref)&&(i.current&&i.current!==n.__e||z(i,null,u)),null!=(i=n.__c)){if(i.componentWillUnmount)try{i.componentWillUnmount();}catch(n){l.__e(n,u);}i.base=i.__P=null;}if(i=n.__k)for(r=0;r<i.length;r++)i[r]&&L(i[r],u,"function"!=typeof n.type);t||null==n.__e||v(n.__e),n.__e=n.__d=void 0;}function M(n,l,u){return this.constructor(n,u)}function N(u,t,i){var r,o,f;l.__&&l.__(u,t),o=(r="function"==typeof i)?null:i&&i.__k||t.__k,f=[],I(t,u=(!r&&i||t).__k=h(y,null,[u]),o||e,e,void 0!==t.ownerSVGElement,!r&&i?[i]:o?null:t.firstChild?n.call(t.childNodes):null,f,!r&&i?i:o?o.__e:t.firstChild,r),T(f,u);}n=c.slice,l={__e:function(n,l){for(var u,t,i;l=l.__;)if((u=l.__c)&&!u.__)try{if((t=u.constructor)&&null!=t.getDerivedStateFromError&&(u.setState(t.getDerivedStateFromError(n)),i=u.__d),null!=u.componentDidCatch&&(u.componentDidCatch(n),i=u.__d),i)return u.__E=u}catch(l){n=l;}throw n}},u=0,t=function(n){return null!=n&&void 0===n.constructor},d.prototype.setState=function(n,l){var u;u=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=a({},this.state),"function"==typeof n&&(n=n(a({},u),this.props)),n&&a(u,n),null!=n&&this.__v&&(l&&this.__h.push(l),x(this));},d.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),x(this));},d.prototype.render=y,i=[],r="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,b.__r=0,f=0,exports.Component=d,exports.Fragment=y,exports.cloneElement=function(l,u,t){var i,r,o,f=a({},l.props);for(o in u)"key"==o?i=u[o]:"ref"==o?r=u[o]:f[o]=u[o];return arguments.length>2&&(f.children=arguments.length>3?n.call(arguments,2):t),p(l.type,f,i||l.key,r||l.ref,null)},exports.createContext=function(n,l){var u={__c:l="__cC"+f++,__:n,Consumer:function(n,l){return n.children(l)},Provider:function(n){var u,t;return this.getChildContext||(u=[],(t={})[l]=this,this.getChildContext=function(){return t},this.shouldComponentUpdate=function(n){this.props.value!==n.value&&u.some(x);},this.sub=function(n){u.push(n);var l=n.componentWillUnmount;n.componentWillUnmount=function(){u.splice(u.indexOf(n),1),l&&l.call(n);};}),n.children}};return u.Provider.__=u.Consumer.contextType=u},exports.createElement=h,exports.createRef=function(){return {current:null}},exports.h=h,exports.hydrate=function n(l,u){N(l,u,n);},exports.isValidElement=t,exports.options=l,exports.render=N,exports.toChildArray=function n(l,u){return u=u||[],null==l||"boolean"==typeof l||(Array.isArray(l)?l.some(function(l){n(l,u);}):u.push(l)),u};

});

/**
 * Check if an object is a DOM element. Duck-typing based on `nodeType`.
 *
 * @param {*} obj
 */
var isDOMElement = function isDOMElement(obj) {
  return (obj == null ? void 0 : obj.nodeType) === Node.ELEMENT_NODE;
};

/**
 * Find a DOM element.
 *
 * @param {Node|string} element
 * @returns {Node|null}
 */


var findDOMElement = function findDOMElement(element, context) {
  if (context === void 0) {
    context = document;
  }

  if (typeof element === 'string') {
    return context.querySelector(element);
  }

  if (isDOMElement(element)) {
    return element;
  }

  return null;
};

/**
 * Core plugin logic that all plugins share.
 *
 * BasePlugin does not contain DOM rendering so it can be used for plugins
 * without a user interface.
 *
 * See `Plugin` for the extended version with Preact rendering for interfaces.
 */


var BasePlugin_1$1 = class BasePlugin {
  constructor(uppy, opts) {
    if (opts === void 0) {
      opts = {};
    }

    this.uppy = uppy;
    this.opts = opts;
  }

  getPluginState() {
    const {
      plugins
    } = this.uppy.getState();
    return plugins[this.id] || {};
  }

  setPluginState(update) {
    const {
      plugins
    } = this.uppy.getState();
    this.uppy.setState({
      plugins: { ...plugins,
        [this.id]: { ...plugins[this.id],
          ...update
        }
      }
    });
  }

  setOptions(newOpts) {
    this.opts = { ...this.opts,
      ...newOpts
    };
    this.setPluginState(); // so that UI re-renders with new options

    this.i18nInit();
  }

  i18nInit() {
    const translator = new Translator_1([this.defaultLocale, this.uppy.locale, this.opts.locale]);
    this.i18n = translator.translate.bind(translator);
    this.i18nArray = translator.translateArray.bind(translator);
    this.setPluginState(); // so that UI re-renders and we see the updated locale
  }
  /**
   * Extendable methods
   * ==================
   * These methods are here to serve as an overview of the extendable methods as well as
   * making them not conditional in use, such as `if (this.afterUpdate)`.
   */
  // eslint-disable-next-line class-methods-use-this


  addTarget() {
    throw new Error('Extend the addTarget method to add your plugin to another plugin\'s target');
  } // eslint-disable-next-line class-methods-use-this


  install() {} // eslint-disable-next-line class-methods-use-this


  uninstall() {}
  /**
   * Called when plugin is mounted, whether in DOM or into another plugin.
   * Needed because sometimes plugins are mounted separately/after `install`,
   * so this.el and this.parent might not be available in `install`.
   * This is the case with @uppy/react plugins, for example.
   */


  render() {
    throw new Error('Extend the render method to add your plugin to a DOM element');
  } // eslint-disable-next-line class-methods-use-this


  update() {} // Called after every state update, after everything's mounted. Debounced.
  // eslint-disable-next-line class-methods-use-this


  afterUpdate() {}

};

function _classPrivateFieldLooseBase$5(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id$7 = 0;

function _classPrivateFieldLooseKey$5(name) { return "__private_" + id$7++ + "_" + name; }

const {
  render
} = preact;




/**
 * Defer a frequent call to the microtask queue.
 *
 * @param {() => T} fn
 * @returns {Promise<T>}
 */


function debounce(fn) {
  let calling = null;
  let latestArgs = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    latestArgs = args;

    if (!calling) {
      calling = Promise.resolve().then(() => {
        calling = null; // At this point `args` may be different from the most
        // recent state, if multiple calls happened since this task
        // was queued. So we use the `latestArgs`, which definitely
        // is the most recent call.

        return fn(...latestArgs);
      });
    }

    return calling;
  };
}
/**
 * UIPlugin is the extended version of BasePlugin to incorporate rendering with Preact.
 * Use this for plugins that need a user interface.
 *
 * For plugins without an user interface, see BasePlugin.
 */


var _updateUI = /*#__PURE__*/_classPrivateFieldLooseKey$5("updateUI");

class UIPlugin extends BasePlugin_1$1 {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, _updateUI, {
      writable: true,
      value: void 0
    });
  }

  /**
   * Check if supplied `target` is a DOM element or an `object`.
   * If it’s an object — target is a plugin, and we search `plugins`
   * for a plugin with same name and return its target.
   */
  mount(target, plugin) {
    const callerPluginName = plugin.id;
    const targetElement = findDOMElement(target);

    if (targetElement) {
      this.isTargetDOMEl = true; // When target is <body> with a single <div> element,
      // Preact thinks it’s the Uppy root element in there when doing a diff,
      // and destroys it. So we are creating a fragment (could be empty div)

      const uppyRootElement = document.createDocumentFragment(); // API for plugins that require a synchronous rerender.

      _classPrivateFieldLooseBase$5(this, _updateUI)[_updateUI] = debounce(state => {
        // plugin could be removed, but this.rerender is debounced below,
        // so it could still be called even after uppy.removePlugin or uppy.close
        // hence the check
        if (!this.uppy.getPlugin(this.id)) return;
        render(this.render(state), uppyRootElement);
        this.afterUpdate();
      });
      this.uppy.log(`Installing ${callerPluginName} to a DOM element '${target}'`);

      if (this.opts.replaceTargetContent) {
        // Doing render(h(null), targetElement), which should have been
        // a better way, since because the component might need to do additional cleanup when it is removed,
        // stopped working — Preact just adds null into target, not replacing
        targetElement.innerHTML = '';
      }

      render(this.render(this.uppy.getState()), uppyRootElement);
      this.el = uppyRootElement.firstElementChild;
      targetElement.appendChild(uppyRootElement);
      this.onMount();
      return this.el;
    }

    let targetPlugin;

    if (typeof target === 'object' && target instanceof UIPlugin) {
      // Targeting a plugin *instance*
      targetPlugin = target;
    } else if (typeof target === 'function') {
      // Targeting a plugin type
      const Target = target; // Find the target plugin instance.

      this.uppy.iteratePlugins(p => {
        if (p instanceof Target) {
          targetPlugin = p;
          return false;
        }
      });
    }

    if (targetPlugin) {
      this.uppy.log(`Installing ${callerPluginName} to ${targetPlugin.id}`);
      this.parent = targetPlugin;
      this.el = targetPlugin.addTarget(plugin);
      this.onMount();
      return this.el;
    }

    this.uppy.log(`Not installing ${callerPluginName}`);
    let message = `Invalid target option given to ${callerPluginName}.`;

    if (typeof target === 'function') {
      message += ' The given target is not a Plugin class. ' + 'Please check that you\'re not specifying a React Component instead of a plugin. ' + 'If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: ' + 'run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly.';
    } else {
      message += 'If you meant to target an HTML element, please make sure that the element exists. ' + 'Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. ' + '(see https://github.com/transloadit/uppy/issues/1042)\n\n' + 'If you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.';
    }

    throw new Error(message);
  }

  update(state) {
    if (this.el != null) {
      var _classPrivateFieldLoo, _classPrivateFieldLoo2;

      (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase$5(this, _updateUI))[_updateUI]) == null ? void 0 : _classPrivateFieldLoo.call(_classPrivateFieldLoo2, state);
    }
  }

  unmount() {
    if (this.isTargetDOMEl) {
      var _this$el;

      (_this$el = this.el) == null ? void 0 : _this$el.remove();
    }

    this.onUnmount();
  } // eslint-disable-next-line class-methods-use-this


  onMount() {} // eslint-disable-next-line class-methods-use-this


  onUnmount() {}

}

var UIPlugin_1$1 = UIPlugin;

const {
  debugLogger
} = loggers;

var lib$2 = Uppy_1$1;
var Uppy_1 = Uppy_1$1;
var UIPlugin_1 = UIPlugin_1$1;
var BasePlugin_1 = BasePlugin_1$1;
var debugLogger_1 = debugLogger;
lib$2.Uppy = Uppy_1;
lib$2.UIPlugin = UIPlugin_1;
lib$2.BasePlugin = BasePlugin_1;
lib$2.debugLogger = debugLogger_1;

class NetworkError extends Error {
  constructor(error, xhr) {
    if (xhr === void 0) {
      xhr = null;
    }

    super(`This looks like a network error, the endpoint might be blocked by an internet provider or a firewall.`);
    this.cause = error;
    this.isNetworkError = true;
    this.request = xhr;
  }

}

var NetworkError_1 = NetworkError;

/**
 * Wrapper around window.fetch that throws a NetworkError when appropriate
 */


var fetchWithNetworkError = function fetchWithNetworkError() {
  return fetch(...arguments).catch(err => {
    if (err.name === 'AbortError') {
      throw err;
    } else {
      throw new NetworkError_1(err);
    }
  });
};

class AuthError extends Error {
  constructor() {
    super('Authorization required');
    this.name = 'AuthError';
    this.isAuthError = true;
  }

}

var AuthError_1 = AuthError;

var _class$1, _getPostResponseFunc, _getUrl, _errorHandler, _temp$1;

function _classPrivateFieldLooseBase$4(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id$6 = 0;

function _classPrivateFieldLooseKey$4(name) { return "__private_" + id$6++ + "_" + name; }



 // Remove the trailing slash so we can always safely append /xyz.


function stripSlash(url) {
  return url.replace(/\/$/, '');
}

async function handleJSONResponse(res) {
  if (res.status === 401) {
    throw new AuthError_1();
  }

  const jsonPromise = res.json();

  if (res.status < 200 || res.status > 300) {
    let errMsg = `Failed request with status: ${res.status}. ${res.statusText}`;

    try {
      const errData = await jsonPromise;
      errMsg = errData.message ? `${errMsg} message: ${errData.message}` : errMsg;
      errMsg = errData.requestId ? `${errMsg} request-Id: ${errData.requestId}` : errMsg;
    } finally {
      // eslint-disable-next-line no-unsafe-finally
      throw new Error(errMsg);
    }
  }

  return jsonPromise;
}

var RequestClient_1 = (_temp$1 = (_getPostResponseFunc = /*#__PURE__*/_classPrivateFieldLooseKey$4("getPostResponseFunc"), _getUrl = /*#__PURE__*/_classPrivateFieldLooseKey$4("getUrl"), _errorHandler = /*#__PURE__*/_classPrivateFieldLooseKey$4("errorHandler"), _class$1 = class RequestClient {
  // eslint-disable-next-line global-require
  constructor(uppy, opts) {
    Object.defineProperty(this, _errorHandler, {
      value: _errorHandler2
    });
    Object.defineProperty(this, _getUrl, {
      value: _getUrl2
    });
    Object.defineProperty(this, _getPostResponseFunc, {
      writable: true,
      value: skip => response => skip ? response : this.onReceiveResponse(response)
    });
    this.uppy = uppy;
    this.opts = opts;
    this.onReceiveResponse = this.onReceiveResponse.bind(this);
    this.allowedHeaders = ['accept', 'content-type', 'uppy-auth-token'];
    this.preflightDone = false;
  }

  get hostname() {
    const {
      companion
    } = this.uppy.getState();
    const host = this.opts.companionUrl;
    return stripSlash(companion && companion[host] ? companion[host] : host);
  }

  headers() {
    const userHeaders = this.opts.companionHeaders || {};
    return Promise.resolve({ ...RequestClient.defaultHeaders,
      ...userHeaders
    });
  }

  onReceiveResponse(response) {
    const state = this.uppy.getState();
    const companion = state.companion || {};
    const host = this.opts.companionUrl;
    const {
      headers
    } = response; // Store the self-identified domain name for the Companion instance we just hit.

    if (headers.has('i-am') && headers.get('i-am') !== companion[host]) {
      this.uppy.setState({
        companion: { ...companion,
          [host]: headers.get('i-am')
        }
      });
    }

    return response;
  }

  preflight(path) {
    if (this.preflightDone) {
      return Promise.resolve(this.allowedHeaders.slice());
    }

    return fetch(_classPrivateFieldLooseBase$4(this, _getUrl)[_getUrl](path), {
      method: 'OPTIONS'
    }).then(response => {
      if (response.headers.has('access-control-allow-headers')) {
        this.allowedHeaders = response.headers.get('access-control-allow-headers').split(',').map(headerName => headerName.trim().toLowerCase());
      }

      this.preflightDone = true;
      return this.allowedHeaders.slice();
    }).catch(err => {
      this.uppy.log(`[CompanionClient] unable to make preflight request ${err}`, 'warning');
      this.preflightDone = true;
      return this.allowedHeaders.slice();
    });
  }

  preflightAndHeaders(path) {
    return Promise.all([this.preflight(path), this.headers()]).then(_ref => {
      let [allowedHeaders, headers] = _ref;
      // filter to keep only allowed Headers
      Object.keys(headers).forEach(header => {
        if (!allowedHeaders.includes(header.toLowerCase())) {
          this.uppy.log(`[CompanionClient] excluding disallowed header ${header}`);
          delete headers[header]; // eslint-disable-line no-param-reassign
        }
      });
      return headers;
    });
  }

  get(path, skipPostResponse) {
    const method = 'get';
    return this.preflightAndHeaders(path).then(headers => fetchWithNetworkError(_classPrivateFieldLooseBase$4(this, _getUrl)[_getUrl](path), {
      method,
      headers,
      credentials: this.opts.companionCookiesRule || 'same-origin'
    })).then(_classPrivateFieldLooseBase$4(this, _getPostResponseFunc)[_getPostResponseFunc](skipPostResponse)).then(handleJSONResponse).catch(_classPrivateFieldLooseBase$4(this, _errorHandler)[_errorHandler](method, path));
  }

  post(path, data, skipPostResponse) {
    const method = 'post';
    return this.preflightAndHeaders(path).then(headers => fetchWithNetworkError(_classPrivateFieldLooseBase$4(this, _getUrl)[_getUrl](path), {
      method,
      headers,
      credentials: this.opts.companionCookiesRule || 'same-origin',
      body: JSON.stringify(data)
    })).then(_classPrivateFieldLooseBase$4(this, _getPostResponseFunc)[_getPostResponseFunc](skipPostResponse)).then(handleJSONResponse).catch(_classPrivateFieldLooseBase$4(this, _errorHandler)[_errorHandler](method, path));
  }

  delete(path, data, skipPostResponse) {
    const method = 'delete';
    return this.preflightAndHeaders(path).then(headers => fetchWithNetworkError(`${this.hostname}/${path}`, {
      method,
      headers,
      credentials: this.opts.companionCookiesRule || 'same-origin',
      body: data ? JSON.stringify(data) : null
    })).then(_classPrivateFieldLooseBase$4(this, _getPostResponseFunc)[_getPostResponseFunc](skipPostResponse)).then(handleJSONResponse).catch(_classPrivateFieldLooseBase$4(this, _errorHandler)[_errorHandler](method, path));
  }

}), _class$1.VERSION = "2.0.4", _class$1.defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Uppy-Versions': `@uppy/companion-client=${_class$1.VERSION}`
}, _temp$1);

function _getUrl2(url) {
  if (/^(https?:|)\/\//.test(url)) {
    return url;
  }

  return `${this.hostname}/${url}`;
}

function _errorHandler2(method, path) {
  return err => {
    var _err;

    if (!((_err = err) != null && _err.isAuthError)) {
      const error = new Error(`Could not ${method} ${_classPrivateFieldLooseBase$4(this, _getUrl)[_getUrl](path)}`);
      error.cause = err;
      err = error; // eslint-disable-line no-param-reassign
    }

    return Promise.reject(err);
  };
}

/**
 * This module serves as an Async wrapper for LocalStorage
 */

var setItem = (key, value) => {
  return new Promise(resolve => {
    localStorage.setItem(key, value);
    resolve();
  });
};

var getItem = key => {
  return Promise.resolve(localStorage.getItem(key));
};

var removeItem = key => {
  return new Promise(resolve => {
    localStorage.removeItem(key);
    resolve();
  });
};

var tokenStorage = {
	setItem: setItem,
	getItem: getItem,
	removeItem: removeItem
};

const getName$1 = id => {
  return id.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ');
};

var Provider_1 = class Provider extends RequestClient_1 {
  constructor(uppy, opts) {
    super(uppy, opts);
    this.provider = opts.provider;
    this.id = this.provider;
    this.name = this.opts.name || getName$1(this.id);
    this.pluginId = this.opts.pluginId;
    this.tokenKey = `companion-${this.pluginId}-auth-token`;
    this.companionKeysParams = this.opts.companionKeysParams;
    this.preAuthToken = null;
  }

  headers() {
    return Promise.all([super.headers(), this.getAuthToken()]).then(_ref => {
      let [headers, token] = _ref;
      const authHeaders = {};

      if (token) {
        authHeaders['uppy-auth-token'] = token;
      }

      if (this.companionKeysParams) {
        authHeaders['uppy-credentials-params'] = btoa(JSON.stringify({
          params: this.companionKeysParams
        }));
      }

      return { ...headers,
        ...authHeaders
      };
    });
  }

  onReceiveResponse(response) {
    response = super.onReceiveResponse(response);
    const plugin = this.uppy.getPlugin(this.pluginId);
    const oldAuthenticated = plugin.getPluginState().authenticated;
    const authenticated = oldAuthenticated ? response.status !== 401 : response.status < 400;
    plugin.setPluginState({
      authenticated
    });
    return response;
  }

  setAuthToken(token) {
    return this.uppy.getPlugin(this.pluginId).storage.setItem(this.tokenKey, token);
  }

  getAuthToken() {
    return this.uppy.getPlugin(this.pluginId).storage.getItem(this.tokenKey);
  }

  authUrl(queries) {
    if (queries === void 0) {
      queries = {};
    }

    if (this.preAuthToken) {
      queries.uppyPreAuthToken = this.preAuthToken;
    }

    return `${this.hostname}/${this.id}/connect?${new URLSearchParams(queries)}`;
  }

  fileUrl(id) {
    return `${this.hostname}/${this.id}/get/${id}`;
  }

  fetchPreAuthToken() {
    if (!this.companionKeysParams) {
      return Promise.resolve();
    }

    return this.post(`${this.id}/preauth/`, {
      params: this.companionKeysParams
    }).then(res => {
      this.preAuthToken = res.token;
    }).catch(err => {
      this.uppy.log(`[CompanionClient] unable to fetch preAuthToken ${err}`, 'warning');
    });
  }

  list(directory) {
    return this.get(`${this.id}/list/${directory || ''}`);
  }

  logout() {
    return this.get(`${this.id}/logout`).then(response => Promise.all([response, this.uppy.getPlugin(this.pluginId).storage.removeItem(this.tokenKey)])).then(_ref2 => {
      let [response] = _ref2;
      return response;
    });
  }

  static initPlugin(plugin, opts, defaultOpts) {
    plugin.type = 'acquirer';
    plugin.files = [];

    if (defaultOpts) {
      plugin.opts = { ...defaultOpts,
        ...opts
      };
    }

    if (opts.serverUrl || opts.serverPattern) {
      throw new Error('`serverUrl` and `serverPattern` have been renamed to `companionUrl` and `companionAllowedHosts` respectively in the 0.30.5 release. Please consult the docs (for example, https://uppy.io/docs/instagram/ for the Instagram plugin) and use the updated options.`');
    }

    if (opts.companionAllowedHosts) {
      const pattern = opts.companionAllowedHosts; // validate companionAllowedHosts param

      if (typeof pattern !== 'string' && !Array.isArray(pattern) && !(pattern instanceof RegExp)) {
        throw new TypeError(`${plugin.id}: the option "companionAllowedHosts" must be one of string, Array, RegExp`);
      }

      plugin.opts.companionAllowedHosts = pattern;
    } else if (/^(?!https?:\/\/).*$/i.test(opts.companionUrl)) {
      // does not start with https://
      plugin.opts.companionAllowedHosts = `https://${opts.companionUrl.replace(/^\/\//, '')}`;
    } else {
      plugin.opts.companionAllowedHosts = new URL(opts.companionUrl).origin;
    }

    plugin.storage = plugin.opts.storage || tokenStorage;
  }

};

const getName = id => {
  return id.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ');
};

var SearchProvider_1 = class SearchProvider extends RequestClient_1 {
  constructor(uppy, opts) {
    super(uppy, opts);
    this.provider = opts.provider;
    this.id = this.provider;
    this.name = this.opts.name || getName(this.id);
    this.pluginId = this.opts.pluginId;
  }

  fileUrl(id) {
    return `${this.hostname}/search/${this.id}/get/${id}`;
  }

  search(text, queries) {
    queries = queries ? `&${queries}` : '';
    return this.get(`search/${this.id}/list?q=${encodeURIComponent(text)}${queries}`);
  }

};

var _queued, _emitter$1, _isOpen, _socket, _handleMessage;

let _Symbol$for, _Symbol$for2;

function _classPrivateFieldLooseBase$3(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id$5 = 0;

function _classPrivateFieldLooseKey$3(name) { return "__private_" + id$5++ + "_" + name; }



var Socket$1 = (_queued = /*#__PURE__*/_classPrivateFieldLooseKey$3("queued"), _emitter$1 = /*#__PURE__*/_classPrivateFieldLooseKey$3("emitter"), _isOpen = /*#__PURE__*/_classPrivateFieldLooseKey$3("isOpen"), _socket = /*#__PURE__*/_classPrivateFieldLooseKey$3("socket"), _handleMessage = /*#__PURE__*/_classPrivateFieldLooseKey$3("handleMessage"), _Symbol$for = Symbol.for('uppy test: getSocket'), _Symbol$for2 = Symbol.for('uppy test: getQueued'), class UppySocket {
  constructor(opts) {
    Object.defineProperty(this, _queued, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _emitter$1, {
      writable: true,
      value: namespaceEmitter()
    });
    Object.defineProperty(this, _isOpen, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _socket, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _handleMessage, {
      writable: true,
      value: e => {
        try {
          const message = JSON.parse(e.data);
          this.emit(message.action, message.payload);
        } catch (err) {
          // TODO: use a more robust error handler.
          console.log(err); // eslint-disable-line no-console
        }
      }
    });
    this.opts = opts;

    if (!opts || opts.autoOpen !== false) {
      this.open();
    }
  }

  get isOpen() {
    return _classPrivateFieldLooseBase$3(this, _isOpen)[_isOpen];
  }

  [_Symbol$for]() {
    return _classPrivateFieldLooseBase$3(this, _socket)[_socket];
  }

  [_Symbol$for2]() {
    return _classPrivateFieldLooseBase$3(this, _queued)[_queued];
  }

  open() {
    _classPrivateFieldLooseBase$3(this, _socket)[_socket] = new WebSocket(this.opts.target);

    _classPrivateFieldLooseBase$3(this, _socket)[_socket].onopen = () => {
      _classPrivateFieldLooseBase$3(this, _isOpen)[_isOpen] = true;

      while (_classPrivateFieldLooseBase$3(this, _queued)[_queued].length > 0 && _classPrivateFieldLooseBase$3(this, _isOpen)[_isOpen]) {
        const first = _classPrivateFieldLooseBase$3(this, _queued)[_queued].shift();

        this.send(first.action, first.payload);
      }
    };

    _classPrivateFieldLooseBase$3(this, _socket)[_socket].onclose = () => {
      _classPrivateFieldLooseBase$3(this, _isOpen)[_isOpen] = false;
    };

    _classPrivateFieldLooseBase$3(this, _socket)[_socket].onmessage = _classPrivateFieldLooseBase$3(this, _handleMessage)[_handleMessage];
  }

  close() {
    var _classPrivateFieldLoo;

    (_classPrivateFieldLoo = _classPrivateFieldLooseBase$3(this, _socket)[_socket]) == null ? void 0 : _classPrivateFieldLoo.close();
  }

  send(action, payload) {
    // attach uuid
    if (!_classPrivateFieldLooseBase$3(this, _isOpen)[_isOpen]) {
      _classPrivateFieldLooseBase$3(this, _queued)[_queued].push({
        action,
        payload
      });

      return;
    }

    _classPrivateFieldLooseBase$3(this, _socket)[_socket].send(JSON.stringify({
      action,
      payload
    }));
  }

  on(action, handler) {
    _classPrivateFieldLooseBase$3(this, _emitter$1)[_emitter$1].on(action, handler);
  }

  emit(action, payload) {
    _classPrivateFieldLooseBase$3(this, _emitter$1)[_emitter$1].emit(action, payload);
  }

  once(action, handler) {
    _classPrivateFieldLooseBase$3(this, _emitter$1)[_emitter$1].once(action, handler);
  }

});

/**
 * Manages communications with Companion
 */









var lib$1 = {
  RequestClient: RequestClient_1,
  Provider: Provider_1,
  SearchProvider: SearchProvider_1,
  Socket: Socket$1
};

function emitSocketProgress(uploader, progressData, file) {
  const {
    progress,
    bytesUploaded,
    bytesTotal
  } = progressData;

  if (progress) {
    uploader.uppy.log(`Upload progress: ${progress}`);
    uploader.uppy.emit('upload-progress', file, {
      uploader,
      bytesUploaded,
      bytesTotal
    });
  }
}

var emitSocketProgress_1 = lodash_throttle(emitSocketProgress, 300, {
  leading: true,
  trailing: true
});

var getSocketHost = function getSocketHost(url) {
  // get the host domain
  const regex = /^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:www\.)?([^\n]+)/i;
  const host = regex.exec(url)[1];
  const socketProtocol = /^http:\/\//i.test(url) ? 'ws' : 'wss';
  return `${socketProtocol}://${host}`;
};

var settle = function settle(promises) {
  const resolutions = [];
  const rejections = [];

  function resolved(value) {
    resolutions.push(value);
  }

  function rejected(error) {
    rejections.push(error);
  }

  const wait = Promise.all(promises.map(promise => promise.then(resolved, rejected)));
  return wait.then(() => {
    return {
      successful: resolutions,
      failed: rejections
    };
  });
};

var _emitter, _events;

function _classPrivateFieldLooseBase$2(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id$4 = 0;

function _classPrivateFieldLooseKey$2(name) { return "__private_" + id$4++ + "_" + name; }

/**
 * Create a wrapper around an event emitter with a `remove` method to remove
 * all events that were added using the wrapped emitter.
 */
var EventTracker_1 = (_emitter = /*#__PURE__*/_classPrivateFieldLooseKey$2("emitter"), _events = /*#__PURE__*/_classPrivateFieldLooseKey$2("events"), class EventTracker {
  constructor(emitter) {
    Object.defineProperty(this, _emitter, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _events, {
      writable: true,
      value: []
    });
    _classPrivateFieldLooseBase$2(this, _emitter)[_emitter] = emitter;
  }

  on(event, fn) {
    _classPrivateFieldLooseBase$2(this, _events)[_events].push([event, fn]);

    return _classPrivateFieldLooseBase$2(this, _emitter)[_emitter].on(event, fn);
  }

  remove() {
    for (const [event, fn] of _classPrivateFieldLooseBase$2(this, _events)[_events].splice(0)) {
      _classPrivateFieldLooseBase$2(this, _emitter)[_emitter].off(event, fn);
    }
  }

});

function _classPrivateFieldLooseBase$1(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id$3 = 0;

function _classPrivateFieldLooseKey$1(name) { return "__private_" + id$3++ + "_" + name; }

var _aliveTimer = /*#__PURE__*/_classPrivateFieldLooseKey$1("aliveTimer");

var _isDone = /*#__PURE__*/_classPrivateFieldLooseKey$1("isDone");

var _onTimedOut = /*#__PURE__*/_classPrivateFieldLooseKey$1("onTimedOut");

var _timeout = /*#__PURE__*/_classPrivateFieldLooseKey$1("timeout");

/**
 * Helper to abort upload requests if there has not been any progress for `timeout` ms.
 * Create an instance using `timer = new ProgressTimeout(10000, onTimeout)`
 * Call `timer.progress()` to signal that there has been progress of any kind.
 * Call `timer.done()` when the upload has completed.
 */
class ProgressTimeout {
  constructor(timeout, timeoutHandler) {
    Object.defineProperty(this, _aliveTimer, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _isDone, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _onTimedOut, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _timeout, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase$1(this, _timeout)[_timeout] = timeout;
    _classPrivateFieldLooseBase$1(this, _onTimedOut)[_onTimedOut] = timeoutHandler;
  }

  progress() {
    // Some browsers fire another progress event when the upload is
    // cancelled, so we have to ignore progress after the timer was
    // told to stop.
    if (_classPrivateFieldLooseBase$1(this, _isDone)[_isDone]) return;

    if (_classPrivateFieldLooseBase$1(this, _timeout)[_timeout] > 0) {
      clearTimeout(_classPrivateFieldLooseBase$1(this, _aliveTimer)[_aliveTimer]);
      _classPrivateFieldLooseBase$1(this, _aliveTimer)[_aliveTimer] = setTimeout(_classPrivateFieldLooseBase$1(this, _onTimedOut)[_onTimedOut], _classPrivateFieldLooseBase$1(this, _timeout)[_timeout]);
    }
  }

  done() {
    if (!_classPrivateFieldLooseBase$1(this, _isDone)[_isDone]) {
      clearTimeout(_classPrivateFieldLooseBase$1(this, _aliveTimer)[_aliveTimer]);
      _classPrivateFieldLooseBase$1(this, _aliveTimer)[_aliveTimer] = null;
      _classPrivateFieldLooseBase$1(this, _isDone)[_isDone] = true;
    }
  }

}

var ProgressTimeout_1 = ProgressTimeout;

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id$2 = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id$2++ + "_" + name; }

function createCancelError() {
  return new Error('Cancelled');
}

var _activeRequests = /*#__PURE__*/_classPrivateFieldLooseKey("activeRequests");

var _queuedHandlers = /*#__PURE__*/_classPrivateFieldLooseKey("queuedHandlers");

var _call = /*#__PURE__*/_classPrivateFieldLooseKey("call");

var _queueNext = /*#__PURE__*/_classPrivateFieldLooseKey("queueNext");

var _next = /*#__PURE__*/_classPrivateFieldLooseKey("next");

var _queue = /*#__PURE__*/_classPrivateFieldLooseKey("queue");

var _dequeue = /*#__PURE__*/_classPrivateFieldLooseKey("dequeue");

class RateLimitedQueue$1 {
  constructor(limit) {
    Object.defineProperty(this, _dequeue, {
      value: _dequeue2
    });
    Object.defineProperty(this, _queue, {
      value: _queue2
    });
    Object.defineProperty(this, _next, {
      value: _next2
    });
    Object.defineProperty(this, _queueNext, {
      value: _queueNext2
    });
    Object.defineProperty(this, _call, {
      value: _call2
    });
    Object.defineProperty(this, _activeRequests, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _queuedHandlers, {
      writable: true,
      value: []
    });

    if (typeof limit !== 'number' || limit === 0) {
      this.limit = Infinity;
    } else {
      this.limit = limit;
    }
  }

  run(fn, queueOptions) {
    if (_classPrivateFieldLooseBase(this, _activeRequests)[_activeRequests] < this.limit) {
      return _classPrivateFieldLooseBase(this, _call)[_call](fn);
    }

    return _classPrivateFieldLooseBase(this, _queue)[_queue](fn, queueOptions);
  }

  wrapPromiseFunction(fn, queueOptions) {
    var _this = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      let queuedRequest;
      const outerPromise = new Promise((resolve, reject) => {
        queuedRequest = _this.run(() => {
          let cancelError;
          let innerPromise;

          try {
            innerPromise = Promise.resolve(fn(...args));
          } catch (err) {
            innerPromise = Promise.reject(err);
          }

          innerPromise.then(result => {
            if (cancelError) {
              reject(cancelError);
            } else {
              queuedRequest.done();
              resolve(result);
            }
          }, err => {
            if (cancelError) {
              reject(cancelError);
            } else {
              queuedRequest.done();
              reject(err);
            }
          });
          return () => {
            cancelError = createCancelError();
          };
        }, queueOptions);
      });

      outerPromise.abort = () => {
        queuedRequest.abort();
      };

      return outerPromise;
    };
  }

}

function _call2(fn) {
  _classPrivateFieldLooseBase(this, _activeRequests)[_activeRequests] += 1;
  let done = false;
  let cancelActive;

  try {
    cancelActive = fn();
  } catch (err) {
    _classPrivateFieldLooseBase(this, _activeRequests)[_activeRequests] -= 1;
    throw err;
  }

  return {
    abort: () => {
      if (done) return;
      done = true;
      _classPrivateFieldLooseBase(this, _activeRequests)[_activeRequests] -= 1;
      cancelActive();

      _classPrivateFieldLooseBase(this, _queueNext)[_queueNext]();
    },
    done: () => {
      if (done) return;
      done = true;
      _classPrivateFieldLooseBase(this, _activeRequests)[_activeRequests] -= 1;

      _classPrivateFieldLooseBase(this, _queueNext)[_queueNext]();
    }
  };
}

function _queueNext2() {
  // Do it soon but not immediately, this allows clearing out the entire queue synchronously
  // one by one without continuously _advancing_ it (and starting new tasks before immediately
  // aborting them)
  queueMicrotask(() => _classPrivateFieldLooseBase(this, _next)[_next]());
}

function _next2() {
  if (_classPrivateFieldLooseBase(this, _activeRequests)[_activeRequests] >= this.limit) {
    return;
  }

  if (_classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].length === 0) {
    return;
  } // Dispatch the next request, and update the abort/done handlers
  // so that cancelling it does the Right Thing (and doesn't just try
  // to dequeue an already-running request).


  const next = _classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].shift();

  const handler = _classPrivateFieldLooseBase(this, _call)[_call](next.fn);

  next.abort = handler.abort;
  next.done = handler.done;
}

function _queue2(fn, options) {
  if (options === void 0) {
    options = {};
  }

  const handler = {
    fn,
    priority: options.priority || 0,
    abort: () => {
      _classPrivateFieldLooseBase(this, _dequeue)[_dequeue](handler);
    },
    done: () => {
      throw new Error('Cannot mark a queued request as done: this indicates a bug');
    }
  };

  const index = _classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].findIndex(other => {
    return handler.priority > other.priority;
  });

  if (index === -1) {
    _classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].push(handler);
  } else {
    _classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].splice(index, 0, handler);
  }

  return handler;
}

function _dequeue2(handler) {
  const index = _classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].indexOf(handler);

  if (index !== -1) {
    _classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].splice(index, 1);
  }
}

var RateLimitedQueue_1 = {
  RateLimitedQueue: RateLimitedQueue$1,
  internalRateLimitedQueue: Symbol('__queue')
};

function isNetworkError(xhr) {
  if (!xhr) {
    return false;
  }

  return xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0;
}

var isNetworkError_1 = isNetworkError;

var locale = {
  strings: {
    // Shown in the Informer if an upload is being canceled because it stalled for too long.
    timedOut: 'Upload stalled for %{seconds} seconds, aborting.'
  }
};

var _class, _temp;



const {
  nanoid
} = require$$0;

const {
  Provider,
  RequestClient,
  Socket
} = lib$1;











const {
  RateLimitedQueue,
  internalRateLimitedQueue
} = RateLimitedQueue_1;







function buildResponseError(xhr, err) {
  let error = err; // No error message

  if (!error) error = new Error('Upload error'); // Got an error message string

  if (typeof error === 'string') error = new Error(error); // Got something else

  if (!(error instanceof Error)) {
    error = Object.assign(new Error('Upload error'), {
      data: error
    });
  }

  if (isNetworkError_1(xhr)) {
    error = new NetworkError_1(error, xhr);
    return error;
  }

  error.request = xhr;
  return error;
}
/**
 * Set `data.type` in the blob to `file.meta.type`,
 * because we might have detected a more accurate file type in Uppy
 * https://stackoverflow.com/a/50875615
 *
 * @param {object} file File object with `data`, `size` and `meta` properties
 * @returns {object} blob updated with the new `type` set from `file.meta.type`
 */


function setTypeInBlob(file) {
  const dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
  return dataWithUpdatedType;
}

var lib = (_temp = _class = class XHRUpload extends BasePlugin_1$1 {
  // eslint-disable-next-line global-require
  constructor(uppy, opts) {
    super(uppy, opts);
    this.type = 'uploader';
    this.id = this.opts.id || 'XHRUpload';
    this.title = 'XHRUpload';
    this.defaultLocale = locale; // Default options

    const defaultOptions = {
      formData: true,
      fieldName: opts.bundle ? 'files[]' : 'file',
      method: 'post',
      metaFields: null,
      responseUrlFieldName: 'url',
      bundle: false,
      headers: {},
      timeout: 30 * 1000,
      limit: 5,
      withCredentials: false,
      responseType: '',

      /**
       * @typedef respObj
       * @property {string} responseText
       * @property {number} status
       * @property {string} statusText
       * @property {object.<string, string>} headers
       *
       * @param {string} responseText the response body string
       * @param {XMLHttpRequest | respObj} response the response object (XHR or similar)
       */
      getResponseData(responseText) {
        let parsedResponse = {};

        try {
          parsedResponse = JSON.parse(responseText);
        } catch (err) {
          uppy.log(err);
        }

        return parsedResponse;
      },

      /**
       *
       * @param {string} responseText the response body string
       * @param {XMLHttpRequest | respObj} response the response object (XHR or similar)
       */
      getResponseError(_, response) {
        let error = new Error('Upload error');

        if (isNetworkError_1(response)) {
          error = new NetworkError_1(error, response);
        }

        return error;
      },

      /**
       * Check if the response from the upload endpoint indicates that the upload was successful.
       *
       * @param {number} status the response status code
       */
      validateStatus(status) {
        return status >= 200 && status < 300;
      }

    };
    this.opts = { ...defaultOptions,
      ...opts
    };
    this.i18nInit();
    this.handleUpload = this.handleUpload.bind(this); // Simultaneous upload limiting is shared across all uploads with this plugin.

    if (internalRateLimitedQueue in this.opts) {
      this.requests = this.opts[internalRateLimitedQueue];
    } else {
      this.requests = new RateLimitedQueue(this.opts.limit);
    }

    if (this.opts.bundle && !this.opts.formData) {
      throw new Error('`opts.formData` must be true when `opts.bundle` is enabled.');
    }

    this.uploaderEvents = Object.create(null);
  }

  getOptions(file) {
    const overrides = this.uppy.getState().xhrUpload;
    const {
      headers
    } = this.opts;
    const opts = { ...this.opts,
      ...(overrides || {}),
      ...(file.xhrUpload || {}),
      headers: {}
    }; // Support for `headers` as a function, only in the XHRUpload settings.
    // Options set by other plugins in Uppy state or on the files themselves are still merged in afterward.
    //
    // ```js
    // headers: (file) => ({ expires: file.meta.expires })
    // ```

    if (typeof headers === 'function') {
      opts.headers = headers(file);
    } else {
      Object.assign(opts.headers, this.opts.headers);
    }

    if (overrides) {
      Object.assign(opts.headers, overrides.headers);
    }

    if (file.xhrUpload) {
      Object.assign(opts.headers, file.xhrUpload.headers);
    }

    return opts;
  } // eslint-disable-next-line class-methods-use-this


  addMetadata(formData, meta, opts) {
    const metaFields = Array.isArray(opts.metaFields) ? opts.metaFields : Object.keys(meta); // Send along all fields by default.

    metaFields.forEach(item => {
      formData.append(item, meta[item]);
    });
  }

  createFormDataUpload(file, opts) {
    const formPost = new FormData();
    this.addMetadata(formPost, file.meta, opts);
    const dataWithUpdatedType = setTypeInBlob(file);

    if (file.name) {
      formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
    } else {
      formPost.append(opts.fieldName, dataWithUpdatedType);
    }

    return formPost;
  }

  createBundledUpload(files, opts) {
    const formPost = new FormData();
    const {
      meta
    } = this.uppy.getState();
    this.addMetadata(formPost, meta, opts);
    files.forEach(file => {
      const options = this.getOptions(file);
      const dataWithUpdatedType = setTypeInBlob(file);

      if (file.name) {
        formPost.append(options.fieldName, dataWithUpdatedType, file.name);
      } else {
        formPost.append(options.fieldName, dataWithUpdatedType);
      }
    });
    return formPost;
  }

  upload(file, current, total) {
    const opts = this.getOptions(file);
    this.uppy.log(`uploading ${current} of ${total}`);
    return new Promise((resolve, reject) => {
      this.uppy.emit('upload-started', file);
      const data = opts.formData ? this.createFormDataUpload(file, opts) : file.data;
      const xhr = new XMLHttpRequest();
      this.uploaderEvents[file.id] = new EventTracker_1(this.uppy);
      const timer = new ProgressTimeout_1(opts.timeout, () => {
        xhr.abort();
        queuedRequest.done();
        const error = new Error(this.i18n('timedOut', {
          seconds: Math.ceil(opts.timeout / 1000)
        }));
        this.uppy.emit('upload-error', file, error);
        reject(error);
      });
      const id = nanoid();
      xhr.upload.addEventListener('loadstart', () => {
        this.uppy.log(`[XHRUpload] ${id} started`);
      });
      xhr.upload.addEventListener('progress', ev => {
        this.uppy.log(`[XHRUpload] ${id} progress: ${ev.loaded} / ${ev.total}`); // Begin checking for timeouts when progress starts, instead of loading,
        // to avoid timing out requests on browser concurrency queue

        timer.progress();

        if (ev.lengthComputable) {
          this.uppy.emit('upload-progress', file, {
            uploader: this,
            bytesUploaded: ev.loaded,
            bytesTotal: ev.total
          });
        }
      });
      xhr.addEventListener('load', ev => {
        this.uppy.log(`[XHRUpload] ${id} finished`);
        timer.done();
        queuedRequest.done();

        if (this.uploaderEvents[file.id]) {
          this.uploaderEvents[file.id].remove();
          this.uploaderEvents[file.id] = null;
        }

        if (opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
          const body = opts.getResponseData(xhr.responseText, xhr);
          const uploadURL = body[opts.responseUrlFieldName];
          const uploadResp = {
            status: ev.target.status,
            body,
            uploadURL
          };
          this.uppy.emit('upload-success', file, uploadResp);

          if (uploadURL) {
            this.uppy.log(`Download ${file.name} from ${uploadURL}`);
          }

          return resolve(file);
        }

        const body = opts.getResponseData(xhr.responseText, xhr);
        const error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
        const response = {
          status: ev.target.status,
          body
        };
        this.uppy.emit('upload-error', file, error, response);
        return reject(error);
      });
      xhr.addEventListener('error', () => {
        this.uppy.log(`[XHRUpload] ${id} errored`);
        timer.done();
        queuedRequest.done();

        if (this.uploaderEvents[file.id]) {
          this.uploaderEvents[file.id].remove();
          this.uploaderEvents[file.id] = null;
        }

        const error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
        this.uppy.emit('upload-error', file, error);
        return reject(error);
      });
      xhr.open(opts.method.toUpperCase(), opts.endpoint, true); // IE10 does not allow setting `withCredentials` and `responseType`
      // before `open()` is called.

      xhr.withCredentials = opts.withCredentials;

      if (opts.responseType !== '') {
        xhr.responseType = opts.responseType;
      }

      const queuedRequest = this.requests.run(() => {
        this.uppy.emit('upload-started', file); // When using an authentication system like JWT, the bearer token goes as a header. This
        // header needs to be fresh each time the token is refreshed so computing and setting the
        // headers just before the upload starts enables this kind of authentication to work properly.
        // Otherwise, half-way through the list of uploads the token could be stale and the upload would fail.

        const currentOpts = this.getOptions(file);
        Object.keys(currentOpts.headers).forEach(header => {
          xhr.setRequestHeader(header, currentOpts.headers[header]);
        });
        xhr.send(data);
        return () => {
          timer.done();
          xhr.abort();
        };
      });
      this.onFileRemove(file.id, () => {
        queuedRequest.abort();
        reject(new Error('File removed'));
      });
      this.onCancelAll(file.id, () => {
        queuedRequest.abort();
        reject(new Error('Upload cancelled'));
      });
    });
  }

  uploadRemote(file) {
    const opts = this.getOptions(file);
    return new Promise((resolve, reject) => {
      this.uppy.emit('upload-started', file);
      const fields = {};
      const metaFields = Array.isArray(opts.metaFields) ? opts.metaFields // Send along all fields by default.
      : Object.keys(file.meta);
      metaFields.forEach(name => {
        fields[name] = file.meta[name];
      });
      const Client = file.remote.providerOptions.provider ? Provider : RequestClient;
      const client = new Client(this.uppy, file.remote.providerOptions);
      client.post(file.remote.url, { ...file.remote.body,
        endpoint: opts.endpoint,
        size: file.data.size,
        fieldname: opts.fieldName,
        metadata: fields,
        httpMethod: opts.method,
        useFormData: opts.formData,
        headers: opts.headers
      }).then(res => {
        const {
          token
        } = res;
        const host = getSocketHost(file.remote.companionUrl);
        const socket = new Socket({
          target: `${host}/api/${token}`,
          autoOpen: false
        });
        this.uploaderEvents[file.id] = new EventTracker_1(this.uppy);
        this.onFileRemove(file.id, () => {
          socket.send('cancel', {});
          queuedRequest.abort();
          resolve(`upload ${file.id} was removed`);
        });
        this.onCancelAll(file.id, () => {
          socket.send('cancel', {});
          queuedRequest.abort();
          resolve(`upload ${file.id} was canceled`);
        });
        this.onRetry(file.id, () => {
          socket.send('pause', {});
          socket.send('resume', {});
        });
        this.onRetryAll(file.id, () => {
          socket.send('pause', {});
          socket.send('resume', {});
        });
        socket.on('progress', progressData => emitSocketProgress_1(this, progressData, file));
        socket.on('success', data => {
          const body = opts.getResponseData(data.response.responseText, data.response);
          const uploadURL = body[opts.responseUrlFieldName];
          const uploadResp = {
            status: data.response.status,
            body,
            uploadURL
          };
          this.uppy.emit('upload-success', file, uploadResp);
          queuedRequest.done();

          if (this.uploaderEvents[file.id]) {
            this.uploaderEvents[file.id].remove();
            this.uploaderEvents[file.id] = null;
          }

          return resolve();
        });
        socket.on('error', errData => {
          const resp = errData.response;
          const error = resp ? opts.getResponseError(resp.responseText, resp) : Object.assign(new Error(errData.error.message), {
            cause: errData.error
          });
          this.uppy.emit('upload-error', file, error);
          queuedRequest.done();

          if (this.uploaderEvents[file.id]) {
            this.uploaderEvents[file.id].remove();
            this.uploaderEvents[file.id] = null;
          }

          reject(error);
        });
        const queuedRequest = this.requests.run(() => {
          socket.open();

          if (file.isPaused) {
            socket.send('pause', {});
          }

          return () => socket.close();
        });
      }).catch(err => {
        this.uppy.emit('upload-error', file, err);
        reject(err);
      });
    });
  }

  uploadBundle(files) {
    return new Promise((resolve, reject) => {
      const {
        endpoint
      } = this.opts;
      const {
        method
      } = this.opts;
      const optsFromState = this.uppy.getState().xhrUpload;
      const formData = this.createBundledUpload(files, { ...this.opts,
        ...(optsFromState || {})
      });
      const xhr = new XMLHttpRequest();
      const timer = new ProgressTimeout_1(this.opts.timeout, () => {
        xhr.abort();
        const error = new Error(this.i18n('timedOut', {
          seconds: Math.ceil(this.opts.timeout / 1000)
        }));
        emitError(error);
        reject(error);
      });

      const emitError = error => {
        files.forEach(file => {
          this.uppy.emit('upload-error', file, error);
        });
      };

      xhr.upload.addEventListener('loadstart', () => {
        this.uppy.log('[XHRUpload] started uploading bundle');
        timer.progress();
      });
      xhr.upload.addEventListener('progress', ev => {
        timer.progress();
        if (!ev.lengthComputable) return;
        files.forEach(file => {
          this.uppy.emit('upload-progress', file, {
            uploader: this,
            bytesUploaded: ev.loaded / ev.total * file.size,
            bytesTotal: file.size
          });
        });
      });
      xhr.addEventListener('load', ev => {
        timer.done();

        if (this.opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
          const body = this.opts.getResponseData(xhr.responseText, xhr);
          const uploadResp = {
            status: ev.target.status,
            body
          };
          files.forEach(file => {
            this.uppy.emit('upload-success', file, uploadResp);
          });
          return resolve();
        }

        const error = this.opts.getResponseError(xhr.responseText, xhr) || new Error('Upload error');
        error.request = xhr;
        emitError(error);
        return reject(error);
      });
      xhr.addEventListener('error', () => {
        timer.done();
        const error = this.opts.getResponseError(xhr.responseText, xhr) || new Error('Upload error');
        emitError(error);
        return reject(error);
      });
      this.uppy.on('cancel-all', () => {
        timer.done();
        xhr.abort();
      });
      xhr.open(method.toUpperCase(), endpoint, true); // IE10 does not allow setting `withCredentials` and `responseType`
      // before `open()` is called.

      xhr.withCredentials = this.opts.withCredentials;

      if (this.opts.responseType !== '') {
        xhr.responseType = this.opts.responseType;
      }

      Object.keys(this.opts.headers).forEach(header => {
        xhr.setRequestHeader(header, this.opts.headers[header]);
      });
      xhr.send(formData);
      files.forEach(file => {
        this.uppy.emit('upload-started', file);
      });
    });
  }

  uploadFiles(files) {
    const promises = files.map((file, i) => {
      const current = parseInt(i, 10) + 1;
      const total = files.length;

      if (file.error) {
        return Promise.reject(new Error(file.error));
      }

      if (file.isRemote) {
        return this.uploadRemote(file, current, total);
      }

      return this.upload(file, current, total);
    });
    return settle(promises);
  }

  onFileRemove(fileID, cb) {
    this.uploaderEvents[fileID].on('file-removed', file => {
      if (fileID === file.id) cb(file.id);
    });
  }

  onRetry(fileID, cb) {
    this.uploaderEvents[fileID].on('upload-retry', targetFileID => {
      if (fileID === targetFileID) {
        cb();
      }
    });
  }

  onRetryAll(fileID, cb) {
    this.uploaderEvents[fileID].on('retry-all', () => {
      if (!this.uppy.getFile(fileID)) return;
      cb();
    });
  }

  onCancelAll(fileID, cb) {
    this.uploaderEvents[fileID].on('cancel-all', () => {
      if (!this.uppy.getFile(fileID)) return;
      cb();
    });
  }

  handleUpload(fileIDs) {
    if (fileIDs.length === 0) {
      this.uppy.log('[XHRUpload] No files to upload!');
      return Promise.resolve();
    } // No limit configured by the user, and no RateLimitedQueue passed in by a "parent" plugin
    // (basically just AwsS3) using the internal symbol


    if (this.opts.limit === 0 && !this.opts[internalRateLimitedQueue]) {
      this.uppy.log('[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0', 'warning');
    }

    this.uppy.log('[XHRUpload] Uploading...');
    const files = fileIDs.map(fileID => this.uppy.getFile(fileID));

    if (this.opts.bundle) {
      // if bundle: true, we don’t support remote uploads
      const isSomeFileRemote = files.some(file => file.isRemote);

      if (isSomeFileRemote) {
        throw new Error('Can’t upload remote files when the `bundle: true` option is set');
      }

      if (typeof this.opts.headers === 'function') {
        throw new TypeError('`headers` may not be a function when the `bundle: true` option is set');
      }

      return this.uploadBundle(files);
    }

    return this.uploadFiles(files).then(() => null);
  }

  install() {
    if (this.opts.bundle) {
      const {
        capabilities
      } = this.uppy.getState();
      this.uppy.setState({
        capabilities: { ...capabilities,
          individualCancellation: false
        }
      });
    }

    this.uppy.addUploader(this.handleUpload);
  }

  uninstall() {
    if (this.opts.bundle) {
      const {
        capabilities
      } = this.uppy.getState();
      this.uppy.setState({
        capabilities: { ...capabilities,
          individualCancellation: true
        }
      });
    }

    this.uppy.removeUploader(this.handleUpload);
  }

}, _class.VERSION = "2.0.6", _temp);

var ne$6="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function re$6(e){var t={exports:{}};return e(t,t.exports),t.exports}var oe$6,ie$6,ae$6=function(e){return e&&e.Math==Math&&e},se$6=ae$6("object"==typeof globalThis&&globalThis)||ae$6("object"==typeof window&&window)||ae$6("object"==typeof self&&self)||ae$6("object"==typeof ne$6&&ne$6)||function(){return this}()||Function("return this")(),le$6=Object.defineProperty,ue$6=function(e,t){try{le$6(se$6,e,{value:t,configurable:!0,writable:!0});}catch(n){se$6[e]=t;}return t},ce$6=se$6["__core-js_shared__"]||ue$6("__core-js_shared__",{}),fe$6=re$6((function(e){(e.exports=function(e,t){return ce$6[e]||(ce$6[e]=void 0!==t?t:{})})("versions",[]).push({version:"3.19.3",mode:"global",copyright:"© 2021 Denis Pushkarev (zloirock.ru)"});})),de$6=Function.prototype,he$6=de$6.bind,pe$6=de$6.call,ge$6=he$6&&he$6.bind(pe$6),ve$6=he$6?function(e){return e&&ge$6(pe$6,e)}:function(e){return e&&function(){return pe$6.apply(e,arguments)}},ye$6=se$6.TypeError,me$6=function(e){if(null==e)throw ye$6("Can't call method on "+e);return e},be$6=se$6.Object,we$6=function(e){return be$6(me$6(e))},xe$6=ve$6({}.hasOwnProperty),Se$6=Object.hasOwn||function(e,t){return xe$6(we$6(e),t)},ke$6=0,Ee$6=Math.random(),Oe$6=ve$6(1..toString),Ce$6=function(e){return "Symbol("+(void 0===e?"":e)+")_"+Oe$6(++ke$6+Ee$6,36)},Ne$6=function(e){return "function"==typeof e},Te$6=function(e){return Ne$6(e)?e:void 0},Le$6=function(e,t){return arguments.length<2?Te$6(se$6[e]):se$6[e]&&se$6[e][t]},Me$6=Le$6("navigator","userAgent")||"",Pe$6=se$6.process,De$6=se$6.Deno,Re$6=Pe$6&&Pe$6.versions||De$6&&De$6.version,je$6=Re$6&&Re$6.v8;je$6&&(ie$6=(oe$6=je$6.split("."))[0]>0&&oe$6[0]<4?1:+(oe$6[0]+oe$6[1])),!ie$6&&Me$6&&(!(oe$6=Me$6.match(/Edge\/(\d+)/))||oe$6[1]>=74)&&(oe$6=Me$6.match(/Chrome\/(\d+)/))&&(ie$6=+oe$6[1]);var Ae$6=ie$6,Fe$6=function(e){try{return !!e()}catch(e){return !0}},Ie$6=!!Object.getOwnPropertySymbols&&!Fe$6((function(){var e=Symbol();return !String(e)||!(Object(e)instanceof Symbol)||!Symbol.sham&&Ae$6&&Ae$6<41})),_e$6=Ie$6&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,Be$6=fe$6("wks"),$e$6=se$6.Symbol,We$6=$e$6&&$e$6.for,Ve$6=_e$6?$e$6:$e$6&&$e$6.withoutSetter||Ce$6,ze$6=function(e){if(!Se$6(Be$6,e)||!Ie$6&&"string"!=typeof Be$6[e]){var t="Symbol."+e;Ie$6&&Se$6($e$6,e)?Be$6[e]=$e$6[e]:Be$6[e]=_e$6&&We$6?We$6(t):Ve$6(t);}return Be$6[e]},He$6={};He$6[ze$6("toStringTag")]="z";var Ue$6="[object z]"===String(He$6),Ke$6=!Fe$6((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),qe$6=function(e){return "object"==typeof e?null!==e:Ne$6(e)},Ge$6=se$6.document,Je$6=qe$6(Ge$6)&&qe$6(Ge$6.createElement),Ye$6=function(e){return Je$6?Ge$6.createElement(e):{}},Xe$6=!Ke$6&&!Fe$6((function(){return 7!=Object.defineProperty(Ye$6("div"),"a",{get:function(){return 7}}).a})),Qe$6=se$6.String,Ze$6=se$6.TypeError,et$6=function(e){if(qe$6(e))return e;throw Ze$6(Qe$6(e)+" is not an object")},tt$6=Function.prototype.call,nt$6=tt$6.bind?tt$6.bind(tt$6):function(){return tt$6.apply(tt$6,arguments)},rt$6=ve$6({}.isPrototypeOf),ot$6=se$6.Object,it$6=_e$6?function(e){return "symbol"==typeof e}:function(e){var t=Le$6("Symbol");return Ne$6(t)&&rt$6(t.prototype,ot$6(e))},at$6=se$6.String,st$6=function(e){try{return at$6(e)}catch(e){return "Object"}},lt$6=se$6.TypeError,ut$6=function(e){if(Ne$6(e))return e;throw lt$6(st$6(e)+" is not a function")},ct$6=function(e,t){var n=e[t];return null==n?void 0:ut$6(n)},ft$6=se$6.TypeError,dt$6=se$6.TypeError,ht$6=ze$6("toPrimitive"),pt$6=function(e,t){if(!qe$6(e)||it$6(e))return e;var n,r=ct$6(e,ht$6);if(r){if(void 0===t&&(t="default"),n=nt$6(r,e,t),!qe$6(n)||it$6(n))return n;throw dt$6("Can't convert object to primitive value")}return void 0===t&&(t="number"),function(e,t){var n,r;if("string"===t&&Ne$6(n=e.toString)&&!qe$6(r=nt$6(n,e)))return r;if(Ne$6(n=e.valueOf)&&!qe$6(r=nt$6(n,e)))return r;if("string"!==t&&Ne$6(n=e.toString)&&!qe$6(r=nt$6(n,e)))return r;throw ft$6("Can't convert object to primitive value")}(e,t)},gt$6=function(e){var t=pt$6(e,"string");return it$6(t)?t:t+""},vt$6=se$6.TypeError,yt$6=Object.defineProperty,mt$6={f:Ke$6?yt$6:function(e,t,n){if(et$6(e),t=gt$6(t),et$6(n),Xe$6)try{return yt$6(e,t,n)}catch(e){}if("get"in n||"set"in n)throw vt$6("Accessors not supported");return "value"in n&&(e[t]=n.value),e}},bt$6=function(e,t){return {enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}},wt$6=Ke$6?function(e,t,n){return mt$6.f(e,t,bt$6(1,n))}:function(e,t,n){return e[t]=n,e},xt$6=ve$6(Function.toString);Ne$6(ce$6.inspectSource)||(ce$6.inspectSource=function(e){return xt$6(e)});var St$6,kt$6,Et$6,Ot$6=ce$6.inspectSource,Ct$6=se$6.WeakMap,Nt$6=Ne$6(Ct$6)&&/native code/.test(Ot$6(Ct$6)),Tt$6=fe$6("keys"),Lt$6=function(e){return Tt$6[e]||(Tt$6[e]=Ce$6(e))},Mt$6={},Pt$6=se$6.TypeError,Dt$6=se$6.WeakMap;if(Nt$6||ce$6.state){var Rt$6=ce$6.state||(ce$6.state=new Dt$6),jt$6=ve$6(Rt$6.get),At$6=ve$6(Rt$6.has),Ft$6=ve$6(Rt$6.set);St$6=function(e,t){if(At$6(Rt$6,e))throw new Pt$6("Object already initialized");return t.facade=e,Ft$6(Rt$6,e,t),t},kt$6=function(e){return jt$6(Rt$6,e)||{}},Et$6=function(e){return At$6(Rt$6,e)};}else {var It$6=Lt$6("state");Mt$6[It$6]=!0,St$6=function(e,t){if(Se$6(e,It$6))throw new Pt$6("Object already initialized");return t.facade=e,wt$6(e,It$6,t),t},kt$6=function(e){return Se$6(e,It$6)?e[It$6]:{}},Et$6=function(e){return Se$6(e,It$6)};}var _t$6={set:St$6,get:kt$6,has:Et$6,enforce:function(e){return Et$6(e)?kt$6(e):St$6(e,{})},getterFor:function(e){return function(t){var n;if(!qe$6(t)||(n=kt$6(t)).type!==e)throw Pt$6("Incompatible receiver, "+e+" required");return n}}},Bt$6=Function.prototype,$t$6=Ke$6&&Object.getOwnPropertyDescriptor,Wt$6=Se$6(Bt$6,"name"),Vt$6={EXISTS:Wt$6,PROPER:Wt$6&&"something"===function(){}.name,CONFIGURABLE:Wt$6&&(!Ke$6||Ke$6&&$t$6(Bt$6,"name").configurable)},zt$6=re$6((function(e){var t=Vt$6.CONFIGURABLE,n=_t$6.get,r=_t$6.enforce,o=String(String).split("String");(e.exports=function(e,n,i,a){var s,l=!!a&&!!a.unsafe,u=!!a&&!!a.enumerable,c=!!a&&!!a.noTargetGet,f=a&&void 0!==a.name?a.name:n;Ne$6(i)&&("Symbol("===String(f).slice(0,7)&&(f="["+String(f).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!Se$6(i,"name")||t&&i.name!==f)&&wt$6(i,"name",f),(s=r(i)).source||(s.source=o.join("string"==typeof f?f:""))),e!==se$6?(l?!c&&e[n]&&(u=!0):delete e[n],u?e[n]=i:wt$6(e,n,i)):u?e[n]=i:ue$6(n,i);})(Function.prototype,"toString",(function(){return Ne$6(this)&&n(this).source||Ot$6(this)}));})),Ht$6=ve$6({}.toString),Ut$6=ve$6("".slice),Kt$6=function(e){return Ut$6(Ht$6(e),8,-1)},qt$6=ze$6("toStringTag"),Gt$6=se$6.Object,Jt$6="Arguments"==Kt$6(function(){return arguments}()),Yt$6=Ue$6?Kt$6:function(e){var t,n,r;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=function(e,t){try{return e[t]}catch(e){}}(t=Gt$6(e),qt$6))?n:Jt$6?Kt$6(t):"Object"==(r=Kt$6(t))&&Ne$6(t.callee)?"Arguments":r},Xt$6=Ue$6?{}.toString:function(){return "[object "+Yt$6(this)+"]"};Ue$6||zt$6(Object.prototype,"toString",Xt$6,{unsafe:!0});var Qt$6={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},Zt$6=Ye$6("span").classList,en$6=Zt$6&&Zt$6.constructor&&Zt$6.constructor.prototype,tn$6=en$6===Object.prototype?void 0:en$6,nn$6=ve$6(ve$6.bind),rn$6=function(e,t){return ut$6(e),void 0===t?e:nn$6?nn$6(e,t):function(){return e.apply(t,arguments)}},on$6=se$6.Object,an$6=ve$6("".split),sn$6=Fe$6((function(){return !on$6("z").propertyIsEnumerable(0)}))?function(e){return "String"==Kt$6(e)?an$6(e,""):on$6(e)}:on$6,ln$6=Math.ceil,un$6=Math.floor,cn$6=function(e){var t=+e;return t!=t||0===t?0:(t>0?un$6:ln$6)(t)},fn$6=Math.min,dn$6=function(e){return e>0?fn$6(cn$6(e),9007199254740991):0},hn$6=function(e){return dn$6(e.length)},pn$6=Array.isArray||function(e){return "Array"==Kt$6(e)},gn$6=function(){},vn$6=[],yn$6=Le$6("Reflect","construct"),mn$6=/^\s*(?:class|function)\b/,bn$6=ve$6(mn$6.exec),wn$6=!mn$6.exec(gn$6),xn$6=function(e){if(!Ne$6(e))return !1;try{return yn$6(gn$6,vn$6,e),!0}catch(e){return !1}},Sn$6=!yn$6||Fe$6((function(){var e;return xn$6(xn$6.call)||!xn$6(Object)||!xn$6((function(){e=!0;}))||e}))?function(e){if(!Ne$6(e))return !1;switch(Yt$6(e)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return !1}return wn$6||!!bn$6(mn$6,Ot$6(e))}:xn$6,kn$6=ze$6("species"),En$6=se$6.Array,On$6=function(e,t){return new(function(e){var t;return pn$6(e)&&(t=e.constructor,(Sn$6(t)&&(t===En$6||pn$6(t.prototype))||qe$6(t)&&null===(t=t[kn$6]))&&(t=void 0)),void 0===t?En$6:t}(e))(0===t?0:t)},Cn$6=ve$6([].push),Nn$6=function(e){var t=1==e,n=2==e,r=3==e,o=4==e,i=6==e,a=7==e,s=5==e||i;return function(l,u,c,f){for(var d,h,p=we$6(l),g=sn$6(p),v=rn$6(u,c),y=hn$6(g),m=0,b=f||On$6,w=t?b(l,y):n||a?b(l,0):void 0;y>m;m++)if((s||m in g)&&(h=v(d=g[m],m,p),e))if(t)w[m]=h;else if(h)switch(e){case 3:return !0;case 5:return d;case 6:return m;case 2:Cn$6(w,d);}else switch(e){case 4:return !1;case 7:Cn$6(w,d);}return i?-1:r||o?o:w}},Tn$6={forEach:Nn$6(0),map:Nn$6(1),filter:Nn$6(2),some:Nn$6(3),every:Nn$6(4),find:Nn$6(5),findIndex:Nn$6(6),filterReject:Nn$6(7)},Ln$6=function(e,t){var n=[][e];return !!n&&Fe$6((function(){n.call(null,t||function(){throw 1},1);}))},Mn$6=Tn$6.forEach,Pn$6=Ln$6("forEach")?[].forEach:function(e){return Mn$6(this,e,arguments.length>1?arguments[1]:void 0)},Dn$6=function(e){if(e&&e.forEach!==Pn$6)try{wt$6(e,"forEach",Pn$6);}catch(t){e.forEach=Pn$6;}};for(var Rn$6 in Qt$6)Qt$6[Rn$6]&&Dn$6(se$6[Rn$6]&&se$6[Rn$6].prototype);Dn$6(tn$6);var jn$6={}.propertyIsEnumerable,An$6=Object.getOwnPropertyDescriptor,Fn$6=An$6&&!jn$6.call({1:2},1)?function(e){var t=An$6(this,e);return !!t&&t.enumerable}:jn$6,In$6={f:Fn$6},_n$6=function(e){return sn$6(me$6(e))},Bn$6=Object.getOwnPropertyDescriptor,$n$6={f:Ke$6?Bn$6:function(e,t){if(e=_n$6(e),t=gt$6(t),Xe$6)try{return Bn$6(e,t)}catch(e){}if(Se$6(e,t))return bt$6(!nt$6(In$6.f,e,t),e[t])}},Wn$6=Math.max,Vn$6=Math.min,zn$6=function(e,t){var n=cn$6(e);return n<0?Wn$6(n+t,0):Vn$6(n,t)},Hn$6=function(e){return function(t,n,r){var o,i=_n$6(t),a=hn$6(i),s=zn$6(r,a);if(e&&n!=n){for(;a>s;)if((o=i[s++])!=o)return !0}else for(;a>s;s++)if((e||s in i)&&i[s]===n)return e||s||0;return !e&&-1}},Un$6={includes:Hn$6(!0),indexOf:Hn$6(!1)},Kn$6=Un$6.indexOf,qn$6=ve$6([].push),Gn$6=function(e,t){var n,r=_n$6(e),o=0,i=[];for(n in r)!Se$6(Mt$6,n)&&Se$6(r,n)&&qn$6(i,n);for(;t.length>o;)Se$6(r,n=t[o++])&&(~Kn$6(i,n)||qn$6(i,n));return i},Jn$6=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],Yn$6=Jn$6.concat("length","prototype"),Xn$6={f:Object.getOwnPropertyNames||function(e){return Gn$6(e,Yn$6)}},Qn$6={f:Object.getOwnPropertySymbols},Zn$6=ve$6([].concat),er$5=Le$6("Reflect","ownKeys")||function(e){var t=Xn$6.f(et$6(e)),n=Qn$6.f;return n?Zn$6(t,n(e)):t},tr$5=function(e,t){for(var n=er$5(t),r=mt$6.f,o=$n$6.f,i=0;i<n.length;i++){var a=n[i];Se$6(e,a)||r(e,a,o(t,a));}},nr$5=/#|\.prototype\./,rr$5=function(e,t){var n=ir$5[or$5(e)];return n==sr$5||n!=ar$5&&(Ne$6(t)?Fe$6(t):!!t)},or$5=rr$5.normalize=function(e){return String(e).replace(nr$5,".").toLowerCase()},ir$5=rr$5.data={},ar$5=rr$5.NATIVE="N",sr$5=rr$5.POLYFILL="P",lr$5=rr$5,ur$5=$n$6.f,cr$5=function(e,t){var n,r,o,i,a,s=e.target,l=e.global,u=e.stat;if(n=l?se$6:u?se$6[s]||ue$6(s,{}):(se$6[s]||{}).prototype)for(r in t){if(i=t[r],o=e.noTargetGet?(a=ur$5(n,r))&&a.value:n[r],!lr$5(l?r:s+(u?".":"#")+r,e.forced)&&void 0!==o){if(typeof i==typeof o)continue;tr$5(i,o);}(e.sham||o&&o.sham)&&wt$6(i,"sham",!0),zt$6(n,r,i,e);}},fr$5=Object.keys||function(e){return Gn$6(e,Jn$6)},dr$5=Fe$6((function(){fr$5(1);}));
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function hr$5(e){return "[object Object]"===Object.prototype.toString.call(e)}cr$5({target:"Object",stat:!0,forced:dr$5},{keys:function(e){return fr$5(we$6(e))}});var pr$5={isHistory(e){return !1!==hr$5(n=e)&&(void 0===(r=n.constructor)||!1!==hr$5(o=r.prototype)&&!1!==o.hasOwnProperty("isPrototypeOf"))&&Array.isArray(e.redos)&&Array.isArray(e.undos)&&(0===e.redos.length||Operation.isOperationList(e.redos[0]))&&(0===e.undos.length||Operation.isOperationList(e.undos[0]));var n,r,o;}},gr$5=new WeakMap,vr$5=new WeakMap,yr$5={isHistoryEditor:t=>pr$5.isHistory(t.history)&&Editor.isEditor(t),isMerging:e=>vr$5.get(e),isSaving:e=>gr$5.get(e),redo(e){e.redo();},undo(e){e.undo();},withoutMerging(e,t){var n=yr$5.isMerging(e);vr$5.set(e,!1),t(),vr$5.set(e,n);},withoutSaving(e,t){var n=yr$5.isSaving(e);gr$5.set(e,!1),t(),gr$5.set(e,n);}},mr$5=(e,t)=>"set_selection"===e.type||(!(!t||"insert_text"!==e.type||"insert_text"!==t.type||e.offset!==t.offset+t.text.length||!Path.equals(e.path,t.path))||!(!t||"remove_text"!==e.type||"remove_text"!==t.type||e.offset+e.text.length!==t.offset||!Path.equals(e.path,t.path))),br$5=(e,t)=>"set_selection"!==e.type||null!=e.properties&&null!=e.newProperties,wr$5=(e,t)=>!(!t||"set_selection"!==e.type||"set_selection"!==t.type),xr$5=e=>"set_selection"!==e.type,Sr$5=se$6.String,kr$5=function(e){if("Symbol"===Yt$6(e))throw TypeError("Cannot convert a Symbol value to a string");return Sr$5(e)},Er$5=function(){var e=et$6(this),t="";return e.global&&(t+="g"),e.ignoreCase&&(t+="i"),e.multiline&&(t+="m"),e.dotAll&&(t+="s"),e.unicode&&(t+="u"),e.sticky&&(t+="y"),t},Or$5=Vt$6.PROPER,Cr$5=RegExp.prototype,Nr$5=Cr$5.toString,Tr$5=ve$6(Er$5),Lr$5=Fe$6((function(){return "/a/b"!=Nr$5.call({source:"a",flags:"b"})})),Mr$5=Or$5&&"toString"!=Nr$5.name;(Lr$5||Mr$5)&&zt$6(RegExp.prototype,"toString",(function(){var e=et$6(this),t=kr$5(e.source),n=e.flags;return "/"+t+"/"+kr$5(void 0===n&&rt$6(Cr$5,e)&&!("flags"in Cr$5)?Tr$5(e):n)}),{unsafe:!0});var Pr$5,Dr$5=Ke$6?Object.defineProperties:function(e,t){et$6(e);for(var n,r=_n$6(t),o=fr$5(t),i=o.length,a=0;i>a;)mt$6.f(e,n=o[a++],r[n]);return e},Rr$5=Le$6("document","documentElement"),jr$5=Lt$6("IE_PROTO"),Ar$5=function(){},Fr$5=function(e){return "<script>"+e+"<\/script>"},Ir$5=function(e){e.write(Fr$5("")),e.close();var t=e.parentWindow.Object;return e=null,t},_r$5=function(){try{Pr$5=new ActiveXObject("htmlfile");}catch(e){}var e,t;_r$5="undefined"!=typeof document?document.domain&&Pr$5?Ir$5(Pr$5):((t=Ye$6("iframe")).style.display="none",Rr$5.appendChild(t),t.src=String("javascript:"),(e=t.contentWindow.document).open(),e.write(Fr$5("document.F=Object")),e.close(),e.F):Ir$5(Pr$5);for(var n=Jn$6.length;n--;)delete _r$5.prototype[Jn$6[n]];return _r$5()};Mt$6[jr$5]=!0;var Br$5=Object.create||function(e,t){var n;return null!==e?(Ar$5.prototype=et$6(e),n=new Ar$5,Ar$5.prototype=null,n[jr$5]=e):n=_r$5(),void 0===t?n:Dr$5(n,t)},$r$5=ze$6("unscopables"),Wr$5=Array.prototype;null==Wr$5[$r$5]&&mt$6.f(Wr$5,$r$5,{configurable:!0,value:Br$5(null)});var Vr$5=function(e){Wr$5[$r$5][e]=!0;},zr$5=Un$6.includes;cr$5({target:"Array",proto:!0},{includes:function(e){return zr$5(this,e,arguments.length>1?arguments[1]:void 0)}}),Vr$5("includes");var Hr$5=ze$6("match"),Ur$5=function(e){var t;return qe$6(e)&&(void 0!==(t=e[Hr$5])?!!t:"RegExp"==Kt$6(e))},Kr$5=se$6.TypeError,qr$5=function(e){if(Ur$5(e))throw Kr$5("The method doesn't accept regular expressions");return e},Gr$5=ze$6("match"),Jr$5=function(e){var t=/./;try{"/./"[e](t);}catch(n){try{return t[Gr$5]=!1,"/./"[e](t)}catch(e){}}return !1},Yr$5=ve$6("".indexOf);cr$5({target:"String",proto:!0,forced:!Jr$5("includes")},{includes:function(e){return !!~Yr$5(kr$5(me$6(this)),kr$5(qr$5(e)),arguments.length>1?arguments[1]:void 0)}});var Xr$5,Qr$5=/"/g,Zr$5=ve$6("".replace);cr$5({target:"String",proto:!0,forced:(Xr$5="anchor",Fe$6((function(){var e=""[Xr$5]('"');return e!==e.toLowerCase()||e.split('"').length>3})))},{anchor:function(e){return t="a",n="name",r=e,o=kr$5(me$6(this)),i="<"+t,""!==n&&(i+=" "+n+'="'+Zr$5(kr$5(r),Qr$5,"&quot;")+'"'),i+">"+o+"</"+t+">";var t,n,r,o,i;}});var eo$5=function(e,t,n){var r,o;et$6(e);try{if(!(r=ct$6(e,"return"))){if("throw"===t)throw n;return n}r=nt$6(r,e);}catch(e){o=!0,r=e;}if("throw"===t)throw n;if(o)throw r;return et$6(r),n},to$5=function(e,t,n,r){try{return r?t(et$6(n)[0],n[1]):t(n)}catch(t){eo$5(e,"throw",t);}},no$5={},ro$5=ze$6("iterator"),oo$5=Array.prototype,io$5=function(e){return void 0!==e&&(no$5.Array===e||oo$5[ro$5]===e)},ao$5=function(e,t,n){var r=gt$6(t);r in e?mt$6.f(e,r,bt$6(0,n)):e[r]=n;},so$5=ze$6("iterator"),lo$5=function(e){if(null!=e)return ct$6(e,so$5)||ct$6(e,"@@iterator")||no$5[Yt$6(e)]},uo$5=se$6.TypeError,co$5=function(e,t){var n=arguments.length<2?lo$5(e):t;if(ut$6(n))return et$6(nt$6(n,e));throw uo$5(st$6(e)+" is not iterable")},fo$5=se$6.Array,ho$5=ze$6("iterator"),po$5=!1;try{var go$5=0,vo$5={next:function(){return {done:!!go$5++}},return:function(){po$5=!0;}};vo$5[ho$5]=function(){return this},Array.from(vo$5,(function(){throw 2}));}catch(e){}var yo$5=function(e,t){if(!t&&!po$5)return !1;var n=!1;try{var r={};r[ho$5]=function(){return {next:function(){return {done:n=!0}}}},e(r);}catch(e){}return n},mo$5=!yo$5((function(e){Array.from(e);}));cr$5({target:"Array",stat:!0,forced:mo$5},{from:function(e){var t=we$6(e),n=Sn$6(this),r=arguments.length,o=r>1?arguments[1]:void 0,i=void 0!==o;i&&(o=rn$6(o,r>2?arguments[2]:void 0));var a,s,l,u,c,f,d=lo$5(t),h=0;if(!d||this==fo$5&&io$5(d))for(a=hn$6(t),s=n?new this(a):fo$5(a);a>h;h++)f=i?o(t[h],h):t[h],ao$5(s,h,f);else for(c=(u=co$5(t,d)).next,s=n?new this:[];!(l=nt$6(c,u)).done;h++)f=i?to$5(u,o,[l.value,h],!0):l.value,ao$5(s,h,f);return s.length=h,s}});var bo$5,wo$5,xo$5,So$5=ve$6("".charAt),ko$5=ve$6("".charCodeAt),Eo$5=ve$6("".slice),Oo$5=function(e){return function(t,n){var r,o,i=kr$5(me$6(t)),a=cn$6(n),s=i.length;return a<0||a>=s?e?"":void 0:(r=ko$5(i,a))<55296||r>56319||a+1===s||(o=ko$5(i,a+1))<56320||o>57343?e?So$5(i,a):r:e?Eo$5(i,a,a+2):o-56320+(r-55296<<10)+65536}},Co$5={codeAt:Oo$5(!1),charAt:Oo$5(!0)},No$5=!Fe$6((function(){function e(){}return e.prototype.constructor=null,Object.getPrototypeOf(new e)!==e.prototype})),To$5=Lt$6("IE_PROTO"),Lo$5=se$6.Object,Mo$5=Lo$5.prototype,Po$5=No$5?Lo$5.getPrototypeOf:function(e){var t=we$6(e);if(Se$6(t,To$5))return t[To$5];var n=t.constructor;return Ne$6(n)&&t instanceof n?n.prototype:t instanceof Lo$5?Mo$5:null},Do$5=ze$6("iterator"),Ro$5=!1;[].keys&&("next"in(xo$5=[].keys())?(wo$5=Po$5(Po$5(xo$5)))!==Object.prototype&&(bo$5=wo$5):Ro$5=!0);var jo$5=null==bo$5||Fe$6((function(){var e={};return bo$5[Do$5].call(e)!==e}));jo$5&&(bo$5={}),Ne$6(bo$5[Do$5])||zt$6(bo$5,Do$5,(function(){return this}));var Ao$5={IteratorPrototype:bo$5,BUGGY_SAFARI_ITERATORS:Ro$5},Fo$5=mt$6.f,Io$5=ze$6("toStringTag"),_o$5=function(e,t,n){e&&!Se$6(e=n?e:e.prototype,Io$5)&&Fo$5(e,Io$5,{configurable:!0,value:t});},Bo$5=Ao$5.IteratorPrototype,$o$5=function(){return this},Wo$5=se$6.String,Vo$5=se$6.TypeError,zo$5=Object.setPrototypeOf||("__proto__"in{}?function(){var e,t=!1,n={};try{(e=ve$6(Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set))(n,[]),t=n instanceof Array;}catch(e){}return function(n,r){return et$6(n),function(e){if("object"==typeof e||Ne$6(e))return e;throw Vo$5("Can't set "+Wo$5(e)+" as a prototype")}(r),t?e(n,r):n.__proto__=r,n}}():void 0),Ho$5=Vt$6.PROPER,Uo$5=Vt$6.CONFIGURABLE,Ko$5=Ao$5.IteratorPrototype,qo$5=Ao$5.BUGGY_SAFARI_ITERATORS,Go$5=ze$6("iterator"),Jo$5=function(){return this},Yo$5=function(e,t,n,r,o,i,a){!function(e,t,n,r){var o=t+" Iterator";e.prototype=Br$5(Bo$5,{next:bt$6(+!r,n)}),_o$5(e,o,!1),no$5[o]=$o$5;}(n,t,r);var s,l,u,c=function(e){if(e===o&&g)return g;if(!qo$5&&e in h)return h[e];switch(e){case"keys":case"values":case"entries":return function(){return new n(this,e)}}return function(){return new n(this)}},f=t+" Iterator",d=!1,h=e.prototype,p=h[Go$5]||h["@@iterator"]||o&&h[o],g=!qo$5&&p||c(o),v="Array"==t&&h.entries||p;if(v&&(s=Po$5(v.call(new e)))!==Object.prototype&&s.next&&(Po$5(s)!==Ko$5&&(zo$5?zo$5(s,Ko$5):Ne$6(s[Go$5])||zt$6(s,Go$5,Jo$5)),_o$5(s,f,!0)),Ho$5&&"values"==o&&p&&"values"!==p.name&&(Uo$5?wt$6(h,"name","values"):(d=!0,g=function(){return nt$6(p,this)})),o)if(l={values:c("values"),keys:i?g:c("keys"),entries:c("entries")},a)for(u in l)(qo$5||d||!(u in h))&&zt$6(h,u,l[u]);else cr$5({target:t,proto:!0,forced:qo$5||d},l);return h[Go$5]!==g&&zt$6(h,Go$5,g,{name:o}),no$5[t]=g,l},Xo$5=Co$5.charAt,Qo$5=_t$6.set,Zo$5=_t$6.getterFor("String Iterator");Yo$5(String,"String",(function(e){Qo$5(this,{type:"String Iterator",string:kr$5(e),index:0});}),(function(){var e,t=Zo$5(this),n=t.string,r=t.index;return r>=n.length?{value:void 0,done:!0}:(e=Xo$5(n,r),t.index+=e.length,{value:e,done:!1})}));var ei$5,ti$5=$n$6.f,ni$5=ve$6("".endsWith),ri$5=ve$6("".slice),oi$5=Math.min,ii$5=Jr$5("endsWith"),ai$5=!(ii$5||(ei$5=ti$5(String.prototype,"endsWith"),!ei$5||ei$5.writable));cr$5({target:"String",proto:!0,forced:!ai$5&&!ii$5},{endsWith:function(e){var t=kr$5(me$6(this));qr$5(e);var n=arguments.length>1?arguments[1]:void 0,r=t.length,o=void 0===n?r:oi$5(dn$6(n),r),i=kr$5(e);return ni$5?ni$5(t,i,o):ri$5(t,o-i.length,o)===i}});var si$5=ve$6([].join),li$5=sn$6!=Object,ui$5=Ln$6("join",",");cr$5({target:"Array",proto:!0,forced:li$5||!ui$5},{join:function(e){return si$5(_n$6(this),void 0===e?",":e)}});var ci$5=ze$6("species"),fi$5=function(e){return Ae$6>=51||!Fe$6((function(){var t=[];return (t.constructor={})[ci$5]=function(){return {foo:1}},1!==t[e](Boolean).foo}))},di$5=Tn$6.map,hi$5=fi$5("map");cr$5({target:"Array",proto:!0,forced:!hi$5},{map:function(e){return di$5(this,e,arguments.length>1?arguments[1]:void 0)}});var pi$5=se$6.RegExp,gi$5=Fe$6((function(){var e=pi$5("a","y");return e.lastIndex=2,null!=e.exec("abcd")})),vi$5=gi$5||Fe$6((function(){return !pi$5("a","y").sticky})),yi$5={BROKEN_CARET:gi$5||Fe$6((function(){var e=pi$5("^r","gy");return e.lastIndex=2,null!=e.exec("str")})),MISSED_STICKY:vi$5,UNSUPPORTED_Y:gi$5},mi$4=se$6.RegExp,bi$4=Fe$6((function(){var e=mi$4(".","s");return !(e.dotAll&&e.exec("\n")&&"s"===e.flags)})),wi$4=se$6.RegExp,xi$4=Fe$6((function(){var e=wi$4("(?<a>b)","g");return "b"!==e.exec("b").groups.a||"bc"!=="b".replace(e,"$<a>c")})),Si$4=_t$6.get,ki$4=fe$6("native-string-replace",String.prototype.replace),Ei$4=RegExp.prototype.exec,Oi$4=Ei$4,Ci$4=ve$6("".charAt),Ni$4=ve$6("".indexOf),Ti$4=ve$6("".replace),Li$4=ve$6("".slice),Mi$4=function(){var e=/a/,t=/b*/g;return nt$6(Ei$4,e,"a"),nt$6(Ei$4,t,"a"),0!==e.lastIndex||0!==t.lastIndex}(),Pi$4=yi$5.BROKEN_CARET,Di$3=void 0!==/()??/.exec("")[1];(Mi$4||Di$3||Pi$4||bi$4||xi$4)&&(Oi$4=function(e){var t,n,r,o,i,a,s,l=this,u=Si$4(l),c=kr$5(e),f=u.raw;if(f)return f.lastIndex=l.lastIndex,t=nt$6(Oi$4,f,c),l.lastIndex=f.lastIndex,t;var d=u.groups,h=Pi$4&&l.sticky,p=nt$6(Er$5,l),g=l.source,v=0,y=c;if(h&&(p=Ti$4(p,"y",""),-1===Ni$4(p,"g")&&(p+="g"),y=Li$4(c,l.lastIndex),l.lastIndex>0&&(!l.multiline||l.multiline&&"\n"!==Ci$4(c,l.lastIndex-1))&&(g="(?: "+g+")",y=" "+y,v++),n=new RegExp("^(?:"+g+")",p)),Di$3&&(n=new RegExp("^"+g+"$(?!\\s)",p)),Mi$4&&(r=l.lastIndex),o=nt$6(Ei$4,h?n:l,y),h?o?(o.input=Li$4(o.input,v),o[0]=Li$4(o[0],v),o.index=l.lastIndex,l.lastIndex+=o[0].length):l.lastIndex=0:Mi$4&&o&&(l.lastIndex=l.global?o.index+o[0].length:r),Di$3&&o&&o.length>1&&nt$6(ki$4,o[0],n,(function(){for(i=1;i<arguments.length-2;i++)void 0===arguments[i]&&(o[i]=void 0);})),o&&d)for(o.groups=a=Br$5(null),i=0;i<d.length;i++)a[(s=d[i])[0]]=o[s[1]];return o});var Ri$4=Oi$4;cr$5({target:"RegExp",proto:!0,forced:/./.exec!==Ri$4},{exec:Ri$4});var ji$4=Function.prototype,Ai$4=ji$4.apply,Fi$4=ji$4.bind,Ii$4=ji$4.call,_i$4="object"==typeof Reflect&&Reflect.apply||(Fi$4?Ii$4.bind(Ai$4):function(){return Ii$4.apply(Ai$4,arguments)}),Bi$3=ze$6("species"),$i$3=RegExp.prototype,Wi$3=function(e,t,n,r){var o=ze$6(e),i=!Fe$6((function(){var t={};return t[o]=function(){return 7},7!=""[e](t)})),a=i&&!Fe$6((function(){var t=!1,n=/a/;return "split"===e&&((n={}).constructor={},n.constructor[Bi$3]=function(){return n},n.flags="",n[o]=/./[o]),n.exec=function(){return t=!0,null},n[o](""),!t}));if(!i||!a||n){var s=ve$6(/./[o]),l=t(o,""[e],(function(e,t,n,r,o){var a=ve$6(e),l=t.exec;return l===Ri$4||l===$i$3.exec?i&&!o?{done:!0,value:s(t,n,r)}:{done:!0,value:a(n,t,r)}:{done:!1}}));zt$6(String.prototype,e,l[0]),zt$6($i$3,o,l[1]);}r&&wt$6($i$3[o],"sham",!0);},Vi$3=Co$5.charAt,zi$4=function(e,t,n){return t+(n?Vi$3(e,t).length:1)},Hi$3=Math.floor,Ui$3=ve$6("".charAt),Ki$3=ve$6("".replace),qi$3=ve$6("".slice),Gi$3=/\$([$&'`]|\d{1,2}|<[^>]*>)/g,Ji$3=/\$([$&'`]|\d{1,2})/g,Yi$3=function(e,t,n,r,o,i){var a=n+e.length,s=r.length,l=Ji$3;return void 0!==o&&(o=we$6(o),l=Gi$3),Ki$3(i,l,(function(i,l){var u;switch(Ui$3(l,0)){case"$":return "$";case"&":return e;case"`":return qi$3(t,0,n);case"'":return qi$3(t,a);case"<":u=o[qi$3(l,1,-1)];break;default:var c=+l;if(0===c)return i;if(c>s){var f=Hi$3(c/10);return 0===f?i:f<=s?void 0===r[f-1]?Ui$3(l,1):r[f-1]+Ui$3(l,1):i}u=r[c-1];}return void 0===u?"":u}))},Xi$3=se$6.TypeError,Qi$3=function(e,t){var n=e.exec;if(Ne$6(n)){var r=nt$6(n,e,t);return null!==r&&et$6(r),r}if("RegExp"===Kt$6(e))return nt$6(Ri$4,e,t);throw Xi$3("RegExp#exec called on incompatible receiver")},Zi$3=ze$6("replace"),ea$4=Math.max,ta$4=Math.min,na$4=ve$6([].concat),ra$4=ve$6([].push),oa$4=ve$6("".indexOf),ia$4=ve$6("".slice),aa$4="$0"==="a".replace(/./,"$0"),sa$4=!!/./[Zi$3]&&""===/./[Zi$3]("a","$0");Wi$3("replace",(function(e,t,n){var r=sa$4?"$":"$0";return [function(e,n){var r=me$6(this),o=null==e?void 0:ct$6(e,Zi$3);return o?nt$6(o,e,r,n):nt$6(t,kr$5(r),e,n)},function(e,o){var i=et$6(this),a=kr$5(e);if("string"==typeof o&&-1===oa$4(o,r)&&-1===oa$4(o,"$<")){var s=n(t,i,a,o);if(s.done)return s.value}var l=Ne$6(o);l||(o=kr$5(o));var u=i.global;if(u){var c=i.unicode;i.lastIndex=0;}for(var f=[];;){var d=Qi$3(i,a);if(null===d)break;if(ra$4(f,d),!u)break;""===kr$5(d[0])&&(i.lastIndex=zi$4(a,dn$6(i.lastIndex),c));}for(var h,p="",g=0,v=0;v<f.length;v++){for(var y=kr$5((d=f[v])[0]),m=ea$4(ta$4(cn$6(d.index),a.length),0),b=[],w=1;w<d.length;w++)ra$4(b,void 0===(h=d[w])?h:String(h));var x=d.groups;if(l){var S=na$4([y],b,m,a);void 0!==x&&ra$4(S,x);var k=kr$5(_i$4(o,void 0,S));}else k=Yi$3(y,a,m,b,x,o);m>=g&&(p+=ia$4(a,g,m)+k,g=m+y.length);}return p+ia$4(a,g)}]}),!!Fe$6((function(){var e=/./;return e.exec=function(){var e=[];return e.groups={a:"7"},e},"7"!=="".replace(e,"$<a>")}))||!aa$4||sa$4);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var la$4=function(e,t){return la$4=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t;}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);},la$4(e,t)};function ua$4(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Class extends value "+String(t)+" is not a constructor or null");function n(){this.constructor=e;}la$4(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n);}var ca$4=function(){return ca$4=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},ca$4.apply(this,arguments)};function fa$4(e){var t="function"==typeof Symbol&&Symbol.iterator,n=t&&e[t],r=0;if(n)return n.call(e);if(e&&"number"==typeof e.length)return {next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")}function da$4(e,t){var n="function"==typeof Symbol&&e[Symbol.iterator];if(!n)return e;var r,o,i=n.call(e),a=[];try{for(;(void 0===t||t-- >0)&&!(r=i.next()).done;)a.push(r.value);}catch(e){o={error:e};}finally{try{r&&!r.done&&(n=i.return)&&n.call(i);}finally{if(o)throw o.error}}return a}function ha$3(e,t){for(var n=0,r=t.length,o=e.length;n<r;n++,o++)e[o]=t[n];return e}var pa$4=0,ga$3=function(){this.id=""+pa$4++;},va$4=_t$6.set,ya$3=_t$6.getterFor("Array Iterator"),ma$3=Yo$5(Array,"Array",(function(e,t){va$4(this,{type:"Array Iterator",target:_n$6(e),index:0,kind:t});}),(function(){var e=ya$3(this),t=e.target,n=e.kind,r=e.index++;return !t||r>=t.length?(e.target=void 0,{value:void 0,done:!0}):"keys"==n?{value:r,done:!1}:"values"==n?{value:t[r],done:!1}:{value:[r,t[r]],done:!1}}),"values");no$5.Arguments=no$5.Array,Vr$5("keys"),Vr$5("values"),Vr$5("entries");var ba$3=function(e,t,n){for(var r in t)zt$6(e,r,t[r],n);return e},wa$3=se$6.Array,xa$3=Math.max,Sa$3=function(e,t,n){for(var r=hn$6(e),o=zn$6(t,r),i=zn$6(void 0===n?r:n,r),a=wa$3(xa$3(i-o,0)),s=0;o<i;o++,s++)ao$5(a,s,e[o]);return a.length=s,a},ka$3=Xn$6.f,Ea$3="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],Oa$3={f:function(e){return Ea$3&&"Window"==Kt$6(e)?function(e){try{return ka$3(e)}catch(e){return Sa$3(Ea$3)}}(e):ka$3(_n$6(e))}},Ca$3=Fe$6((function(){if("function"==typeof ArrayBuffer){var e=new ArrayBuffer(8);Object.isExtensible(e)&&Object.defineProperty(e,"a",{value:8});}})),Na$3=Object.isExtensible,Ta$3=Fe$6((function(){Na$3(1);}))||Ca$3?function(e){return !!qe$6(e)&&((!Ca$3||"ArrayBuffer"!=Kt$6(e))&&(!Na$3||Na$3(e)))}:Na$3,La$3=!Fe$6((function(){return Object.isExtensible(Object.preventExtensions({}))})),Ma$3=re$6((function(e){var t=mt$6.f,n=!1,r=Ce$6("meta"),o=0,i=function(e){t(e,r,{value:{objectID:"O"+o++,weakData:{}}});},a=e.exports={enable:function(){a.enable=function(){},n=!0;var e=Xn$6.f,t=ve$6([].splice),o={};o[r]=1,e(o).length&&(Xn$6.f=function(n){for(var o=e(n),i=0,a=o.length;i<a;i++)if(o[i]===r){t(o,i,1);break}return o},cr$5({target:"Object",stat:!0,forced:!0},{getOwnPropertyNames:Oa$3.f}));},fastKey:function(e,t){if(!qe$6(e))return "symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!Se$6(e,r)){if(!Ta$3(e))return "F";if(!t)return "E";i(e);}return e[r].objectID},getWeakData:function(e,t){if(!Se$6(e,r)){if(!Ta$3(e))return !0;if(!t)return !1;i(e);}return e[r].weakData},onFreeze:function(e){return La$3&&n&&Ta$3(e)&&!Se$6(e,r)&&i(e),e}};Mt$6[r]=!0;})),Pa$3=se$6.TypeError,Da$3=function(e,t){this.stopped=e,this.result=t;},Ra$3=Da$3.prototype,ja$2=function(e,t,n){var r,o,i,a,s,l,u,c=n&&n.that,f=!(!n||!n.AS_ENTRIES),d=!(!n||!n.IS_ITERATOR),h=!(!n||!n.INTERRUPTED),p=rn$6(t,c),g=function(e){return r&&eo$5(r,"normal",e),new Da$3(!0,e)},v=function(e){return f?(et$6(e),h?p(e[0],e[1],g):p(e[0],e[1])):h?p(e,g):p(e)};if(d)r=e;else {if(!(o=lo$5(e)))throw Pa$3(st$6(e)+" is not iterable");if(io$5(o)){for(i=0,a=hn$6(e);a>i;i++)if((s=v(e[i]))&&rt$6(Ra$3,s))return s;return new Da$3(!1)}r=co$5(e,o);}for(l=r.next;!(u=nt$6(l,r)).done;){try{s=v(u.value);}catch(e){eo$5(r,"throw",e);}if("object"==typeof s&&s&&rt$6(Ra$3,s))return s}return new Da$3(!1)},Aa$3=se$6.TypeError,Fa$3=function(e,t){if(rt$6(t,e))return e;throw Aa$3("Incorrect invocation")},Ia$3=function(e,t,n){var r,o;return zo$5&&Ne$6(r=t.constructor)&&r!==n&&qe$6(o=r.prototype)&&o!==n.prototype&&zo$5(e,o),e},_a$3=function(e,t,n){var r=-1!==e.indexOf("Map"),o=-1!==e.indexOf("Weak"),i=r?"set":"add",a=se$6[e],s=a&&a.prototype,l=a,u={},c=function(e){var t=ve$6(s[e]);zt$6(s,e,"add"==e?function(e){return t(this,0===e?0:e),this}:"delete"==e?function(e){return !(o&&!qe$6(e))&&t(this,0===e?0:e)}:"get"==e?function(e){return o&&!qe$6(e)?void 0:t(this,0===e?0:e)}:"has"==e?function(e){return !(o&&!qe$6(e))&&t(this,0===e?0:e)}:function(e,n){return t(this,0===e?0:e,n),this});};if(lr$5(e,!Ne$6(a)||!(o||s.forEach&&!Fe$6((function(){(new a).entries().next();})))))l=n.getConstructor(t,e,r,i),Ma$3.enable();else if(lr$5(e,!0)){var f=new l,d=f[i](o?{}:-0,1)!=f,h=Fe$6((function(){f.has(1);})),p=yo$5((function(e){new a(e);})),g=!o&&Fe$6((function(){for(var e=new a,t=5;t--;)e[i](t,t);return !e.has(-0)}));p||((l=t((function(e,t){Fa$3(e,s);var n=Ia$3(new a,e,l);return null!=t&&ja$2(t,n[i],{that:n,AS_ENTRIES:r}),n}))).prototype=s,s.constructor=l),(h||g)&&(c("delete"),c("has"),r&&c("get")),(g||d)&&c(i),o&&s.clear&&delete s.clear;}return u[e]=l,cr$5({global:!0,forced:l!=a},u),_o$5(l,e),o||n.setStrong(l,e,r),l},Ba$3=Ma$3.getWeakData,$a$3=_t$6.set,Wa$2=_t$6.getterFor,Va$2=Tn$6.find,za$2=Tn$6.findIndex,Ha$2=ve$6([].splice),Ua$3=0,Ka$2=function(e){return e.frozen||(e.frozen=new qa$2)},qa$2=function(){this.entries=[];},Ga$2=function(e,t){return Va$2(e.entries,(function(e){return e[0]===t}))};qa$2.prototype={get:function(e){var t=Ga$2(this,e);if(t)return t[1]},has:function(e){return !!Ga$2(this,e)},set:function(e,t){var n=Ga$2(this,e);n?n[1]=t:this.entries.push([e,t]);},delete:function(e){var t=za$2(this.entries,(function(t){return t[0]===e}));return ~t&&Ha$2(this.entries,t,1),!!~t}};var Ja$2,Ya$2={getConstructor:function(e,t,n,r){var o=e((function(e,o){Fa$3(e,i),$a$3(e,{type:t,id:Ua$3++,frozen:void 0}),null!=o&&ja$2(o,e[r],{that:e,AS_ENTRIES:n});})),i=o.prototype,a=Wa$2(t),s=function(e,t,n){var r=a(e),o=Ba$3(et$6(t),!0);return !0===o?Ka$2(r).set(t,n):o[r.id]=n,e};return ba$3(i,{delete:function(e){var t=a(this);if(!qe$6(e))return !1;var n=Ba$3(e);return !0===n?Ka$2(t).delete(e):n&&Se$6(n,t.id)&&delete n[t.id]},has:function(e){var t=a(this);if(!qe$6(e))return !1;var n=Ba$3(e);return !0===n?Ka$2(t).has(e):n&&Se$6(n,t.id)}}),ba$3(i,n?{get:function(e){var t=a(this);if(qe$6(e)){var n=Ba$3(e);return !0===n?Ka$2(t).get(e):n?n[t.id]:void 0}},set:function(e,t){return s(this,e,t)}}:{add:function(e){return s(this,e,!0)}}),o}},Xa$2=_t$6.enforce,Qa$2=!se$6.ActiveXObject&&"ActiveXObject"in se$6,Za$1=function(e){return function(){return e(this,arguments.length?arguments[0]:void 0)}},es$1=_a$3("WeakMap",Za$1,Ya$2);if(Nt$6&&Qa$2){Ja$2=Ya$2.getConstructor(Za$1,"WeakMap",!0),Ma$3.enable();var ts$1=es$1.prototype,ns$1=ve$6(ts$1.delete),rs$1=ve$6(ts$1.has),os$1=ve$6(ts$1.get),is$1=ve$6(ts$1.set);ba$3(ts$1,{delete:function(e){if(qe$6(e)&&!Ta$3(e)){var t=Xa$2(this);return t.frozen||(t.frozen=new Ja$2),ns$1(this,e)||t.frozen.delete(e)}return ns$1(this,e)},has:function(e){if(qe$6(e)&&!Ta$3(e)){var t=Xa$2(this);return t.frozen||(t.frozen=new Ja$2),rs$1(this,e)||t.frozen.has(e)}return rs$1(this,e)},get:function(e){if(qe$6(e)&&!Ta$3(e)){var t=Xa$2(this);return t.frozen||(t.frozen=new Ja$2),rs$1(this,e)?os$1(this,e):t.frozen.get(e)}return os$1(this,e)},set:function(e,t){if(qe$6(e)&&!Ta$3(e)){var n=Xa$2(this);n.frozen||(n.frozen=new Ja$2),rs$1(this,e)?is$1(this,e,t):n.frozen.set(e,t);}else is$1(this,e,t);return this}});}var as$1=ze$6("iterator"),ss$1=ze$6("toStringTag"),ls$1=ma$3.values,us$1=function(e,t){if(e){if(e[as$1]!==ls$1)try{wt$6(e,as$1,ls$1);}catch(t){e[as$1]=ls$1;}if(e[ss$1]||wt$6(e,ss$1,t),Qt$6[t])for(var n in ma$3)if(e[n]!==ma$3[n])try{wt$6(e,n,ma$3[n]);}catch(t){e[n]=ma$3[n];}}};for(var cs$1 in Qt$6)us$1(se$6[cs$1]&&se$6[cs$1].prototype,cs$1);us$1(tn$6,"DOMTokenList");var fs$1=new WeakMap,ds$1=new WeakMap,hs$1=new WeakMap,ps$1=new WeakMap,gs$1=new WeakMap,vs$1=new WeakMap,ys$1=new WeakMap,ms$1=new WeakMap,bs$1=new WeakMap,ws$1=new WeakMap,xs$1=new WeakMap,Ss$1=new WeakMap,ks$1=new WeakMap,Es$1=new WeakMap,Os$1=new WeakMap,Cs$1=new WeakMap,Ns$1=new WeakMap,Ts$1=new WeakMap,Ls$1=new WeakMap,Ms$1=new WeakMap,Ps$1=new WeakMap,Ds$1=new WeakMap,Rs$1=new WeakMap,js$1=new WeakMap,As$1=new WeakMap,Fs$1=Tn$6.find,Is$1=!0;"find"in[]&&Array(1).find((function(){Is$1=!1;})),cr$5({target:"Array",proto:!0,forced:Is$1},{find:function(e){return Fs$1(this,e,arguments.length>1?arguments[1]:void 0)}}),Vr$5("find"),cr$5({global:!0},{globalThis:se$6});const _s$1=["area","base","basefont","bgsound","br","col","command","embed","frame","hr","image","img","input","isindex","keygen","link","menuitem","meta","nextid","param","source","track","wbr"];css&&($$6.fn.css=css),append&&($$6.fn.append=append),addClass&&($$6.fn.addClass=addClass),removeClass&&($$6.fn.removeClass=removeClass),hasClass&&($$6.fn.hasClass=hasClass),on$7&&($$6.fn.on=on$7),focus&&($$6.fn.focus=focus),attr&&($$6.fn.attr=attr),removeAttr&&($$6.fn.removeAttr=removeAttr),hide&&($$6.fn.hide=hide),show&&($$6.fn.show=show),offset&&($$6.fn.offset=offset),width&&($$6.fn.width=width),height&&($$6.fn.height=height),parent&&($$6.fn.parent=parent),parents&&($$6.fn.parents=parents),is$2&&($$6.fn.is=is$2),dataset&&($$6.fn.dataset=dataset),val&&($$6.fn.val=val),text&&($$6.fn.text=text),html&&($$6.fn.html=html),children&&($$6.fn.children=children),remove&&($$6.fn.remove=remove),find&&($$6.fn.find=find),each&&($$6.fn.each=each),empty&&($$6.fn.empty=empty);var Bs$1,$s$1=function(e){return e&&e.ownerDocument&&e.ownerDocument.defaultView||null},Ws$1=function(e){return Vs$1(e)&&1===e.nodeType},Vs$1=function(e){var t=$s$1(e);return !!t&&e instanceof t.Node},zs$1=function(e){var t=e&&e.anchorNode&&$s$1(e.anchorNode);return !!t&&e instanceof t.Selection},Hs$1=function(e){return Vs$1(e)&&3===e.nodeType},Us$1=function(e){var t,n,r;return null!==(t=window.document.getElementById(e))&&void 0!==t?t:(null===(r=null===(n=window.document.activeElement)||void 0===n?void 0:n.shadowRoot)||void 0===r?void 0:r.getElementById(e))||null},Ks$1=function(e,t,n){for(var r,o=e.childNodes,i=o[t],a=t,s=!1,l=!1;(Vs$1(r=i)&&8===r.nodeType||Ws$1(i)&&0===i.childNodes.length||Ws$1(i)&&"false"===i.getAttribute("contenteditable"))&&(!s||!l);)a>=o.length?(s=!0,a=t-1,n="backward"):a<0?(l=!0,a=t+1,n="forward"):(i=o[a],t=a,a+="forward"===n?1:-1);return [i,t]},qs$1=function(e,t,n){return da$4(Ks$1(e,t,n),1)[0]},Gs$1=function e(t){var n,r,o="";if(Hs$1(t)&&t.nodeValue)return t.nodeValue;if(Ws$1(t)){try{for(var i=fa$4(Array.from(t.childNodes)),a=i.next();!a.done;a=i.next()){o+=e(a.value);}}catch(e){n={error:e};}finally{try{a&&!a.done&&(r=i.return)&&r.call(i);}finally{if(n)throw n.error}}var s=getComputedStyle(t).getPropertyValue("display");"block"!==s&&"list"!==s&&"table-row"!==s&&"BR"!==t.tagName||(o+="\n");}return o};function Js$1(e,t){if(!(e instanceof HTMLElement&&"true"===e.dataset.slateVoid))for(var n=e.childNodes,r=n.length;r--;){var o=n[r],i=o.nodeType;3==i?t(o,e):1!=i&&9!=i&&11!=i||Js$1(o,t);}}function Ys$1(e){if(0===e.length)return "";var t=e[0];return t.nodeType!==Bs$1.ELEMENT_NODE?"":t.tagName.toLowerCase()}!function(e){e[e.ELEMENT_NODE=1]="ELEMENT_NODE",e[e.TEXT_NODE=3]="TEXT_NODE",e[e.CDATA_SECTION_NODE=4]="CDATA_SECTION_NODE",e[e.PROCESSING_INSTRUCTION_NODE=7]="PROCESSING_INSTRUCTION_NODE",e[e.COMMENT_NODE=8]="COMMENT_NODE",e[e.DOCUMENT_NODE=9]="DOCUMENT_NODE",e[e.DOCUMENT_TYPE_NODE=10]="DOCUMENT_TYPE_NODE",e[e.DOCUMENT_FRAGMENT_NODE=11]="DOCUMENT_FRAGMENT_NODE";}(Bs$1||(Bs$1={})),void 0!==globalThis.navigator&&void 0!==globalThis.window&&/iPad|iPhone|iPod/.test(navigator.userAgent)&&globalThis.window.MSStream;var Xs$1="undefined"!=typeof navigator&&/Mac OS X/.test(navigator.userAgent),Qs$1="undefined"!=typeof navigator&&/^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);"undefined"!=typeof navigator&&/^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent);var Zs$1="undefined"!=typeof navigator&&/Version\/[\d\.]+.*Safari/.test(navigator.userAgent),el$1="undefined"!=typeof navigator&&/Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent),tl$1="undefined"!=typeof navigator&&/Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent),nl$1="undefined"!=typeof navigator&&/Chrome/i.test(navigator.userAgent);"undefined"!=typeof navigator&&/.*QQBrowser/.test(navigator.userAgent);var rl$1=!tl$1&&!el$1&&"undefined"!=typeof globalThis&&globalThis.InputEvent&&"function"==typeof globalThis.InputEvent.prototype.getTargetRanges,ol$1={getWindow:function(e){var t=Ps$1.get(e);if(!t)throw new Error("Unable to find a host window element for this editor");return t},findKey:function(e,t){var n=Ms$1.get(t);return n||(n=new ga$3,Ms$1.set(t,n)),n},setNewKey:function(e){var t=new ga$3;Ms$1.set(e,t);},findPath:function(t,n){for(var r=[],o=n;;){var i=Os$1.get(o);if(null==i){if(Editor.isEditor(o))return r;break}var a=Es$1.get(o);if(null==a)break;r.unshift(a),o=i;}throw new Error("Unable to find the path for Slate node: "+JSON.stringify(n))},findDocumentOrShadowRoot:function(e){if(e.isDestroyed)return window.document;var t=ol$1.toDOMNode(e,e),n=t.getRootNode();return (n instanceof Document||n instanceof ShadowRoot)&&null!=n.getSelection?n:t.ownerDocument},getParentNode:function(e,t){return Os$1.get(t)||null},getParentsNodes:function(e,t){for(var n=[],r=t;r!==e&&null!=r;){var o=ol$1.getParentNode(e,r);if(null==o)break;n.push(o),r=o;}return n},getTopNode:function(e,t){var n=[ol$1.findPath(e,t)[0]];return Node$1.get(e,n)},toDOMNode:function(t,n){var r;if(Editor.isEditor(n))r=Cs$1.get(t);else {var o=ol$1.findKey(t,n);r=Ts$1.get(o);}if(!r)throw new Error("Cannot resolve a DOM node from Slate node: "+JSON.stringify(n));return r},hasDOMNode:function(e,t,n){void 0===n&&(n={});var r,o=n.editable,i=void 0!==o&&o,a=ol$1.toDOMNode(e,e);try{r=Ws$1(t)?t:t.parentElement;}catch(e){if(!e.message.includes('Permission denied to access property "nodeType"'))throw e}return !!r&&(r.closest("[data-slate-editor]")===a&&(!i||r.isContentEditable||!!r.getAttribute("data-slate-zero-width")))},toDOMRange:function(e,t){var n=t.anchor,r=t.focus,i=Range.isBackward(t),a=ol$1.toDOMPoint(e,n),s=Range.isCollapsed(t)?a:ol$1.toDOMPoint(e,r),l=ol$1.getWindow(e).document.createRange(),u=da$4(i?s:a,2),c=u[0],f=u[1],d=da$4(i?a:s,2),h=d[0],p=d[1],g=!!(Ws$1(c)?c:c.parentElement).getAttribute("data-slate-zero-width"),v=!!(Ws$1(h)?h:h.parentElement).getAttribute("data-slate-zero-width");return l.setStart(c,g?1:f),l.setEnd(h,v?1:p),l},toDOMPoint:function(t,n){var r,o,i,a=da$4(Editor.node(t,n.path),1)[0],s=ol$1.toDOMNode(t,a);Editor.void(t,{at:n})&&(n={path:n.path,offset:0});var l=Array.from(s.querySelectorAll("[data-slate-string], [data-slate-zero-width]")),u=0;try{for(var c=fa$4(l),f=c.next();!f.done;f=c.next()){var d=f.value,h=d.childNodes[0];if(null!=h&&null!=h.textContent){var p=h.textContent.length,g=d.getAttribute("data-slate-length"),v=u+(null==g?p:parseInt(g,10));if(n.offset<=v){i=[h,Math.min(p,Math.max(0,n.offset-u))];break}u=v;}}}catch(e){r={error:e};}finally{try{f&&!f.done&&(o=c.return)&&o.call(c);}finally{if(r)throw r.error}}if(!i)throw new Error("Cannot resolve a DOM point from Slate point: "+JSON.stringify(n));return i},toSlateNode:function(e,t){var n=Ws$1(t)?t:t.parentElement;n&&!n.hasAttribute("data-slate-node")&&(n=n.closest("[data-slate-node]"));var r=n?Ns$1.get(n):null;if(!r)throw new Error("Cannot resolve a Slate node from DOM node: "+n);return r},findEventRange:function(t,n){"nativeEvent"in n&&(n=n.nativeEvent);var r=n.clientX,o=n.clientY,i=n.target;if(null==r||null==o)throw new Error("Cannot resolve a Slate range from a DOM event: "+n);var a,s=ol$1.toSlateNode(t,n.target),l=ol$1.findPath(t,s);if(Editor.isVoid(t,s)){var u=i.getBoundingClientRect(),c=t.isInline(s)?r-u.left<u.left+u.width-r:o-u.top<u.top+u.height-o,f=Editor.point(t,l,{edge:c?"start":"end"}),d=c?Editor.before(t,f):Editor.after(t,f);if(d)return Editor.range(t,d)}var h=this.getWindow(t).document;if(h.caretRangeFromPoint)a=h.caretRangeFromPoint(r,o);else {var p=h.caretPositionFromPoint(r,o);p&&((a=h.createRange()).setStart(p.offsetNode,p.offset),a.setEnd(p.offsetNode,p.offset));}if(!a)throw new Error("Cannot resolve a Slate range from a DOM event: "+n);return ol$1.toSlateRange(t,a,{exactMatch:!1,suppressThrow:!1})},toSlateRange:function(t,n,r){var i,a,s,l,u,c=r.exactMatch,f=r.suppressThrow;if((zs$1(n)?n.anchorNode:n.startContainer)&&(zs$1(n)?(i=n.anchorNode,a=n.anchorOffset,s=n.focusNode,l=n.focusOffset,u=nl$1&&window.document.activeElement&&window.document.activeElement.shadowRoot?n.anchorNode===n.focusNode&&n.anchorOffset===n.focusOffset:n.isCollapsed):(i=n.startContainer,a=n.startOffset,s=n.endContainer,l=n.endOffset,u=n.collapsed)),null==i||null==s||null==a||null==l)throw new Error("Cannot resolve a Slate range from DOM range: "+n);var d=ol$1.toSlatePoint(t,[i,a],{exactMatch:c,suppressThrow:f});if(!d)return null;var h=u?d:ol$1.toSlatePoint(t,[s,l],{exactMatch:c,suppressThrow:f});if(!h)return null;var p={anchor:d,focus:h};return Range.isExpanded(p)&&Range.isForward(p)&&Ws$1(s)&&Editor.void(t,{at:p.focus,mode:"highest"})&&(p=Editor.unhangRange(t,p,{voids:!0})),p},toSlatePoint:function(e,t,n){var r,o=n.exactMatch,i=n.suppressThrow,a=da$4(o?t:function(e){var t,n=da$4(e,2),r=n[0],o=n[1];if(Ws$1(r)&&r.childNodes.length){var i=o===r.childNodes.length,a=i?o-1:o;for(r=(t=da$4(Ks$1(r,a,i?"backward":"forward"),2))[0],i=(a=t[1])<o;Ws$1(r)&&r.childNodes.length;){var s=i?r.childNodes.length-1:0;r=qs$1(r,s,i?"backward":"forward");}o=i&&null!=r.textContent?r.textContent.length:0;}return [r,o]}(t),2),s=a[0],l=a[1],u=s.parentNode,f=null,d=0;if(u){var h=u.closest('[data-slate-void="true"]'),p=u.closest("[data-slate-leaf]"),g=null;if(p){f=p.closest('[data-slate-node="text"]');var v=ol$1.getWindow(e).document.createRange();v.setStart(f,0),v.setEnd(s,l);var y=v.cloneContents();ha$3(ha$3([],da$4(lodash_toarray(y.querySelectorAll("[data-slate-zero-width]")))),da$4(lodash_toarray(y.querySelectorAll("[contenteditable=false]")))).forEach((function(e){e.parentNode.removeChild(e);})),d=y.textContent.length,g=f;}else h&&((p=h.querySelector("[data-slate-leaf]"))?(f=p.closest('[data-slate-node="text"]'),d=(g=p).textContent.length,g.querySelectorAll("[data-slate-zero-width]").forEach((function(e){d-=e.textContent.length;}))):d=1);g&&d===g.textContent.length&&(u.hasAttribute("data-slate-zero-width")||Qs$1&&(null===(r=g.textContent)||void 0===r?void 0:r.endsWith("\n")))&&d--;}if(!f){if(i)return null;throw new Error("Cannot resolve a Slate point from DOM point: "+t)}var m=ol$1.toSlateNode(e,f);return {path:ol$1.findPath(e,m),offset:d}},hasRange:function(t,n){var r=n.anchor,o=n.focus;return Editor.hasPath(t,r.path)&&Editor.hasPath(t,o.path)},getNodeType:function(e){return Element$1.isElement(e)?e.type:""},checkNodeType:function(e,t){return this.getNodeType(e)===t},getNodesStr:function(e){return e.map((function(e){return Node$1.string(e)})).join("")},getSelectedElems:function(t){var n,r,o=[],a=Editor.nodes(t,{universal:!0});try{for(var s=fa$4(a),l=s.next();!l.done;l=s.next()){var u=da$4(l.value,1)[0];Element$1.isElement(u)&&o.push(u);}}catch(e){n={error:e};}finally{try{l&&!l.done&&(r=s.return)&&r.call(s);}finally{if(n)throw n.error}}return o},getSelectedNodeByType:function(t,n){var r=this,o=da$4(Editor.nodes(t,{match:function(e){return r.checkNodeType(e,n)},universal:!0}),1),i=o[0];return null==i?null:i[0]},getSelectedTextNode:function(t){var n=da$4(Editor.nodes(t,{match:function(e){return Text.isText(e)},universal:!0}),1),r=n[0];return null==r?null:r[0]},isNodeSelected:function(t,n){var r=da$4(Editor.nodes(t,{match:function(e){return e===n},universal:!0}),1),o=r[0];return null!=o&&da$4(o,1)[0]===n},isSelectionAtLineEnd:function(t,n){var r=t.selection;return !!r&&(Editor.isEnd(t,r.anchor,n)||Editor.isEnd(t,r.focus,n))},getTextarea:function(e){var t=fs$1.get(e);if(null==t)throw new Error("Cannot find textarea instance by editor");return t},getToolbar:function(e){return ps$1.get(e)||null},getHoverbar:function(e){return vs$1.get(e)||null},normalizeContent:function(e){e.children.forEach((function(t,n){e.normalizeNode([t,[n]]);}));},getLeftLengthOfMaxLength:function(e){var t=e.getConfig(),n=t.maxLength,r=t.onMaxLength;if("number"!=typeof n||n<=0)return 1/0;var o=n-e.getText().replace(/\r|\n|(\r\n)/g,"").length;return o<=0&&r&&r(e),o},cleanExposedTexNodeInSelectionBlock:function(t){var n,r,o,a,s=ol$1.getTextarea(t).$textArea,l=null==s?void 0:s[0].childNodes;if(l)try{for(var u=fa$4(Array.from(l)),c=u.next();!c.done;c=u.next()){var d=c.value;if(3!==d.nodeType)break;d.remove();}}catch(e){n={error:e};}finally{try{c&&!c.done&&(r=u.return)&&r.call(u);}finally{if(n)throw n.error}}var h=Editor.nodes(t,{match:function(e){return !(!Element$1.isElement(e)||t.isInline(e))},universal:!0});try{for(var p=fa$4(h),g=p.next();!g.done;g=p.next()){var v=g.value;if(null!=v){var y=v[0];Js$1(ol$1.toDOMNode(t,y),(function(e,t){var n=$$6(t);n.attr("data-slate-string")||n.attr("data-slate-zero-width")||n.attr("data-w-e-reserve")||t.removeChild(e);}));}}}catch(e){o={error:e};}finally{try{g&&!g.done&&(a=p.return)&&a.call(p);}finally{if(o)throw o.error}}},isLastNode:function(e,t){var n=e.children||[];return n[n.length-1]===t},genEmptyParagraph:function(){return {type:"paragraph",children:[{text:""}]}},isSelectedVoidNode:function(t){var n,r,o=Editor.nodes(t,{match:function(e){return t.isVoid(e)}}),i=0;try{for(var a=fa$4(o),s=a.next();!s.done;s=a.next()){s.value;i++;}}catch(e){n={error:e};}finally{try{s&&!s.done&&(r=a.return)&&r.call(a);}finally{if(n)throw n.error}}return i>0},isSelectedEmptyParagraph:function(e){var t=e.selection;if(null==t)return !1;if(Range.isExpanded(t))return !1;var n=ol$1.getSelectedNodeByType(e,"paragraph");if(null===n)return !1;var r=n.children;return 1===r.length&&(""===r[0].text||void 0)},isEmptyPath:function(t,n){var r=Editor.node(t,n);if(null==r)return !1;var o=da$4(r,1)[0].children;if(1===o.length&&""===o[0].text)return !0;return !1}},il$1=1,al$1={};var sl$1={};function ll$1(e,t){var n=e.key,r=e.factory,o=e.config,i=ca$4(ca$4({},o),t||{});if(null!=sl$1[n])throw new Error("Duplicated key '"+n+"' in menu items");sl$1[n]=r,function(e,t){null!=t&&(al$1[e]=t);}(n,i);}var ul$1=Tn$6.filter,cl$1=fi$5("filter");cr$5({target:"Array",proto:!0,forced:!cl$1},{filter:function(e){return ul$1(this,e,arguments.length>1?arguments[1]:void 0)}});var fl$1="\t\n\v\f\r                　\u2028\u2029\ufeff",dl$1=ve$6("".replace),hl$1="["+fl$1+"]",pl$1=RegExp("^"+hl$1+hl$1+"*"),gl$1=RegExp(hl$1+hl$1+"*$"),vl$1=function(e){return function(t){var n=kr$5(me$6(t));return 1&e&&(n=dl$1(n,pl$1,"")),2&e&&(n=dl$1(n,gl$1,"")),n}},yl$1={start:vl$1(1),end:vl$1(2),trim:vl$1(3)},ml$1=Vt$6.PROPER,bl$1=yl$1.trim;cr$5({target:"String",proto:!0,forced:function(e){return Fe$6((function(){return !!fl$1[e]()||"​᠎"!=="​᠎"[e]()||ml$1&&fl$1[e].name!==e}))}("trim")},{trim:function(){return bl$1(this)}});var wl$1=[];function xl$1(e){wl$1.push(e);}var Sl$1={};function kl$1(e){var t=e.type,n=e.elemToHtml;Sl$1[t||""]=n;}function El$1(e,t,n){var r=n.isInline(e)?"span":"div";return "<"+r+">"+t+"</"+r+">"}function Ol$1(t,n){var r=t.type,o=void 0===r?"":r,i=t.children,a=void 0===i?[]:i,s=Editor.isVoid(n,t),l="";s||(l=a.map((function(e){return sc$1(e,n)})).join(""));var u=function(e){return Sl$1[e]||El$1}(o),c=u(t,l,n),f="";if(f="string"==typeof c?c:c.html||"",s||wl$1.forEach((function(e){return f=e(t,f)})),"string"==typeof c)return f;var d=c.prefix,h=void 0===d?"":d,p=c.suffix,g=void 0===p?"":p;return h&&(f=h+f),g&&(f+=g),f}var Cl$1,Nl$1,Tl$1,Ll$1,Ml$1=se$6.Promise,Pl$1=ze$6("species"),Dl$1=function(e){var t=Le$6(e),n=mt$6.f;Ke$6&&t&&!t[Pl$1]&&n(t,Pl$1,{configurable:!0,get:function(){return this}});},Rl$1=se$6.TypeError,jl$1=ze$6("species"),Al$1=function(e,t){var n,r=et$6(e).constructor;return void 0===r||null==(n=et$6(r)[jl$1])?t:function(e){if(Sn$6(e))return e;throw Rl$1(st$6(e)+" is not a constructor")}(n)},Fl$1=ve$6([].slice),Il$1=/(?:ipad|iphone|ipod).*applewebkit/i.test(Me$6),_l$1="process"==Kt$6(se$6.process),Bl$1=se$6.setImmediate,$l$1=se$6.clearImmediate,Wl$1=se$6.process,Vl$1=se$6.Dispatch,zl$1=se$6.Function,Hl$1=se$6.MessageChannel,Ul$1=se$6.String,Kl$1=0,ql$1={};try{Cl$1=se$6.location;}catch(e){}var Gl$1=function(e){if(Se$6(ql$1,e)){var t=ql$1[e];delete ql$1[e],t();}},Jl$1=function(e){return function(){Gl$1(e);}},Yl$1=function(e){Gl$1(e.data);},Xl$1=function(e){se$6.postMessage(Ul$1(e),Cl$1.protocol+"//"+Cl$1.host);};Bl$1&&$l$1||(Bl$1=function(e){var t=Fl$1(arguments,1);return ql$1[++Kl$1]=function(){_i$4(Ne$6(e)?e:zl$1(e),void 0,t);},Nl$1(Kl$1),Kl$1},$l$1=function(e){delete ql$1[e];},_l$1?Nl$1=function(e){Wl$1.nextTick(Jl$1(e));}:Vl$1&&Vl$1.now?Nl$1=function(e){Vl$1.now(Jl$1(e));}:Hl$1&&!Il$1?(Ll$1=(Tl$1=new Hl$1).port2,Tl$1.port1.onmessage=Yl$1,Nl$1=rn$6(Ll$1.postMessage,Ll$1)):se$6.addEventListener&&Ne$6(se$6.postMessage)&&!se$6.importScripts&&Cl$1&&"file:"!==Cl$1.protocol&&!Fe$6(Xl$1)?(Nl$1=Xl$1,se$6.addEventListener("message",Yl$1,!1)):Nl$1="onreadystatechange"in Ye$6("script")?function(e){Rr$5.appendChild(Ye$6("script")).onreadystatechange=function(){Rr$5.removeChild(this),Gl$1(e);};}:function(e){setTimeout(Jl$1(e),0);});var Ql$1,Zl$1,eu$3,tu$3,nu$3,ru$3,ou$3,iu$3,au$3={set:Bl$1,clear:$l$1},su$3=/ipad|iphone|ipod/i.test(Me$6)&&void 0!==se$6.Pebble,lu$3=/web0s(?!.*chrome)/i.test(Me$6),uu$3=$n$6.f,cu$3=au$3.set,fu$3=se$6.MutationObserver||se$6.WebKitMutationObserver,du$3=se$6.document,hu$3=se$6.process,pu$3=se$6.Promise,gu$3=uu$3(se$6,"queueMicrotask"),vu$3=gu$3&&gu$3.value;vu$3||(Ql$1=function(){var e,t;for(_l$1&&(e=hu$3.domain)&&e.exit();Zl$1;){t=Zl$1.fn,Zl$1=Zl$1.next;try{t();}catch(e){throw Zl$1?tu$3():eu$3=void 0,e}}eu$3=void 0,e&&e.enter();},Il$1||_l$1||lu$3||!fu$3||!du$3?!su$3&&pu$3&&pu$3.resolve?((ou$3=pu$3.resolve(void 0)).constructor=pu$3,iu$3=rn$6(ou$3.then,ou$3),tu$3=function(){iu$3(Ql$1);}):_l$1?tu$3=function(){hu$3.nextTick(Ql$1);}:(cu$3=rn$6(cu$3,se$6),tu$3=function(){cu$3(Ql$1);}):(nu$3=!0,ru$3=du$3.createTextNode(""),new fu$3(Ql$1).observe(ru$3,{characterData:!0}),tu$3=function(){ru$3.data=nu$3=!nu$3;}));var yu$3,mu$3,bu$3,wu$3,xu$3=vu$3||function(e){var t={fn:e,next:void 0};eu$3&&(eu$3.next=t),Zl$1||(Zl$1=t,tu$3()),eu$3=t;},Su$3=function(e){var t,n;this.promise=new e((function(e,r){if(void 0!==t||void 0!==n)throw TypeError("Bad Promise constructor");t=e,n=r;})),this.resolve=ut$6(t),this.reject=ut$6(n);},ku$3={f:function(e){return new Su$3(e)}},Eu$3=function(e){try{return {error:!1,value:e()}}catch(e){return {error:!0,value:e}}},Ou$3="object"==typeof window,Cu$3=au$3.set,Nu$3=ze$6("species"),Tu$3="Promise",Lu$3=_t$6.getterFor(Tu$3),Mu$3=_t$6.set,Pu$3=_t$6.getterFor(Tu$3),Du$3=Ml$1&&Ml$1.prototype,Ru$3=Ml$1,ju$3=Du$3,Au$3=se$6.TypeError,Fu$3=se$6.document,Iu$3=se$6.process,_u$3=ku$3.f,Bu$3=_u$3,$u$3=!!(Fu$3&&Fu$3.createEvent&&se$6.dispatchEvent),Wu$3=Ne$6(se$6.PromiseRejectionEvent),Vu$3=!1,zu$3=lr$5(Tu$3,(function(){var e=Ot$6(Ru$3),t=e!==String(Ru$3);if(!t&&66===Ae$6)return !0;if(Ae$6>=51&&/native code/.test(e))return !1;var n=new Ru$3((function(e){e(1);})),r=function(e){e((function(){}),(function(){}));};return (n.constructor={})[Nu$3]=r,!(Vu$3=n.then((function(){}))instanceof r)||!t&&Ou$3&&!Wu$3})),Hu$3=zu$3||!yo$5((function(e){Ru$3.all(e).catch((function(){}));})),Uu$3=function(e){var t;return !(!qe$6(e)||!Ne$6(t=e.then))&&t},Ku$3=function(e,t){if(!e.notified){e.notified=!0;var n=e.reactions;xu$3((function(){for(var r=e.value,o=1==e.state,i=0;n.length>i;){var a,s,l,u=n[i++],c=o?u.ok:u.fail,f=u.resolve,d=u.reject,h=u.domain;try{c?(o||(2===e.rejection&&Yu$3(e),e.rejection=1),!0===c?a=r:(h&&h.enter(),a=c(r),h&&(h.exit(),l=!0)),a===u.promise?d(Au$3("Promise-chain cycle")):(s=Uu$3(a))?nt$6(s,a,f,d):f(a)):d(r);}catch(e){h&&!l&&h.exit(),d(e);}}e.reactions=[],e.notified=!1,t&&!e.rejection&&Gu$3(e);}));}},qu$3=function(e,t,n){var r,o;$u$3?((r=Fu$3.createEvent("Event")).promise=t,r.reason=n,r.initEvent(e,!1,!0),se$6.dispatchEvent(r)):r={promise:t,reason:n},!Wu$3&&(o=se$6["on"+e])?o(r):"unhandledrejection"===e&&function(e,t){var n=se$6.console;n&&n.error&&(1==arguments.length?n.error(e):n.error(e,t));}("Unhandled promise rejection",n);},Gu$3=function(e){nt$6(Cu$3,se$6,(function(){var t,n=e.facade,r=e.value;if(Ju$3(e)&&(t=Eu$3((function(){_l$1?Iu$3.emit("unhandledRejection",r,n):qu$3("unhandledrejection",n,r);})),e.rejection=_l$1||Ju$3(e)?2:1,t.error))throw t.value}));},Ju$3=function(e){return 1!==e.rejection&&!e.parent},Yu$3=function(e){nt$6(Cu$3,se$6,(function(){var t=e.facade;_l$1?Iu$3.emit("rejectionHandled",t):qu$3("rejectionhandled",t,e.value);}));},Xu$3=function(e,t,n){return function(r){e(t,r,n);}},Qu$3=function(e,t,n){e.done||(e.done=!0,n&&(e=n),e.value=t,e.state=2,Ku$3(e,!0));},Zu$3=function(e,t,n){if(!e.done){e.done=!0,n&&(e=n);try{if(e.facade===t)throw Au$3("Promise can't be resolved itself");var r=Uu$3(t);r?xu$3((function(){var n={done:!1};try{nt$6(r,t,Xu$3(Zu$3,n,e),Xu$3(Qu$3,n,e));}catch(t){Qu$3(n,t,e);}})):(e.value=t,e.state=1,Ku$3(e,!1));}catch(t){Qu$3({done:!1},t,e);}}};if(zu$3&&(ju$3=(Ru$3=function(e){Fa$3(this,ju$3),ut$6(e),nt$6(yu$3,this);var t=Lu$3(this);try{e(Xu$3(Zu$3,t),Xu$3(Qu$3,t));}catch(e){Qu$3(t,e);}}).prototype,(yu$3=function(e){Mu$3(this,{type:Tu$3,done:!1,notified:!1,parent:!1,reactions:[],rejection:!1,state:0,value:void 0});}).prototype=ba$3(ju$3,{then:function(e,t){var n=Pu$3(this),r=n.reactions,o=_u$3(Al$1(this,Ru$3));return o.ok=!Ne$6(e)||e,o.fail=Ne$6(t)&&t,o.domain=_l$1?Iu$3.domain:void 0,n.parent=!0,r[r.length]=o,0!=n.state&&Ku$3(n,!1),o.promise},catch:function(e){return this.then(void 0,e)}}),mu$3=function(){var e=new yu$3,t=Lu$3(e);this.promise=e,this.resolve=Xu$3(Zu$3,t),this.reject=Xu$3(Qu$3,t);},ku$3.f=_u$3=function(e){return e===Ru$3||e===bu$3?new mu$3(e):Bu$3(e)},Ne$6(Ml$1)&&Du$3!==Object.prototype)){wu$3=Du$3.then,Vu$3||(zt$6(Du$3,"then",(function(e,t){var n=this;return new Ru$3((function(e,t){nt$6(wu$3,n,e,t);})).then(e,t)}),{unsafe:!0}),zt$6(Du$3,"catch",ju$3.catch,{unsafe:!0}));try{delete Du$3.constructor;}catch(e){}zo$5&&zo$5(Du$3,ju$3);}cr$5({global:!0,wrap:!0,forced:zu$3},{Promise:Ru$3}),_o$5(Ru$3,Tu$3,!1),Dl$1(Tu$3),bu$3=Le$6(Tu$3),cr$5({target:Tu$3,stat:!0,forced:zu$3},{reject:function(e){var t=_u$3(this);return nt$6(t.reject,void 0,e),t.promise}}),cr$5({target:Tu$3,stat:!0,forced:zu$3},{resolve:function(e){return function(e,t){if(et$6(e),qe$6(t)&&t.constructor===e)return t;var n=ku$3.f(e);return (0, n.resolve)(t),n.promise}(this,e)}}),cr$5({target:Tu$3,stat:!0,forced:Hu$3},{all:function(e){var t=this,n=_u$3(t),r=n.resolve,o=n.reject,i=Eu$3((function(){var n=ut$6(t.resolve),i=[],a=0,s=1;ja$2(e,(function(e){var l=a++,u=!1;s++,nt$6(n,t,e).then((function(e){u||(u=!0,i[l]=e,--s||r(i));}),o);})),--s||r(i);}));return i.error&&o(i.value),n.promise},race:function(e){var t=this,n=_u$3(t),r=n.reject,o=Eu$3((function(){var o=ut$6(t.resolve);ja$2(e,(function(e){nt$6(o,t,e).then(n.resolve,r);}));}));return o.error&&r(o.value),n.promise}});var ec$1=yi$5.UNSUPPORTED_Y,tc$1=Math.min,nc$1=[].push,rc$1=ve$6(/./.exec),oc$1=ve$6(nc$1),ic$1=ve$6("".slice);function ac$1(e){Promise.resolve().then(e);}function sc$1(e,t){return Element$1.isElement(e)?Ol$1(e,t):function(e,t){var n=e.text;if(null==n)throw new Error("Current node is not slate Text "+JSON.stringify(e));var r=n;r=function(e){return e.replace(/ {2}/g," &nbsp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/®/g,"&reg;").replace(/©/g,"&copy;").replace(/™/g,"&trade;")}(r);var o=ol$1.getParentsNodes(t,e).some((function(e){return "pre"===ol$1.getNodeType(e)}));if(o||(r=r.replace(/\r\n|\r|\n/g,"<br>")),o&&(r=r.replace(/&nbsp;/g," ")),""===r){var i=ol$1.getParentNode(null,e);if(!i||0!==i.children.length)return r;r="<br>";}return wl$1.forEach((function(t){return r=t(e,r)})),r}(e,t)}function lc$1(e){return "w-e-element-"+e}Wi$3("split",(function(e,t,n){var r;return r="c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1).length||2!="ab".split(/(?:ab)*/).length||4!=".".split(/(.?)(.?)/).length||".".split(/()()/).length>1||"".split(/.?/).length?function(e,n){var r=kr$5(me$6(this)),o=void 0===n?4294967295:n>>>0;if(0===o)return [];if(void 0===e)return [r];if(!Ur$5(e))return nt$6(t,r,e,o);for(var i,a,s,l=[],u=(e.ignoreCase?"i":"")+(e.multiline?"m":"")+(e.unicode?"u":"")+(e.sticky?"y":""),c=0,f=new RegExp(e.source,u+"g");(i=nt$6(Ri$4,f,r))&&!((a=f.lastIndex)>c&&(oc$1(l,ic$1(r,c,i.index)),i.length>1&&i.index<r.length&&_i$4(nc$1,l,Sa$3(i,1)),s=i[0].length,c=a,l.length>=o));)f.lastIndex===i.index&&f.lastIndex++;return c===r.length?!s&&rc$1(f,"")||oc$1(l,""):oc$1(l,ic$1(r,c)),l.length>o?Sa$3(l,0,o):l}:"0".split(void 0,0).length?function(e,n){return void 0===e&&0===n?[]:nt$6(t,this,e,n)}:t,[function(t,n){var o=me$6(this),i=null==t?void 0:ct$6(t,e);return i?nt$6(i,t,o,n):nt$6(r,kr$5(o),t,n)},function(e,o){var i=et$6(this),a=kr$5(e),s=n(r,i,a,o,r!==t);if(s.done)return s.value;var l=Al$1(i,RegExp),u=i.unicode,c=(i.ignoreCase?"i":"")+(i.multiline?"m":"")+(i.unicode?"u":"")+(ec$1?"g":"y"),f=new l(ec$1?"^(?:"+i.source+")":i,c),d=void 0===o?4294967295:o>>>0;if(0===d)return [];if(0===a.length)return null===Qi$3(f,a)?[a]:[];for(var h=0,p=0,g=[];p<a.length;){f.lastIndex=ec$1?0:p;var v,y=Qi$3(f,ec$1?ic$1(a,p):a);if(null===y||(v=tc$1(dn$6(f.lastIndex+(ec$1?p:0)),a.length))===h)p=zi$4(a,p,u);else {if(oc$1(g,ic$1(a,h,p)),g.length===d)return g;for(var m=1;m<=y.length-1;m++)if(oc$1(g,y[m]),g.length===d)return g;p=h=v;}}return oc$1(g,ic$1(a,h)),g}]}),!!Fe$6((function(){var e=/(?:)/,t=e.exec;e.exec=function(){return t.apply(this,arguments)};var n="ab".split(e);return 2!==n.length||"a"!==n[0]||"b"!==n[1]})),ec$1);var uc$1=function(e,t){var n=(t.top+t.bottom)/2;return e.top<=n&&e.bottom>=n},cc$1=function(e,t,n){var r=ol$1.toDOMRange(e,t).getBoundingClientRect(),o=ol$1.toDOMRange(e,n).getBoundingClientRect();return uc$1(r,o)&&uc$1(o,r)},fc$1=["span","b","strong","i","em","s","strike","u","font","sub","sup"],dc$1=[];function hc$1(e){dc$1.push(e);}var pc$1=[];function gc$1(e){pc$1.push(e);}var vc$1={};function yc$1(e){var t=e.selector,n=e.parseElemHtml;vc$1[t]=n;}var mc$1=mt$6.f,bc$1=Xn$6.f,wc$1=_t$6.enforce,xc$1=ze$6("match"),Sc$1=se$6.RegExp,kc$1=Sc$1.prototype,Ec$1=se$6.SyntaxError,Oc$1=ve$6(Er$5),Cc$1=ve$6(kc$1.exec),Nc$1=ve$6("".charAt),Tc$1=ve$6("".replace),Lc$1=ve$6("".indexOf),Mc$1=ve$6("".slice),Pc$1=/^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/,Dc$1=/a/g,Rc$1=/a/g,jc$1=new Sc$1(Dc$1)!==Dc$1,Ac$1=yi$5.MISSED_STICKY,Fc$1=yi$5.UNSUPPORTED_Y,Ic$1=Ke$6&&(!jc$1||Ac$1||bi$4||xi$4||Fe$6((function(){return Rc$1[xc$1]=!1,Sc$1(Dc$1)!=Dc$1||Sc$1(Rc$1)==Rc$1||"/a/i"!=Sc$1(Dc$1,"i")})));if(lr$5("RegExp",Ic$1)){for(var _c$1=function(e,t){var n,r,o,i,a,s,l=rt$6(kc$1,this),u=Ur$5(e),c=void 0===t,f=[],d=e;if(!l&&u&&c&&e.constructor===_c$1)return e;if((u||rt$6(kc$1,e))&&(e=e.source,c&&(t="flags"in d?d.flags:Oc$1(d))),e=void 0===e?"":kr$5(e),t=void 0===t?"":kr$5(t),d=e,bi$4&&"dotAll"in Dc$1&&(r=!!t&&Lc$1(t,"s")>-1)&&(t=Tc$1(t,/s/g,"")),n=t,Ac$1&&"sticky"in Dc$1&&(o=!!t&&Lc$1(t,"y")>-1)&&Fc$1&&(t=Tc$1(t,/y/g,"")),xi$4&&(i=function(e){for(var t,n=e.length,r=0,o="",i=[],a={},s=!1,l=!1,u=0,c="";r<=n;r++){if("\\"===(t=Nc$1(e,r)))t+=Nc$1(e,++r);else if("]"===t)s=!1;else if(!s)switch(!0){case"["===t:s=!0;break;case"("===t:Cc$1(Pc$1,Mc$1(e,r+1))&&(r+=2,l=!0),o+=t,u++;continue;case">"===t&&l:if(""===c||Se$6(a,c))throw new Ec$1("Invalid capture group name");a[c]=!0,i[i.length]=[c,u],l=!1,c="";continue}l?c+=t:o+=t;}return [o,i]}(e),e=i[0],f=i[1]),a=Ia$3(Sc$1(e,t),l?this:kc$1,_c$1),(r||o||f.length)&&(s=wc$1(a),r&&(s.dotAll=!0,s.raw=_c$1(function(e){for(var t,n=e.length,r=0,o="",i=!1;r<=n;r++)"\\"!==(t=Nc$1(e,r))?i||"."!==t?("["===t?i=!0:"]"===t&&(i=!1),o+=t):o+="[\\s\\S]":o+=t+Nc$1(e,++r);return o}(e),n)),o&&(s.sticky=!0),f.length&&(s.groups=f)),e!==d)try{wt$6(a,"source",""===d?"(?:)":d);}catch(e){}return a},Bc$1=function(e){e in _c$1||mc$1(_c$1,e,{configurable:!0,get:function(){return Sc$1[e]},set:function(t){Sc$1[e]=t;}});},$c$1=bc$1(Sc$1),Wc$1=0;$c$1.length>Wc$1;)Bc$1($c$1[Wc$1++]);kc$1.constructor=_c$1,_c$1.prototype=kc$1,zt$6(se$6,"RegExp",_c$1);}Dl$1("RegExp");var Vc$1=new RegExp(String.fromCharCode(160),"g");function zc$1(e){return e.replace(Vc$1," ")}function Hc$1(e,t){var n=e.length;if(n){var r=e[n-1];if(Text.isText(r)){var o=Object.keys(r);if(1===o.length&&"text"===o[0])return r.text=r.text+t,!0}}return !1}function Uc$1(e,t,n){return {type:"paragraph",children:[{text:$$6(e).text().replace(/\s+/gm," ")}]}}function Kc$1(t,n){var r=function(e,t){var n=[];if(null!=e.attr("data-w-e-is-void"))return n;var r=e[0].childNodes;return 1===r.length&&"BR"===r[0].nodeName?(n.push({text:""}),n):(r.forEach((function(e){if(e.nodeType!==Bs$1.ELEMENT_NODE)if(e.nodeType!==Bs$1.TEXT_NODE);else {var r=e.textContent||"";if(""===r.trim()&&r.indexOf("\n")>=0)return;r&&(r=zc$1(r),Hc$1(n,r)||n.push({text:r}));}else {if("BR"===e.nodeName)return void(Hc$1(n,"\n")||n.push({text:"\n"}));var o=Gc$1($$6(e),t);Array.isArray(o)?o.forEach((function(e){return n.push(e)})):n.push(o);}})),n)}(t,n),o=function(e){for(var t in vc$1)if(e[0].matches(t))return vc$1[t];return Uc$1}(t),i=o(t[0],r,n);return Array.isArray(i)||(i=[i]),i.forEach((function(o){Editor.isVoid(n,o)||(0===r.length&&(o.children=[{text:t.text().replace(/\s+/gm," ")}]),pc$1.forEach((function(e){o=e(t[0],o,n);})));})),i}function qc$1(e,t){0===e.parents("pre").length&&(e[0].innerHTML=e[0].innerHTML.replace(/\s+/gm," ").replace(/<br>/g,"\n"));var n=e[0].textContent||"";n=function(e){return e.replace(/&nbsp;/g," ").replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&reg;/g,"®").replace(/&copy;/g,"©").replace(/&trade;/g,"™")}(n);var r={text:n=zc$1(n)};return pc$1.forEach((function(n){r=n(e[0],r,t);})),r}function Gc$1(e,t){dc$1.forEach((function(t){var n=t.selector,r=t.preParseHtml;e[0].matches(n)&&(e=$$6(r(e[0])));}));var n=Ys$1(e);return "span"===n?e.attr("data-w-e-type")?Kc$1(e,t):qc$1(e,t):"code"===n?"pre"===Ys$1(e.parent())?Kc$1(e,t):qc$1(e,t):fc$1.includes(n)?qc$1(e,t):Kc$1(e,t)}function Jc$1(e,t,n){var r=$$6(n);return !!r.attr(t)||(r.attr(t,"true"),e.on("destroyed",(function(){r.removeAttr(t);})),!1)}function Yc$1(e,t){void 0===t&&(t="");var n=[];""===t&&(t="<p><br></p>"),0!==t.indexOf("<")&&(t=t.split(/\n/).map((function(e){return "<p>"+e+"</p>"})).join(""));var r=$$6("<div>"+t+"</div>");return Array.from(r.children()).forEach((function(t){var r=Gc$1($$6(t),e);Array.isArray(r)?r.forEach((function(e){return n.push(e)})):n.push(r);})),n}var Xc$1=mt$6.f,Qc$1=Ma$3.fastKey,Zc$1=_t$6.set,ef$1=_t$6.getterFor,tf$1={getConstructor:function(e,t,n,r){var o=e((function(e,o){Fa$3(e,i),Zc$1(e,{type:t,index:Br$5(null),first:void 0,last:void 0,size:0}),Ke$6||(e.size=0),null!=o&&ja$2(o,e[r],{that:e,AS_ENTRIES:n});})),i=o.prototype,a=ef$1(t),s=function(e,t,n){var r,o,i=a(e),s=l(e,t);return s?s.value=n:(i.last=s={index:o=Qc$1(t,!0),key:t,value:n,previous:r=i.last,next:void 0,removed:!1},i.first||(i.first=s),r&&(r.next=s),Ke$6?i.size++:e.size++,"F"!==o&&(i.index[o]=s)),e},l=function(e,t){var n,r=a(e),o=Qc$1(t);if("F"!==o)return r.index[o];for(n=r.first;n;n=n.next)if(n.key==t)return n};return ba$3(i,{clear:function(){for(var e=a(this),t=e.index,n=e.first;n;)n.removed=!0,n.previous&&(n.previous=n.previous.next=void 0),delete t[n.index],n=n.next;e.first=e.last=void 0,Ke$6?e.size=0:this.size=0;},delete:function(e){var t=this,n=a(t),r=l(t,e);if(r){var o=r.next,i=r.previous;delete n.index[r.index],r.removed=!0,i&&(i.next=o),o&&(o.previous=i),n.first==r&&(n.first=o),n.last==r&&(n.last=i),Ke$6?n.size--:t.size--;}return !!r},forEach:function(e){for(var t,n=a(this),r=rn$6(e,arguments.length>1?arguments[1]:void 0);t=t?t.next:n.first;)for(r(t.value,t.key,this);t&&t.removed;)t=t.previous;},has:function(e){return !!l(this,e)}}),ba$3(i,n?{get:function(e){var t=l(this,e);return t&&t.value},set:function(e,t){return s(this,0===e?0:e,t)}}:{add:function(e){return s(this,e=0===e?0:e,e)}}),Ke$6&&Xc$1(i,"size",{get:function(){return a(this).size}}),o},setStrong:function(e,t,n){var r=t+" Iterator",o=ef$1(t),i=ef$1(r);Yo$5(e,t,(function(e,t){Zc$1(this,{type:r,target:e,state:o(e),kind:t,last:void 0});}),(function(){for(var e=i(this),t=e.kind,n=e.last;n&&n.removed;)n=n.previous;return e.target&&(e.last=n=n?n.next:e.state.first)?"keys"==t?{value:n.key,done:!1}:"values"==t?{value:n.value,done:!1}:{value:[n.key,n.value],done:!1}:(e.target=void 0,{value:void 0,done:!0})}),n?"entries":"values",!n,!0),Dl$1(t);}};_a$3("Set",(function(e){return function(){return e(this,arguments.length?arguments[0]:void 0)}}),tf$1);var nf$1=new Set(["doctype","!doctype","meta","script","style","link","frame","iframe","title","svg"]);function rf$1(e,t){e.isInline(t)?(e.insertNode(t),"link"===t.type&&e.insertFragment([{text:""}])):Transforms.insertNodes(e,t,{mode:"highest"});}var of$1=function(t){var l=t,u=l.onChange,c=l.insertText,d=l.apply,h=l.deleteBackward;return l.insertText=function(e){l.getConfig().readOnly||c(e);},l.apply=function(t){var r,o,i,a,s,u,c,f,h=[];switch(t.type){case"insert_text":case"remove_text":case"set_node":try{for(var p=fa$4(Editor.levels(l,{at:t.path})),g=p.next();!g.done;g=p.next()){var v=da$4(g.value,2),y=v[0],m=v[1],b=ol$1.findKey(l,y);h.push([m,b]);}}catch(e){r={error:e};}finally{try{g&&!g.done&&(o=p.return)&&o.call(p);}finally{if(r)throw r.error}}break;case"insert_node":case"remove_node":case"merge_node":case"split_node":try{for(var w=fa$4(Editor.levels(l,{at:Path.parent(t.path)})),x=w.next();!x.done;x=w.next()){var S=da$4(x.value,2);y=S[0],m=S[1],b=ol$1.findKey(l,y);h.push([m,b]);}}catch(e){i={error:e};}finally{try{x&&!x.done&&(a=w.return)&&a.call(w);}finally{if(i)throw i.error}}break;case"move_node":try{for(var k=fa$4(Editor.levels(l,{at:Path.common(Path.parent(t.path),Path.parent(t.newPath))})),E=k.next();!E.done;E=k.next()){var O=da$4(E.value,2);y=O[0],m=O[1],b=ol$1.findKey(l,y);h.push([m,b]);}}catch(e){s={error:e};}finally{try{E&&!E.done&&(u=k.return)&&u.call(k);}finally{if(s)throw s.error}}}d(t);try{for(var C=fa$4(h),N=C.next();!N.done;N=C.next()){var T=da$4(N.value,2);m=T[0],b=T[1],y=da$4(Editor.node(l,m),1)[0];Ms$1.set(y,b);}}catch(e){c={error:e};}finally{try{N&&!N.done&&(f=C.return)&&f.call(C);}finally{if(c)throw c.error}}},l.deleteBackward=function(n){if("line"!==n)return h(n);if(t.selection&&Range.isCollapsed(t.selection)){var r=Editor.above(t,{match:function(n){return Editor.isBlock(t,n)},at:t.selection});if(r){var i=da$4(r,2)[1],a=Editor.range(t,i,t.selection.anchor),u=function(t,n){var r=Editor.range(t,Range.end(n)),i=Array.from(Editor.positions(t,{at:n})),a=0,s=i.length,l=Math.floor(s/2);if(cc$1(t,Editor.range(t,i[a]),r))return Editor.range(t,i[a],r);if(i.length<2)return Editor.range(t,i[i.length-1],r);for(;l!==i.length&&l!==a;)cc$1(t,Editor.range(t,i[l]),r)?s=l:a=l,l=Math.floor((a+s)/2);return Editor.range(t,i[s],r)}(l,a);Range.isCollapsed(u)||Transforms.delete(t,{at:u});}}},l.onChange=function(){var e=l.selection;null!=e&&Rs$1.set(l,e),l.emit("change"),u();},l.handleTab=function(){l.insertText("    ");},l.getHtml=function(){var e=l.children;return (void 0===e?[]:e).map((function(e){return sc$1(e,l)})).join("")},l.getText=function(){var e=l.children;return (void 0===e?[]:e).map((function(e){return Node$1.string(e)})).join("\n")},l.getSelectionText=function(){var n=l.selection;return null==n?"":Editor.string(t,n)},l.getElemsByType=function(t,n){var r,o;void 0===n&&(n=!1);var a=[],s=Editor.nodes(l,{at:[],universal:!0});try{for(var u=fa$4(s),c=u.next();!c.done;c=u.next()){var f=da$4(c.value,1)[0];if(Element$1.isElement(f))if(n?f.type.indexOf(t)>=0:f.type===t){var d=lc$1(ol$1.findKey(l,f).id);a.push(ca$4(ca$4({},f),{id:d}));}}}catch(e){r={error:e};}finally{try{c&&!c.done&&(o=u.return)&&o.call(u);}finally{if(r)throw r.error}}return a},l.getElemsByTypePrefix=function(e){return l.getElemsByType(e,!0)},l.isEmpty=function(){var e=l.children,t=void 0===e?[]:e;if(t.length>1)return !1;var n=t[0];if(null==n)return !0;if(Element$1.isElement(n)&&"paragraph"===n.type){var r=n.children,o=void 0===r?[]:r;if(o.length>1)return !1;var s=o[0];if(null==s)return !0;if(Text.isText(s)&&""===s.text)return !0}return !1},l.clear=function(){Transforms.delete(l,{at:{anchor:Editor.start(l,[]),focus:Editor.end(l,[])}}),0===l.children.length&&Transforms.insertNodes(l,[{type:"paragraph",children:[{text:""}]}]);},l.getParentNode=function(e){return ol$1.getParentNode(l,e)},l.dangerouslyInsertHtml=function(e,t){if(void 0===e&&(e=""),void 0===t&&(t=!1),e){var n=document.createElement("div");n.innerHTML=e;var r=Array.from(n.childNodes);if(r=r.filter((function(e){var t=e.nodeType,n=e.nodeName;return t===Bs$1.TEXT_NODE||t===Bs$1.ELEMENT_NODE&&!nf$1.has(n.toLowerCase())})),0!==r.length){var o=l.selection;if(null!=o){var i=null;if(ol$1.isSelectedEmptyParagraph(l)&&!t)i=[o.focus.path[0]];n.setAttribute("hidden","true"),document.body.appendChild(n);var a=0;r.forEach((function(e){var t=e.nodeType,n=e.nodeName,r=e.textContent,o=void 0===r?"":r;if(t!==Bs$1.TEXT_NODE)if("BR"!==n){var i=e,s=!1;if(fc$1.includes(n.toLowerCase()))s=!0;else for(var u in vc$1)if(i.matches(u)){s=!0;break}if(s){var c=Gc$1($$6(i),l);return Array.isArray(c)?(c.forEach((function(e){return rf$1(l,e)})),a++):(rf$1(l,c),a++),void(ol$1.isSelectedVoidNode(l)&&l.move(1))}var d=window.getComputedStyle(i).display;ol$1.isSelectedEmptyParagraph(l)||d.indexOf("inline")<0&&l.insertBreak(),l.dangerouslyInsertHtml(i.innerHTML,!0);}else l.insertText("\n");else {if(!o||!o.trim())return;l.insertNode({text:o});}})),a&&i&&ol$1.isEmptyPath(l,i)&&Transforms.removeNodes(l,{at:i}),n.remove();}}}},l.setHtml=function(t){void 0===t&&(t="");var n=l.isDisabled(),r=l.isFocused(),o=JSON.stringify(l.selection);l.enable(),l.focus(),l.clear();var i=Yc$1(l,t);if(Transforms.insertFragment(l,i),r||(l.deselect(),l.blur()),n&&(l.deselect(),l.disable()),l.isFocused())try{l.select(JSON.parse(o));}catch(t){l.select(Editor.start(l,[]));}},l},af$1=function(t){var n=t,r=n.insertText;return n.insertFragment,n.setFragmentData=function(t){var r=n.selection;if(r){var i=da$4(Range.edges(r),2),a=i[0],s=i[1],l=Editor.void(n,{at:a.path}),u=Editor.void(n,{at:s.path});if(!Range.isCollapsed(r)||l){var c=ol$1.toDOMRange(n,r),f=c.cloneContents(),d=f.childNodes[0];if(f.childNodes.forEach((function(e){e.textContent&&""!==e.textContent.trim()&&(d=e);})),u){var h=da$4(u,1)[0],p=c.cloneRange(),g=ol$1.toDOMNode(n,h);p.setEndAfter(g),f=p.cloneContents();}if(l&&(d=f.querySelector("[data-slate-spacer]")),Array.from(f.querySelectorAll("[data-slate-zero-width]")).forEach((function(e){var t="n"===e.getAttribute("data-slate-zero-width");e.textContent=t?"\n":"";})),Hs$1(d)){var v=d.ownerDocument.createElement("span");v.style.whiteSpace="pre",v.appendChild(d),f.appendChild(v),d=v;}var y=n.getFragment(),m=JSON.stringify(y),b=window.btoa(encodeURIComponent(m));d.setAttribute("data-slate-fragment",b),t.setData("application/x-slate-fragment",b);var w=f.ownerDocument.createElement("div");return w.appendChild(f),w.setAttribute("hidden","true"),f.ownerDocument.body.appendChild(w),t.setData("text/html",w.innerHTML),t.setData("text/plain",Gs$1(w)),f.ownerDocument.body.removeChild(w),t}}},n.insertData=function(e){var t,o,i=e.getData("application/x-slate-fragment");if(i){var a=decodeURIComponent(window.atob(i)),l=JSON.parse(a);n.insertFragment(l);}else {var u=e.getData("text/plain"),c=e.getData("text/html");if(c)n.dangerouslyInsertHtml(c);else if(u){var f=u.split(/\r\n|\r|\n/),d=!1;try{for(var h=fa$4(f),p=h.next();!p.done;p=h.next()){var g=p.value;d&&Transforms.splitNodes(n,{always:!0}),r(g),d=!0;}}catch(e){t={error:e};}finally{try{p&&!p.done&&(o=h.return)&&o.call(h);}finally{if(t)throw t.error}}}else;}},n},sf$1=function(e){return null!=e},lf$1={object:!0,function:!0,undefined:!0},uf$1=function(e){if(!function(e){return !!sf$1(e)&&hasOwnProperty.call(lf$1,typeof e)}(e))return !1;try{return !!e.constructor&&e.constructor.prototype===e}catch(e){return !1}},cf$1=/^\s*class[\s{/}]/,ff$1=Function.prototype.toString,df$1=function(e){return !!function(e){if("function"!=typeof e)return !1;if(!hasOwnProperty.call(e,"length"))return !1;try{if("number"!=typeof e.length)return !1;if("function"!=typeof e.call)return !1;if("function"!=typeof e.apply)return !1}catch(e){return !1}return !uf$1(e)}(e)&&!cf$1.test(ff$1.call(e))},hf$1=function(e){return null!=e},pf$1=Object.keys,gf$1=function(){try{return Object.keys("primitive"),!0}catch(e){return !1}}()?Object.keys:function(e){return pf$1(hf$1(e)?Object(e):e)},vf$1=function(e){if(!hf$1(e))throw new TypeError("Cannot use null or undefined");return e},yf$1=Math.max,mf$1=function(){var e,t=Object.assign;return "function"==typeof t&&(t(e={foo:"raz"},{bar:"dwa"},{trzy:"trzy"}),e.foo+e.bar+e.trzy==="razdwatrzy")}()?Object.assign:function(e,t){var n,r,o,i=yf$1(arguments.length,2);for(e=Object(vf$1(e)),o=function(r){try{e[r]=t[r];}catch(e){n||(n=e);}},r=1;r<i;++r)gf$1(t=arguments[r]).forEach(o);if(void 0!==n)throw n;return e},bf$1=Array.prototype.forEach,wf$1=Object.create,xf$1=function(e,t){var n;for(n in e)t[n]=e[n];},Sf$1=function(e){var t=wf$1(null);return bf$1.call(arguments,(function(e){hf$1(e)&&xf$1(Object(e),t);})),t},kf$1="razdwatrzy",Ef$1=String.prototype.indexOf,Of$1="function"==typeof kf$1.contains&&!0===kf$1.contains("dwa")&&!1===kf$1.contains("foo")?String.prototype.contains:function(e){return Ef$1.call(this,e,arguments[1])>-1},Cf$1=re$6((function(e){var t=e.exports=function(e,t){var n,r,o,i,a;return arguments.length<2||"string"!=typeof e?(i=t,t=e,e=null):i=arguments[2],sf$1(e)?(n=Of$1.call(e,"c"),r=Of$1.call(e,"e"),o=Of$1.call(e,"w")):(n=o=!0,r=!1),a={value:t,configurable:n,enumerable:r,writable:o},i?mf$1(Sf$1(i),a):a};t.gs=function(e,t,n){var r,o,i,a;return "string"!=typeof e?(i=n,n=t,t=e,e=null):i=arguments[3],sf$1(t)?df$1(t)?sf$1(n)?df$1(n)||(i=n,n=void 0):n=void 0:(i=t,t=n=void 0):t=void 0,sf$1(e)?(r=Of$1.call(e,"c"),o=Of$1.call(e,"e")):(r=!0,o=!1),a={get:t,set:n,configurable:r,enumerable:o},i?mf$1(Sf$1(i),a):a};})),Nf$1=function(e){if("function"!=typeof e)throw new TypeError(e+" is not a function");return e},Tf$1=re$6((function(e,t){var n,r,o,i,a,s,l,u=Function.prototype.apply,c=Function.prototype.call,f=Object.create,d=Object.defineProperty,h=Object.defineProperties,p=Object.prototype.hasOwnProperty,g={configurable:!0,enumerable:!1,writable:!0};n=function(e,t){var n;return Nf$1(t),p.call(this,"__ee__")?n=this.__ee__:(n=g.value=f(null),d(this,"__ee__",g),g.value=null),n[e]?"object"==typeof n[e]?n[e].push(t):n[e]=[n[e],t]:n[e]=t,this},r=function(e,t){var r,i;return Nf$1(t),i=this,n.call(this,e,r=function(){o.call(i,e,r),u.call(t,this,arguments);}),r.__eeOnceListener__=t,this},o=function(e,t){var n,r,o,i;if(Nf$1(t),!p.call(this,"__ee__"))return this;if(!(n=this.__ee__)[e])return this;if("object"==typeof(r=n[e]))for(i=0;o=r[i];++i)o!==t&&o.__eeOnceListener__!==t||(2===r.length?n[e]=r[i?0:1]:r.splice(i,1));else r!==t&&r.__eeOnceListener__!==t||delete n[e];return this},i=function(e){var t,n,r,o,i;if(p.call(this,"__ee__")&&(o=this.__ee__[e]))if("object"==typeof o){for(n=arguments.length,i=new Array(n-1),t=1;t<n;++t)i[t-1]=arguments[t];for(o=o.slice(),t=0;r=o[t];++t)u.call(r,this,i);}else switch(arguments.length){case 1:c.call(o,this);break;case 2:c.call(o,this,arguments[1]);break;case 3:c.call(o,this,arguments[1],arguments[2]);break;default:for(n=arguments.length,i=new Array(n-1),t=1;t<n;++t)i[t-1]=arguments[t];u.call(o,this,i);}},a={on:n,once:r,off:o,emit:i},s={on:Cf$1(n),once:Cf$1(r),off:Cf$1(o),emit:Cf$1(i)},l=h({},s),e.exports=t=function(e){return null==e?f(l):h(Object(e),s)},t.methods=a;}));function Lf$1(e){var t=js$1.get(e);return null==t&&(t=Tf$1(),js$1.set(e,t)),t}var Mf$1=new WeakMap;function Pf$1(e,t){var n=Mf$1.get(e);null==n&&(n=new Set,Mf$1.set(e,n)),n.add(t);}function Df$1(e){return Mf$1.get(e)||new Set}function Rf$1(e){Mf$1.set(e,new Set);}function jf$1(e){var t=ol$1.getTextarea(e).$textAreaContainer,n=t.width(),r=t.height(),o=t.offset();return {top:o.top,left:o.left,width:n,height:r}}function Af$1(e){var t={top:"0",left:"0"},n=e.selection;if(null==n)return t;var r=jf$1(e);if(null==r)return t;var o=r.top,i=r.left,a=r.width,s=r.height,l=ol$1.toDOMRange(e,n).getClientRects()[0];if(null==l)return t;l.width;var u=l.height,c={},f=l.top-o,d=l.left-i;if(d>a/2){var h=a-d;c.right=h+5+"px";}else c.left=d+5+"px";if(f>s/2){var p=s-f;c.bottom=p+5+"px";}else {var g=f+u;g<0&&(g=0),c.top=g+5+"px";}return c}function Ff$1(e,t,n){void 0===n&&(n="modal");var r={top:"0",left:"0"};if(null==e.selection)return r;var o=Element$1.isElement(t)&&e.isVoid(t),a=Element$1.isElement(t)&&e.isInline(t),s=Ls$1.get(t);if(null==s)return r;var l=s.getBoundingClientRect(),u=l.top,c=l.left,f=l.height,d=l.width;if(o){var h=function(e){var t=[];t.push(e);for(var n=0;t.length>0;){var r=t.pop();if(null==r)break;if(++n>1e4)break;var o=r.nodeName;if(1===r.nodeType){var i=o.toLowerCase();if(_s$1.includes(i)||"iframe"===i||"video"===i)return r;var a=r.children||[],s=a.length;if(s)for(var l=s-1;l>=0;l--)t.push(a[l]);}}return null}(s);if(null!=h){var p=h.getBoundingClientRect();u=p.top,f=p.height;}}var g=jf$1(e);if(null==g)return r;var v=g.top,y=g.left,m=g.width,b=g.height,w={},x=u-v,S=c-y;if("bar"===n)return w.left=S+"px",x>40?w.bottom=b-x+5+"px":w.top=x+f+5+"px",w;if("modal"===n){var k;if(o?a?S>(m-d)/2?w.right=m-S+5+"px":w.left=S+d+5+"px":w.left="20px":w.left=S+"px",o)(k=x)<0&&(k=0),w.top=k+"px";else if(x>(b-f)/2)w.bottom=b-x+5+"px";else (k=x+f)<0&&(k=0),w.top=k+5+"px";return w}throw new Error("type '"+n+"' is invalid")}function If$1(e,t){ac$1((function(){var n=jf$1(e);if(null!=n){var r,o=n.top,i=n.left,a=n.width,s=n.height,l=t.offset(),u=l.top,c=l.left,f=t.width(),d=t.height(),h=u-o,p=c-i,g=t.attr("style");if(g.indexOf("top")>=0)if((r=h+d-s)>0){var v=t.css("top"),y=parseInt(v.toString())-r;y<0&&(y=0),t.css("top",y+"px");}if(g.indexOf("bottom")>=0&&u<0){var m=t.css("bottom"),b=parseInt(m.toString())-Math.abs(u);t.css("bottom",b+"px");}if(g.indexOf("left")>=0)if((r=p+f-a)>0){var w=t.css("left"),x=parseInt(w.toString())-r;x<0&&(x=0),t.css("left",x+"px");}if(g.indexOf("right")>=0&&c<0){var S=t.css("right"),k=parseInt(S.toString())-Math.abs(c);t.css("right",k+"px");}}}));}var _f$1=fi$5("slice"),Bf$1=ze$6("species"),$f$1=se$6.Array,Wf$1=Math.max;cr$5({target:"Array",proto:!0,forced:!_f$1},{slice:function(e,t){var n,r,o,i=_n$6(this),a=hn$6(i),s=zn$6(e,a),l=zn$6(void 0===t?a:t,a);if(pn$6(i)&&(n=i.constructor,(Sn$6(n)&&(n===$f$1||pn$6(n.prototype))||qe$6(n)&&null===(n=n[Bf$1]))&&(n=void 0),n===$f$1||void 0===n))return Fl$1(i,s,l);for(r=new(void 0===n?$f$1:n)(Wf$1(l-s,0)),o=0;s<l;s++,o++)s in i&&ao$5(r,o,i[s]);return r.length=o,r}});var Vf$1=$n$6.f,zf$1=ve$6("".startsWith),Hf$1=ve$6("".slice),Uf$1=Math.min,Kf$1=Jr$5("startsWith"),qf$1=!Kf$1&&!!function(){var e=Vf$1(String.prototype,"startsWith");return e&&!e.writable}();cr$5({target:"String",proto:!0,forced:!qf$1&&!Kf$1},{startsWith:function(e){var t=kr$5(me$6(this));qr$5(e);var n=dn$6(Uf$1(arguments.length>1?arguments[1]:void 0,t.length)),r=kr$5(e);return zf$1?zf$1(t,r,n):Hf$1(t,n,n+r.length)===r}});var Gf$1=Object.assign,Jf$1=Object.defineProperty,Yf$1=ve$6([].concat),Xf$1=!Gf$1||Fe$6((function(){if(Ke$6&&1!==Gf$1({b:1},Gf$1(Jf$1({},"a",{enumerable:!0,get:function(){Jf$1(this,"b",{value:3,enumerable:!1});}}),{b:2})).b)return !0;var e={},t={},n=Symbol(),r="abcdefghijklmnopqrst";return e[n]=7,r.split("").forEach((function(e){t[e]=e;})),7!=Gf$1({},e)[n]||fr$5(Gf$1({},t)).join("")!=r}))?function(e,t){for(var n=we$6(e),r=arguments.length,o=1,i=Qn$6.f,a=In$6.f;r>o;)for(var s,l=sn$6(arguments[o++]),u=i?Yf$1(fr$5(l),i(l)):fr$5(l),c=u.length,f=0;c>f;)s=u[f++],Ke$6&&!nt$6(a,l,s)||(n[s]=l[s]);return n}:Gf$1;cr$5({target:"Object",stat:!0,forced:Object.assign!==Xf$1},{assign:Xf$1});var Qf$1=["props","attrs","style","dataset","on","hook"];function Zf$1(e){var t=e.data,n=void 0===t?{}:t,r=e.children,o=void 0===r?[]:r;Object.keys(n).forEach((function(t){var r,o,i=n[t];if("key"!==t){if(!Qf$1.includes(t)){if(t.startsWith("data-")){var a=t.slice(5);return a=lodash_camelcase(a),function(e,t){null==e.data&&(e.data={});var n=e.data;null==n.dataset&&(n.dataset={});Object.assign(n.dataset,t);}(e,((r={})[a]=i,r)),void delete n[t]}!function(e,t){null==e.data&&(e.data={});var n=e.data;null==n.props&&(n.props={});Object.assign(n.props,t);}(e,(o={},o[t]=i,o)),delete n[t];}}else e.key=i;})),o.length>0&&o.forEach((function(e){"string"!=typeof e&&Zf$1(e);}));}var ed$1=[];function td$1(e){ed$1.push(e);}var nd$1={};function rd$1(e){var t=e.type,n=e.renderElem;nd$1[t||""]=n;}function od$1(e,t,n){var r=n.isInline(e)?"span":"div";return jsx(r,null,t)}function id$1(t,n){var o,i=ol$1.findKey(n,t),a=n.isInline(t),s=Editor.isVoid(n,t),l=lc$1(i.id),u={id:l,key:i.id,"data-slate-node":"element","data-slate-inline":a},c=t.type,f=t.children,d=void 0===f?[]:f,h=function(e){return nd$1[e]||od$1}(c);o=s?null:d.map((function(e,r){return ud$1(e,r,t,n)}));var p=h(t,o,n);if(s){u["data-slate-void"]=!0;var g=a?"span":"div",v=da$4(Node$1.texts(t),1),y=da$4(v[0],1)[0],m=ud$1(y,0,t,n),b=jsx(g,{"data-slate-spacer":!0,style:{height:"0",color:"transparent",outline:"none",position:"absolute"}},m);p=jsx(g,{style:{position:"relative"}},p,b),Es$1.set(y,0),Os$1.set(y,t);}return null==p.data&&(p.data={}),Object.assign(p.data,u),s||a||(p=function(e,t){var n=t;return ed$1.forEach((function(r){n=r(e,t);})),n}(t,p)),ac$1((function(){var e=Us$1(l);null!=e&&(Ts$1.set(i,e),Ls$1.set(t,e),Ns$1.set(e,t));})),p}function ad$1(e,t){return void 0===t&&(t=!1),jsx("span",{"data-slate-string":!0},t?e+"\n":e)}function sd$1(e,t){return void 0===e&&(e=0),void 0===t&&(t=!1),jsx("span",{"data-slate-zero-width":t?"n":"z","data-slate-length":e},"\ufeff",t?jsx("br",null):null)}function ld$1(t,o,i){if(null==t.text)throw new Error("Current node is not slate Text "+JSON.stringify(t));var s=ol$1.findKey(i,t),l=i.getConfig().decorate;if(null==l)throw new Error("Can not get config.decorate");var u=ol$1.findPath(i,t),c=l([t,u]),f=Text.decorations(t,c),d=f.map((function(a,s){var l=function(t,o,i,a,s){void 0===o&&(o=!1);var l=t.text,u=ol$1.findPath(s,i),c=Path.parent(u);if(Editor.isEditor(a))throw new Error("Text node "+JSON.stringify(i)+" parent is Editor");return s.isVoid(a)?sd$1(Node$1.string(a).length):""!==l||a.children[a.children.length-1]!==i||s.isInline(a)||""!==Editor.string(s,c)?""===l?sd$1():o&&"\n"===l.slice(-1)?ad$1(l,!0):ad$1(l):sd$1(0,!0)}(a,s===f.length-1,t,o,i);return l=function(e,t){var n=t;return ed$1.forEach((function(t){n=t(e,n);})),n}(a,l),jsx("span",{"data-slate-leaf":!0},l)})),h=function(e){return "w-e-text-"+e}(s.id),p=jsx("span",{"data-slate-node":"text",id:h,key:s.id},d);return ac$1((function(){var e=Us$1(h);null!=e&&(Ts$1.set(s,e),Ls$1.set(t,e),Ns$1.set(e,t));})),p}function ud$1(e,t,n,r){return Es$1.set(e,t),Os$1.set(e,n),Element$1.isElement(e)?id$1(e,r):ld$1(e,n,r)}function cd$1(e,t){var n,r=e.$scroll,o=function(e){return "w-e-textarea-"+e}(e.id),i=t.getConfig(),a=i.readOnly,s=i.autoFocus,l=function(e,t){return void 0===t&&(t=!1),h$3("div#"+e,{props:{contentEditable:!t}})}(o,a),u=t.children||[];l.children=u.map((function(e,n){var r=ud$1(e,n,t,t);return Zf$1(r),r}));var c=xs$1.get(e);if(null==c&&(c=!0),c){var d=function(e,t){return $$6('<div\n        id="'+e+'"\n        data-slate-editor\n        data-slate-node="value"\n        suppressContentEditableWarning\n        role="textarea"\n        spellCheck="true"\n        autoCorrect="true"\n        autoCapitalize="true"\n    ></div>')}(o);r.append(d),e.$textArea=d,n=d[0],(p=init([classModule,propsModule,styleModule,datasetModule,eventListenersModule,attributesModule]))(n,l),xs$1.set(e,!1),Ss$1.set(e,p);}else {var h=ks$1.get(e),p=Ss$1.get(e);if(null==h||null==p)return;n=h.elm,p(h,l);}if(null!=n||null!=(n=Us$1(o))){if((c?s:t.isFocused())&&n.focus({preventScroll:!0}),c){var g=$s$1(n);g&&Ps$1.set(t,g);}Cs$1.set(t,n),Ls$1.set(t,n),Ns$1.set(n,t),ks$1.set(e,l);}}function fd$1(e){return "object"==typeof e&&null!=e&&1===e.nodeType}function dd$1(e,t){return (!t||"hidden"!==e)&&"visible"!==e&&"clip"!==e}function hd$1(e,t){if(e.clientHeight<e.scrollHeight||e.clientWidth<e.scrollWidth){var n=getComputedStyle(e,null);return dd$1(n.overflowY,t)||dd$1(n.overflowX,t)||function(e){var t=function(e){if(!e.ownerDocument||!e.ownerDocument.defaultView)return null;try{return e.ownerDocument.defaultView.frameElement}catch(e){return null}}(e);return !!t&&(t.clientHeight<e.scrollHeight||t.clientWidth<e.scrollWidth)}(e)}return !1}function pd$1(e,t,n,r,o,i,a,s){return i<e&&a>t||i>e&&a<t?0:i<=e&&s<=n||a>=t&&s>=n?i-e-r:a>t&&s<n||i<e&&s>n?a-t+o:0}function gd$1(e,t){var n=window,r=t.scrollMode,o=t.block,i=t.inline,a=t.boundary,s=t.skipOverflowHiddenElements,l="function"==typeof a?a:function(e){return e!==a};if(!fd$1(e))throw new TypeError("Invalid target");for(var u=document.scrollingElement||document.documentElement,c=[],f=e;fd$1(f)&&l(f);){if((f=f.parentElement)===u){c.push(f);break}null!=f&&f===document.body&&hd$1(f)&&!hd$1(document.documentElement)||null!=f&&hd$1(f,s)&&c.push(f);}for(var d=n.visualViewport?n.visualViewport.width:innerWidth,h=n.visualViewport?n.visualViewport.height:innerHeight,p=window.scrollX||pageXOffset,g=window.scrollY||pageYOffset,v=e.getBoundingClientRect(),y=v.height,m=v.width,b=v.top,w=v.right,x=v.bottom,S=v.left,k="start"===o||"nearest"===o?b:"end"===o?x:b+y/2,E="center"===i?S+m/2:"end"===i?w:S,O=[],C=0;C<c.length;C++){var N=c[C],T=N.getBoundingClientRect(),L=T.height,M=T.width,P=T.top,D=T.right,R=T.bottom,j=T.left;if("if-needed"===r&&b>=0&&S>=0&&x<=h&&w<=d&&b>=P&&x<=R&&S>=j&&w<=D)return O;var A=getComputedStyle(N),F=parseInt(A.borderLeftWidth,10),I=parseInt(A.borderTopWidth,10),_=parseInt(A.borderRightWidth,10),B=parseInt(A.borderBottomWidth,10),$=0,W=0,V="offsetWidth"in N?N.offsetWidth-N.clientWidth-F-_:0,z="offsetHeight"in N?N.offsetHeight-N.clientHeight-I-B:0;if(u===N)$="start"===o?k:"end"===o?k-h:"nearest"===o?pd$1(g,g+h,h,I,B,g+k,g+k+y,y):k-h/2,W="start"===i?E:"center"===i?E-d/2:"end"===i?E-d:pd$1(p,p+d,d,F,_,p+E,p+E+m,m),$=Math.max(0,$+g),W=Math.max(0,W+p);else {$="start"===o?k-P-I:"end"===o?k-R+B+z:"nearest"===o?pd$1(P,R,L,I,B+z,k,k+y,y):k-(P+L/2)+z/2,W="start"===i?E-j-F:"center"===i?E-(j+M/2)+V/2:"end"===i?E-D+_+V:pd$1(j,D,M,F,_+V,E,E+m,m);var H=N.scrollLeft,U=N.scrollTop;k+=U-($=Math.max(0,Math.min(U+$,N.scrollHeight-L+z))),E+=H-(W=Math.max(0,Math.min(H+W,N.scrollWidth-M+V)));}O.push({el:N,top:$,left:W});}return O}function vd$1(e){return e===Object(e)&&0!==Object.keys(e).length}function yd$1(e,t){var n=!e.ownerDocument.documentElement.contains(e);if(vd$1(t)&&"function"==typeof t.behavior)return t.behavior(n?[]:gd$1(e,t));if(!n){var r=function(e){return !1===e?{block:"end",inline:"nearest"}:vd$1(e)?e:{block:"start",inline:"nearest"}}(t);return function(e,t){void 0===t&&(t="auto");var n="scrollBehavior"in document.body.style;e.forEach((function(e){var r=e.el,o=e.top,i=e.left;r.scroll&&n?r.scroll({top:o,left:i,behavior:t}):(r.scrollTop=o,r.scrollLeft=i);}));}(gd$1(e,r),r.behavior)}}function md$1(e,t){return Vs$1(t)&&ol$1.hasDOMNode(e,t,{editable:!0})}function bd$1(t,n){if(t.getConfig().readOnly)return !1;var r=wd$1(t,n)&&ol$1.toSlateNode(t,n);return Editor.isVoid(t,r)}function wd$1(e,t){return Vs$1(t)&&ol$1.hasDOMNode(e,t)}function xd$1(e,t,n){void 0===n&&(n=!1);var r=t.selection,i=t.getConfig(),a=ol$1.findDocumentOrShadowRoot(t).getSelection();if(a&&(!e.isComposing||n)&&t.isFocused()){var s="None"!==a.type;if(r||s){var l=Cs$1.get(t),u=!1;if(l.contains(a.anchorNode)&&l.contains(a.focusNode)&&(u=!0),s&&u&&r){var c=ol$1.toSlateRange(t,a,{exactMatch:!0,suppressThrow:!0});if(c&&Range.equals(c,r)){var f=!0;if(Range.isCollapsed(r)){var d=a.anchorNode,h=a.anchorOffset;if(d===l){var p=l.childNodes,g=void 0;(g=p[h])&&g.matches("table")&&(f=!1),(g=p[h-1])&&g.matches("table")&&(f=!1);}}if(f)return}}if(!r||ol$1.hasRange(t,r)){e.isUpdatingSelection=!0;var v=r&&ol$1.toDOMRange(t,r);if(v){Range.isBackward(r)?a.setBaseAndExtent(v.endContainer,v.endOffset,v.startContainer,v.startOffset):a.setBaseAndExtent(v.startContainer,v.startOffset,v.endContainer,v.endOffset);var y=v.startContainer.parentElement;if(!y.closest("[data-slate-spacer]")){y.getBoundingClientRect=v.getBoundingClientRect.bind(v);var m=document.body;yd$1(y,{scrollMode:"if-needed",boundary:i.scroll?l.parentElement:m,block:"end",behavior:"smooth"}),delete y.getBoundingClientRect;}}else a.removeAllRanges();setTimeout((function(){v&&Qs$1&&l.focus(),e.isUpdatingSelection=!1;}));}else t.selection=ol$1.toSlateRange(t,a,{exactMatch:!1,suppressThrow:!1});}}}var Sd$1=new WeakMap,kd$1=new WeakMap;var Ed$1={bold:"mod+b",compose:["down","left","right","up","backspace","enter"],moveBackward:"left",moveForward:"right",moveWordBackward:"ctrl+left",moveWordForward:"ctrl+right",deleteBackward:"shift?+backspace",deleteForward:"shift?+delete",extendBackward:"shift+left",extendForward:"shift+right",italic:"mod+i",splitBlock:"shift?+enter",undo:"mod+z",tab:"tab",selectAll:"mod+a"},Od$1={moveLineBackward:"opt+up",moveLineForward:"opt+down",moveWordBackward:"opt+left",moveWordForward:"opt+right",deleteBackward:["ctrl+backspace","ctrl+h"],deleteForward:["ctrl+delete","ctrl+d"],deleteLineBackward:"cmd+shift?+backspace",deleteLineForward:["cmd+shift?+delete","ctrl+k"],deleteWordBackward:"opt+shift?+backspace",deleteWordForward:"opt+shift?+delete",extendLineBackward:"opt+shift+up",extendLineForward:"opt+shift+down",redo:"cmd+shift+z",transposeCharacter:"ctrl+t"},Cd$1={deleteWordBackward:"ctrl+shift?+backspace",deleteWordForward:"ctrl+shift?+delete",redo:["ctrl+y","ctrl+shift+z"]},Nd$1=function(e){var t=Ed$1[e],n=Od$1[e],r=Cd$1[e],o=t&&isKeyHotkey_1(t),i=n&&isKeyHotkey_1(n),a=r&&isKeyHotkey_1(r);return function(e){return !(!o||!o(e))||(!!(Xs$1&&i&&i(e))||!(Xs$1||!a||!a(e)))}},Td$1={isBold:Nd$1("bold"),isCompose:Nd$1("compose"),isMoveBackward:Nd$1("moveBackward"),isMoveForward:Nd$1("moveForward"),isDeleteBackward:Nd$1("deleteBackward"),isDeleteForward:Nd$1("deleteForward"),isDeleteLineBackward:Nd$1("deleteLineBackward"),isDeleteLineForward:Nd$1("deleteLineForward"),isDeleteWordBackward:Nd$1("deleteWordBackward"),isDeleteWordForward:Nd$1("deleteWordForward"),isExtendBackward:Nd$1("extendBackward"),isExtendForward:Nd$1("extendForward"),isExtendLineBackward:Nd$1("extendLineBackward"),isExtendLineForward:Nd$1("extendLineForward"),isItalic:Nd$1("italic"),isMoveLineBackward:Nd$1("moveLineBackward"),isMoveLineForward:Nd$1("moveLineForward"),isMoveWordBackward:Nd$1("moveWordBackward"),isMoveWordForward:Nd$1("moveWordForward"),isRedo:Nd$1("redo"),isSplitBlock:Nd$1("splitBlock"),isTransposeCharacter:Nd$1("transposeCharacter"),isUndo:Nd$1("undo"),isTab:Nd$1("tab"),isSelectAll:Nd$1("selectAll")};function Ld$1(e){e.preventDefault();}var Md$1={beforeinput:function(t,n,r){var i=t,a=r.getConfig().readOnly;if(rl$1&&!a&&md$1(r,i.target)){var l=r.selection,u=i.inputType,c=i.dataTransfer||i.data||void 0;if("insertCompositionText"!==u&&"deleteCompositionText"!==u){if(i.preventDefault(),!u.startsWith("delete")||u.startsWith("deleteBy")){var f=da$4(i.getTargetRanges(),1)[0];if(f){var d=ol$1.toSlateRange(r,f,{exactMatch:!1,suppressThrow:!1});l&&Range.equals(l,d)||Transforms.select(r,d);}}if(l&&Range.isExpanded(l)&&u.startsWith("delete")){var h=u.endsWith("Backward")?"backward":"forward";Editor.deleteFragment(r,{direction:h});}else switch(u){case"deleteByComposition":case"deleteByCut":case"deleteByDrag":Editor.deleteFragment(r);break;case"deleteContent":case"deleteContentForward":Editor.deleteForward(r);break;case"deleteContentBackward":Editor.deleteBackward(r);break;case"deleteEntireSoftLine":Editor.deleteBackward(r,{unit:"line"}),Editor.deleteForward(r,{unit:"line"});break;case"deleteHardLineBackward":Editor.deleteBackward(r,{unit:"block"});break;case"deleteSoftLineBackward":Editor.deleteBackward(r,{unit:"line"});break;case"deleteHardLineForward":Editor.deleteForward(r,{unit:"block"});break;case"deleteSoftLineForward":Editor.deleteForward(r,{unit:"line"});break;case"deleteWordBackward":Editor.deleteBackward(r,{unit:"word"});break;case"deleteWordForward":Editor.deleteForward(r,{unit:"word"});break;case"insertLineBreak":case"insertParagraph":Editor.insertBreak(r);break;case"insertFromDrop":case"insertFromPaste":case"insertFromYank":case"insertReplacementText":case"insertText":if("insertFromPaste"===u&&!As$1.get(r))break;c instanceof DataTransfer?r.insertData(c):"string"==typeof c&&Editor.insertText(r,c);}}}},blur:function(e,t,n){var r=e,o=t.isUpdatingSelection,a=t.latestElement;if(!n.getConfig().readOnly&&!o&&md$1(n,r.target)){var s=ol$1.findDocumentOrShadowRoot(n);if(a!==s.activeElement){var l=r.relatedTarget;if(!(l===ol$1.toDOMNode(n,n)||Ws$1(l)&&l.hasAttribute("data-slate-spacer"))){if(null!=l&&Vs$1(l)&&ol$1.hasDOMNode(n,l)){var u=ol$1.toSlateNode(n,l);if(Element$1.isElement(u)&&!n.isVoid(u))return}if(Zs$1){var c=s.getSelection();null==c||c.removeAllRanges();}Ds$1.delete(n);}}}},focus:function(e,t,n){var r=ol$1.toDOMNode(n,n),o=ol$1.findDocumentOrShadowRoot(n);t.latestElement=o.activeElement,Qs$1&&e.target!==r?r.focus():Ds$1.set(n,!0);},click:function(t,o,i){if(!i.getConfig().readOnly&&wd$1(i,t.target)&&Vs$1(t.target)){var a=ol$1.toSlateNode(i,t.target),l=ol$1.findPath(i,a);if(Editor.hasPath(i,l))if(Node$1.get(i,l)===a){var u=Editor.start(i,l),c=Editor.end(i,l),f=Editor.void(i,{at:u}),d=Editor.void(i,{at:c});if(f&&d&&Path.equals(f[1],d[1])){var h=Editor.range(i,u);Transforms.select(i,h);}}}},compositionstart:function(t,n,r){if(md$1(r,t.target)){var i=r.selection;if(i&&Range.isExpanded(i)&&(Editor.deleteFragment(r),Promise.resolve().then((function(){xd$1(n,r,!0);}))),i&&Range.isCollapsed(i)){var a=ol$1.toDOMRange(r,i).startContainer,s=a.textContent||"";Sd$1.set(r,s),kd$1.set(r,a);}n.isComposing=!0,function(e,t){var n;t.getConfig().placeholder&&t.isEmpty()&&e.showPlaceholder&&(null===(n=e.$placeholder)||void 0===n||n.hide(),e.showPlaceholder=!1);}(n,r);}},compositionend:function(t,n,r){var a=t;if(md$1(r,a.target)){n.isComposing=!1;var s=r.selection;if(null!=s){(nl$1||Qs$1)&&ol$1.cleanExposedTexNodeInSelectionBlock(r);for(var l=Range.isBackward(s)?s.focus:s.anchor,u=da$4(Editor.node(r,[l.path[0]]),1)[0],c=0;c<l.path.length;c++){var f=da$4(Editor.node(r,l.path.slice(0,c+1)),1)[0];if(Element$1.isElement(f)&&((Zs$1||Qs$1)&&"link"===f.type||"code"===f.type)){ol$1.setNewKey(u);break}}var d=a.data;if(d){if(r.getConfig().maxLength){var h=ol$1.getLeftLengthOfMaxLength(r);if(h<d.length)ol$1.toDOMRange(r,s).startContainer.textContent=Sd$1.get(r)||"",h>0&&Editor.insertText(r,d.slice(0,h)),n.changeViewState();else Editor.insertText(r,d);}else Editor.insertText(r,d);Zs$1||setTimeout((function(){var e=r.selection;if(null!=e){var t=kd$1.get(r);if(null!=t)ol$1.toDOMRange(r,e).startContainer!==t&&(t.textContent=Sd$1.get(r)||"");}}));}}}},compositionupdate:function(e,t,n){md$1(n,e.target)&&(t.isComposing=!0);},keydown:function(t,n,a){var l=t,u=a.selection;if(!a.getConfig().readOnly&&!n.isComposing&&md$1(a,l.target)){if(function(e,t){var n=ps$1.get(e),r=n&&n.getMenus(),o=vs$1.get(e),i=o&&o.getMenus(),a=ca$4(ca$4({},r),i);for(var s in a){var l=a[s],u=l.hotkey;if(u&&isHotkey_1(u,t)&&!l.isDisabled(e)){var c=l.getValue(e);l.exec(e,c);}}}(a,l),Td$1.isTab(l))return Ld$1(l),void a.handleTab();if(Td$1.isRedo(l))return Ld$1(l),void("function"==typeof a.redo&&a.redo());if(Td$1.isUndo(l))return Ld$1(l),void("function"==typeof a.undo&&a.undo());if(Td$1.isMoveLineBackward(l))return Ld$1(l),void Transforms.move(a,{unit:"line",reverse:!0});if(Td$1.isMoveLineForward(l))return Ld$1(l),void Transforms.move(a,{unit:"line"});if(Td$1.isExtendLineBackward(l))return Ld$1(l),void Transforms.move(a,{unit:"line",edge:"focus",reverse:!0});if(Td$1.isExtendLineForward(l))return Ld$1(l),void Transforms.move(a,{unit:"line",edge:"focus"});if(Td$1.isMoveBackward(l))return Ld$1(l),void(u&&Range.isCollapsed(u)?Transforms.move(a,{reverse:!0}):Transforms.collapse(a,{edge:"start"}));if(Td$1.isMoveForward(l))return Ld$1(l),void(u&&Range.isCollapsed(u)?Transforms.move(a):Transforms.collapse(a,{edge:"end"}));if(Td$1.isMoveWordBackward(l))return Ld$1(l),u&&Range.isExpanded(u)&&Transforms.collapse(a,{edge:"focus"}),void Transforms.move(a,{unit:"word",reverse:!0});if(Td$1.isMoveWordForward(l))return Ld$1(l),u&&Range.isExpanded(u)&&Transforms.collapse(a,{edge:"focus"}),void Transforms.move(a,{unit:"word"});if(Td$1.isSelectAll(l))return Ld$1(l),void a.selectAll();if(rl$1){if((nl$1||Zs$1)&&u&&(Td$1.isDeleteBackward(l)||Td$1.isDeleteForward(l))&&Range.isCollapsed(u)){var c=Node$1.parent(a,u.anchor.path);if(Element$1.isElement(c)&&Editor.isVoid(a,c)&&Editor.isInline(a,c))return l.preventDefault(),void Transforms.delete(a,{unit:"block"})}}else {if(Td$1.isBold(l)||Td$1.isItalic(l)||Td$1.isTransposeCharacter(l))return void Ld$1(l);if(Td$1.isSplitBlock(l))return Ld$1(l),void Editor.insertBreak(a);if(Td$1.isDeleteBackward(l))return Ld$1(l),void(u&&Range.isExpanded(u)?Editor.deleteFragment(a,{direction:"backward"}):Editor.deleteBackward(a));if(Td$1.isDeleteForward(l))return Ld$1(l),void(u&&Range.isExpanded(u)?Editor.deleteFragment(a,{direction:"forward"}):Editor.deleteForward(a));if(Td$1.isDeleteLineBackward(l))return Ld$1(l),void(u&&Range.isExpanded(u)?Editor.deleteFragment(a,{direction:"backward"}):Editor.deleteBackward(a,{unit:"line"}));if(Td$1.isDeleteLineForward(l))return Ld$1(l),void(u&&Range.isExpanded(u)?Editor.deleteFragment(a,{direction:"forward"}):Editor.deleteForward(a,{unit:"line"}));if(Td$1.isDeleteWordBackward(l))return Ld$1(l),void(u&&Range.isExpanded(u)?Editor.deleteFragment(a,{direction:"backward"}):Editor.deleteBackward(a,{unit:"word"}));if(Td$1.isDeleteWordForward(l))return Ld$1(l),void(u&&Range.isExpanded(u)?Editor.deleteFragment(a,{direction:"forward"}):Editor.deleteForward(a,{unit:"word"}))}}},keypress:function(t,n,r){if(!rl$1&&!r.getConfig().readOnly&&md$1(r,t.target)){t.preventDefault();var o=t.key;Editor.insertText(r,o);}},copy:function(e,t,n){var r=e;if(md$1(n,r.target)){r.preventDefault();var o=r.clipboardData;null!=o&&n.setFragmentData(o);}},cut:function(t,n,i){var a=t,l=i.selection;if(!i.getConfig().readOnly&&md$1(i,a.target)){a.preventDefault();var u=a.clipboardData;if(null!=u&&(i.setFragmentData(u),l))if(Range.isExpanded(l))Editor.deleteFragment(i);else {var c=Node$1.parent(i,l.anchor.path);Editor.isVoid(i,c)&&Transforms.delete(i);}}},paste:function(e,t,n){As$1.set(n,!0);var r=e;if(!n.getConfig().readOnly&&md$1(n,r.target)){var o=n.getConfig().customPaste;if(o)if(!1===o(n,r))return void As$1.set(n,!1);if(!rl$1||function(e){return e.clipboardData&&""!==e.clipboardData.getData("text/plain")&&1===e.clipboardData.types.length}(r)){r.preventDefault();var i=r.clipboardData;null!=i&&n.insertData(i);}}},dragover:function(t,n,r){if(wd$1(r,t.target)){var o=ol$1.toSlateNode(r,t.target);Editor.isVoid(r,o)&&t.preventDefault();}},dragstart:function(t,n,r){var o=t;if(wd$1(r,o.target)&&!r.getConfig().readOnly){var i=ol$1.toSlateNode(r,o.target),a=ol$1.findPath(r,i);if(Editor.isVoid(r,i)||Editor.void(r,{at:a,voids:!0})){var l=Editor.range(r,a);Transforms.select(r,l);}var u=o.dataTransfer;null!=u&&(n.isDraggingInternally=!0,r.setFragmentData(u));}},dragend:function(e,t,n){var r=e;n.getConfig().readOnly||t.isDraggingInternally&&wd$1(n,r.target)&&(t.isDraggingInternally=!1);},drop:function(e,t,n){var r=e,o=r.dataTransfer;if(!n.getConfig().readOnly&&wd$1(n,r.target)&&null!=o&&!(rl$1&&Zs$1&&o.files.length>0)){r.preventDefault();var i=n.selection,a=ol$1.findEventRange(n,r);Transforms.select(n,a),t.isDraggingInternally&&(i&&Transforms.delete(n,{at:i}),t.isDraggingInternally=!1),n.insertData(o),n.isFocused()||n.focus();}}},Pd$1=1,Dd$1=function(){function e(e){var t=this;this.id=Pd$1++,this.$textArea=null,this.$progressBar=$$6('<div class="w-e-progress-bar"></div>'),this.$maxLengthInfo=$$6('<div class="w-e-max-length-info"></div>'),this.isComposing=!1,this.isUpdatingSelection=!1,this.isDraggingInternally=!1,this.latestElement=null,this.showPlaceholder=!1,this.$placeholder=null,this.latestEditorSelection=null,this.onDOMSelectionChange=lodash_throttle((function(){var e=t.editorInstance;!function(e,t){var n=e.isComposing,r=e.isUpdatingSelection,o=e.isDraggingInternally;if(!(t.getConfig().readOnly||n||r||o)){var i=ol$1.findDocumentOrShadowRoot(t),a=i.activeElement,l=ol$1.toDOMNode(t,t),u=i.getSelection();if(a===l?(e.latestElement=a,Ds$1.set(t,!0)):Ds$1.delete(t),!u)return Transforms.deselect(t);var c=u.anchorNode,f=u.focusNode,d=md$1(t,c)||bd$1(t,c),h=md$1(t,f)||bd$1(t,f);if(d&&h){var p=ol$1.toSlateRange(t,u,{exactMatch:!1,suppressThrow:!1});Transforms.select(t,p);}else Transforms.deselect(t);}}(t,e);}),100);var n=$$6(e);if(0===n.length)throw new Error("Cannot find textarea DOM by selector '"+e+"'");this.$box=n;var r=$$6('<div class="w-e-text-container"></div>');r.append(this.$progressBar),r.append(this.$maxLengthInfo),n.append(r);var o=$$6('<div class="w-e-scroll"></div>');r.append(o),this.$scroll=o,this.$textAreaContainer=r,ac$1((function(){var e=t.editorInstance,n=ol$1.getWindow(e);n.document.addEventListener("selectionchange",t.onDOMSelectionChange),e.on("destroyed",(function(){n.document.removeEventListener("selectionchange",t.onDOMSelectionChange);})),r.on("click",(function(){return e.hidePanelOrModal()})),e.on("change",t.changeViewState.bind(t));var o=e.getConfig().onChange;o&&e.on("change",(function(){return o(e)})),t.onFocusAndOnBlur(),e.on("change",t.changeMaxLengthInfo.bind(t)),t.bindEvent();}));}return Object.defineProperty(e.prototype,"editorInstance",{get:function(){var e=ds$1.get(this);if(null==e)throw new Error("Can not get editor instance");return e},enumerable:!1,configurable:!0}),e.prototype.bindEvent=function(){var e=this,t=this.$textArea,n=this.$scroll,r=this.editorInstance;null!=t&&(lodash_foreach(Md$1,(function(n,o){t.on(o,(function(t){n(t,e,r);}));})),r.getConfig().scroll&&(n.css("overflow-y","auto"),n.on("scroll",lodash_throttle((function(){r.emit("scroll");}),100))));},e.prototype.onFocusAndOnBlur=function(){var e=this,t=this.editorInstance,n=t.getConfig(),r=n.onBlur,o=n.onFocus;this.latestEditorSelection=t.selection,t.on("change",(function(){null==e.latestEditorSelection&&null!=t.selection?setTimeout((function(){return o&&o(t)})):null!=e.latestEditorSelection&&null==t.selection&&setTimeout((function(){return r&&r(t)})),e.latestEditorSelection=t.selection;}));},e.prototype.changeMaxLengthInfo=function(){var e=this.editorInstance,t=e.getConfig().maxLength;if(t){var n=t-ol$1.getLeftLengthOfMaxLength(e);this.$maxLengthInfo[0].innerHTML=n+"/"+t;}},e.prototype.changeProgress=function(e){var t=this.$progressBar;t.css("width",e+"%"),e>=100&&setTimeout((function(){t.hide(),t.css("width","0"),t.show();}),1e3);},e.prototype.changeViewState=function(){var e=this,t=this.editorInstance;cd$1(this,t),function(e,t){var n,r=t.getConfig().placeholder;if(r){var o=t.isEmpty();if(o&&!e.showPlaceholder&&!e.isComposing){if(null==e.$placeholder){var i=$$6('<div class="w-e-text-placeholder">'+r+"</div>");e.$textAreaContainer.append(i),e.$placeholder=i;}return e.$placeholder.show(),void(e.showPlaceholder=!0)}!o&&e.showPlaceholder&&(null===(n=e.$placeholder)||void 0===n||n.hide(),e.showPlaceholder=!1);}}(this,t),ac$1((function(){xd$1(e,t);}));},e.prototype.destroy=function(){this.$textAreaContainer.remove();},e}();Wi$3("match",(function(e,t,n){return [function(t){var n=me$6(this),r=null==t?void 0:ct$6(t,e);return r?nt$6(r,t,n):new RegExp(t)[e](kr$5(n))},function(e){var r=et$6(this),o=kr$5(e),i=n(t,r,o);if(i.done)return i.value;if(!r.global)return Qi$3(r,o);var a=r.unicode;r.lastIndex=0;for(var s,l=[],u=0;null!==(s=Qi$3(r,o));){var c=kr$5(s[0]);l[u]=c,""===c&&(r.lastIndex=zi$4(o,dn$6(r.lastIndex),a)),u++;}return 0===u?null:l}]}));function Rd$1(e){e.removeAttr("width"),e.removeAttr("height"),e.removeAttr("fill"),e.removeAttr("class"),e.removeAttr("t"),e.removeAttr("p-id");var t=e.children();t.length&&Rd$1(t);}function jd$1(){return $$6('<svg viewBox="0 0 1024 1024"><path d="M498.7 655.8l-197.6-268c-8.1-10.9-0.3-26.4 13.3-26.4h395.2c13.6 0 21.4 15.4 13.3 26.4l-197.6 268c-6.6 9-20 9-26.6 0z"></path></svg>')}function Ad$1(){return $$6('<div class="w-e-bar-divider"></div>')}function Fd$1(e,t,n,r,o){if(void 0===o&&(o=!1),t){if(r){var i=Xs$1?"cmd":"ctrl";r=r.replace("mod",i);}if(o)r&&(e.attr("data-tooltip",r),e.addClass("w-e-menu-tooltip-v5"),e.addClass("tooltip-right"));else {var a=r?n+"\n"+r:n;e.attr("data-tooltip",a),e.addClass("w-e-menu-tooltip-v5");}}}var Id$1=function(){function e(e,t,n){var r=this;void 0===n&&(n=!1),this.$elem=$$6('<div class="w-e-bar-item"></div>'),this.$button=$$6('<button type="button"></button>'),this.disabled=!1,this.menu=t;var o=t.tag,i=t.width;if("button"!==o)throw new Error("Invalid tag '"+o+"', expected 'button'");var a=t.title,s=t.hotkey,l=void 0===s?"":s,u=t.iconSvg,c=void 0===u?"":u,d=this.$button;if(c){var h=$$6(c);Rd$1(h),d.append(h);}else d.text(a);Fd$1(d,c,a,l,n),n&&c&&d.append($$6('<span class="title">'+a+"</span>")),i&&d.css("width",i+"px"),d.attr("data-menu-key",e),this.$elem.append(d),ac$1((function(){return r.init()}));}return e.prototype.init=function(){var e=this;this.setActive(),this.setDisabled(),this.$button.on("click",(function(t){t.preventDefault(),Xd(e).hidePanelOrModal(),e.disabled||(e.exec(),e.onButtonClick());}));},e.prototype.exec=function(){var e=Xd(this),t=this.menu,n=t.getValue(e);t.exec(e,n);},e.prototype.setActive=function(){var e=Xd(this),t=this.$button,n="active";this.menu.isActive(e)?t.addClass(n):t.removeClass(n);},e.prototype.setDisabled=function(){var e=Xd(this),t=this.$button,n=this.menu.isDisabled(e);(null==e.selection||e.isDisabled())&&(n=!0),this.menu.alwaysEnable&&(n=!1);var r="disabled";n?t.addClass(r):t.removeClass(r),this.disabled=n;},e.prototype.changeMenuState=function(){this.setActive(),this.setDisabled();},e}(),_d$1=function(e){function t(t,n,r){return void 0===r&&(r=!1),e.call(this,t,n,r)||this}return ua$4(t,e),t.prototype.onButtonClick=function(){},t}(Id$1),Bd$1=function(){function e(e){this.isShow=!1,this.showTime=0,this.record(e);}return e.prototype.record=function(e){var t=ms$1.get(e);null==t&&(t=new Set,ms$1.set(e,t)),t.add(this),bs$1.set(this,e);},e.prototype.renderContent=function(e){var t=this.$elem;t.empty(),t.append(e);var n=this.genSelfElem();n&&t.append(n);},e.prototype.appendTo=function(e){var t=this.$elem;e.append(t);},e.prototype.show=function(){if(!this.isShow){this.showTime=Date.now(),this.$elem.show(),this.isShow=!0;var e=bs$1.get(this);e&&e.emit("modalOrPanelShow",this);}},e.prototype.hide=function(){if(this.isShow&&!(Date.now()-this.showTime<200)){this.$elem.hide(),this.isShow=!1;var e=bs$1.get(this);e&&e.emit("modalOrPanelHide");}},e}(),$d$1=function(e){function t(t){var n=e.call(this,t)||this;return n.type="dropPanel",n.$elem=$$6('<div class="w-e-drop-panel"></div>'),n}return ua$4(t,e),t.prototype.genSelfElem=function(){return null},t}(Bd$1),Wd$1=function(e){function t(t,n,r){void 0===r&&(r=!1);var o=e.call(this,t,n,r)||this;if(o.dropPanel=null,o.menu=n,n.showDropPanel){var i=jd$1();o.$button.append(i);}return o}return ua$4(t,e),t.prototype.onButtonClick=function(){this.menu.showDropPanel&&this.handleDropPanel();},t.prototype.handleDropPanel=function(){var e=this.menu;if(null!=e.getPanelContentElem){var t=Xd(this);if(null==this.dropPanel){var n=new $d$1(t),r=e.getPanelContentElem(t);n.renderContent(r),n.appendTo(this.$elem),n.show(),this.dropPanel=n;}else {var o=this.dropPanel;if(o.isShow)o.hide();else {r=e.getPanelContentElem(t);o.renderContent(r),o.show();}}var i=this.dropPanel;if(i.isShow){var a=this.$elem,s=a.offset().left,l=a.parents(".w-e-bar");s-l.offset().left>=l.width()/2?i.$elem.css({left:"none",right:"0"}):i.$elem.css({left:"0",right:"none"});}}},t}(Id$1),Vd$1=function(e){function t(t,n){void 0===n&&(n=0);var r=e.call(this,t)||this;r.type="modal",r.$elem=$$6('<div class="w-e-modal"></div>'),r.width=0,n&&(r.width=n);var o=r.$elem;return o.on("click",(function(e){return e.stopPropagation()})),o.on("keyup",(function(e){"Escape"===e.code&&(r.hide(),t.restoreSelection());})),r}return ua$4(t,e),t.prototype.genSelfElem=function(){var e=this,t=$$6('<span class="btn-close"><svg viewBox="0 0 1024 1024"><path d="M1024 896.1024l-128 128L512 640 128 1024 0 896 384 512 0 128 128 0 512 384 896.1024 0l128 128L640 512z"></path></svg></span>'),n=bs$1.get(this);return t.on("click",(function(){e.hide(),null==n||n.restoreSelection();})),t},t.prototype.setStyle=function(e){var t=this.width,n=this.$elem;n.attr("style",""),t&&n.css("width",t+"px"),n.css(e);},t}(Bd$1);function zd$1(e,t,n){var r=$$6('<label class="babel-container"></label>');r.append("<span>"+e+"</span>");var o=$$6('<input type="text" id="'+t+'" placeholder="'+(n||"")+'">');return r.append(o),[r[0],o[0]]}function Hd$1(e,t,n){var r=$$6('<label class="babel-container"></label>');r.append("<span>"+e+"</span>");var o=$$6('<textarea type="text" id="'+t+'" placeholder="'+(n||"")+'"></textarea>');return r.append(o),[r[0],o[0]]}function Ud(e,t){var n=$$6('<div class="button-container"></div>'),r=$$6('<button type="button" id="'+e+'">'+t+"</button>");return n.append(r),[n[0],r[0]]}var Kd=function(e){function t(t,n,r){void 0===r&&(r=!1);var o=e.call(this,t,n,r)||this;return o.$body=$$6("body"),o.modal=null,o.menu=n,o}return ua$4(t,e),t.prototype.onButtonClick=function(){this.menu.showModal&&this.handleModal();},t.prototype.getPosition=function(){var e=Xd(this),t=this.menu.getModalPositionNode(e);return Element$1.isElement(t)?Ff$1(e,t,"modal"):Af$1(e)},t.prototype.handleModal=function(){var e=Xd(this),t=this.menu;if(null==this.modal){var n=new Vd$1(e,t.modalWidth);this.renderAndShowModal(n,!0),this.modal=n;}else {(n=this.modal).isShow?n.hide():this.renderAndShowModal(n,!1);}},t.prototype.renderAndShowModal=function(e,t){void 0===t&&(t=!1);var n=Xd(this),r=this.menu;if(null!=r.getModalContentElem){var o=ol$1.getTextarea(n),i=ol$1.getToolbar(n),a=((null==i?void 0:i.getConfig())||{}).modalAppendToBody,s=r.getModalContentElem(n);if(e.renderContent(s),a)e.setStyle({left:"0",right:"0"});else {var l=this.getPosition();e.setStyle(l);}t&&(a?e.appendTo(this.$body):e.appendTo(o.$textAreaContainer)),e.show(),a||If$1(n,e.$elem),setTimeout((function(){n.blur();}));}},t}(Id$1);var qd$1=function(e){function t(t,n){var r=e.call(this,t)||this;return r.type="selectList",r.$elem=$$6('<div class="w-e-select-list"></div>'),n&&r.$elem.css("width",n+"px"),r.$elem.on("click",(function(e){e.stopPropagation();})),r}return ua$4(t,e),t.prototype.renderList=function(e){var t=this.$elem;t.empty();var n=$$6("<ul></ul>");e.forEach((function(e){var t=e.value,r=e.text,o=e.selected,i=e.styleForRenderMenuList,a=$$6('<li data-value="'+t+'"></li>');if(i&&a.css(i),o){var s=$$6('<svg viewBox="0 0 1446 1024"><path d="M574.116299 786.736392 1238.811249 48.517862C1272.390222 11.224635 1329.414799 7.827718 1366.75664 41.450462 1403.840015 74.840484 1406.731043 132.084741 1373.10189 169.433699L655.118888 966.834607C653.072421 969.716875 650.835807 972.514337 648.407938 975.210759 615.017957 1012.29409 558.292155 1015.652019 521.195664 982.250188L72.778218 578.493306C35.910826 545.297758 32.859041 488.584019 66.481825 451.242134 99.871807 414.158803 156.597563 410.800834 193.694055 444.202665L574.116299 786.736392Z"></path></svg>');a.append(s),a.addClass("selected");}a.append($$6('<span data-value="'+t+'">'+r+"</span>")),a.attr("title",r),n.append(a);})),t.append(n);},t.prototype.genSelfElem=function(){return null},t}(Bd$1);var Gd$1=function(){function e(e,t,n){var r=this;void 0===n&&(n=!1),this.$elem=$$6('<div class="w-e-bar-item"></div>'),this.$button=$$6('<button type="button" class="select-button"></button>'),this.disabled=!1,this.selectList=null;var o=t.tag,i=t.title,a=t.width,s=t.iconSvg,l=void 0===s?"":s,u=t.hotkey,c=void 0===u?"":u;if("select"!==o)throw new Error("Invalid tag '"+o+"', expected 'select'");var d=this.$button;a&&d.css("width",a+"px"),d.attr("data-menu-key",e),Fd$1(d,l,i,c,n),this.$elem.append(d),this.menu=t,ac$1((function(){return r.init()}));}return e.prototype.init=function(){var e=this;this.setSelectedValue(),this.$button.on("click",(function(t){t.preventDefault(),Xd(e).hidePanelOrModal(),e.trigger();}));},e.prototype.trigger=function(){var e=this,t=Xd(this);if(!t.isDisabled()&&!this.disabled){var n=this.menu;if(null==this.selectList){this.selectList=new qd$1(t,n.selectPanelWidth);var r=this.selectList,o=n.getOptions(t);r.renderList(o),r.appendTo(this.$elem),r.show(),r.$elem.on("click","li",(function(t){var n=t.target;if(null!=n){t.preventDefault();var r=$$6(n).attr("data-value");e.onChange(r);}}));}else {if((r=this.selectList).isShow)r.hide();else {o=n.getOptions(t);r.renderList(o),r.show();}}}},e.prototype.onChange=function(e){var t=Xd(this),n=this.menu;n.exec&&n.exec(t,e);},e.prototype.setSelectedValue=function(){var e=Xd(this),t=this.menu,n=t.getValue(e),r=function(e,t){for(var n=e.length,r="",o=0;o<n;o++){var i=e[o];if(i.value===t){r=i.text;break}}return r}(t.getOptions(e),n.toString()),o=this.$button,i=jd$1();o.empty(),o.text(r),o.append(i);},e.prototype.setDisabled=function(){var e=Xd(this),t=this.menu.isDisabled(e),n=this.$button;(null==e.selection||e.isDisabled())&&(t=!0);var r="disabled";t?n.addClass(r):n.removeClass(r),this.disabled=t;},e.prototype.changeMenuState=function(){this.setSelectedValue(),this.setDisabled();},e}(),Jd=function(){function e(e){this.$elem=$$6('<div class="w-e-bar-item w-e-bar-item-group"></div>'),this.$container=$$6('<div class="w-e-bar-item-menus-container"></div>'),this.$button=$$6('<button type="button"></button>');var t=e.key,n=e.iconSvg,r=e.title,o=this.$elem,i=this.$button;if(n){var a=$$6(n);Rd$1(a),i.append(a);}else i.text(r);i.attr("data-menu-key",t);var s=jd$1();i.append(s),o.append(i);var l=this.$container;o.append(l);var u=this.createObserver();this.observe(u);}return e.prototype.appendBarItem=function(e){var t=e.$elem;this.$container.append(t);},e.prototype.observe=function(e){var t=this.$container;e.observe(t[0],{childList:!0,subtree:!0,attributes:!0});},e.prototype.createObserver=function(){var e=this,t=this.$container,n=this.$button,r=new MutationObserver((function(){var o=t.find("button"),i=o.length;if(0!==i){var a=0;o.each((function(e){$$6(e).hasClass("disabled")&&a++;})),r.disconnect(),a===i?n.addClass("disabled"):n.removeClass("disabled"),e.observe(r);}}));return r},e}(),Yd=new WeakMap;function Xd(e){var t=ys$1.get(e);if(null==t)throw new Error("Can not get editor instance");return t}function Qd(e,t,n){void 0===n&&(n=!1);var r=Yd.get(t);if(r)return r;var o=t.tag;if("button"===o){var i=t.showDropPanel,a=t.showModal;r=i?new Wd$1(e,t,n):a?new Kd(e,t,n):new _d$1(e,t,n);}if("select"===o&&(r=new Gd$1(e,t,n)),null==r)throw new Error("Invalid tag in menu "+JSON.stringify(t));return Yd.set(t,r),r}function Zd(e,t){var n=e.selection;return null!=n&&(!Range.isCollapsed(n)&&(!ol$1.getSelectedElems(e).some((function(t){if(e.isVoid(t))return !0;var n=t.type;return !!["pre","code","table"].includes(n)||void 0}))&&!!Text.isText(t)))}var eh=function(){function t(){var e=this;this.$elem=$$6('<div class="w-e-bar w-e-bar-hidden w-e-hover-bar"></div>'),this.menus={},this.hoverbarItems=[],this.prevSelectedNode=null,this.isShow=!1,this.changeHoverbarState=lodash_debounce((function(){var t=e.isShow,n=e.getSelectedNodeAndMenuKeys()||{},r=n.node,o=void 0===r?null:r,a=n.menuKeys,s=void 0===a?[]:a;if((null!=o&&e.changeItemsState(),o&&Element$1.isElement(o))&&(t&&e.isSamePath(o,e.prevSelectedNode)))return;e.hideAndClean(),null!=o&&(e.registerItems(s),e.setPosition(o),e.show()),e.prevSelectedNode=o;}),200),ac$1((function(){var t=e.getEditorInstance(),n=e.$elem;n.on("mousedown",(function(e){return e.preventDefault()}),{passive:!1}),ol$1.getTextarea(t).$textAreaContainer.append(n),t.on("change",e.changeHoverbarState);var r=e.hideAndClean.bind(e);t.on("scroll",r),t.on("fullScreen",r),t.on("unFullScreen",r);}));}return t.prototype.getMenus=function(){return this.menus},t.prototype.hideAndClean=function(){var e=this.$elem;e.removeClass("w-e-bar-show").addClass("w-e-bar-hidden"),this.hoverbarItems=[],e.empty(),this.isShow=!1;},t.prototype.checkPositionBottom=function(){var e=this.$elem,t=!1,n=window.innerHeight;n&&n>=360&&(n-e[0].getBoundingClientRect().bottom<360&&(t=!0));t?e.addClass("w-e-bar-bottom"):e.removeClass("w-e-bar-bottom");},t.prototype.show=function(){this.$elem.removeClass("w-e-bar-hidden").addClass("w-e-bar-show"),this.isShow=!0,this.checkPositionBottom();},t.prototype.changeItemsState=function(){var e=this;ac$1((function(){e.hoverbarItems.forEach((function(e){e.changeMenuState();}));}));},t.prototype.registerItems=function(e){var t=this,n=this.$elem;e.forEach((function(e){if("|"!==e)t.registerSingleItem(e);else {var r=Ad$1();n.append(r);}}));},t.prototype.registerSingleItem=function(e){var t=this.getEditorInstance(),n=this.menus,r=n[e];if(null==r){var o=sl$1[e];if(null==o)throw new Error("Not found menu item factory by key '"+e+"'");if("function"!=typeof o)throw new Error("Menu item factory (key='"+e+"') is not a function");r=o(),n[e]=r;}var i=Qd(e,r);this.hoverbarItems.push(i),ys$1.set(i,t),this.$elem.append(i.$elem);},t.prototype.setPosition=function(e){var t=this.getEditorInstance(),n=this.$elem;if(n.attr("style",""),Element$1.isElement(e)){var r=Ff$1(t,e,"bar");return n.css(r),void If$1(t,n)}if(Text.isText(e)){r=Af$1(t);return n.css(r),void If$1(t,n)}throw new Error("hoverbar.setPosition error, current selected node is not elem nor text")},t.prototype.getSelectedNodeAndMenuKeys=function(){var t=this.getEditorInstance();if(null==t.selection)return null;var n=this.getHoverbarKeysConf(),r=null,o=[],i=function(i){var a=n[i],s=a.match,l=a.menuKeys,u=void 0===l?[]:l,c=s||function(e,t){return ol$1.checkNodeType(t,i)},f=da$4(Editor.nodes(t,{match:function(e){return c(t,e)},universal:!0}),1),d=f[0];if(null!=d)return r=d[0],o=u,"break"};for(var a in n){if("break"===i(a))break}return null==r||0===o.length?null:{node:r,menuKeys:o}},t.prototype.getEditorInstance=function(){var e=gs$1.get(this);if(null==e)throw new Error("Can not get editor instance");return e},t.prototype.getHoverbarKeysConf=function(){var e=this.getEditorInstance().getConfig().hoverbarKeys,t=void 0===e?{}:e,n=t.text;return n&&null==n.match&&(n.match=Zd),t},t.prototype.isSamePath=function(e,t){if(null==e||null==t)return !1;var r=ol$1.findPath(null,e),o=ol$1.findPath(null,t);return Path.equals(r,o)},t.prototype.destroy=function(){this.changeHoverbarState.cancel(),this.$elem.remove(),this.menus={},this.hoverbarItems=[],this.prevSelectedNode=null;},t}();function th(t,n,o,a){if(Es$1.set(t,n),Os$1.set(t,o),Element$1.isElement(t)){var s=t.children;if((void 0===s?[]:s).forEach((function(e,n){return th(e,n,t,a)})),Editor.isVoid(a,t)){var l=da$4(Node$1.texts(t),1),u=da$4(l[0],1)[0];Es$1.set(u,0),Os$1.set(u,t);}}}function nh(n){var i=n.selector,a=void 0===i?"":i,c=n.config,d=void 0===c?{}:c,h=n.content,p=n.html,g=n.plugins,v=void 0===g?[]:g,y=(n=>{var r=n,{apply:o}=r;return r.history={undos:[],redos:[]},r.redo=()=>{var{history:t}=r,{redos:n}=t;if(n.length>0){var o=n[n.length-1];yr$5.withoutSaving(r,(()=>{Editor.withoutNormalizing(r,(()=>{for(var e of o)r.apply(e);}));})),t.redos.pop(),t.undos.push(o);}},r.undo=()=>{var{history:n}=r,{undos:o}=n;if(o.length>0){var i=o[o.length-1];yr$5.withoutSaving(r,(()=>{Editor.withoutNormalizing(r,(()=>{var e=i.map(Operation.inverse).reverse();for(var n of e)r.apply(n);}));})),n.redos.push(i),n.undos.pop();}},r.apply=e=>{var{operations:t,history:n}=r,{undos:i}=n,a=i[i.length-1],s=a&&a[a.length-1],l=wr$5(e,s),u=yr$5.isSaving(r),c=yr$5.isMerging(r);if(null==u&&(u=br$5(e)),u){if(null==c&&(c=null!=a&&(0!==t.length||mr$5(e,s)||l)),a&&c)l&&a.pop(),a.push(e);else {var f=[e];i.push(f);}for(;i.length>100;)i.shift();xr$5(e)&&(n.redos=[]);}o(e);},r})(function(e){var t=e,n=t.insertText,o=t.insertNode,i=t.insertFragment,a=t.dangerouslyInsertHtml;return t.insertText=function(e){if(t.getConfig().maxLength){var r=ol$1.getLeftLengthOfMaxLength(t);r<=0||(r<e.length?n(e.slice(0,r)):n(e));}else n(e);},t.insertNode=function(e){if(t.getConfig().maxLength){var n=ol$1.getLeftLengthOfMaxLength(t);n<=0||n<Node$1.string(e).length||o(e);}else o(e);},t.insertFragment=function(e){if(t.getConfig().maxLength)if(1!==e.length)e.forEach((function(e){t.insertNode(e);}));else {var n=e[0];if(ol$1.getLeftLengthOfMaxLength(t)<Node$1.string(n).length)return;i(e);}else i(e);},t.dangerouslyInsertHtml=function(e,n){if(void 0===e&&(e=""),void 0===n&&(n=!1),e)if(t.getConfig().maxLength){var r=ol$1.getLeftLengthOfMaxLength(t);if(!(r<=0)){var o=document.createElement("div");o.innerHTML=e;var i=Array.from(o.childNodes).reduce((function(e,t){var n=t.nodeType,r=t.nodeName;return t?n===Bs$1.TEXT_NODE?e+(t.textContent||""):n===Bs$1.ELEMENT_NODE?nf$1.has(r.toLowerCase())?e:e+(t.textContent||""):e:e}),"");r<i.length||a(e,n);}}else a(e,n);},t}(function(e){var t=e;return t.on=function(e,n){var r=Lf$1(t);if(r.on(e,n),"destroyed"===e&&Pf$1(t,n),"destroyed"!==e){var o=function(){return r.off(e,n)};r.on("destroyed",o),Pf$1(t,o);}},t.once=function(e,n){Lf$1(t).once(e,n);},t.off=function(e,n){Lf$1(t).off(e,n);},t.emit=function(e){for(var n=[],r=1;r<arguments.length;r++)n[r-1]=arguments[r];var o=Lf$1(t);(o.emit.apply(o,ha$3([e],da$4(n))),"destroyed"===e)&&(Df$1(t).forEach((function(e){return o.off("destroyed",e)})),Rf$1(t));},t}(function(t){var n=t;return n.select=function(e){Transforms.select(n,e);},n.deselect=function(){var e=n.selection,r=ol$1.findDocumentOrShadowRoot(n).getSelection();r&&r.rangeCount>0&&r.removeAllRanges(),e&&Transforms.deselect(t);},n.move=function(e,n){void 0===n&&(n=!1),e&&(e<0||Transforms.move(t,{distance:e,unit:"character",reverse:n}));},n.moveReverse=function(e){n.move(e,!0);},n.restoreSelection=function(){var e=Rs$1.get(n);null!=e&&(n.focus(),Transforms.select(n,e));},n.getSelectionPosition=function(){return Af$1(n)},n.getNodePosition=function(e){return Ff$1(n,e)},n.isSelectedAll=function(){var t=n.selection;if(null==t)return !1;var r=da$4(Range.edges(t),2),i=r[0],a=r[1],s=da$4(Editor.edges(n,[]),2),u=s[0],c=s[1];return !(!Point.equals(i,u)||!Point.equals(a,c))},n.selectAll=function(){var t=Editor.start(n,[]),r=Editor.end(n,[]);Transforms.select(n,{anchor:t,focus:r});},n}(of$1(function(e){var t=e;return t.getAllMenuKeys=function(){var e=[];for(var t in sl$1)e.push(t);return e},t.getConfig=function(){var e=ws$1.get(t);if(null==e)throw new Error("Can not get editor config");return e},t.getMenuConfig=function(e){var n=t.getConfig().MENU_CONF;return (void 0===n?{}:n)[e]||{}},t.alert=function(e,n){void 0===n&&(n="info");var r=t.getConfig().customAlert;r&&r(e,n);},t}(function(t){var n=t;return n.id="wangEditor-"+il$1++,n.isDestroyed=!1,n.isFullScreen=!1,n.focus=function(t){if(ol$1.toDOMNode(n,n).focus({preventScroll:!0}),Ds$1.set(n,!0),t){var r=Editor.end(n,[]);Transforms.select(n,r);}else {var o=Rs$1.get(n);o?Transforms.select(n,o):Transforms.select(n,Editor.start(n,[]));}},n.isFocused=function(){return !!Ds$1.get(n)},n.blur=function(){ol$1.toDOMNode(n,n).blur(),Transforms.deselect(n),Ds$1.set(n,!1);},n.updateView=function(){ol$1.getTextarea(n).changeViewState();var e=ol$1.getToolbar(n);e&&e.changeToolbarState();var t=ol$1.getHoverbar(n);t&&t.changeHoverbarState();},n.destroy=function(){if(!n.isDestroyed){var e=ol$1.getTextarea(n);e.destroy(),fs$1.delete(n),ds$1.delete(e);var t=ol$1.getToolbar(n);t&&(t.destroy(),ps$1.delete(n),hs$1.delete(t));var r=ol$1.getHoverbar(n);r&&(r.destroy(),vs$1.delete(n),gs$1.delete(r)),n.isDestroyed=!0,n.emit("destroyed");}},n.scrollToElem=function(e){if(!n.getConfig().scroll){var t="编辑器禁用了 scroll ，编辑器内容无法滚动，请自行实现该功能";return t+="\nYou has disabled editor scroll, please do this yourself",void console.warn(t)}var r=$$6("#"+e);if(0!==r.length){var o=r[0];if(!ol$1.hasDOMNode(n,o))return t="Element (found by id is '"+e+"') is not in editor DOM",t+="\n 通过 id '"+e+"' 找到的 element 不在 editor DOM 之内",void console.error(t,o);var i=ol$1.getTextarea(n),a=i.$textAreaContainer,s=i.$scroll,l=r.offset().top,u=a.offset().top;s[0].scrollBy({top:l-u,behavior:"smooth"});}},n.showProgressBar=function(e){e<1||ol$1.getTextarea(n).changeProgress(e);},n.hidePanelOrModal=function(){var e=ms$1.get(n);null!=e&&e.forEach((function(e){return e.hide()}));},n.enable=function(){n.getConfig().readOnly=!1,n.updateView();},n.disable=function(){n.getConfig().readOnly=!0,n.updateView();},n.isDisabled=function(){return n.getConfig().readOnly},n.toDOMNode=function(e){return ol$1.toDOMNode(n,e)},n.fullScreen=function(){if(!n.isFullScreen){var e=null,t=ol$1.getToolbar(n);t&&(e=t.$box);var r=ol$1.getTextarea(n).$box.parent();if(e&&e.parent()[0]!==r[0])throw new Error("Can not set full screen, cause toolbar DOM parent is not equal to textarea DOM parent\n不能设置全屏，因为 toolbar DOM 父节点和 textarea DOM 父节点不一致");r.addClass("w-e-full-screen-container");var o=r.css("z-index");r.attr("data-z-index",o.toString()),n.isFullScreen=!0,n.emit("fullScreen");}},n.unFullScreen=function(){if(n.isFullScreen){var e=ol$1.getTextarea(n).$box.parent();setTimeout((function(){e.removeClass("w-e-full-screen-container"),n.isFullScreen=!1,n.emit("unFullScreen");}),200);}},n.getEditableContainer=function(){return ol$1.getTextarea(n).$textAreaContainer[0]},n}(af$1(createEditor$1()))))))));if(a&&function(e,t){return Jc$1(e,"data-w-e-textarea",t)}(y,a))throw new Error("Repeated create editor by selector '"+a+"'");var m=function(e){void 0===e&&(e={});var t=lodash_clonedeep(al$1),n={},r=e.MENU_CONF,o=void 0===r?{}:r;return lodash_foreach(t,(function(e,t){n[t]=ca$4(ca$4({},e),o[t]||{});})),delete e.MENU_CONF,ca$4({scroll:!0,readOnly:!1,autoFocus:!0,decorate:function(){return []},maxLength:0,MENU_CONF:n,hoverbarKeys:{},customAlert:function(e,t){window.alert(t+":\n"+e);}},e)}(d);ws$1.set(y,m);var b=m.hoverbarKeys,w=void 0===b?{}:b;if(v.forEach((function(e){y=e(y);})),null!=p&&(y.children=Yc$1(y,p)),h&&h.length&&(y.children=h),0===y.children.length&&(y.children=[{type:"paragraph",children:[{text:""}]}]),ol$1.normalizeContent(y),a){var x=new Dd$1(a);fs$1.set(y,x),ds$1.set(x,y),x.changeViewState(),ac$1((function(){var e=x.$scroll;if(null!=e&&e.height()<300){console.warn("编辑区域高度 < 300px 这可能会导致 modal hoverbar 定位异常\nTextarea height < 300px . This may be cause modal and hoverbar position error",e);}}));var S=void 0;Object.keys(w).length>0&&(S=new eh,gs$1.set(S,y),vs$1.set(y,S)),y.on("change",(function(){y.hidePanelOrModal();})),y.on("scroll",(function(){y.hidePanelOrModal();}));}else y.children.forEach((function(e,t){return th(e,t,y,y)}));var k=m.onCreated,E=m.onDestroyed;return k&&y.on("created",(function(){return k(y)})),E&&y.on("destroyed",(function(){return E(y)})),ac$1((function(){return y.emit("created")})),y}var rh=fi$5("splice"),oh=se$6.TypeError,ih=Math.max,ah=Math.min;cr$5({target:"Array",proto:!0,forced:!rh},{splice:function(e,t){var n,r,o,i,a,s,l=we$6(this),u=hn$6(l),c=zn$6(e,u),f=arguments.length;if(0===f?n=r=0:1===f?(n=0,r=u-c):(n=f-2,r=ah(ih(cn$6(t),0),u-c)),u+n-r>9007199254740991)throw oh("Maximum allowed length exceeded");for(o=On$6(l,r),i=0;i<r;i++)(a=c+i)in l&&ao$5(o,i,l[a]);if(o.length=r,n<r){for(i=c;i<u-r;i++)s=i+n,(a=i+r)in l?l[s]=l[a]:delete l[s];for(i=u;i>u-r+n;i--)delete l[i-1];}else if(n>r)for(i=u-r;i>c;i--)s=i+n-1,(a=i+r-1)in l?l[s]=l[a]:delete l[s];for(i=0;i<n;i++)l[i+c]=arguments[i+2];return l.length=u-r+n,o}});var sh=function(){function e(e,t){var n=this;this.$toolbar=$$6('<div class="w-e-bar w-e-bar-show w-e-toolbar"></div>'),this.menus={},this.toolbarItems=[],this.config={},this.changeToolbarState=lodash_debounce((function(){n.toolbarItems.forEach((function(e){e.changeMenuState();}));}),200),this.config=t;var r=$$6(e);if(0===r.length)throw new Error("Cannot find toolbar DOM by selector '"+e+"'");this.$box=r;var o=this.$toolbar;o.on("mousedown",(function(e){return e.preventDefault()}),{passive:!1}),r.append(o),ac$1((function(){n.registerItems(),n.changeToolbarState(),n.getEditorInstance().on("change",n.changeToolbarState);}));}return e.prototype.getMenus=function(){return this.menus},e.prototype.getConfig=function(){return this.config},e.prototype.registerItems=function(){var e=this,t="",n=this.$toolbar,r=this.config,o=r.toolbarKeys,i=void 0===o?[]:o,a=r.insertKeys,s=void 0===a?{index:0,keys:[]}:a,l=r.excludeKeys,u=void 0===l?[]:l,c=lodash_clonedeep(i);s.keys.length>0&&("string"==typeof s.keys&&(s.keys=[s.keys]),s.keys.forEach((function(e,t){c.splice(s.index+t,0,e);})));var f=c.filter((function(e){if("string"==typeof e){if(u.includes(e))return !1}else if(u.includes(e.key))return !1;return !0})),d=f.length;f.forEach((function(r,o){if("|"===r){if(0===o)return;if(o+1===d)return;if("|"===t)return;var i=Ad$1();return n.append(i),void(t=r)}if("string"==typeof r)return e.registerSingleItem(r,e),void(t=r);e.registerGroup(r),t="group";}));},e.prototype.registerGroup=function(e){var t=this,n=this.$toolbar,r=function(e){return new Jd(e)}(e),o=e.menuKeys,i=void 0===o?[]:o,a=this.config.excludeKeys,s=void 0===a?[]:a;i.forEach((function(e){s.includes(e)||t.registerSingleItem(e,r);})),n.append(r.$elem);},e.prototype.registerSingleItem=function(e,t){var n=this.getEditorInstance(),r=t instanceof Jd,o=this.menus,i=o[e];if(null==i){var a=sl$1[e];if(null==a)throw new Error("Not found menu item factory by key '"+e+"'");if("function"!=typeof a)throw new Error("Menu item factory (key='"+e+"') is not a function");i=a(),o[e]=i;}else console.warn("Duplicated toolbar menu key '"+e+"'\n重复注册了菜单栏 menu '"+e+"'");var s=Qd(e,i,r);(this.toolbarItems.push(s),ys$1.set(s,n),r)?t.appendBarItem(s):t.$toolbar.append(s.$elem);},e.prototype.getEditorInstance=function(){var e=hs$1.get(this);if(null==e)throw new Error("Can not get editor instance");return e},e.prototype.destroy=function(){this.$toolbar.remove(),this.menus={},this.toolbarItems=[];},e}();function lh(e,t){if(null==e)throw new Error("Cannot create toolbar, because editor is null");var n=t.selector,r=t.config,o=void 0===r?{}:r;if(function(e,t){return Jc$1(e,"data-w-e-toolbar",t)}(e,n))throw new Error("Repeated create toolbar by selector '"+n+"'");var i=ca$4({toolbarKeys:[],excludeKeys:[],insertKeys:{index:0,keys:[]},modalAppendToBody:!1},o||{}),a=new sh(n,i);return hs$1.set(a,e),ps$1.set(e,a),a}var uh=Vt$6.EXISTS,ch=mt$6.f,fh=Function.prototype,dh=ve$6(fh.toString),hh=/function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/,ph=ve$6(hh.exec);function gh(e){var t=e.server,n=void 0===t?"":t,r=e.fieldName,o=void 0===r?"":r,i=e.maxFileSize,a=void 0===i?10485760:i,s=e.maxNumberOfFiles,l=void 0===s?100:s,u=e.meta,c=void 0===u?{}:u,f=e.metaWithUrl,d=void 0!==f&&f,h=e.headers,p=void 0===h?{}:h,g=e.withCredentials,v=void 0!==g&&g,y=e.timeout,m=void 0===y?1e4:y,b=e.onBeforeUpload,w=void 0===b?function(e){return e}:b,x=e.onSuccess,S=void 0===x?function(e,t){}:x,k=e.onError,E=void 0===k?function(e,t,n){console.error(e.name+" upload error",t,n);}:k,O=e.onProgress,C=void 0===O?function(e){}:O;if(!n)throw new Error("Cannot get upload server address\n没有配置上传地址");if(!o)throw new Error("Cannot get fieldName\n没有配置 fieldName");var N=n;d&&(N=function(e,t){var n=da$4(e.split("#"),2),r=n[0],o=n[1],i=[];lodash_foreach(t,(function(e,t){i.push(t+"="+e);}));var a=i.join("&");return r=r.indexOf("?")>0?r+"&"+a:r+"?"+a,o?r+"#"+o:r}(N,c));var T=new lib$2({onBeforeUpload:w,restrictions:{maxFileSize:a,maxNumberOfFiles:l},meta:c}).use(lib,{endpoint:N,headers:p,formData:!0,fieldName:o,bundle:!0,withCredentials:v,timeout:m});return T.on("upload-success",(function(e,t){var n=t.body,r=void 0===n?{}:n;try{S(e,r);}catch(e){console.error("wangEditor upload file - onSuccess error",e);}T.removeFile(e.id);})),T.on("progress",(function(e){e<1||C(e);})),T.on("upload-error",(function(e,t,n){try{E(e,t,n);}catch(e){console.error("wangEditor upload file - onError error",e);}T.removeFile(e.id);})),T.on("restriction-failed",(function(e,t){try{E(e,t);}catch(e){console.error("wangEditor upload file - onError error",e);}T.removeFile(e.id);})),T}function vh(e){return vh="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},vh(e)}function yh(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function mh(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?Object(arguments[t]):{},r=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&r.push.apply(r,Object.getOwnPropertySymbols(n).filter((function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable}))),r.forEach((function(t){yh(e,t,n[t]);}));}return e}function bh(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function wh(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}function xh(e,t,n){return t&&wh(e.prototype,t),n&&wh(e,n),e}function Sh(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function kh(e,t){if(t&&("object"===vh(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return Sh(e)}function Eh(e){return Eh=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},Eh(e)}function Oh(e,t){return Oh=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},Oh(e,t)}function Ch(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&Oh(e,t);}Ke$6&&!uh&&ch(fh,"name",{configurable:!0,get:function(){try{return ph(hh,dh(this))[1]}catch(e){return ""}}});var Nh={type:"logger",log:function(e){this.output("log",e);},warn:function(e){this.output("warn",e);},error:function(e){this.output("error",e);},output:function(e,t){console&&console[e]&&console[e].apply(console,t);}},Th=new(function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};bh(this,e),this.init(t,n);}return xh(e,[{key:"init",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};this.prefix=t.prefix||"i18next:",this.logger=e||Nh,this.options=t,this.debug=t.debug;}},{key:"setDebug",value:function(e){this.debug=e;}},{key:"log",value:function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return this.forward(t,"log","",!0)}},{key:"warn",value:function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return this.forward(t,"warn","",!0)}},{key:"error",value:function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return this.forward(t,"error","")}},{key:"deprecate",value:function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return this.forward(t,"warn","WARNING DEPRECATED: ",!0)}},{key:"forward",value:function(e,t,n,r){return r&&!this.debug?null:("string"==typeof e[0]&&(e[0]="".concat(n).concat(this.prefix," ").concat(e[0])),this.logger[t](e))}},{key:"create",value:function(t){return new e(this.logger,mh({},{prefix:"".concat(this.prefix,":").concat(t,":")},this.options))}}]),e}()),Lh=function(){function e(){bh(this,e),this.observers={};}return xh(e,[{key:"on",value:function(e,t){var n=this;return e.split(" ").forEach((function(e){n.observers[e]=n.observers[e]||[],n.observers[e].push(t);})),this}},{key:"off",value:function(e,t){this.observers[e]&&(t?this.observers[e]=this.observers[e].filter((function(e){return e!==t})):delete this.observers[e]);}},{key:"emit",value:function(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];if(this.observers[e]){var o=[].concat(this.observers[e]);o.forEach((function(e){e.apply(void 0,n);}));}if(this.observers["*"]){var i=[].concat(this.observers["*"]);i.forEach((function(t){t.apply(t,[e].concat(n));}));}}}]),e}();function Mh(){var e,t,n=new Promise((function(n,r){e=n,t=r;}));return n.resolve=e,n.reject=t,n}function Ph(e){return null==e?"":""+e}function Dh(e,t,n){e.forEach((function(e){t[e]&&(n[e]=t[e]);}));}function Rh(e,t,n){function r(e){return e&&e.indexOf("###")>-1?e.replace(/###/g,"."):e}function o(){return !e||"string"==typeof e}for(var i="string"!=typeof t?[].concat(t):t.split(".");i.length>1;){if(o())return {};var a=r(i.shift());!e[a]&&n&&(e[a]=new n),e=Object.prototype.hasOwnProperty.call(e,a)?e[a]:{};}return o()?{}:{obj:e,k:r(i.shift())}}function jh(e,t,n){var r=Rh(e,t,Object);r.obj[r.k]=n;}function Ah(e,t){var n=Rh(e,t),r=n.obj,o=n.k;if(r)return r[o]}function Fh(e,t,n){var r=Ah(e,n);return void 0!==r?r:Ah(t,n)}function Ih(e,t,n){for(var r in t)"__proto__"!==r&&"constructor"!==r&&(r in e?"string"==typeof e[r]||e[r]instanceof String||"string"==typeof t[r]||t[r]instanceof String?n&&(e[r]=t[r]):Ih(e[r],t[r],n):e[r]=t[r]);return e}function _h(e){return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")}var Bh={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;"};function $h(e){return "string"==typeof e?e.replace(/[&<>"'\/]/g,(function(e){return Bh[e]})):e}var Wh="undefined"!=typeof window&&window.navigator&&window.navigator.userAgent&&window.navigator.userAgent.indexOf("MSIE")>-1;function Vh(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:".";if(e){if(e[t])return e[t];for(var r=t.split(n),o=e,i=0;i<r.length;++i){if(!o)return;if("string"==typeof o[r[i]]&&i+1<r.length)return;if(void 0===o[r[i]]){for(var a=2,s=r.slice(i,i+a).join(n),l=o[s];void 0===l&&r.length>i+a;)a++,l=o[s=r.slice(i,i+a).join(n)];if(void 0===l)return;if("string"==typeof l)return l;if(s&&"string"==typeof l[s])return l[s];var u=r.slice(i+a).join(n);return u?Vh(l,u,n):void 0}o=o[r[i]];}return o}}var zh=function(e){function t(e){var n,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{ns:["translation"],defaultNS:"translation"};return bh(this,t),n=kh(this,Eh(t).call(this)),Wh&&Lh.call(Sh(n)),n.data=e||{},n.options=r,void 0===n.options.keySeparator&&(n.options.keySeparator="."),void 0===n.options.ignoreJSONStructure&&(n.options.ignoreJSONStructure=!0),n}return Ch(t,Lh),xh(t,[{key:"addNamespaces",value:function(e){this.options.ns.indexOf(e)<0&&this.options.ns.push(e);}},{key:"removeNamespaces",value:function(e){var t=this.options.ns.indexOf(e);t>-1&&this.options.ns.splice(t,1);}},{key:"getResource",value:function(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},o=void 0!==r.keySeparator?r.keySeparator:this.options.keySeparator,i=void 0!==r.ignoreJSONStructure?r.ignoreJSONStructure:this.options.ignoreJSONStructure,a=[e,t];n&&"string"!=typeof n&&(a=a.concat(n)),n&&"string"==typeof n&&(a=a.concat(o?n.split(o):n)),e.indexOf(".")>-1&&(a=e.split("."));var s=Ah(this.data,a);return s||!i||"string"!=typeof n?s:Vh(this.data&&this.data[e]&&this.data[e][t],n,o)}},{key:"addResource",value:function(e,t,n,r){var o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:{silent:!1},i=this.options.keySeparator;void 0===i&&(i=".");var a=[e,t];n&&(a=a.concat(i?n.split(i):n)),e.indexOf(".")>-1&&(r=t,t=(a=e.split("."))[1]),this.addNamespaces(t),jh(this.data,a,r),o.silent||this.emit("added",e,t,n,r);}},{key:"addResources",value:function(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{silent:!1};for(var o in n)"string"!=typeof n[o]&&"[object Array]"!==Object.prototype.toString.apply(n[o])||this.addResource(e,t,o,n[o],{silent:!0});r.silent||this.emit("added",e,t,n);}},{key:"addResourceBundle",value:function(e,t,n,r,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:{silent:!1},a=[e,t];e.indexOf(".")>-1&&(r=n,n=t,t=(a=e.split("."))[1]),this.addNamespaces(t);var s=Ah(this.data,a)||{};r?Ih(s,n,o):s=mh({},s,n),jh(this.data,a,s),i.silent||this.emit("added",e,t,n);}},{key:"removeResourceBundle",value:function(e,t){this.hasResourceBundle(e,t)&&delete this.data[e][t],this.removeNamespaces(t),this.emit("removed",e,t);}},{key:"hasResourceBundle",value:function(e,t){return void 0!==this.getResource(e,t)}},{key:"getResourceBundle",value:function(e,t){return t||(t=this.options.defaultNS),"v1"===this.options.compatibilityAPI?mh({},{},this.getResource(e,t)):this.getResource(e,t)}},{key:"getDataByLanguage",value:function(e){return this.data[e]}},{key:"toJSON",value:function(){return this.data}}]),t}(),Hh={processors:{},addPostProcessor:function(e){this.processors[e.name]=e;},handle:function(e,t,n,r,o){var i=this;return e.forEach((function(e){i.processors[e]&&(t=i.processors[e].process(t,n,r,o));})),t}},Uh={},Kh=function(e){function t(e){var n,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return bh(this,t),n=kh(this,Eh(t).call(this)),Wh&&Lh.call(Sh(n)),Dh(["resourceStore","languageUtils","pluralResolver","interpolator","backendConnector","i18nFormat","utils"],e,Sh(n)),n.options=r,void 0===n.options.keySeparator&&(n.options.keySeparator="."),n.logger=Th.create("translator"),n}return Ch(t,Lh),xh(t,[{key:"changeLanguage",value:function(e){e&&(this.language=e);}},{key:"exists",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{interpolation:{}};if(null==e)return !1;var n=this.resolve(e,t);return n&&void 0!==n.res}},{key:"extractFromKey",value:function(e,t){var n=void 0!==t.nsSeparator?t.nsSeparator:this.options.nsSeparator;void 0===n&&(n=":");var r=void 0!==t.keySeparator?t.keySeparator:this.options.keySeparator,o=t.ns||this.options.defaultNS;if(n&&e.indexOf(n)>-1){var i=e.match(this.interpolator.nestingRegexp);if(i&&i.length>0)return {key:e,namespaces:o};var a=e.split(n);(n!==r||n===r&&this.options.ns.indexOf(a[0])>-1)&&(o=a.shift()),e=a.join(r);}return "string"==typeof o&&(o=[o]),{key:e,namespaces:o}}},{key:"translate",value:function(e,n,r){var o=this;if("object"!==vh(n)&&this.options.overloadTranslationOptionHandler&&(n=this.options.overloadTranslationOptionHandler(arguments)),n||(n={}),null==e)return "";Array.isArray(e)||(e=[String(e)]);var i=void 0!==n.keySeparator?n.keySeparator:this.options.keySeparator,a=this.extractFromKey(e[e.length-1],n),s=a.key,l=a.namespaces,u=l[l.length-1],c=n.lng||this.language,f=n.appendNamespaceToCIMode||this.options.appendNamespaceToCIMode;if(c&&"cimode"===c.toLowerCase()){if(f){var d=n.nsSeparator||this.options.nsSeparator;return u+d+s}return s}var h=this.resolve(e,n),p=h&&h.res,g=h&&h.usedKey||s,v=h&&h.exactUsedKey||s,y=Object.prototype.toString.apply(p),m=["[object Number]","[object Function]","[object RegExp]"],b=void 0!==n.joinArrays?n.joinArrays:this.options.joinArrays,w=!this.i18nFormat||this.i18nFormat.handleAsObject,x="string"!=typeof p&&"boolean"!=typeof p&&"number"!=typeof p;if(w&&p&&x&&m.indexOf(y)<0&&("string"!=typeof b||"[object Array]"!==y)){if(!n.returnObjects&&!this.options.returnObjects)return this.options.returnedObjectHandler||this.logger.warn("accessing an object - but returnObjects options is not enabled!"),this.options.returnedObjectHandler?this.options.returnedObjectHandler(g,p,mh({},n,{ns:l})):"key '".concat(s," (").concat(this.language,")' returned an object instead of string.");if(i){var S="[object Array]"===y,k=S?[]:{},E=S?v:g;for(var O in p)if(Object.prototype.hasOwnProperty.call(p,O)){var C="".concat(E).concat(i).concat(O);k[O]=this.translate(C,mh({},n,{joinArrays:!1,ns:l})),k[O]===C&&(k[O]=p[O]);}p=k;}}else if(w&&"string"==typeof b&&"[object Array]"===y)(p=p.join(b))&&(p=this.extendTranslation(p,e,n,r));else {var N=!1,T=!1,L=void 0!==n.count&&"string"!=typeof n.count,M=t.hasDefaultValue(n),P=L?this.pluralResolver.getSuffix(c,n.count):"",D=n["defaultValue".concat(P)]||n.defaultValue;!this.isValidLookup(p)&&M&&(N=!0,p=D),this.isValidLookup(p)||(T=!0,p=s);var R=n.missingKeyNoValueFallbackToKey||this.options.missingKeyNoValueFallbackToKey,j=R&&T?void 0:p,A=M&&D!==p&&this.options.updateMissing;if(T||N||A){if(this.logger.log(A?"updateKey":"missingKey",c,u,s,A?D:p),i){var F=this.resolve(s,mh({},n,{keySeparator:!1}));F&&F.res&&this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");}var I=[],_=this.languageUtils.getFallbackCodes(this.options.fallbackLng,n.lng||this.language);if("fallback"===this.options.saveMissingTo&&_&&_[0])for(var B=0;B<_.length;B++)I.push(_[B]);else "all"===this.options.saveMissingTo?I=this.languageUtils.toResolveHierarchy(n.lng||this.language):I.push(n.lng||this.language);var $=function(e,t,r){o.options.missingKeyHandler?o.options.missingKeyHandler(e,u,t,A?r:j,A,n):o.backendConnector&&o.backendConnector.saveMissing&&o.backendConnector.saveMissing(e,u,t,A?r:j,A,n),o.emit("missingKey",e,u,t,p);};this.options.saveMissing&&(this.options.saveMissingPlurals&&L?I.forEach((function(e){o.pluralResolver.getSuffixes(e).forEach((function(t){$([e],s+t,n["defaultValue".concat(t)]||D);}));})):$(I,s,D));}p=this.extendTranslation(p,e,n,h,r),T&&p===s&&this.options.appendNamespaceToMissingKey&&(p="".concat(u,":").concat(s)),(T||N)&&this.options.parseMissingKeyHandler&&(p=this.options.parseMissingKeyHandler(p));}return p}},{key:"extendTranslation",value:function(e,t,n,r,o){var i=this;if(this.i18nFormat&&this.i18nFormat.parse)e=this.i18nFormat.parse(e,n,r.usedLng,r.usedNS,r.usedKey,{resolved:r});else if(!n.skipInterpolation){n.interpolation&&this.interpolator.init(mh({},n,{interpolation:mh({},this.options.interpolation,n.interpolation)}));var a,s=n.interpolation&&n.interpolation.skipOnVariables||this.options.interpolation.skipOnVariables;if(s){var l=e.match(this.interpolator.nestingRegexp);a=l&&l.length;}var u=n.replace&&"string"!=typeof n.replace?n.replace:n;if(this.options.interpolation.defaultVariables&&(u=mh({},this.options.interpolation.defaultVariables,u)),e=this.interpolator.interpolate(e,u,n.lng||this.language,n),s){var c=e.match(this.interpolator.nestingRegexp);a<(c&&c.length)&&(n.nest=!1);}!1!==n.nest&&(e=this.interpolator.nest(e,(function(){for(var e=arguments.length,r=new Array(e),a=0;a<e;a++)r[a]=arguments[a];return o&&o[0]===r[0]&&!n.context?(i.logger.warn("It seems you are nesting recursively key: ".concat(r[0]," in key: ").concat(t[0])),null):i.translate.apply(i,r.concat([t]))}),n)),n.interpolation&&this.interpolator.reset();}var f=n.postProcess||this.options.postProcess,d="string"==typeof f?[f]:f;return null!=e&&d&&d.length&&!1!==n.applyPostProcessor&&(e=Hh.handle(d,e,t,this.options&&this.options.postProcessPassResolved?mh({i18nResolved:r},n):n,this)),e}},{key:"resolve",value:function(e){var t,n,r,o,i,a=this,s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return "string"==typeof e&&(e=[e]),e.forEach((function(e){if(!a.isValidLookup(t)){var l=a.extractFromKey(e,s),u=l.key;n=u;var c=l.namespaces;a.options.fallbackNS&&(c=c.concat(a.options.fallbackNS));var f=void 0!==s.count&&"string"!=typeof s.count,d=void 0!==s.context&&("string"==typeof s.context||"number"==typeof s.context)&&""!==s.context,h=s.lngs?s.lngs:a.languageUtils.toResolveHierarchy(s.lng||a.language,s.fallbackLng);c.forEach((function(e){a.isValidLookup(t)||(i=e,!Uh["".concat(h[0],"-").concat(e)]&&a.utils&&a.utils.hasLoadedNamespace&&!a.utils.hasLoadedNamespace(i)&&(Uh["".concat(h[0],"-").concat(e)]=!0,a.logger.warn('key "'.concat(n,'" for languages "').concat(h.join(", "),'" won\'t get resolved as namespace "').concat(i,'" was not yet loaded'),"This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")),h.forEach((function(n){if(!a.isValidLookup(t)){o=n;var i,l,c=u,h=[c];if(a.i18nFormat&&a.i18nFormat.addLookupKeys)a.i18nFormat.addLookupKeys(h,u,n,e,s);else f&&(i=a.pluralResolver.getSuffix(n,s.count)),f&&d&&h.push(c+i),d&&h.push(c+="".concat(a.options.contextSeparator).concat(s.context)),f&&h.push(c+=i);for(;l=h.pop();)a.isValidLookup(t)||(r=l,t=a.getResource(n,e,l,s));}})));}));}})),{res:t,usedKey:n,exactUsedKey:r,usedLng:o,usedNS:i}}},{key:"isValidLookup",value:function(e){return !(void 0===e||!this.options.returnNull&&null===e||!this.options.returnEmptyString&&""===e)}},{key:"getResource",value:function(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};return this.i18nFormat&&this.i18nFormat.getResource?this.i18nFormat.getResource(e,t,n,r):this.resourceStore.getResource(e,t,n,r)}}],[{key:"hasDefaultValue",value:function(e){var t="defaultValue";for(var n in e)if(Object.prototype.hasOwnProperty.call(e,n)&&t===n.substring(0,t.length)&&void 0!==e[n])return !0;return !1}}]),t}();function qh(e){return e.charAt(0).toUpperCase()+e.slice(1)}var Gh=function(){function e(t){bh(this,e),this.options=t,this.whitelist=this.options.supportedLngs||!1,this.supportedLngs=this.options.supportedLngs||!1,this.logger=Th.create("languageUtils");}return xh(e,[{key:"getScriptPartFromCode",value:function(e){if(!e||e.indexOf("-")<0)return null;var t=e.split("-");return 2===t.length?null:(t.pop(),"x"===t[t.length-1].toLowerCase()?null:this.formatLanguageCode(t.join("-")))}},{key:"getLanguagePartFromCode",value:function(e){if(!e||e.indexOf("-")<0)return e;var t=e.split("-");return this.formatLanguageCode(t[0])}},{key:"formatLanguageCode",value:function(e){if("string"==typeof e&&e.indexOf("-")>-1){var t=["hans","hant","latn","cyrl","cans","mong","arab"],n=e.split("-");return this.options.lowerCaseLng?n=n.map((function(e){return e.toLowerCase()})):2===n.length?(n[0]=n[0].toLowerCase(),n[1]=n[1].toUpperCase(),t.indexOf(n[1].toLowerCase())>-1&&(n[1]=qh(n[1].toLowerCase()))):3===n.length&&(n[0]=n[0].toLowerCase(),2===n[1].length&&(n[1]=n[1].toUpperCase()),"sgn"!==n[0]&&2===n[2].length&&(n[2]=n[2].toUpperCase()),t.indexOf(n[1].toLowerCase())>-1&&(n[1]=qh(n[1].toLowerCase())),t.indexOf(n[2].toLowerCase())>-1&&(n[2]=qh(n[2].toLowerCase()))),n.join("-")}return this.options.cleanCode||this.options.lowerCaseLng?e.toLowerCase():e}},{key:"isWhitelisted",value:function(e){return this.logger.deprecate("languageUtils.isWhitelisted",'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.'),this.isSupportedCode(e)}},{key:"isSupportedCode",value:function(e){return ("languageOnly"===this.options.load||this.options.nonExplicitSupportedLngs)&&(e=this.getLanguagePartFromCode(e)),!this.supportedLngs||!this.supportedLngs.length||this.supportedLngs.indexOf(e)>-1}},{key:"getBestMatchFromCodes",value:function(e){var t,n=this;return e?(e.forEach((function(e){if(!t){var r=n.formatLanguageCode(e);n.options.supportedLngs&&!n.isSupportedCode(r)||(t=r);}})),!t&&this.options.supportedLngs&&e.forEach((function(e){if(!t){var r=n.getLanguagePartFromCode(e);if(n.isSupportedCode(r))return t=r;t=n.options.supportedLngs.find((function(e){if(0===e.indexOf(r))return e}));}})),t||(t=this.getFallbackCodes(this.options.fallbackLng)[0]),t):null}},{key:"getFallbackCodes",value:function(e,t){if(!e)return [];if("function"==typeof e&&(e=e(t)),"string"==typeof e&&(e=[e]),"[object Array]"===Object.prototype.toString.apply(e))return e;if(!t)return e.default||[];var n=e[t];return n||(n=e[this.getScriptPartFromCode(t)]),n||(n=e[this.formatLanguageCode(t)]),n||(n=e[this.getLanguagePartFromCode(t)]),n||(n=e.default),n||[]}},{key:"toResolveHierarchy",value:function(e,t){var n=this,r=this.getFallbackCodes(t||this.options.fallbackLng||[],e),o=[],i=function(e){e&&(n.isSupportedCode(e)?o.push(e):n.logger.warn("rejecting language code not found in supportedLngs: ".concat(e)));};return "string"==typeof e&&e.indexOf("-")>-1?("languageOnly"!==this.options.load&&i(this.formatLanguageCode(e)),"languageOnly"!==this.options.load&&"currentOnly"!==this.options.load&&i(this.getScriptPartFromCode(e)),"currentOnly"!==this.options.load&&i(this.getLanguagePartFromCode(e))):"string"==typeof e&&i(this.formatLanguageCode(e)),r.forEach((function(e){o.indexOf(e)<0&&i(n.formatLanguageCode(e));})),o}}]),e}(),Jh=[{lngs:["ach","ak","am","arn","br","fil","gun","ln","mfe","mg","mi","oc","pt","pt-BR","tg","tl","ti","tr","uz","wa"],nr:[1,2],fc:1},{lngs:["af","an","ast","az","bg","bn","ca","da","de","dev","el","en","eo","es","et","eu","fi","fo","fur","fy","gl","gu","ha","hi","hu","hy","ia","it","kk","kn","ku","lb","mai","ml","mn","mr","nah","nap","nb","ne","nl","nn","no","nso","pa","pap","pms","ps","pt-PT","rm","sco","se","si","so","son","sq","sv","sw","ta","te","tk","ur","yo"],nr:[1,2],fc:2},{lngs:["ay","bo","cgg","fa","ht","id","ja","jbo","ka","km","ko","ky","lo","ms","sah","su","th","tt","ug","vi","wo","zh"],nr:[1],fc:3},{lngs:["be","bs","cnr","dz","hr","ru","sr","uk"],nr:[1,2,5],fc:4},{lngs:["ar"],nr:[0,1,2,3,11,100],fc:5},{lngs:["cs","sk"],nr:[1,2,5],fc:6},{lngs:["csb","pl"],nr:[1,2,5],fc:7},{lngs:["cy"],nr:[1,2,3,8],fc:8},{lngs:["fr"],nr:[1,2],fc:9},{lngs:["ga"],nr:[1,2,3,7,11],fc:10},{lngs:["gd"],nr:[1,2,3,20],fc:11},{lngs:["is"],nr:[1,2],fc:12},{lngs:["jv"],nr:[0,1],fc:13},{lngs:["kw"],nr:[1,2,3,4],fc:14},{lngs:["lt"],nr:[1,2,10],fc:15},{lngs:["lv"],nr:[1,2,0],fc:16},{lngs:["mk"],nr:[1,2],fc:17},{lngs:["mnk"],nr:[0,1,2],fc:18},{lngs:["mt"],nr:[1,2,11,20],fc:19},{lngs:["or"],nr:[2,1],fc:2},{lngs:["ro"],nr:[1,2,20],fc:20},{lngs:["sl"],nr:[5,1,2,3],fc:21},{lngs:["he","iw"],nr:[1,2,20,21],fc:22}],Yh={1:function(e){return Number(e>1)},2:function(e){return Number(1!=e)},3:function(e){return 0},4:function(e){return Number(e%10==1&&e%100!=11?0:e%10>=2&&e%10<=4&&(e%100<10||e%100>=20)?1:2)},5:function(e){return Number(0==e?0:1==e?1:2==e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5)},6:function(e){return Number(1==e?0:e>=2&&e<=4?1:2)},7:function(e){return Number(1==e?0:e%10>=2&&e%10<=4&&(e%100<10||e%100>=20)?1:2)},8:function(e){return Number(1==e?0:2==e?1:8!=e&&11!=e?2:3)},9:function(e){return Number(e>=2)},10:function(e){return Number(1==e?0:2==e?1:e<7?2:e<11?3:4)},11:function(e){return Number(1==e||11==e?0:2==e||12==e?1:e>2&&e<20?2:3)},12:function(e){return Number(e%10!=1||e%100==11)},13:function(e){return Number(0!==e)},14:function(e){return Number(1==e?0:2==e?1:3==e?2:3)},15:function(e){return Number(e%10==1&&e%100!=11?0:e%10>=2&&(e%100<10||e%100>=20)?1:2)},16:function(e){return Number(e%10==1&&e%100!=11?0:0!==e?1:2)},17:function(e){return Number(1==e||e%10==1&&e%100!=11?0:1)},18:function(e){return Number(0==e?0:1==e?1:2)},19:function(e){return Number(1==e?0:0==e||e%100>1&&e%100<11?1:e%100>10&&e%100<20?2:3)},20:function(e){return Number(1==e?0:0==e||e%100>0&&e%100<20?1:2)},21:function(e){return Number(e%100==1?1:e%100==2?2:e%100==3||e%100==4?3:0)},22:function(e){return Number(1==e?0:2==e?1:(e<0||e>10)&&e%10==0?2:3)}};function Xh(){var e={};return Jh.forEach((function(t){t.lngs.forEach((function(n){e[n]={numbers:t.nr,plurals:Yh[t.fc]};}));})),e}var Qh=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};bh(this,e),this.languageUtils=t,this.options=n,this.logger=Th.create("pluralResolver"),this.rules=Xh();}return xh(e,[{key:"addRule",value:function(e,t){this.rules[e]=t;}},{key:"getRule",value:function(e){return this.rules[e]||this.rules[this.languageUtils.getLanguagePartFromCode(e)]}},{key:"needsPlural",value:function(e){var t=this.getRule(e);return t&&t.numbers.length>1}},{key:"getPluralFormsOfKey",value:function(e,t){return this.getSuffixes(e).map((function(e){return t+e}))}},{key:"getSuffixes",value:function(e){var t=this,n=this.getRule(e);return n?n.numbers.map((function(n){return t.getSuffix(e,n)})):[]}},{key:"getSuffix",value:function(e,t){var n=this,r=this.getRule(e);if(r){var o=r.noAbs?r.plurals(t):r.plurals(Math.abs(t)),i=r.numbers[o];this.options.simplifyPluralSuffix&&2===r.numbers.length&&1===r.numbers[0]&&(2===i?i="plural":1===i&&(i=""));var a=function(){return n.options.prepend&&i.toString()?n.options.prepend+i.toString():i.toString()};return "v1"===this.options.compatibilityJSON?1===i?"":"number"==typeof i?"_plural_".concat(i.toString()):a():"v2"===this.options.compatibilityJSON||this.options.simplifyPluralSuffix&&2===r.numbers.length&&1===r.numbers[0]?a():this.options.prepend&&o.toString()?this.options.prepend+o.toString():o.toString()}return this.logger.warn("no plural rule found for: ".concat(e)),""}}]),e}(),Zh=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};bh(this,e),this.logger=Th.create("interpolator"),this.options=t,this.format=t.interpolation&&t.interpolation.format||function(e){return e},this.init(t);}return xh(e,[{key:"init",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e.interpolation||(e.interpolation={escapeValue:!0});var t=e.interpolation;this.escape=void 0!==t.escape?t.escape:$h,this.escapeValue=void 0===t.escapeValue||t.escapeValue,this.useRawValueToEscape=void 0!==t.useRawValueToEscape&&t.useRawValueToEscape,this.prefix=t.prefix?_h(t.prefix):t.prefixEscaped||"{{",this.suffix=t.suffix?_h(t.suffix):t.suffixEscaped||"}}",this.formatSeparator=t.formatSeparator?t.formatSeparator:t.formatSeparator||",",this.unescapePrefix=t.unescapeSuffix?"":t.unescapePrefix||"-",this.unescapeSuffix=this.unescapePrefix?"":t.unescapeSuffix||"",this.nestingPrefix=t.nestingPrefix?_h(t.nestingPrefix):t.nestingPrefixEscaped||_h("$t("),this.nestingSuffix=t.nestingSuffix?_h(t.nestingSuffix):t.nestingSuffixEscaped||_h(")"),this.nestingOptionsSeparator=t.nestingOptionsSeparator?t.nestingOptionsSeparator:t.nestingOptionsSeparator||",",this.maxReplaces=t.maxReplaces?t.maxReplaces:1e3,this.alwaysFormat=void 0!==t.alwaysFormat&&t.alwaysFormat,this.resetRegExp();}},{key:"reset",value:function(){this.options&&this.init(this.options);}},{key:"resetRegExp",value:function(){var e="".concat(this.prefix,"(.+?)").concat(this.suffix);this.regexp=new RegExp(e,"g");var t="".concat(this.prefix).concat(this.unescapePrefix,"(.+?)").concat(this.unescapeSuffix).concat(this.suffix);this.regexpUnescape=new RegExp(t,"g");var n="".concat(this.nestingPrefix,"(.+?)").concat(this.nestingSuffix);this.nestingRegexp=new RegExp(n,"g");}},{key:"interpolate",value:function(e,t,n,r){var o,i,a,s=this,l=this.options&&this.options.interpolation&&this.options.interpolation.defaultVariables||{};function u(e){return e.replace(/\$/g,"$$$$")}var c=function(e){if(e.indexOf(s.formatSeparator)<0){var o=Fh(t,l,e);return s.alwaysFormat?s.format(o,void 0,n,mh({},r,t,{interpolationkey:e})):o}var i=e.split(s.formatSeparator),a=i.shift().trim(),u=i.join(s.formatSeparator).trim();return s.format(Fh(t,l,a),u,n,mh({},r,t,{interpolationkey:a}))};this.resetRegExp();var f=r&&r.missingInterpolationHandler||this.options.missingInterpolationHandler,d=r&&r.interpolation&&r.interpolation.skipOnVariables||this.options.interpolation.skipOnVariables,h=[{regex:this.regexpUnescape,safeValue:function(e){return u(e)}},{regex:this.regexp,safeValue:function(e){return s.escapeValue?u(s.escape(e)):u(e)}}];return h.forEach((function(t){for(a=0;o=t.regex.exec(e);){if(void 0===(i=c(o[1].trim())))if("function"==typeof f){var n=f(e,o,r);i="string"==typeof n?n:"";}else {if(d){i=o[0];continue}s.logger.warn("missed to pass in variable ".concat(o[1]," for interpolating ").concat(e)),i="";}else "string"==typeof i||s.useRawValueToEscape||(i=Ph(i));var l=t.safeValue(i);if(e=e.replace(o[0],l),d?(t.regex.lastIndex+=l.length,t.regex.lastIndex-=o[0].length):t.regex.lastIndex=0,++a>=s.maxReplaces)break}})),e}},{key:"nest",value:function(e,t){var n,r,o=this,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},a=mh({},i);function s(e,t){var n=this.nestingOptionsSeparator;if(e.indexOf(n)<0)return e;var r=e.split(new RegExp("".concat(n,"[ ]*{"))),o="{".concat(r[1]);e=r[0],o=(o=this.interpolate(o,a)).replace(/'/g,'"');try{a=JSON.parse(o),t&&(a=mh({},t,a));}catch(t){return this.logger.warn("failed parsing options string in nesting for key ".concat(e),t),"".concat(e).concat(n).concat(o)}return delete a.defaultValue,e}for(a.applyPostProcessor=!1,delete a.defaultValue;n=this.nestingRegexp.exec(e);){var l=[],u=!1;if(-1!==n[0].indexOf(this.formatSeparator)&&!/{.*}/.test(n[1])){var c=n[1].split(this.formatSeparator).map((function(e){return e.trim()}));n[1]=c.shift(),l=c,u=!0;}if((r=t(s.call(this,n[1].trim(),a),a))&&n[0]===e&&"string"!=typeof r)return r;"string"!=typeof r&&(r=Ph(r)),r||(this.logger.warn("missed to resolve ".concat(n[1]," for nesting ").concat(e)),r=""),u&&(r=l.reduce((function(e,t){return o.format(e,t,i.lng,mh({},i,{interpolationkey:n[1].trim()}))}),r.trim())),e=e.replace(n[0],r),this.regexp.lastIndex=0;}return e}}]),e}();var ep$1=function(e){function t(e,n,r){var o,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};return bh(this,t),o=kh(this,Eh(t).call(this)),Wh&&Lh.call(Sh(o)),o.backend=e,o.store=n,o.services=r,o.languageUtils=r.languageUtils,o.options=i,o.logger=Th.create("backendConnector"),o.state={},o.queue=[],o.backend&&o.backend.init&&o.backend.init(r,i.backend,i),o}return Ch(t,Lh),xh(t,[{key:"queueLoad",value:function(e,t,n,r){var o=this,i=[],a=[],s=[],l=[];return e.forEach((function(e){var r=!0;t.forEach((function(t){var s="".concat(e,"|").concat(t);!n.reload&&o.store.hasResourceBundle(e,t)?o.state[s]=2:o.state[s]<0||(1===o.state[s]?a.indexOf(s)<0&&a.push(s):(o.state[s]=1,r=!1,a.indexOf(s)<0&&a.push(s),i.indexOf(s)<0&&i.push(s),l.indexOf(t)<0&&l.push(t)));})),r||s.push(e);})),(i.length||a.length)&&this.queue.push({pending:a,loaded:{},errors:[],callback:r}),{toLoad:i,pending:a,toLoadLanguages:s,toLoadNamespaces:l}}},{key:"loaded",value:function(e,t,n){var r=e.split("|"),o=r[0],i=r[1];t&&this.emit("failedLoading",o,i,t),n&&this.store.addResourceBundle(o,i,n),this.state[e]=t?-1:2;var a={};this.queue.forEach((function(n){!function(e,t,n,r){var o=Rh(e,t,Object),i=o.obj,a=o.k;i[a]=i[a]||[],r&&(i[a]=i[a].concat(n)),r||i[a].push(n);}(n.loaded,[o],i),function(e,t){for(var n=e.indexOf(t);-1!==n;)e.splice(n,1),n=e.indexOf(t);}(n.pending,e),t&&n.errors.push(t),0!==n.pending.length||n.done||(Object.keys(n.loaded).forEach((function(e){a[e]||(a[e]=[]),n.loaded[e].length&&n.loaded[e].forEach((function(t){a[e].indexOf(t)<0&&a[e].push(t);}));})),n.done=!0,n.errors.length?n.callback(n.errors):n.callback());})),this.emit("loaded",a),this.queue=this.queue.filter((function(e){return !e.done}));}},{key:"read",value:function(e,t,n){var r=this,o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:350,a=arguments.length>5?arguments[5]:void 0;return e.length?this.backend[n](e,t,(function(s,l){s&&l&&o<5?setTimeout((function(){r.read.call(r,e,t,n,o+1,2*i,a);}),i):a(s,l);})):a(null,{})}},{key:"prepareLoading",value:function(e,t){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},o=arguments.length>3?arguments[3]:void 0;if(!this.backend)return this.logger.warn("No backend was added via i18next.use. Will not load resources."),o&&o();"string"==typeof e&&(e=this.languageUtils.toResolveHierarchy(e)),"string"==typeof t&&(t=[t]);var i=this.queueLoad(e,t,r,o);if(!i.toLoad.length)return i.pending.length||o(),null;i.toLoad.forEach((function(e){n.loadOne(e);}));}},{key:"load",value:function(e,t,n){this.prepareLoading(e,t,{},n);}},{key:"reload",value:function(e,t,n){this.prepareLoading(e,t,{reload:!0},n);}},{key:"loadOne",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",r=e.split("|"),o=r[0],i=r[1];this.read(o,i,"read",void 0,void 0,(function(r,a){r&&t.logger.warn("".concat(n,"loading namespace ").concat(i," for language ").concat(o," failed"),r),!r&&a&&t.logger.log("".concat(n,"loaded namespace ").concat(i," for language ").concat(o),a),t.loaded(e,r,a);}));}},{key:"saveMissing",value:function(e,t,n,r,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:{};this.services.utils&&this.services.utils.hasLoadedNamespace&&!this.services.utils.hasLoadedNamespace(t)?this.logger.warn('did not save key "'.concat(n,'" as the namespace "').concat(t,'" was not yet loaded'),"This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!"):null!=n&&""!==n&&(this.backend&&this.backend.create&&this.backend.create(e,t,n,r,null,mh({},i,{isUpdate:o})),e&&e[0]&&this.store.addResource(e[0],t,n,r));}}]),t}();function tp$1(){return {debug:!1,initImmediate:!0,ns:["translation"],defaultNS:["translation"],fallbackLng:["dev"],fallbackNS:!1,whitelist:!1,nonExplicitWhitelist:!1,supportedLngs:!1,nonExplicitSupportedLngs:!1,load:"all",preload:!1,simplifyPluralSuffix:!0,keySeparator:".",nsSeparator:":",pluralSeparator:"_",contextSeparator:"_",partialBundledLanguages:!1,saveMissing:!1,updateMissing:!1,saveMissingTo:"fallback",saveMissingPlurals:!0,missingKeyHandler:!1,missingInterpolationHandler:!1,postProcess:!1,postProcessPassResolved:!1,returnNull:!0,returnEmptyString:!0,returnObjects:!1,joinArrays:!1,returnedObjectHandler:!1,parseMissingKeyHandler:!1,appendNamespaceToMissingKey:!1,appendNamespaceToCIMode:!1,overloadTranslationOptionHandler:function(e){var t={};if("object"===vh(e[1])&&(t=e[1]),"string"==typeof e[1]&&(t.defaultValue=e[1]),"string"==typeof e[2]&&(t.tDescription=e[2]),"object"===vh(e[2])||"object"===vh(e[3])){var n=e[3]||e[2];Object.keys(n).forEach((function(e){t[e]=n[e];}));}return t},interpolation:{escapeValue:!0,format:function(e,t,n,r){return e},prefix:"{{",suffix:"}}",formatSeparator:",",unescapePrefix:"-",nestingPrefix:"$t(",nestingSuffix:")",nestingOptionsSeparator:",",maxReplaces:1e3,skipOnVariables:!1}}}function np$1(e){return "string"==typeof e.ns&&(e.ns=[e.ns]),"string"==typeof e.fallbackLng&&(e.fallbackLng=[e.fallbackLng]),"string"==typeof e.fallbackNS&&(e.fallbackNS=[e.fallbackNS]),e.whitelist&&(e.whitelist&&e.whitelist.indexOf("cimode")<0&&(e.whitelist=e.whitelist.concat(["cimode"])),e.supportedLngs=e.whitelist),e.nonExplicitWhitelist&&(e.nonExplicitSupportedLngs=e.nonExplicitWhitelist),e.supportedLngs&&e.supportedLngs.indexOf("cimode")<0&&(e.supportedLngs=e.supportedLngs.concat(["cimode"])),e}function rp$1(){}var op$1=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=arguments.length>1?arguments[1]:void 0;if(bh(this,t),e=kh(this,Eh(t).call(this)),Wh&&Lh.call(Sh(e)),e.options=np$1(n),e.services={},e.logger=Th,e.modules={external:[]},r&&!e.isInitialized&&!n.isClone){if(!e.options.initImmediate)return e.init(n,r),kh(e,Sh(e));setTimeout((function(){e.init(n,r);}),0);}return e}return Ch(t,Lh),xh(t,[{key:"init",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=arguments.length>1?arguments[1]:void 0;function r(e){return e?"function"==typeof e?new e:e:null}if("function"==typeof t&&(n=t,t={}),t.whitelist&&!t.supportedLngs&&this.logger.deprecate("whitelist",'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.'),t.nonExplicitWhitelist&&!t.nonExplicitSupportedLngs&&this.logger.deprecate("whitelist",'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.'),this.options=mh({},tp$1(),this.options,np$1(t)),this.format=this.options.interpolation.format,n||(n=rp$1),!this.options.isClone){this.modules.logger?Th.init(r(this.modules.logger),this.options):Th.init(null,this.options);var o=new Gh(this.options);this.store=new zh(this.options.resources,this.options);var i=this.services;i.logger=Th,i.resourceStore=this.store,i.languageUtils=o,i.pluralResolver=new Qh(o,{prepend:this.options.pluralSeparator,compatibilityJSON:this.options.compatibilityJSON,simplifyPluralSuffix:this.options.simplifyPluralSuffix}),i.interpolator=new Zh(this.options),i.utils={hasLoadedNamespace:this.hasLoadedNamespace.bind(this)},i.backendConnector=new ep$1(r(this.modules.backend),i.resourceStore,i,this.options),i.backendConnector.on("*",(function(t){for(var n=arguments.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];e.emit.apply(e,[t].concat(r));})),this.modules.languageDetector&&(i.languageDetector=r(this.modules.languageDetector),i.languageDetector.init(i,this.options.detection,this.options)),this.modules.i18nFormat&&(i.i18nFormat=r(this.modules.i18nFormat),i.i18nFormat.init&&i.i18nFormat.init(this)),this.translator=new Kh(this.services,this.options),this.translator.on("*",(function(t){for(var n=arguments.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];e.emit.apply(e,[t].concat(r));})),this.modules.external.forEach((function(t){t.init&&t.init(e);}));}if(this.options.fallbackLng&&!this.services.languageDetector&&!this.options.lng){var a=this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);a.length>0&&"dev"!==a[0]&&(this.options.lng=a[0]);}this.services.languageDetector||this.options.lng||this.logger.warn("init: no languageDetector is used and no lng is defined");var s=["getResource","hasResourceBundle","getResourceBundle","getDataByLanguage"];s.forEach((function(t){e[t]=function(){var n;return (n=e.store)[t].apply(n,arguments)};}));var l=["addResource","addResources","addResourceBundle","removeResourceBundle"];l.forEach((function(t){e[t]=function(){var n;return (n=e.store)[t].apply(n,arguments),e};}));var u=Mh(),c=function(){var t=function(t,r){e.isInitialized&&!e.initializedStoreOnce&&e.logger.warn("init: i18next is already initialized. You should call init just once!"),e.isInitialized=!0,e.options.isClone||e.logger.log("initialized",e.options),e.emit("initialized",e.options),u.resolve(r),n(t,r);};if(e.languages&&"v1"!==e.options.compatibilityAPI&&!e.isInitialized)return t(null,e.t.bind(e));e.changeLanguage(e.options.lng,t);};return this.options.resources||!this.options.initImmediate?c():setTimeout(c,0),u}},{key:"loadResources",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:rp$1,r=n,o="string"==typeof e?e:this.language;if("function"==typeof e&&(r=e),!this.options.resources||this.options.partialBundledLanguages){if(o&&"cimode"===o.toLowerCase())return r();var i=[],a=function(e){e&&t.services.languageUtils.toResolveHierarchy(e).forEach((function(e){i.indexOf(e)<0&&i.push(e);}));};if(o)a(o);else {var s=this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);s.forEach((function(e){return a(e)}));}this.options.preload&&this.options.preload.forEach((function(e){return a(e)})),this.services.backendConnector.load(i,this.options.ns,r);}else r(null);}},{key:"reloadResources",value:function(e,t,n){var r=Mh();return e||(e=this.languages),t||(t=this.options.ns),n||(n=rp$1),this.services.backendConnector.reload(e,t,(function(e){r.resolve(),n(e);})),r}},{key:"use",value:function(e){if(!e)throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");if(!e.type)throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");return "backend"===e.type&&(this.modules.backend=e),("logger"===e.type||e.log&&e.warn&&e.error)&&(this.modules.logger=e),"languageDetector"===e.type&&(this.modules.languageDetector=e),"i18nFormat"===e.type&&(this.modules.i18nFormat=e),"postProcessor"===e.type&&Hh.addPostProcessor(e),"3rdParty"===e.type&&this.modules.external.push(e),this}},{key:"changeLanguage",value:function(e,t){var n=this;this.isLanguageChangingTo=e;var r=Mh();this.emit("languageChanging",e);var o=function(o){e||o||!n.services.languageDetector||(o=[]);var i="string"==typeof o?o:n.services.languageUtils.getBestMatchFromCodes(o);i&&(n.language||(n.language=i,n.languages=n.services.languageUtils.toResolveHierarchy(i)),n.translator.language||n.translator.changeLanguage(i),n.services.languageDetector&&n.services.languageDetector.cacheUserLanguage(i)),n.loadResources(i,(function(e){!function(e,o){o?(n.language=o,n.languages=n.services.languageUtils.toResolveHierarchy(o),n.translator.changeLanguage(o),n.isLanguageChangingTo=void 0,n.emit("languageChanged",o),n.logger.log("languageChanged",o)):n.isLanguageChangingTo=void 0,r.resolve((function(){return n.t.apply(n,arguments)})),t&&t(e,(function(){return n.t.apply(n,arguments)}));}(e,i);}));};return e||!this.services.languageDetector||this.services.languageDetector.async?!e&&this.services.languageDetector&&this.services.languageDetector.async?this.services.languageDetector.detect(o):o(e):o(this.services.languageDetector.detect()),r}},{key:"getFixedT",value:function(e,t,n){var r=this,o=function e(t,o){var i;if("object"!==vh(o)){for(var a=arguments.length,s=new Array(a>2?a-2:0),l=2;l<a;l++)s[l-2]=arguments[l];i=r.options.overloadTranslationOptionHandler([t,o].concat(s));}else i=mh({},o);i.lng=i.lng||e.lng,i.lngs=i.lngs||e.lngs,i.ns=i.ns||e.ns;var u=r.options.keySeparator||".",c=n?"".concat(n).concat(u).concat(t):t;return r.t(c,i)};return "string"==typeof e?o.lng=e:o.lngs=e,o.ns=t,o.keyPrefix=n,o}},{key:"t",value:function(){var e;return this.translator&&(e=this.translator).translate.apply(e,arguments)}},{key:"exists",value:function(){var e;return this.translator&&(e=this.translator).exists.apply(e,arguments)}},{key:"setDefaultNamespace",value:function(e){this.options.defaultNS=e;}},{key:"hasLoadedNamespace",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!this.isInitialized)return this.logger.warn("hasLoadedNamespace: i18next was not initialized",this.languages),!1;if(!this.languages||!this.languages.length)return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty",this.languages),!1;var r=this.languages[0],o=!!this.options&&this.options.fallbackLng,i=this.languages[this.languages.length-1];if("cimode"===r.toLowerCase())return !0;var a=function(e,n){var r=t.services.backendConnector.state["".concat(e,"|").concat(n)];return -1===r||2===r};if(n.precheck){var s=n.precheck(this,a);if(void 0!==s)return s}return !!this.hasResourceBundle(r,e)||(!this.services.backendConnector.backend||!(!a(r,e)||o&&!a(i,e)))}},{key:"loadNamespaces",value:function(e,t){var n=this,r=Mh();return this.options.ns?("string"==typeof e&&(e=[e]),e.forEach((function(e){n.options.ns.indexOf(e)<0&&n.options.ns.push(e);})),this.loadResources((function(e){r.resolve(),t&&t(e);})),r):(t&&t(),Promise.resolve())}},{key:"loadLanguages",value:function(e,t){var n=Mh();"string"==typeof e&&(e=[e]);var r=this.options.preload||[],o=e.filter((function(e){return r.indexOf(e)<0}));return o.length?(this.options.preload=r.concat(o),this.loadResources((function(e){n.resolve(),t&&t(e);})),n):(t&&t(),Promise.resolve())}},{key:"dir",value:function(e){if(e||(e=this.languages&&this.languages.length>0?this.languages[0]:this.language),!e)return "rtl";return ["ar","shu","sqr","ssh","xaa","yhd","yud","aao","abh","abv","acm","acq","acw","acx","acy","adf","ads","aeb","aec","afb","ajp","apc","apd","arb","arq","ars","ary","arz","auz","avl","ayh","ayl","ayn","ayp","bbz","pga","he","iw","ps","pbt","pbu","pst","prp","prd","ug","ur","ydd","yds","yih","ji","yi","hbo","men","xmn","fa","jpr","peo","pes","prs","dv","sam"].indexOf(this.services.languageUtils.getLanguagePartFromCode(e))>=0?"rtl":"ltr"}},{key:"createInstance",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=arguments.length>1?arguments[1]:void 0;return new t(e,n)}},{key:"cloneInstance",value:function(){var e=this,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:rp$1,o=mh({},this.options,n,{isClone:!0}),i=new t(o),a=["store","services","language"];return a.forEach((function(t){i[t]=e[t];})),i.services=mh({},this.services),i.services.utils={hasLoadedNamespace:i.hasLoadedNamespace.bind(i)},i.translator=new Kh(i.services,i.options),i.translator.on("*",(function(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];i.emit.apply(i,[e].concat(n));})),i.init(o,r),i.translator.options=i.options,i.translator.backendConnector.services.utils={hasLoadedNamespace:i.hasLoadedNamespace.bind(i)},i}},{key:"toJSON",value:function(){return {options:this.options,store:this.store,language:this.language,languages:this.languages}}}]),t}(),ip$1=new op$1,ap$1="translation";function sp$1(e,t){ip$1.addResourceBundle(e,ap$1,t,!0,!0);}function lp$1(e){ip$1.changeLanguage(e);}function up$1(e){return ip$1.getResourceBundle(e,ap$1)}ip$1.init({lng:"zh-CN",resources:{}});var cp$1=ip$1.t.bind(ip$1);

/**
 * @description i18n en
 * @author wangfupeng
 */
var enResources = {
    editor: {
        more: 'More',
        justify: 'Justify',
        indent: 'Indent',
        image: 'Image',
        video: 'Video',
    },
};

/**
 * @description i18n zh-CN
 * @author wangfupeng
 */
var zhResources = {
    editor: {
        more: '更多',
        justify: '对齐',
        indent: '缩进',
        image: '图片',
        video: '视频',
    },
};

/**
 * @description i18n entry
 * @author wangfupeng
 */
sp$1('en', enResources);
sp$1('zh-CN', zhResources);

sp$1("en",{common:{ok:"OK",delete:"Delete",enter:"Enter"},blockQuote:{title:"Quote"},codeBlock:{title:"Code block"},color:{color:"Font color",bgColor:"Back color",default:"Default color",clear:"Clear back color"},divider:{title:"Divider"},emotion:{title:"Emotion"},fontSize:{title:"Font size",default:"Default"},fontFamily:{title:"Font family",default:"Default"},fullScreen:{title:"Full screen"},header:{title:"Header",text:"Text"},image:{netImage:"Net image",delete:"Delete image",edit:"Edit image",viewLink:"View link",src:"Image src",desc:"Description",link:"Image link"},indent:{decrease:"Decrease",increase:"Increase"},justify:{left:"Left",right:"Right",center:"Center",justify:"Justify"},lineHeight:{title:"Line height",default:"Default"},link:{insert:"Insert link",text:"Link text",url:"Link source",unLink:"Unlink",edit:"Edit link",view:"View link"},textStyle:{bold:"Bold",clear:"Clear styles",code:"Inline code",italic:"Italic",sub:"Sub",sup:"Sup",through:"Through",underline:"Underline"},undo:{undo:"undo",redo:"Redo"},todo:{todo:"Todo"}}),sp$1("zh-CN",{common:{ok:"确定",delete:"删除",enter:"回车"},blockQuote:{title:"引用"},codeBlock:{title:"代码块"},color:{color:"文字颜色",bgColor:"背景色",default:"默认颜色",clear:"清除背景色"},divider:{title:"分割线"},emotion:{title:"表情"},fontSize:{title:"字号",default:"默认字号"},fontFamily:{title:"字体",default:"默认字体"},fullScreen:{title:"全屏"},header:{title:"标题",text:"正文"},image:{netImage:"网络图片",delete:"删除图片",edit:"编辑图片",viewLink:"查看链接",src:"图片地址",desc:"图片描述",link:"图片链接"},indent:{decrease:"减少缩进",increase:"增加缩进"},justify:{left:"左对齐",right:"右对齐",center:"居中对齐",justify:"两端对齐"},lineHeight:{title:"行高",default:"默认行高"},link:{insert:"插入链接",text:"链接文本",url:"链接地址",unLink:"取消链接",edit:"修改链接",view:"查看链接"},textStyle:{bold:"粗体",clear:"清除格式",code:"行内代码",italic:"斜体",sub:"下标",sup:"上标",through:"删除线",underline:"下划线"},undo:{undo:"撤销",redo:"重做"},todo:{todo:"待办"}});var _$5={type:"paragraph",renderElem:function(t,e,n){return jsx("p",null,e)}};var $$5={type:"paragraph",elemToHtml:function(t,e){return ""===e?"<p><br></p>":"<p>"+e+"</p>"}},q$5="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function W$5(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}function G$5(t){var e={exports:{}};return t(e,e.exports),e.exports}var U$5,X$5,Y$5=function(t){return t&&t.Math==Math&&t},J$5=Y$5("object"==typeof globalThis&&globalThis)||Y$5("object"==typeof window&&window)||Y$5("object"==typeof self&&self)||Y$5("object"==typeof q$5&&q$5)||function(){return this}()||Function("return this")(),K$5=function(t){try{return !!t()}catch(t){return !0}},Q$5=!K$5((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),Z$5=Function.prototype.call,tt$5=Z$5.bind?Z$5.bind(Z$5):function(){return Z$5.apply(Z$5,arguments)},et$5={}.propertyIsEnumerable,nt$5=Object.getOwnPropertyDescriptor,rt$5=nt$5&&!et$5.call({1:2},1)?function(t){var e=nt$5(this,t);return !!e&&e.enumerable}:et$5,ot$5={f:rt$5},it$5=function(t,e){return {enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},ut$5=Function.prototype,at$5=ut$5.bind,ct$5=ut$5.call,lt$5=at$5&&at$5.bind(ct$5),st$5=at$5?function(t){return t&&lt$5(ct$5,t)}:function(t){return t&&function(){return ct$5.apply(t,arguments)}},ft$5=st$5({}.toString),pt$5=st$5("".slice),dt$5=function(t){return pt$5(ft$5(t),8,-1)},ht$5=J$5.Object,vt$5=st$5("".split),gt$5=K$5((function(){return !ht$5("z").propertyIsEnumerable(0)}))?function(t){return "String"==dt$5(t)?vt$5(t,""):ht$5(t)}:ht$5,yt$5=J$5.TypeError,mt$5=function(t){if(null==t)throw yt$5("Can't call method on "+t);return t},bt$5=function(t){return gt$5(mt$5(t))},wt$5=function(t){return "function"==typeof t},xt$5=function(t){return "object"==typeof t?null!==t:wt$5(t)},St$5=function(t){return wt$5(t)?t:void 0},kt$5=function(t,e){return arguments.length<2?St$5(J$5[t]):J$5[t]&&J$5[t][e]},Et$5=st$5({}.isPrototypeOf),Tt$5=kt$5("navigator","userAgent")||"",Mt$5=J$5.process,Ht$5=J$5.Deno,Ot$5=Mt$5&&Mt$5.versions||Ht$5&&Ht$5.version,It$5=Ot$5&&Ot$5.v8;It$5&&(X$5=(U$5=It$5.split("."))[0]>0&&U$5[0]<4?1:+(U$5[0]+U$5[1])),!X$5&&Tt$5&&(!(U$5=Tt$5.match(/Edge\/(\d+)/))||U$5[1]>=74)&&(U$5=Tt$5.match(/Chrome\/(\d+)/))&&(X$5=+U$5[1]);var Nt$5=X$5,Lt$5=!!Object.getOwnPropertySymbols&&!K$5((function(){var t=Symbol();return !String(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&Nt$5&&Nt$5<41})),zt$5=Lt$5&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,jt$5=J$5.Object,At$5=zt$5?function(t){return "symbol"==typeof t}:function(t){var e=kt$5("Symbol");return wt$5(e)&&Et$5(e.prototype,jt$5(t))},Pt$5=J$5.String,Vt$5=function(t){try{return Pt$5(t)}catch(t){return "Object"}},Ct$5=J$5.TypeError,Dt$5=function(t){if(wt$5(t))return t;throw Ct$5(Vt$5(t)+" is not a function")},Bt$5=function(t,e){var n=t[e];return null==n?void 0:Dt$5(n)},Rt$5=J$5.TypeError,Ft$5=Object.defineProperty,_t$5=function(t,e){try{Ft$5(J$5,t,{value:e,configurable:!0,writable:!0});}catch(n){J$5[t]=e;}return e},$t$5=J$5["__core-js_shared__"]||_t$5("__core-js_shared__",{}),qt$5=G$5((function(t){(t.exports=function(t,e){return $t$5[t]||($t$5[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.19.3",mode:"global",copyright:"© 2021 Denis Pushkarev (zloirock.ru)"});})),Wt$5=J$5.Object,Gt$5=function(t){return Wt$5(mt$5(t))},Ut$5=st$5({}.hasOwnProperty),Xt$5=Object.hasOwn||function(t,e){return Ut$5(Gt$5(t),e)},Yt$5=0,Jt$5=Math.random(),Kt$5=st$5(1..toString),Qt$5=function(t){return "Symbol("+(void 0===t?"":t)+")_"+Kt$5(++Yt$5+Jt$5,36)},Zt$5=qt$5("wks"),te$5=J$5.Symbol,ee$5=te$5&&te$5.for,ne$5=zt$5?te$5:te$5&&te$5.withoutSetter||Qt$5,re$5=function(t){if(!Xt$5(Zt$5,t)||!Lt$5&&"string"!=typeof Zt$5[t]){var e="Symbol."+t;Lt$5&&Xt$5(te$5,t)?Zt$5[t]=te$5[t]:Zt$5[t]=zt$5&&ee$5?ee$5(e):ne$5(e);}return Zt$5[t]},oe$5=J$5.TypeError,ie$5=re$5("toPrimitive"),ue$5=function(t,e){if(!xt$5(t)||At$5(t))return t;var n,r=Bt$5(t,ie$5);if(r){if(void 0===e&&(e="default"),n=tt$5(r,t,e),!xt$5(n)||At$5(n))return n;throw oe$5("Can't convert object to primitive value")}return void 0===e&&(e="number"),function(t,e){var n,r;if("string"===e&&wt$5(n=t.toString)&&!xt$5(r=tt$5(n,t)))return r;if(wt$5(n=t.valueOf)&&!xt$5(r=tt$5(n,t)))return r;if("string"!==e&&wt$5(n=t.toString)&&!xt$5(r=tt$5(n,t)))return r;throw Rt$5("Can't convert object to primitive value")}(t,e)},ae$5=function(t){var e=ue$5(t,"string");return At$5(e)?e:e+""},ce$5=J$5.document,le$5=xt$5(ce$5)&&xt$5(ce$5.createElement),se$5=function(t){return le$5?ce$5.createElement(t):{}},fe$5=!Q$5&&!K$5((function(){return 7!=Object.defineProperty(se$5("div"),"a",{get:function(){return 7}}).a})),pe$5=Object.getOwnPropertyDescriptor,de$5={f:Q$5?pe$5:function(t,e){if(t=bt$5(t),e=ae$5(e),fe$5)try{return pe$5(t,e)}catch(t){}if(Xt$5(t,e))return it$5(!tt$5(ot$5.f,t,e),t[e])}},he$5=J$5.String,ve$5=J$5.TypeError,ge$5=function(t){if(xt$5(t))return t;throw ve$5(he$5(t)+" is not an object")},ye$5=J$5.TypeError,me$5=Object.defineProperty,be$5={f:Q$5?me$5:function(t,e,n){if(ge$5(t),e=ae$5(e),ge$5(n),fe$5)try{return me$5(t,e,n)}catch(t){}if("get"in n||"set"in n)throw ye$5("Accessors not supported");return "value"in n&&(t[e]=n.value),t}},we$5=Q$5?function(t,e,n){return be$5.f(t,e,it$5(1,n))}:function(t,e,n){return t[e]=n,t},xe$5=st$5(Function.toString);wt$5($t$5.inspectSource)||($t$5.inspectSource=function(t){return xe$5(t)});var Se$5,ke$5,Ee$5,Te$5=$t$5.inspectSource,Me$5=J$5.WeakMap,He$5=wt$5(Me$5)&&/native code/.test(Te$5(Me$5)),Oe$5=qt$5("keys"),Ie$5=function(t){return Oe$5[t]||(Oe$5[t]=Qt$5(t))},Ne$5={},Le$5=J$5.TypeError,ze$5=J$5.WeakMap;if(He$5||$t$5.state){var je$5=$t$5.state||($t$5.state=new ze$5),Ae$5=st$5(je$5.get),Pe$5=st$5(je$5.has),Ve$5=st$5(je$5.set);Se$5=function(t,e){if(Pe$5(je$5,t))throw new Le$5("Object already initialized");return e.facade=t,Ve$5(je$5,t,e),e},ke$5=function(t){return Ae$5(je$5,t)||{}},Ee$5=function(t){return Pe$5(je$5,t)};}else {var Ce$5=Ie$5("state");Ne$5[Ce$5]=!0,Se$5=function(t,e){if(Xt$5(t,Ce$5))throw new Le$5("Object already initialized");return e.facade=t,we$5(t,Ce$5,e),e},ke$5=function(t){return Xt$5(t,Ce$5)?t[Ce$5]:{}},Ee$5=function(t){return Xt$5(t,Ce$5)};}var De$5={set:Se$5,get:ke$5,has:Ee$5,enforce:function(t){return Ee$5(t)?ke$5(t):Se$5(t,{})},getterFor:function(t){return function(e){var n;if(!xt$5(e)||(n=ke$5(e)).type!==t)throw Le$5("Incompatible receiver, "+t+" required");return n}}},Be$5=Function.prototype,Re$5=Q$5&&Object.getOwnPropertyDescriptor,Fe$5=Xt$5(Be$5,"name"),_e$5={EXISTS:Fe$5,PROPER:Fe$5&&"something"===function(){}.name,CONFIGURABLE:Fe$5&&(!Q$5||Q$5&&Re$5(Be$5,"name").configurable)},$e$5=G$5((function(t){var e=_e$5.CONFIGURABLE,n=De$5.get,r=De$5.enforce,o=String(String).split("String");(t.exports=function(t,n,i,u){var a,c=!!u&&!!u.unsafe,l=!!u&&!!u.enumerable,s=!!u&&!!u.noTargetGet,f=u&&void 0!==u.name?u.name:n;wt$5(i)&&("Symbol("===String(f).slice(0,7)&&(f="["+String(f).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!Xt$5(i,"name")||e&&i.name!==f)&&we$5(i,"name",f),(a=r(i)).source||(a.source=o.join("string"==typeof f?f:""))),t!==J$5?(c?!s&&t[n]&&(l=!0):delete t[n],l?t[n]=i:we$5(t,n,i)):l?t[n]=i:_t$5(n,i);})(Function.prototype,"toString",(function(){return wt$5(this)&&n(this).source||Te$5(this)}));})),qe$5=Math.ceil,We$5=Math.floor,Ge$5=function(t){var e=+t;return e!=e||0===e?0:(e>0?We$5:qe$5)(e)},Ue$5=Math.max,Xe$5=Math.min,Ye$5=function(t,e){var n=Ge$5(t);return n<0?Ue$5(n+e,0):Xe$5(n,e)},Je$5=Math.min,Ke$5=function(t){return t>0?Je$5(Ge$5(t),9007199254740991):0},Qe$5=function(t){return Ke$5(t.length)},Ze$5=function(t){return function(e,n,r){var o,i=bt$5(e),u=Qe$5(i),a=Ye$5(r,u);if(t&&n!=n){for(;u>a;)if((o=i[a++])!=o)return !0}else for(;u>a;a++)if((t||a in i)&&i[a]===n)return t||a||0;return !t&&-1}},tn$5={includes:Ze$5(!0),indexOf:Ze$5(!1)},en$5=tn$5.indexOf,nn$5=st$5([].push),rn$5=function(t,e){var n,r=bt$5(t),o=0,i=[];for(n in r)!Xt$5(Ne$5,n)&&Xt$5(r,n)&&nn$5(i,n);for(;e.length>o;)Xt$5(r,n=e[o++])&&(~en$5(i,n)||nn$5(i,n));return i},on$5=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],un$5=on$5.concat("length","prototype"),an$5={f:Object.getOwnPropertyNames||function(t){return rn$5(t,un$5)}},cn$5={f:Object.getOwnPropertySymbols},ln$5=st$5([].concat),sn$5=kt$5("Reflect","ownKeys")||function(t){var e=an$5.f(ge$5(t)),n=cn$5.f;return n?ln$5(e,n(t)):e},fn$5=function(t,e){for(var n=sn$5(e),r=be$5.f,o=de$5.f,i=0;i<n.length;i++){var u=n[i];Xt$5(t,u)||r(t,u,o(e,u));}},pn$5=/#|\.prototype\./,dn$5=function(t,e){var n=vn$5[hn$5(t)];return n==yn$5||n!=gn$5&&(wt$5(e)?K$5(e):!!e)},hn$5=dn$5.normalize=function(t){return String(t).replace(pn$5,".").toLowerCase()},vn$5=dn$5.data={},gn$5=dn$5.NATIVE="N",yn$5=dn$5.POLYFILL="P",mn$5=dn$5,bn$5=de$5.f,wn$5=function(t,e){var n,r,o,i,u,a=t.target,c=t.global,l=t.stat;if(n=c?J$5:l?J$5[a]||_t$5(a,{}):(J$5[a]||{}).prototype)for(r in e){if(i=e[r],o=t.noTargetGet?(u=bn$5(n,r))&&u.value:n[r],!mn$5(c?r:a+(l?".":"#")+r,t.forced)&&void 0!==o){if(typeof i==typeof o)continue;fn$5(i,o);}(t.sham||o&&o.sham)&&we$5(i,"sham",!0),$e$5(n,r,i,t);}},xn$5=st$5(st$5.bind),Sn$5=Array.isArray||function(t){return "Array"==dt$5(t)},kn$5={};kn$5[re$5("toStringTag")]="z";var En$5="[object z]"===String(kn$5),Tn$5=re$5("toStringTag"),Mn$5=J$5.Object,Hn$5="Arguments"==dt$5(function(){return arguments}()),On$5=En$5?dt$5:function(t){var e,n,r;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Mn$5(t),Tn$5))?n:Hn$5?dt$5(e):"Object"==(r=dt$5(e))&&wt$5(e.callee)?"Arguments":r},In$5=function(){},Nn$5=[],Ln$5=kt$5("Reflect","construct"),zn$5=/^\s*(?:class|function)\b/,jn$5=st$5(zn$5.exec),An$5=!zn$5.exec(In$5),Pn$5=function(t){if(!wt$5(t))return !1;try{return Ln$5(In$5,Nn$5,t),!0}catch(t){return !1}},Vn$5=!Ln$5||K$5((function(){var t;return Pn$5(Pn$5.call)||!Pn$5(Object)||!Pn$5((function(){t=!0;}))||t}))?function(t){if(!wt$5(t))return !1;switch(On$5(t)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return !1}return An$5||!!jn$5(zn$5,Te$5(t))}:Pn$5,Cn$5=re$5("species"),Dn$5=J$5.Array,Bn$5=function(t,e){return new(function(t){var e;return Sn$5(t)&&(e=t.constructor,(Vn$5(e)&&(e===Dn$5||Sn$5(e.prototype))||xt$5(e)&&null===(e=e[Cn$5]))&&(e=void 0)),void 0===e?Dn$5:e}(t))(0===e?0:e)},Rn$5=st$5([].push),Fn$5=function(t){var e=1==t,n=2==t,r=3==t,o=4==t,i=6==t,u=7==t,a=5==t||i;return function(c,l,s,f){for(var p,d,h=Gt$5(c),v=gt$5(h),g=function(t,e){return Dt$5(t),void 0===e?t:xn$5?xn$5(t,e):function(){return t.apply(e,arguments)}}(l,s),y=Qe$5(v),m=0,b=f||Bn$5,w=e?b(c,y):n||u?b(c,0):void 0;y>m;m++)if((a||m in v)&&(d=g(p=v[m],m,h),t))if(e)w[m]=d;else if(d)switch(t){case 3:return !0;case 5:return p;case 6:return m;case 2:Rn$5(w,p);}else switch(t){case 4:return !1;case 7:Rn$5(w,p);}return i?-1:r||o?o:w}},_n$5={forEach:Fn$5(0),map:Fn$5(1),filter:Fn$5(2),some:Fn$5(3),every:Fn$5(4),find:Fn$5(5),findIndex:Fn$5(6),filterReject:Fn$5(7)},$n$5=re$5("species"),qn$5=function(t){return Nt$5>=51||!K$5((function(){var e=[];return (e.constructor={})[$n$5]=function(){return {foo:1}},1!==e[t](Boolean).foo}))},Wn$5=_n$5.filter;wn$5({target:"Array",proto:!0,forced:!qn$5("filter")},{filter:function(t){return Wn$5(this,t,arguments.length>1?arguments[1]:void 0)}});var Gn$5=En$5?{}.toString:function(){return "[object "+On$5(this)+"]"};En$5||$e$5(Object.prototype,"toString",Gn$5,{unsafe:!0});var Un$5,Xn$5=J$5.String,Yn$5=function(t){if("Symbol"===On$5(t))throw TypeError("Cannot convert a Symbol value to a string");return Xn$5(t)},Jn$5=function(){var t=ge$5(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.dotAll&&(e+="s"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e},Kn$5=J$5.RegExp,Qn$5=K$5((function(){var t=Kn$5("a","y");return t.lastIndex=2,null!=t.exec("abcd")})),Zn$5=Qn$5||K$5((function(){return !Kn$5("a","y").sticky})),tr$4={BROKEN_CARET:Qn$5||K$5((function(){var t=Kn$5("^r","gy");return t.lastIndex=2,null!=t.exec("str")})),MISSED_STICKY:Zn$5,UNSUPPORTED_Y:Qn$5},er$4=Object.keys||function(t){return rn$5(t,on$5)},nr$4=Q$5?Object.defineProperties:function(t,e){ge$5(t);for(var n,r=bt$5(e),o=er$4(e),i=o.length,u=0;i>u;)be$5.f(t,n=o[u++],r[n]);return t},rr$4=kt$5("document","documentElement"),or$4=Ie$5("IE_PROTO"),ir$4=function(){},ur$4=function(t){return "<script>"+t+"<\/script>"},ar$4=function(t){t.write(ur$4("")),t.close();var e=t.parentWindow.Object;return t=null,e},cr$4=function(){try{Un$5=new ActiveXObject("htmlfile");}catch(t){}var t,e;cr$4="undefined"!=typeof document?document.domain&&Un$5?ar$4(Un$5):((e=se$5("iframe")).style.display="none",rr$4.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write(ur$4("document.F=Object")),t.close(),t.F):ar$4(Un$5);for(var n=on$5.length;n--;)delete cr$4.prototype[on$5[n]];return cr$4()};Ne$5[or$4]=!0;var lr$4,sr$4,fr$4=Object.create||function(t,e){var n;return null!==t?(ir$4.prototype=ge$5(t),n=new ir$4,ir$4.prototype=null,n[or$4]=t):n=cr$4(),void 0===e?n:nr$4(n,e)},pr$4=J$5.RegExp,dr$4=K$5((function(){var t=pr$4(".","s");return !(t.dotAll&&t.exec("\n")&&"s"===t.flags)})),hr$4=J$5.RegExp,vr$4=K$5((function(){var t=hr$4("(?<a>b)","g");return "b"!==t.exec("b").groups.a||"bc"!=="b".replace(t,"$<a>c")})),gr$4=De$5.get,yr$4=qt$5("native-string-replace",String.prototype.replace),mr$4=RegExp.prototype.exec,br$4=mr$4,wr$4=st$5("".charAt),xr$4=st$5("".indexOf),Sr$4=st$5("".replace),kr$4=st$5("".slice),Er$4=(sr$4=/b*/g,tt$5(mr$4,lr$4=/a/,"a"),tt$5(mr$4,sr$4,"a"),0!==lr$4.lastIndex||0!==sr$4.lastIndex),Tr$4=tr$4.BROKEN_CARET,Mr$4=void 0!==/()??/.exec("")[1];(Er$4||Mr$4||Tr$4||dr$4||vr$4)&&(br$4=function(t){var e,n,r,o,i,u,a,c=this,l=gr$4(c),s=Yn$5(t),f=l.raw;if(f)return f.lastIndex=c.lastIndex,e=tt$5(br$4,f,s),c.lastIndex=f.lastIndex,e;var p=l.groups,d=Tr$4&&c.sticky,h=tt$5(Jn$5,c),v=c.source,g=0,y=s;if(d&&(h=Sr$4(h,"y",""),-1===xr$4(h,"g")&&(h+="g"),y=kr$4(s,c.lastIndex),c.lastIndex>0&&(!c.multiline||c.multiline&&"\n"!==wr$4(s,c.lastIndex-1))&&(v="(?: "+v+")",y=" "+y,g++),n=new RegExp("^(?:"+v+")",h)),Mr$4&&(n=new RegExp("^"+v+"$(?!\\s)",h)),Er$4&&(r=c.lastIndex),o=tt$5(mr$4,d?n:c,y),d?o?(o.input=kr$4(o.input,g),o[0]=kr$4(o[0],g),o.index=c.lastIndex,c.lastIndex+=o[0].length):c.lastIndex=0:Er$4&&o&&(c.lastIndex=c.global?o.index+o[0].length:r),Mr$4&&o&&o.length>1&&tt$5(yr$4,o[0],n,(function(){for(i=1;i<arguments.length-2;i++)void 0===arguments[i]&&(o[i]=void 0);})),o&&p)for(o.groups=u=fr$4(null),i=0;i<p.length;i++)u[(a=p[i])[0]]=o[a[1]];return o});var Hr$4=br$4;wn$5({target:"RegExp",proto:!0,forced:/./.exec!==Hr$4},{exec:Hr$4});var Or$4=Function.prototype,Ir$4=Or$4.apply,Nr$4=Or$4.bind,Lr$4=Or$4.call,zr$4="object"==typeof Reflect&&Reflect.apply||(Nr$4?Lr$4.bind(Ir$4):function(){return Lr$4.apply(Ir$4,arguments)}),jr$4=re$5("species"),Ar$4=RegExp.prototype,Pr$4=function(t,e,n,r){var o=re$5(t),i=!K$5((function(){var e={};return e[o]=function(){return 7},7!=""[t](e)})),u=i&&!K$5((function(){var e=!1,n=/a/;return "split"===t&&((n={}).constructor={},n.constructor[jr$4]=function(){return n},n.flags="",n[o]=/./[o]),n.exec=function(){return e=!0,null},n[o](""),!e}));if(!i||!u||n){var a=st$5(/./[o]),c=e(o,""[t],(function(t,e,n,r,o){var u=st$5(t),c=e.exec;return c===Hr$4||c===Ar$4.exec?i&&!o?{done:!0,value:a(e,n,r)}:{done:!0,value:u(n,e,r)}:{done:!1}}));$e$5(String.prototype,t,c[0]),$e$5(Ar$4,o,c[1]);}r&&we$5(Ar$4[o],"sham",!0);},Vr$4=st$5("".charAt),Cr$4=st$5("".charCodeAt),Dr$4=st$5("".slice),Br$4=function(t){return function(e,n){var r,o,i=Yn$5(mt$5(e)),u=Ge$5(n),a=i.length;return u<0||u>=a?t?"":void 0:(r=Cr$4(i,u))<55296||r>56319||u+1===a||(o=Cr$4(i,u+1))<56320||o>57343?t?Vr$4(i,u):r:t?Dr$4(i,u,u+2):o-56320+(r-55296<<10)+65536}},Rr$4={codeAt:Br$4(!1),charAt:Br$4(!0)}.charAt,Fr$4=function(t,e,n){return e+(n?Rr$4(t,e).length:1)},_r$4=Math.floor,$r$4=st$5("".charAt),qr$4=st$5("".replace),Wr$4=st$5("".slice),Gr$4=/\$([$&'`]|\d{1,2}|<[^>]*>)/g,Ur$4=/\$([$&'`]|\d{1,2})/g,Xr$4=function(t,e,n,r,o,i){var u=n+t.length,a=r.length,c=Ur$4;return void 0!==o&&(o=Gt$5(o),c=Gr$4),qr$4(i,c,(function(i,c){var l;switch($r$4(c,0)){case"$":return "$";case"&":return t;case"`":return Wr$4(e,0,n);case"'":return Wr$4(e,u);case"<":l=o[Wr$4(c,1,-1)];break;default:var s=+c;if(0===s)return i;if(s>a){var f=_r$4(s/10);return 0===f?i:f<=a?void 0===r[f-1]?$r$4(c,1):r[f-1]+$r$4(c,1):i}l=r[s-1];}return void 0===l?"":l}))},Yr$4=J$5.TypeError,Jr$4=function(t,e){var n=t.exec;if(wt$5(n)){var r=tt$5(n,t,e);return null!==r&&ge$5(r),r}if("RegExp"===dt$5(t))return tt$5(Hr$4,t,e);throw Yr$4("RegExp#exec called on incompatible receiver")},Kr$4=re$5("replace"),Qr$4=Math.max,Zr$4=Math.min,to$4=st$5([].concat),eo$4=st$5([].push),no$4=st$5("".indexOf),ro$4=st$5("".slice),oo$4="$0"==="a".replace(/./,"$0"),io$4=!!/./[Kr$4]&&""===/./[Kr$4]("a","$0");Pr$4("replace",(function(t,e,n){var r=io$4?"$":"$0";return [function(t,n){var r=mt$5(this),o=null==t?void 0:Bt$5(t,Kr$4);return o?tt$5(o,t,r,n):tt$5(e,Yn$5(r),t,n)},function(t,o){var i=ge$5(this),u=Yn$5(t);if("string"==typeof o&&-1===no$4(o,r)&&-1===no$4(o,"$<")){var a=n(e,i,u,o);if(a.done)return a.value}var c=wt$5(o);c||(o=Yn$5(o));var l=i.global;if(l){var s=i.unicode;i.lastIndex=0;}for(var f=[];;){var p=Jr$4(i,u);if(null===p)break;if(eo$4(f,p),!l)break;""===Yn$5(p[0])&&(i.lastIndex=Fr$4(u,Ke$5(i.lastIndex),s));}for(var d,h="",v=0,g=0;g<f.length;g++){for(var y=Yn$5((p=f[g])[0]),m=Qr$4(Zr$4(Ge$5(p.index),u.length),0),b=[],w=1;w<p.length;w++)eo$4(b,void 0===(d=p[w])?d:String(d));var x=p.groups;if(c){var S=to$4([y],b,m,u);void 0!==x&&eo$4(S,x);var k=Yn$5(zr$4(o,void 0,S));}else k=Xr$4(y,u,m,b,x,o);m>=v&&(h+=ro$4(u,v,m)+k,v=m+y.length);}return h+ro$4(u,v)}]}),!!K$5((function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")}))||!oo$4||io$4);var uo$4=re$5("unscopables"),ao$4=Array.prototype;null==ao$4[uo$4]&&be$5.f(ao$4,uo$4,{configurable:!0,value:fr$4(null)});var co$4=function(t){ao$4[uo$4][t]=!0;},lo$4=_n$5.find,so$4=!0;"find"in[]&&Array(1).find((function(){so$4=!1;})),wn$5({target:"Array",proto:!0,forced:so$4},{find:function(t){return lo$4(this,t,arguments.length>1?arguments[1]:void 0)}}),co$4("find");var fo$4=re$5("match"),po$4=function(t){var e;return xt$5(t)&&(void 0!==(e=t[fo$4])?!!e:"RegExp"==dt$5(t))},ho$4=J$5.TypeError,vo$4=re$5("species"),go$4=function(t,e){var n,r=ge$5(t).constructor;return void 0===r||null==(n=ge$5(r)[vo$4])?e:function(t){if(Vn$5(t))return t;throw ho$4(Vt$5(t)+" is not a constructor")}(n)},yo$4=function(t,e,n){var r=ae$5(e);r in t?be$5.f(t,r,it$5(0,n)):t[r]=n;},mo$4=J$5.Array,bo$4=Math.max,wo$4=function(t,e,n){for(var r=Qe$5(t),o=Ye$5(e,r),i=Ye$5(void 0===n?r:n,r),u=mo$4(bo$4(i-o,0)),a=0;o<i;o++,a++)yo$4(u,a,t[o]);return u.length=a,u},xo$4=tr$4.UNSUPPORTED_Y,So$4=Math.min,ko$4=[].push,Eo$4=st$5(/./.exec),To$4=st$5(ko$4),Mo$4=st$5("".slice);Pr$4("split",(function(t,e,n){var r;return r="c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1).length||2!="ab".split(/(?:ab)*/).length||4!=".".split(/(.?)(.?)/).length||".".split(/()()/).length>1||"".split(/.?/).length?function(t,n){var r=Yn$5(mt$5(this)),o=void 0===n?4294967295:n>>>0;if(0===o)return [];if(void 0===t)return [r];if(!po$4(t))return tt$5(e,r,t,o);for(var i,u,a,c=[],l=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.unicode?"u":"")+(t.sticky?"y":""),s=0,f=new RegExp(t.source,l+"g");(i=tt$5(Hr$4,f,r))&&!((u=f.lastIndex)>s&&(To$4(c,Mo$4(r,s,i.index)),i.length>1&&i.index<r.length&&zr$4(ko$4,c,wo$4(i,1)),a=i[0].length,s=u,c.length>=o));)f.lastIndex===i.index&&f.lastIndex++;return s===r.length?!a&&Eo$4(f,"")||To$4(c,""):To$4(c,Mo$4(r,s)),c.length>o?wo$4(c,0,o):c}:"0".split(void 0,0).length?function(t,n){return void 0===t&&0===n?[]:tt$5(e,this,t,n)}:e,[function(e,n){var o=mt$5(this),i=null==e?void 0:Bt$5(e,t);return i?tt$5(i,e,o,n):tt$5(r,Yn$5(o),e,n)},function(t,o){var i=ge$5(this),u=Yn$5(t),a=n(r,i,u,o,r!==e);if(a.done)return a.value;var c=go$4(i,RegExp),l=i.unicode,s=(i.ignoreCase?"i":"")+(i.multiline?"m":"")+(i.unicode?"u":"")+(xo$4?"g":"y"),f=new c(xo$4?"^(?:"+i.source+")":i,s),p=void 0===o?4294967295:o>>>0;if(0===p)return [];if(0===u.length)return null===Jr$4(f,u)?[u]:[];for(var d=0,h=0,v=[];h<u.length;){f.lastIndex=xo$4?0:h;var g,y=Jr$4(f,xo$4?Mo$4(u,h):u);if(null===y||(g=So$4(Ke$5(f.lastIndex+(xo$4?h:0)),u.length))===d)h=Fr$4(u,h,l);else {if(To$4(v,Mo$4(u,d,h)),v.length===p)return v;for(var m=1;m<=y.length-1;m++)if(To$4(v,y[m]),v.length===p)return v;h=d=g;}}return To$4(v,Mo$4(u,d)),v}]}),!!K$5((function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var n="ab".split(t);return 2!==n.length||"a"!==n[0]||"b"!==n[1]})),xo$4);var Ho$4,Oo$4="\t\n\v\f\r                　\u2028\u2029\ufeff",Io$4=st$5("".replace),No$4="["+Oo$4+"]",Lo$4=RegExp("^"+No$4+No$4+"*"),zo$4=RegExp(No$4+No$4+"*$"),jo$4=function(t){return function(e){var n=Yn$5(mt$5(e));return 1&t&&(n=Io$4(n,Lo$4,"")),2&t&&(n=Io$4(n,zo$4,"")),n}},Ao$4={start:jo$4(1),end:jo$4(2),trim:jo$4(3)},Po$4=_e$5.PROPER,Vo$4=Ao$4.trim;function Co$4(t){return 0===$$6("<div>"+t+"</div>").children().filter((function(t){return "BR"!==t.tagName})).length}function Do$4(t){return 0===t.length?"":t[0].outerHTML}function Bo$4(t){return t.length?t[0].tagName.toLowerCase():""}function Ro$4(t,e){for(var n="",r=(t.attr("style")||"").split(";"),o=r.length,i=0;i<o;i++){var u=r[i];if(u){var a=u.split(":");a[0].trim()===e&&(n=a[1].trim());}}return n}wn$5({target:"String",proto:!0,forced:(Ho$4="trim",K$5((function(){return !!Oo$4[Ho$4]()||"​᠎"!=="​᠎"[Ho$4]()||Po$4&&Oo$4[Ho$4].name!==Ho$4})))},{trim:function(){return Vo$4(this)}}),wn$5({global:!0},{globalThis:J$5}),css&&($$6.fn.css=css),append&&($$6.fn.append=append),prepend&&($$6.fn.prepend=prepend),addClass&&($$6.fn.addClass=addClass),removeClass&&($$6.fn.removeClass=removeClass),hasClass&&($$6.fn.hasClass=hasClass),on$7&&($$6.fn.on=on$7),off&&($$6.fn.off=off),focus&&($$6.fn.focus=focus),attr&&($$6.fn.attr=attr),removeAttr&&($$6.fn.removeAttr=removeAttr),hide&&($$6.fn.hide=hide),show&&($$6.fn.show=show),parents&&($$6.fn.parents=parents),dataset&&($$6.fn.dataset=dataset),val&&($$6.fn.val=val),text&&($$6.fn.text=text),html&&($$6.fn.html=html),children&&($$6.fn.children=children),remove&&($$6.fn.remove=remove),find&&($$6.fn.find=find),width&&($$6.fn.width=width),height&&($$6.fn.height=height),filter&&($$6.fn.filter=filter),empty&&($$6.fn.empty=empty);var Fo$4={selector:"p:not([data-w-e-type])",parseElemHtml:function(t,e,n){var r=$$6(t);return 0===(e=e.filter((function(t){return !!Text.isText(t)||!!n.isInline(t)}))).length&&(e=[{text:r.text().replace(/\s+/gm," ")}]),{type:"paragraph",children:e}}},_o$4=function(t,e){return _o$4=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e;}||function(t,e){for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);},_o$4(t,e)};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */function $o$4(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Class extends value "+String(e)+" is not a constructor or null");function n(){this.constructor=t;}_o$4(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n);}var qo$4=function(){return qo$4=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t},qo$4.apply(this,arguments)};function Wo$4(t,e,n,r){return new(n||(n=Promise))((function(o,i){function u(t){try{c(r.next(t));}catch(t){i(t);}}function a(t){try{c(r.throw(t));}catch(t){i(t);}}function c(t){var e;t.done?o(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e);}))).then(u,a);}c((r=r.apply(t,e||[])).next());}))}function Go$4(t,e){var n,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;u;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=u.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=e.call(t,u);}catch(t){i=[6,t],r=0;}finally{n=o=0;}if(5&i[0])throw i[1];return {value:i[0]?i[1]:void 0,done:!0}}([i,a])}}}function Uo$4(t){var e="function"==typeof Symbol&&Symbol.iterator,n=e&&t[e],r=0;if(n)return n.call(t);if(t&&"number"==typeof t.length)return {next:function(){return t&&r>=t.length&&(t=void 0),{value:t&&t[r++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")}function Xo$4(t,e){var n="function"==typeof Symbol&&t[Symbol.iterator];if(!n)return t;var r,o,i=n.call(t),u=[];try{for(;(void 0===e||e-- >0)&&!(r=i.next()).done;)u.push(r.value);}catch(t){o={error:t};}finally{try{r&&!r.done&&(n=i.return)&&n.call(i);}finally{if(o)throw o.error}}return u}function Yo$4(t){var e=Xo$4(Editor.nodes(t,{match:function(e){return t.children[0]===e},mode:"highest"}),1),n=e[0];if(null==n)return !1;var r=n[0];if(!Element$1.isElement(r))return !1;if("paragraph"===r.type)return !1;if(""!==Node$1.string(r))return !1;var o=r.children,i=void 0===o?[]:o;return !!Text.isText(i[0])&&(Transforms.setNodes(t,{type:"paragraph"}),!0)}var Jo$4={renderElems:[_$5],elemsToHtml:[$$5],parseElemsHtml:[Fo$4],editorPlugin:function(t){var e=t.deleteBackward,n=t.deleteForward;t.insertText,t.insertBreak;var r=t;return r.deleteBackward=function(t){Yo$4(r)||e(t);},r.deleteForward=function(t){Yo$4(r)||n(t);},r}},Ko$4=/"/g,Qo$4=st$5("".replace),Zo$4=function(t,e,n,r){var o=Yn$5(mt$5(t)),i="<"+e;return ""!==n&&(i+=" "+n+'="'+Qo$4(Yn$5(r),Ko$4,"&quot;")+'"'),i+">"+o+"</"+e+">"},ti$4=function(t){return K$5((function(){var e=""[t]('"');return e!==e.toLowerCase()||e.split('"').length>3}))};function ei$4(t,e){var n=e,r=t,o=r.bold,i=r.italic,u=r.underline;return o&&(n="<strong>"+n+"</strong>"),r.code&&(n="<code>"+n+"</code>"),i&&(n="<em>"+n+"</em>"),u&&(n="<u>"+n+"</u>"),r.through&&(n="<s>"+n+"</s>"),r.sub&&(n="<sub>"+n+"</sub>"),r.sup&&(n="<sup>"+n+"</sup>"),n}function ni$4(t,e){return 0!==t.length&&(!!t[0].matches(e)||t.find(e).length>0)}wn$5({target:"String",proto:!0,forced:ti$4("bold")},{bold:function(){return Zo$4(this,"b","","")}}),wn$5({target:"String",proto:!0,forced:ti$4("italics")},{italics:function(){return Zo$4(this,"i","","")}}),wn$5({target:"String",proto:!0,forced:ti$4("sub")},{sub:function(){return Zo$4(this,"sub","","")}}),wn$5({target:"String",proto:!0,forced:ti$4("sup")},{sup:function(){return Zo$4(this,"sup","","")}});var ri$4={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},oi$4=se$5("span").classList,ii$4=oi$4&&oi$4.constructor&&oi$4.constructor.prototype,ui$4=ii$4===Object.prototype?void 0:ii$4,ai$4=function(t,e){var n=[][t];return !!n&&K$5((function(){n.call(null,e||function(){throw 1},1);}))},ci$4=_n$5.forEach,li$4=ai$4("forEach")?[].forEach:function(t){return ci$4(this,t,arguments.length>1?arguments[1]:void 0)},si$4=function(t){if(t&&t.forEach!==li$4)try{we$5(t,"forEach",li$4);}catch(e){t.forEach=li$4;}};for(var fi$4 in ri$4)ri$4[fi$4]&&si$4(J$5[fi$4]&&J$5[fi$4].prototype);function pi$4(t,n){return null==t.selection||!!Xo$4(Editor.nodes(t,{match:function(n){return "pre"===ol$1.getNodeType(n)||!!Editor.isVoid(t,n)},universal:!0}),1)[0]}function di$4(t,e){Object.keys(e).forEach((function(e){"text"!==e&&Editor.removeMark(t,e);}));}si$4(ui$4),wn$5({target:"Object",stat:!0,forced:K$5((function(){er$4(1);}))},{keys:function(t){return er$4(Gt$5(t))}});var hi$4=function(){function t(){this.marksNeedToRemove=[],this.tag="button";}return t.prototype.getValue=function(t){var e=this.mark,n=Editor.marks(t);return n?n[e]:!!Xo$4(Editor.nodes(t,{match:function(t){return !0===t[e]}}),1)[0]},t.prototype.isActive=function(t){return !!this.getValue(t)},t.prototype.isDisabled=function(t){return pi$4(t,this.mark)},t.prototype.exec=function(t,e){var n=this.mark,r=this.marksNeedToRemove;e?t.removeMark(n):(t.addMark(n,!0),r&&r.forEach((function(e){return t.removeMark(e)})));},t}(),vi$4='<svg viewBox="0 0 1024 1024"><path d="M707.872 484.64A254.88 254.88 0 0 0 768 320c0-141.152-114.848-256-256-256H192v896h384c141.152 0 256-114.848 256-256a256.096 256.096 0 0 0-124.128-219.36zM384 192h101.504c55.968 0 101.504 57.408 101.504 128s-45.536 128-101.504 128H384V192z m159.008 640H384v-256h159.008c58.464 0 106.016 57.408 106.016 128s-47.552 128-106.016 128z"></path></svg>',gi$4='<svg viewBox="0 0 1024 1024"><path d="M704 64l128 0 0 416c0 159.072-143.264 288-320 288s-320-128.928-320-288l0-416 128 0 0 416c0 40.16 18.24 78.688 51.36 108.512 36.896 33.216 86.848 51.488 140.64 51.488s103.744-18.304 140.64-51.488c33.12-29.792 51.36-68.352 51.36-108.512l0-416zM192 832l640 0 0 128-640 0z"></path></svg>',yi$4='<svg viewBox="0 0 1024 1024"><path d="M896 64v64h-128L448 896h128v64H128v-64h128L576 128h-128V64z"></path></svg>',mi$3='<svg viewBox="0 0 1024 1024"><path d="M1024 512v64h-234.496c27.52 38.496 42.496 82.688 42.496 128 0 70.88-36.672 139.04-100.576 186.976C672.064 935.488 594.144 960 512 960s-160.064-24.512-219.424-69.024C228.64 843.04 192 774.88 192 704h128c0 69.376 87.936 128 192 128s192-58.624 192-128-87.936-128-192-128H0v-64h299.52a385.984 385.984 0 0 1-6.944-5.024C228.64 459.04 192 390.88 192 320s36.672-139.04 100.576-186.976C351.936 88.512 429.856 64 512 64s160.064 24.512 219.424 69.024C795.328 180.96 832 249.12 832 320h-128c0-69.376-87.936-128-192-128s-192 58.624-192 128 87.936 128 192 128c78.976 0 154.048 22.688 212.48 64H1024z"></path></svg>',bi$3='<svg viewBox="0 0 1024 1024"><path d="M576 736l96 96 320-320L672 192l-96 96 224 224zM448 288l-96-96L32 512l320 320 96-96-224-224z"></path></svg>',wi$3='<svg viewBox="0 0 1024 1024"><path d="M864 0a160 160 0 0 1 128 256l-64 64-224-224 64-64c26.752-20.096 59.968-32 96-32zM64 736l-64 288 288-64 592-592-224-224L64 736z m651.584-372.416l-448 448-55.168-55.168 448-448 55.168 55.168z"></path></svg>',xi$3='<svg viewBox="0 0 1024 1024"><path d="M924.402464 1023.068211H0.679665V99.345412h461.861399v98.909208H99.596867v725.896389h725.896389V561.206811h98.909208z" p-id="10909"></path><path d="M930.805104 22.977336l69.965436 69.965436-453.492405 453.492404-69.965435-69.901489z" p-id="10910"></path><path d="M1022.464381 304.030081h-98.917201V99.345412H709.230573V0.428211h313.233808z"></path></svg>',Si$3='<svg viewBox="0 0 1024 1024"><path d="M64 864h896v96H64zM360.58 576h302.85l81.53 224h102.16L579.24 64H444.77L176.89 800h102.16l81.53-224zM512 159.96L628.49 480H395.52L512 159.96z"></path></svg>',ki$3='<svg viewBox="0 0 1024 1024"><path d="M510.030769 315.076923l84.676923 196.923077h-177.230769l76.8-196.923077h15.753846zM945.230769 157.538462v708.923076c0 43.323077-35.446154 78.769231-78.769231 78.769231H157.538462c-43.323077 0-78.769231-35.446154-78.769231-78.769231V157.538462c0-43.323077 35.446154-78.769231 78.769231-78.769231h708.923076c43.323077 0 78.769231 35.446154 78.769231 78.769231z m-108.307692 643.938461L600.615385 216.615385c-5.907692-11.815385-15.753846-19.692308-29.538462-19.692308h-139.815385c-11.815385 0-23.630769 7.876923-27.56923 19.692308l-216.615385 584.861538c-3.938462 11.815385 3.938462 25.6 17.723077 25.6h80.738462c11.815385 0 23.630769-9.846154 27.56923-21.661538l63.015385-175.261539h263.876923l68.923077 175.261539c3.938462 11.815385 15.753846 21.661538 27.569231 21.661538h80.738461c13.784615 0 23.630769-13.784615 19.692308-25.6z"></path></svg>',Ei$3='<svg viewBox="0 0 1024 1024"><path d="M64 512h384v128h-128V1024h-128V640h-128z m896-256H708.2496v768h-136.4992V256H320V128h640z"></path></svg>',Ti$3='<svg viewBox="0 0 1024 1024"><path d="M956.788364 152.110545h-24.110546l23.924364 9.029819 0.186182 121.018181h-65.070546l-86.574545-130.048H566.551273v650.14691l130.048 64.977454v65.163636h-390.050909v-65.163636l129.954909-64.977454V152.110545H198.283636L111.429818 282.065455H46.545455V69.259636C46.545455 33.792 82.664727 22.062545 98.955636 22.062545h812.683637c23.738182 0 45.056 15.173818 45.056 41.053091V169.425455v-17.221819z"></path></svg>',Mi$3='<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m256-512v384l-256-192z"></path></svg>',Hi$2='<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z"></path></svg>',Oi$3='<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>',Ii$3='<svg viewBox="0 0 1024 1024"><path d="M972.8 793.6v102.4H256v-102.4h716.8z m0-230.4v102.4H51.2v-102.4h921.6z m0-230.4v102.4H256v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>',Ni$3='<svg viewBox="0 0 1024 1024"><path d="M870.4 793.6v102.4H153.6v-102.4h716.8z m102.4-230.4v102.4H51.2v-102.4h921.6z m-102.4-230.4v102.4H153.6v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>',Li$3='<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m0 192h1024v128H0z m0 192h1024v128H0z m0 192h1024v128H0z m0 192h1024v128H0z"></path></svg>',zi$3='<svg viewBox="0 0 1024 1024"><path d="M768 206.016v50.016h128v64h-192V174.016l128-60V64h-128V0h192v146.016zM676 256h-136L352 444 164 256H28l256 256-256 256h136L352 580 540 768h136l-256-256z"></path></svg>',ji$3='<svg viewBox="0 0 1024 1024"><path d="M768 910.016v50.016h128v64h-192v-146.016l128-60V768h-128v-64h192v146.016zM676 256h-136L352 444 164 256H28l256 256-256 256h136L352 580 540 768h136l-256-256z"></path></svg>',Ai$3=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.mark="bold",e.title=cp$1("textStyle.bold"),e.iconSvg=vi$4,e.hotkey="mod+b",e}return $o$4(e,t),e}(hi$4),Pi$3=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.mark="code",e.title=cp$1("textStyle.code"),e.iconSvg=bi$3,e.hotkey="mod+e",e}return $o$4(e,t),e}(hi$4),Vi$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.mark="italic",e.title=cp$1("textStyle.italic"),e.iconSvg=yi$4,e.hotkey="mod+i",e}return $o$4(e,t),e}(hi$4),Ci$3=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.mark="through",e.title=cp$1("textStyle.through"),e.iconSvg=mi$3,e.hotkey="mod+shift+x",e}return $o$4(e,t),e}(hi$4),Di$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.mark="underline",e.title=cp$1("textStyle.underline"),e.iconSvg=gi$4,e.hotkey="mod+u",e}return $o$4(e,t),e}(hi$4),Bi$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.mark="sub",e.marksNeedToRemove=["sup"],e.title=cp$1("textStyle.sub"),e.iconSvg=ji$3,e.hotkey="",e}return $o$4(e,t),e}(hi$4),Ri$3=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.mark="sup",e.marksNeedToRemove=["sub"],e.title=cp$1("textStyle.sup"),e.iconSvg=zi$3,e.hotkey="",e}return $o$4(e,t),e}(hi$4),Fi$3=function(){function t(){this.title=cp$1("textStyle.clear"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M969.382408 288.738615l-319.401123-270.852152a67.074236 67.074236 0 0 0-96.459139 5.74922l-505.931379 574.922021a68.35184 68.35184 0 0 0-17.886463 47.910169 74.101061 74.101061 0 0 0 24.274486 47.910168l156.50655 132.232065h373.060512L975.131628 383.281347a67.074236 67.074236 0 0 0-5.74922-96.459139z m-440.134747 433.746725H264.144729l-90.071117-78.572676c-5.74922-5.74922-12.137243-12.137243-12.137243-17.886463a36.411728 36.411728 0 0 1 5.749221-24.274485l210.804741-240.828447 265.102932 228.691204z m-439.495945 180.781036h843.218964a60.047411 60.047411 0 1 1 0 120.733624H89.751716a60.047411 60.047411 0 1 1 0-120.733624z m0 0"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){return pi$4(t)},t.prototype.exec=function(t,e){var n,r,o=Editor.nodes(t,{match:function(t){return Text.isText(t)},universal:!0});try{for(var i=Uo$4(o),u=i.next();!u.done;u=i.next()){di$4(t,u.value[0]);}}catch(t){n={error:t};}finally{try{u&&!u.done&&(r=i.return)&&r.call(i);}finally{if(n)throw n.error}}},t}(),_i$3={renderStyle:function(t,e){var n=t,r=n.bold,o=n.italic,u=n.underline,a=n.code,c=n.through,l=n.sub,s=n.sup,f=e;return r&&(f=jsx("strong",null,f)),a&&(f=jsx("code",null,f)),o&&(f=jsx("em",null,f)),u&&(f=jsx("u",null,f)),c&&(f=jsx("s",null,f)),l&&(f=jsx("sub",null,f)),s&&(f=jsx("sup",null,f)),f},menus:[{key:"bold",factory:function(){return new Ai$3}},{key:"underline",factory:function(){return new Di$2}},{key:"italic",factory:function(){return new Vi$2}},{key:"through",factory:function(){return new Ci$3}},{key:"code",factory:function(){return new Pi$3}},{key:"sub",factory:function(){return new Bi$2}},{key:"sup",factory:function(){return new Ri$3}},{key:"clearStyle",factory:function(){return new Fi$3}}],styleToHtml:function(t,e){if(!Text.isText(t))return e;if(Co$4(e))return ei$4(t,e);var n=$$6(e);if("br"===Bo$4(n))return ei$4(t,"<br>");var r=n.html();return r=ei$4(t,r),n.html(r),Do$4(n)},parseStyleHtml:function(t,e,n){var r=$$6(t);if(!Text.isText(e))return e;var o=e;return ni$4(r,"b,strong")&&(o.bold=!0),ni$4(r,"i,em")&&(o.italic=!0),ni$4(r,"u")&&(o.underline=!0),ni$4(r,"s,strike")&&(o.through=!0),ni$4(r,"sub")&&(o.sub=!0),ni$4(r,"sup")&&(o.sup=!0),ni$4(r,"code")&&(o.code=!0),o}};function $i$2(t){return function(e,n,r){return jsx("h"+t,null,n)}}var qi$2={type:"header1",renderElem:$i$2(1)},Wi$2={type:"header2",renderElem:$i$2(2)},Gi$2={type:"header3",renderElem:$i$2(3)},Ui$2={type:"header4",renderElem:$i$2(4)},Xi$2={type:"header5",renderElem:$i$2(5)},Yi$2=_e$5.PROPER,Ji$2=RegExp.prototype,Ki$2=Ji$2.toString,Qi$2=st$5(Jn$5),Zi$2=K$5((function(){return "/a/b"!=Ki$2.call({source:"a",flags:"b"})})),tu$2=Yi$2&&"toString"!=Ki$2.name;(Zi$2||tu$2)&&$e$5(RegExp.prototype,"toString",(function(){var t=ge$5(this),e=Yn$5(t.source),n=t.flags;return "/"+e+"/"+Yn$5(void 0===n&&Et$5(Ji$2,t)&&!("flags"in Ji$2)?Qi$2(t):n)}),{unsafe:!0});var eu$2,nu$2=J$5.TypeError,ru$2=function(t){if(po$4(t))throw nu$2("The method doesn't accept regular expressions");return t},ou$2=re$5("match"),iu$2=function(t){var e=/./;try{"/./"[t](e);}catch(n){try{return e[ou$2]=!1,"/./"[t](e)}catch(t){}}return !1},uu$2=de$5.f,au$2=st$5("".startsWith),cu$2=st$5("".slice),lu$2=Math.min,su$2=iu$2("startsWith");function fu$2(t){var n=Xo$4(Editor.nodes(t,{match:function(t){return ol$1.getNodeType(t).startsWith("header")},universal:!0}),1),r=n[0];if(null==r)return "paragraph";var o=Xo$4(r,1)[0];return ol$1.getNodeType(o)}function pu$2(t){return null==t.selection||!Xo$4(Editor.nodes(t,{match:function(t){var n=ol$1.getNodeType(t);return "paragraph"===n||!!n.startsWith("header")},universal:!0,mode:"highest"}),1)[0]}function du$2(t,e){e&&Transforms.setNodes(t,{type:e});}wn$5({target:"String",proto:!0,forced:!!(su$2||(eu$2=uu$2(String.prototype,"startsWith"),!eu$2||eu$2.writable))&&!su$2},{startsWith:function(t){var e=Yn$5(mt$5(this));ru$2(t);var n=Ke$5(lu$2(arguments.length>1?arguments[1]:void 0,e.length)),r=Yn$5(t);return au$2?au$2(e,r,n):cu$2(e,n,n+r.length)===r}});var hu$2=function(){function t(){this.title=cp$1("header.title"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M960 960c-51.2 0-102.4-3.2-153.6-3.2-51.2 0-99.2 3.2-150.4 3.2-19.2 0-28.8-22.4-28.8-38.4 0-51.2 57.6-28.8 86.4-48 19.2-12.8 19.2-60.8 19.2-80v-224-19.2c-9.6-3.2-19.2-3.2-28.8-3.2H320c-9.6 0-19.2 0-28.8 3.2V780.8c0 22.4 0 80 22.4 92.8 28.8 19.2 96-6.4 96 44.8 0 16-9.6 41.6-28.8 41.6-54.4 0-105.6-3.2-160-3.2-48 0-96 3.2-147.2 3.2-19.2 0-28.8-22.4-28.8-38.4 0-51.2 51.2-28.8 80-48 19.2-12.8 19.2-60.8 19.2-83.2V294.4c0-28.8 3.2-115.2-22.4-131.2-25.6-16-86.4 9.6-86.4-41.6 0-16 6.4-41.6 28.8-41.6 51.2 0 105.6 3.2 156.8 3.2 48 0 96-3.2 144-3.2 19.2 0 28.8 22.4 28.8 41.6 0 48-57.6 25.6-83.2 41.6-19.2 12.8-19.2 73.6-19.2 92.8v201.6c6.4 3.2 16 3.2 22.4 3.2h400c6.4 0 12.8 0 22.4-3.2V256c0-22.4 0-80-19.2-92.8-28.8-16-86.4 6.4-86.4-41.6 0-16 9.6-41.6 28.8-41.6 51.2 0 99.2 3.2 150.4 3.2 48 0 99.2-3.2 147.2-3.2 19.2 0 28.8 22.4 28.8 41.6 0 51.2-57.6 25.6-86.4 41.6-19.2 12.8-19.2 70.4-19.2 92.8v537.6c0 19.2 0 67.2 19.2 80 28.8 19.2 89.6-6.4 89.6 44.8 0 19.2-6.4 41.6-28.8 41.6z"></path></svg>',this.tag="select",this.width=60;}return t.prototype.getOptions=function(t){var e=[{value:"header1",text:"H1",styleForRenderMenuList:{"font-size":"32px","font-weight":"bold"}},{value:"header2",text:"H2",styleForRenderMenuList:{"font-size":"24px","font-weight":"bold"}},{value:"header3",text:"H3",styleForRenderMenuList:{"font-size":"18px","font-weight":"bold"}},{value:"header4",text:"H4",styleForRenderMenuList:{"font-size":"16px","font-weight":"bold"}},{value:"header5",text:"H5",styleForRenderMenuList:{"font-size":"13px","font-weight":"bold"}},{value:"paragraph",text:cp$1("header.text")}],r=this.getValue(t).toString();return e.forEach((function(t){t.value===r?t.selected=!0:delete t.selected;})),e},t.prototype.isActive=function(t){return !1},t.prototype.getValue=function(t){return fu$2(t)},t.prototype.isDisabled=function(t){return pu$2(t)},t.prototype.exec=function(t,e){du$2(t,e.toString());},t}(),vu$2=function(){function t(){this.tag="button";}return t.prototype.getValue=function(t){return fu$2(t)},t.prototype.isActive=function(t){return this.getValue(t)===this.type},t.prototype.isDisabled=function(t){return pu$2(t)},t.prototype.exec=function(t,e){var n=this.type;du$2(t,e===n?"paragraph":n);},t}(),gu$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title="H1",e.type="header1",e}return $o$4(e,t),e}(vu$2),yu$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title="H2",e.type="header2",e}return $o$4(e,t),e}(vu$2),mu$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title="H3",e.type="header3",e}return $o$4(e,t),e}(vu$2),bu$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title="H4",e.type="header4",e}return $o$4(e,t),e}(vu$2),wu$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title="H5",e.type="header5",e}return $o$4(e,t),e}(vu$2),xu$2={key:"headerSelect",factory:function(){return new hu$2}},Su$2={key:"header1",factory:function(){return new gu$2}},ku$2={key:"header2",factory:function(){return new yu$2}},Eu$2={key:"header3",factory:function(){return new mu$2}},Tu$2={key:"header4",factory:function(){return new bu$2}},Mu$2={key:"header5",factory:function(){return new wu$2}};function Hu$2(t){return function(e,n){return "<h"+t+">"+n+"</h"+t+">"}}function Ou$2(t){return function(e,n,r){var o=$$6(e);return 0===(n=n.filter((function(t){return !!Text.isText(t)||!!r.isInline(t)}))).length&&(n=[{text:o.text().replace(/\s+/gm," ")}]),{type:"header"+t,children:n}}}var Iu$2={renderElems:[qi$2,Wi$2,Gi$2,Ui$2,Xi$2],elemsToHtml:[{type:"header1",elemToHtml:Hu$2(1)},{type:"header2",elemToHtml:Hu$2(2)},{type:"header3",elemToHtml:Hu$2(3)},{type:"header4",elemToHtml:Hu$2(4)},{type:"header5",elemToHtml:Hu$2(5)}],parseElemsHtml:[{selector:"h1:not([data-w-e-type])",parseElemHtml:Ou$2(1)},{selector:"h2:not([data-w-e-type])",parseElemHtml:Ou$2(2)},{selector:"h3:not([data-w-e-type])",parseElemHtml:Ou$2(3)},{selector:"h4:not([data-w-e-type])",parseElemHtml:Ou$2(4)},{selector:"h5:not([data-w-e-type])",parseElemHtml:Ou$2(5)}],menus:[xu$2,Su$2,ku$2,Eu$2,Tu$2,Mu$2],editorPlugin:function(t){var n=t.insertBreak;t.insertNode;var r=t;return r.insertBreak=function(){var o=Xo$4(Editor.nodes(r,{match:function(t){return ol$1.getNodeType(t).startsWith("header")},universal:!0}),1)[0];if(o)if(ol$1.isSelectionAtLineEnd(t,o[1])){Transforms.insertNodes(r,{type:"paragraph",children:[{text:""}]},{mode:"highest"});}else n();else n();},r}},Nu$2=Object.assign,Lu$2=Object.defineProperty,zu$2=st$5([].concat),ju$2=!Nu$2||K$5((function(){if(Q$5&&1!==Nu$2({b:1},Nu$2(Lu$2({},"a",{enumerable:!0,get:function(){Lu$2(this,"b",{value:3,enumerable:!1});}}),{b:2})).b)return !0;var t={},e={},n=Symbol(),r="abcdefghijklmnopqrst";return t[n]=7,r.split("").forEach((function(t){e[t]=t;})),7!=Nu$2({},t)[n]||er$4(Nu$2({},e)).join("")!=r}))?function(t,e){for(var n=Gt$5(t),r=arguments.length,o=1,i=cn$5.f,u=ot$5.f;r>o;)for(var a,c=gt$5(arguments[o++]),l=i?zu$2(er$4(c),i(c)):er$4(c),s=l.length,f=0;s>f;)a=l[f++],Q$5&&!tt$5(u,c,a)||(n[a]=c[a]);return n}:Nu$2;function Au$2(t,e){null==t.data&&(t.data={});var n=t.data;null==n.style&&(n.style={}),Object.assign(n.style,e);}wn$5({target:"Object",stat:!0,forced:Object.assign!==ju$2},{assign:ju$2});var Pu$2={selector:"font",preParseHtml:function(t){var e=$$6(t);if("font"!==Bo$4(e))return t;var n=e.attr("color")||"";return n&&(e.removeAttr("color"),e.css("color",n)),e[0]}};var Vu$2=function(){function t(){this.tag="button",this.showDropPanel=!0,this.$content=null;}return t.prototype.exec=function(t,e){},t.prototype.getValue=function(t){var e=this.mark,n=Editor.marks(t);return n&&n[e]?n[e]:""},t.prototype.isActive=function(t){return !!this.getValue(t)},t.prototype.isDisabled=function(t){return null==t.selection||!!Xo$4(Editor.nodes(t,{match:function(n){return "pre"===ol$1.getNodeType(n)||!!Editor.isVoid(t,n)},universal:!0}),1)[0]},t.prototype.getPanelContentElem=function(t){var e=this.mark;if(null==this.$content){var r=$$6('<ul class="w-e-panel-content-color"></ul>');r.on("click","li",(function(n){var r=n.target;if(null!=r&&(n.preventDefault(),null!=t.selection)){var o=$$6(r).attr("data-value");"0"===o?Editor.removeMark(t,e):Editor.addMark(t,e,o);}})),this.$content=r;}var o=this.$content;if(null==o)return document.createElement("ul");o.empty();var i=this.getValue(t),u=t.getMenuConfig(e).colors;(void 0===u?[]:u).forEach((function(t){var e=$$6('<div class="color-block" data-value="'+t+'"></div>');e.css("background-color",t);var n=$$6('<li data-value="'+t+'"></li>');i===t&&n.addClass("active"),n.append(e),o.append(n);}));var a="";"color"===e&&(a=cp$1("color.default")),"bgColor"===e&&(a=cp$1("color.clear"));var l=$$6('\n      <li data-value="0" class="clear">\n        <svg viewBox="0 0 1024 1024"><path d="M236.8 128L896 787.2V128H236.8z m614.4 704L192 172.8V832h659.2zM192 64h704c38.4 0 64 25.6 64 64v704c0 38.4-25.6 64-64 64H192c-38.4 0-64-25.6-64-64V128c0-38.4 25.6-64 64-64z"></path></svg>\n        '+a+"\n      </li>\n    ");return o.prepend(l),o[0]},t}(),Cu$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title=cp$1("color.color"),e.iconSvg=Si$3,e.mark="color",e}return $o$4(e,t),e}(Vu$2),Du$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title=cp$1("color.bgColor"),e.iconSvg=ki$3,e.mark="bgColor",e}return $o$4(e,t),e}(Vu$2),Bu$2=["rgb(0, 0, 0)","rgb(38, 38, 38)","rgb(89, 89, 89)","rgb(140, 140, 140)","rgb(191, 191, 191)","rgb(217, 217, 217)","rgb(233, 233, 233)","rgb(245, 245, 245)","rgb(250, 250, 250)","rgb(255, 255, 255)","rgb(225, 60, 57)","rgb(231, 95, 51)","rgb(235, 144, 58)","rgb(245, 219, 77)","rgb(114, 192, 64)","rgb(89, 191, 192)","rgb(66, 144, 247)","rgb(54, 88, 226)","rgb(106, 57, 201)","rgb(216, 68, 147)","rgb(251, 233, 230)","rgb(252, 237, 225)","rgb(252, 239, 212)","rgb(252, 251, 207)","rgb(231, 246, 213)","rgb(218, 244, 240)","rgb(217, 237, 250)","rgb(224, 232, 250)","rgb(237, 225, 248)","rgb(246, 226, 234)","rgb(255, 163, 158)","rgb(255, 187, 150)","rgb(255, 213, 145)","rgb(255, 251, 143)","rgb(183, 235, 143)","rgb(135, 232, 222)","rgb(145, 213, 255)","rgb(173, 198, 255)","rgb(211, 173, 247)","rgb(255, 173, 210)","rgb(255, 77, 79)","rgb(255, 122, 69)","rgb(255, 169, 64)","rgb(255, 236, 61)","rgb(115, 209, 61)","rgb(54, 207, 201)","rgb(64, 169, 255)","rgb(89, 126, 247)","rgb(146, 84, 222)","rgb(247, 89, 171)","rgb(207, 19, 34)","rgb(212, 56, 13)","rgb(212, 107, 8)","rgb(212, 177, 6)","rgb(56, 158, 13)","rgb(8, 151, 156)","rgb(9, 109, 217)","rgb(29, 57, 196)","rgb(83, 29, 171)","rgb(196, 29, 127)","rgb(130, 0, 20)","rgb(135, 20, 0)","rgb(135, 56, 0)","rgb(97, 71, 0)","rgb(19, 82, 0)","rgb(0, 71, 79)","rgb(0, 58, 140)","rgb(6, 17, 120)","rgb(34, 7, 94)","rgb(120, 6, 80)"];var Ru$2={renderStyle:function(t,e){var n=t,r=n.color,o=n.bgColor,i=e;return r&&Au$2(i,{color:r}),o&&Au$2(i,{backgroundColor:o}),i},styleToHtml:function(t,e){if(!Text.isText(t))return e;var n,r=t,o=r.color,i=r.bgColor;return o||i?((Co$4(e)||"span"!==Bo$4(n=$$6(e)))&&(n=$$6("<span>"+e+"</span>")),o&&n.css("color",o),i&&n.css("background-color",i),Do$4(n)):e},preParseHtml:[Pu$2],parseStyleHtml:function(t,e,n){var r=$$6(t);if(!Text.isText(e))return e;var o=e,i=Ro$4(r,"color");i&&(o.color=i);var u=Ro$4(r,"background-color");return u||(u=Ro$4(r,"background")),u&&(o.bgColor=u),o},menus:[{key:"color",factory:function(){return new Cu$2},config:{colors:Bu$2}},{key:"bgColor",factory:function(){return new Du$2},config:{colors:Bu$2}}]},Fu$2=function(t){if("string"!=typeof t)return !1;var e=t.match(_u$2);if(!e)return !1;var n=e[1];if(!n)return !1;if($u$2.test(n)||qu$2.test(n))return !0;return !1},_u$2=/^(?:\w+:)?\/\/(\S+)$/,$u$2=/^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/,qu$2=/^[^\s\.]+\.\S{2,}$/;var Wu$2=tn$5.includes;function Gu$2(t){return void 0===t&&(t="r"),t+"-"+nanoid$3()}function Uu$2(t){return t.replace(/</g,"&lt;").replace(/>/g,"&gt;")}function Xu$2(t,e,n,r){return Wo$4(this,void 0,void 0,(function(){var o,i;return Go$4(this,(function(u){switch(u.label){case 0:return (o=e.getMenuConfig(t).checkLink)?[4,o(n,r)]:[3,2];case 1:if("string"==typeof(i=u.sent()))return e.alert(i,"error"),[2,!1];if(null==i)return [2,!1];u.label=2;case 2:return [2,!0]}}))}))}function Yu$2(t,e,n){return Wo$4(this,void 0,void 0,(function(){var r;return Go$4(this,(function(o){switch(o.label){case 0:return (r=e.getMenuConfig(t).parseLinkUrl)?[4,r(n)]:[3,2];case 1:return [2,o.sent()];case 2:return [2,n]}}))}))}function Ju$2(t){return null==t.selection||!!ol$1.getSelectedElems(t).some((function(e){var n=e.type;return !!t.isVoid(e)||(!!["pre","code","link"].includes(n)||void 0)}))}function Ku$2(t,e){return {type:"link",url:Uu$2(t),children:e?[{text:e}]:[]}}function Qu$2(t,e,n){return Wo$4(this,void 0,void 0,(function(){var r,o,i;return Go$4(this,(function(u){switch(u.label){case 0:return n?(e||(e=n),t.restoreSelection(),Ju$2(t)?[2]:[4,Xu$2("insertLink",t,e,n)]):[2];case 1:return u.sent()?[4,Yu$2("insertLink",t,n)]:[2];case 2:return r=u.sent(),null==(o=t.selection)?[2]:(Range.isCollapsed(o)?(t.insertText(" "),i=Ku$2(r,e),Transforms.insertNodes(t,i),t.insertFragment([{text:" "}])):Editor.string(t,o)!==e?(t.deleteFragment(),i=Ku$2(r,e),Transforms.insertNodes(t,i)):(i=Ku$2(r),Transforms.wrapNodes(t,i,{split:!0}),Transforms.collapse(t,{edge:"end"})),[2])}}))}))}wn$5({target:"Array",proto:!0},{includes:function(t){return Wu$2(this,t,arguments.length>1?arguments[1]:void 0)}}),co$4("includes");var Zu$2={type:"link",renderElem:function(t,e,n){var r=t,o=r.url,u=r.target;return jsx("a",{href:o,target:void 0===u?"_blank":u},e)}};var ta$3={type:"link",elemToHtml:function(t,e){var n=t,r=n.url,o=n.target;return '<a href="'+r+'" target="'+(void 0===o?"_blank":o)+'">'+e+"</a>"}};var ea$3={selector:"a:not([data-w-e-type])",parseElemHtml:function(t,e,n){var r=$$6(t);return 0===(e=e.filter((function(t){return !!Text.isText(t)||!!n.isInline(t)}))).length&&(e=[{text:r.text().replace(/\s+/gm," ")}]),{type:"link",url:r.attr("href")||"",target:r.attr("target")||"",children:e}}};function na$3(){return Gu$2("w-e-insert-link")}var ra$3=function(){function t(){this.title=cp$1("link.insert"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M440.224 635.776a51.84 51.84 0 0 1-36.768-15.232c-95.136-95.136-95.136-249.92 0-345.056l192-192C641.536 37.408 702.816 12.032 768 12.032s126.432 25.376 172.544 71.456c95.136 95.136 95.136 249.92 0 345.056l-87.776 87.776a51.968 51.968 0 1 1-73.536-73.536l87.776-87.776a140.16 140.16 0 0 0 0-197.984c-26.432-26.432-61.6-40.992-99.008-40.992s-72.544 14.56-99.008 40.992l-192 192a140.16 140.16 0 0 0 0 197.984 51.968 51.968 0 0 1-36.768 88.768z"></path><path d="M256 1012a242.4 242.4 0 0 1-172.544-71.456c-95.136-95.136-95.136-249.92 0-345.056l87.776-87.776a51.968 51.968 0 1 1 73.536 73.536l-87.776 87.776a140.16 140.16 0 0 0 0 197.984c26.432 26.432 61.6 40.992 99.008 40.992s72.544-14.56 99.008-40.992l192-192a140.16 140.16 0 0 0 0-197.984 51.968 51.968 0 1 1 73.536-73.536c95.136 95.136 95.136 249.92 0 345.056l-192 192A242.4 242.4 0 0 1 256 1012z"></path></svg>',this.tag="button",this.showModal=!0,this.modalWidth=300,this.$content=null,this.textInputId=na$3(),this.urlInputId=na$3(),this.buttonId=na$3();}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.exec=function(t,e){},t.prototype.isDisabled=function(t){return Ju$2(t)},t.prototype.getModalPositionNode=function(t){return null},t.prototype.getModalContentElem=function(t){var e=t.selection,i=this,u=i.textInputId,a=i.urlInputId,l=i.buttonId,s=Xo$4(zd$1(cp$1("link.text"),u),2),f=s[0],d=s[1],v=$$6(d),g=Xo$4(zd$1(cp$1("link.url"),a),2),y=g[0],m=g[1],b=$$6(m),w=Xo$4(Ud(l,cp$1("common.ok")),1)[0];if(null==this.$content){var x=$$6("<div></div>");x.on("click","#"+l,(function(e){e.preventDefault();var n=x.find("#"+u).val(),r=x.find("#"+a).val();Qu$2(t,n,r),t.hidePanelOrModal();})),this.$content=x;}var S=this.$content;if(S.empty(),S.append(f),S.append(y),S.append(w),null==e||Range.isCollapsed(e))v.val("");else {var k=Editor.string(t,e);v.val(k);}return b.val(""),setTimeout((function(){v.focus();})),S[0]},t}();function oa$3(){return Gu$2("w-e-update-link")}var ia$3=function(){function t(){this.title=cp$1("link.edit"),this.iconSvg=wi$3,this.tag="button",this.showModal=!0,this.modalWidth=300,this.$content=null,this.urlInputId=oa$3(),this.buttonId=oa$3();}return t.prototype.getSelectedLinkElem=function(t){var n=ol$1.getSelectedNodeByType(t,"link");return null==n?null:n},t.prototype.getValue=function(t){var e=this.getSelectedLinkElem(t);return e&&e.url||""},t.prototype.isActive=function(t){return !1},t.prototype.exec=function(t,e){},t.prototype.isDisabled=function(t){return null==t.selection||null==this.getSelectedLinkElem(t)},t.prototype.getModalPositionNode=function(t){return ol$1.getSelectedNodeByType(t,"link")},t.prototype.getModalContentElem=function(t){var i=this.urlInputId,u=this.buttonId,a=Xo$4(zd$1(cp$1("link.url"),i),2),c=a[0],l=a[1],p=$$6(l),d=Xo$4(Ud(u,cp$1("common.ok")),1)[0];if(null==this.$content){var v=$$6("<div></div>");v.on("click","button",(function(n){n.preventDefault(),t.restoreSelection();var r=ol$1.getSelectedNodeByType(t,"link"),o=r?Node$1.string(r):"",u=v.find("#"+i).val();!function(t,n,r){Wo$4(this,void 0,void 0,(function(){var o,i;return Go$4(this,(function(u){switch(u.label){case 0:return r?[4,Xu$2("editLink",t,n,r)]:[2];case 1:return u.sent()?[4,Yu$2("editLink",t,r)]:[2];case 2:return o=u.sent(),i={url:Uu$2(o)},Transforms.setNodes(t,i,{match:function(t){return ol$1.checkNodeType(t,"link")}}),[2]}}))}));}(t,o,u),t.hidePanelOrModal();})),this.$content=v;}var g=this.$content;g.empty(),g.append(c),g.append(d);var y=this.getValue(t);return p.val(y),setTimeout((function(){p.focus();})),g[0]},t}(),ua$3=function(){function t(){this.title=cp$1("link.unLink"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M608.16328 811.815036c9.371954 9.371954 9.371954 24.56788 0 33.941834l-89.347563 89.347564c-118.525421 118.523421-311.38448 118.531421-429.919901 0-118.527421-118.529421-118.527421-311.39048 0-429.917901l89.349564-89.349563c9.371954-9.371954 24.56788-9.371954 33.941834 0l79.195613 79.195613c9.371954 9.371954 9.371954 24.56788 0 33.941834l-89.349563 89.347564c-56.143726 56.145726-56.143726 147.49928 0 203.645005 56.143726 56.143726 147.49928 56.145726 203.647005 0l89.347564-89.347563c9.371954-9.371954 24.56788-9.371954 33.941834 0l79.193613 79.195613z m-113.135447-520.429459c9.371954 9.371954 24.56788 9.371954 33.941834 0l89.347564-89.347564c56.143726-56.149726 147.49928-56.145726 203.647006 0 56.143726 56.145726 56.143726 147.49928 0 203.645006l-89.349564 89.347564c-9.371954 9.371954-9.371954 24.56788 0 33.941834l79.195613 79.195613c9.371954 9.371954 24.56788 9.371954 33.941834 0l89.349564-89.349563c118.529421-118.529421 118.529421-311.38848 0-429.917901-118.531421-118.527421-311.38848-118.527421-429.919901 0l-89.347563 89.347564c-9.371954 9.371954-9.371954 24.56788 0 33.941834l79.193613 79.195613z m469.653707 718.556492l45.253779-45.253779c18.745908-18.745908 18.745908-49.13776 0-67.881669L127.195629 14.062931c-18.745908-18.745908-49.13776-18.745908-67.881669 0L14.058181 59.31871c-18.745908 18.745908-18.745908 49.13776 0 67.881669l882.74169 882.74169c18.745908 18.743908 49.13776 18.743908 67.881669 0z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){return null==t.selection||null==ol$1.getSelectedNodeByType(t,"link")},t.prototype.exec=function(t,n){this.isDisabled(t)||Transforms.unwrapNodes(t,{match:function(t){return ol$1.checkNodeType(t,"link")}});},t}(),aa$3=function(){function t(){this.title=cp$1("link.view"),this.iconSvg=xi$3,this.tag="button";}return t.prototype.getSelectedLinkElem=function(t){var n=ol$1.getSelectedNodeByType(t,"link");return null==n?null:n},t.prototype.getValue=function(t){var e=this.getSelectedLinkElem(t);return e&&e.url||""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){return null==t.selection||null==this.getSelectedLinkElem(t)},t.prototype.exec=function(t,e){if(!this.isDisabled(t)){if(!e||"string"!=typeof e)throw new Error("View link failed, link url is '"+e+"'");window.open(e,"_blank");}},t}();var ca$3={checkLink:function(t,e){return !0},parseLinkUrl:function(t){return t}},la$3={renderElems:[Zu$2],elemsToHtml:[ta$3],parseElemsHtml:[ea$3],menus:[{key:"insertLink",factory:function(){return new ra$3},config:ca$3},{key:"editLink",factory:function(){return new ia$3},config:ca$3},{key:"unLink",factory:function(){return new ua$3}},{key:"viewLink",factory:function(){return new aa$3}}],editorPlugin:function(t){var n=t.isInline,r=t.insertData,o=t.normalizeNode;t.insertNode,t.insertText;var i=t;return i.isInline=function(t){return "link"===t.type||n(t)},i.insertData=function(t){var e=t.getData("text/plain");if(Fu$2(e)){if(!Ju$2(i)){var n=i.selection;if(null!=n){var o=Editor.string(i,n);Qu$2(i,o,e);}}}else r(t);},i.normalizeNode=function(t){var n=Xo$4(t,2),r=n[0],u=n[1];return "link"!==ol$1.getNodeType(r)?o([r,u]):""===Node$1.string(r)?Transforms.removeNodes(i,{at:u}):o([r,u])},i}};var sa$3=st$5(1..valueOf),fa$3=J$5.RangeError,pa$3=J$5.RangeError,da$3=J$5.String,ha$2=Math.floor,va$3=st$5((function(t){var e=Yn$5(mt$5(this)),n="",r=Ge$5(t);if(r<0||r==1/0)throw fa$3("Wrong number of repetitions");for(;r>0;(r>>>=1)&&(e+=e))1&r&&(n+=e);return n})),ga$2=st$5("".slice),ya$2=st$5(1..toFixed),ma$2=function(t,e,n){return 0===e?n:e%2==1?ma$2(t,e-1,n*t):ma$2(t*t,e/2,n)},ba$2=function(t,e,n){for(var r=-1,o=n;++r<6;)o+=e*t[r],t[r]=o%1e7,o=ha$2(o/1e7);},wa$2=function(t,e){for(var n=6,r=0;--n>=0;)r+=t[n],t[n]=ha$2(r/e),r=r%e*1e7;},xa$2=function(t){for(var e=6,n="";--e>=0;)if(""!==n||0===e||0!==t[e]){var r=da$3(t[e]);n=""===n?r:n+va$3("0",7-r.length)+r;}return n};function Sa$2(t,n){return "w-e-image-container-"+ol$1.findKey(t,n).id}function ka$2(t,n,r,o){var u=$$6("body"),a=Sa$2(t,n),c=o.width,l=o.height,s=0,p=0,d=0,v=!1,g=null;function y(n){g=function(){var t=$$6("#"+a);if(0===t.length)throw new Error("Cannot find image container elem");return t}(),s=n;var r=g.find("img");if(0===r.length)throw new Error("Cannot find image elem");p=r.width(),d=r.height(),u.on("mousemove",m),u.on("mouseup",b);var o=ol$1.getHoverbar(t);o&&o.hideAndClean();}var m=lodash_throttle((function(t){t.preventDefault();var e=t.clientX,n=p+(v?s-e:e-s),r=d*(n/p);null!=g&&(n<=15||r<=15||(g.css("width",n+"px"),g.css("height",r+"px")));}),100);function b(r){if(u.off("mousemove",m),null!=g){var o=g.width().toFixed(2),i=g.height().toFixed(2),a={style:qo$4(qo$4({},n.style),{width:o+"px",height:i+"px"})};Transforms.setNodes(t,a,{at:ol$1.findPath(t,n)}),u.off("mouseup",b);}}var w={};return c&&(w.width=c),l&&(w.height=l),jsx("div",{id:a,style:w,className:"w-e-image-container w-e-selected-image-container",on:{mousedown:function(t){var e=$$6(t.target);e.hasClass("w-e-image-dragger")&&(t.preventDefault(),(e.hasClass("left-top")||e.hasClass("left-bottom"))&&(v=!0),y(t.clientX));}}},r,jsx("div",{className:"w-e-image-dragger left-top"}),jsx("div",{className:"w-e-image-dragger right-top"}),jsx("div",{className:"w-e-image-dragger left-bottom"}),jsx("div",{className:"w-e-image-dragger right-bottom"}))}wn$5({target:"Number",proto:!0,forced:K$5((function(){return "0.000"!==ya$2(8e-5,3)||"1"!==ya$2(.9,0)||"1.25"!==ya$2(1.255,2)||"1000000000000000128"!==ya$2(0xde0b6b3a7640080,0)}))||!K$5((function(){ya$2({});}))},{toFixed:function(t){var e,n,r,o,i=sa$3(this),u=Ge$5(t),a=[0,0,0,0,0,0],c="",l="0";if(u<0||u>20)throw pa$3("Incorrect fraction digits");if(i!=i)return "NaN";if(i<=-1e21||i>=1e21)return da$3(i);if(i<0&&(c="-",i=-i),i>1e-21)if(n=(e=function(t){for(var e=0,n=t;n>=4096;)e+=12,n/=4096;for(;n>=2;)e+=1,n/=2;return e}(i*ma$2(2,69,1))-69)<0?i*ma$2(2,-e,1):i/ma$2(2,e,1),n*=4503599627370496,(e=52-e)>0){for(ba$2(a,0,n),r=u;r>=7;)ba$2(a,1e7,0),r-=7;for(ba$2(a,ma$2(10,r,1),0),r=e-1;r>=23;)wa$2(a,1<<23),r-=23;wa$2(a,1<<r),ba$2(a,1,1),wa$2(a,2),l=xa$2(a);}else ba$2(a,0,n),ba$2(a,1<<-e,0),l=xa$2(a)+va$3("0",u);return l=u>0?c+((o=l.length)<=u?"0."+va$3("0",u-o)+l:ga$2(l,0,o-u)+"."+ga$2(l,o-u)):c+l}});var Ea$2={type:"image",renderElem:function(t,n,r){var o=t,u=o.src,a=o.alt,c=void 0===a?"":a,l=o.href,s=void 0===l?"":l,f=o.style,p=void 0===f?{}:f,d=p.width,h=void 0===d?"":d,v=p.height,g=void 0===v?"":v,y=ol$1.isNodeSelected(r,t),m={};h&&(m.width="100%"),g&&(m.height="100%");var b=jsx("img",{style:m,src:u,alt:c,"data-href":s}),w=r.isDisabled();return y&&!w?ka$2(r,t,b,{width:h,height:g}):function(t,e,n,r){var o=r.width,u=r.height,a={};o&&(a.width=o),u&&(a.height=u);var c=Sa$2(t,e);return jsx("div",{id:c,style:a,className:"w-e-image-container"},n)}(r,t,b,{width:h,height:g})}};var Ta$2={type:"image",elemToHtml:function(t,e){var n=t,r=n.src,o=n.alt,i=void 0===o?"":o,u=n.href,a=void 0===u?"":u,c=n.style,l=void 0===c?{}:c,s=l.width,f=void 0===s?"":s,p=l.height,d=void 0===p?"":p,h="";return f&&(h+="width: "+f+";"),d&&(h+="height: "+d+";"),'<img src="'+r+'" alt="'+i+'" data-href="'+a+'" style="'+h+'"/>'}};var Ma$2={selector:"img:not([data-w-e-type])",parseElemHtml:function(t,e,n){var r=$$6(t),o=r.attr("data-href")||"";return o=decodeURIComponent(o),{type:"image",src:r.attr("src")||"",alt:r.attr("alt")||"",href:o,style:{width:Ro$4(r,"width"),height:Ro$4(r,"height")},children:[{text:""}]}}};function Ha$1(t,e,n,r,o){return void 0===r&&(r=""),void 0===o&&(o=""),Wo$4(this,void 0,void 0,(function(){var i,u;return Go$4(this,(function(a){switch(a.label){case 0:return (i=e.getMenuConfig(t).checkImage)?[4,i(n,r,o)]:[3,2];case 1:if("string"==typeof(u=a.sent()))return e.alert(u,"error"),[2,!1];if(null==u)return [2,!1];a.label=2;case 2:return [2,!0]}}))}))}function Oa$2(t,e,n){return Wo$4(this,void 0,void 0,(function(){var r;return Go$4(this,(function(o){switch(o.label){case 0:return (r=e.getMenuConfig(t).parseImageSrc)?[4,r(n)]:[3,2];case 1:return [2,o.sent()];case 2:return [2,n]}}))}))}function Ia$2(t,n,r,o){return void 0===r&&(r=""),void 0===o&&(o=""),Wo$4(this,void 0,void 0,(function(){var i,u,a;return Go$4(this,(function(c){switch(c.label){case 0:return [4,Ha$1("insertImage",t,n,r,o)];case 1:return c.sent()?[4,Oa$2("insertImage",t,n)]:[2];case 2:return i=c.sent(),u={type:"image",src:Uu$2(i),href:o,alt:r,style:{},children:[{text:""}]},null===t.selection&&t.restoreSelection(),ol$1.getSelectedNodeByType(t,"image")&&t.move(1),La$2(t)?[2]:(Transforms.insertNodes(t,u),(a=t.getMenuConfig("insertImage").onInsertedImage)&&a(u),[2])}}))}))}function Na$2(t,n,r,o,i){return void 0===r&&(r=""),void 0===o&&(o=""),void 0===i&&(i={}),Wo$4(this,void 0,void 0,(function(){var u,a,c,l,s,p;return Go$4(this,(function(d){switch(d.label){case 0:return [4,Ha$1("editImage",t,n,r,o)];case 1:return d.sent()?[4,Oa$2("editImage",t,n)]:[2];case 2:return u=d.sent(),null==(a=ol$1.getSelectedNodeByType(t,"image"))?[2]:(c=a.style,l={src:u,alt:r,href:o,style:qo$4(qo$4({},void 0===c?{}:c),i)},Transforms.setNodes(t,l,{match:function(t){return ol$1.checkNodeType(t,"image")}}),s=ol$1.getSelectedNodeByType(t,"image"),(p=t.getMenuConfig("editImage").onUpdatedImage)&&p(s),[2])}}))}))}function La$2(t){var n=t.selection;return null==n||(!Range.isCollapsed(n)||!!Xo$4(Editor.nodes(t,{match:function(n){var r=ol$1.getNodeType(n);return "code"===r||("pre"===r||("link"===r||("list-item"===r||(!!r.startsWith("header")||("blockquote"===r||!!Editor.isVoid(t,n))))))},universal:!0}),1)[0])}function za$1(){return Gu$2("w-e-insert-image")}var ja$1=function(){function t(){this.title=cp$1("image.netImage"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',this.tag="button",this.showModal=!0,this.modalWidth=300,this.$content=null,this.srcInputId=za$1(),this.altInputId=za$1(),this.hrefInputId=za$1(),this.buttonId=za$1();}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.exec=function(t,e){},t.prototype.isDisabled=function(t){return La$2(t)},t.prototype.getModalPositionNode=function(t){return null},t.prototype.getModalContentElem=function(t){var e=this,i=this,u=i.srcInputId,a=i.altInputId,c=i.hrefInputId,l=i.buttonId,s=Xo$4(zd$1(cp$1("image.src"),u),2),f=s[0],p=s[1],d=$$6(p),v=Xo$4(zd$1(cp$1("image.desc"),a),2),g=v[0],y=v[1],m=$$6(y),b=Xo$4(zd$1(cp$1("image.link"),c),2),w=b[0],x=b[1],S=$$6(x),k=Xo$4(Ud(l,cp$1("common.ok")),1)[0];if(null==this.$content){var E=$$6("<div></div>");E.on("click","#"+l,(function(n){n.preventDefault();var r=E.find("#"+u).val().trim(),o=E.find("#"+a).val().trim(),i=E.find("#"+c).val().trim();e.insertImage(t,r,o,i),t.hidePanelOrModal();})),this.$content=E;}var T=this.$content;return T.empty(),T.append(f),T.append(g),T.append(w),T.append(k),d.val(""),m.val(""),S.val(""),setTimeout((function(){d.focus();})),T[0]},t.prototype.insertImage=function(t,e,n,r){void 0===n&&(n=""),void 0===r&&(r=""),e&&(t.restoreSelection(),this.isDisabled(t)||Ia$2(t,e,n,r));},t}(),Aa$2=function(){function t(){this.title=cp$1("image.delete"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M826.8032 356.5312c-19.328 0-36.3776 15.6928-36.3776 35.0464v524.2624c0 19.328-16 34.56-35.328 34.56H264.9344c-19.328 0-35.5072-15.3088-35.5072-34.56V390.0416c0-19.328-14.1568-35.0464-33.5104-35.0464s-33.5104 15.6928-33.5104 35.0464V915.712c0 57.9328 44.6208 108.288 102.528 108.288H755.2c57.9328 0 108.0832-50.4576 108.0832-108.288V391.4752c-0.1024-19.2512-17.1264-34.944-36.48-34.944z" p-id="9577"></path><path d="M437.1712 775.7568V390.6048c0-19.328-14.1568-35.0464-33.5104-35.0464s-33.5104 15.616-33.5104 35.0464v385.152c0 19.328 14.1568 35.0464 33.5104 35.0464s33.5104-15.7184 33.5104-35.0464zM649.7024 775.7568V390.6048c0-19.328-17.0496-35.0464-36.3776-35.0464s-36.3776 15.616-36.3776 35.0464v385.152c0 19.328 17.0496 35.0464 36.3776 35.0464s36.3776-15.7184 36.3776-35.0464zM965.0432 217.0368h-174.6176V145.5104c0-57.9328-47.2064-101.76-104.6528-101.76h-350.976c-57.8304 0-105.3952 43.8528-105.3952 101.76v71.5264H54.784c-19.4304 0-35.0464 14.1568-35.0464 33.5104 0 19.328 15.616 33.5104 35.0464 33.5104h910.3616c19.328 0 35.0464-14.1568 35.0464-33.5104 0-19.3536-15.6928-33.5104-35.1488-33.5104z m-247.3728 0H297.3952V145.5104c0-19.328 18.2016-34.7648 37.4272-34.7648h350.976c19.1488 0 31.872 15.1296 31.872 34.7648v71.5264z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){return null==t.selection||null==ol$1.getSelectedNodeByType(t,"image")},t.prototype.exec=function(t,n){this.isDisabled(t)||Transforms.removeNodes(t,{match:function(t){return ol$1.checkNodeType(t,"image")}});},t}();function Pa$2(){return Gu$2("w-e-edit-image")}var Va$1=function(){function t(){this.title=cp$1("image.edit"),this.iconSvg=wi$3,this.tag="button",this.showModal=!0,this.modalWidth=300,this.$content=null,this.srcInputId=Pa$2(),this.altInputId=Pa$2(),this.hrefInputId=Pa$2(),this.buttonId=Pa$2();}return t.prototype.getValue=function(t){return ""},t.prototype.getImageNode=function(t){return ol$1.getSelectedNodeByType(t,"image")},t.prototype.isActive=function(t){return !1},t.prototype.exec=function(t,e){},t.prototype.isDisabled=function(t){var n=t.selection;return null==n||(!Range.isCollapsed(n)||null==ol$1.getSelectedNodeByType(t,"image"))},t.prototype.getModalPositionNode=function(t){return this.getImageNode(t)},t.prototype.getModalContentElem=function(t){var e=this,i=this,u=i.srcInputId,a=i.altInputId,c=i.hrefInputId,l=i.buttonId,s=this.getImageNode(t);if(null==s)throw new Error("Not found selected image node");var f=Xo$4(zd$1(cp$1("image.src"),u),2),p=f[0],d=f[1],v=$$6(d),g=Xo$4(zd$1(cp$1("image.desc"),a),2),y=g[0],m=g[1],b=$$6(m),w=Xo$4(zd$1(cp$1("image.link"),c),2),x=w[0],S=w[1],k=$$6(S),E=Xo$4(Ud(l,cp$1("common.ok")),1)[0];if(null==this.$content){var T=$$6("<div></div>");T.on("click","#"+l,(function(n){n.preventDefault();var r=T.find("#"+u).val(),o=T.find("#"+a).val(),i=T.find("#"+c).val();e.updateImage(t,r,o,i),t.hidePanelOrModal();})),this.$content=T;}var M=this.$content;M.empty(),M.append(p),M.append(y),M.append(x),M.append(E);var H=s,O=H.src,I=H.alt,N=void 0===I?"":I,L=H.href,z=void 0===L?"":L;return v.val(O),b.val(N),k.val(z),setTimeout((function(){v.focus();})),M[0]},t.prototype.updateImage=function(t,e,n,r,o){void 0===n&&(n=""),void 0===r&&(r=""),void 0===o&&(o={}),e&&(t.restoreSelection(),this.isDisabled(t)||Na$2(t,e,n,r,o));},t}(),Ca$2=function(){function t(){this.title=cp$1("image.viewLink"),this.iconSvg=xi$3,this.tag="button";}return t.prototype.getValue=function(t){var n=ol$1.getSelectedNodeByType(t,"image");return n&&n.href||""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){return null==t.selection||!this.getValue(t)},t.prototype.exec=function(t,e){if(!this.isDisabled(t)){if(!e||"string"!=typeof e)throw new Error("View image link failed, image.href is '"+e+"'");window.open(e,"_blank");}},t}(),Da$2=function(){function t(){this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.getSelectedNode=function(t){return ol$1.getSelectedNodeByType(t,"image")},t.prototype.isDisabled=function(t){return null==t.selection||null==this.getSelectedNode(t)},t.prototype.exec=function(t,n){if(!this.isDisabled(t)){var r=this.getSelectedNode(t);if(null!=r){var o=ol$1.getHoverbar(t);o&&o.hideAndClean();var i=r.style,u={style:qo$4(qo$4({},void 0===i?{}:i),{width:this.value,height:""})};Transforms.setNodes(t,u,{match:function(t){return ol$1.checkNodeType(t,"image")}});}}},t}(),Ba$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title="30%",e.value="30%",e}return $o$4(e,t),e}(Da$2),Ra$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title="50%",e.value="50%",e}return $o$4(e,t),e}(Da$2),Fa$2=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title="100%",e.value="100%",e}return $o$4(e,t),e}(Da$2);var _a$2={onInsertedImage:function(t){},onUpdatedImage:function(t){},checkImage:function(t,e,n){return !0},parseImageSrc:function(t){return t}},$a$2={renderElems:[Ea$2],elemsToHtml:[Ta$2],parseElemsHtml:[Ma$2],menus:[{key:"insertImage",factory:function(){return new ja$1},config:_a$2},{key:"deleteImage",factory:function(){return new Aa$2}},{key:"editImage",factory:function(){return new Va$1},config:_a$2},{key:"viewImageLink",factory:function(){return new Ca$2}},{key:"imageWidth30",factory:function(){return new Ba$2}},{key:"imageWidth50",factory:function(){return new Ra$2}},{key:"imageWidth100",factory:function(){return new Fa$2}}],editorPlugin:function(t){var e=t.isInline,n=t.isVoid;t.insertNode;var r=t;return r.isInline=function(t){return "image"===t.type||e(t)},r.isVoid=function(t){return "image"===t.type||n(t)},r}};var qa$1={type:"todo",renderElem:function(t,n,r){var o=!1;r.isDisabled()&&(o=!0);var u=t.checked,a=jsx("div",{style:{margin:"5px 0"}},jsx("span",{contentEditable:!1,style:{marginRight:"0.5em"}},jsx("input",{type:"checkbox",checked:u,disabled:o,on:{change:function(n){var o=ol$1.findPath(r,t),i={checked:n.target.checked};Transforms.setNodes(r,i,{at:o});}}})),jsx("span",null,n));return a}};var Wa$1=function(){function t(){this.title=cp$1("todo.todo"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M278.755556 403.911111l-79.644445 79.644445L455.111111 739.555556l568.888889-568.888889-79.644444-79.644445L455.111111 580.266667l-176.355555-176.355556zM910.222222 910.222222H113.777778V113.777778h568.888889V0H113.777778C51.2 0 0 51.2 0 113.777778v796.444444c0 62.577778 51.2 113.777778 113.777778 113.777778h796.444444c62.577778 0 113.777778-51.2 113.777778-113.777778V455.111111h-113.777778v455.111111z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !!ol$1.getSelectedNodeByType(t,"todo")},t.prototype.isDisabled=function(t){return null==t.selection||!!ol$1.getSelectedElems(t).some((function(e){if(Editor.isVoid(t,e)&&Editor.isBlock(t,e))return !0;var n=e.type;return !!["pre","table","list-item"].includes(n)||void 0}))},t.prototype.exec=function(t,e){var n=this.isActive(t);Transforms.setNodes(t,{type:n?"paragraph":"todo"});},t}();var Ga$1={selector:'div[data-w-e-type="todo"]',parseElemHtml:function(t,e,n){var r=$$6(t);0===(e=e.filter((function(t){return !!Text.isText(t)||!!n.isInline(t)}))).length&&(e=[{text:r.text().replace(/\s+/gm," ")}]);var o=!1;return null!=r.find('input[type="checkbox"]').attr("checked")&&(o=!0),{type:"todo",checked:o,children:e}}};var Ua$2={renderElems:[qa$1],elemsToHtml:[{type:"todo",elemToHtml:function(t,e){return '<div data-w-e-type="todo"><input type="checkbox" disabled '+(t.checked?"checked":"")+">"+e+"</div>"}}],preParseHtml:[{selector:"ul.w-e-todo",preParseHtml:function(t){var e=$$6(t).find("li"),n=$$6('<div data-w-e-type="todo"></div>'),r=e.find("input[type]");return n.append(r),e.children()[0].remove(),n[0].innerHTML=n[0].innerHTML+e[0].innerHTML,n[0]}}],parseElemsHtml:[Ga$1],menus:[{key:"todo",factory:function(){return new Wa$1}}],editorPlugin:function(t){var n=t.deleteBackward,r=t;return r.deleteBackward=function(r){var o=t.selection;if(o&&Range.isCollapsed(o)){var i=ol$1.getSelectedNodeByType(t,"todo");if(i&&0===Node$1.string(i).length)return void Transforms.setNodes(t,{type:"paragraph"},{mode:"highest"})}n(r);},r}};var Xa$1={type:"blockquote",renderElem:function(t,e,n){return jsx("blockquote",null,e)}};var Ya$1={type:"blockquote",elemToHtml:function(t,e){return "<blockquote>"+e+"</blockquote>"}};var Ja$1={selector:"blockquote:not([data-w-e-type])",parseElemHtml:function(t,e,n){var r=$$6(t);return 0===(e=e.filter((function(t){return !!Text.isText(t)||!!n.isInline(t)}))).length&&(e=[{text:r.text().replace(/\s+/gm," ")}]),{type:"blockquote",children:e}}},Ka$1=function(){function t(){this.title=cp$1("blockQuote.title"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M894.6 907.1H605.4c-32.6 0-59-26.4-59-59V608.2l-4-14.9c0-315.9 125.5-485.1 376.5-507.5v59.8C752.7 180.4 711.3 315.8 711.3 442.4v41.2l31.5 12.3h151.8c32.6 0 59 26.4 59 59v293.2c0 32.5-26.4 59-59 59z m-472 0H133.4c-32.6 0-59-26.4-59-59V608.2l-4-14.9c0-315.9 125.5-485.1 376.5-507.5v59.8C280.7 180.4 239.3 315.8 239.3 442.4v41.2l31.5 12.3h151.8c32.6 0 59 26.4 59 59v293.2c0 32.5-26.4 59-59 59z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !!ol$1.getSelectedNodeByType(t,"blockquote")},t.prototype.isDisabled=function(t){return null==t.selection||!Xo$4(Editor.nodes(t,{match:function(t){var n=ol$1.getNodeType(t);return "paragraph"===n||"blockquote"===n},universal:!0,mode:"highest"}),1)[0]},t.prototype.exec=function(t,e){if(!this.isDisabled(t)){var n=this.isActive(t)?"paragraph":"blockquote";Transforms.setNodes(t,{type:n},{mode:"highest"});}},t}(),Qa$1={key:"blockquote",factory:function(){return new Ka$1}},Za=st$5([].slice),tc=qn$5("slice"),ec=re$5("species"),nc=J$5.Array,rc=Math.max;wn$5({target:"Array",proto:!0,forced:!tc},{slice:function(t,e){var n,r,o,i=bt$5(this),u=Qe$5(i),a=Ye$5(t,u),c=Ye$5(void 0===e?u:e,u);if(Sn$5(i)&&(n=i.constructor,(Vn$5(n)&&(n===nc||Sn$5(n.prototype))||xt$5(n)&&null===(n=n[ec]))&&(n=void 0),n===nc||void 0===n))return Za(i,a,c);for(r=new(void 0===n?nc:n)(rc(c-a,0)),o=0;a<c;a++,o++)a in i&&yo$4(r,o,i[a]);return r.length=o,r}});var oc={renderElems:[Xa$1],elemsToHtml:[Ya$1],parseElemsHtml:[Ja$1],menus:[Qa$1],editorPlugin:function(t){var n=t.insertBreak,r=t.insertText,o=t;return o.insertBreak=function(){var i=o.selection;if(null==i)return n();var u=Xo$4(Editor.nodes(t,{match:function(t){return ol$1.checkNodeType(t,"blockquote")},universal:!0}),1)[0];if(!u)return n();var a=u[0],l=ol$1.findPath(t,a),p=Editor.end(t,l);if(Point.equals(p,i.focus)){var h=Node$1.string(a);if(h&&"\n"===h.slice(-1)){t.deleteBackward("character");return void Transforms.insertNodes(o,{type:"paragraph",children:[{text:""}]},{mode:"highest"})}}r("\n");},o}},ic=function(){function t(){this.title=cp$1("emotion.title"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M512 1024C230.4 1024 0 793.6 0 512S230.4 0 512 0s512 230.4 512 512-230.4 512-512 512z m0-102.4c226.742857 0 409.6-182.857143 409.6-409.6S738.742857 102.4 512 102.4 102.4 285.257143 102.4 512s182.857143 409.6 409.6 409.6z m-204.8-358.4h409.6c0 113.371429-91.428571 204.8-204.8 204.8s-204.8-91.428571-204.8-204.8z m0-102.4c-43.885714 0-76.8-32.914286-76.8-76.8s32.914286-76.8 76.8-76.8 76.8 32.914286 76.8 76.8-32.914286 76.8-76.8 76.8z m409.6 0c-43.885714 0-76.8-32.914286-76.8-76.8s32.914286-76.8 76.8-76.8c43.885714 0 76.8 32.914286 76.8 76.8s-32.914286 76.8-76.8 76.8z"></path></svg>',this.tag="button",this.showDropPanel=!0,this.$content=null;}return t.prototype.exec=function(t,e){},t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){return null==t.selection||!!Xo$4(Editor.nodes(t,{match:function(n){return "pre"===ol$1.getNodeType(n)||!!Editor.isVoid(t,n)},universal:!0}),1)[0]},t.prototype.getPanelContentElem=function(t){if(null==this.$content){var e=$$6('<ul class="w-e-panel-content-emotion"></ul>');e.on("click","li",(function(e){var n=e.target;if(null!=n){e.preventDefault();var r=$$6(n).text();t.insertText(r);}})),this.$content=e;}var n=this.$content;if(null==n)return document.createElement("ul");n.empty();var r=t.getMenuConfig("emotion").emotions;return (void 0===r?[]:r).forEach((function(t){var e=$$6("<li>"+t+"</li>");n.append(e);})),n[0]},t}();var uc={menus:[{key:"emotion",factory:function(){return new ic},config:{emotions:"😀 😃 😄 😁 😆 😅 😂 🤣 😊 😇 🙂 🙃 😉 😌 😍 😘 😗 😙 😚 😋 😛 😝 😜 🤓 😎 😏 😒 😞 😔 😟 😕 🙁 😣 😖 😫 😩 😢 😭 😤 😠 😡 😳 😱 😨 🤗 🤔 😶 😑 😬 🙄 😯 😴 😷 🤑 😈 🤡 💩 👻 💀 👀 👣 👐 🙌 👏 🤝 👍 👎 👊 ✊ 🤛 🤜 🤞 ✌️ 🤘 👌 👈 👉 👆 👇 ☝️ ✋ 🤚 🖐 🖖 👋 🤙 💪 🖕 ✍️ 🙏".split(" ")}}]};var ac={1:"12px",2:"14px",3:"16px",4:"19px",5:"24px",6:"32px",7:"48px"};var cc={selector:"font",preParseHtml:function(t){var e=$$6(t);if("font"!==Bo$4(e))return t;var n=e.attr("size")||"";n&&(e.removeAttr("size"),e.css("font-size",ac[n]));var r=e.attr("face")||"";return r&&(e.removeAttr("face"),e.css("font-family",r)),e[0]}},lc=st$5("".indexOf);wn$5({target:"String",proto:!0,forced:!iu$2("includes")},{includes:function(t){return !!~lc(Yn$5(mt$5(this)),Yn$5(ru$2(t)),arguments.length>1?arguments[1]:void 0)}});var sc,fc,pc=function(t){return t&&t.Math==Math&&t},dc=pc("object"==typeof globalThis&&globalThis)||pc("object"==typeof window&&window)||pc("object"==typeof self&&self)||pc("object"==typeof q$5&&q$5)||function(){return this}()||Function("return this")(),hc=Function.prototype,vc=hc.apply,gc=hc.bind,yc=hc.call,mc="object"==typeof Reflect&&Reflect.apply||(gc?yc.bind(vc):function(){return yc.apply(vc,arguments)}),bc=Function.prototype,wc=bc.bind,xc=bc.call,Sc=wc&&wc.bind(xc),kc=wc?function(t){return t&&Sc(xc,t)}:function(t){return t&&function(){return xc.apply(t,arguments)}},Ec=function(t){return "function"==typeof t},Tc=function(t){try{return !!t()}catch(t){return !0}},Mc=!Tc((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),Hc=Function.prototype.call,Oc=Hc.bind?Hc.bind(Hc):function(){return Hc.apply(Hc,arguments)},Ic={}.propertyIsEnumerable,Nc=Object.getOwnPropertyDescriptor,Lc=Nc&&!Ic.call({1:2},1)?function(t){var e=Nc(this,t);return !!e&&e.enumerable}:Ic,zc={f:Lc},jc=function(t,e){return {enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},Ac=kc({}.toString),Pc=kc("".slice),Vc=function(t){return Pc(Ac(t),8,-1)},Cc=dc.Object,Dc=kc("".split),Bc=Tc((function(){return !Cc("z").propertyIsEnumerable(0)}))?function(t){return "String"==Vc(t)?Dc(t,""):Cc(t)}:Cc,Rc=dc.TypeError,Fc=function(t){if(null==t)throw Rc("Can't call method on "+t);return t},_c=function(t){return Bc(Fc(t))},$c=function(t){return "object"==typeof t?null!==t:Ec(t)},qc={},Wc=function(t){return Ec(t)?t:void 0},Gc=function(t,e){return arguments.length<2?Wc(qc[t])||Wc(dc[t]):qc[t]&&qc[t][e]||dc[t]&&dc[t][e]},Uc=kc({}.isPrototypeOf),Xc=Gc("navigator","userAgent")||"",Yc=dc.process,Jc=dc.Deno,Kc=Yc&&Yc.versions||Jc&&Jc.version,Qc=Kc&&Kc.v8;Qc&&(fc=(sc=Qc.split("."))[0]>0&&sc[0]<4?1:+(sc[0]+sc[1])),!fc&&Xc&&(!(sc=Xc.match(/Edge\/(\d+)/))||sc[1]>=74)&&(sc=Xc.match(/Chrome\/(\d+)/))&&(fc=+sc[1]);var Zc=fc,tl=!!Object.getOwnPropertySymbols&&!Tc((function(){var t=Symbol();return !String(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&Zc&&Zc<41})),el=tl&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,nl=dc.Object,rl=el?function(t){return "symbol"==typeof t}:function(t){var e=Gc("Symbol");return Ec(e)&&Uc(e.prototype,nl(t))},ol=dc.String,il=dc.TypeError,ul=function(t){if(Ec(t))return t;throw il(function(t){try{return ol(t)}catch(t){return "Object"}}(t)+" is not a function")},al=dc.TypeError,cl=Object.defineProperty,ll=dc["__core-js_shared__"]||function(t,e){try{cl(dc,t,{value:e,configurable:!0,writable:!0});}catch(n){dc[t]=e;}return e}("__core-js_shared__",{}),sl=G$5((function(t){(t.exports=function(t,e){return ll[t]||(ll[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.19.3",mode:"pure",copyright:"© 2021 Denis Pushkarev (zloirock.ru)"});})),fl=dc.Object,pl=function(t){return fl(Fc(t))},dl=kc({}.hasOwnProperty),hl=Object.hasOwn||function(t,e){return dl(pl(t),e)},vl=0,gl=Math.random(),yl=kc(1..toString),ml=function(t){return "Symbol("+(void 0===t?"":t)+")_"+yl(++vl+gl,36)},bl=sl("wks"),wl=dc.Symbol,xl=wl&&wl.for,Sl=el?wl:wl&&wl.withoutSetter||ml,kl=function(t){if(!hl(bl,t)||!tl&&"string"!=typeof bl[t]){var e="Symbol."+t;tl&&hl(wl,t)?bl[t]=wl[t]:bl[t]=el&&xl?xl(e):Sl(e);}return bl[t]},El=dc.TypeError,Tl=kl("toPrimitive"),Ml=function(t,e){if(!$c(t)||rl(t))return t;var n,r,o=null==(n=t[Tl])?void 0:ul(n);if(o){if(void 0===e&&(e="default"),r=Oc(o,t,e),!$c(r)||rl(r))return r;throw El("Can't convert object to primitive value")}return void 0===e&&(e="number"),function(t,e){var n,r;if("string"===e&&Ec(n=t.toString)&&!$c(r=Oc(n,t)))return r;if(Ec(n=t.valueOf)&&!$c(r=Oc(n,t)))return r;if("string"!==e&&Ec(n=t.toString)&&!$c(r=Oc(n,t)))return r;throw al("Can't convert object to primitive value")}(t,e)},Hl=function(t){var e=Ml(t,"string");return rl(e)?e:e+""},Ol=dc.document,Il=$c(Ol)&&$c(Ol.createElement),Nl=function(t){return Il?Ol.createElement(t):{}},Ll=!Mc&&!Tc((function(){return 7!=Object.defineProperty(Nl("div"),"a",{get:function(){return 7}}).a})),zl=Object.getOwnPropertyDescriptor,jl={f:Mc?zl:function(t,e){if(t=_c(t),e=Hl(e),Ll)try{return zl(t,e)}catch(t){}if(hl(t,e))return jc(!Oc(zc.f,t,e),t[e])}},Al=/#|\.prototype\./,Pl=function(t,e){var n=Cl[Vl(t)];return n==Bl||n!=Dl&&(Ec(e)?Tc(e):!!e)},Vl=Pl.normalize=function(t){return String(t).replace(Al,".").toLowerCase()},Cl=Pl.data={},Dl=Pl.NATIVE="N",Bl=Pl.POLYFILL="P",Rl=Pl,Fl=kc(kc.bind),_l=function(t,e){return ul(t),void 0===e?t:Fl?Fl(t,e):function(){return t.apply(e,arguments)}},$l=dc.String,ql=dc.TypeError,Wl=function(t){if($c(t))return t;throw ql($l(t)+" is not an object")},Gl=dc.TypeError,Ul=Object.defineProperty,Xl={f:Mc?Ul:function(t,e,n){if(Wl(t),e=Hl(e),Wl(n),Ll)try{return Ul(t,e,n)}catch(t){}if("get"in n||"set"in n)throw Gl("Accessors not supported");return "value"in n&&(t[e]=n.value),t}},Yl=Mc?function(t,e,n){return Xl.f(t,e,jc(1,n))}:function(t,e,n){return t[e]=n,t},Jl=jl.f,Kl=function(t){var e=function(n,r,o){if(this instanceof e){switch(arguments.length){case 0:return new t;case 1:return new t(n);case 2:return new t(n,r)}return new t(n,r,o)}return mc(t,this,arguments)};return e.prototype=t.prototype,e},Ql=function(t,e){var n,r,o,i,u,a,c,l,s=t.target,f=t.global,p=t.stat,d=t.proto,h=f?dc:p?dc[s]:(dc[s]||{}).prototype,v=f?qc:qc[s]||Yl(qc,s,{})[s],g=v.prototype;for(o in e)n=!Rl(f?o:s+(p?".":"#")+o,t.forced)&&h&&hl(h,o),u=v[o],n&&(a=t.noTargetGet?(l=Jl(h,o))&&l.value:h[o]),i=n&&a?a:e[o],n&&typeof u==typeof i||(c=t.bind&&n?_l(i,dc):t.wrap&&n?Kl(i):d&&Ec(i)?kc(i):i,(t.sham||i&&i.sham||u&&u.sham)&&Yl(c,"sham",!0),Yl(v,o,c),d&&(hl(qc,r=s+"Prototype")||Yl(qc,r,{}),Yl(qc[r],o,i),t.real&&g&&!g[o]&&Yl(g,o,i)));},Zl=Array.isArray||function(t){return "Array"==Vc(t)},ts=Math.ceil,es=Math.floor,ns=function(t){var e=+t;return e!=e||0===e?0:(e>0?es:ts)(e)},rs=Math.min,os=function(t){return (e=t.length)>0?rs(ns(e),9007199254740991):0;var e;},is=function(t,e,n){var r=Hl(e);r in t?Xl.f(t,r,jc(0,n)):t[r]=n;},us={};us[kl("toStringTag")]="z";var as="[object z]"===String(us),cs=kl("toStringTag"),ls=dc.Object,ss="Arguments"==Vc(function(){return arguments}()),fs=as?Vc:function(t){var e,n,r;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=ls(t),cs))?n:ss?Vc(e):"Object"==(r=Vc(e))&&Ec(e.callee)?"Arguments":r},ps=kc(Function.toString);Ec(ll.inspectSource)||(ll.inspectSource=function(t){return ps(t)});var ds=ll.inspectSource,hs=function(){},vs=[],gs=Gc("Reflect","construct"),ys=/^\s*(?:class|function)\b/,ms=kc(ys.exec),bs=!ys.exec(hs),ws=function(t){if(!Ec(t))return !1;try{return gs(hs,vs,t),!0}catch(t){return !1}},xs=!gs||Tc((function(){var t;return ws(ws.call)||!ws(Object)||!ws((function(){t=!0;}))||t}))?function(t){if(!Ec(t))return !1;switch(fs(t)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return !1}return bs||!!ms(ys,ds(t))}:ws,Ss=kl("species"),ks=dc.Array,Es=function(t,e){return new(function(t){var e;return Zl(t)&&(e=t.constructor,(xs(e)&&(e===ks||Zl(e.prototype))||$c(e)&&null===(e=e[Ss]))&&(e=void 0)),void 0===e?ks:e}(t))(0===e?0:e)},Ts=kl("species"),Ms=kl("isConcatSpreadable"),Hs=dc.TypeError,Os=Zc>=51||!Tc((function(){var t=[];return t[Ms]=!1,t.concat()[0]!==t})),Is=function(t){return Zc>=51||!Tc((function(){var e=[];return (e.constructor={})[Ts]=function(){return {foo:1}},1!==e[t](Boolean).foo}))}("concat"),Ns=function(t){if(!$c(t))return !1;var e=t[Ms];return void 0!==e?!!e:Zl(t)};Ql({target:"Array",proto:!0,forced:!Os||!Is},{concat:function(t){var e,n,r,o,i,u=pl(this),a=Es(u,0),c=0;for(e=-1,r=arguments.length;e<r;e++)if(Ns(i=-1===e?u:arguments[e])){if(c+(o=os(i))>9007199254740991)throw Hs("Maximum allowed index exceeded");for(n=0;n<o;n++,c++)n in i&&is(a,c,i[n]);}else {if(c>=9007199254740991)throw Hs("Maximum allowed index exceeded");is(a,c++,i);}return a.length=c,a}});var Ls,zs=dc.String,js=function(t){if("Symbol"===fs(t))throw TypeError("Cannot convert a Symbol value to a string");return zs(t)},As=Math.max,Ps=Math.min,Vs=function(t,e){var n=ns(t);return n<0?As(n+e,0):Ps(n,e)},Cs=function(t){return function(e,n,r){var o,i=_c(e),u=os(i),a=Vs(r,u);if(t&&n!=n){for(;u>a;)if((o=i[a++])!=o)return !0}else for(;u>a;a++)if((t||a in i)&&i[a]===n)return t||a||0;return !t&&-1}},Ds={includes:Cs(!0),indexOf:Cs(!1)},Bs={},Rs=Ds.indexOf,Fs=kc([].push),_s=function(t,e){var n,r=_c(t),o=0,i=[];for(n in r)!hl(Bs,n)&&hl(r,n)&&Fs(i,n);for(;e.length>o;)hl(r,n=e[o++])&&(~Rs(i,n)||Fs(i,n));return i},$s=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],qs=Object.keys||function(t){return _s(t,$s)},Ws=Mc?Object.defineProperties:function(t,e){Wl(t);for(var n,r=_c(e),o=qs(e),i=o.length,u=0;i>u;)Xl.f(t,n=o[u++],r[n]);return t},Gs=Gc("document","documentElement"),Us=sl("keys"),Xs=function(t){return Us[t]||(Us[t]=ml(t))},Ys=Xs("IE_PROTO"),Js=function(){},Ks=function(t){return "<script>"+t+"<\/script>"},Qs=function(t){t.write(Ks("")),t.close();var e=t.parentWindow.Object;return t=null,e},Zs=function(){try{Ls=new ActiveXObject("htmlfile");}catch(t){}var t,e;Zs="undefined"!=typeof document?document.domain&&Ls?Qs(Ls):((e=Nl("iframe")).style.display="none",Gs.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write(Ks("document.F=Object")),t.close(),t.F):Qs(Ls);for(var n=$s.length;n--;)delete Zs.prototype[$s[n]];return Zs()};Bs[Ys]=!0;var tf,ef,nf,rf=Object.create||function(t,e){var n;return null!==t?(Js.prototype=Wl(t),n=new Js,Js.prototype=null,n[Ys]=t):n=Zs(),void 0===e?n:Ws(n,e)},of=$s.concat("length","prototype"),uf={f:Object.getOwnPropertyNames||function(t){return _s(t,of)}},af=dc.Array,cf=Math.max,lf=uf.f,sf="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],ff=function(t){try{return lf(t)}catch(t){return function(t,e,n){for(var r=os(t),o=Vs(e,r),i=Vs(void 0===n?r:n,r),u=af(cf(i-o,0)),a=0;o<i;o++,a++)is(u,a,t[o]);return u.length=a,u}(sf)}},pf={f:function(t){return sf&&"Window"==Vc(t)?ff(t):lf(_c(t))}},df={f:Object.getOwnPropertySymbols},hf=kc([].slice),vf=function(t,e,n,r){r&&r.enumerable?t[e]=n:Yl(t,e,n);},gf={f:kl},yf=Xl.f,mf=function(t){var e=qc.Symbol||(qc.Symbol={});hl(e,t)||yf(e,t,{value:gf.f(t)});},bf=as?{}.toString:function(){return "[object "+fs(this)+"]"},wf=Xl.f,xf=kl("toStringTag"),Sf=function(t,e,n,r){if(t){var o=n?t:t.prototype;hl(o,xf)||wf(o,xf,{configurable:!0,value:e}),r&&!as&&Yl(o,"toString",bf);}},kf=dc.WeakMap,Ef=Ec(kf)&&/native code/.test(ds(kf)),Tf=dc.TypeError,Mf=dc.WeakMap;if(Ef||ll.state){var Hf=ll.state||(ll.state=new Mf),Of=kc(Hf.get),If=kc(Hf.has),Nf=kc(Hf.set);tf=function(t,e){if(If(Hf,t))throw new Tf("Object already initialized");return e.facade=t,Nf(Hf,t,e),e},ef=function(t){return Of(Hf,t)||{}},nf=function(t){return If(Hf,t)};}else {var Lf=Xs("state");Bs[Lf]=!0,tf=function(t,e){if(hl(t,Lf))throw new Tf("Object already initialized");return e.facade=t,Yl(t,Lf,e),e},ef=function(t){return hl(t,Lf)?t[Lf]:{}},nf=function(t){return hl(t,Lf)};}var zf={set:tf,get:ef,has:nf,enforce:function(t){return nf(t)?ef(t):tf(t,{})},getterFor:function(t){return function(e){var n;if(!$c(e)||(n=ef(e)).type!==t)throw Tf("Incompatible receiver, "+t+" required");return n}}},jf=kc([].push),Af=function(t){var e=1==t,n=2==t,r=3==t,o=4==t,i=6==t,u=7==t,a=5==t||i;return function(c,l,s,f){for(var p,d,h=pl(c),v=Bc(h),g=_l(l,s),y=os(v),m=0,b=f||Es,w=e?b(c,y):n||u?b(c,0):void 0;y>m;m++)if((a||m in v)&&(d=g(p=v[m],m,h),t))if(e)w[m]=d;else if(d)switch(t){case 3:return !0;case 5:return p;case 6:return m;case 2:jf(w,p);}else switch(t){case 4:return !1;case 7:jf(w,p);}return i?-1:r||o?o:w}},Pf={forEach:Af(0),map:Af(1),filter:Af(2),some:Af(3),every:Af(4),find:Af(5),findIndex:Af(6),filterReject:Af(7)}.forEach,Vf=Xs("hidden"),Cf=kl("toPrimitive"),Df=zf.set,Bf=zf.getterFor("Symbol"),Rf=Object.prototype,Ff=dc.Symbol,_f=Ff&&Ff.prototype,$f=dc.TypeError,qf=dc.QObject,Wf=Gc("JSON","stringify"),Gf=jl.f,Uf=Xl.f,Xf=pf.f,Yf=zc.f,Jf=kc([].push),Kf=sl("symbols"),Qf=sl("op-symbols"),Zf=sl("string-to-symbol-registry"),tp=sl("symbol-to-string-registry"),ep=sl("wks"),np=!qf||!qf.prototype||!qf.prototype.findChild,rp=Mc&&Tc((function(){return 7!=rf(Uf({},"a",{get:function(){return Uf(this,"a",{value:7}).a}})).a}))?function(t,e,n){var r=Gf(Rf,e);r&&delete Rf[e],Uf(t,e,n),r&&t!==Rf&&Uf(Rf,e,r);}:Uf,op=function(t,e){var n=Kf[t]=rf(_f);return Df(n,{type:"Symbol",tag:t,description:e}),Mc||(n.description=e),n},ip=function(t,e,n){t===Rf&&ip(Qf,e,n),Wl(t);var r=Hl(e);return Wl(n),hl(Kf,r)?(n.enumerable?(hl(t,Vf)&&t[Vf][r]&&(t[Vf][r]=!1),n=rf(n,{enumerable:jc(0,!1)})):(hl(t,Vf)||Uf(t,Vf,jc(1,{})),t[Vf][r]=!0),rp(t,r,n)):Uf(t,r,n)},up=function(t,e){Wl(t);var n=_c(e),r=qs(n).concat(sp(n));return Pf(r,(function(e){Mc&&!Oc(ap,n,e)||ip(t,e,n[e]);})),t},ap=function(t){var e=Hl(t),n=Oc(Yf,this,e);return !(this===Rf&&hl(Kf,e)&&!hl(Qf,e))&&(!(n||!hl(this,e)||!hl(Kf,e)||hl(this,Vf)&&this[Vf][e])||n)},cp=function(t,e){var n=_c(t),r=Hl(e);if(n!==Rf||!hl(Kf,r)||hl(Qf,r)){var o=Gf(n,r);return !o||!hl(Kf,r)||hl(n,Vf)&&n[Vf][r]||(o.enumerable=!0),o}},lp=function(t){var e=Xf(_c(t)),n=[];return Pf(e,(function(t){hl(Kf,t)||hl(Bs,t)||Jf(n,t);})),n},sp=function(t){var e=t===Rf,n=Xf(e?Qf:_c(t)),r=[];return Pf(n,(function(t){!hl(Kf,t)||e&&!hl(Rf,t)||Jf(r,Kf[t]);})),r};if(tl||(_f=(Ff=function(){if(Uc(_f,this))throw $f("Symbol is not a constructor");var t=arguments.length&&void 0!==arguments[0]?js(arguments[0]):void 0,e=ml(t),n=function(t){this===Rf&&Oc(n,Qf,t),hl(this,Vf)&&hl(this[Vf],e)&&(this[Vf][e]=!1),rp(this,e,jc(1,t));};return Mc&&np&&rp(Rf,e,{configurable:!0,set:n}),op(e,t)}).prototype,vf(_f,"toString",(function(){return Bf(this).tag})),vf(Ff,"withoutSetter",(function(t){return op(ml(t),t)})),zc.f=ap,Xl.f=ip,jl.f=cp,uf.f=pf.f=lp,df.f=sp,gf.f=function(t){return op(kl(t),t)},Mc&&Uf(_f,"description",{configurable:!0,get:function(){return Bf(this).description}})),Ql({global:!0,wrap:!0,forced:!tl,sham:!tl},{Symbol:Ff}),Pf(qs(ep),(function(t){mf(t);})),Ql({target:"Symbol",stat:!0,forced:!tl},{for:function(t){var e=js(t);if(hl(Zf,e))return Zf[e];var n=Ff(e);return Zf[e]=n,tp[n]=e,n},keyFor:function(t){if(!rl(t))throw $f(t+" is not a symbol");if(hl(tp,t))return tp[t]},useSetter:function(){np=!0;},useSimple:function(){np=!1;}}),Ql({target:"Object",stat:!0,forced:!tl,sham:!Mc},{create:function(t,e){return void 0===e?rf(t):up(rf(t),e)},defineProperty:ip,defineProperties:up,getOwnPropertyDescriptor:cp}),Ql({target:"Object",stat:!0,forced:!tl},{getOwnPropertyNames:lp,getOwnPropertySymbols:sp}),Ql({target:"Object",stat:!0,forced:Tc((function(){df.f(1);}))},{getOwnPropertySymbols:function(t){return df.f(pl(t))}}),Wf){var fp=!tl||Tc((function(){var t=Ff();return "[null]"!=Wf([t])||"{}"!=Wf({a:t})||"{}"!=Wf(Object(t))}));Ql({target:"JSON",stat:!0,forced:fp},{stringify:function(t,e,n){var r=hf(arguments),o=e;if(($c(e)||void 0!==t)&&!rl(t))return Zl(e)||(e=function(t,e){if(Ec(o)&&(e=Oc(o,this,t,e)),!rl(e))return e}),r[1]=e,mc(Wf,null,r)}});}if(!_f[Cf]){var pp=_f.valueOf;vf(_f,Cf,(function(t){return Oc(pp,this)}));}Sf(Ff,"Symbol"),Bs[Vf]=!0,mf("asyncIterator"),mf("hasInstance"),mf("isConcatSpreadable"),mf("iterator"),mf("match"),mf("matchAll"),mf("replace"),mf("search"),mf("species"),mf("split"),mf("toPrimitive"),mf("toStringTag"),mf("unscopables"),Sf(dc.JSON,"JSON",!0);var dp,hp,vp,gp=qc.Symbol,yp={},mp=Function.prototype,bp=Mc&&Object.getOwnPropertyDescriptor,wp=hl(mp,"name"),xp={EXISTS:wp,PROPER:wp&&"something"===function(){}.name,CONFIGURABLE:wp&&(!Mc||Mc&&bp(mp,"name").configurable)},Sp=!Tc((function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype})),kp=Xs("IE_PROTO"),Ep=dc.Object,Tp=Ep.prototype,Mp=Sp?Ep.getPrototypeOf:function(t){var e=pl(t);if(hl(e,kp))return e[kp];var n=e.constructor;return Ec(n)&&e instanceof n?n.prototype:e instanceof Ep?Tp:null},Hp=kl("iterator"),Op=!1;[].keys&&("next"in(vp=[].keys())?(hp=Mp(Mp(vp)))!==Object.prototype&&(dp=hp):Op=!0);var Ip=null==dp||Tc((function(){var t={};return dp[Hp].call(t)!==t}));dp=Ip?{}:rf(dp),Ec(dp[Hp])||vf(dp,Hp,(function(){return this}));var Np={IteratorPrototype:dp,BUGGY_SAFARI_ITERATORS:Op},Lp=Np.IteratorPrototype,zp=function(){return this};dc.String,dc.TypeError;Object.setPrototypeOf||"__proto__"in{}&&function(){var t,e=!1,n={};try{(t=kc(Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set))(n,[]),e=n instanceof Array;}catch(t){}}();var jp=xp.PROPER,Ap=Np.BUGGY_SAFARI_ITERATORS,Pp=kl("iterator"),Vp=function(){return this},Cp=function(t,e,n,r,o,i,u){!function(t,e,n,r){var o=e+" Iterator";t.prototype=rf(Lp,{next:jc(+!r,n)}),Sf(t,o,!1,!0),yp[o]=zp;}(n,e,r);var a,c,l,s=function(t){if(t===o&&v)return v;if(!Ap&&t in d)return d[t];switch(t){case"keys":case"values":case"entries":return function(){return new n(this,t)}}return function(){return new n(this)}},f=e+" Iterator",p=!1,d=t.prototype,h=d[Pp]||d["@@iterator"]||o&&d[o],v=!Ap&&h||s(o),g="Array"==e&&d.entries||h;if(g&&(a=Mp(g.call(new t)))!==Object.prototype&&a.next&&(Sf(a,f,!0,!0),yp[f]=Vp),jp&&"values"==o&&h&&"values"!==h.name&&(p=!0,v=function(){return Oc(h,this)}),o)if(c={values:s("values"),keys:i?v:s("keys"),entries:s("entries")},u)for(l in c)(Ap||p||!(l in d))&&vf(d,l,c[l]);else Ql({target:e,proto:!0,forced:Ap||p},c);return u&&d[Pp]!==v&&vf(d,Pp,v,{name:o}),yp[e]=v,c},Dp=zf.set,Bp=zf.getterFor("Array Iterator");Cp(Array,"Array",(function(t,e){Dp(this,{type:"Array Iterator",target:_c(t),index:0,kind:e});}),(function(){var t=Bp(this),e=t.target,n=t.kind,r=t.index++;return !e||r>=e.length?(t.target=void 0,{value:void 0,done:!0}):"keys"==n?{value:r,done:!1}:"values"==n?{value:e[r],done:!1}:{value:[r,e[r]],done:!1}}),"values"),yp.Arguments=yp.Array;var Rp=kl("toStringTag");for(var Fp in {CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}){var _p=dc[Fp],$p=_p&&_p.prototype;$p&&fs($p)!==Rp&&Yl($p,Rp,Fp),yp[Fp]=yp.Array;}var qp=gp;mf("asyncDispose"),mf("dispose"),mf("matcher"),mf("metadata"),mf("observable"),mf("patternMatch"),mf("replaceAll");var Wp=qp,Gp=kc("".charAt),Up=kc("".charCodeAt),Xp=kc("".slice),Yp=function(t){return function(e,n){var r,o,i=js(Fc(e)),u=ns(n),a=i.length;return u<0||u>=a?t?"":void 0:(r=Up(i,u))<55296||r>56319||u+1===a||(o=Up(i,u+1))<56320||o>57343?t?Gp(i,u):r:t?Xp(i,u,u+2):o-56320+(r-55296<<10)+65536}},Jp={codeAt:Yp(!1),charAt:Yp(!0)}.charAt,Kp=zf.set,Qp=zf.getterFor("String Iterator");Cp(String,"String",(function(t){Kp(this,{type:"String Iterator",string:js(t),index:0});}),(function(){var t,e=Qp(this),n=e.string,r=e.index;return r>=n.length?{value:void 0,done:!0}:(t=Jp(n,r),e.index+=t.length,{value:t,done:!1})}));var Zp=gf.f("iterator"),td=G$5((function(t){function e(n){return "function"==typeof Wp&&"symbol"==typeof Zp?(t.exports=e=function(t){return typeof t},t.exports.default=t.exports,t.exports.__esModule=!0):(t.exports=e=function(t){return t&&"function"==typeof Wp&&t.constructor===Wp&&t!==Wp.prototype?"symbol":typeof t},t.exports.default=t.exports,t.exports.__esModule=!0),e(n)}t.exports=e,t.exports.default=t.exports,t.exports.__esModule=!0;})),ed=W$5(td),nd=_e$5.EXISTS,rd=be$5.f,od=Function.prototype,id=st$5(od.toString),ud=/function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/,ad=st$5(ud.exec);Q$5&&!nd&&rd(od,"name",{configurable:!0,get:function(){try{return ad(ud,id(this))[1]}catch(t){return ""}}});var cd=function(){function t(){this.tag="select",this.width=80;}return t.prototype.isActive=function(t){return !1},t.prototype.getValue=function(t){var e=this.mark,n=Editor.marks(t);return n&&n[e]?n[e]:""},t.prototype.isDisabled=function(t){return null==t.selection||(this.mark,!!Xo$4(Editor.nodes(t,{match:function(n){return "pre"===ol$1.getNodeType(n)||!!Editor.isVoid(t,n)},universal:!0}),1)[0])},t.prototype.exec=function(t,e){var n=this.mark;e?t.addMark(n,e):t.removeMark(n);},t}(),ld=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title=cp$1("fontSize.title"),e.iconSvg=Ei$3,e.mark="fontSize",e}return $o$4(e,t),e.prototype.getOptions=function(t){var e=[],r=t.getMenuConfig(this.mark).fontSizeList,o=void 0===r?[]:r;e.push({text:cp$1("fontSize.default"),value:""}),o.forEach((function(t){if("string"==typeof t)e.push({text:t,value:t});else if("object"===ed(t)){var n=t.name,r=t.value;e.push({text:n,value:r});}}));var i=this.getValue(t);return e.forEach((function(t){t.value===i?t.selected=!0:delete t.selected;})),e},e}(cd),sd=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title=cp$1("fontFamily.title"),e.iconSvg=Ti$3,e.mark="fontFamily",e.selectPanelWidth=150,e}return $o$4(e,t),e.prototype.getOptions=function(t){var e=[],r=t.getMenuConfig(this.mark).fontFamilyList,o=void 0===r?[]:r;e.push({text:cp$1("fontFamily.default"),value:""}),o.forEach((function(t){if("string"==typeof t)e.push({text:t,value:t,styleForRenderMenuList:{"font-family":t}});else if("object"===ed(t)){var n=t.name,r=t.value;e.push({text:n,value:r,styleForRenderMenuList:{"font-family":r}});}}));var i=this.getValue(t);return e.forEach((function(t){t.value===i?t.selected=!0:delete t.selected;})),e},e}(cd);var fd={renderStyle:function(t,e){var n=t,r=n.fontSize,o=n.fontFamily,i=e;return r&&Au$2(i,{fontSize:r}),o&&Au$2(i,{fontFamily:o}),i},styleToHtml:function(t,e){if(!Text.isText(t))return e;var n,r=t,o=r.fontSize,i=r.fontFamily;return o||i?((Co$4(e)||"span"!==Bo$4(n=$$6(e)))&&(n=$$6("<span>"+e+"</span>")),o&&n.css("font-size",o),i&&n.css("font-family",i),Do$4(n)):e},preParseHtml:[cc],parseStyleHtml:function(t,e,n){var r=$$6(t);if(!Text.isText(e))return e;var o=e,i=n.getMenuConfig("fontSize").fontSizeList,u=void 0===i?[]:i,c=Ro$4(r,"font-size"),l=u.find((function(t){return t.value&&t.value===c}))||u.includes(c);c&&l&&(o.fontSize=c);var s=n.getMenuConfig("fontFamily").fontFamilyList,f=void 0===s?[]:s,p=Ro$4(r,"font-family"),d=f.find((function(t){return t.value&&t.value===p}))||f.includes(p);return p&&d&&(o.fontFamily=p),o},menus:[{key:"fontSize",factory:function(){return new ld},config:{fontSizeList:["12px",{name:"13px",value:"13px"},"14px","15px","16px","19px",{name:"22px",value:"22px"},"24px","29px","32px","40px","48px"]}},{key:"fontFamily",factory:function(){return new sd},config:{fontFamilyList:["黑体",{name:"仿宋",value:"仿宋"},"楷体","标楷体","华文仿宋","华文楷体",{name:"宋体",value:"宋体"},"微软雅黑","Arial","Tahoma","Verdana","Times New Roman","Courier New"]}}]};var pd={selector:"p,h1,h2,h3,h4,h5",preParseHtml:function(t){var e=$$6(t),n=Ro$4(e,"padding-left");return /\dem/.test(n)&&e.css("text-indent","2em"),/\dpx/.test(n)&&parseInt(n,10)%32==0&&e.css("text-indent","2em"),e[0]}};var dd=function(){function t(){this.tag="button";}return t.prototype.getValue=function(t){var e=Xo$4(Editor.nodes(t,{match:function(t){return !!t.indent},universal:!0}),1),n=e[0];return null==n?"":Xo$4(n,1)[0].indent||""},t.prototype.isActive=function(t){return !1},t.prototype.getMatchNode=function(t){var n=Xo$4(Editor.nodes(t,{match:function(t){var n=ol$1.getNodeType(t);return "paragraph"===n||!!n.startsWith("header")},universal:!0,mode:"highest"}),1)[0];return null==n?null:n[0]},t}(),hd=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title=cp$1("indent.decrease"),e.iconSvg=Mi$3,e}return $o$4(e,t),e.prototype.isDisabled=function(t){var e=this.getMatchNode(t);return null==e||!e.indent},e.prototype.exec=function(t,e){Transforms.setNodes(t,{indent:null},{match:function(t){return Element$1.isElement(t)}});},e}(dd),vd=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title=cp$1("indent.increase"),e.iconSvg=Hi$2,e}return $o$4(e,t),e.prototype.isDisabled=function(t){var e=this.getMatchNode(t);return null==e||!!e.indent},e.prototype.exec=function(t,e){Transforms.setNodes(t,{indent:"2em"},{match:function(t){return Element$1.isElement(t)},mode:"highest"});},e}(dd),gd={renderStyle:function(t,e){if(!Element$1.isElement(t))return e;var n=t.indent,r=e;return n&&Au$2(r,{textIndent:n}),r},styleToHtml:function(t,e){if(!Element$1.isElement(t))return e;var n=t.indent;if(!n)return e;var r=$$6(e);return r.css("text-indent",n),Do$4(r)},preParseHtml:[pd],parseStyleHtml:function(t,e,n){var r=$$6(t);if(!Element$1.isElement(e))return e;var o=e,i=Ro$4(r,"text-indent"),u=parseInt(i,10);return i&&u>0&&(o.indent=i),o},menus:[{key:"indent",factory:function(){return new vd}},{key:"delIndent",factory:function(){return new hd}}]};var yd=function(){function t(){this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.getMatchNode=function(t){var n=Xo$4(Editor.nodes(t,{match:function(t){var n=ol$1.getNodeType(t);return "paragraph"===n||("blockquote"===n||!!n.startsWith("header"))},universal:!0,mode:"highest"}),1)[0];return null==n?null:n[0]},t.prototype.isDisabled=function(t){return null==t.selection||!!ol$1.getSelectedElems(t).some((function(e){if(Editor.isVoid(t,e)&&Editor.isBlock(t,e))return !0;var n=e.type;return !!["pre","code"].includes(n)||void 0}))},t}(),md=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title=cp$1("justify.left"),e.iconSvg=Oi$3,e}return $o$4(e,t),e.prototype.exec=function(t,e){Transforms.setNodes(t,{textAlign:"left"},{match:function(e){return Element$1.isElement(e)&&!t.isInline(e)}});},e}(yd),bd=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title=cp$1("justify.right"),e.iconSvg=Ii$3,e}return $o$4(e,t),e.prototype.exec=function(t,e){Transforms.setNodes(t,{textAlign:"right"},{match:function(e){return Element$1.isElement(e)&&!t.isInline(e)}});},e}(yd),wd=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title=cp$1("justify.center"),e.iconSvg=Ni$3,e}return $o$4(e,t),e.prototype.exec=function(t,e){Transforms.setNodes(t,{textAlign:"center"},{match:function(e){return Element$1.isElement(e)&&!t.isInline(e)}});},e}(yd),xd=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.title=cp$1("justify.justify"),e.iconSvg=Li$3,e}return $o$4(e,t),e.prototype.exec=function(t,e){Transforms.setNodes(t,{textAlign:"justify"},{match:function(e){return Element$1.isElement(e)&&!t.isInline(e)}});},e}(yd),Sd={renderStyle:function(t,e){if(!Element$1.isElement(t))return e;var n=t.textAlign,r=e;return n&&Au$2(r,{textAlign:n}),r},styleToHtml:function(t,e){if(!Element$1.isElement(t))return e;var n=t.textAlign;if(!n)return e;var r=$$6(e);return r.css("text-align",n),Do$4(r)},parseStyleHtml:function(t,e,n){var r=$$6(t);if(!Element$1.isElement(e))return e;var o=e,i=Ro$4(r,"text-align");return i&&(o.textAlign=i),o},menus:[{key:"justifyLeft",factory:function(){return new md}},{key:"justifyRight",factory:function(){return new bd}},{key:"justifyCenter",factory:function(){return new wd}},{key:"justifyJustify",factory:function(){return new xd}}]};var kd=function(){function t(){this.title=cp$1("lineHeight.title"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M964 788a8 8 0 0 1 8 8v98a8 8 0 0 1-8 8H438a8 8 0 0 1-8-8v-98a8 8 0 0 1 8-8h526zM198.93 144.306c6.668-5.798 16.774-5.094 22.573 1.574l122.26 140.582a16 16 0 0 1 3.927 10.5c0 8.836-7.164 16-16 16h-61.8a8 8 0 0 0-8 8v390.077h69.819a16 16 0 0 1 10.502 3.928c6.666 5.8 7.37 15.906 1.57 22.573L221.476 878.123a16 16 0 0 1-1.57 1.57c-6.668 5.8-16.774 5.097-22.574-1.57L75.051 737.538a16 16 0 0 1-3.928-10.5c0-8.837 7.163-16 16-16h69.822V312.96H87.127a16 16 0 0 1-10.502-3.928c-6.666-5.8-7.37-15.906-1.57-22.573l122.303-140.582a16 16 0 0 1 1.572-1.572zM964 465a8 8 0 0 1 8 8v98a8 8 0 0 1-8 8H438a8 8 0 0 1-8-8v-98a8 8 0 0 1 8-8h526z m0-323a8 8 0 0 1 8 8v98a8 8 0 0 1-8 8H438a8 8 0 0 1-8-8v-98a8 8 0 0 1 8-8h526z"></path></svg>',this.tag="select",this.width=80;}return t.prototype.getOptions=function(t){var e=[],r=t.getMenuConfig("lineHeight").lineHeightList,o=void 0===r?[]:r;e.push({text:cp$1("lineHeight.default"),value:""}),o.forEach((function(t){e.push({text:t,value:t});}));var i=this.getValue(t);return e.forEach((function(t){t.value===i?t.selected=!0:delete t.selected;})),e},t.prototype.getMatchNode=function(t){var n=Xo$4(Editor.nodes(t,{match:function(t){var n=ol$1.getNodeType(t);return !!n.startsWith("header")||!!["paragraph","blockquote","list-item"].includes(n)},universal:!0,mode:"highest"}),1)[0];return null==n?null:n[0]},t.prototype.isActive=function(t){return !1},t.prototype.getValue=function(t){var e=this.getMatchNode(t);return null==e?"":Element$1.isElement(e)&&e.lineHeight||""},t.prototype.isDisabled=function(t){return null==t.selection||null==this.getMatchNode(t)},t.prototype.exec=function(t,e){Transforms.setNodes(t,{lineHeight:e.toString()},{mode:"highest"});},t}();var Ed={renderStyle:function(t,e){if(!Element$1.isElement(t))return e;var n=t.lineHeight,r=e;return n&&Au$2(r,{lineHeight:n}),r},styleToHtml:function(t,e){if(!Element$1.isElement(t))return e;var n=t.lineHeight;if(!n)return e;var r=$$6(e);return r.css("line-height",n),Do$4(r)},parseStyleHtml:function(t,e,n){var r=$$6(t);if(!Element$1.isElement(e))return e;var o=e,i=n.getMenuConfig("lineHeight").lineHeightList,u=void 0===i?[]:i,a=Ro$4(r,"line-height");return a&&u.includes(a)&&(o.lineHeight=a),o},menus:[{key:"lineHeight",factory:function(){return new kd},config:{lineHeightList:["1","1.15","1.5","2","2.5","3"]}}]},Td=function(){function t(){this.title=cp$1("undo.redo"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M0.00032 576a510.72 510.72 0 0 0 173.344 384l84.672-96A383.136 383.136 0 0 1 128.00032 576C128.00032 363.936 299.93632 192 512.00032 192c106.048 0 202.048 42.976 271.52 112.48L640.00032 448h384V64l-149.984 149.984A510.272 510.272 0 0 0 512.00032 64C229.21632 64 0.00032 293.216 0.00032 576z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){return null==t.selection},t.prototype.exec=function(t,e){"function"==typeof t.redo&&t.redo();},t}(),Md=function(){function t(){this.title=cp$1("undo.undo"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M512 64A510.272 510.272 0 0 0 149.984 213.984L0.032 64v384h384L240.512 304.48A382.784 382.784 0 0 1 512.032 192c212.064 0 384 171.936 384 384 0 114.688-50.304 217.632-130.016 288l84.672 96a510.72 510.72 0 0 0 173.344-384c0-282.784-229.216-512-512-512z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){return null==t.selection},t.prototype.exec=function(t,e){"function"==typeof t.undo&&t.undo();},t}(),Hd={menus:[{key:"redo",factory:function(){return new Td}},{key:"undo",factory:function(){return new Md}}]};var Od={type:"divider",renderElem:function(t,n,r){var o=ol$1.isNodeSelected(r,t);return h$3("div",{props:{contentEditable:!1,className:"w-e-textarea-divider"},dataset:{selected:o?"true":""},style:{},on:{mousedown:function(t){return t.preventDefault()}}},[h$3("hr")])}};var Id={type:"divider",elemToHtml:function(t,e){return "<hr/>"}};var Nd={selector:"hr:not([data-w-e-type])",parseElemHtml:function(t,e,n){return {type:"divider",children:[{text:""}]}}},Ld=function(){function t(){this.title=cp$1("divider.title"),this.iconSvg='<svg viewBox="0 0 1092 1024"><path d="M0 51.2m51.2 0l989.866667 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-989.866667 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z"></path><path d="M0 460.8m51.2 0l170.666667 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-170.666667 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z"></path><path d="M819.2 460.8m51.2 0l170.666667 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-170.666667 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z"></path><path d="M409.6 460.8m51.2 0l170.666667 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-170.666667 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z"></path><path d="M0 870.4m51.2 0l989.866667 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-989.866667 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){return null==t.selection||!!ol$1.getSelectedElems(t).some((function(n){if(t.isVoid(n))return !0;var r=ol$1.getNodeType(n);return "table"===r||("pre"===r||void 0)}))},t.prototype.exec=function(t,e){Transforms.insertNodes(t,{type:"divider",children:[{text:""}]},{mode:"highest"});},t}(),zd={renderElems:[Od],elemsToHtml:[Id],parseElemsHtml:[Nd],menus:[{key:"divider",factory:function(){return new Ld}}],editorPlugin:function(t){var n=t.isVoid,r=t.normalizeNode,o=t;return o.isVoid=function(t){return "divider"===t.type||n(t)},o.normalizeNode=function(t){var n=Xo$4(t,2),i=n[0],u=n[1];if("divider"!==ol$1.getNodeType(i))return r([i,u]);ol$1.isLastNode(o,i)&&Transforms.insertNodes(o,ol$1.genEmptyParagraph(),{at:[u[0]+1]});},o}},jd=_n$5.map;wn$5({target:"Array",proto:!0,forced:!qn$5("map")},{map:function(t){return jd(this,t,arguments.length>1?arguments[1]:void 0)}});var Ad=st$5([].join),Pd=gt$5!=Object,Vd=ai$4("join",",");wn$5({target:"Array",proto:!0,forced:Pd||!Vd},{join:function(t){return Ad(bt$5(this),void 0===t?",":t)}});var Cd=function(){function t(){this.title=cp$1("codeBlock.title"),this.iconSvg='<svg viewBox="0 0 1280 1024"><path d="M832 736l96 96 320-320L928 192l-96 96 224 224zM448 288l-96-96L32 512l320 320 96-96-224-224zM701.312 150.528l69.472 18.944-192 704.032-69.472-18.944 192-704.032z"></path></svg>',this.tag="button";}return t.prototype.getSelectCodeElem=function(t){var n=ol$1.getSelectedNodeByType(t,"code");if(null==n)return null;var r=ol$1.getParentNode(t,n);return null==r||"pre"!==ol$1.getNodeType(r)?null:n},t.prototype.getValue=function(t){var e=this.getSelectCodeElem(t);return null==e?"":e.language||""},t.prototype.isActive=function(t){return !!this.getSelectCodeElem(t)},t.prototype.isDisabled=function(t){if(null==t.selection)return !0;var n=ol$1.getSelectedElems(t);return !!n.some((function(e){return t.isVoid(e)}))||!n.some((function(t){var n=ol$1.getNodeType(t);if("pre"===n||"paragraph"===n)return !0}))},t.prototype.exec=function(t,e){this.isActive(t)?this.changeToPlainText(t):this.changeToCodeBlock(t,e.toString());},t.prototype.changeToPlainText=function(t){var e=this.getSelectCodeElem(t);if(null!=e){var n=Node$1.string(e);Transforms.removeNodes(t,{mode:"highest"});var r=n.split("\n").map((function(t){return {type:"paragraph",children:[{text:t}]}}));Transforms.insertNodes(t,r,{mode:"highest"});}},t.prototype.changeToCodeBlock=function(t,e){var n,r,o=[],i=Editor.nodes(t,{match:function(e){return t.children.includes(e)},universal:!0});try{for(var u=Uo$4(i),a=u.next();!a.done;a=u.next()){var l=Xo$4(a.value,1)[0];l&&o.push(Node$1.string(l));}}catch(t){n={error:t};}finally{try{a&&!a.done&&(r=u.return)&&r.call(u);}finally{if(n)throw n.error}}Transforms.removeNodes(t,{mode:"highest"});var p={type:"pre",children:[{type:"code",language:e,children:[{text:o.join("\n")}]}]};Transforms.insertNodes(t,p,{mode:"highest"});},t}(),Dd={key:"codeBlock",factory:function(){return new Cd}};wn$5({target:"String",proto:!0,forced:ti$4("anchor")},{anchor:function(t){return Zo$4(this,"a","name",t)}}),Pr$4("match",(function(t,e,n){return [function(e){var n=mt$5(this),r=null==e?void 0:Bt$5(e,t);return r?tt$5(r,e,n):new RegExp(e)[t](Yn$5(n))},function(t){var r=ge$5(this),o=Yn$5(t),i=n(e,r,o);if(i.done)return i.value;if(!r.global)return Jr$4(r,o);var u=r.unicode;r.lastIndex=0;for(var a,c=[],l=0;null!==(a=Jr$4(r,o));){var s=Yn$5(a[0]);c[l]=s,""===s&&(r.lastIndex=Fr$4(o,Ke$5(r.lastIndex),u)),l++;}return 0===l?null:c}]}));var Bd={type:"pre",renderElem:function(t,e,n){return jsx("pre",null,e)}},Rd={type:"code",renderElem:function(t,e,n){return jsx("code",null,e)}};var Fd={selector:"pre:not([data-w-e-type])",parseElemHtml:function(t,n,r){var o=$$6(t);return 0===(n=n.filter((function(t){return "code"===ol$1.getNodeType(t)}))).length&&(n=[{type:"code",language:"",children:[{text:o[0].textContent||""}]}]),{type:"pre",children:n.filter((function(t){return "code"===ol$1.getNodeType(t)}))}}};var _d={menus:[Dd],editorPlugin:function(t){var n=t.insertBreak,r=t.normalizeNode,o=t.insertData;t.insertNode;var i=t;return i.insertBreak=function(){var t=ol$1.getSelectedNodeByType(i,"code");if(null!=t){var r=function(t,e){var n=e.selection;if(null==n)return "";var r=Node$1.string(t),o=n.anchor.offset,i=r.slice(0,o).split("\n"),u=i.length;return 0===u?"":i[u-1]}(t,i);if(r){var o=r.match(/^\s+/);if(null!=o&&null!=o[0]){var u=o[0];return void i.insertText("\n"+u)}}i.insertText("\n");}else n();},i.normalizeNode=function(t){var n=Xo$4(t,2),o=n[0],u=n[1],a=ol$1.getNodeType(o);("code"===a&&u.length<=1&&Transforms.setNodes(i,{type:"paragraph"},{at:u}),"pre"===a)&&(ol$1.isLastNode(i,o)&&Transforms.insertNodes(i,ol$1.genEmptyParagraph(),{at:[u[0]+1]}),"code"!==ol$1.getNodeType(o.children[0])&&(Transforms.unwrapNodes(i),Transforms.setNodes(i,{type:"paragraph"},{mode:"highest"})));return r([o,u])},i.insertData=function(t){if(null!=ol$1.getSelectedNodeByType(i,"code")){var n=t.getData("text/plain");Editor.insertText(i,n);}else o(t);},i},renderElems:[Bd,Rd],elemsToHtml:[{type:"code",elemToHtml:function(t,e){return "<code>"+e+"</code>"}},{type:"pre",elemToHtml:function(t,e){return "<pre>"+e+"</pre>"}}],preParseHtml:[{selector:"pre>code",preParseHtml:function(t){var e=$$6(t);if("code"!==Bo$4(e))return t;var n=e.find("xmp");if(0===n.length)return t;var r=n.text();return n.remove(),e.text(r),e[0]}}],parseElemsHtml:[{selector:"pre:not([data-w-e-type])>code",parseElemHtml:function(t,e,n){return {type:"code",language:"",children:[{text:$$6(t)[0].textContent||""}]}}},Fd]},$d=function(){function t(){this.title=cp$1("fullScreen.title"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M133.705143 335.433143V133.851429h201.581714a29.622857 29.622857 0 0 0 29.622857-29.549715V68.754286a29.622857 29.622857 0 0 0-29.622857-29.622857H61.732571A22.893714 22.893714 0 0 0 38.765714 62.025143V335.725714c0 16.310857 13.238857 29.622857 29.622857 29.622857h35.547429a29.842286 29.842286 0 0 0 29.696-29.842285zM690.980571 133.851429h201.581715v201.654857c0 16.310857 13.238857 29.549714 29.622857 29.549714h35.547428a29.622857 29.622857 0 0 0 29.549715-29.549714V61.952a22.893714 22.893714 0 0 0-22.820572-22.893714h-273.554285a29.622857 29.622857 0 0 0-29.549715 29.622857v35.547428c0 16.310857 13.238857 29.696 29.622857 29.696zM335.286857 892.781714H133.705143V691.2a29.622857 29.622857 0 0 0-29.622857-29.622857H68.534857a29.622857 29.622857 0 0 0-29.549714 29.622857v273.554286c0 12.653714 10.24 22.893714 22.820571 22.893714h273.554286a29.622857 29.622857 0 0 0 29.696-29.622857v-35.547429a29.769143 29.769143 0 0 0-29.769143-29.696z m557.348572-201.581714v201.581714H690.907429a29.622857 29.622857 0 0 0-29.622858 29.622857v35.547429c0 16.310857 13.238857 29.622857 29.622858 29.622857h273.554285c12.580571 0 22.893714-10.313143 22.893715-22.893714V691.2a29.622857 29.622857 0 0 0-29.622858-29.622857h-35.547428a29.622857 29.622857 0 0 0-29.696 29.622857z"></path></svg>',this.tag="button",this.alwaysEnable=!0;}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return t.isFullScreen},t.prototype.isDisabled=function(t){return !1},t.prototype.exec=function(t,e){t.isFullScreen?t.unFullScreen():t.fullScreen();},t}(),qd={menus:[{key:"fullScreen",factory:function(){return new $d}}]},Wd=function(){function t(){this.title=cp$1("common.enter"),this.iconSvg='<svg viewBox="0 0 1255 1024"><path d="M1095.111111 731.477333h-625.777778V1024L0 658.318222 469.333333 292.408889v292.636444h625.777778V0h156.444445v731.477333z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){var e=t.selection;return null==e||!!Range.isExpanded(e)},t.prototype.exec=function(t,e){var n=t.selection;if(null!=n){var r=[n.anchor.path[0]];Transforms.insertNodes(t,{type:"paragraph",children:[{text:""}]},{at:r}),t.select(Editor.start(t,r));}},t}(),Gd=[_i$3,Ru$2,fd,gd,Sd,Ed,$a$2,zd,uc,la$3,_d,oc,Iu$2,Jo$4,Ua$2,Hd,qd,{menus:[{key:"enter",factory:function(){return new Wd}}]}];

sp$1("en",{listModule:{unOrderedList:"Unordered list",orderedList:"Ordered list"}}),sp$1("zh-CN",{listModule:{unOrderedList:"无序列表",orderedList:"有序列表"}});var d$2="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function p$2(t){var e={exports:{}};return t(e,e.exports),e.exports}var y$2,h$2,g$2=function(t){return t&&t.Math==Math&&t},b$2=g$2("object"==typeof globalThis&&globalThis)||g$2("object"==typeof window&&window)||g$2("object"==typeof self&&self)||g$2("object"==typeof d$2&&d$2)||function(){return this}()||Function("return this")(),m$2=Function.prototype,w$2=m$2.bind,x$3=m$2.call,S$3=w$2&&w$2.bind(x$3),O$4=w$2?function(t){return t&&S$3(x$3,t)}:function(t){return t&&function(){return x$3.apply(t,arguments)}},E$3=function(t){try{return !!t()}catch(t){return !0}},T$3=O$4({}.toString),j$4=O$4("".slice),A$4=function(t){return j$4(T$3(t),8,-1)},I$4=b$2.Object,P$4=O$4("".split),L$4=E$3((function(){return !I$4("z").propertyIsEnumerable(0)}))?function(t){return "String"==A$4(t)?P$4(t,""):I$4(t)}:I$4,R$4=b$2.TypeError,k$4=function(t){if(null==t)throw R$4("Can't call method on "+t);return t},_$4=function(t){return L$4(k$4(t))},N$3=Object.defineProperty,M$3=function(t,e){try{N$3(b$2,t,{value:e,configurable:!0,writable:!0});}catch(r){b$2[t]=e;}return e},z$4=b$2["__core-js_shared__"]||M$3("__core-js_shared__",{}),C$4=p$2((function(t){(t.exports=function(t,e){return z$4[t]||(z$4[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.19.3",mode:"global",copyright:"© 2021 Denis Pushkarev (zloirock.ru)"});})),F$4=b$2.Object,D$4=function(t){return F$4(k$4(t))},H$4=O$4({}.hasOwnProperty),B$4=Object.hasOwn||function(t,e){return H$4(D$4(t),e)},G$4=0,$$4=Math.random(),V$4=O$4(1..toString),W$4=function(t){return "Symbol("+(void 0===t?"":t)+")_"+V$4(++G$4+$$4,36)},U$4=function(t){return "function"==typeof t},K$4=function(t){return U$4(t)?t:void 0},Y$4=function(t,e){return arguments.length<2?K$4(b$2[t]):b$2[t]&&b$2[t][e]},X$4=Y$4("navigator","userAgent")||"",q$4=b$2.process,J$4=b$2.Deno,Q$4=q$4&&q$4.versions||J$4&&J$4.version,Z$4=Q$4&&Q$4.v8;Z$4&&(h$2=(y$2=Z$4.split("."))[0]>0&&y$2[0]<4?1:+(y$2[0]+y$2[1])),!h$2&&X$4&&(!(y$2=X$4.match(/Edge\/(\d+)/))||y$2[1]>=74)&&(y$2=X$4.match(/Chrome\/(\d+)/))&&(h$2=+y$2[1]);var tt$4,et$4=h$2,rt$4=!!Object.getOwnPropertySymbols&&!E$3((function(){var t=Symbol();return !String(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&et$4&&et$4<41})),nt$4=rt$4&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,ot$4=C$4("wks"),it$4=b$2.Symbol,ut$4=it$4&&it$4.for,at$4=nt$4?it$4:it$4&&it$4.withoutSetter||W$4,ct$4=function(t){if(!B$4(ot$4,t)||!rt$4&&"string"!=typeof ot$4[t]){var e="Symbol."+t;rt$4&&B$4(it$4,t)?ot$4[t]=it$4[t]:ot$4[t]=nt$4&&ut$4?ut$4(e):at$4(e);}return ot$4[t]},ft$4=function(t){return "object"==typeof t?null!==t:U$4(t)},lt$4=b$2.String,st$4=b$2.TypeError,vt$4=function(t){if(ft$4(t))return t;throw st$4(lt$4(t)+" is not an object")},dt$4=!E$3((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),pt$4=b$2.document,yt$4=ft$4(pt$4)&&ft$4(pt$4.createElement),ht$4=function(t){return yt$4?pt$4.createElement(t):{}},gt$4=!dt$4&&!E$3((function(){return 7!=Object.defineProperty(ht$4("div"),"a",{get:function(){return 7}}).a})),bt$4=Function.prototype.call,mt$4=bt$4.bind?bt$4.bind(bt$4):function(){return bt$4.apply(bt$4,arguments)},wt$4=O$4({}.isPrototypeOf),xt$4=b$2.Object,St$4=nt$4?function(t){return "symbol"==typeof t}:function(t){var e=Y$4("Symbol");return U$4(e)&&wt$4(e.prototype,xt$4(t))},Ot$4=b$2.String,Et$4=function(t){try{return Ot$4(t)}catch(t){return "Object"}},Tt$4=b$2.TypeError,jt$4=function(t){if(U$4(t))return t;throw Tt$4(Et$4(t)+" is not a function")},At$4=function(t,e){var r=t[e];return null==r?void 0:jt$4(r)},It$4=b$2.TypeError,Pt$4=b$2.TypeError,Lt$4=ct$4("toPrimitive"),Rt$4=function(t,e){if(!ft$4(t)||St$4(t))return t;var r,n=At$4(t,Lt$4);if(n){if(void 0===e&&(e="default"),r=mt$4(n,t,e),!ft$4(r)||St$4(r))return r;throw Pt$4("Can't convert object to primitive value")}return void 0===e&&(e="number"),function(t,e){var r,n;if("string"===e&&U$4(r=t.toString)&&!ft$4(n=mt$4(r,t)))return n;if(U$4(r=t.valueOf)&&!ft$4(n=mt$4(r,t)))return n;if("string"!==e&&U$4(r=t.toString)&&!ft$4(n=mt$4(r,t)))return n;throw It$4("Can't convert object to primitive value")}(t,e)},kt$4=function(t){var e=Rt$4(t,"string");return St$4(e)?e:e+""},_t$4=b$2.TypeError,Nt$4=Object.defineProperty,Mt$4={f:dt$4?Nt$4:function(t,e,r){if(vt$4(t),e=kt$4(e),vt$4(r),gt$4)try{return Nt$4(t,e,r)}catch(t){}if("get"in r||"set"in r)throw _t$4("Accessors not supported");return "value"in r&&(t[e]=r.value),t}},zt$4=Math.ceil,Ct$4=Math.floor,Ft$4=function(t){var e=+t;return e!=e||0===e?0:(e>0?Ct$4:zt$4)(e)},Dt$4=Math.max,Ht$4=Math.min,Bt$4=function(t,e){var r=Ft$4(t);return r<0?Dt$4(r+e,0):Ht$4(r,e)},Gt$4=Math.min,$t$4=function(t){return t>0?Gt$4(Ft$4(t),9007199254740991):0},Vt$4=function(t){return $t$4(t.length)},Wt$4=function(t){return function(e,r,n){var o,i=_$4(e),u=Vt$4(i),a=Bt$4(n,u);if(t&&r!=r){for(;u>a;)if((o=i[a++])!=o)return !0}else for(;u>a;a++)if((t||a in i)&&i[a]===r)return t||a||0;return !t&&-1}},Ut$4={includes:Wt$4(!0),indexOf:Wt$4(!1)},Kt$4={},Yt$4=Ut$4.indexOf,Xt$4=O$4([].push),qt$4=function(t,e){var r,n=_$4(t),o=0,i=[];for(r in n)!B$4(Kt$4,r)&&B$4(n,r)&&Xt$4(i,r);for(;e.length>o;)B$4(n,r=e[o++])&&(~Yt$4(i,r)||Xt$4(i,r));return i},Jt$4=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],Qt$4=Object.keys||function(t){return qt$4(t,Jt$4)},Zt$4=dt$4?Object.defineProperties:function(t,e){vt$4(t);for(var r,n=_$4(e),o=Qt$4(e),i=o.length,u=0;i>u;)Mt$4.f(t,r=o[u++],n[r]);return t},te$4=Y$4("document","documentElement"),ee$4=C$4("keys"),re$4=function(t){return ee$4[t]||(ee$4[t]=W$4(t))},ne$4=re$4("IE_PROTO"),oe$4=function(){},ie$4=function(t){return "<script>"+t+"<\/script>"},ue$4=function(t){t.write(ie$4("")),t.close();var e=t.parentWindow.Object;return t=null,e},ae$4=function(){try{tt$4=new ActiveXObject("htmlfile");}catch(t){}var t,e;ae$4="undefined"!=typeof document?document.domain&&tt$4?ue$4(tt$4):((e=ht$4("iframe")).style.display="none",te$4.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write(ie$4("document.F=Object")),t.close(),t.F):ue$4(tt$4);for(var r=Jt$4.length;r--;)delete ae$4.prototype[Jt$4[r]];return ae$4()};Kt$4[ne$4]=!0;var ce$4=Object.create||function(t,e){var r;return null!==t?(oe$4.prototype=vt$4(t),r=new oe$4,oe$4.prototype=null,r[ne$4]=t):r=ae$4(),void 0===e?r:Zt$4(r,e)},fe$4=ct$4("unscopables"),le$4=Array.prototype;null==le$4[fe$4]&&Mt$4.f(le$4,fe$4,{configurable:!0,value:ce$4(null)});var se$4=function(t){le$4[fe$4][t]=!0;},ve$4={},de$4=O$4(Function.toString);U$4(z$4.inspectSource)||(z$4.inspectSource=function(t){return de$4(t)});var pe$4,ye$4,he$4,ge$4=z$4.inspectSource,be$4=b$2.WeakMap,me$4=U$4(be$4)&&/native code/.test(ge$4(be$4)),we$4=function(t,e){return {enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},xe$4=dt$4?function(t,e,r){return Mt$4.f(t,e,we$4(1,r))}:function(t,e,r){return t[e]=r,t},Se$4=b$2.TypeError,Oe$4=b$2.WeakMap;if(me$4||z$4.state){var Ee$4=z$4.state||(z$4.state=new Oe$4),Te$4=O$4(Ee$4.get),je$4=O$4(Ee$4.has),Ae$4=O$4(Ee$4.set);pe$4=function(t,e){if(je$4(Ee$4,t))throw new Se$4("Object already initialized");return e.facade=t,Ae$4(Ee$4,t,e),e},ye$4=function(t){return Te$4(Ee$4,t)||{}},he$4=function(t){return je$4(Ee$4,t)};}else {var Ie$4=re$4("state");Kt$4[Ie$4]=!0,pe$4=function(t,e){if(B$4(t,Ie$4))throw new Se$4("Object already initialized");return e.facade=t,xe$4(t,Ie$4,e),e},ye$4=function(t){return B$4(t,Ie$4)?t[Ie$4]:{}},he$4=function(t){return B$4(t,Ie$4)};}var Pe$4,Le$4,Re$4,ke$4={set:pe$4,get:ye$4,has:he$4,enforce:function(t){return he$4(t)?ye$4(t):pe$4(t,{})},getterFor:function(t){return function(e){var r;if(!ft$4(e)||(r=ye$4(e)).type!==t)throw Se$4("Incompatible receiver, "+t+" required");return r}}},_e$4={}.propertyIsEnumerable,Ne$4=Object.getOwnPropertyDescriptor,Me$4={f:Ne$4&&!_e$4.call({1:2},1)?function(t){var e=Ne$4(this,t);return !!e&&e.enumerable}:_e$4},ze$4=Object.getOwnPropertyDescriptor,Ce$4={f:dt$4?ze$4:function(t,e){if(t=_$4(t),e=kt$4(e),gt$4)try{return ze$4(t,e)}catch(t){}if(B$4(t,e))return we$4(!mt$4(Me$4.f,t,e),t[e])}},Fe$4=Function.prototype,De$4=dt$4&&Object.getOwnPropertyDescriptor,He$4=B$4(Fe$4,"name"),Be$4={EXISTS:He$4,PROPER:He$4&&"something"===function(){}.name,CONFIGURABLE:He$4&&(!dt$4||dt$4&&De$4(Fe$4,"name").configurable)},Ge$4=p$2((function(t){var e=Be$4.CONFIGURABLE,r=ke$4.get,n=ke$4.enforce,o=String(String).split("String");(t.exports=function(t,r,i,u){var a,c=!!u&&!!u.unsafe,f=!!u&&!!u.enumerable,l=!!u&&!!u.noTargetGet,s=u&&void 0!==u.name?u.name:r;U$4(i)&&("Symbol("===String(s).slice(0,7)&&(s="["+String(s).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!B$4(i,"name")||e&&i.name!==s)&&xe$4(i,"name",s),(a=n(i)).source||(a.source=o.join("string"==typeof s?s:""))),t!==b$2?(c?!l&&t[r]&&(f=!0):delete t[r],f?t[r]=i:xe$4(t,r,i)):f?t[r]=i:M$3(r,i);})(Function.prototype,"toString",(function(){return U$4(this)&&r(this).source||ge$4(this)}));})),$e$4=Jt$4.concat("length","prototype"),Ve$4={f:Object.getOwnPropertyNames||function(t){return qt$4(t,$e$4)}},We$4={f:Object.getOwnPropertySymbols},Ue$4=O$4([].concat),Ke$4=Y$4("Reflect","ownKeys")||function(t){var e=Ve$4.f(vt$4(t)),r=We$4.f;return r?Ue$4(e,r(t)):e},Ye$4=function(t,e){for(var r=Ke$4(e),n=Mt$4.f,o=Ce$4.f,i=0;i<r.length;i++){var u=r[i];B$4(t,u)||n(t,u,o(e,u));}},Xe$4=/#|\.prototype\./,qe$4=function(t,e){var r=Qe$4[Je$4(t)];return r==tr$3||r!=Ze$4&&(U$4(e)?E$3(e):!!e)},Je$4=qe$4.normalize=function(t){return String(t).replace(Xe$4,".").toLowerCase()},Qe$4=qe$4.data={},Ze$4=qe$4.NATIVE="N",tr$3=qe$4.POLYFILL="P",er$3=qe$4,rr$3=Ce$4.f,nr$3=function(t,e){var r,n,o,i,u,a=t.target,c=t.global,f=t.stat;if(r=c?b$2:f?b$2[a]||M$3(a,{}):(b$2[a]||{}).prototype)for(n in e){if(i=e[n],o=t.noTargetGet?(u=rr$3(r,n))&&u.value:r[n],!er$3(c?n:a+(f?".":"#")+n,t.forced)&&void 0!==o){if(typeof i==typeof o)continue;Ye$4(i,o);}(t.sham||o&&o.sham)&&xe$4(i,"sham",!0),Ge$4(r,n,i,t);}},or$3=!E$3((function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype})),ir$3=re$4("IE_PROTO"),ur$3=b$2.Object,ar$3=ur$3.prototype,cr$3=or$3?ur$3.getPrototypeOf:function(t){var e=D$4(t);if(B$4(e,ir$3))return e[ir$3];var r=e.constructor;return U$4(r)&&e instanceof r?r.prototype:e instanceof ur$3?ar$3:null},fr$3=ct$4("iterator"),lr$3=!1;[].keys&&("next"in(Re$4=[].keys())?(Le$4=cr$3(cr$3(Re$4)))!==Object.prototype&&(Pe$4=Le$4):lr$3=!0);var sr$3=null==Pe$4||E$3((function(){var t={};return Pe$4[fr$3].call(t)!==t}));sr$3&&(Pe$4={}),U$4(Pe$4[fr$3])||Ge$4(Pe$4,fr$3,(function(){return this}));var vr$3={IteratorPrototype:Pe$4,BUGGY_SAFARI_ITERATORS:lr$3},dr$3=Mt$4.f,pr$3=ct$4("toStringTag"),yr$3=function(t,e,r){t&&!B$4(t=r?t:t.prototype,pr$3)&&dr$3(t,pr$3,{configurable:!0,value:e});},hr$3=vr$3.IteratorPrototype,gr$3=function(){return this},br$3=b$2.String,mr$3=b$2.TypeError,wr$3=Object.setPrototypeOf||("__proto__"in{}?function(){var t,e=!1,r={};try{(t=O$4(Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set))(r,[]),e=r instanceof Array;}catch(t){}return function(r,n){return vt$4(r),function(t){if("object"==typeof t||U$4(t))return t;throw mr$3("Can't set "+br$3(t)+" as a prototype")}(n),e?t(r,n):r.__proto__=n,r}}():void 0),xr$3=Be$4.PROPER,Sr$3=Be$4.CONFIGURABLE,Or$3=vr$3.IteratorPrototype,Er$3=vr$3.BUGGY_SAFARI_ITERATORS,Tr$3=ct$4("iterator"),jr$3=function(){return this},Ar$3=function(t,e,r,n,o,i,u){!function(t,e,r,n){var o=e+" Iterator";t.prototype=ce$4(hr$3,{next:we$4(+!n,r)}),yr$3(t,o,!1),ve$4[o]=gr$3;}(r,e,n);var a,c,f,l=function(t){if(t===o&&y)return y;if(!Er$3&&t in d)return d[t];switch(t){case"keys":case"values":case"entries":return function(){return new r(this,t)}}return function(){return new r(this)}},s=e+" Iterator",v=!1,d=t.prototype,p=d[Tr$3]||d["@@iterator"]||o&&d[o],y=!Er$3&&p||l(o),h="Array"==e&&d.entries||p;if(h&&(a=cr$3(h.call(new t)))!==Object.prototype&&a.next&&(cr$3(a)!==Or$3&&(wr$3?wr$3(a,Or$3):U$4(a[Tr$3])||Ge$4(a,Tr$3,jr$3)),yr$3(a,s,!0)),xr$3&&"values"==o&&p&&"values"!==p.name&&(Sr$3?xe$4(d,"name","values"):(v=!0,y=function(){return mt$4(p,this)})),o)if(c={values:l("values"),keys:i?y:l("keys"),entries:l("entries")},u)for(f in c)(Er$3||v||!(f in d))&&Ge$4(d,f,c[f]);else nr$3({target:e,proto:!0,forced:Er$3||v},c);return d[Tr$3]!==y&&Ge$4(d,Tr$3,y,{name:o}),ve$4[e]=y,c},Ir$3=ke$4.set,Pr$3=ke$4.getterFor("Array Iterator"),Lr$3=Ar$3(Array,"Array",(function(t,e){Ir$3(this,{type:"Array Iterator",target:_$4(t),index:0,kind:e});}),(function(){var t=Pr$3(this),e=t.target,r=t.kind,n=t.index++;return !e||n>=e.length?(t.target=void 0,{value:void 0,done:!0}):"keys"==r?{value:n,done:!1}:"values"==r?{value:e[n],done:!1}:{value:[n,e[n]],done:!1}}),"values");ve$4.Arguments=ve$4.Array,se$4("keys"),se$4("values"),se$4("entries");var Rr$3={};Rr$3[ct$4("toStringTag")]="z";var kr$3="[object z]"===String(Rr$3),_r$3=ct$4("toStringTag"),Nr$3=b$2.Object,Mr$3="Arguments"==A$4(function(){return arguments}()),zr$3=kr$3?A$4:function(t){var e,r,n;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(r=function(t,e){try{return t[e]}catch(t){}}(e=Nr$3(t),_r$3))?r:Mr$3?A$4(e):"Object"==(n=A$4(e))&&U$4(e.callee)?"Arguments":n},Cr$3=kr$3?{}.toString:function(){return "[object "+zr$3(this)+"]"};kr$3||Ge$4(Object.prototype,"toString",Cr$3,{unsafe:!0});var Fr$3=b$2.String,Dr$3=function(t){if("Symbol"===zr$3(t))throw TypeError("Cannot convert a Symbol value to a string");return Fr$3(t)},Hr$3=O$4("".charAt),Br$3=O$4("".charCodeAt),Gr$3=O$4("".slice),$r$3=function(t){return function(e,r){var n,o,i=Dr$3(k$4(e)),u=Ft$4(r),a=i.length;return u<0||u>=a?t?"":void 0:(n=Br$3(i,u))<55296||n>56319||u+1===a||(o=Br$3(i,u+1))<56320||o>57343?t?Hr$3(i,u):n:t?Gr$3(i,u,u+2):o-56320+(n-55296<<10)+65536}},Vr$3={codeAt:$r$3(!1),charAt:$r$3(!0)},Wr$3=Vr$3.charAt,Ur$3=ke$4.set,Kr$3=ke$4.getterFor("String Iterator");Ar$3(String,"String",(function(t){Ur$3(this,{type:"String Iterator",string:Dr$3(t),index:0});}),(function(){var t,e=Kr$3(this),r=e.string,n=e.index;return n>=r.length?{value:void 0,done:!0}:(t=Wr$3(r,n),e.index+=t.length,{value:t,done:!1})}));var Yr$3=function(t,e,r){for(var n in e)Ge$4(t,n,e[n],r);return t},Xr$3=b$2.Array,qr$3=Math.max,Jr$3=Ve$4.f,Qr$3="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],Zr$3=function(t){try{return Jr$3(t)}catch(t){return function(t,e,r){for(var n,o,i,u,a=Vt$4(t),c=Bt$4(e,a),f=Bt$4(void 0===r?a:r,a),l=Xr$3(qr$3(f-c,0)),s=0;c<f;c++,s++)n=l,o=s,i=t[c],u=void 0,(u=kt$4(o))in n?Mt$4.f(n,u,we$4(0,i)):n[u]=i;return l.length=s,l}(Qr$3)}},tn$4={f:function(t){return Qr$3&&"Window"==A$4(t)?Zr$3(t):Jr$3(_$4(t))}},en$4=E$3((function(){if("function"==typeof ArrayBuffer){var t=new ArrayBuffer(8);Object.isExtensible(t)&&Object.defineProperty(t,"a",{value:8});}})),rn$4=Object.isExtensible,nn$4=E$3((function(){rn$4(1);}))||en$4?function(t){return !!ft$4(t)&&((!en$4||"ArrayBuffer"!=A$4(t))&&(!rn$4||rn$4(t)))}:rn$4,on$4=!E$3((function(){return Object.isExtensible(Object.preventExtensions({}))})),un$4=p$2((function(t){var e=Mt$4.f,r=!1,n=W$4("meta"),o=0,i=function(t){e(t,n,{value:{objectID:"O"+o++,weakData:{}}});},u=t.exports={enable:function(){u.enable=function(){},r=!0;var t=Ve$4.f,e=O$4([].splice),o={};o[n]=1,t(o).length&&(Ve$4.f=function(r){for(var o=t(r),i=0,u=o.length;i<u;i++)if(o[i]===n){e(o,i,1);break}return o},nr$3({target:"Object",stat:!0,forced:!0},{getOwnPropertyNames:tn$4.f}));},fastKey:function(t,e){if(!ft$4(t))return "symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!B$4(t,n)){if(!nn$4(t))return "F";if(!e)return "E";i(t);}return t[n].objectID},getWeakData:function(t,e){if(!B$4(t,n)){if(!nn$4(t))return !0;if(!e)return !1;i(t);}return t[n].weakData},onFreeze:function(t){return on$4&&r&&nn$4(t)&&!B$4(t,n)&&i(t),t}};Kt$4[n]=!0;})),an$4=O$4(O$4.bind),cn$4=function(t,e){return jt$4(t),void 0===e?t:an$4?an$4(t,e):function(){return t.apply(e,arguments)}},fn$4=ct$4("iterator"),ln$4=Array.prototype,sn$4=ct$4("iterator"),vn$4=function(t){if(null!=t)return At$4(t,sn$4)||At$4(t,"@@iterator")||ve$4[zr$3(t)]},dn$4=b$2.TypeError,pn$4=function(t,e,r){var n,o;vt$4(t);try{if(!(n=At$4(t,"return"))){if("throw"===e)throw r;return r}n=mt$4(n,t);}catch(t){o=!0,n=t;}if("throw"===e)throw r;if(o)throw n;return vt$4(n),r},yn$4=b$2.TypeError,hn$4=function(t,e){this.stopped=t,this.result=e;},gn$4=hn$4.prototype,bn$4=function(t,e,r){var n,o,i,u,a,c,f,l,s=r&&r.that,v=!(!r||!r.AS_ENTRIES),d=!(!r||!r.IS_ITERATOR),p=!(!r||!r.INTERRUPTED),y=cn$4(e,s),h=function(t){return n&&pn$4(n,"normal",t),new hn$4(!0,t)},g=function(t){return v?(vt$4(t),p?y(t[0],t[1],h):y(t[0],t[1])):p?y(t,h):y(t)};if(d)n=t;else {if(!(o=vn$4(t)))throw yn$4(Et$4(t)+" is not iterable");if(void 0!==(l=o)&&(ve$4.Array===l||ln$4[fn$4]===l)){for(i=0,u=Vt$4(t);u>i;i++)if((a=g(t[i]))&&wt$4(gn$4,a))return a;return new hn$4(!1)}n=function(t,e){var r=arguments.length<2?vn$4(t):e;if(jt$4(r))return vt$4(mt$4(r,t));throw dn$4(Et$4(t)+" is not iterable")}(t,o);}for(c=n.next;!(f=mt$4(c,n)).done;){try{a=g(f.value);}catch(t){pn$4(n,"throw",t);}if("object"==typeof a&&a&&wt$4(gn$4,a))return a}return new hn$4(!1)},mn$4=b$2.TypeError,wn$4=function(t,e){if(wt$4(e,t))return t;throw mn$4("Incorrect invocation")},xn$4=ct$4("iterator"),Sn$4=!1;try{var On$4=0,En$4={next:function(){return {done:!!On$4++}},return:function(){Sn$4=!0;}};En$4[xn$4]=function(){return this},Array.from(En$4,(function(){throw 2}));}catch(t){}var Tn$4=Array.isArray||function(t){return "Array"==A$4(t)},jn$4=function(){},An$4=[],In$4=Y$4("Reflect","construct"),Pn$4=/^\s*(?:class|function)\b/,Ln$4=O$4(Pn$4.exec),Rn$4=!Pn$4.exec(jn$4),kn$4=function(t){if(!U$4(t))return !1;try{return In$4(jn$4,An$4,t),!0}catch(t){return !1}},_n$4=!In$4||E$3((function(){var t;return kn$4(kn$4.call)||!kn$4(Object)||!kn$4((function(){t=!0;}))||t}))?function(t){if(!U$4(t))return !1;switch(zr$3(t)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return !1}return Rn$4||!!Ln$4(Pn$4,ge$4(t))}:kn$4,Nn$4=ct$4("species"),Mn$4=b$2.Array,zn$4=function(t,e){return new(function(t){var e;return Tn$4(t)&&(e=t.constructor,(_n$4(e)&&(e===Mn$4||Tn$4(e.prototype))||ft$4(e)&&null===(e=e[Nn$4]))&&(e=void 0)),void 0===e?Mn$4:e}(t))(0===e?0:e)},Cn$4=O$4([].push),Fn$4=function(t){var e=1==t,r=2==t,n=3==t,o=4==t,i=6==t,u=7==t,a=5==t||i;return function(c,f,l,s){for(var v,d,p=D$4(c),y=L$4(p),h=cn$4(f,l),g=Vt$4(y),b=0,m=s||zn$4,w=e?m(c,g):r||u?m(c,0):void 0;g>b;b++)if((a||b in y)&&(d=h(v=y[b],b,p),t))if(e)w[b]=d;else if(d)switch(t){case 3:return !0;case 5:return v;case 6:return b;case 2:Cn$4(w,v);}else switch(t){case 4:return !1;case 7:Cn$4(w,v);}return i?-1:n||o?o:w}},Dn$4={forEach:Fn$4(0),map:Fn$4(1),filter:Fn$4(2),some:Fn$4(3),every:Fn$4(4),find:Fn$4(5),findIndex:Fn$4(6),filterReject:Fn$4(7)},Hn$4=un$4.getWeakData,Bn$4=ke$4.set,Gn$4=ke$4.getterFor,$n$4=Dn$4.find,Vn$4=Dn$4.findIndex,Wn$4=O$4([].splice),Un$4=0,Kn$4=function(t){return t.frozen||(t.frozen=new Yn$4)},Yn$4=function(){this.entries=[];},Xn$4=function(t,e){return $n$4(t.entries,(function(t){return t[0]===e}))};Yn$4.prototype={get:function(t){var e=Xn$4(this,t);if(e)return e[1]},has:function(t){return !!Xn$4(this,t)},set:function(t,e){var r=Xn$4(this,t);r?r[1]=e:this.entries.push([t,e]);},delete:function(t){var e=Vn$4(this.entries,(function(e){return e[0]===t}));return ~e&&Wn$4(this.entries,e,1),!!~e}};var qn$4,Jn$4={getConstructor:function(t,e,r,n){var o=t((function(t,o){wn$4(t,i),Bn$4(t,{type:e,id:Un$4++,frozen:void 0}),null!=o&&bn$4(o,t[n],{that:t,AS_ENTRIES:r});})),i=o.prototype,u=Gn$4(e),a=function(t,e,r){var n=u(t),o=Hn$4(vt$4(e),!0);return !0===o?Kn$4(n).set(e,r):o[n.id]=r,t};return Yr$3(i,{delete:function(t){var e=u(this);if(!ft$4(t))return !1;var r=Hn$4(t);return !0===r?Kn$4(e).delete(t):r&&B$4(r,e.id)&&delete r[e.id]},has:function(t){var e=u(this);if(!ft$4(t))return !1;var r=Hn$4(t);return !0===r?Kn$4(e).has(t):r&&B$4(r,e.id)}}),Yr$3(i,r?{get:function(t){var e=u(this);if(ft$4(t)){var r=Hn$4(t);return !0===r?Kn$4(e).get(t):r?r[e.id]:void 0}},set:function(t,e){return a(this,t,e)}}:{add:function(t){return a(this,t,!0)}}),o}},Qn$4=ke$4.enforce,Zn$4=!b$2.ActiveXObject&&"ActiveXObject"in b$2,to$3=function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}},eo$3=function(t,e,r){var n=-1!==t.indexOf("Map"),o=-1!==t.indexOf("Weak"),i=n?"set":"add",u=b$2[t],a=u&&u.prototype,c=u,f={},l=function(t){var e=O$4(a[t]);Ge$4(a,t,"add"==t?function(t){return e(this,0===t?0:t),this}:"delete"==t?function(t){return !(o&&!ft$4(t))&&e(this,0===t?0:t)}:"get"==t?function(t){return o&&!ft$4(t)?void 0:e(this,0===t?0:t)}:"has"==t?function(t){return !(o&&!ft$4(t))&&e(this,0===t?0:t)}:function(t,r){return e(this,0===t?0:t,r),this});};if(er$3(t,!U$4(u)||!(o||a.forEach&&!E$3((function(){(new u).entries().next();})))))c=r.getConstructor(e,t,n,i),un$4.enable();else if(er$3(t,!0)){var s=new c,v=s[i](o?{}:-0,1)!=s,d=E$3((function(){s.has(1);})),p=function(t,e){if(!e&&!Sn$4)return !1;var r=!1;try{var n={};n[xn$4]=function(){return {next:function(){return {done:r=!0}}}},t(n);}catch(t){}return r}((function(t){new u(t);})),y=!o&&E$3((function(){for(var t=new u,e=5;e--;)t[i](e,e);return !t.has(-0)}));p||((c=e((function(t,e){wn$4(t,a);var r=function(t,e,r){var n,o;return wr$3&&U$4(n=e.constructor)&&n!==r&&ft$4(o=n.prototype)&&o!==r.prototype&&wr$3(t,o),t}(new u,t,c);return null!=e&&bn$4(e,r[i],{that:r,AS_ENTRIES:n}),r}))).prototype=a,a.constructor=c),(d||y)&&(l("delete"),l("has"),n&&l("get")),(y||v)&&l(i),o&&a.clear&&delete a.clear;}return f[t]=c,nr$3({global:!0,forced:c!=u},f),yr$3(c,t),o||r.setStrong(c,t,n),c}("WeakMap",to$3,Jn$4);if(me$4&&Zn$4){qn$4=Jn$4.getConstructor(to$3,"WeakMap",!0),un$4.enable();var ro$3=eo$3.prototype,no$3=O$4(ro$3.delete),oo$3=O$4(ro$3.has),io$3=O$4(ro$3.get),uo$3=O$4(ro$3.set);Yr$3(ro$3,{delete:function(t){if(ft$4(t)&&!nn$4(t)){var e=Qn$4(this);return e.frozen||(e.frozen=new qn$4),no$3(this,t)||e.frozen.delete(t)}return no$3(this,t)},has:function(t){if(ft$4(t)&&!nn$4(t)){var e=Qn$4(this);return e.frozen||(e.frozen=new qn$4),oo$3(this,t)||e.frozen.has(t)}return oo$3(this,t)},get:function(t){if(ft$4(t)&&!nn$4(t)){var e=Qn$4(this);return e.frozen||(e.frozen=new qn$4),oo$3(this,t)?io$3(this,t):e.frozen.get(t)}return io$3(this,t)},set:function(t,e){if(ft$4(t)&&!nn$4(t)){var r=Qn$4(this);r.frozen||(r.frozen=new qn$4),oo$3(this,t)?uo$3(this,t,e):r.frozen.set(t,e);}else uo$3(this,t,e);return this}});}var ao$3={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},co$3=ht$4("span").classList,fo$3=co$3&&co$3.constructor&&co$3.constructor.prototype,lo$3=fo$3===Object.prototype?void 0:fo$3,so$3=ct$4("iterator"),vo$3=ct$4("toStringTag"),po$3=Lr$3.values,yo$3=function(t,e){if(t){if(t[so$3]!==po$3)try{xe$4(t,so$3,po$3);}catch(e){t[so$3]=po$3;}if(t[vo$3]||xe$4(t,vo$3,e),ao$3[e])for(var r in Lr$3)if(t[r]!==Lr$3[r])try{xe$4(t,r,Lr$3[r]);}catch(e){t[r]=Lr$3[r];}}};for(var ho$3 in ao$3)yo$3(b$2[ho$3]&&b$2[ho$3].prototype,ho$3);yo$3(lo$3,"DOMTokenList");var go$3=new WeakMap;var bo$3={type:"list-item",renderElem:function(t,r,u){go$3.set(t,u);var a=t,f=a.level,l=void 0===f?0:f,s=a.ordered,v={margin:"5px 0 5px "+20*l+"px"},d="";if(void 0!==s&&s){var p=function(t,r){var i=r,u=i.type,a=i.level,c=void 0===a?0:a,f=i.ordered,l=void 0!==f&&f;if(!l)return -1;var s=1,v=r,d=ol$1.findPath(t,v);if(0===d[0])return 1;for(;d[0]>0;){var p=Path.previous(d),y=Editor.node(t,p);if(null==y)break;var h=y[0],g=h.level,b=void 0===g?0:g,m=h.type,w=h.ordered;if(m!==u)break;if(b<c)break;if(b===c){if(w!==l)break;s++;}v=h,d=p;}return s}(u,t);d=p+".";}else d=function(t){void 0===t&&(t=0);var e="";switch(t){case 0:e="•";break;case 1:e="◦";break;default:e="▪";}return e}(l);var y=function(t){var e,r=t.children||[],n=r.length;if(0===n)return "";for(var o=0;o<n&&!e;o++){var u=r[o];Text.isText(u)&&(e=u);}return null==e?"":e.color||""}(t);return jsx("div",{style:v},jsx("span",{contentEditable:!1,style:{marginRight:"0.5em",color:y},"data-w-e-reserve":!0},d),jsx("span",null,r))}},mo$3=function(t,e){return mo$3=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e;}||function(t,e){for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r]);},mo$3(t,e)};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */function wo$3(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Class extends value "+String(e)+" is not a constructor or null");function r(){this.constructor=t;}mo$3(t,e),t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r);}function xo$3(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return {next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")}function So$3(t,e){var r="function"==typeof Symbol&&t[Symbol.iterator];if(!r)return t;var n,o,i=r.call(t),u=[];try{for(;(void 0===e||e-- >0)&&!(n=i.next()).done;)u.push(n.value);}catch(t){o={error:t};}finally{try{n&&!n.done&&(r=i.return)&&r.call(i);}finally{if(o)throw o.error}}return u}function Oo$3(t){return Editor.nodes(t,{at:t.selection||void 0,match:function(r){return 1===ol$1.findPath(t,r).length}})}var Eo$3=Ut$4.includes;nr$3({target:"Array",proto:!0},{includes:function(t){return Eo$3(this,t,arguments.length>1?arguments[1]:void 0)}}),se$4("includes");var To$3,jo$3,Ao$3=function(){var t=vt$4(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.dotAll&&(e+="s"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e},Io$3=b$2.RegExp,Po$3=E$3((function(){var t=Io$3("a","y");return t.lastIndex=2,null!=t.exec("abcd")})),Lo$3=Po$3||E$3((function(){return !Io$3("a","y").sticky})),Ro$3={BROKEN_CARET:Po$3||E$3((function(){var t=Io$3("^r","gy");return t.lastIndex=2,null!=t.exec("str")})),MISSED_STICKY:Lo$3,UNSUPPORTED_Y:Po$3},ko$3=b$2.RegExp,_o$3=E$3((function(){var t=ko$3(".","s");return !(t.dotAll&&t.exec("\n")&&"s"===t.flags)})),No$3=b$2.RegExp,Mo$3=E$3((function(){var t=No$3("(?<a>b)","g");return "b"!==t.exec("b").groups.a||"bc"!=="b".replace(t,"$<a>c")})),zo$3=ke$4.get,Co$3=C$4("native-string-replace",String.prototype.replace),Fo$3=RegExp.prototype.exec,Do$3=Fo$3,Ho$3=O$4("".charAt),Bo$3=O$4("".indexOf),Go$3=O$4("".replace),$o$3=O$4("".slice),Vo$3=(jo$3=/b*/g,mt$4(Fo$3,To$3=/a/,"a"),mt$4(Fo$3,jo$3,"a"),0!==To$3.lastIndex||0!==jo$3.lastIndex),Wo$3=Ro$3.BROKEN_CARET,Uo$3=void 0!==/()??/.exec("")[1];(Vo$3||Uo$3||Wo$3||_o$3||Mo$3)&&(Do$3=function(t){var e,r,n,o,i,u,a,c=this,f=zo$3(c),l=Dr$3(t),s=f.raw;if(s)return s.lastIndex=c.lastIndex,e=mt$4(Do$3,s,l),c.lastIndex=s.lastIndex,e;var v=f.groups,d=Wo$3&&c.sticky,p=mt$4(Ao$3,c),y=c.source,h=0,g=l;if(d&&(p=Go$3(p,"y",""),-1===Bo$3(p,"g")&&(p+="g"),g=$o$3(l,c.lastIndex),c.lastIndex>0&&(!c.multiline||c.multiline&&"\n"!==Ho$3(l,c.lastIndex-1))&&(y="(?: "+y+")",g=" "+g,h++),r=new RegExp("^(?:"+y+")",p)),Uo$3&&(r=new RegExp("^"+y+"$(?!\\s)",p)),Vo$3&&(n=c.lastIndex),o=mt$4(Fo$3,d?r:c,g),d?o?(o.input=$o$3(o.input,h),o[0]=$o$3(o[0],h),o.index=c.lastIndex,c.lastIndex+=o[0].length):c.lastIndex=0:Vo$3&&o&&(c.lastIndex=c.global?o.index+o[0].length:n),Uo$3&&o&&o.length>1&&mt$4(Co$3,o[0],r,(function(){for(i=1;i<arguments.length-2;i++)void 0===arguments[i]&&(o[i]=void 0);})),o&&v)for(o.groups=u=ce$4(null),i=0;i<v.length;i++)u[(a=v[i])[0]]=o[a[1]];return o});var Ko$3=Do$3;nr$3({target:"RegExp",proto:!0,forced:/./.exec!==Ko$3},{exec:Ko$3});var Yo$3=function(){function t(){this.type="list-item",this.tag="button";}return t.prototype.getListNode=function(t){var r=this.type;return ol$1.getSelectedNodeByType(t,r)},t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){var e=this.getListNode(t);if(null==e)return !1;var r=e.ordered;return (void 0!==r&&r)===this.ordered},t.prototype.isDisabled=function(t){return null==t.selection||!!ol$1.getSelectedElems(t).some((function(e){if(Editor.isVoid(t,e)&&Editor.isBlock(t,e))return !0;var r=e.type;return !!["pre","code","table"].includes(r)||void 0}))},t.prototype.exec=function(t,e){this.isActive(t)?Transforms.setNodes(t,{type:"paragraph",ordered:void 0,level:void 0}):Transforms.setNodes(t,{type:"list-item",ordered:this.ordered,indent:void 0});},t}(),Xo$3='<svg viewBox="0 0 1024 1024"><path d="M384 64h640v128H384V64z m0 384h640v128H384v-128z m0 384h640v128H384v-128zM0 128a128 128 0 1 1 256 0 128 128 0 0 1-256 0z m0 384a128 128 0 1 1 256 0 128 128 0 0 1-256 0z m0 384a128 128 0 1 1 256 0 128 128 0 0 1-256 0z"></path></svg>',qo$3='<svg viewBox="0 0 1024 1024"><path d="M384 832h640v128H384z m0-384h640v128H384z m0-384h640v128H384zM192 0v256H128V64H64V0zM128 526.016v50.016h128v64H64v-146.016l128-60V384H64v-64h192v146.016zM256 704v320H64v-64h128v-64H64v-64h128v-64H64v-64z"></path></svg>',Jo$3=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.ordered=!1,e.title=cp$1("listModule.unOrderedList"),e.iconSvg=Xo$3,e}return wo$3(e,t),e}(Yo$3),Qo$3=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.ordered=!0,e.title=cp$1("listModule.orderedList"),e.iconSvg=qo$3,e}return wo$3(e,t),e}(Yo$3),Zo$3={key:"bulletedList",factory:function(){return new Jo$3}},ti$3={key:"numberedList",factory:function(){return new Qo$3}};var ei$3=[];var ri$3,ni$3={type:"list-item",elemToHtml:function(t,r){var i="",u="",a=t.ordered,c=void 0!==a&&a?"ol":"ul",f=function(t){var r=go$3.get(t);if(null==r)return 0;var i=t,u=i.type,a=i.ordered,c=void 0!==a&&a,f=i.level,l=void 0===f?0:f,s=ol$1.findPath(r,t);if(0===s[0])return l+1;var v=Path.previous(s),d=Editor.node(r,v);if(!d)return 0;var p=So$3(d,1)[0];if(ol$1.getNodeType(p)!==u)return l+1;var y=p,h=y.ordered,g=void 0!==h&&h,b=y.level,m=void 0===b?0:b;return m<l?l-m:m>l?0:m===l?g===c?0:1:0}(t);if(f>0)for(var l=0;l<f;l++)i+="<"+c+">",ei$3.push(c);var s=function(t){var r=go$3.get(t);if(null==r)return 0;var i=t,u=i.type,a=i.ordered,c=void 0!==a&&a,f=i.level,l=void 0===f?0:f,s=ol$1.findPath(r,t);if(s[0]===r.children.length-1)return l+1;var v=Path.next(s),d=Editor.node(r,v);if(!d)return 0;var p=So$3(d,1)[0];if(ol$1.getNodeType(p)!==u)return l+1;var y=p,h=y.ordered,g=void 0!==h&&h,b=y.level,m=void 0===b?0:b;return m<l?l-m:m>l?0:m===l?g===c?0:1:0}(t);if(s>0)for(l=0;l<s;l++){u+="</"+ei$3.pop()+">";}return {html:"<li>"+r+"</li>",prefix:i,suffix:u}}},oi$3=ct$4("species"),ii$3=Dn$4.filter,ui$3=(ri$3="filter",et$4>=51||!E$3((function(){var t=[];return (t.constructor={})[oi$3]=function(){return {foo:1}},1!==t[ri$3](Boolean).foo})));nr$3({target:"Array",proto:!0,forced:!ui$3},{filter:function(t){return ii$3(this,t,arguments.length>1?arguments[1]:void 0)}});var ai$3=Function.prototype,ci$3=ai$3.apply,fi$3=ai$3.bind,li$3=ai$3.call,si$3="object"==typeof Reflect&&Reflect.apply||(fi$3?li$3.bind(ci$3):function(){return li$3.apply(ci$3,arguments)}),vi$3=ct$4("species"),di$3=RegExp.prototype,pi$3=Vr$3.charAt,yi$3=function(t,e,r){return e+(r?pi$3(t,e).length:1)},hi$3=Math.floor,gi$3=O$4("".charAt),bi$2=O$4("".replace),mi$2=O$4("".slice),wi$2=/\$([$&'`]|\d{1,2}|<[^>]*>)/g,xi$2=/\$([$&'`]|\d{1,2})/g,Si$2=function(t,e,r,n,o,i){var u=r+t.length,a=n.length,c=xi$2;return void 0!==o&&(o=D$4(o),c=wi$2),bi$2(i,c,(function(i,c){var f;switch(gi$3(c,0)){case"$":return "$";case"&":return t;case"`":return mi$2(e,0,r);case"'":return mi$2(e,u);case"<":f=o[mi$2(c,1,-1)];break;default:var l=+c;if(0===l)return i;if(l>a){var s=hi$3(l/10);return 0===s?i:s<=a?void 0===n[s-1]?gi$3(c,1):n[s-1]+gi$3(c,1):i}f=n[l-1];}return void 0===f?"":f}))},Oi$2=b$2.TypeError,Ei$2=function(t,e){var r=t.exec;if(U$4(r)){var n=mt$4(r,t,e);return null!==n&&vt$4(n),n}if("RegExp"===A$4(t))return mt$4(Ko$3,t,e);throw Oi$2("RegExp#exec called on incompatible receiver")},Ti$2=ct$4("replace"),ji$2=Math.max,Ai$2=Math.min,Ii$2=O$4([].concat),Pi$2=O$4([].push),Li$2=O$4("".indexOf),Ri$2=O$4("".slice),ki$2="$0"==="a".replace(/./,"$0"),_i$2=!!/./[Ti$2]&&""===/./[Ti$2]("a","$0");!function(t,e,r,n){var o=ct$4(t),i=!E$3((function(){var e={};return e[o]=function(){return 7},7!=""[t](e)})),u=i&&!E$3((function(){var e=!1,r=/a/;return "split"===t&&((r={}).constructor={},r.constructor[vi$3]=function(){return r},r.flags="",r[o]=/./[o]),r.exec=function(){return e=!0,null},r[o](""),!e}));if(!i||!u||r){var a=O$4(/./[o]),c=e(o,""[t],(function(t,e,r,n,o){var u=O$4(t),c=e.exec;return c===Ko$3||c===di$3.exec?i&&!o?{done:!0,value:a(e,r,n)}:{done:!0,value:u(r,e,n)}:{done:!1}}));Ge$4(String.prototype,t,c[0]),Ge$4(di$3,o,c[1]);}n&&xe$4(di$3[o],"sham",!0);}("replace",(function(t,e,r){var n=_i$2?"$":"$0";return [function(t,r){var n=k$4(this),o=null==t?void 0:At$4(t,Ti$2);return o?mt$4(o,t,n,r):mt$4(e,Dr$3(n),t,r)},function(t,o){var i=vt$4(this),u=Dr$3(t);if("string"==typeof o&&-1===Li$2(o,n)&&-1===Li$2(o,"$<")){var a=r(e,i,u,o);if(a.done)return a.value}var c=U$4(o);c||(o=Dr$3(o));var f=i.global;if(f){var l=i.unicode;i.lastIndex=0;}for(var s=[];;){var v=Ei$2(i,u);if(null===v)break;if(Pi$2(s,v),!f)break;""===Dr$3(v[0])&&(i.lastIndex=yi$3(u,$t$4(i.lastIndex),l));}for(var d,p="",y=0,h=0;h<s.length;h++){for(var g=Dr$3((v=s[h])[0]),b=ji$2(Ai$2(Ft$4(v.index),u.length),0),m=[],w=1;w<v.length;w++)Pi$2(m,void 0===(d=v[w])?d:String(d));var x=v.groups;if(c){var S=Ii$2([g],m,b,u);void 0!==x&&Pi$2(S,x);var O=Dr$3(si$3(o,void 0,S));}else O=Si$2(g,u,b,m,x,o);b>=y&&(p+=Ri$2(u,y,b)+O,y=b+g.length);}return p+Ri$2(u,y)}]}),!!E$3((function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")}))||!ki$2||_i$2);var Ni$2=b$2.TypeError,Mi$2=function(t,e,r,n,o,i,u,a){for(var c,f,l=o,s=0,v=!!u&&cn$4(u,a);s<n;){if(s in r){if(c=v?v(r[s],s,e):r[s],i>0&&Tn$4(c))f=Vt$4(c),l=Mi$2(t,e,c,f,l,i-1)-1;else {if(l>=9007199254740991)throw Ni$2("Exceed the acceptable array length");t[l]=c;}l++;}s++;}return l},zi$2=Mi$2;function Ci$2(t){return t.length?t[0].tagName.toLowerCase():""}nr$3({target:"Array",proto:!0},{flat:function(){var t=arguments.length?arguments[0]:void 0,e=D$4(this),r=Vt$4(e),n=zn$4(e,0);return n.length=zi$2(n,e,e,r,0,void 0===t?1:Ft$4(t)),n}}),se$4("flat"),nr$3({global:!0},{globalThis:b$2}),append&&($$6.fn.append=append),attr&&($$6.fn.attr=attr),parent&&($$6.fn.parent=parent);var Fi$2={renderElems:[bo$3],editorPlugin:function(t){var r=t.deleteBackward,n=t.handleTab,o=t.normalizeNode,i=t;return i.deleteBackward=function(t){var n=i.selection;if(null!=n)if(Range.isExpanded(n))r(t);else {var o=ol$1.getSelectedNodeByType(i,"list-item");if(null!=o)if(0!==n.focus.offset)r(t);else {var c=o.level,f=void 0===c?0:c;f>0?Transforms.setNodes(i,{level:f-1}):Transforms.setNodes(i,{type:"paragraph",ordered:void 0,level:void 0});}else r(t);}else r(t);},i.handleTab=function(){var t,r,o,c,f=i.selection;if(null!=f){if(Range.isCollapsed(f)){var l=ol$1.getSelectedNodeByType(i,"list-item");if(null==l)return void n();if(0===f.focus.offset){var s=l.level,v=void 0===s?0:s;return void Transforms.setNodes(i,{level:v+1})}}if(Range.isExpanded(f)){var d=0,p=!1;try{for(var y=xo$3(Oo$3(i)),h=y.next();!h.done;h=y.next()){var g=So$3(h.value,1)[0];"list-item"===ol$1.getNodeType(g)?d++:p=!0;}}catch(e){t={error:e};}finally{try{h&&!h.done&&(r=y.return)&&r.call(y);}finally{if(t)throw t.error}}if(p||d<=1)return void n();try{for(var b=xo$3(Oo$3(i)),m=b.next();!m.done;m=b.next()){var w=So$3(m.value,2),x=(g=w[0],w[1]),S=g.level;v=void 0===S?0:S;Transforms.setNodes(i,{level:v+1},{at:x});}}catch(t){o={error:t};}finally{try{m&&!m.done&&(c=b.return)&&c.call(b);}finally{if(o)throw o.error}}}else n();}else n();},i.normalizeNode=function(t){var r=So$3(t,2),n=r[0],u=r[1],c=ol$1.getNodeType(n);return "bulleted-list"!==c&&"numbered-list"!==c||Transforms.unwrapNodes(i,{at:u}),o([n,u])},i},menus:[Zo$3,ti$3],elemsToHtml:[ni$3],parseElemsHtml:[{selector:"ul:not([data-w-e-type]),ol:not([data-w-e-type])",parseElemHtml:function(t,e,r){return e.flat(1/0)}},{selector:"li:not([data-w-e-type])",parseElemHtml:function(t,e,r){var n=$$6(t);0===(e=e.filter((function(t){return !!Text.isText(t)||!!r.isInline(t)}))).length&&(e=[{text:n.text().replace(/\s+/gm," ")}]);var o=function(t){return "ol"===Ci$2(t.parent())}(n),u=function(t){for(var e=0,r=t.parent(),n=Ci$2(r);"ul"===n||"ol"===n;)n=Ci$2(r=r.parent()),e++;return e-1}(n);return {type:"list-item",ordered:o,level:u,children:e}}}]};

/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

var lodash_isequal = createCommonjsModule(function (module, exports) {
/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;
});

sp$1("en",{tableModule:{deleteCol:"Delete column",deleteRow:"Delete row",deleteTable:"Delete table",widthAuto:"Width auto",insertCol:"Insert column",insertRow:"Insert row",insertTable:"Insert table",header:"Header"}}),sp$1("zh-CN",{tableModule:{deleteCol:"删除列",deleteRow:"删除行",deleteTable:"删除表格",widthAuto:"宽度自适应",insertCol:"插入列",insertRow:"插入行",insertTable:"插入表格",header:"表头"}});var O$3="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function H$3(t){var e={exports:{}};return t(e,e.exports),e.exports}var P$3,V$3,z$3=function(t){return t&&t.Math==Math&&t},L$3=z$3("object"==typeof globalThis&&globalThis)||z$3("object"==typeof window&&window)||z$3("object"==typeof self&&self)||z$3("object"==typeof O$3&&O$3)||function(){return this}()||Function("return this")(),R$3=function(t){try{return !!t()}catch(t){return !0}},A$3=!R$3((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),C$3=Function.prototype.call,I$3=C$3.bind?C$3.bind(C$3):function(){return C$3.apply(C$3,arguments)},j$3={}.propertyIsEnumerable,D$3=Object.getOwnPropertyDescriptor,k$3={f:D$3&&!j$3.call({1:2},1)?function(t){var e=D$3(this,t);return !!e&&e.enumerable}:j$3},B$3=function(t,e){return {enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},F$3=Function.prototype,$$3=F$3.bind,_$3=F$3.call,G$3=$$3&&$$3.bind(_$3),q$3=$$3?function(t){return t&&G$3(_$3,t)}:function(t){return t&&function(){return _$3.apply(t,arguments)}},U$3=q$3({}.toString),W$3=q$3("".slice),X$3=function(t){return W$3(U$3(t),8,-1)},Y$3=L$3.Object,K$3=q$3("".split),J$3=R$3((function(){return !Y$3("z").propertyIsEnumerable(0)}))?function(t){return "String"==X$3(t)?K$3(t,""):Y$3(t)}:Y$3,Q$3=L$3.TypeError,Z$3=function(t){if(null==t)throw Q$3("Can't call method on "+t);return t},tt$3=function(t){return J$3(Z$3(t))},et$3=function(t){return "function"==typeof t},nt$3=function(t){return "object"==typeof t?null!==t:et$3(t)},rt$3=function(t){return et$3(t)?t:void 0},ot$3=function(t,e){return arguments.length<2?rt$3(L$3[t]):L$3[t]&&L$3[t][e]},it$3=q$3({}.isPrototypeOf),at$3=ot$3("navigator","userAgent")||"",lt$3=L$3.process,ut$3=L$3.Deno,ct$3=lt$3&&lt$3.versions||ut$3&&ut$3.version,st$3=ct$3&&ct$3.v8;st$3&&(V$3=(P$3=st$3.split("."))[0]>0&&P$3[0]<4?1:+(P$3[0]+P$3[1])),!V$3&&at$3&&(!(P$3=at$3.match(/Edge\/(\d+)/))||P$3[1]>=74)&&(P$3=at$3.match(/Chrome\/(\d+)/))&&(V$3=+P$3[1]);var ft$3=V$3,dt$3=!!Object.getOwnPropertySymbols&&!R$3((function(){var t=Symbol();return !String(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&ft$3&&ft$3<41})),pt$3=dt$3&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,vt$3=L$3.Object,ht$3=pt$3?function(t){return "symbol"==typeof t}:function(t){var e=ot$3("Symbol");return et$3(e)&&it$3(e.prototype,vt$3(t))},gt$3=L$3.String,yt$3=function(t){try{return gt$3(t)}catch(t){return "Object"}},bt$3=L$3.TypeError,mt$3=function(t){if(et$3(t))return t;throw bt$3(yt$3(t)+" is not a function")},wt$3=function(t,e){var n=t[e];return null==n?void 0:mt$3(n)},St$3=L$3.TypeError,xt$3=Object.defineProperty,Tt$3=function(t,e){try{xt$3(L$3,t,{value:e,configurable:!0,writable:!0});}catch(n){L$3[t]=e;}return e},Et$3=L$3["__core-js_shared__"]||Tt$3("__core-js_shared__",{}),Nt$3=H$3((function(t){(t.exports=function(t,e){return Et$3[t]||(Et$3[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.19.3",mode:"global",copyright:"© 2021 Denis Pushkarev (zloirock.ru)"});})),Mt$3=L$3.Object,Ot$3=function(t){return Mt$3(Z$3(t))},Ht$3=q$3({}.hasOwnProperty),Pt$3=Object.hasOwn||function(t,e){return Ht$3(Ot$3(t),e)},Vt$3=0,zt$3=Math.random(),Lt$3=q$3(1..toString),Rt$3=function(t){return "Symbol("+(void 0===t?"":t)+")_"+Lt$3(++Vt$3+zt$3,36)},At$3=Nt$3("wks"),Ct$3=L$3.Symbol,It$3=Ct$3&&Ct$3.for,jt$3=pt$3?Ct$3:Ct$3&&Ct$3.withoutSetter||Rt$3,Dt$3=function(t){if(!Pt$3(At$3,t)||!dt$3&&"string"!=typeof At$3[t]){var e="Symbol."+t;dt$3&&Pt$3(Ct$3,t)?At$3[t]=Ct$3[t]:At$3[t]=pt$3&&It$3?It$3(e):jt$3(e);}return At$3[t]},kt$3=L$3.TypeError,Bt$3=Dt$3("toPrimitive"),Ft$3=function(t,e){if(!nt$3(t)||ht$3(t))return t;var n,r=wt$3(t,Bt$3);if(r){if(void 0===e&&(e="default"),n=I$3(r,t,e),!nt$3(n)||ht$3(n))return n;throw kt$3("Can't convert object to primitive value")}return void 0===e&&(e="number"),function(t,e){var n,r;if("string"===e&&et$3(n=t.toString)&&!nt$3(r=I$3(n,t)))return r;if(et$3(n=t.valueOf)&&!nt$3(r=I$3(n,t)))return r;if("string"!==e&&et$3(n=t.toString)&&!nt$3(r=I$3(n,t)))return r;throw St$3("Can't convert object to primitive value")}(t,e)},$t$3=function(t){var e=Ft$3(t,"string");return ht$3(e)?e:e+""},_t$3=L$3.document,Gt$3=nt$3(_t$3)&&nt$3(_t$3.createElement),qt$3=function(t){return Gt$3?_t$3.createElement(t):{}},Ut$3=!A$3&&!R$3((function(){return 7!=Object.defineProperty(qt$3("div"),"a",{get:function(){return 7}}).a})),Wt$3=Object.getOwnPropertyDescriptor,Xt$3={f:A$3?Wt$3:function(t,e){if(t=tt$3(t),e=$t$3(e),Ut$3)try{return Wt$3(t,e)}catch(t){}if(Pt$3(t,e))return B$3(!I$3(k$3.f,t,e),t[e])}},Yt$3=L$3.String,Kt$3=L$3.TypeError,Jt$3=function(t){if(nt$3(t))return t;throw Kt$3(Yt$3(t)+" is not an object")},Qt$3=L$3.TypeError,Zt$3=Object.defineProperty,te$3={f:A$3?Zt$3:function(t,e,n){if(Jt$3(t),e=$t$3(e),Jt$3(n),Ut$3)try{return Zt$3(t,e,n)}catch(t){}if("get"in n||"set"in n)throw Qt$3("Accessors not supported");return "value"in n&&(t[e]=n.value),t}},ee$3=A$3?function(t,e,n){return te$3.f(t,e,B$3(1,n))}:function(t,e,n){return t[e]=n,t},ne$3=q$3(Function.toString);et$3(Et$3.inspectSource)||(Et$3.inspectSource=function(t){return ne$3(t)});var re$3,oe$3,ie$3,ae$3=Et$3.inspectSource,le$3=L$3.WeakMap,ue$3=et$3(le$3)&&/native code/.test(ae$3(le$3)),ce$3=Nt$3("keys"),se$3=function(t){return ce$3[t]||(ce$3[t]=Rt$3(t))},fe$3={},de$3=L$3.TypeError,pe$3=L$3.WeakMap;if(ue$3||Et$3.state){var ve$3=Et$3.state||(Et$3.state=new pe$3),he$3=q$3(ve$3.get),ge$3=q$3(ve$3.has),ye$3=q$3(ve$3.set);re$3=function(t,e){if(ge$3(ve$3,t))throw new de$3("Object already initialized");return e.facade=t,ye$3(ve$3,t,e),e},oe$3=function(t){return he$3(ve$3,t)||{}},ie$3=function(t){return ge$3(ve$3,t)};}else {var be$3=se$3("state");fe$3[be$3]=!0,re$3=function(t,e){if(Pt$3(t,be$3))throw new de$3("Object already initialized");return e.facade=t,ee$3(t,be$3,e),e},oe$3=function(t){return Pt$3(t,be$3)?t[be$3]:{}},ie$3=function(t){return Pt$3(t,be$3)};}var me$3={set:re$3,get:oe$3,has:ie$3,enforce:function(t){return ie$3(t)?oe$3(t):re$3(t,{})},getterFor:function(t){return function(e){var n;if(!nt$3(e)||(n=oe$3(e)).type!==t)throw de$3("Incompatible receiver, "+t+" required");return n}}},we$3=Function.prototype,Se$3=A$3&&Object.getOwnPropertyDescriptor,xe$3=Pt$3(we$3,"name"),Te$3={EXISTS:xe$3,PROPER:xe$3&&"something"===function(){}.name,CONFIGURABLE:xe$3&&(!A$3||A$3&&Se$3(we$3,"name").configurable)},Ee$3=H$3((function(t){var e=Te$3.CONFIGURABLE,n=me$3.get,r=me$3.enforce,o=String(String).split("String");(t.exports=function(t,n,i,a){var l,u=!!a&&!!a.unsafe,c=!!a&&!!a.enumerable,s=!!a&&!!a.noTargetGet,f=a&&void 0!==a.name?a.name:n;et$3(i)&&("Symbol("===String(f).slice(0,7)&&(f="["+String(f).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!Pt$3(i,"name")||e&&i.name!==f)&&ee$3(i,"name",f),(l=r(i)).source||(l.source=o.join("string"==typeof f?f:""))),t!==L$3?(u?!s&&t[n]&&(c=!0):delete t[n],c?t[n]=i:ee$3(t,n,i)):c?t[n]=i:Tt$3(n,i);})(Function.prototype,"toString",(function(){return et$3(this)&&n(this).source||ae$3(this)}));})),Ne$3=Math.ceil,Me$3=Math.floor,Oe$3=function(t){var e=+t;return e!=e||0===e?0:(e>0?Me$3:Ne$3)(e)},He$3=Math.max,Pe$3=Math.min,Ve$3=function(t,e){var n=Oe$3(t);return n<0?He$3(n+e,0):Pe$3(n,e)},ze$3=Math.min,Le$3=function(t){return t>0?ze$3(Oe$3(t),9007199254740991):0},Re$3=function(t){return Le$3(t.length)},Ae$3=function(t){return function(e,n,r){var o,i=tt$3(e),a=Re$3(i),l=Ve$3(r,a);if(t&&n!=n){for(;a>l;)if((o=i[l++])!=o)return !0}else for(;a>l;l++)if((t||l in i)&&i[l]===n)return t||l||0;return !t&&-1}},Ce$3={includes:Ae$3(!0),indexOf:Ae$3(!1)}.indexOf,Ie$3=q$3([].push),je$3=function(t,e){var n,r=tt$3(t),o=0,i=[];for(n in r)!Pt$3(fe$3,n)&&Pt$3(r,n)&&Ie$3(i,n);for(;e.length>o;)Pt$3(r,n=e[o++])&&(~Ce$3(i,n)||Ie$3(i,n));return i},De$3=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],ke$3=De$3.concat("length","prototype"),Be$3={f:Object.getOwnPropertyNames||function(t){return je$3(t,ke$3)}},Fe$3={f:Object.getOwnPropertySymbols},$e$3=q$3([].concat),_e$3=ot$3("Reflect","ownKeys")||function(t){var e=Be$3.f(Jt$3(t)),n=Fe$3.f;return n?$e$3(e,n(t)):e},Ge$3=function(t,e){for(var n=_e$3(e),r=te$3.f,o=Xt$3.f,i=0;i<n.length;i++){var a=n[i];Pt$3(t,a)||r(t,a,o(e,a));}},qe$3=/#|\.prototype\./,Ue$3=function(t,e){var n=Xe$3[We$3(t)];return n==Ke$3||n!=Ye$3&&(et$3(e)?R$3(e):!!e)},We$3=Ue$3.normalize=function(t){return String(t).replace(qe$3,".").toLowerCase()},Xe$3=Ue$3.data={},Ye$3=Ue$3.NATIVE="N",Ke$3=Ue$3.POLYFILL="P",Je$3=Ue$3,Qe$3=Xt$3.f,Ze$3=function(t,e){var n,r,o,i,a,l=t.target,u=t.global,c=t.stat;if(n=u?L$3:c?L$3[l]||Tt$3(l,{}):(L$3[l]||{}).prototype)for(r in e){if(i=e[r],o=t.noTargetGet?(a=Qe$3(n,r))&&a.value:n[r],!Je$3(u?r:l+(c?".":"#")+r,t.forced)&&void 0!==o){if(typeof i==typeof o)continue;Ge$3(i,o);}(t.sham||o&&o.sham)&&ee$3(i,"sham",!0),Ee$3(n,r,i,t);}},tn$3={};tn$3[Dt$3("toStringTag")]="z";var en$3,nn$3="[object z]"===String(tn$3),rn$3=Dt$3("toStringTag"),on$3=L$3.Object,an$3="Arguments"==X$3(function(){return arguments}()),ln$3=nn$3?X$3:function(t){var e,n,r;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=on$3(t),rn$3))?n:an$3?X$3(e):"Object"==(r=X$3(e))&&et$3(e.callee)?"Arguments":r},un$3=L$3.String,cn$3=function(t){if("Symbol"===ln$3(t))throw TypeError("Cannot convert a Symbol value to a string");return un$3(t)},sn$3=/"/g,fn$3=q$3("".replace);Ze$3({target:"String",proto:!0,forced:(en$3="anchor",R$3((function(){var t=""[en$3]('"');return t!==t.toLowerCase()||t.split('"').length>3})))},{anchor:function(t){return e="a",n="name",r=t,o=cn$3(Z$3(this)),i="<"+e,""!==n&&(i+=" "+n+'="'+fn$3(cn$3(r),sn$3,"&quot;")+'"'),i+">"+o+"</"+e+">";var e,n,r,o,i;}});var dn$3,pn$3=function(){var t=Jt$3(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.dotAll&&(e+="s"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e},vn$3=L$3.RegExp,hn$3=R$3((function(){var t=vn$3("a","y");return t.lastIndex=2,null!=t.exec("abcd")})),gn$3=hn$3||R$3((function(){return !vn$3("a","y").sticky})),yn$3={BROKEN_CARET:hn$3||R$3((function(){var t=vn$3("^r","gy");return t.lastIndex=2,null!=t.exec("str")})),MISSED_STICKY:gn$3,UNSUPPORTED_Y:hn$3},bn$3=Object.keys||function(t){return je$3(t,De$3)},mn$3=A$3?Object.defineProperties:function(t,e){Jt$3(t);for(var n,r=tt$3(e),o=bn$3(e),i=o.length,a=0;i>a;)te$3.f(t,n=o[a++],r[n]);return t},wn$3=ot$3("document","documentElement"),Sn$3=se$3("IE_PROTO"),xn$3=function(){},Tn$3=function(t){return "<script>"+t+"<\/script>"},En$3=function(t){t.write(Tn$3("")),t.close();var e=t.parentWindow.Object;return t=null,e},Nn$3=function(){try{dn$3=new ActiveXObject("htmlfile");}catch(t){}var t,e;Nn$3="undefined"!=typeof document?document.domain&&dn$3?En$3(dn$3):((e=qt$3("iframe")).style.display="none",wn$3.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write(Tn$3("document.F=Object")),t.close(),t.F):En$3(dn$3);for(var n=De$3.length;n--;)delete Nn$3.prototype[De$3[n]];return Nn$3()};fe$3[Sn$3]=!0;var Mn$3,On$3,Hn$3=Object.create||function(t,e){var n;return null!==t?(xn$3.prototype=Jt$3(t),n=new xn$3,xn$3.prototype=null,n[Sn$3]=t):n=Nn$3(),void 0===e?n:mn$3(n,e)},Pn$3=L$3.RegExp,Vn$3=R$3((function(){var t=Pn$3(".","s");return !(t.dotAll&&t.exec("\n")&&"s"===t.flags)})),zn$3=L$3.RegExp,Ln$3=R$3((function(){var t=zn$3("(?<a>b)","g");return "b"!==t.exec("b").groups.a||"bc"!=="b".replace(t,"$<a>c")})),Rn$3=me$3.get,An$3=Nt$3("native-string-replace",String.prototype.replace),Cn$3=RegExp.prototype.exec,In$3=Cn$3,jn$3=q$3("".charAt),Dn$3=q$3("".indexOf),kn$3=q$3("".replace),Bn$3=q$3("".slice),Fn$3=(On$3=/b*/g,I$3(Cn$3,Mn$3=/a/,"a"),I$3(Cn$3,On$3,"a"),0!==Mn$3.lastIndex||0!==On$3.lastIndex),$n$3=yn$3.BROKEN_CARET,_n$3=void 0!==/()??/.exec("")[1];(Fn$3||_n$3||$n$3||Vn$3||Ln$3)&&(In$3=function(t){var e,n,r,o,i,a,l,u=this,c=Rn$3(u),s=cn$3(t),f=c.raw;if(f)return f.lastIndex=u.lastIndex,e=I$3(In$3,f,s),u.lastIndex=f.lastIndex,e;var d=c.groups,p=$n$3&&u.sticky,v=I$3(pn$3,u),h=u.source,g=0,y=s;if(p&&(v=kn$3(v,"y",""),-1===Dn$3(v,"g")&&(v+="g"),y=Bn$3(s,u.lastIndex),u.lastIndex>0&&(!u.multiline||u.multiline&&"\n"!==jn$3(s,u.lastIndex-1))&&(h="(?: "+h+")",y=" "+y,g++),n=new RegExp("^(?:"+h+")",v)),_n$3&&(n=new RegExp("^"+h+"$(?!\\s)",v)),Fn$3&&(r=u.lastIndex),o=I$3(Cn$3,p?n:u,y),p?o?(o.input=Bn$3(o.input,g),o[0]=Bn$3(o[0],g),o.index=u.lastIndex,u.lastIndex+=o[0].length):u.lastIndex=0:Fn$3&&o&&(u.lastIndex=u.global?o.index+o[0].length:r),_n$3&&o&&o.length>1&&I$3(An$3,o[0],n,(function(){for(i=1;i<arguments.length-2;i++)void 0===arguments[i]&&(o[i]=void 0);})),o&&d)for(o.groups=a=Hn$3(null),i=0;i<d.length;i++)a[(l=d[i])[0]]=o[l[1]];return o});var Gn$3=In$3;Ze$3({target:"RegExp",proto:!0,forced:/./.exec!==Gn$3},{exec:Gn$3});var qn$3=Array.isArray||function(t){return "Array"==X$3(t)},Un$3=function(){},Wn$3=[],Xn$3=ot$3("Reflect","construct"),Yn$3=/^\s*(?:class|function)\b/,Kn$3=q$3(Yn$3.exec),Jn$3=!Yn$3.exec(Un$3),Qn$3=function(t){if(!et$3(t))return !1;try{return Xn$3(Un$3,Wn$3,t),!0}catch(t){return !1}},Zn$3=!Xn$3||R$3((function(){var t;return Qn$3(Qn$3.call)||!Qn$3(Object)||!Qn$3((function(){t=!0;}))||t}))?function(t){if(!et$3(t))return !1;switch(ln$3(t)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return !1}return Jn$3||!!Kn$3(Yn$3,ae$3(t))}:Qn$3,tr$2=function(t,e,n){var r=$t$3(e);r in t?te$3.f(t,r,B$3(0,n)):t[r]=n;},er$2=Dt$3("species"),nr$2=function(t){return ft$3>=51||!R$3((function(){var e=[];return (e.constructor={})[er$2]=function(){return {foo:1}},1!==e[t](Boolean).foo}))},rr$2=q$3([].slice),or$2=nr$2("slice"),ir$2=Dt$3("species"),ar$2=L$3.Array,lr$2=Math.max;function ur$2(t,e){var n="function"==typeof Symbol&&t[Symbol.iterator];if(!n)return t;var r,o,i=n.call(t),a=[];try{for(;(void 0===e||e-- >0)&&!(r=i.next()).done;)a.push(r.value);}catch(t){o={error:t};}finally{try{r&&!r.done&&(n=i.return)&&n.call(i);}finally{if(o)throw o.error}}return a}function cr$2(t){var n=t.selection;if(null==n)return !1;var o=ur$2(Editor.nodes(t,{match:function(t){return ol$1.checkNodeType(t,"table-cell")}}),1)[0];if(o){var i=ur$2(o,2)[1],a=Editor.start(t,i);if(Point.equals(n.anchor,a))return !0}return !1}function sr$2(t,n){var o,i,a=Editor.nodes(t,{at:n,match:function(t){return "table"===ol$1.getNodeType(t)}}),l=!1;try{for(var u=
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function(t){var e="function"==typeof Symbol&&Symbol.iterator,n=e&&t[e],r=0;if(n)return n.call(t);if(t&&"number"==typeof t.length)return {next:function(){return t&&r>=t.length&&(t=void 0),{value:t&&t[r++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")}(a),c=u.next();!c.done;c=u.next()){c.value;l=!0;}}catch(t){o={error:t};}finally{try{c&&!c.done&&(i=u.return)&&i.call(u);}finally{if(o)throw o.error}}return l}Ze$3({target:"Array",proto:!0,forced:!or$2},{slice:function(t,e){var n,r,o,i=tt$3(this),a=Re$3(i),l=Ve$3(t,a),u=Ve$3(void 0===e?a:e,a);if(qn$3(i)&&(n=i.constructor,(Zn$3(n)&&(n===ar$2||qn$3(n.prototype))||nt$3(n)&&null===(n=n[ir$2]))&&(n=void 0),n===ar$2||void 0===n))return rr$2(i,l,u);for(r=new(void 0===n?ar$2:n)(lr$2(u-l,0)),o=0;l<u;l++,o++)l in i&&tr$2(r,o,i[l]);return r.length=o,r}});var fr$2=q$3(q$3.bind),dr$2=Dt$3("species"),pr$2=L$3.Array,vr$2=function(t,e){return new(function(t){var e;return qn$3(t)&&(e=t.constructor,(Zn$3(e)&&(e===pr$2||qn$3(e.prototype))||nt$3(e)&&null===(e=e[dr$2]))&&(e=void 0)),void 0===e?pr$2:e}(t))(0===e?0:e)},hr$2=q$3([].push),gr$2=function(t){var e=1==t,n=2==t,r=3==t,o=4==t,i=6==t,a=7==t,l=5==t||i;return function(u,c,s,f){for(var d,p,v=Ot$3(u),h=J$3(v),g=function(t,e){return mt$3(t),void 0===e?t:fr$2?fr$2(t,e):function(){return t.apply(e,arguments)}}(c,s),y=Re$3(h),b=0,m=f||vr$2,w=e?m(u,y):n||a?m(u,0):void 0;y>b;b++)if((l||b in h)&&(p=g(d=h[b],b,v),t))if(e)w[b]=p;else if(p)switch(t){case 3:return !0;case 5:return d;case 6:return b;case 2:hr$2(w,d);}else switch(t){case 4:return !1;case 7:hr$2(w,d);}return i?-1:r||o?o:w}},yr$2={forEach:gr$2(0),map:gr$2(1),filter:gr$2(2),some:gr$2(3),every:gr$2(4),find:gr$2(5),findIndex:gr$2(6),filterReject:gr$2(7)},br$2=yr$2.map;Ze$3({target:"Array",proto:!0,forced:!nr$2("map")},{map:function(t){return br$2(this,t,arguments.length>1?arguments[1]:void 0)}});var mr$2=nn$3?{}.toString:function(){return "[object "+ln$3(this)+"]"};function wr$2(t){var e=t.children||[];return 0===e.length?[]:(e[0]||{}).children||[]}function Sr$2(t){return wr$2(t).every((function(t){return !!t.isHeader}))}nn$3||Ee$3(Object.prototype,"toString",mr$2,{unsafe:!0});var xr$2=Te$3.PROPER,Tr$2=RegExp.prototype,Er$2=Tr$2.toString,Nr$2=q$3(pn$3),Mr$2=R$3((function(){return "/a/b"!=Er$2.call({source:"a",flags:"b"})})),Or$2=xr$2&&"toString"!=Er$2.name;(Mr$2||Or$2)&&Ee$3(RegExp.prototype,"toString",(function(){var t=Jt$3(this),e=cn$3(t.source),n=t.flags;return "/"+e+"/"+cn$3(void 0===n&&it$3(Tr$2,t)&&!("flags"in Tr$2)?Nr$2(t):n)}),{unsafe:!0});var Hr$2=Dt$3("unscopables"),Pr$2=Array.prototype;null==Pr$2[Hr$2]&&te$3.f(Pr$2,Hr$2,{configurable:!0,value:Hn$3(null)});var Vr$2,zr$2=yr$2.find,Lr$2=!0;"find"in[]&&Array(1).find((function(){Lr$2=!1;})),Ze$3({target:"Array",proto:!0,forced:Lr$2},{find:function(t){return zr$2(this,t,arguments.length>1?arguments[1]:void 0)}}),Vr$2="find",Pr$2[Hr$2][Vr$2]=!0;var Rr$2=Function.prototype,Ar$2=Rr$2.apply,Cr$2=Rr$2.bind,Ir$2=Rr$2.call,jr$2="object"==typeof Reflect&&Reflect.apply||(Cr$2?Ir$2.bind(Ar$2):function(){return Ir$2.apply(Ar$2,arguments)}),Dr$2=Dt$3("species"),kr$2=RegExp.prototype,Br$2=function(t,e,n,r){var o=Dt$3(t),i=!R$3((function(){var e={};return e[o]=function(){return 7},7!=""[t](e)})),a=i&&!R$3((function(){var e=!1,n=/a/;return "split"===t&&((n={}).constructor={},n.constructor[Dr$2]=function(){return n},n.flags="",n[o]=/./[o]),n.exec=function(){return e=!0,null},n[o](""),!e}));if(!i||!a||n){var l=q$3(/./[o]),u=e(o,""[t],(function(t,e,n,r,o){var a=q$3(t),u=e.exec;return u===Gn$3||u===kr$2.exec?i&&!o?{done:!0,value:l(e,n,r)}:{done:!0,value:a(n,e,r)}:{done:!1}}));Ee$3(String.prototype,t,u[0]),Ee$3(kr$2,o,u[1]);}r&&ee$3(kr$2[o],"sham",!0);},Fr$2=Dt$3("match"),$r$2=L$3.TypeError,_r$2=Dt$3("species"),Gr$2=function(t,e){var n,r=Jt$3(t).constructor;return void 0===r||null==(n=Jt$3(r)[_r$2])?e:function(t){if(Zn$3(t))return t;throw $r$2(yt$3(t)+" is not a constructor")}(n)},qr$2=q$3("".charAt),Ur$2=q$3("".charCodeAt),Wr$2=q$3("".slice),Xr$2=function(t){return function(e,n){var r,o,i=cn$3(Z$3(e)),a=Oe$3(n),l=i.length;return a<0||a>=l?t?"":void 0:(r=Ur$2(i,a))<55296||r>56319||a+1===l||(o=Ur$2(i,a+1))<56320||o>57343?t?qr$2(i,a):r:t?Wr$2(i,a,a+2):o-56320+(r-55296<<10)+65536}},Yr$2={codeAt:Xr$2(!1),charAt:Xr$2(!0)}.charAt,Kr$2=function(t,e,n){return e+(n?Yr$2(t,e).length:1)},Jr$2=L$3.Array,Qr$2=Math.max,Zr$2=function(t,e,n){for(var r=Re$3(t),o=Ve$3(e,r),i=Ve$3(void 0===n?r:n,r),a=Jr$2(Qr$2(i-o,0)),l=0;o<i;o++,l++)tr$2(a,l,t[o]);return a.length=l,a},to$2=L$3.TypeError,eo$2=function(t,e){var n=t.exec;if(et$3(n)){var r=I$3(n,t,e);return null!==r&&Jt$3(r),r}if("RegExp"===X$3(t))return I$3(Gn$3,t,e);throw to$2("RegExp#exec called on incompatible receiver")},no$2=yn$3.UNSUPPORTED_Y,ro$2=Math.min,oo$2=[].push,io$2=q$3(/./.exec),ao$2=q$3(oo$2),lo$2=q$3("".slice);Br$2("split",(function(t,e,n){var r;return r="c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1).length||2!="ab".split(/(?:ab)*/).length||4!=".".split(/(.?)(.?)/).length||".".split(/()()/).length>1||"".split(/.?/).length?function(t,n){var r,o,i=cn$3(Z$3(this)),a=void 0===n?4294967295:n>>>0;if(0===a)return [];if(void 0===t)return [i];if(!nt$3(r=t)||!(void 0!==(o=r[Fr$2])?o:"RegExp"==X$3(r)))return I$3(e,i,t,a);for(var l,u,c,s=[],f=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.unicode?"u":"")+(t.sticky?"y":""),d=0,p=new RegExp(t.source,f+"g");(l=I$3(Gn$3,p,i))&&!((u=p.lastIndex)>d&&(ao$2(s,lo$2(i,d,l.index)),l.length>1&&l.index<i.length&&jr$2(oo$2,s,Zr$2(l,1)),c=l[0].length,d=u,s.length>=a));)p.lastIndex===l.index&&p.lastIndex++;return d===i.length?!c&&io$2(p,"")||ao$2(s,""):ao$2(s,lo$2(i,d)),s.length>a?Zr$2(s,0,a):s}:"0".split(void 0,0).length?function(t,n){return void 0===t&&0===n?[]:I$3(e,this,t,n)}:e,[function(e,n){var o=Z$3(this),i=null==e?void 0:wt$3(e,t);return i?I$3(i,e,o,n):I$3(r,cn$3(o),e,n)},function(t,o){var i=Jt$3(this),a=cn$3(t),l=n(r,i,a,o,r!==e);if(l.done)return l.value;var u=Gr$2(i,RegExp),c=i.unicode,s=(i.ignoreCase?"i":"")+(i.multiline?"m":"")+(i.unicode?"u":"")+(no$2?"g":"y"),f=new u(no$2?"^(?:"+i.source+")":i,s),d=void 0===o?4294967295:o>>>0;if(0===d)return [];if(0===a.length)return null===eo$2(f,a)?[a]:[];for(var p=0,v=0,h=[];v<a.length;){f.lastIndex=no$2?0:v;var g,y=eo$2(f,no$2?lo$2(a,v):a);if(null===y||(g=ro$2(Le$3(f.lastIndex+(no$2?v:0)),a.length))===p)v=Kr$2(a,v,c);else {if(ao$2(h,lo$2(a,p,v)),h.length===d)return h;for(var b=1;b<=y.length-1;b++)if(ao$2(h,y[b]),h.length===d)return h;v=p=g;}}return ao$2(h,lo$2(a,p)),h}]}),!!R$3((function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var n="ab".split(t);return 2!==n.length||"a"!==n[0]||"b"!==n[1]})),no$2);var uo$2="\t\n\v\f\r                　\u2028\u2029\ufeff",co$2=q$3("".replace),so$2="["+uo$2+"]",fo$2=RegExp("^"+so$2+so$2+"*"),po$2=RegExp(so$2+so$2+"*$"),vo$2=function(t){return function(e){var n=cn$3(Z$3(e));return 1&t&&(n=co$2(n,fo$2,"")),2&t&&(n=co$2(n,po$2,"")),n}},ho$2={start:vo$2(1),end:vo$2(2),trim:vo$2(3)},go$2=Te$3.PROPER,yo$2=ho$2.trim;function bo$2(t){return t.length?t[0].tagName.toLowerCase():""}Ze$3({target:"String",proto:!0,forced:function(t){return R$3((function(){return !!uo$2[t]()||"​᠎"!=="​᠎"[t]()||go$2&&uo$2[t].name!==t}))}("trim")},{trim:function(){return yo$2(this)}}),Ze$3({global:!0},{globalThis:L$3}),append&&($$6.fn.append=append),on$7&&($$6.fn.on=on$7),focus&&($$6.fn.focus=focus),attr&&($$6.fn.attr=attr),val&&($$6.fn.val=val),html&&($$6.fn.html=html),dataset&&($$6.fn.dataset=dataset),addClass&&($$6.fn.addClass=addClass),removeClass&&($$6.fn.removeClass=removeClass),children&&($$6.fn.children=children),each&&($$6.fn.each=each),find&&($$6.fn.find=find);var mo$2=!1,wo$2=0,So$2=0,xo$2=null,To$2=null,Eo$2=$$6("body");function No$2(t){mo$2=!1,To$2=null,xo$2=null,Eo$2.off("mousemove",Mo$2),Eo$2.off("mouseup",No$2);}Eo$2.on("mousedown",(function(t){var e=t.target;if(("TH"===e.tagName||"TD"===e.tagName)&&"col-resize"===e.style.cursor){e.style.cursor="auto",t.preventDefault(),mo$2=!0;var n=t.clientX;wo$2=n;var r=e.getBoundingClientRect().width;So$2=r,Eo$2.on("mousemove",Mo$2),Eo$2.on("mouseup",No$2);}}));var Mo$2=lodash_throttle((function(t){if(mo$2&&null!=To$2&&null!=xo$2){t.preventDefault();var e=t.clientX,n=So$2+(e-wo$2);(n=Math.floor(100*n)/100)<30&&(n=30),Transforms.setNodes(To$2,{width:n.toString()},{at:xo$2});}}),100);var Oo$2={type:"table",renderElem:function(t,n,o){var a=function(t,n){if(t.isDisabled())return !1;var o=t.selection;if(null==o)return !0;if(Range.isCollapsed(o))return !0;var a=o.anchor,c=o.focus,s=ol$1.findPath(t,n),f=Editor.start(t,s),d=Editor.end(t,s),p=Point.compare(a,d)<=0&&Point.compare(a,f)>=0,v=Point.compare(c,d)<=0&&Point.compare(c,f)>=0;return !!(p&&v&&Path.equals(a.path.slice(0,3),c.path.slice(0,3)))}(o,t),c=t.width,s=void 0===c?"auto":c,d=ol$1.isNodeSelected(o,t),p=wr$2(t),v=jsx("div",{className:"table-container","data-selected":d,on:{mousedown:function(n){if("DIV"===n.target.tagName&&n.preventDefault(),!o.isDisabled()){var i=ol$1.findPath(o,t),a=Editor.start(o,i),l=o.selection;if(null!=l)l.anchor.path[0]!==i[0]&&o.select(a);else o.select(a);}}}},jsx("table",{width:s,contentEditable:a},jsx("colgroup",null,p.map((function(t){var e=t.width;return jsx("col",{width:void 0===e?"auto":e})}))),jsx("tbody",null,n)));return v}},Ho$2={type:"table-row",renderElem:function(t,e,n){return jsx("tr",null,e)}},Po$2={type:"table-cell",renderElem:function(t,n,r){var o=function(t,n){var r=ol$1.getParentNode(t,n);if(null==r)return !1;var o=ol$1.getParentNode(t,r);return null!=o&&wr$2(o).some((function(t){return t===n}))}(r,t),i=t,a=i.colSpan,l=void 0===a?1:a,u=i.rowSpan,c=void 0===u?1:u,s=i.isHeader,p=void 0!==s&&s;if(!o)return jsx("td",{colSpan:l,rowSpan:c},n);var v=jsx(p?"th":"td",{colSpan:l,rowSpan:c,style:{borderRightWidth:"3px"},on:{mousemove:lodash_throttle((function(n){var o=this.elm;if(null!=o){var i=o.getBoundingClientRect(),a=i.left,l=i.width,u=i.top,c=i.height,s=n.clientX,f=n.clientY;if(!mo$2)s>a+l-5&&s<a+l&&(f>u&&f<u+c)?(o.style.cursor="col-resize",To$2=r,xo$2=ol$1.findPath(r,t)):mo$2||(o.style.cursor="auto",To$2=null,xo$2=null);}}),100)}},n);return v}};var Vo$2={type:"table",elemToHtml:function(t,e){var n=t.width;return '<table style="width: '+(void 0===n?"auto":n)+';"><tbody>'+e+"</tbody></table>"}},zo$2={type:"table-row",elemToHtml:function(t,e){return "<tr>"+e+"</tr>"}},Lo$2={type:"table-cell",elemToHtml:function(t,e){var n=t,r=n.colSpan,o=void 0===r?1:r,i=n.rowSpan,a=void 0===i?1:i,l=n.isHeader,u=void 0!==l&&l,c=n.width,s=u?"th":"td";return "<"+s+' colSpan="'+o+'" rowSpan="'+a+'" width="'+(void 0===c?"auto":c)+'">'+e+"</"+s+">"}};var Ro$2={selector:"table",preParseHtml:function(t){var e=$$6(t);if("table"!==bo$2(e))return t;var n=e.find("tbody");if(0===n.length)return t;var r=e.find("tr");return e.append(r),n.remove(),e[0]}},Ao$2=yr$2.filter;Ze$3({target:"Array",proto:!0,forced:!nr$2("filter")},{filter:function(t){return Ao$2(this,t,arguments.length>1?arguments[1]:void 0)}});var Co$2=Math.floor,Io$2=q$3("".charAt),jo$2=q$3("".replace),Do$2=q$3("".slice),ko$2=/\$([$&'`]|\d{1,2}|<[^>]*>)/g,Bo$2=/\$([$&'`]|\d{1,2})/g,Fo$2=function(t,e,n,r,o,i){var a=n+t.length,l=r.length,u=Bo$2;return void 0!==o&&(o=Ot$3(o),u=ko$2),jo$2(i,u,(function(i,u){var c;switch(Io$2(u,0)){case"$":return "$";case"&":return t;case"`":return Do$2(e,0,n);case"'":return Do$2(e,a);case"<":c=o[Do$2(u,1,-1)];break;default:var s=+u;if(0===s)return i;if(s>l){var f=Co$2(s/10);return 0===f?i:f<=l?void 0===r[f-1]?Io$2(u,1):r[f-1]+Io$2(u,1):i}c=r[s-1];}return void 0===c?"":c}))},$o$2=Dt$3("replace"),_o$2=Math.max,Go$2=Math.min,qo$2=q$3([].concat),Uo$2=q$3([].push),Wo$2=q$3("".indexOf),Xo$2=q$3("".slice),Yo$2="$0"==="a".replace(/./,"$0"),Ko$2=!!/./[$o$2]&&""===/./[$o$2]("a","$0");Br$2("replace",(function(t,e,n){var r=Ko$2?"$":"$0";return [function(t,n){var r=Z$3(this),o=null==t?void 0:wt$3(t,$o$2);return o?I$3(o,t,r,n):I$3(e,cn$3(r),t,n)},function(t,o){var i=Jt$3(this),a=cn$3(t);if("string"==typeof o&&-1===Wo$2(o,r)&&-1===Wo$2(o,"$<")){var l=n(e,i,a,o);if(l.done)return l.value}var u=et$3(o);u||(o=cn$3(o));var c=i.global;if(c){var s=i.unicode;i.lastIndex=0;}for(var f=[];;){var d=eo$2(i,a);if(null===d)break;if(Uo$2(f,d),!c)break;""===cn$3(d[0])&&(i.lastIndex=Kr$2(a,Le$3(i.lastIndex),s));}for(var p,v="",h=0,g=0;g<f.length;g++){for(var y=cn$3((d=f[g])[0]),b=_o$2(Go$2(Oe$3(d.index),a.length),0),m=[],w=1;w<d.length;w++)Uo$2(m,void 0===(p=d[w])?p:String(p));var S=d.groups;if(u){var x=qo$2([y],m,b,a);void 0!==S&&Uo$2(x,S);var T=cn$3(jr$2(o,void 0,x));}else T=Fo$2(y,a,b,m,S,o);b>=h&&(v+=Xo$2(a,h,b)+T,h=b+y.length);}return v+Xo$2(a,h)}]}),!!R$3((function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")}))||!Yo$2||Ko$2);var Jo$2={selector:"td:not([data-w-e-type]),th:not([data-w-e-type])",parseElemHtml:function(t,e,n){var r=$$6(t);0===(e=e.filter((function(t){return !!Text.isText(t)||!!n.isInline(t)}))).length&&(e=[{text:r.text().replace(/\s+/gm," ")}]);var o=parseInt(r.attr("colSpan")||"1"),i=parseInt(r.attr("rowSpan")||"1"),a=r.attr("width")||"auto";return {type:"table-cell",isHeader:"th"===bo$2(r),colSpan:o,rowSpan:i,width:a,children:e}}};var Qo$2={selector:"tr:not([data-w-e-type])",parseElemHtml:function(t,n,r){return {type:"table-row",children:n.filter((function(t){return "table-cell"===ol$1.getNodeType(t)}))}}};var Zo$2={selector:"table:not([data-w-e-type])",parseElemHtml:function(t,n,r){var o=$$6(t),i="auto";return "100%"===function(t,e){for(var n="",r=(t.attr("style")||"").split(";"),o=r.length,i=0;i<o;i++){var a=r[i];if(a){var l=a.split(":");l[0].trim()===e&&(n=l[1].trim());}}return n}(o,"width")&&(i="100%"),"100%"===o.attr("width")&&(i="100%"),{type:"table",width:i,children:n.filter((function(t){return "table-row"===ol$1.getNodeType(t)}))}}};var ti$2=function(){function t(){this.title=cp$1("tableModule.insertTable"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M0 64v896h1024V64H0z m384 576v-192h256v192h-256z m256 64v192h-256v-192h256z m0-512v192h-256V192h256zM320 192v192H64V192h256z m-256 256h256v192H64v-192z m640 0h256v192h-256v-192z m0-64V192h256v192h-256zM64 704h256v192H64v-192z m640 192v-192h256v192h-256z"></path></svg>',this.tag="button",this.showDropPanel=!0,this.$content=null;}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.exec=function(t,e){},t.prototype.isDisabled=function(t){var n=t.selection;return null==n||(!Range.isCollapsed(n)||!!ol$1.getSelectedElems(t).some((function(n){var r=ol$1.getNodeType(n);return "pre"===r||("table"===r||("list-item"===r||!!t.isVoid(n)))})))},t.prototype.getPanelContentElem=function(t){var e=this;if(this.$content)return this.$content[0];for(var n=$$6('<div class="w-e-panel-content-table"></div>'),r=$$6("<span>0 &times; 0</span>"),o=$$6("<table></table>"),i=0;i<10;i++){for(var a=$$6("<tr></tr>"),l=0;l<10;l++){var u=$$6("<td></td>");u.attr("data-x",l.toString()),u.attr("data-y",i.toString()),a.append(u),u.on("mouseenter",(function(t){var e=t.target;if(null!=e){var n=$$6(e).dataset(),i=n.x,a=n.y;r[0].innerHTML=i+1+" &times; "+(a+1),o.children().each((function(t){$$6(t).children().each((function(t){var e=$$6(t),n=e.dataset(),r=n.x,o=n.y;r<=i&&o<=a?e.addClass("active"):e.removeClass("active");}));}));}})),u.on("click",(function(n){n.preventDefault();var r=n.target;if(null!=r){var o=$$6(r).dataset(),i=o.x,a=o.y;e.insertTable(t,a+1,i+1);}}));}o.append(a);}return n.append(o),n.append(r),this.$content=n,n[0]},t.prototype.insertTable=function(t,n,r){var i=parseInt(n,10),a=parseInt(r,10);if(i&&a&&!(i<=0||a<=0)){ol$1.isSelectedEmptyParagraph(t)&&Transforms.removeNodes(t,{mode:"highest"});var l=function(t,e){for(var n=[],r=0;r<t;r++){for(var o=[],i=0;i<e;i++){var a={type:"table-cell",children:[{text:""}]};0===r&&(a.isHeader=!0),o.push(a);}n.push({type:"table-row",children:o});}return {type:"table",width:"auto",children:n}}(i,a);Transforms.insertNodes(t,l,{mode:"highest"});}},t}(),ei$2=function(){function t(){this.title=cp$1("tableModule.deleteTable"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M826.8032 356.5312c-19.328 0-36.3776 15.6928-36.3776 35.0464v524.2624c0 19.328-16 34.56-35.328 34.56H264.9344c-19.328 0-35.5072-15.3088-35.5072-34.56V390.0416c0-19.328-14.1568-35.0464-33.5104-35.0464s-33.5104 15.6928-33.5104 35.0464V915.712c0 57.9328 44.6208 108.288 102.528 108.288H755.2c57.9328 0 108.0832-50.4576 108.0832-108.288V391.4752c-0.1024-19.2512-17.1264-34.944-36.48-34.944z" p-id="9577"></path><path d="M437.1712 775.7568V390.6048c0-19.328-14.1568-35.0464-33.5104-35.0464s-33.5104 15.616-33.5104 35.0464v385.152c0 19.328 14.1568 35.0464 33.5104 35.0464s33.5104-15.7184 33.5104-35.0464zM649.7024 775.7568V390.6048c0-19.328-17.0496-35.0464-36.3776-35.0464s-36.3776 15.616-36.3776 35.0464v385.152c0 19.328 17.0496 35.0464 36.3776 35.0464s36.3776-15.7184 36.3776-35.0464zM965.0432 217.0368h-174.6176V145.5104c0-57.9328-47.2064-101.76-104.6528-101.76h-350.976c-57.8304 0-105.3952 43.8528-105.3952 101.76v71.5264H54.784c-19.4304 0-35.0464 14.1568-35.0464 33.5104 0 19.328 15.616 33.5104 35.0464 33.5104h910.3616c19.328 0 35.0464-14.1568 35.0464-33.5104 0-19.3536-15.6928-33.5104-35.1488-33.5104z m-247.3728 0H297.3952V145.5104c0-19.328 18.2016-34.7648 37.4272-34.7648h350.976c19.1488 0 31.872 15.1296 31.872 34.7648v71.5264z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){return null==t.selection||null==ol$1.getSelectedNodeByType(t,"table")},t.prototype.exec=function(t,e){this.isDisabled(t)||Transforms.removeNodes(t,{mode:"highest"});},t}(),ni$2=function(){function t(){this.title=cp$1("tableModule.insertRow"),this.iconSvg='<svg viewBox="0 0 1048 1024"><path d="M707.7888 521.0112h-147.456v-147.456H488.2432v147.456h-147.456v68.8128h147.456v147.456h72.0896v-147.456h147.456zM0 917.504V0h1048.576v917.504H0zM327.68 65.536H65.536v196.608H327.68V65.536z m327.68 0H393.216v196.608h262.144V65.536z m327.68 0h-262.144v196.608h262.144V65.536z m0 258.8672H65.536v462.0288H983.04V324.4032z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){var n=t.selection;return null==n||(!Range.isCollapsed(n)||null==ol$1.getSelectedNodeByType(t,"table"))},t.prototype.exec=function(t,n){if(!this.isDisabled(t)){var a=ur$2(Editor.nodes(t,{match:function(t){return ol$1.checkNodeType(t,"table-cell")},universal:!0}),1),l=ur$2(a[0],2),u=l[0],c=l[1],s=ol$1.getParentNode(t,u),f=(null==s?void 0:s.children.length)||0;if(0!==f){for(var d={type:"table-row",children:[]},p=0;p<f;p++){d.children.push({type:"table-cell",children:[{text:""}]});}var v=Path.parent(c),h=Path.next(v);Transforms.insertNodes(t,d,{at:h});}}},t}(),ri$2=function(){function t(){this.title=cp$1("tableModule.deleteRow"),this.iconSvg='<svg viewBox="0 0 1048 1024"><path d="M907.6736 586.5472L747.1104 425.984l163.84-163.84-78.6432-78.6432-163.84 163.84L507.904 186.7776 429.2608 262.144l163.84 163.84-167.1168 167.1168 78.6432 78.6432 167.1168-167.1168 160.5632 160.5632 75.3664-78.6432zM0 917.504V0h1048.576v917.504H0z m983.04-327.68h-22.9376l-65.536-65.536H983.04V327.68h-91.7504l65.536-65.536h26.2144V65.536H65.536v196.608h317.8496l65.536 65.536H65.536v196.608h380.1088l-65.536 65.536H65.536v196.608H983.04v-196.608z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){var n=t.selection;return null==n||(!Range.isCollapsed(n)||null==ol$1.getSelectedNodeByType(t,"table-row"))},t.prototype.exec=function(t,n){if(!this.isDisabled(t)){var i=ur$2(Editor.nodes(t,{match:function(t){return ol$1.checkNodeType(t,"table-row")},universal:!0}),1),a=ur$2(i[0],2),l=a[0],u=a[1],c=ol$1.getParentNode(t,l);((null==c?void 0:c.children.length)||0)<=1?Transforms.removeNodes(t,{mode:"highest"}):Transforms.removeNodes(t,{at:u});}},t}(),oi$2={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},ii$2=qt$3("span").classList,ai$2=ii$2&&ii$2.constructor&&ii$2.constructor.prototype,li$2=ai$2===Object.prototype?void 0:ai$2,ui$2=yr$2.forEach,ci$2=function(t,e){var n=[][t];return !!n&&R$3((function(){n.call(null,e||function(){throw 1},1);}))}("forEach"),si$2=ci$2?[].forEach:function(t){return ui$2(this,t,arguments.length>1?arguments[1]:void 0)},fi$2=function(t){if(t&&t.forEach!==si$2)try{ee$3(t,"forEach",si$2);}catch(e){t.forEach=si$2;}};for(var di$2 in oi$2)oi$2[di$2]&&fi$2(L$3[di$2]&&L$3[di$2].prototype);fi$2(li$2);var pi$2=function(){function t(){this.title=cp$1("tableModule.insertCol"),this.iconSvg='<svg viewBox="0 0 1048 1024"><path d="M327.68 193.3312v186.7776H140.9024v91.7504H327.68v186.7776h88.4736V471.8592h190.0544V380.1088H416.1536V193.3312zM0 917.504V0h1048.576v917.504H0zM655.36 65.536H65.536v720.896H655.36V65.536z m327.68 0h-262.144v196.608h262.144V65.536z m0 262.144h-262.144v196.608h262.144V327.68z m0 262.144h-262.144v196.608h262.144v-196.608z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){var n=t.selection;return null==n||(!Range.isCollapsed(n)||null==ol$1.getSelectedNodeByType(t,"table"))},t.prototype.exec=function(t,n){if(!this.isDisabled(t)){var i=ur$2(Editor.nodes(t,{match:function(t){return ol$1.checkNodeType(t,"table-cell")},universal:!0}),1),a=ur$2(i[0],2),l=a[0],u=a[1],c=ol$1.getParentNode(t,l);if(null!=c){var f=ol$1.getParentNode(t,c);if(null!=f)(f.children||[]).forEach((function(n,r){Element$1.isElement(n)&&(n.children||[]).forEach((function(n){var i=ol$1.findPath(t,n);if(i.length===u.length&&lodash_isequal(i.slice(-1),u.slice(-1))){var a={type:"table-cell",children:[{text:""}]};0===r&&Sr$2(f)&&(a.isHeader=!0),Transforms.insertNodes(t,a,{at:i});}}));}));}}},t}(),vi$2=function(){function t(){this.title=cp$1("tableModule.deleteCol"),this.iconSvg='<svg viewBox="0 0 1048 1024"><path d="M327.68 510.976L393.216 445.44v-13.1072L327.68 366.7968V510.976z m327.68-78.4384l65.536-65.536V507.904L655.36 442.368v-9.8304z m393.216 484.9664V0H0v917.504h1048.576z m-65.536-131.072h-262.144v-52.4288l-13.1072 13.1072-52.4288-52.4288v91.7504H393.216v-91.7504l-52.4288 52.4288-13.1072-13.1072v52.4288H65.536V65.536H327.68v121.2416l36.0448-36.0448 29.4912 29.4912V62.2592h262.144V180.224l49.152-49.152 16.384 16.384V62.2592h262.144V786.432z m-294.912-108.1344l-160.5632-160.5632-167.1168 167.1168-78.6432-78.6432 167.1168-167.1168L288.3584 278.528l78.6432-78.6432 160.5632 160.5632 163.84-163.84 78.6432 78.6432-163.84 163.84 160.5632 160.5632-78.6432 78.6432z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){var n=t.selection;return null==n||(!Range.isCollapsed(n)||null==ol$1.getSelectedNodeByType(t,"table-cell"))},t.prototype.exec=function(t,n){if(!this.isDisabled(t)){var i=ur$2(Editor.nodes(t,{match:function(t){return ol$1.checkNodeType(t,"table-cell")},universal:!0}),1),a=ur$2(i[0],2),l=a[0],u=a[1],c=ol$1.getParentNode(t,l),f=(null==c?void 0:c.children.length)||0;if(!c||f<=1)Transforms.removeNodes(t,{mode:"highest"});else {var d=ol$1.getParentNode(t,c);if(null!=d)(d.children||[]).forEach((function(n){Element$1.isElement(n)&&(n.children||[]).forEach((function(n){var r=ol$1.findPath(t,n);r.length===u.length&&lodash_isequal(r.slice(-1),u.slice(-1))&&Transforms.removeNodes(t,{at:r});}));}));}}},t}(),hi$2=function(){function t(){this.title=cp$1("tableModule.header"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M704 128l-64 0L384 128 320 128 0 128l0 256 0 64 0 192 0 64 0 256 320 0 64 0 256 0 64 0 320 0 0-256 0-64L1024 448 1024 384 1024 128 704 128zM640 640 384 640 384 448l256 0L640 640zM64 448l256 0 0 192L64 640 64 448zM320 896 64 896l0-192 256 0L320 896zM640 896 384 896l0-192 256 0L640 896zM960 896l-256 0 0-192 256 0L960 896zM960 640l-256 0L704 448l256 0L960 640z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){var n=ol$1.getSelectedNodeByType(t,"table");return null!=n&&Sr$2(n)},t.prototype.isActive=function(t){return !!this.getValue(t)},t.prototype.isDisabled=function(t){var n=t.selection;return null==n||(!Range.isCollapsed(n)||null==ol$1.getSelectedNodeByType(t,"table"))},t.prototype.exec=function(t,n){if(!this.isDisabled(t)){var r=!n,i=ol$1.getSelectedNodeByType(t,"table");if(null!=i)wr$2(i).forEach((function(n){return Transforms.setNodes(t,{isHeader:r},{at:ol$1.findPath(t,n)})}));}},t}(),gi$2=function(){function t(){this.title=cp$1("tableModule.widthAuto"),this.iconSvg='<svg viewBox="0 0 1228 1024"><path d="M862.514337 563.200461H404.581995v121.753478a13.311987 13.311987 0 0 1-6.655993 11.468789 10.23999 10.23999 0 0 1-12.083188-1.433599l-204.799795-179.199821a13.721586 13.721586 0 0 1 0-20.479979l204.799795-179.302221a10.23999 10.23999 0 0 1 12.185588-1.535998 13.209587 13.209587 0 0 1 6.553593 11.673588v115.097485h457.932342V319.693504a11.571188 11.571188 0 0 1 18.841582-10.239989l204.799795 179.19982a13.721586 13.721586 0 0 1 0 20.47998l-204.799795 179.199821a10.23999 10.23999 0 0 1-12.185588 1.535998 13.311987 13.311987 0 0 1-6.655994-11.571188V563.200461zM136.499064 14.951409v993.893406a15.257585 15.257585 0 0 1-15.155185 15.052785H15.155185A15.155185 15.155185 0 0 1 0 1008.844815V14.951409a15.257585 15.257585 0 0 1 15.155185-15.052785h106.086294a15.155185 15.155185 0 0 1 15.257585 15.155185zM1228.798771 14.951409v993.893406a15.257585 15.257585 0 0 1-15.155185 15.052785h-106.188693a15.155185 15.155185 0 0 1-15.155185-15.052785V14.951409a15.257585 15.257585 0 0 1 15.155185-15.052785h106.086293A15.155185 15.155185 0 0 1 1228.798771 15.053809z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){var n=ol$1.getSelectedNodeByType(t,"table");return null!=n&&"100%"===n.width},t.prototype.isActive=function(t){return !!this.getValue(t)},t.prototype.isDisabled=function(t){var n=t.selection;return null==n||(!Range.isCollapsed(n)||null==ol$1.getSelectedNodeByType(t,"table"))},t.prototype.exec=function(t,e){if(!this.isDisabled(t)){var n={width:e?"auto":"100%"};Transforms.setNodes(t,n,{mode:"highest"});}},t}(),yi$2={renderElems:[Oo$2,Ho$2,Po$2],elemsToHtml:[Vo$2,zo$2,Lo$2],preParseHtml:[Ro$2],parseElemsHtml:[Jo$2,Qo$2,Zo$2],menus:[{key:"insertTable",factory:function(){return new ti$2}},{key:"deleteTable",factory:function(){return new ei$2}},{key:"insertTableRow",factory:function(){return new ni$2}},{key:"deleteTableRow",factory:function(){return new ri$2}},{key:"insertTableCol",factory:function(){return new pi$2}},{key:"deleteTableCol",factory:function(){return new vi$2}},{key:"tableHeader",factory:function(){return new hi$2}},{key:"tableFullWidth",factory:function(){return new gi$2}}],editorPlugin:function(t){var n=t.insertBreak,l=t.deleteBackward,u=t.deleteForward,c=t.normalizeNode,s=t.insertData,f=t.handleTab,d=t.selectAll,p=t;return p.insertBreak=function(){null==ol$1.getSelectedNodeByType(p,"table")?n():p.insertText("\n");},p.deleteBackward=function(t){if(!cr$2(p)){var e=p.selection;if(e){var n=Editor.before(p,e);if(n){var o=sr$2(p,n),i=sr$2(p,e);if(o&&!i)return}}l(t);}},p.handleTab=function(){var n;if(ol$1.getSelectedNodeByType(p,"table")){var i=Editor.above(t);ol$1.checkNodeType(i[0],"table-cell")&&Transforms.select(t,i[1]);var a=Editor.next(t);if(a)a[0]&&a[0].text&&(a=null!==(n=Editor.above(t,{at:a[1]}))&&void 0!==n?n:a),Transforms.select(t,a[1]);else {var l=p.children||[],u=l.length;if(ol$1.checkNodeType(l[u-1],"table")){var c=ol$1.genEmptyParagraph();Transforms.insertNodes(p,c,{at:[u]}),p.handleTab();}}}else f();},p.deleteForward=function(t){cr$2(p)||u(t);},p.normalizeNode=function(t){var n=ur$2(t,2),r=n[0],i=n[1];if("table"!==ol$1.getNodeType(r))return c([r,i]);if(ol$1.isLastNode(p,r)){var a=ol$1.genEmptyParagraph();Transforms.insertNodes(p,a,{at:[i[0]+1]});}},p.insertData=function(t){if(null!=ol$1.getSelectedNodeByType(p,"table")){var n=t.getData("text/plain");"\n"===n||/<img[^>]+>/.test(t.getData("text/html"))?s(t):Editor.insertText(p,n);}else s(t);},p.selectAll=function(){var t=p.selection;if(null!=t){var n=ol$1.getSelectedNodeByType(p,"table-cell");if(null!=n){var o=t.anchor,l=t.focus;if(Path.equals(o.path.slice(0,3),l.path.slice(0,3)))if(0!==Node$1.string(n).length){var u=ol$1.findPath(p,n),c={anchor:Editor.start(p,u),focus:Editor.end(p,u)};p.select(c);}else d();else d();}else d();}else d();},p}};

sp$1("en",{videoModule:{delete:"Delete",uploadVideo:"Upload video",insertVideo:"Insert video",videoSrc:"Video source",videoSrcPlaceHolder:"Video file url, or third-party <iframe>",videoPoster:"Video poster",videoPosterPlaceHolder:"Poster image url",ok:"Ok",editSize:"Edit size",width:"Width",height:"Height"}}),sp$1("zh-CN",{videoModule:{delete:"删除视频",uploadVideo:"上传视频",insertVideo:"插入视频",videoSrc:"视频地址",videoSrcPlaceHolder:"视频文件 url 或第三方 <iframe>",videoPoster:"视频封面",videoPosterPlaceHolder:"封面图片 url",ok:"确定",editSize:"修改尺寸",width:"宽度",height:"高度"}});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var S$2=function(){return S$2=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t},S$2.apply(this,arguments)};function x$2(t,e,n,r){return new(n||(n=Promise))((function(o,i){function u(t){try{c(r.next(t));}catch(t){i(t);}}function a(t){try{c(r.throw(t));}catch(t){i(t);}}function c(t){var e;t.done?o(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e);}))).then(u,a);}c((r=r.apply(t,e||[])).next());}))}function O$2(t,e){var n,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;u;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=u.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=e.call(t,u);}catch(t){i=[6,t],r=0;}finally{n=o=0;}if(5&i[0])throw i[1];return {value:i[0]?i[1]:void 0,done:!0}}([i,a])}}}function E$2(t){var e="function"==typeof Symbol&&Symbol.iterator,n=e&&t[e],r=0;if(n)return n.call(t);if(t&&"number"==typeof t.length)return {next:function(){return t&&r>=t.length&&(t=void 0),{value:t&&t[r++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")}function j$2(t,e){var n="function"==typeof Symbol&&t[Symbol.iterator];if(!n)return t;var r,o,i=n.call(t),u=[];try{for(;(void 0===e||e-- >0)&&!(r=i.next()).done;)u.push(r.value);}catch(t){o={error:t};}finally{try{r&&!r.done&&(n=i.return)&&n.call(i);}finally{if(o)throw o.error}}return u}function I$2(t){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var e,n=t[Symbol.asyncIterator];return n?n.call(t):(t=E$2(t),e={},r("next"),r("throw"),r("return"),e[Symbol.asyncIterator]=function(){return this},e);function r(n){e[n]=t[n]&&function(e){return new Promise((function(r,o){(function(t,e,n,r){Promise.resolve(r).then((function(e){t({value:e,done:n});}),e);})(r,o,(e=t[n](e)).done,e.value);}))};}}var P$2="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function T$2(t){var e={exports:{}};return t(e,e.exports),e.exports}var M$2,A$2,k$2=function(t){return t&&t.Math==Math&&t},R$2=k$2("object"==typeof globalThis&&globalThis)||k$2("object"==typeof window&&window)||k$2("object"==typeof self&&self)||k$2("object"==typeof P$2&&P$2)||function(){return this}()||Function("return this")(),C$2=function(t){try{return !!t()}catch(t){return !0}},N$2=!C$2((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),L$2=Function.prototype.call,V$2=L$2.bind?L$2.bind(L$2):function(){return L$2.apply(L$2,arguments)},z$2={}.propertyIsEnumerable,F$2=Object.getOwnPropertyDescriptor,_$2={f:F$2&&!z$2.call({1:2},1)?function(t){var e=F$2(this,t);return !!e&&e.enumerable}:z$2},D$2=function(t,e){return {enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},$$2=Function.prototype,H$2=$$2.bind,B$2=$$2.call,G$2=H$2&&H$2.bind(B$2),W$2=H$2?function(t){return t&&G$2(B$2,t)}:function(t){return t&&function(){return B$2.apply(t,arguments)}},U$2=W$2({}.toString),K$2=W$2("".slice),X$2=function(t){return K$2(U$2(t),8,-1)},Y$2=R$2.Object,q$2=W$2("".split),J$2=C$2((function(){return !Y$2("z").propertyIsEnumerable(0)}))?function(t){return "String"==X$2(t)?q$2(t,""):Y$2(t)}:Y$2,Q$2=R$2.TypeError,Z$2=function(t){if(null==t)throw Q$2("Can't call method on "+t);return t},tt$2=function(t){return J$2(Z$2(t))},et$2=function(t){return "function"==typeof t},nt$2=function(t){return "object"==typeof t?null!==t:et$2(t)},rt$2=function(t){return et$2(t)?t:void 0},ot$2=function(t,e){return arguments.length<2?rt$2(R$2[t]):R$2[t]&&R$2[t][e]},it$2=W$2({}.isPrototypeOf),ut$2=ot$2("navigator","userAgent")||"",at$2=R$2.process,ct$2=R$2.Deno,st$2=at$2&&at$2.versions||ct$2&&ct$2.version,ft$2=st$2&&st$2.v8;ft$2&&(A$2=(M$2=ft$2.split("."))[0]>0&&M$2[0]<4?1:+(M$2[0]+M$2[1])),!A$2&&ut$2&&(!(M$2=ut$2.match(/Edge\/(\d+)/))||M$2[1]>=74)&&(M$2=ut$2.match(/Chrome\/(\d+)/))&&(A$2=+M$2[1]);var lt$2=A$2,dt$2=!!Object.getOwnPropertySymbols&&!C$2((function(){var t=Symbol();return !String(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&lt$2&&lt$2<41})),pt$2=dt$2&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,vt$2=R$2.Object,ht$2=pt$2?function(t){return "symbol"==typeof t}:function(t){var e=ot$2("Symbol");return et$2(e)&&it$2(e.prototype,vt$2(t))},yt$2=R$2.String,gt$2=function(t){try{return yt$2(t)}catch(t){return "Object"}},mt$2=R$2.TypeError,bt$2=function(t){if(et$2(t))return t;throw mt$2(gt$2(t)+" is not a function")},wt$2=function(t,e){var n=t[e];return null==n?void 0:bt$2(n)},St$2=R$2.TypeError,xt$2=Object.defineProperty,Ot$2=function(t,e){try{xt$2(R$2,t,{value:e,configurable:!0,writable:!0});}catch(n){R$2[t]=e;}return e},Et$2=R$2["__core-js_shared__"]||Ot$2("__core-js_shared__",{}),jt$2=T$2((function(t){(t.exports=function(t,e){return Et$2[t]||(Et$2[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.19.3",mode:"global",copyright:"© 2021 Denis Pushkarev (zloirock.ru)"});})),It$2=R$2.Object,Pt$2=function(t){return It$2(Z$2(t))},Tt$2=W$2({}.hasOwnProperty),Mt$2=Object.hasOwn||function(t,e){return Tt$2(Pt$2(t),e)},At$2=0,kt$2=Math.random(),Rt$2=W$2(1..toString),Ct$2=function(t){return "Symbol("+(void 0===t?"":t)+")_"+Rt$2(++At$2+kt$2,36)},Nt$2=jt$2("wks"),Lt$2=R$2.Symbol,Vt$2=Lt$2&&Lt$2.for,zt$2=pt$2?Lt$2:Lt$2&&Lt$2.withoutSetter||Ct$2,Ft$2=function(t){if(!Mt$2(Nt$2,t)||!dt$2&&"string"!=typeof Nt$2[t]){var e="Symbol."+t;dt$2&&Mt$2(Lt$2,t)?Nt$2[t]=Lt$2[t]:Nt$2[t]=pt$2&&Vt$2?Vt$2(e):zt$2(e);}return Nt$2[t]},_t$2=R$2.TypeError,Dt$2=Ft$2("toPrimitive"),$t$2=function(t,e){if(!nt$2(t)||ht$2(t))return t;var n,r=wt$2(t,Dt$2);if(r){if(void 0===e&&(e="default"),n=V$2(r,t,e),!nt$2(n)||ht$2(n))return n;throw _t$2("Can't convert object to primitive value")}return void 0===e&&(e="number"),function(t,e){var n,r;if("string"===e&&et$2(n=t.toString)&&!nt$2(r=V$2(n,t)))return r;if(et$2(n=t.valueOf)&&!nt$2(r=V$2(n,t)))return r;if("string"!==e&&et$2(n=t.toString)&&!nt$2(r=V$2(n,t)))return r;throw St$2("Can't convert object to primitive value")}(t,e)},Ht$2=function(t){var e=$t$2(t,"string");return ht$2(e)?e:e+""},Bt$2=R$2.document,Gt$2=nt$2(Bt$2)&&nt$2(Bt$2.createElement),Wt$2=function(t){return Gt$2?Bt$2.createElement(t):{}},Ut$2=!N$2&&!C$2((function(){return 7!=Object.defineProperty(Wt$2("div"),"a",{get:function(){return 7}}).a})),Kt$2=Object.getOwnPropertyDescriptor,Xt$2={f:N$2?Kt$2:function(t,e){if(t=tt$2(t),e=Ht$2(e),Ut$2)try{return Kt$2(t,e)}catch(t){}if(Mt$2(t,e))return D$2(!V$2(_$2.f,t,e),t[e])}},Yt$2=R$2.String,qt$2=R$2.TypeError,Jt$2=function(t){if(nt$2(t))return t;throw qt$2(Yt$2(t)+" is not an object")},Qt$2=R$2.TypeError,Zt$2=Object.defineProperty,te$2={f:N$2?Zt$2:function(t,e,n){if(Jt$2(t),e=Ht$2(e),Jt$2(n),Ut$2)try{return Zt$2(t,e,n)}catch(t){}if("get"in n||"set"in n)throw Qt$2("Accessors not supported");return "value"in n&&(t[e]=n.value),t}},ee$2=N$2?function(t,e,n){return te$2.f(t,e,D$2(1,n))}:function(t,e,n){return t[e]=n,t},ne$2=W$2(Function.toString);et$2(Et$2.inspectSource)||(Et$2.inspectSource=function(t){return ne$2(t)});var re$2,oe$2,ie$2,ue$2=Et$2.inspectSource,ae$2=R$2.WeakMap,ce$2=et$2(ae$2)&&/native code/.test(ue$2(ae$2)),se$2=jt$2("keys"),fe$2=function(t){return se$2[t]||(se$2[t]=Ct$2(t))},le$2={},de$2=R$2.TypeError,pe$2=R$2.WeakMap;if(ce$2||Et$2.state){var ve$2=Et$2.state||(Et$2.state=new pe$2),he$2=W$2(ve$2.get),ye$2=W$2(ve$2.has),ge$2=W$2(ve$2.set);re$2=function(t,e){if(ye$2(ve$2,t))throw new de$2("Object already initialized");return e.facade=t,ge$2(ve$2,t,e),e},oe$2=function(t){return he$2(ve$2,t)||{}},ie$2=function(t){return ye$2(ve$2,t)};}else {var me$2=fe$2("state");le$2[me$2]=!0,re$2=function(t,e){if(Mt$2(t,me$2))throw new de$2("Object already initialized");return e.facade=t,ee$2(t,me$2,e),e},oe$2=function(t){return Mt$2(t,me$2)?t[me$2]:{}},ie$2=function(t){return Mt$2(t,me$2)};}var be$2={set:re$2,get:oe$2,has:ie$2,enforce:function(t){return ie$2(t)?oe$2(t):re$2(t,{})},getterFor:function(t){return function(e){var n;if(!nt$2(e)||(n=oe$2(e)).type!==t)throw de$2("Incompatible receiver, "+t+" required");return n}}},we$2=Function.prototype,Se$2=N$2&&Object.getOwnPropertyDescriptor,xe$2=Mt$2(we$2,"name"),Oe$2={EXISTS:xe$2,PROPER:xe$2&&"something"===function(){}.name,CONFIGURABLE:xe$2&&(!N$2||N$2&&Se$2(we$2,"name").configurable)},Ee$2=T$2((function(t){var e=Oe$2.CONFIGURABLE,n=be$2.get,r=be$2.enforce,o=String(String).split("String");(t.exports=function(t,n,i,u){var a,c=!!u&&!!u.unsafe,s=!!u&&!!u.enumerable,f=!!u&&!!u.noTargetGet,l=u&&void 0!==u.name?u.name:n;et$2(i)&&("Symbol("===String(l).slice(0,7)&&(l="["+String(l).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!Mt$2(i,"name")||e&&i.name!==l)&&ee$2(i,"name",l),(a=r(i)).source||(a.source=o.join("string"==typeof l?l:""))),t!==R$2?(c?!f&&t[n]&&(s=!0):delete t[n],s?t[n]=i:ee$2(t,n,i)):s?t[n]=i:Ot$2(n,i);})(Function.prototype,"toString",(function(){return et$2(this)&&n(this).source||ue$2(this)}));})),je$2=Math.ceil,Ie$2=Math.floor,Pe$2=function(t){var e=+t;return e!=e||0===e?0:(e>0?Ie$2:je$2)(e)},Te$2=Math.max,Me$2=Math.min,Ae$2=function(t,e){var n=Pe$2(t);return n<0?Te$2(n+e,0):Me$2(n,e)},ke$2=Math.min,Re$2=function(t){return t>0?ke$2(Pe$2(t),9007199254740991):0},Ce$2=function(t){return Re$2(t.length)},Ne$2=function(t){return function(e,n,r){var o,i=tt$2(e),u=Ce$2(i),a=Ae$2(r,u);if(t&&n!=n){for(;u>a;)if((o=i[a++])!=o)return !0}else for(;u>a;a++)if((t||a in i)&&i[a]===n)return t||a||0;return !t&&-1}},Le$2={includes:Ne$2(!0),indexOf:Ne$2(!1)},Ve$2=Le$2.indexOf,ze$2=W$2([].push),Fe$2=function(t,e){var n,r=tt$2(t),o=0,i=[];for(n in r)!Mt$2(le$2,n)&&Mt$2(r,n)&&ze$2(i,n);for(;e.length>o;)Mt$2(r,n=e[o++])&&(~Ve$2(i,n)||ze$2(i,n));return i},_e$2=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],De$2=_e$2.concat("length","prototype"),$e$2={f:Object.getOwnPropertyNames||function(t){return Fe$2(t,De$2)}},He$2={f:Object.getOwnPropertySymbols},Be$2=W$2([].concat),Ge$2=ot$2("Reflect","ownKeys")||function(t){var e=$e$2.f(Jt$2(t)),n=He$2.f;return n?Be$2(e,n(t)):e},We$2=function(t,e){for(var n=Ge$2(e),r=te$2.f,o=Xt$2.f,i=0;i<n.length;i++){var u=n[i];Mt$2(t,u)||r(t,u,o(e,u));}},Ue$2=/#|\.prototype\./,Ke$2=function(t,e){var n=Ye$2[Xe$2(t)];return n==Je$2||n!=qe$2&&(et$2(e)?C$2(e):!!e)},Xe$2=Ke$2.normalize=function(t){return String(t).replace(Ue$2,".").toLowerCase()},Ye$2=Ke$2.data={},qe$2=Ke$2.NATIVE="N",Je$2=Ke$2.POLYFILL="P",Qe$2=Ke$2,Ze$2=Xt$2.f,tn$2=function(t,e){var n,r,o,i,u,a=t.target,c=t.global,s=t.stat;if(n=c?R$2:s?R$2[a]||Ot$2(a,{}):(R$2[a]||{}).prototype)for(r in e){if(i=e[r],o=t.noTargetGet?(u=Ze$2(n,r))&&u.value:n[r],!Qe$2(c?r:a+(s?".":"#")+r,t.forced)&&void 0!==o){if(typeof i==typeof o)continue;We$2(i,o);}(t.sham||o&&o.sham)&&ee$2(i,"sham",!0),Ee$2(n,r,i,t);}},en$2={};en$2[Ft$2("toStringTag")]="z";var nn$2,rn$2="[object z]"===String(en$2),on$2=Ft$2("toStringTag"),un$2=R$2.Object,an$2="Arguments"==X$2(function(){return arguments}()),cn$2=rn$2?X$2:function(t){var e,n,r;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=un$2(t),on$2))?n:an$2?X$2(e):"Object"==(r=X$2(e))&&et$2(e.callee)?"Arguments":r},sn$2=R$2.String,fn$2=function(t){if("Symbol"===cn$2(t))throw TypeError("Cannot convert a Symbol value to a string");return sn$2(t)},ln$2="\t\n\v\f\r                　\u2028\u2029\ufeff",dn$2=W$2("".replace),pn$2="["+ln$2+"]",vn$2=RegExp("^"+pn$2+pn$2+"*"),hn$2=RegExp(pn$2+pn$2+"*$"),yn$2=function(t){return function(e){var n=fn$2(Z$2(e));return 1&t&&(n=dn$2(n,vn$2,"")),2&t&&(n=dn$2(n,hn$2,"")),n}},gn$2={start:yn$2(1),end:yn$2(2),trim:yn$2(3)},mn$2=Oe$2.PROPER,bn$2=gn$2.trim;function wn$2(t){return t.length?t[0].tagName.toLowerCase():""}function Sn$2(t,e,n){void 0===e&&(e="auto"),void 0===n&&(n="auto");var r=$$6(t);return r.attr("width",e),r.attr("height",n),r[0].outerHTML}tn$2({target:"String",proto:!0,forced:(nn$2="trim",C$2((function(){return !!ln$2[nn$2]()||"​᠎"!=="​᠎"[nn$2]()||mn$2&&ln$2[nn$2].name!==nn$2})))},{trim:function(){return bn$2(this)}}),tn$2({global:!0},{globalThis:R$2}),append&&($$6.fn.append=append),on$7&&($$6.fn.on=on$7),focus&&($$6.fn.focus=focus),attr&&($$6.fn.attr=attr),val&&($$6.fn.val=val),html&&($$6.fn.html=html),parent&&($$6.fn.parent=parent),hasClass&&($$6.fn.hasClass=hasClass),empty&&($$6.fn.empty=empty);var xn$2={type:"video",renderElem:function(t,n,r){var o,i=t,u=i.src,a=void 0===u?"":u,f=i.poster,l=void 0===f?"":f,d=i.width,p=void 0===d?"auto":d,v=i.height,h=void 0===v?"auto":v,y=ol$1.isNodeSelected(r,t);if(0===a.trim().indexOf("<iframe ")){var g=Sn$2(a,p,h);o=jsx("div",{className:"w-e-textarea-video-container","data-selected":y?"true":"",innerHTML:g});}else {var m=jsx("video",{poster:l,controls:!0},jsx("source",{src:a,type:"video/mp4"}),"Sorry, your browser doesn't support embedded videos.\n 抱歉，浏览器不支持 video 视频");"auto"!==p&&(m.data.width=p),"auto"!==h&&(m.data.height=h),o=jsx("div",{className:"w-e-textarea-video-container","data-selected":y?"true":""},m);}return h$3("div",{props:{contentEditable:!1},on:{mousedown:function(t){return t.preventDefault()}}},o)}};var On$2,En$2={type:"video",elemToHtml:function(t,e){var n=t,r=n.src,o=void 0===r?"":r,i=n.poster,u=void 0===i?"":i,a=n.width,c=void 0===a?"auto":a,s=n.height,f=void 0===s?"auto":s,l='<div data-w-e-type="video" data-w-e-is-void>\n';return 0===o.trim().indexOf("<iframe ")?l+=Sn$2(o,c,f):l+='<video poster="'+u+'" controls="true" width="'+c+'" height="'+f+'"><source src="'+o+'" type="video/mp4"/></video>',l+="\n</div>"}},jn$2=Object.keys||function(t){return Fe$2(t,_e$2)},In$2=N$2?Object.defineProperties:function(t,e){Jt$2(t);for(var n,r=tt$2(e),o=jn$2(e),i=o.length,u=0;i>u;)te$2.f(t,n=o[u++],r[n]);return t},Pn$2=ot$2("document","documentElement"),Tn$2=fe$2("IE_PROTO"),Mn$2=function(){},An$2=function(t){return "<script>"+t+"<\/script>"},kn$2=function(t){t.write(An$2("")),t.close();var e=t.parentWindow.Object;return t=null,e},Rn$2=function(){try{On$2=new ActiveXObject("htmlfile");}catch(t){}var t,e;Rn$2="undefined"!=typeof document?document.domain&&On$2?kn$2(On$2):((e=Wt$2("iframe")).style.display="none",Pn$2.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write(An$2("document.F=Object")),t.close(),t.F):kn$2(On$2);for(var n=_e$2.length;n--;)delete Rn$2.prototype[_e$2[n]];return Rn$2()};le$2[Tn$2]=!0;var Cn$2=Object.create||function(t,e){var n;return null!==t?(Mn$2.prototype=Jt$2(t),n=new Mn$2,Mn$2.prototype=null,n[Tn$2]=t):n=Rn$2(),void 0===e?n:In$2(n,e)},Nn$2=Ft$2("unscopables"),Ln$2=Array.prototype;null==Ln$2[Nn$2]&&te$2.f(Ln$2,Nn$2,{configurable:!0,value:Cn$2(null)});var Vn$2=function(t){Ln$2[Nn$2][t]=!0;},zn$2=Le$2.includes;tn$2({target:"Array",proto:!0},{includes:function(t){return zn$2(this,t,arguments.length>1?arguments[1]:void 0)}}),Vn$2("includes");var Fn$2={selector:"iframe,video,p",preParseHtml:function(t){var e=$$6(t),n=e;if("p"===wn$2(e)){var r=e.children();if(1===r.length){var o=r[0],i=o.tagName.toLowerCase();["iframe","video"].includes(i)&&(n=$$6(o));}}var u=wn$2(n);if("iframe"!==u&&"video"!==u)return n[0];if("video"===n.parent().attr("data-w-e-type"))return n[0];var a=$$6('<div data-w-e-type="video" data-w-e-is-void></div>');return a.append(n),a[0]}},_n$2=W$2(W$2.bind),Dn$2=function(t,e){return bt$2(t),void 0===e?t:_n$2?_n$2(t,e):function(){return t.apply(e,arguments)}},$n$2=Array.isArray||function(t){return "Array"==X$2(t)},Hn$2=function(){},Bn$2=[],Gn$2=ot$2("Reflect","construct"),Wn$2=/^\s*(?:class|function)\b/,Un$2=W$2(Wn$2.exec),Kn$2=!Wn$2.exec(Hn$2),Xn$2=function(t){if(!et$2(t))return !1;try{return Gn$2(Hn$2,Bn$2,t),!0}catch(t){return !1}},Yn$2=!Gn$2||C$2((function(){var t;return Xn$2(Xn$2.call)||!Xn$2(Object)||!Xn$2((function(){t=!0;}))||t}))?function(t){if(!et$2(t))return !1;switch(cn$2(t)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return !1}return Kn$2||!!Un$2(Wn$2,ue$2(t))}:Xn$2,qn$2=Ft$2("species"),Jn$2=R$2.Array,Qn$2=function(t,e){return new(function(t){var e;return $n$2(t)&&(e=t.constructor,(Yn$2(e)&&(e===Jn$2||$n$2(e.prototype))||nt$2(e)&&null===(e=e[qn$2]))&&(e=void 0)),void 0===e?Jn$2:e}(t))(0===e?0:e)},Zn$2=W$2([].push),tr$1=function(t){var e=1==t,n=2==t,r=3==t,o=4==t,i=6==t,u=7==t,a=5==t||i;return function(c,s,f,l){for(var d,p,v=Pt$2(c),h=J$2(v),y=Dn$2(s,f),g=Ce$2(h),m=0,b=l||Qn$2,w=e?b(c,g):n||u?b(c,0):void 0;g>m;m++)if((a||m in h)&&(p=y(d=h[m],m,v),t))if(e)w[m]=p;else if(p)switch(t){case 3:return !0;case 5:return d;case 6:return m;case 2:Zn$2(w,d);}else switch(t){case 4:return !1;case 7:Zn$2(w,d);}return i?-1:r||o?o:w}},er$1={forEach:tr$1(0),map:tr$1(1),filter:tr$1(2),some:tr$1(3),every:tr$1(4),find:tr$1(5),findIndex:tr$1(6),filterReject:tr$1(7)},nr$1=er$1.find,rr$1=!0;"find"in[]&&Array(1).find((function(){rr$1=!1;})),tn$2({target:"Array",proto:!0,forced:rr$1},{find:function(t){return nr$1(this,t,arguments.length>1?arguments[1]:void 0)}}),Vn$2("find");var or$1=rn$2?{}.toString:function(){return "[object "+cn$2(this)+"]"};function ir$1(t,e,n,r){return void 0===e&&(e=""),void 0===n&&(n="auto"),void 0===r&&(r="auto"),{type:"video",src:t,poster:e,width:n,height:r,children:[{text:""}]}}rn$2||Ee$2(Object.prototype,"toString",or$1,{unsafe:!0});var ur$1,ar$1,cr$1={selector:'div[data-w-e-type="video"]',parseElemHtml:function(t,e,n){var r=$$6(t),o="",i="",u="auto",a="auto",c=r.find("iframe");if(c.length>0)return u=c.attr("width")||"auto",a=c.attr("height")||"auto",ir$1(o=c[0].outerHTML,i,u,a);var s=r.find("video");return (o=s.attr("src")||"")||s.length>0&&(o=s.find("source").attr("src")||""),u=s.attr("width")||"auto",a=s.attr("height")||"auto",ir$1(o,i=s.attr("poster")||"",u,a)}},sr$1=function(){var t=Jt$2(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.dotAll&&(e+="s"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e},fr$1=R$2.RegExp,lr$1=C$2((function(){var t=fr$1("a","y");return t.lastIndex=2,null!=t.exec("abcd")})),dr$1=lr$1||C$2((function(){return !fr$1("a","y").sticky})),pr$1={BROKEN_CARET:lr$1||C$2((function(){var t=fr$1("^r","gy");return t.lastIndex=2,null!=t.exec("str")})),MISSED_STICKY:dr$1,UNSUPPORTED_Y:lr$1},vr$1=R$2.RegExp,hr$1=C$2((function(){var t=vr$1(".","s");return !(t.dotAll&&t.exec("\n")&&"s"===t.flags)})),yr$1=R$2.RegExp,gr$1=C$2((function(){var t=yr$1("(?<a>b)","g");return "b"!==t.exec("b").groups.a||"bc"!=="b".replace(t,"$<a>c")})),mr$1=be$2.get,br$1=jt$2("native-string-replace",String.prototype.replace),wr$1=RegExp.prototype.exec,Sr$1=wr$1,xr$1=W$2("".charAt),Or$1=W$2("".indexOf),Er$1=W$2("".replace),jr$1=W$2("".slice),Ir$1=(ar$1=/b*/g,V$2(wr$1,ur$1=/a/,"a"),V$2(wr$1,ar$1,"a"),0!==ur$1.lastIndex||0!==ar$1.lastIndex),Pr$1=pr$1.BROKEN_CARET,Tr$1=void 0!==/()??/.exec("")[1];(Ir$1||Tr$1||Pr$1||hr$1||gr$1)&&(Sr$1=function(t){var e,n,r,o,i,u,a,c=this,s=mr$1(c),f=fn$2(t),l=s.raw;if(l)return l.lastIndex=c.lastIndex,e=V$2(Sr$1,l,f),c.lastIndex=l.lastIndex,e;var d=s.groups,p=Pr$1&&c.sticky,v=V$2(sr$1,c),h=c.source,y=0,g=f;if(p&&(v=Er$1(v,"y",""),-1===Or$1(v,"g")&&(v+="g"),g=jr$1(f,c.lastIndex),c.lastIndex>0&&(!c.multiline||c.multiline&&"\n"!==xr$1(f,c.lastIndex-1))&&(h="(?: "+h+")",g=" "+g,y++),n=new RegExp("^(?:"+h+")",v)),Tr$1&&(n=new RegExp("^"+h+"$(?!\\s)",v)),Ir$1&&(r=c.lastIndex),o=V$2(wr$1,p?n:c,g),p?o?(o.input=jr$1(o.input,y),o[0]=jr$1(o[0],y),o.index=c.lastIndex,c.lastIndex+=o[0].length):c.lastIndex=0:Ir$1&&o&&(c.lastIndex=c.global?o.index+o[0].length:r),Tr$1&&o&&o.length>1&&V$2(br$1,o[0],n,(function(){for(i=1;i<arguments.length-2;i++)void 0===arguments[i]&&(o[i]=void 0);})),o&&d)for(o.groups=u=Cn$2(null),i=0;i<d.length;i++)u[(a=d[i])[0]]=o[a[1]];return o});var Mr$1=Sr$1;tn$2({target:"RegExp",proto:!0,forced:/./.exec!==Mr$1},{exec:Mr$1});var Ar$1=Function.prototype,kr$1=Ar$1.apply,Rr$1=Ar$1.bind,Cr$1=Ar$1.call,Nr$1="object"==typeof Reflect&&Reflect.apply||(Rr$1?Cr$1.bind(kr$1):function(){return Cr$1.apply(kr$1,arguments)}),Lr$1=Ft$2("species"),Vr$1=RegExp.prototype,zr$1=W$2("".charAt),Fr$1=W$2("".charCodeAt),_r$1=W$2("".slice),Dr$1=function(t){return function(e,n){var r,o,i=fn$2(Z$2(e)),u=Pe$2(n),a=i.length;return u<0||u>=a?t?"":void 0:(r=Fr$1(i,u))<55296||r>56319||u+1===a||(o=Fr$1(i,u+1))<56320||o>57343?t?zr$1(i,u):r:t?_r$1(i,u,u+2):o-56320+(r-55296<<10)+65536}},$r$1={codeAt:Dr$1(!1),charAt:Dr$1(!0)},Hr$1=$r$1.charAt,Br$1=function(t,e,n){return e+(n?Hr$1(t,e).length:1)},Gr$1=Math.floor,Wr$1=W$2("".charAt),Ur$1=W$2("".replace),Kr$1=W$2("".slice),Xr$1=/\$([$&'`]|\d{1,2}|<[^>]*>)/g,Yr$1=/\$([$&'`]|\d{1,2})/g,qr$1=function(t,e,n,r,o,i){var u=n+t.length,a=r.length,c=Yr$1;return void 0!==o&&(o=Pt$2(o),c=Xr$1),Ur$1(i,c,(function(i,c){var s;switch(Wr$1(c,0)){case"$":return "$";case"&":return t;case"`":return Kr$1(e,0,n);case"'":return Kr$1(e,u);case"<":s=o[Kr$1(c,1,-1)];break;default:var f=+c;if(0===f)return i;if(f>a){var l=Gr$1(f/10);return 0===l?i:l<=a?void 0===r[l-1]?Wr$1(c,1):r[l-1]+Wr$1(c,1):i}s=r[f-1];}return void 0===s?"":s}))},Jr$1=R$2.TypeError,Qr$1=function(t,e){var n=t.exec;if(et$2(n)){var r=V$2(n,t,e);return null!==r&&Jt$2(r),r}if("RegExp"===X$2(t))return V$2(Mr$1,t,e);throw Jr$1("RegExp#exec called on incompatible receiver")},Zr$1=Ft$2("replace"),to$1=Math.max,eo$1=Math.min,no$1=W$2([].concat),ro$1=W$2([].push),oo$1=W$2("".indexOf),io$1=W$2("".slice),uo$1="$0"==="a".replace(/./,"$0"),ao$1=!!/./[Zr$1]&&""===/./[Zr$1]("a","$0");function co$1(t){return void 0===t&&(t="r"),t+"-"+nanoid$3()}!function(t,e,n,r){var o=Ft$2(t),i=!C$2((function(){var e={};return e[o]=function(){return 7},7!=""[t](e)})),u=i&&!C$2((function(){var e=!1,n=/a/;return "split"===t&&((n={}).constructor={},n.constructor[Lr$1]=function(){return n},n.flags="",n[o]=/./[o]),n.exec=function(){return e=!0,null},n[o](""),!e}));if(!i||!u||n){var a=W$2(/./[o]),c=e(o,""[t],(function(t,e,n,r,o){var u=W$2(t),c=e.exec;return c===Mr$1||c===Vr$1.exec?i&&!o?{done:!0,value:a(e,n,r)}:{done:!0,value:u(n,e,r)}:{done:!1}}));Ee$2(String.prototype,t,c[0]),Ee$2(Vr$1,o,c[1]);}r&&ee$2(Vr$1[o],"sham",!0);}("replace",(function(t,e,n){var r=ao$1?"$":"$0";return [function(t,n){var r=Z$2(this),o=null==t?void 0:wt$2(t,Zr$1);return o?V$2(o,t,r,n):V$2(e,fn$2(r),t,n)},function(t,o){var i=Jt$2(this),u=fn$2(t);if("string"==typeof o&&-1===oo$1(o,r)&&-1===oo$1(o,"$<")){var a=n(e,i,u,o);if(a.done)return a.value}var c=et$2(o);c||(o=fn$2(o));var s=i.global;if(s){var f=i.unicode;i.lastIndex=0;}for(var l=[];;){var d=Qr$1(i,u);if(null===d)break;if(ro$1(l,d),!s)break;""===fn$2(d[0])&&(i.lastIndex=Br$1(u,Re$2(i.lastIndex),f));}for(var p,v="",h=0,y=0;y<l.length;y++){for(var g=fn$2((d=l[y])[0]),m=to$1(eo$1(Pe$2(d.index),u.length),0),b=[],w=1;w<d.length;w++)ro$1(b,void 0===(p=d[w])?p:String(p));var S=d.groups;if(c){var x=no$1([g],b,m,u);void 0!==S&&ro$1(x,S);var O=fn$2(Nr$1(o,void 0,x));}else O=qr$1(g,u,m,b,S,o);m>=h&&(v+=io$1(u,h,m)+O,h=m+g.length);}return v+io$1(u,h)}]}),!!C$2((function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")}))||!uo$1||ao$1);var so$1=R$2.Promise,fo$1=function(t,e,n){for(var r in e)Ee$2(t,r,e[r],n);return t},lo$1=R$2.String,po$1=R$2.TypeError,vo$1=Object.setPrototypeOf||("__proto__"in{}?function(){var t,e=!1,n={};try{(t=W$2(Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set))(n,[]),e=n instanceof Array;}catch(t){}return function(n,r){return Jt$2(n),function(t){if("object"==typeof t||et$2(t))return t;throw po$1("Can't set "+lo$1(t)+" as a prototype")}(r),e?t(n,r):n.__proto__=r,n}}():void 0),ho$1=te$2.f,yo$1=Ft$2("toStringTag"),go$1=function(t,e,n){t&&!Mt$2(t=n?t:t.prototype,yo$1)&&ho$1(t,yo$1,{configurable:!0,value:e});},mo$1=Ft$2("species"),bo$1=R$2.TypeError,wo$1=function(t,e){if(it$2(e,t))return t;throw bo$1("Incorrect invocation")},So$1={},xo$1=Ft$2("iterator"),Oo$1=Array.prototype,Eo$1=Ft$2("iterator"),jo$1=function(t){if(null!=t)return wt$2(t,Eo$1)||wt$2(t,"@@iterator")||So$1[cn$2(t)]},Io$1=R$2.TypeError,Po$1=function(t,e,n){var r,o;Jt$2(t);try{if(!(r=wt$2(t,"return"))){if("throw"===e)throw n;return n}r=V$2(r,t);}catch(t){o=!0,r=t;}if("throw"===e)throw n;if(o)throw r;return Jt$2(r),n},To$1=R$2.TypeError,Mo$1=function(t,e){this.stopped=t,this.result=e;},Ao$1=Mo$1.prototype,ko$1=function(t,e,n){var r,o,i,u,a,c,s,f,l=n&&n.that,d=!(!n||!n.AS_ENTRIES),p=!(!n||!n.IS_ITERATOR),v=!(!n||!n.INTERRUPTED),h=Dn$2(e,l),y=function(t){return r&&Po$1(r,"normal",t),new Mo$1(!0,t)},g=function(t){return d?(Jt$2(t),v?h(t[0],t[1],y):h(t[0],t[1])):v?h(t,y):h(t)};if(p)r=t;else {if(!(o=jo$1(t)))throw To$1(gt$2(t)+" is not iterable");if(void 0!==(f=o)&&(So$1.Array===f||Oo$1[xo$1]===f)){for(i=0,u=Ce$2(t);u>i;i++)if((a=g(t[i]))&&it$2(Ao$1,a))return a;return new Mo$1(!1)}r=function(t,e){var n=arguments.length<2?jo$1(t):e;if(bt$2(n))return Jt$2(V$2(n,t));throw Io$1(gt$2(t)+" is not iterable")}(t,o);}for(c=r.next;!(s=V$2(c,r)).done;){try{a=g(s.value);}catch(t){Po$1(r,"throw",t);}if("object"==typeof a&&a&&it$2(Ao$1,a))return a}return new Mo$1(!1)},Ro$1=Ft$2("iterator"),Co$1=!1;try{var No$1=0,Lo$1={next:function(){return {done:!!No$1++}},return:function(){Co$1=!0;}};Lo$1[Ro$1]=function(){return this},Array.from(Lo$1,(function(){throw 2}));}catch(t){}var Vo$1,zo$1,Fo$1,_o$1,Do$1=function(t,e){if(!e&&!Co$1)return !1;var n=!1;try{var r={};r[Ro$1]=function(){return {next:function(){return {done:n=!0}}}},t(r);}catch(t){}return n},$o$1=R$2.TypeError,Ho$1=Ft$2("species"),Bo$1=function(t,e){var n,r=Jt$2(t).constructor;return void 0===r||null==(n=Jt$2(r)[Ho$1])?e:function(t){if(Yn$2(t))return t;throw $o$1(gt$2(t)+" is not a constructor")}(n)},Go$1=W$2([].slice),Wo$1=/(?:ipad|iphone|ipod).*applewebkit/i.test(ut$2),Uo$1="process"==X$2(R$2.process),Ko$1=R$2.setImmediate,Xo$1=R$2.clearImmediate,Yo$1=R$2.process,qo$1=R$2.Dispatch,Jo$1=R$2.Function,Qo$1=R$2.MessageChannel,Zo$1=R$2.String,ti$1=0,ei$1={};try{Vo$1=R$2.location;}catch(t){}var ni$1=function(t){if(Mt$2(ei$1,t)){var e=ei$1[t];delete ei$1[t],e();}},ri$1=function(t){return function(){ni$1(t);}},oi$1=function(t){ni$1(t.data);},ii$1=function(t){R$2.postMessage(Zo$1(t),Vo$1.protocol+"//"+Vo$1.host);};Ko$1&&Xo$1||(Ko$1=function(t){var e=Go$1(arguments,1);return ei$1[++ti$1]=function(){Nr$1(et$2(t)?t:Jo$1(t),void 0,e);},zo$1(ti$1),ti$1},Xo$1=function(t){delete ei$1[t];},Uo$1?zo$1=function(t){Yo$1.nextTick(ri$1(t));}:qo$1&&qo$1.now?zo$1=function(t){qo$1.now(ri$1(t));}:Qo$1&&!Wo$1?(_o$1=(Fo$1=new Qo$1).port2,Fo$1.port1.onmessage=oi$1,zo$1=Dn$2(_o$1.postMessage,_o$1)):R$2.addEventListener&&et$2(R$2.postMessage)&&!R$2.importScripts&&Vo$1&&"file:"!==Vo$1.protocol&&!C$2(ii$1)?(zo$1=ii$1,R$2.addEventListener("message",oi$1,!1)):zo$1="onreadystatechange"in Wt$2("script")?function(t){Pn$2.appendChild(Wt$2("script")).onreadystatechange=function(){Pn$2.removeChild(this),ni$1(t);};}:function(t){setTimeout(ri$1(t),0);});var ui$1,ai$1,ci$1,si$1,fi$1,li$1,di$1,pi$1,vi$1={set:Ko$1,clear:Xo$1},hi$1=/ipad|iphone|ipod/i.test(ut$2)&&void 0!==R$2.Pebble,yi$1=/web0s(?!.*chrome)/i.test(ut$2),gi$1=Xt$2.f,mi$1=vi$1.set,bi$1=R$2.MutationObserver||R$2.WebKitMutationObserver,wi$1=R$2.document,Si$1=R$2.process,xi$1=R$2.Promise,Oi$1=gi$1(R$2,"queueMicrotask"),Ei$1=Oi$1&&Oi$1.value;Ei$1||(ui$1=function(){var t,e;for(Uo$1&&(t=Si$1.domain)&&t.exit();ai$1;){e=ai$1.fn,ai$1=ai$1.next;try{e();}catch(t){throw ai$1?si$1():ci$1=void 0,t}}ci$1=void 0,t&&t.enter();},Wo$1||Uo$1||yi$1||!bi$1||!wi$1?!hi$1&&xi$1&&xi$1.resolve?((di$1=xi$1.resolve(void 0)).constructor=xi$1,pi$1=Dn$2(di$1.then,di$1),si$1=function(){pi$1(ui$1);}):Uo$1?si$1=function(){Si$1.nextTick(ui$1);}:(mi$1=Dn$2(mi$1,R$2),si$1=function(){mi$1(ui$1);}):(fi$1=!0,li$1=wi$1.createTextNode(""),new bi$1(ui$1).observe(li$1,{characterData:!0}),si$1=function(){li$1.data=fi$1=!fi$1;}));var ji$1,Ii$1,Pi$1,Ti$1,Mi$1=Ei$1||function(t){var e={fn:t,next:void 0};ci$1&&(ci$1.next=e),ai$1||(ai$1=e,si$1()),ci$1=e;},Ai$1=function(t){var e,n;this.promise=new t((function(t,r){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=r;})),this.resolve=bt$2(e),this.reject=bt$2(n);},ki$1={f:function(t){return new Ai$1(t)}},Ri$1=function(t){try{return {error:!1,value:t()}}catch(t){return {error:!0,value:t}}},Ci$1="object"==typeof window,Ni$1=vi$1.set,Li$1=Ft$2("species"),Vi$1="Promise",zi$1=be$2.getterFor(Vi$1),Fi$1=be$2.set,_i$1=be$2.getterFor(Vi$1),Di$1=so$1&&so$1.prototype,$i$1=so$1,Hi$1=Di$1,Bi$1=R$2.TypeError,Gi$1=R$2.document,Wi$1=R$2.process,Ui$1=ki$1.f,Ki$1=Ui$1,Xi$1=!!(Gi$1&&Gi$1.createEvent&&R$2.dispatchEvent),Yi$1=et$2(R$2.PromiseRejectionEvent),qi$1=!1,Ji$1=Qe$2(Vi$1,(function(){var t=ue$2($i$1),e=t!==String($i$1);if(!e&&66===lt$2)return !0;if(lt$2>=51&&/native code/.test(t))return !1;var n=new $i$1((function(t){t(1);})),r=function(t){t((function(){}),(function(){}));};return (n.constructor={})[Li$1]=r,!(qi$1=n.then((function(){}))instanceof r)||!e&&Ci$1&&!Yi$1})),Qi$1=Ji$1||!Do$1((function(t){$i$1.all(t).catch((function(){}));})),Zi$1=function(t){var e;return !(!nt$2(t)||!et$2(e=t.then))&&e},tu$1=function(t,e){if(!t.notified){t.notified=!0;var n=t.reactions;Mi$1((function(){for(var r=t.value,o=1==t.state,i=0;n.length>i;){var u,a,c,s=n[i++],f=o?s.ok:s.fail,l=s.resolve,d=s.reject,p=s.domain;try{f?(o||(2===t.rejection&&ou$1(t),t.rejection=1),!0===f?u=r:(p&&p.enter(),u=f(r),p&&(p.exit(),c=!0)),u===s.promise?d(Bi$1("Promise-chain cycle")):(a=Zi$1(u))?V$2(a,u,l,d):l(u)):d(r);}catch(t){p&&!c&&p.exit(),d(t);}}t.reactions=[],t.notified=!1,e&&!t.rejection&&nu$1(t);}));}},eu$1=function(t,e,n){var r,o;Xi$1?((r=Gi$1.createEvent("Event")).promise=e,r.reason=n,r.initEvent(t,!1,!0),R$2.dispatchEvent(r)):r={promise:e,reason:n},!Yi$1&&(o=R$2["on"+t])?o(r):"unhandledrejection"===t&&function(t,e){var n=R$2.console;n&&n.error&&(1==arguments.length?n.error(t):n.error(t,e));}("Unhandled promise rejection",n);},nu$1=function(t){V$2(Ni$1,R$2,(function(){var e,n=t.facade,r=t.value;if(ru$1(t)&&(e=Ri$1((function(){Uo$1?Wi$1.emit("unhandledRejection",r,n):eu$1("unhandledrejection",n,r);})),t.rejection=Uo$1||ru$1(t)?2:1,e.error))throw e.value}));},ru$1=function(t){return 1!==t.rejection&&!t.parent},ou$1=function(t){V$2(Ni$1,R$2,(function(){var e=t.facade;Uo$1?Wi$1.emit("rejectionHandled",e):eu$1("rejectionhandled",e,t.value);}));},iu$1=function(t,e,n){return function(r){t(e,r,n);}},uu$1=function(t,e,n){t.done||(t.done=!0,n&&(t=n),t.value=e,t.state=2,tu$1(t,!0));},au$1=function(t,e,n){if(!t.done){t.done=!0,n&&(t=n);try{if(t.facade===e)throw Bi$1("Promise can't be resolved itself");var r=Zi$1(e);r?Mi$1((function(){var n={done:!1};try{V$2(r,e,iu$1(au$1,n,t),iu$1(uu$1,n,t));}catch(e){uu$1(n,e,t);}})):(t.value=e,t.state=1,tu$1(t,!1));}catch(e){uu$1({done:!1},e,t);}}};if(Ji$1&&(Hi$1=($i$1=function(t){wo$1(this,Hi$1),bt$2(t),V$2(ji$1,this);var e=zi$1(this);try{t(iu$1(au$1,e),iu$1(uu$1,e));}catch(t){uu$1(e,t);}}).prototype,(ji$1=function(t){Fi$1(this,{type:Vi$1,done:!1,notified:!1,parent:!1,reactions:[],rejection:!1,state:0,value:void 0});}).prototype=fo$1(Hi$1,{then:function(t,e){var n=_i$1(this),r=n.reactions,o=Ui$1(Bo$1(this,$i$1));return o.ok=!et$2(t)||t,o.fail=et$2(e)&&e,o.domain=Uo$1?Wi$1.domain:void 0,n.parent=!0,r[r.length]=o,0!=n.state&&tu$1(n,!1),o.promise},catch:function(t){return this.then(void 0,t)}}),Ii$1=function(){var t=new ji$1,e=zi$1(t);this.promise=t,this.resolve=iu$1(au$1,e),this.reject=iu$1(uu$1,e);},ki$1.f=Ui$1=function(t){return t===$i$1||t===Pi$1?new Ii$1(t):Ki$1(t)},et$2(so$1)&&Di$1!==Object.prototype)){Ti$1=Di$1.then,qi$1||(Ee$2(Di$1,"then",(function(t,e){var n=this;return new $i$1((function(t,e){V$2(Ti$1,n,t,e);})).then(t,e)}),{unsafe:!0}),Ee$2(Di$1,"catch",Hi$1.catch,{unsafe:!0}));try{delete Di$1.constructor;}catch(t){}vo$1&&vo$1(Di$1,Hi$1);}function cu$1(t,e,n){return void 0===n&&(n=""),x$2(this,void 0,void 0,(function(){var r,o,i,a,c,s,f;return O$2(this,(function(l){switch(l.label){case 0:return e?(t.restoreSelection(),r=t.getMenuConfig("insertVideo"),o=r.onInsertedVideo,i=r.checkVideo,a=r.parseVideoSrc,[4,i(e,n)]):[2];case 1:return "string"==typeof(c=l.sent())?(t.alert(c,"error"),[2]):null==c?[2]:[4,a(e)];case 2:return 0!==(s=l.sent()).trim().indexOf("<iframe ")&&(s=s.replace(/</g,"&lt;").replace(/>/g,"&gt;")),f={type:"video",src:s,poster:n,children:[{text:""}]},Promise.resolve().then((function(){Transforms.insertNodes(t,f);})),o(f),[2]}}))}))}function su$1(){return co$1("w-e-insert-video")}tn$2({global:!0,wrap:!0,forced:Ji$1},{Promise:$i$1}),go$1($i$1,Vi$1,!1),function(t){var e=ot$2(t),n=te$2.f;N$2&&e&&!e[mo$1]&&n(e,mo$1,{configurable:!0,get:function(){return this}});}(Vi$1),Pi$1=ot$2(Vi$1),tn$2({target:Vi$1,stat:!0,forced:Ji$1},{reject:function(t){var e=Ui$1(this);return V$2(e.reject,void 0,t),e.promise}}),tn$2({target:Vi$1,stat:!0,forced:Ji$1},{resolve:function(t){return function(t,e){if(Jt$2(t),nt$2(e)&&e.constructor===t)return e;var n=ki$1.f(t);return (0, n.resolve)(e),n.promise}(this,t)}}),tn$2({target:Vi$1,stat:!0,forced:Qi$1},{all:function(t){var e=this,n=Ui$1(e),r=n.resolve,o=n.reject,i=Ri$1((function(){var n=bt$2(e.resolve),i=[],u=0,a=1;ko$1(t,(function(t){var c=u++,s=!1;a++,V$2(n,e,t).then((function(t){s||(s=!0,i[c]=t,--a||r(i));}),o);})),--a||r(i);}));return i.error&&o(i.value),n.promise},race:function(t){var e=this,n=Ui$1(e),r=n.reject,o=Ri$1((function(){var o=bt$2(e.resolve);ko$1(t,(function(t){V$2(o,e,t).then(n.resolve,r);}));}));return o.error&&r(o.value),n.promise}});var fu$1=function(){function t(){this.title=cp$1("videoModule.insertVideo"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z"></path></svg>',this.tag="button",this.showModal=!0,this.modalWidth=320,this.$content=null,this.srcInputId=su$1(),this.posterInputId=su$1(),this.buttonId=su$1();}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.exec=function(t,e){},t.prototype.isDisabled=function(t){var n=t.selection;return null==n||(!Range.isCollapsed(n)||!!ol$1.getSelectedElems(t).some((function(n){var r=ol$1.getNodeType(n);return "pre"===r||("list-item"===r||!!t.isVoid(n))})))},t.prototype.getModalPositionNode=function(t){return null},t.prototype.getModalContentElem=function(t){var e=this,i=this,u=i.srcInputId,a=i.posterInputId,c=i.buttonId,s=j$2(zd$1(cp$1("videoModule.videoSrc"),u,cp$1("videoModule.videoSrcPlaceHolder")),2),l=s[0],d=s[1],p=j$2(zd$1(cp$1("videoModule.videoPoster"),a,cp$1("videoModule.videoPosterPlaceHolder")),2),v=p[0],h=p[1],y=$$6(d),g=$$6(h),m=j$2(Ud(c,cp$1("videoModule.ok")),1)[0];if(null==this.$content){var b=$$6("<div></div>");b.on("click","#"+c,(function(n){return x$2(e,void 0,void 0,(function(){var e,r;return O$2(this,(function(o){switch(o.label){case 0:return n.preventDefault(),e=b.find("#"+u).val().trim(),r=b.find("#"+a).val().trim(),[4,cu$1(t,e,r)];case 1:return o.sent(),t.hidePanelOrModal(),[2]}}))}))})),this.$content=b;}var w=this.$content;return w.empty(),w.append(l),w.append(v),w.append(m),y.val(""),g.val(""),setTimeout((function(){y.focus();})),w[0]},t}(),lu$1=W$2([].join),du$1=J$2!=Object,pu$1=function(t,e){var n=[][t];return !!n&&C$2((function(){n.call(null,e||function(){throw 1},1);}))}("join",",");tn$2({target:"Array",proto:!0,forced:du$1||!pu$1},{join:function(t){return lu$1(tt$2(this),void 0===t?",":t)}});var vu$1,hu$1,yu$1,gu$1=!C$2((function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype})),mu$1=fe$2("IE_PROTO"),bu$1=R$2.Object,wu$1=bu$1.prototype,Su$1=gu$1?bu$1.getPrototypeOf:function(t){var e=Pt$2(t);if(Mt$2(e,mu$1))return e[mu$1];var n=e.constructor;return et$2(n)&&e instanceof n?n.prototype:e instanceof bu$1?wu$1:null},xu$1=Ft$2("iterator"),Ou$1=!1;[].keys&&("next"in(yu$1=[].keys())?(hu$1=Su$1(Su$1(yu$1)))!==Object.prototype&&(vu$1=hu$1):Ou$1=!0);var Eu$1=null==vu$1||C$2((function(){var t={};return vu$1[xu$1].call(t)!==t}));Eu$1&&(vu$1={}),et$2(vu$1[xu$1])||Ee$2(vu$1,xu$1,(function(){return this}));var ju$1={IteratorPrototype:vu$1,BUGGY_SAFARI_ITERATORS:Ou$1},Iu$1=ju$1.IteratorPrototype,Pu$1=function(){return this},Tu$1=Oe$2.PROPER,Mu$1=Oe$2.CONFIGURABLE,Au$1=ju$1.IteratorPrototype,ku$1=ju$1.BUGGY_SAFARI_ITERATORS,Ru$1=Ft$2("iterator"),Cu$1=function(){return this},Nu$1=function(t,e,n,r,o,i,u){!function(t,e,n,r){var o=e+" Iterator";t.prototype=Cn$2(Iu$1,{next:D$2(+!r,n)}),go$1(t,o,!1),So$1[o]=Pu$1;}(n,e,r);var a,c,s,f=function(t){if(t===o&&h)return h;if(!ku$1&&t in p)return p[t];switch(t){case"keys":case"values":case"entries":return function(){return new n(this,t)}}return function(){return new n(this)}},l=e+" Iterator",d=!1,p=t.prototype,v=p[Ru$1]||p["@@iterator"]||o&&p[o],h=!ku$1&&v||f(o),y="Array"==e&&p.entries||v;if(y&&(a=Su$1(y.call(new t)))!==Object.prototype&&a.next&&(Su$1(a)!==Au$1&&(vo$1?vo$1(a,Au$1):et$2(a[Ru$1])||Ee$2(a,Ru$1,Cu$1)),go$1(a,l,!0)),Tu$1&&"values"==o&&v&&"values"!==v.name&&(Mu$1?ee$2(p,"name","values"):(d=!0,h=function(){return V$2(v,this)})),o)if(c={values:f("values"),keys:i?h:f("keys"),entries:f("entries")},u)for(s in c)(ku$1||d||!(s in p))&&Ee$2(p,s,c[s]);else tn$2({target:e,proto:!0,forced:ku$1||d},c);return p[Ru$1]!==h&&Ee$2(p,Ru$1,h,{name:o}),So$1[e]=h,c},Lu$1=be$2.set,Vu$1=be$2.getterFor("Array Iterator"),zu$1=Nu$1(Array,"Array",(function(t,e){Lu$1(this,{type:"Array Iterator",target:tt$2(t),index:0,kind:e});}),(function(){var t=Vu$1(this),e=t.target,n=t.kind,r=t.index++;return !e||r>=e.length?(t.target=void 0,{value:void 0,done:!0}):"keys"==n?{value:r,done:!1}:"values"==n?{value:e[r],done:!1}:{value:[r,e[r]],done:!1}}),"values");So$1.Arguments=So$1.Array,Vn$2("keys"),Vn$2("values"),Vn$2("entries");var Fu$1=$r$1.charAt,_u$1=be$2.set,Du$1=be$2.getterFor("String Iterator");Nu$1(String,"String",(function(t){_u$1(this,{type:"String Iterator",string:fn$2(t),index:0});}),(function(){var t,e=Du$1(this),n=e.string,r=e.index;return r>=n.length?{value:void 0,done:!0}:(t=Fu$1(n,r),e.index+=t.length,{value:t,done:!1})}));var $u$1=function(t,e,n){var r=Ht$2(e);r in t?te$2.f(t,r,D$2(0,n)):t[r]=n;},Hu$1=R$2.Array,Bu$1=Math.max,Gu$1=$e$2.f,Wu$1="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],Uu$1=function(t){try{return Gu$1(t)}catch(t){return function(t,e,n){for(var r=Ce$2(t),o=Ae$2(e,r),i=Ae$2(void 0===n?r:n,r),u=Hu$1(Bu$1(i-o,0)),a=0;o<i;o++,a++)$u$1(u,a,t[o]);return u.length=a,u}(Wu$1)}},Ku$1={f:function(t){return Wu$1&&"Window"==X$2(t)?Uu$1(t):Gu$1(tt$2(t))}},Xu$1=C$2((function(){if("function"==typeof ArrayBuffer){var t=new ArrayBuffer(8);Object.isExtensible(t)&&Object.defineProperty(t,"a",{value:8});}})),Yu$1=Object.isExtensible,qu$1=C$2((function(){Yu$1(1);}))||Xu$1?function(t){return !!nt$2(t)&&((!Xu$1||"ArrayBuffer"!=X$2(t))&&(!Yu$1||Yu$1(t)))}:Yu$1,Ju$1=!C$2((function(){return Object.isExtensible(Object.preventExtensions({}))})),Qu$1=T$2((function(t){var e=te$2.f,n=!1,r=Ct$2("meta"),o=0,i=function(t){e(t,r,{value:{objectID:"O"+o++,weakData:{}}});},u=t.exports={enable:function(){u.enable=function(){},n=!0;var t=$e$2.f,e=W$2([].splice),o={};o[r]=1,t(o).length&&($e$2.f=function(n){for(var o=t(n),i=0,u=o.length;i<u;i++)if(o[i]===r){e(o,i,1);break}return o},tn$2({target:"Object",stat:!0,forced:!0},{getOwnPropertyNames:Ku$1.f}));},fastKey:function(t,e){if(!nt$2(t))return "symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!Mt$2(t,r)){if(!qu$1(t))return "F";if(!e)return "E";i(t);}return t[r].objectID},getWeakData:function(t,e){if(!Mt$2(t,r)){if(!qu$1(t))return !0;if(!e)return !1;i(t);}return t[r].weakData},onFreeze:function(t){return Ju$1&&n&&qu$1(t)&&!Mt$2(t,r)&&i(t),t}};le$2[r]=!0;})),Zu$1=Qu$1.getWeakData,ta$2=be$2.set,ea$2=be$2.getterFor,na$2=er$1.find,ra$2=er$1.findIndex,oa$2=W$2([].splice),ia$2=0,ua$2=function(t){return t.frozen||(t.frozen=new aa$2)},aa$2=function(){this.entries=[];},ca$2=function(t,e){return na$2(t.entries,(function(t){return t[0]===e}))};aa$2.prototype={get:function(t){var e=ca$2(this,t);if(e)return e[1]},has:function(t){return !!ca$2(this,t)},set:function(t,e){var n=ca$2(this,t);n?n[1]=e:this.entries.push([t,e]);},delete:function(t){var e=ra$2(this.entries,(function(e){return e[0]===t}));return ~e&&oa$2(this.entries,e,1),!!~e}};var sa$2,fa$2={getConstructor:function(t,e,n,r){var o=t((function(t,o){wo$1(t,i),ta$2(t,{type:e,id:ia$2++,frozen:void 0}),null!=o&&ko$1(o,t[r],{that:t,AS_ENTRIES:n});})),i=o.prototype,u=ea$2(e),a=function(t,e,n){var r=u(t),o=Zu$1(Jt$2(e),!0);return !0===o?ua$2(r).set(e,n):o[r.id]=n,t};return fo$1(i,{delete:function(t){var e=u(this);if(!nt$2(t))return !1;var n=Zu$1(t);return !0===n?ua$2(e).delete(t):n&&Mt$2(n,e.id)&&delete n[e.id]},has:function(t){var e=u(this);if(!nt$2(t))return !1;var n=Zu$1(t);return !0===n?ua$2(e).has(t):n&&Mt$2(n,e.id)}}),fo$1(i,n?{get:function(t){var e=u(this);if(nt$2(t)){var n=Zu$1(t);return !0===n?ua$2(e).get(t):n?n[e.id]:void 0}},set:function(t,e){return a(this,t,e)}}:{add:function(t){return a(this,t,!0)}}),o}},la$2=be$2.enforce,da$2=!R$2.ActiveXObject&&"ActiveXObject"in R$2,pa$2=function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}},va$2=function(t,e,n){var r=-1!==t.indexOf("Map"),o=-1!==t.indexOf("Weak"),i=r?"set":"add",u=R$2[t],a=u&&u.prototype,c=u,s={},f=function(t){var e=W$2(a[t]);Ee$2(a,t,"add"==t?function(t){return e(this,0===t?0:t),this}:"delete"==t?function(t){return !(o&&!nt$2(t))&&e(this,0===t?0:t)}:"get"==t?function(t){return o&&!nt$2(t)?void 0:e(this,0===t?0:t)}:"has"==t?function(t){return !(o&&!nt$2(t))&&e(this,0===t?0:t)}:function(t,n){return e(this,0===t?0:t,n),this});};if(Qe$2(t,!et$2(u)||!(o||a.forEach&&!C$2((function(){(new u).entries().next();})))))c=n.getConstructor(e,t,r,i),Qu$1.enable();else if(Qe$2(t,!0)){var l=new c,d=l[i](o?{}:-0,1)!=l,p=C$2((function(){l.has(1);})),v=Do$1((function(t){new u(t);})),h=!o&&C$2((function(){for(var t=new u,e=5;e--;)t[i](e,e);return !t.has(-0)}));v||((c=e((function(t,e){wo$1(t,a);var n=function(t,e,n){var r,o;return vo$1&&et$2(r=e.constructor)&&r!==n&&nt$2(o=r.prototype)&&o!==n.prototype&&vo$1(t,o),t}(new u,t,c);return null!=e&&ko$1(e,n[i],{that:n,AS_ENTRIES:r}),n}))).prototype=a,a.constructor=c),(p||h)&&(f("delete"),f("has"),r&&f("get")),(h||d)&&f(i),o&&a.clear&&delete a.clear;}return s[t]=c,tn$2({global:!0,forced:c!=u},s),go$1(c,t),o||n.setStrong(c,t,r),c}("WeakMap",pa$2,fa$2);if(ce$2&&da$2){sa$2=fa$2.getConstructor(pa$2,"WeakMap",!0),Qu$1.enable();var ha$1=va$2.prototype,ya$1=W$2(ha$1.delete),ga$1=W$2(ha$1.has),ma$1=W$2(ha$1.get),ba$1=W$2(ha$1.set);fo$1(ha$1,{delete:function(t){if(nt$2(t)&&!qu$1(t)){var e=la$2(this);return e.frozen||(e.frozen=new sa$2),ya$1(this,t)||e.frozen.delete(t)}return ya$1(this,t)},has:function(t){if(nt$2(t)&&!qu$1(t)){var e=la$2(this);return e.frozen||(e.frozen=new sa$2),ga$1(this,t)||e.frozen.has(t)}return ga$1(this,t)},get:function(t){if(nt$2(t)&&!qu$1(t)){var e=la$2(this);return e.frozen||(e.frozen=new sa$2),ga$1(this,t)?ma$1(this,t):e.frozen.get(t)}return ma$1(this,t)},set:function(t,e){if(nt$2(t)&&!qu$1(t)){var n=la$2(this);n.frozen||(n.frozen=new sa$2),ga$1(this,t)?ba$1(this,t,e):n.frozen.set(t,e);}else ba$1(this,t,e);return this}});}var wa$1={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},Sa$1=Wt$2("span").classList,xa$1=Sa$1&&Sa$1.constructor&&Sa$1.constructor.prototype,Oa$1=xa$1===Object.prototype?void 0:xa$1,Ea$1=Ft$2("iterator"),ja=Ft$2("toStringTag"),Ia$1=zu$1.values,Pa$1=function(t,e){if(t){if(t[Ea$1]!==Ia$1)try{ee$2(t,Ea$1,Ia$1);}catch(e){t[Ea$1]=Ia$1;}if(t[ja]||ee$2(t,ja,e),wa$1[e])for(var n in zu$1)if(t[n]!==zu$1[n])try{ee$2(t,n,zu$1[n]);}catch(e){t[n]=zu$1[n];}}};for(var Ta$1 in wa$1)Pa$1(R$2[Ta$1]&&R$2[Ta$1].prototype,Ta$1);Pa$1(Oa$1,"DOMTokenList");var Ma$1=Oe$2.EXISTS,Aa$1=te$2.f,ka$1=Function.prototype,Ra$1=W$2(ka$1.toString),Ca$1=/function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/,Na$1=W$2(Ca$1.exec);N$2&&!Ma$1&&Aa$1(ka$1,"name",{configurable:!0,get:function(){try{return Na$1(Ca$1,Ra$1(this))[1]}catch(t){return ""}}});var La$1=Ft$2("species"),Va=function(t){return lt$2>=51||!C$2((function(){var e=[];return (e.constructor={})[La$1]=function(){return {foo:1}},1!==e[t](Boolean).foo}))}("slice"),za=Ft$2("species"),Fa$1=R$2.Array,_a$1=Math.max;function Da$1(t){return t.getMenuConfig("uploadVideo")}tn$2({target:"Array",proto:!0,forced:!Va},{slice:function(t,e){var n,r,o,i=tt$2(this),u=Ce$2(i),a=Ae$2(t,u),c=Ae$2(void 0===e?u:e,u);if($n$2(i)&&(n=i.constructor,(Yn$2(n)&&(n===Fa$1||$n$2(n.prototype))||nt$2(n)&&null===(n=n[za]))&&(n=void 0),n===Fa$1||void 0===n))return Go$1(i,a,c);for(r=new(void 0===n?Fa$1:n)(_a$1(c-a,0)),o=0;a<c;a++,o++)a in i&&$u$1(r,o,i[a]);return r.length=o,r}});var $a$1=new WeakMap;function Ha(t,e){return x$2(this,void 0,void 0,(function(){var n,r,o,u;return O$2(this,(function(a){switch(a.label){case 0:return n=function(t){var e=$a$1.get(t);if(null!=e)return e;var n=Da$1(t),r=n.onSuccess,o=n.onProgress,u=n.onFailed,a=n.customInsert,c=n.onError;return e=gh(S$2(S$2({},n),{onProgress:function(e){t.showProgressBar(e),o&&o(e);},onSuccess:function(e,n){if(a)return a(n,(function(e,n){return cu$1(t,e,n)})),void r(e,n);var o=n.errno,i=void 0===o?1:o,c=n.data,s=void 0===c?{}:c;if(0===i){var f=s.url,l=void 0===f?"":f,d=s.poster;cu$1(t,l,void 0===d?"":d),r(e,n);}else u(e,n);},onError:function(t,e,n){c(t,e,n);}})),$a$1.set(t,e),e}(t),r=e.name,o=e.type,u=e.size,n.addFile({name:r,type:o,size:u,data:e}),[4,n.upload()];case 1:return a.sent(),[2]}}))}))}var Ba$1=function(){function t(){this.title=cp$1("videoModule.uploadVideo"),this.iconSvg='<svg viewBox="0 0 1056 1024"><path d="M805.902261 521.819882a251.441452 251.441452 0 0 0-251.011972 246.600033 251.051015 251.051015 0 1 0 502.023944 8.823877 253.237463 253.237463 0 0 0-251.011972-255.42391z m59.463561 240.001647v129.898403h-116.701631v-129.898403h-44.041298l101.279368-103.504859 101.279368 103.504859z" p-id="6802"></path><path d="M788.254507 0.000781H99.094092A98.663439 98.663439 0 0 0 0.001171 99.093701v590.067495a98.663439 98.663439 0 0 0 99.092921 99.092921h411.7549a266.434235 266.434235 0 0 1-2.186448-41.815807 275.843767 275.843767 0 0 1 275.180024-270.729042 270.650955 270.650955 0 0 1 103.504859 19.834201V99.093701A101.51363 101.51363 0 0 0 788.254507 0.000781zM295.054441 640.747004V147.507894l394.146189 246.600033z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.exec=function(t,e){var n=this.getMenuConfig(t),r=n.allowedFileTypes,o=void 0===r?[]:r,i=n.customBrowseAndUpload;if(i)i((function(e,n){return cu$1(t,e,n)}));else {var u="";o.length>0&&(u='accept="'+o.join(", ")+'"');var a=$$6("body"),c=$$6('<input type="file" '+u+" multiple/>");c.hide(),a.append(c),c.click(),c.on("change",(function(){var e=c[0].files;!function(t,e){var n,r;x$2(this,void 0,void 0,(function(){var o,i,u,a,c,s;return O$2(this,(function(f){switch(f.label){case 0:if(null==e)return [2];o=Array.prototype.slice.call(e),i=Da$1(t).customUpload,f.label=1;case 1:f.trys.push([1,9,10,15]),u=I$2(o),f.label=2;case 2:return [4,u.next()];case 3:return (a=f.sent()).done?[3,8]:(c=a.value,i?[4,i(c,(function(e,n){return cu$1(t,e,n)}))]:[3,5]);case 4:return f.sent(),[3,7];case 5:return [4,Ha(t,c)];case 6:f.sent(),f.label=7;case 7:return [3,2];case 8:return [3,15];case 9:return s=f.sent(),n={error:s},[3,15];case 10:return f.trys.push([10,,13,14]),a&&!a.done&&(r=u.return)?[4,r.call(u)]:[3,12];case 11:f.sent(),f.label=12;case 12:return [3,14];case 13:if(n)throw n.error;return [7];case 14:return [7];case 15:return [2]}}))}));}(t,e);}));}},t.prototype.isDisabled=function(t){var n=t.selection;return null==n||(!Range.isCollapsed(n)||!!ol$1.getSelectedElems(t).some((function(n){var r=ol$1.getNodeType(n);return "pre"===r||("list-item"===r||!!t.isVoid(n))})))},t.prototype.getMenuConfig=function(t){return t.getMenuConfig("uploadVideo")},t}(),Ga=Oe$2.PROPER,Wa=RegExp.prototype,Ua$1=Wa.toString,Ka=W$2(sr$1),Xa=C$2((function(){return "/a/b"!=Ua$1.call({source:"a",flags:"b"})})),Ya=Ga&&"toString"!=Ua$1.name;function qa(){return co$1("w-e-insert-video")}(Xa||Ya)&&Ee$2(RegExp.prototype,"toString",(function(){var t=Jt$2(this),e=fn$2(t.source),n=t.flags;return "/"+e+"/"+fn$2(void 0===n&&it$2(Wa,t)&&!("flags"in Wa)?Ka(t):n)}),{unsafe:!0});var Ja=function(){function t(){this.title=cp$1("videoModule.editSize"),this.tag="button",this.showModal=!0,this.modalWidth=320,this.$content=null,this.widthInputId=qa(),this.heightInputId=qa(),this.buttonId=qa();}return t.prototype.getSelectedVideoNode=function(t){return ol$1.getSelectedNodeByType(t,"video")},t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.exec=function(t,e){},t.prototype.isDisabled=function(t){return null==t.selection||null==this.getSelectedVideoNode(t)},t.prototype.getModalPositionNode=function(t){return this.getSelectedVideoNode(t)},t.prototype.getModalContentElem=function(t){var i=this,a=i.widthInputId,c=i.heightInputId,s=i.buttonId,l=j$2(zd$1(cp$1("videoModule.width"),a,"auto"),2),d=l[0],p=l[1],v=$$6(p),h=j$2(zd$1(cp$1("videoModule.height"),c,"auto"),2),y=h[0],g=h[1],m=$$6(g),b=j$2(Ud(s,cp$1("videoModule.ok")),1)[0];if(null==this.$content){var w=$$6("<div></div>");w.on("click","#"+s,(function(n){n.preventDefault();var r=w.find("#"+a).val().trim(),o=w.find("#"+c).val().trim(),i=parseInt(r),s=parseInt(o),f=i?i.toString():"auto",l=s?s.toString():"auto";t.restoreSelection(),Transforms.setNodes(t,{width:f,height:l},{match:function(t){return ol$1.checkNodeType(t,"video")}}),t.hidePanelOrModal();})),this.$content=w;}var S=this.$content;S.empty(),S.append(d),S.append(y),S.append(b);var x=this.getSelectedVideoNode(t);if(null==x)return S[0];var O=x.width,E=void 0===O?"auto":O,I=x.height,P=void 0===I?"auto":I;return v.val(E),m.val(P),setTimeout((function(){v.focus();})),S[0]},t}();var Qa={renderElems:[xn$2],elemsToHtml:[En$2],preParseHtml:[Fn$2],parseElemsHtml:[cr$1],menus:[{key:"insertVideo",factory:function(){return new fu$1},config:{onInsertedVideo:function(t){},checkVideo:function(t,e){return !0},parseVideoSrc:function(t){return t}}},{key:"uploadVideo",factory:function(){return new Ba$1},config:{server:"",fieldName:"wangeditor-uploaded-video",maxFileSize:10485760,maxNumberOfFiles:5,allowedFileTypes:["video/*"],meta:{},metaWithUrl:!1,withCredentials:!1,timeout:3e4,onBeforeUpload:function(t){return t},onProgress:function(t){},onSuccess:function(t,e){},onFailed:function(t,e){console.error("'"+t.name+"' upload failed",e);},onError:function(t,e,n){console.error("'"+t.name+" upload error",e,n);}}},{key:"editVideoSize",factory:function(){return new Ja}}],editorPlugin:function(t){var n=t.isVoid,r=t.normalizeNode,o=t;return o.isVoid=function(t){return "video"===t.type||n(t)},o.normalizeNode=function(t){var n=j$2(t,2),i=n[0],a=n[1];"video"===ol$1.getNodeType(i)&&(ol$1.isLastNode(o,i)&&Transforms.insertNodes(o,ol$1.genEmptyParagraph(),{at:[a[0]+1]}));return r([i,a])},o}};

sp$1("en",{uploadImgModule:{uploadImage:"Upload Image",uploadError:"{{fileName}} upload error"}}),sp$1("zh-CN",{uploadImgModule:{uploadImage:"上传图片",uploadError:"{{fileName}} 上传出错"}});var p$1="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function v$1(t){var e={exports:{}};return t(e,e.exports),e.exports}var d$1,h$1,y$1=function(t){return t&&t.Math==Math&&t},g$1=y$1("object"==typeof globalThis&&globalThis)||y$1("object"==typeof window&&window)||y$1("object"==typeof self&&self)||y$1("object"==typeof p$1&&p$1)||function(){return this}()||Function("return this")(),m$1=function(t){try{return !!t()}catch(t){return !0}},b$1=!m$1((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),w$1=Function.prototype.call,S$1=w$1.bind?w$1.bind(w$1):function(){return w$1.apply(w$1,arguments)},x$1={}.propertyIsEnumerable,O$1=Object.getOwnPropertyDescriptor,E$1={f:O$1&&!x$1.call({1:2},1)?function(t){var e=O$1(this,t);return !!e&&e.enumerable}:x$1},j$1=function(t,e){return {enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},I$1=Function.prototype,T$1=I$1.bind,A$1=I$1.call,P$1=T$1&&T$1.bind(A$1),R$1=T$1?function(t){return t&&P$1(A$1,t)}:function(t){return t&&function(){return A$1.apply(t,arguments)}},k$1=R$1({}.toString),M$1=R$1("".slice),L$1=function(t){return M$1(k$1(t),8,-1)},F$1=g$1.Object,_$1=R$1("".split),C$1=m$1((function(){return !F$1("z").propertyIsEnumerable(0)}))?function(t){return "String"==L$1(t)?_$1(t,""):F$1(t)}:F$1,z$1=g$1.TypeError,D$1=function(t){if(null==t)throw z$1("Can't call method on "+t);return t},N$1=function(t){return C$1(D$1(t))},G$1=function(t){return "function"==typeof t},U$1=function(t){return "object"==typeof t?null!==t:G$1(t)},B$1=function(t){return G$1(t)?t:void 0},V$1=function(t,e){return arguments.length<2?B$1(g$1[t]):g$1[t]&&g$1[t][e]},W$1=R$1({}.isPrototypeOf),H$1=V$1("navigator","userAgent")||"",K$1=g$1.process,Y$1=g$1.Deno,X$1=K$1&&K$1.versions||Y$1&&Y$1.version,q$1=X$1&&X$1.v8;q$1&&(h$1=(d$1=q$1.split("."))[0]>0&&d$1[0]<4?1:+(d$1[0]+d$1[1])),!h$1&&H$1&&(!(d$1=H$1.match(/Edge\/(\d+)/))||d$1[1]>=74)&&(d$1=H$1.match(/Chrome\/(\d+)/))&&(h$1=+d$1[1]);var $$1=h$1,J$1=!!Object.getOwnPropertySymbols&&!m$1((function(){var t=Symbol();return !String(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&$$1&&$$1<41})),Q$1=J$1&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,Z$1=g$1.Object,tt$1=Q$1?function(t){return "symbol"==typeof t}:function(t){var e=V$1("Symbol");return G$1(e)&&W$1(e.prototype,Z$1(t))},et$1=g$1.String,nt$1=function(t){try{return et$1(t)}catch(t){return "Object"}},rt$1=g$1.TypeError,ot$1=function(t){if(G$1(t))return t;throw rt$1(nt$1(t)+" is not a function")},it$1=function(t,e){var n=t[e];return null==n?void 0:ot$1(n)},ut$1=g$1.TypeError,at$1=Object.defineProperty,ct$1=function(t,e){try{at$1(g$1,t,{value:e,configurable:!0,writable:!0});}catch(n){g$1[t]=e;}return e},ft$1=g$1["__core-js_shared__"]||ct$1("__core-js_shared__",{}),st$1=v$1((function(t){(t.exports=function(t,e){return ft$1[t]||(ft$1[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.19.3",mode:"global",copyright:"© 2021 Denis Pushkarev (zloirock.ru)"});})),lt$1=g$1.Object,pt$1=function(t){return lt$1(D$1(t))},vt$1=R$1({}.hasOwnProperty),dt$1=Object.hasOwn||function(t,e){return vt$1(pt$1(t),e)},ht$1=0,yt$1=Math.random(),gt$1=R$1(1..toString),mt$1=function(t){return "Symbol("+(void 0===t?"":t)+")_"+gt$1(++ht$1+yt$1,36)},bt$1=st$1("wks"),wt$1=g$1.Symbol,St$1=wt$1&&wt$1.for,xt$1=Q$1?wt$1:wt$1&&wt$1.withoutSetter||mt$1,Ot$1=function(t){if(!dt$1(bt$1,t)||!J$1&&"string"!=typeof bt$1[t]){var e="Symbol."+t;J$1&&dt$1(wt$1,t)?bt$1[t]=wt$1[t]:bt$1[t]=Q$1&&St$1?St$1(e):xt$1(e);}return bt$1[t]},Et$1=g$1.TypeError,jt$1=Ot$1("toPrimitive"),It$1=function(t,e){if(!U$1(t)||tt$1(t))return t;var n,r=it$1(t,jt$1);if(r){if(void 0===e&&(e="default"),n=S$1(r,t,e),!U$1(n)||tt$1(n))return n;throw Et$1("Can't convert object to primitive value")}return void 0===e&&(e="number"),function(t,e){var n,r;if("string"===e&&G$1(n=t.toString)&&!U$1(r=S$1(n,t)))return r;if(G$1(n=t.valueOf)&&!U$1(r=S$1(n,t)))return r;if("string"!==e&&G$1(n=t.toString)&&!U$1(r=S$1(n,t)))return r;throw ut$1("Can't convert object to primitive value")}(t,e)},Tt$1=function(t){var e=It$1(t,"string");return tt$1(e)?e:e+""},At$1=g$1.document,Pt$1=U$1(At$1)&&U$1(At$1.createElement),Rt$1=function(t){return Pt$1?At$1.createElement(t):{}},kt$1=!b$1&&!m$1((function(){return 7!=Object.defineProperty(Rt$1("div"),"a",{get:function(){return 7}}).a})),Mt$1=Object.getOwnPropertyDescriptor,Lt$1={f:b$1?Mt$1:function(t,e){if(t=N$1(t),e=Tt$1(e),kt$1)try{return Mt$1(t,e)}catch(t){}if(dt$1(t,e))return j$1(!S$1(E$1.f,t,e),t[e])}},Ft$1=g$1.String,_t$1=g$1.TypeError,Ct$1=function(t){if(U$1(t))return t;throw _t$1(Ft$1(t)+" is not an object")},zt$1=g$1.TypeError,Dt$1=Object.defineProperty,Nt$1={f:b$1?Dt$1:function(t,e,n){if(Ct$1(t),e=Tt$1(e),Ct$1(n),kt$1)try{return Dt$1(t,e,n)}catch(t){}if("get"in n||"set"in n)throw zt$1("Accessors not supported");return "value"in n&&(t[e]=n.value),t}},Gt$1=b$1?function(t,e,n){return Nt$1.f(t,e,j$1(1,n))}:function(t,e,n){return t[e]=n,t},Ut$1=R$1(Function.toString);G$1(ft$1.inspectSource)||(ft$1.inspectSource=function(t){return Ut$1(t)});var Bt$1,Vt$1,Wt$1,Ht$1=ft$1.inspectSource,Kt$1=g$1.WeakMap,Yt$1=G$1(Kt$1)&&/native code/.test(Ht$1(Kt$1)),Xt$1=st$1("keys"),qt$1=function(t){return Xt$1[t]||(Xt$1[t]=mt$1(t))},$t$1={},Jt$1=g$1.TypeError,Qt$1=g$1.WeakMap;if(Yt$1||ft$1.state){var Zt$1=ft$1.state||(ft$1.state=new Qt$1),te$1=R$1(Zt$1.get),ee$1=R$1(Zt$1.has),ne$1=R$1(Zt$1.set);Bt$1=function(t,e){if(ee$1(Zt$1,t))throw new Jt$1("Object already initialized");return e.facade=t,ne$1(Zt$1,t,e),e},Vt$1=function(t){return te$1(Zt$1,t)||{}},Wt$1=function(t){return ee$1(Zt$1,t)};}else {var re$1=qt$1("state");$t$1[re$1]=!0,Bt$1=function(t,e){if(dt$1(t,re$1))throw new Jt$1("Object already initialized");return e.facade=t,Gt$1(t,re$1,e),e},Vt$1=function(t){return dt$1(t,re$1)?t[re$1]:{}},Wt$1=function(t){return dt$1(t,re$1)};}var oe$1={set:Bt$1,get:Vt$1,has:Wt$1,enforce:function(t){return Wt$1(t)?Vt$1(t):Bt$1(t,{})},getterFor:function(t){return function(e){var n;if(!U$1(e)||(n=Vt$1(e)).type!==t)throw Jt$1("Incompatible receiver, "+t+" required");return n}}},ie$1=Function.prototype,ue$1=b$1&&Object.getOwnPropertyDescriptor,ae$1=dt$1(ie$1,"name"),ce$1={EXISTS:ae$1,PROPER:ae$1&&"something"===function(){}.name,CONFIGURABLE:ae$1&&(!b$1||b$1&&ue$1(ie$1,"name").configurable)},fe$1=v$1((function(t){var e=ce$1.CONFIGURABLE,n=oe$1.get,r=oe$1.enforce,o=String(String).split("String");(t.exports=function(t,n,i,u){var a,c=!!u&&!!u.unsafe,f=!!u&&!!u.enumerable,s=!!u&&!!u.noTargetGet,l=u&&void 0!==u.name?u.name:n;G$1(i)&&("Symbol("===String(l).slice(0,7)&&(l="["+String(l).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!dt$1(i,"name")||e&&i.name!==l)&&Gt$1(i,"name",l),(a=r(i)).source||(a.source=o.join("string"==typeof l?l:""))),t!==g$1?(c?!s&&t[n]&&(f=!0):delete t[n],f?t[n]=i:Gt$1(t,n,i)):f?t[n]=i:ct$1(n,i);})(Function.prototype,"toString",(function(){return G$1(this)&&n(this).source||Ht$1(this)}));})),se$1=Math.ceil,le$1=Math.floor,pe$1=function(t){var e=+t;return e!=e||0===e?0:(e>0?le$1:se$1)(e)},ve$1=Math.max,de$1=Math.min,he$1=function(t,e){var n=pe$1(t);return n<0?ve$1(n+e,0):de$1(n,e)},ye$1=Math.min,ge$1=function(t){return t>0?ye$1(pe$1(t),9007199254740991):0},me$1=function(t){return ge$1(t.length)},be$1=function(t){return function(e,n,r){var o,i=N$1(e),u=me$1(i),a=he$1(r,u);if(t&&n!=n){for(;u>a;)if((o=i[a++])!=o)return !0}else for(;u>a;a++)if((t||a in i)&&i[a]===n)return t||a||0;return !t&&-1}},we$1={includes:be$1(!0),indexOf:be$1(!1)}.indexOf,Se$1=R$1([].push),xe$1=function(t,e){var n,r=N$1(t),o=0,i=[];for(n in r)!dt$1($t$1,n)&&dt$1(r,n)&&Se$1(i,n);for(;e.length>o;)dt$1(r,n=e[o++])&&(~we$1(i,n)||Se$1(i,n));return i},Oe$1=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],Ee$1=Oe$1.concat("length","prototype"),je$1={f:Object.getOwnPropertyNames||function(t){return xe$1(t,Ee$1)}},Ie$1={f:Object.getOwnPropertySymbols},Te$1=R$1([].concat),Ae$1=V$1("Reflect","ownKeys")||function(t){var e=je$1.f(Ct$1(t)),n=Ie$1.f;return n?Te$1(e,n(t)):e},Pe$1=function(t,e){for(var n=Ae$1(e),r=Nt$1.f,o=Lt$1.f,i=0;i<n.length;i++){var u=n[i];dt$1(t,u)||r(t,u,o(e,u));}},Re$1=/#|\.prototype\./,ke$1=function(t,e){var n=Le$1[Me$1(t)];return n==_e$1||n!=Fe$1&&(G$1(e)?m$1(e):!!e)},Me$1=ke$1.normalize=function(t){return String(t).replace(Re$1,".").toLowerCase()},Le$1=ke$1.data={},Fe$1=ke$1.NATIVE="N",_e$1=ke$1.POLYFILL="P",Ce$1=ke$1,ze$1=Lt$1.f,De$1=function(t,e){var n,r,o,i,u,a=t.target,c=t.global,f=t.stat;if(n=c?g$1:f?g$1[a]||ct$1(a,{}):(g$1[a]||{}).prototype)for(r in e){if(i=e[r],o=t.noTargetGet?(u=ze$1(n,r))&&u.value:n[r],!Ce$1(c?r:a+(f?".":"#")+r,t.forced)&&void 0!==o){if(typeof i==typeof o)continue;Pe$1(i,o);}(t.sham||o&&o.sham)&&Gt$1(i,"sham",!0),fe$1(n,r,i,t);}},Ne$1=Array.isArray||function(t){return "Array"==L$1(t)},Ge$1={};Ge$1[Ot$1("toStringTag")]="z";var Ue$1,Be$1="[object z]"===String(Ge$1),Ve$1=Ot$1("toStringTag"),We$1=g$1.Object,He$1="Arguments"==L$1(function(){return arguments}()),Ke$1=Be$1?L$1:function(t){var e,n,r;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=We$1(t),Ve$1))?n:He$1?L$1(e):"Object"==(r=L$1(e))&&G$1(e.callee)?"Arguments":r},Ye$1=function(){},Xe$1=[],qe$1=V$1("Reflect","construct"),$e$1=/^\s*(?:class|function)\b/,Je$1=R$1($e$1.exec),Qe$1=!$e$1.exec(Ye$1),Ze$1=function(t){if(!G$1(t))return !1;try{return qe$1(Ye$1,Xe$1,t),!0}catch(t){return !1}},tn$1=!qe$1||m$1((function(){var t;return Ze$1(Ze$1.call)||!Ze$1(Object)||!Ze$1((function(){t=!0;}))||t}))?function(t){if(!G$1(t))return !1;switch(Ke$1(t)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return !1}return Qe$1||!!Je$1($e$1,Ht$1(t))}:Ze$1,en$1=function(t,e,n){var r=Tt$1(e);r in t?Nt$1.f(t,r,j$1(0,n)):t[r]=n;},nn$1=Ot$1("species"),rn$1=R$1([].slice),on$1=(Ue$1="slice",$$1>=51||!m$1((function(){var t=[];return (t.constructor={})[nn$1]=function(){return {foo:1}},1!==t[Ue$1](Boolean).foo}))),un$1=Ot$1("species"),an$1=g$1.Array,cn$1=Math.max;De$1({target:"Array",proto:!0,forced:!on$1},{slice:function(t,e){var n,r,o,i=N$1(this),u=me$1(i),a=he$1(t,u),c=he$1(void 0===e?u:e,u);if(Ne$1(i)&&(n=i.constructor,(tn$1(n)&&(n===an$1||Ne$1(n.prototype))||U$1(n)&&null===(n=n[un$1]))&&(n=void 0),n===an$1||void 0===n))return rn$1(i,a,c);for(r=new(void 0===n?an$1:n)(cn$1(c-a,0)),o=0;a<c;a++,o++)a in i&&en$1(r,o,i[a]);return r.length=o,r}});var fn$1=Be$1?{}.toString:function(){return "[object "+Ke$1(this)+"]"};Be$1||fe$1(Object.prototype,"toString",fn$1,{unsafe:!0});var sn$1,ln$1=g$1.String,pn$1=function(t){if("Symbol"===Ke$1(t))throw TypeError("Cannot convert a Symbol value to a string");return ln$1(t)},vn$1=function(){var t=Ct$1(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.dotAll&&(e+="s"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e},dn$1=g$1.RegExp,hn$1=m$1((function(){var t=dn$1("a","y");return t.lastIndex=2,null!=t.exec("abcd")})),yn$1=hn$1||m$1((function(){return !dn$1("a","y").sticky})),gn$1={BROKEN_CARET:hn$1||m$1((function(){var t=dn$1("^r","gy");return t.lastIndex=2,null!=t.exec("str")})),MISSED_STICKY:yn$1,UNSUPPORTED_Y:hn$1},mn$1=Object.keys||function(t){return xe$1(t,Oe$1)},bn$1=b$1?Object.defineProperties:function(t,e){Ct$1(t);for(var n,r=N$1(e),o=mn$1(e),i=o.length,u=0;i>u;)Nt$1.f(t,n=o[u++],r[n]);return t},wn$1=V$1("document","documentElement"),Sn$1=qt$1("IE_PROTO"),xn$1=function(){},On$1=function(t){return "<script>"+t+"<\/script>"},En$1=function(t){t.write(On$1("")),t.close();var e=t.parentWindow.Object;return t=null,e},jn$1=function(){try{sn$1=new ActiveXObject("htmlfile");}catch(t){}var t,e;jn$1="undefined"!=typeof document?document.domain&&sn$1?En$1(sn$1):((e=Rt$1("iframe")).style.display="none",wn$1.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write(On$1("document.F=Object")),t.close(),t.F):En$1(sn$1);for(var n=Oe$1.length;n--;)delete jn$1.prototype[Oe$1[n]];return jn$1()};$t$1[Sn$1]=!0;var In$1,Tn$1,An$1=Object.create||function(t,e){var n;return null!==t?(xn$1.prototype=Ct$1(t),n=new xn$1,xn$1.prototype=null,n[Sn$1]=t):n=jn$1(),void 0===e?n:bn$1(n,e)},Pn$1=g$1.RegExp,Rn$1=m$1((function(){var t=Pn$1(".","s");return !(t.dotAll&&t.exec("\n")&&"s"===t.flags)})),kn$1=g$1.RegExp,Mn$1=m$1((function(){var t=kn$1("(?<a>b)","g");return "b"!==t.exec("b").groups.a||"bc"!=="b".replace(t,"$<a>c")})),Ln$1=oe$1.get,Fn$1=st$1("native-string-replace",String.prototype.replace),_n$1=RegExp.prototype.exec,Cn$1=_n$1,zn$1=R$1("".charAt),Dn$1=R$1("".indexOf),Nn$1=R$1("".replace),Gn$1=R$1("".slice),Un$1=(Tn$1=/b*/g,S$1(_n$1,In$1=/a/,"a"),S$1(_n$1,Tn$1,"a"),0!==In$1.lastIndex||0!==Tn$1.lastIndex),Bn$1=gn$1.BROKEN_CARET,Vn$1=void 0!==/()??/.exec("")[1];(Un$1||Vn$1||Bn$1||Rn$1||Mn$1)&&(Cn$1=function(t){var e,n,r,o,i,u,a,c=this,f=Ln$1(c),s=pn$1(t),l=f.raw;if(l)return l.lastIndex=c.lastIndex,e=S$1(Cn$1,l,s),c.lastIndex=l.lastIndex,e;var p=f.groups,v=Bn$1&&c.sticky,d=S$1(vn$1,c),h=c.source,y=0,g=s;if(v&&(d=Nn$1(d,"y",""),-1===Dn$1(d,"g")&&(d+="g"),g=Gn$1(s,c.lastIndex),c.lastIndex>0&&(!c.multiline||c.multiline&&"\n"!==zn$1(s,c.lastIndex-1))&&(h="(?: "+h+")",g=" "+g,y++),n=new RegExp("^(?:"+h+")",d)),Vn$1&&(n=new RegExp("^"+h+"$(?!\\s)",d)),Un$1&&(r=c.lastIndex),o=S$1(_n$1,v?n:c,g),v?o?(o.input=Gn$1(o.input,y),o[0]=Gn$1(o[0],y),o.index=c.lastIndex,c.lastIndex+=o[0].length):c.lastIndex=0:Un$1&&o&&(c.lastIndex=c.global?o.index+o[0].length:r),Vn$1&&o&&o.length>1&&S$1(Fn$1,o[0],n,(function(){for(i=1;i<arguments.length-2;i++)void 0===arguments[i]&&(o[i]=void 0);})),o&&p)for(o.groups=u=An$1(null),i=0;i<p.length;i++)u[(a=p[i])[0]]=o[a[1]];return o});var Wn$1=Cn$1;De$1({target:"RegExp",proto:!0,forced:/./.exec!==Wn$1},{exec:Wn$1});var Hn$1=Function.prototype,Kn$1=Hn$1.apply,Yn$1=Hn$1.bind,Xn$1=Hn$1.call,qn$1="object"==typeof Reflect&&Reflect.apply||(Yn$1?Xn$1.bind(Kn$1):function(){return Xn$1.apply(Kn$1,arguments)}),$n$1=Ot$1("species"),Jn$1=RegExp.prototype,Qn$1=Ot$1("match"),Zn$1=g$1.TypeError,tr=Ot$1("species"),er=function(t,e){var n,r=Ct$1(t).constructor;return void 0===r||null==(n=Ct$1(r)[tr])?e:function(t){if(tn$1(t))return t;throw Zn$1(nt$1(t)+" is not a constructor")}(n)},nr=R$1("".charAt),rr=R$1("".charCodeAt),or=R$1("".slice),ir=function(t){return function(e,n){var r,o,i=pn$1(D$1(e)),u=pe$1(n),a=i.length;return u<0||u>=a?t?"":void 0:(r=rr(i,u))<55296||r>56319||u+1===a||(o=rr(i,u+1))<56320||o>57343?t?nr(i,u):r:t?or(i,u,u+2):o-56320+(r-55296<<10)+65536}},ur={codeAt:ir(!1),charAt:ir(!0)},ar=ur.charAt,cr=function(t,e,n){return e+(n?ar(t,e).length:1)},fr=g$1.Array,sr=Math.max,lr=function(t,e,n){for(var r=me$1(t),o=he$1(e,r),i=he$1(void 0===n?r:n,r),u=fr(sr(i-o,0)),a=0;o<i;o++,a++)en$1(u,a,t[o]);return u.length=a,u},pr=g$1.TypeError,vr=function(t,e){var n=t.exec;if(G$1(n)){var r=S$1(n,t,e);return null!==r&&Ct$1(r),r}if("RegExp"===L$1(t))return S$1(Wn$1,t,e);throw pr("RegExp#exec called on incompatible receiver")},dr=gn$1.UNSUPPORTED_Y,hr=Math.min,yr=[].push,gr=R$1(/./.exec),mr=R$1(yr),br=R$1("".slice);!function(t,e,n,r){var o=Ot$1(t),i=!m$1((function(){var e={};return e[o]=function(){return 7},7!=""[t](e)})),u=i&&!m$1((function(){var e=!1,n=/a/;return "split"===t&&((n={}).constructor={},n.constructor[$n$1]=function(){return n},n.flags="",n[o]=/./[o]),n.exec=function(){return e=!0,null},n[o](""),!e}));if(!i||!u||n){var a=R$1(/./[o]),c=e(o,""[t],(function(t,e,n,r,o){var u=R$1(t),c=e.exec;return c===Wn$1||c===Jn$1.exec?i&&!o?{done:!0,value:a(e,n,r)}:{done:!0,value:u(n,e,r)}:{done:!1}}));fe$1(String.prototype,t,c[0]),fe$1(Jn$1,o,c[1]);}r&&Gt$1(Jn$1[o],"sham",!0);}("split",(function(t,e,n){var r;return r="c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1).length||2!="ab".split(/(?:ab)*/).length||4!=".".split(/(.?)(.?)/).length||".".split(/()()/).length>1||"".split(/.?/).length?function(t,n){var r,o,i=pn$1(D$1(this)),u=void 0===n?4294967295:n>>>0;if(0===u)return [];if(void 0===t)return [i];if(!U$1(r=t)||!(void 0!==(o=r[Qn$1])?o:"RegExp"==L$1(r)))return S$1(e,i,t,u);for(var a,c,f,s=[],l=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.unicode?"u":"")+(t.sticky?"y":""),p=0,v=new RegExp(t.source,l+"g");(a=S$1(Wn$1,v,i))&&!((c=v.lastIndex)>p&&(mr(s,br(i,p,a.index)),a.length>1&&a.index<i.length&&qn$1(yr,s,lr(a,1)),f=a[0].length,p=c,s.length>=u));)v.lastIndex===a.index&&v.lastIndex++;return p===i.length?!f&&gr(v,"")||mr(s,""):mr(s,br(i,p)),s.length>u?lr(s,0,u):s}:"0".split(void 0,0).length?function(t,n){return void 0===t&&0===n?[]:S$1(e,this,t,n)}:e,[function(e,n){var o=D$1(this),i=null==e?void 0:it$1(e,t);return i?S$1(i,e,o,n):S$1(r,pn$1(o),e,n)},function(t,o){var i=Ct$1(this),u=pn$1(t),a=n(r,i,u,o,r!==e);if(a.done)return a.value;var c=er(i,RegExp),f=i.unicode,s=(i.ignoreCase?"i":"")+(i.multiline?"m":"")+(i.unicode?"u":"")+(dr?"g":"y"),l=new c(dr?"^(?:"+i.source+")":i,s),p=void 0===o?4294967295:o>>>0;if(0===p)return [];if(0===u.length)return null===vr(l,u)?[u]:[];for(var v=0,d=0,h=[];d<u.length;){l.lastIndex=dr?0:d;var y,g=vr(l,dr?br(u,d):u);if(null===g||(y=hr(ge$1(l.lastIndex+(dr?d:0)),u.length))===v)d=cr(u,d,f);else {if(mr(h,br(u,v,d)),h.length===p)return h;for(var m=1;m<=g.length-1;m++)if(mr(h,g[m]),h.length===p)return h;d=v=y;}}return mr(h,br(u,v)),h}]}),!!m$1((function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var n="ab".split(t);return 2!==n.length||"a"!==n[0]||"b"!==n[1]})),dr);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var wr=function(){return wr=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t},wr.apply(this,arguments)};function Sr(t,e,n,r){return new(n||(n=Promise))((function(o,i){function u(t){try{c(r.next(t));}catch(t){i(t);}}function a(t){try{c(r.throw(t));}catch(t){i(t);}}function c(t){var e;t.done?o(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e);}))).then(u,a);}c((r=r.apply(t,e||[])).next());}))}function xr(t,e){var n,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;u;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=u.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=e.call(t,u);}catch(t){i=[6,t],r=0;}finally{n=o=0;}if(5&i[0])throw i[1];return {value:i[0]?i[1]:void 0,done:!0}}([i,a])}}}function Or(t){var e="function"==typeof Symbol&&Symbol.iterator,n=e&&t[e],r=0;if(n)return n.call(t);if(t&&"number"==typeof t.length)return {next:function(){return t&&r>=t.length&&(t=void 0),{value:t&&t[r++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")}function Er(t){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var e,n=t[Symbol.asyncIterator];return n?n.call(t):(t=Or(t),e={},r("next"),r("throw"),r("return"),e[Symbol.asyncIterator]=function(){return this},e);function r(n){e[n]=t[n]&&function(e){return new Promise((function(r,o){(function(t,e,n,r){Promise.resolve(r).then((function(e){t({value:e,done:n});}),e);})(r,o,(e=t[n](e)).done,e.value);}))};}}var jr=Ot$1("unscopables"),Ir=Array.prototype;null==Ir[jr]&&Nt$1.f(Ir,jr,{configurable:!0,value:An$1(null)});var Tr,Ar,Pr,Rr=function(t){Ir[jr][t]=!0;},kr={},Mr=!m$1((function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype})),Lr=qt$1("IE_PROTO"),Fr=g$1.Object,_r=Fr.prototype,Cr=Mr?Fr.getPrototypeOf:function(t){var e=pt$1(t);if(dt$1(e,Lr))return e[Lr];var n=e.constructor;return G$1(n)&&e instanceof n?n.prototype:e instanceof Fr?_r:null},zr=Ot$1("iterator"),Dr=!1;[].keys&&("next"in(Pr=[].keys())?(Ar=Cr(Cr(Pr)))!==Object.prototype&&(Tr=Ar):Dr=!0);var Nr=null==Tr||m$1((function(){var t={};return Tr[zr].call(t)!==t}));Nr&&(Tr={}),G$1(Tr[zr])||fe$1(Tr,zr,(function(){return this}));var Gr={IteratorPrototype:Tr,BUGGY_SAFARI_ITERATORS:Dr},Ur=Nt$1.f,Br=Ot$1("toStringTag"),Vr=function(t,e,n){t&&!dt$1(t=n?t:t.prototype,Br)&&Ur(t,Br,{configurable:!0,value:e});},Wr=Gr.IteratorPrototype,Hr=function(){return this},Kr=g$1.String,Yr=g$1.TypeError,Xr=Object.setPrototypeOf||("__proto__"in{}?function(){var t,e=!1,n={};try{(t=R$1(Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set))(n,[]),e=n instanceof Array;}catch(t){}return function(n,r){return Ct$1(n),function(t){if("object"==typeof t||G$1(t))return t;throw Yr("Can't set "+Kr(t)+" as a prototype")}(r),e?t(n,r):n.__proto__=r,n}}():void 0),qr=ce$1.PROPER,$r=ce$1.CONFIGURABLE,Jr=Gr.IteratorPrototype,Qr=Gr.BUGGY_SAFARI_ITERATORS,Zr=Ot$1("iterator"),to=function(){return this},eo=function(t,e,n,r,o,i,u){!function(t,e,n,r){var o=e+" Iterator";t.prototype=An$1(Wr,{next:j$1(+!r,n)}),Vr(t,o,!1),kr[o]=Hr;}(n,e,r);var a,c,f,s=function(t){if(t===o&&h)return h;if(!Qr&&t in v)return v[t];switch(t){case"keys":case"values":case"entries":return function(){return new n(this,t)}}return function(){return new n(this)}},l=e+" Iterator",p=!1,v=t.prototype,d=v[Zr]||v["@@iterator"]||o&&v[o],h=!Qr&&d||s(o),y="Array"==e&&v.entries||d;if(y&&(a=Cr(y.call(new t)))!==Object.prototype&&a.next&&(Cr(a)!==Jr&&(Xr?Xr(a,Jr):G$1(a[Zr])||fe$1(a,Zr,to)),Vr(a,l,!0)),qr&&"values"==o&&d&&"values"!==d.name&&($r?Gt$1(v,"name","values"):(p=!0,h=function(){return S$1(d,this)})),o)if(c={values:s("values"),keys:i?h:s("keys"),entries:s("entries")},u)for(f in c)(Qr||p||!(f in v))&&fe$1(v,f,c[f]);else De$1({target:e,proto:!0,forced:Qr||p},c);return v[Zr]!==h&&fe$1(v,Zr,h,{name:o}),kr[e]=h,c},no=oe$1.set,ro=oe$1.getterFor("Array Iterator"),oo=eo(Array,"Array",(function(t,e){no(this,{type:"Array Iterator",target:N$1(t),index:0,kind:e});}),(function(){var t=ro(this),e=t.target,n=t.kind,r=t.index++;return !e||r>=e.length?(t.target=void 0,{value:void 0,done:!0}):"keys"==n?{value:r,done:!1}:"values"==n?{value:e[r],done:!1}:{value:[r,e[r]],done:!1}}),"values");kr.Arguments=kr.Array,Rr("keys"),Rr("values"),Rr("entries");var io=ur.charAt,uo=oe$1.set,ao=oe$1.getterFor("String Iterator");eo(String,"String",(function(t){uo(this,{type:"String Iterator",string:pn$1(t),index:0});}),(function(){var t,e=ao(this),n=e.string,r=e.index;return r>=n.length?{value:void 0,done:!0}:(t=io(n,r),e.index+=t.length,{value:t,done:!1})}));var co=function(t,e,n){for(var r in e)fe$1(t,r,e[r],n);return t},fo=je$1.f,so="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],lo={f:function(t){return so&&"Window"==L$1(t)?function(t){try{return fo(t)}catch(t){return lr(so)}}(t):fo(N$1(t))}},po=m$1((function(){if("function"==typeof ArrayBuffer){var t=new ArrayBuffer(8);Object.isExtensible(t)&&Object.defineProperty(t,"a",{value:8});}})),vo=Object.isExtensible,ho=m$1((function(){vo(1);}))||po?function(t){return !!U$1(t)&&((!po||"ArrayBuffer"!=L$1(t))&&(!vo||vo(t)))}:vo,yo=!m$1((function(){return Object.isExtensible(Object.preventExtensions({}))})),go=v$1((function(t){var e=Nt$1.f,n=!1,r=mt$1("meta"),o=0,i=function(t){e(t,r,{value:{objectID:"O"+o++,weakData:{}}});},u=t.exports={enable:function(){u.enable=function(){},n=!0;var t=je$1.f,e=R$1([].splice),o={};o[r]=1,t(o).length&&(je$1.f=function(n){for(var o=t(n),i=0,u=o.length;i<u;i++)if(o[i]===r){e(o,i,1);break}return o},De$1({target:"Object",stat:!0,forced:!0},{getOwnPropertyNames:lo.f}));},fastKey:function(t,e){if(!U$1(t))return "symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!dt$1(t,r)){if(!ho(t))return "F";if(!e)return "E";i(t);}return t[r].objectID},getWeakData:function(t,e){if(!dt$1(t,r)){if(!ho(t))return !0;if(!e)return !1;i(t);}return t[r].weakData},onFreeze:function(t){return yo&&n&&ho(t)&&!dt$1(t,r)&&i(t),t}};$t$1[r]=!0;})),mo=R$1(R$1.bind),bo=function(t,e){return ot$1(t),void 0===e?t:mo?mo(t,e):function(){return t.apply(e,arguments)}},wo=Ot$1("iterator"),So=Array.prototype,xo=Ot$1("iterator"),Oo=function(t){if(null!=t)return it$1(t,xo)||it$1(t,"@@iterator")||kr[Ke$1(t)]},Eo=g$1.TypeError,jo=function(t,e,n){var r,o;Ct$1(t);try{if(!(r=it$1(t,"return"))){if("throw"===e)throw n;return n}r=S$1(r,t);}catch(t){o=!0,r=t;}if("throw"===e)throw n;if(o)throw r;return Ct$1(r),n},Io=g$1.TypeError,To=function(t,e){this.stopped=t,this.result=e;},Ao=To.prototype,Po=function(t,e,n){var r,o,i,u,a,c,f,s,l=n&&n.that,p=!(!n||!n.AS_ENTRIES),v=!(!n||!n.IS_ITERATOR),d=!(!n||!n.INTERRUPTED),h=bo(e,l),y=function(t){return r&&jo(r,"normal",t),new To(!0,t)},g=function(t){return p?(Ct$1(t),d?h(t[0],t[1],y):h(t[0],t[1])):d?h(t,y):h(t)};if(v)r=t;else {if(!(o=Oo(t)))throw Io(nt$1(t)+" is not iterable");if(void 0!==(s=o)&&(kr.Array===s||So[wo]===s)){for(i=0,u=me$1(t);u>i;i++)if((a=g(t[i]))&&W$1(Ao,a))return a;return new To(!1)}r=function(t,e){var n=arguments.length<2?Oo(t):e;if(ot$1(n))return Ct$1(S$1(n,t));throw Eo(nt$1(t)+" is not iterable")}(t,o);}for(c=r.next;!(f=S$1(c,r)).done;){try{a=g(f.value);}catch(t){jo(r,"throw",t);}if("object"==typeof a&&a&&W$1(Ao,a))return a}return new To(!1)},Ro=g$1.TypeError,ko=function(t,e){if(W$1(e,t))return t;throw Ro("Incorrect invocation")},Mo=Ot$1("iterator"),Lo=!1;try{var Fo=0,_o={next:function(){return {done:!!Fo++}},return:function(){Lo=!0;}};_o[Mo]=function(){return this},Array.from(_o,(function(){throw 2}));}catch(t){}var Co=function(t,e){if(!e&&!Lo)return !1;var n=!1;try{var r={};r[Mo]=function(){return {next:function(){return {done:n=!0}}}},t(r);}catch(t){}return n},zo=Ot$1("species"),Do=g$1.Array,No=function(t,e){return new(function(t){var e;return Ne$1(t)&&(e=t.constructor,(tn$1(e)&&(e===Do||Ne$1(e.prototype))||U$1(e)&&null===(e=e[zo]))&&(e=void 0)),void 0===e?Do:e}(t))(0===e?0:e)},Go=R$1([].push),Uo=function(t){var e=1==t,n=2==t,r=3==t,o=4==t,i=6==t,u=7==t,a=5==t||i;return function(c,f,s,l){for(var p,v,d=pt$1(c),h=C$1(d),y=bo(f,s),g=me$1(h),m=0,b=l||No,w=e?b(c,g):n||u?b(c,0):void 0;g>m;m++)if((a||m in h)&&(v=y(p=h[m],m,d),t))if(e)w[m]=v;else if(v)switch(t){case 3:return !0;case 5:return p;case 6:return m;case 2:Go(w,p);}else switch(t){case 4:return !1;case 7:Go(w,p);}return i?-1:r||o?o:w}},Bo={forEach:Uo(0),map:Uo(1),filter:Uo(2),some:Uo(3),every:Uo(4),find:Uo(5),findIndex:Uo(6),filterReject:Uo(7)},Vo=go.getWeakData,Wo=oe$1.set,Ho=oe$1.getterFor,Ko=Bo.find,Yo=Bo.findIndex,Xo=R$1([].splice),qo=0,$o=function(t){return t.frozen||(t.frozen=new Jo)},Jo=function(){this.entries=[];},Qo=function(t,e){return Ko(t.entries,(function(t){return t[0]===e}))};Jo.prototype={get:function(t){var e=Qo(this,t);if(e)return e[1]},has:function(t){return !!Qo(this,t)},set:function(t,e){var n=Qo(this,t);n?n[1]=e:this.entries.push([t,e]);},delete:function(t){var e=Yo(this.entries,(function(e){return e[0]===t}));return ~e&&Xo(this.entries,e,1),!!~e}};var Zo,ti={getConstructor:function(t,e,n,r){var o=t((function(t,o){ko(t,i),Wo(t,{type:e,id:qo++,frozen:void 0}),null!=o&&Po(o,t[r],{that:t,AS_ENTRIES:n});})),i=o.prototype,u=Ho(e),a=function(t,e,n){var r=u(t),o=Vo(Ct$1(e),!0);return !0===o?$o(r).set(e,n):o[r.id]=n,t};return co(i,{delete:function(t){var e=u(this);if(!U$1(t))return !1;var n=Vo(t);return !0===n?$o(e).delete(t):n&&dt$1(n,e.id)&&delete n[e.id]},has:function(t){var e=u(this);if(!U$1(t))return !1;var n=Vo(t);return !0===n?$o(e).has(t):n&&dt$1(n,e.id)}}),co(i,n?{get:function(t){var e=u(this);if(U$1(t)){var n=Vo(t);return !0===n?$o(e).get(t):n?n[e.id]:void 0}},set:function(t,e){return a(this,t,e)}}:{add:function(t){return a(this,t,!0)}}),o}},ei=oe$1.enforce,ni=!g$1.ActiveXObject&&"ActiveXObject"in g$1,ri=function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}},oi=function(t,e,n){var r=-1!==t.indexOf("Map"),o=-1!==t.indexOf("Weak"),i=r?"set":"add",u=g$1[t],a=u&&u.prototype,c=u,f={},s=function(t){var e=R$1(a[t]);fe$1(a,t,"add"==t?function(t){return e(this,0===t?0:t),this}:"delete"==t?function(t){return !(o&&!U$1(t))&&e(this,0===t?0:t)}:"get"==t?function(t){return o&&!U$1(t)?void 0:e(this,0===t?0:t)}:"has"==t?function(t){return !(o&&!U$1(t))&&e(this,0===t?0:t)}:function(t,n){return e(this,0===t?0:t,n),this});};if(Ce$1(t,!G$1(u)||!(o||a.forEach&&!m$1((function(){(new u).entries().next();})))))c=n.getConstructor(e,t,r,i),go.enable();else if(Ce$1(t,!0)){var l=new c,p=l[i](o?{}:-0,1)!=l,v=m$1((function(){l.has(1);})),d=Co((function(t){new u(t);})),h=!o&&m$1((function(){for(var t=new u,e=5;e--;)t[i](e,e);return !t.has(-0)}));d||((c=e((function(t,e){ko(t,a);var n=function(t,e,n){var r,o;return Xr&&G$1(r=e.constructor)&&r!==n&&U$1(o=r.prototype)&&o!==n.prototype&&Xr(t,o),t}(new u,t,c);return null!=e&&Po(e,n[i],{that:n,AS_ENTRIES:r}),n}))).prototype=a,a.constructor=c),(v||h)&&(s("delete"),s("has"),r&&s("get")),(h||p)&&s(i),o&&a.clear&&delete a.clear;}return f[t]=c,De$1({global:!0,forced:c!=u},f),Vr(c,t),o||n.setStrong(c,t,r),c}("WeakMap",ri,ti);if(Yt$1&&ni){Zo=ti.getConstructor(ri,"WeakMap",!0),go.enable();var ii=oi.prototype,ui=R$1(ii.delete),ai=R$1(ii.has),ci=R$1(ii.get),fi=R$1(ii.set);co(ii,{delete:function(t){if(U$1(t)&&!ho(t)){var e=ei(this);return e.frozen||(e.frozen=new Zo),ui(this,t)||e.frozen.delete(t)}return ui(this,t)},has:function(t){if(U$1(t)&&!ho(t)){var e=ei(this);return e.frozen||(e.frozen=new Zo),ai(this,t)||e.frozen.has(t)}return ai(this,t)},get:function(t){if(U$1(t)&&!ho(t)){var e=ei(this);return e.frozen||(e.frozen=new Zo),ai(this,t)?ci(this,t):e.frozen.get(t)}return ci(this,t)},set:function(t,e){if(U$1(t)&&!ho(t)){var n=ei(this);n.frozen||(n.frozen=new Zo),ai(this,t)?fi(this,t,e):n.frozen.set(t,e);}else fi(this,t,e);return this}});}var si={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},li=Rt$1("span").classList,pi=li&&li.constructor&&li.constructor.prototype,vi=pi===Object.prototype?void 0:pi,di=Ot$1("iterator"),hi=Ot$1("toStringTag"),yi=oo.values,gi=function(t,e){if(t){if(t[di]!==yi)try{Gt$1(t,di,yi);}catch(e){t[di]=yi;}if(t[hi]||Gt$1(t,hi,e),si[e])for(var n in oo)if(t[n]!==oo[n])try{Gt$1(t,n,oo[n]);}catch(e){t[n]=oo[n];}}};for(var mi in si)gi(g$1[mi]&&g$1[mi].prototype,mi);gi(vi,"DOMTokenList");var bi=function(t,e){var n=[][t];return !!n&&m$1((function(){n.call(null,e||function(){throw 1},1);}))},wi=Bo.forEach,Si=bi("forEach")?[].forEach:function(t){return wi(this,t,arguments.length>1?arguments[1]:void 0)},xi=function(t){if(t&&t.forEach!==Si)try{Gt$1(t,"forEach",Si);}catch(e){t.forEach=Si;}};for(var Oi in si)si[Oi]&&xi(g$1[Oi]&&g$1[Oi].prototype);xi(vi);var Ei,ji,Ii,Ti,Ai=g$1.Promise,Pi=Ot$1("species"),Ri=/(?:ipad|iphone|ipod).*applewebkit/i.test(H$1),ki="process"==L$1(g$1.process),Mi=g$1.setImmediate,Li=g$1.clearImmediate,Fi=g$1.process,_i=g$1.Dispatch,Ci=g$1.Function,zi=g$1.MessageChannel,Di=g$1.String,Ni=0,Gi={};try{Ei=g$1.location;}catch(t){}var Ui=function(t){if(dt$1(Gi,t)){var e=Gi[t];delete Gi[t],e();}},Bi=function(t){return function(){Ui(t);}},Vi=function(t){Ui(t.data);},Wi=function(t){g$1.postMessage(Di(t),Ei.protocol+"//"+Ei.host);};Mi&&Li||(Mi=function(t){var e=rn$1(arguments,1);return Gi[++Ni]=function(){qn$1(G$1(t)?t:Ci(t),void 0,e);},ji(Ni),Ni},Li=function(t){delete Gi[t];},ki?ji=function(t){Fi.nextTick(Bi(t));}:_i&&_i.now?ji=function(t){_i.now(Bi(t));}:zi&&!Ri?(Ti=(Ii=new zi).port2,Ii.port1.onmessage=Vi,ji=bo(Ti.postMessage,Ti)):g$1.addEventListener&&G$1(g$1.postMessage)&&!g$1.importScripts&&Ei&&"file:"!==Ei.protocol&&!m$1(Wi)?(ji=Wi,g$1.addEventListener("message",Vi,!1)):ji="onreadystatechange"in Rt$1("script")?function(t){wn$1.appendChild(Rt$1("script")).onreadystatechange=function(){wn$1.removeChild(this),Ui(t);};}:function(t){setTimeout(Bi(t),0);});var Hi,Ki,Yi,Xi,qi,$i,Ji,Qi,Zi={set:Mi,clear:Li},tu=/ipad|iphone|ipod/i.test(H$1)&&void 0!==g$1.Pebble,eu=/web0s(?!.*chrome)/i.test(H$1),nu=Lt$1.f,ru=Zi.set,ou=g$1.MutationObserver||g$1.WebKitMutationObserver,iu=g$1.document,uu=g$1.process,au=g$1.Promise,cu=nu(g$1,"queueMicrotask"),fu=cu&&cu.value;fu||(Hi=function(){var t,e;for(ki&&(t=uu.domain)&&t.exit();Ki;){e=Ki.fn,Ki=Ki.next;try{e();}catch(t){throw Ki?Xi():Yi=void 0,t}}Yi=void 0,t&&t.enter();},Ri||ki||eu||!ou||!iu?!tu&&au&&au.resolve?((Ji=au.resolve(void 0)).constructor=au,Qi=bo(Ji.then,Ji),Xi=function(){Qi(Hi);}):ki?Xi=function(){uu.nextTick(Hi);}:(ru=bo(ru,g$1),Xi=function(){ru(Hi);}):(qi=!0,$i=iu.createTextNode(""),new ou(Hi).observe($i,{characterData:!0}),Xi=function(){$i.data=qi=!qi;}));var su,lu,pu,vu,du=fu||function(t){var e={fn:t,next:void 0};Yi&&(Yi.next=e),Ki||(Ki=e,Xi()),Yi=e;},hu=function(t){var e,n;this.promise=new t((function(t,r){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=r;})),this.resolve=ot$1(e),this.reject=ot$1(n);},yu={f:function(t){return new hu(t)}},gu=function(t){try{return {error:!1,value:t()}}catch(t){return {error:!0,value:t}}},mu="object"==typeof window,bu=Zi.set,wu=Ot$1("species"),Su="Promise",xu=oe$1.getterFor(Su),Ou=oe$1.set,Eu=oe$1.getterFor(Su),ju=Ai&&Ai.prototype,Iu=Ai,Tu=ju,Au=g$1.TypeError,Pu=g$1.document,Ru=g$1.process,ku=yu.f,Mu=ku,Lu=!!(Pu&&Pu.createEvent&&g$1.dispatchEvent),Fu=G$1(g$1.PromiseRejectionEvent),_u=!1,Cu=Ce$1(Su,(function(){var t=Ht$1(Iu),e=t!==String(Iu);if(!e&&66===$$1)return !0;if($$1>=51&&/native code/.test(t))return !1;var n=new Iu((function(t){t(1);})),r=function(t){t((function(){}),(function(){}));};return (n.constructor={})[wu]=r,!(_u=n.then((function(){}))instanceof r)||!e&&mu&&!Fu})),zu=Cu||!Co((function(t){Iu.all(t).catch((function(){}));})),Du=function(t){var e;return !(!U$1(t)||!G$1(e=t.then))&&e},Nu=function(t,e){if(!t.notified){t.notified=!0;var n=t.reactions;du((function(){for(var r=t.value,o=1==t.state,i=0;n.length>i;){var u,a,c,f=n[i++],s=o?f.ok:f.fail,l=f.resolve,p=f.reject,v=f.domain;try{s?(o||(2===t.rejection&&Vu(t),t.rejection=1),!0===s?u=r:(v&&v.enter(),u=s(r),v&&(v.exit(),c=!0)),u===f.promise?p(Au("Promise-chain cycle")):(a=Du(u))?S$1(a,u,l,p):l(u)):p(r);}catch(t){v&&!c&&v.exit(),p(t);}}t.reactions=[],t.notified=!1,e&&!t.rejection&&Uu(t);}));}},Gu=function(t,e,n){var r,o;Lu?((r=Pu.createEvent("Event")).promise=e,r.reason=n,r.initEvent(t,!1,!0),g$1.dispatchEvent(r)):r={promise:e,reason:n},!Fu&&(o=g$1["on"+t])?o(r):"unhandledrejection"===t&&function(t,e){var n=g$1.console;n&&n.error&&(1==arguments.length?n.error(t):n.error(t,e));}("Unhandled promise rejection",n);},Uu=function(t){S$1(bu,g$1,(function(){var e,n=t.facade,r=t.value;if(Bu(t)&&(e=gu((function(){ki?Ru.emit("unhandledRejection",r,n):Gu("unhandledrejection",n,r);})),t.rejection=ki||Bu(t)?2:1,e.error))throw e.value}));},Bu=function(t){return 1!==t.rejection&&!t.parent},Vu=function(t){S$1(bu,g$1,(function(){var e=t.facade;ki?Ru.emit("rejectionHandled",e):Gu("rejectionhandled",e,t.value);}));},Wu=function(t,e,n){return function(r){t(e,r,n);}},Hu=function(t,e,n){t.done||(t.done=!0,n&&(t=n),t.value=e,t.state=2,Nu(t,!0));},Ku=function(t,e,n){if(!t.done){t.done=!0,n&&(t=n);try{if(t.facade===e)throw Au("Promise can't be resolved itself");var r=Du(e);r?du((function(){var n={done:!1};try{S$1(r,e,Wu(Ku,n,t),Wu(Hu,n,t));}catch(e){Hu(n,e,t);}})):(t.value=e,t.state=1,Nu(t,!1));}catch(e){Hu({done:!1},e,t);}}};if(Cu&&(Tu=(Iu=function(t){ko(this,Tu),ot$1(t),S$1(su,this);var e=xu(this);try{t(Wu(Ku,e),Wu(Hu,e));}catch(t){Hu(e,t);}}).prototype,(su=function(t){Ou(this,{type:Su,done:!1,notified:!1,parent:!1,reactions:[],rejection:!1,state:0,value:void 0});}).prototype=co(Tu,{then:function(t,e){var n=Eu(this),r=n.reactions,o=ku(er(this,Iu));return o.ok=!G$1(t)||t,o.fail=G$1(e)&&e,o.domain=ki?Ru.domain:void 0,n.parent=!0,r[r.length]=o,0!=n.state&&Nu(n,!1),o.promise},catch:function(t){return this.then(void 0,t)}}),lu=function(){var t=new su,e=xu(t);this.promise=t,this.resolve=Wu(Ku,e),this.reject=Wu(Hu,e);},yu.f=ku=function(t){return t===Iu||t===pu?new lu(t):Mu(t)},G$1(Ai)&&ju!==Object.prototype)){vu=ju.then,_u||(fe$1(ju,"then",(function(t,e){var n=this;return new Iu((function(t,e){S$1(vu,n,t,e);})).then(t,e)}),{unsafe:!0}),fe$1(ju,"catch",Tu.catch,{unsafe:!0}));try{delete ju.constructor;}catch(t){}Xr&&Xr(ju,Tu);}De$1({global:!0,wrap:!0,forced:Cu},{Promise:Iu}),Vr(Iu,Su,!1),function(t){var e=V$1(t),n=Nt$1.f;b$1&&e&&!e[Pi]&&n(e,Pi,{configurable:!0,get:function(){return this}});}(Su),pu=V$1(Su),De$1({target:Su,stat:!0,forced:Cu},{reject:function(t){var e=ku(this);return S$1(e.reject,void 0,t),e.promise}}),De$1({target:Su,stat:!0,forced:Cu},{resolve:function(t){return function(t,e){if(Ct$1(t),U$1(e)&&e.constructor===t)return e;var n=yu.f(t);return (0, n.resolve)(e),n.promise}(this,t)}}),De$1({target:Su,stat:!0,forced:zu},{all:function(t){var e=this,n=ku(e),r=n.resolve,o=n.reject,i=gu((function(){var n=ot$1(e.resolve),i=[],u=0,a=1;Po(t,(function(t){var c=u++,f=!1;a++,S$1(n,e,t).then((function(t){f||(f=!0,i[c]=t,--a||r(i));}),o);})),--a||r(i);}));return i.error&&o(i.value),n.promise},race:function(t){var e=this,n=ku(e),r=n.reject,o=gu((function(){var o=ot$1(e.resolve);Po(t,(function(t){S$1(o,e,t).then(n.resolve,r);}));}));return o.error&&r(o.value),n.promise}});var Yu=ce$1.PROPER,Xu=RegExp.prototype,qu=Xu.toString,$u=R$1(vn$1),Ju=m$1((function(){return "/a/b"!=qu.call({source:"a",flags:"b"})})),Qu=Yu&&"toString"!=qu.name;(Ju||Qu)&&fe$1(RegExp.prototype,"toString",(function(){var t=Ct$1(this),e=pn$1(t.source),n=t.flags;return "/"+e+"/"+pn$1(void 0===n&&W$1(Xu,t)&&!("flags"in Xu)?$u(t):n)}),{unsafe:!0});var Zu=ce$1.EXISTS,ta$1=Nt$1.f,ea$1=Function.prototype,na$1=R$1(ea$1.toString),ra$1=/function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/,oa$1=R$1(ra$1.exec);b$1&&!Zu&&ta$1(ea$1,"name",{configurable:!0,get:function(){try{return oa$1(ra$1,na$1(this))[1]}catch(t){return ""}}});var ia$1=new WeakMap;function ua$1(t){return t.getMenuConfig("uploadImage")}function aa$1(t,e){return Sr(this,void 0,void 0,(function(){return xr(this,(function(n){return [2,new Promise((function(n){var o=new FileReader;o.readAsDataURL(e),o.onload=function(){var i=o.result;if(i){var u=i.toString(),a=0===u.indexOf("data:image")?"":u;Ia$2(t,u,e.name,a),n("ok");}};}))]}))}))}function ca$1(t,n){return Sr(this,void 0,void 0,(function(){var o,i,u,a;return xr(this,(function(c){switch(c.label){case 0:return o=function(t){var n=ia$1.get(t);if(null!=n)return n;var o=ua$1(t),i=o.onSuccess,u=o.onProgress,a=o.onFailed,c=o.customInsert,f=o.onError;return n=gh(wr(wr({},o),{onProgress:function(e){t.showProgressBar(e),u&&u(e);},onSuccess:function(e,n){if(c)return c(n,(function(e,n,o){return Ia$2(t,e,n,o)})),void i(e,n);var o=n.errno,u=void 0===o?1:o,f=n.data,s=void 0===f?{}:f;if(0===u){if(Array.isArray(s))s.forEach((function(e){var n=e.url,o=void 0===n?"":n,i=e.alt,u=void 0===i?"":i,a=e.href;Ia$2(t,o,u,void 0===a?"":a);}));else {var l=s.url,p=void 0===l?"":l,v=s.alt,d=void 0===v?"":v,h=s.href;Ia$2(t,p,d,void 0===h?"":h);}i(e,n);}else a(e,n);},onError:function(t,e,n){f(t,e,n);}})),ia$1.set(t,n),n}(t),i=n.name,u=n.type,a=n.size,o.addFile({name:i,type:u,size:a,data:n}),[4,o.upload()];case 1:return c.sent(),[2]}}))}))}function fa$1(t,e){var n,o;return Sr(this,void 0,void 0,(function(){var i,u,a,c,f,s,l,p,v;return xr(this,(function(d){switch(d.label){case 0:if(null==e)return [2];i=Array.prototype.slice.call(e),u=ua$1(t),a=u.customUpload,c=u.base64LimitSize,d.label=1;case 1:d.trys.push([1,11,12,17]),f=Er(i),d.label=2;case 2:return [4,f.next()];case 3:return (s=d.sent()).done?[3,10]:(l=s.value,p=l.size,c&&p<=c?[4,aa$1(t,l)]:[3,5]);case 4:return d.sent(),[3,9];case 5:return a?[4,a(l,(function(e,n,o){return Ia$2(t,e,n,o)}))]:[3,7];case 6:return d.sent(),[3,9];case 7:return [4,ca$1(t,l)];case 8:d.sent(),d.label=9;case 9:return [3,2];case 10:return [3,17];case 11:return v=d.sent(),n={error:v},[3,17];case 12:return d.trys.push([12,,15,16]),s&&!s.done&&(o=f.return)?[4,o.call(f)]:[3,14];case 13:d.sent(),d.label=14;case 14:return [3,16];case 15:if(n)throw n.error;return [7];case 16:return [7];case 17:return [2]}}))}))}var sa$1=R$1([].join),la$1=C$1!=Object,pa$1=bi("join",",");De$1({target:"Array",proto:!0,forced:la$1||!pa$1},{join:function(t){return sa$1(N$1(this),void 0===t?",":t)}});append&&($$6.fn.append=append),on$7&&($$6.fn.on=on$7),remove&&($$6.fn.remove=remove),val&&($$6.fn.val=val),click&&($$6.fn.click=click),hide&&($$6.fn.hide=hide);var va$1=function(){function t(){this.title=cp$1("uploadImgModule.uploadImage"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M828.708571 585.045333a48.761905 48.761905 0 0 0-48.737523 48.761905v18.529524l-72.143238-72.167619a135.972571 135.972571 0 0 0-191.585524 0l-34.133334 34.133333-120.880762-120.953905a138.898286 138.898286 0 0 0-191.585523 0l-72.167619 72.167619V292.400762a48.786286 48.786286 0 0 1 48.761904-48.761905h341.23581a48.737524 48.737524 0 0 0 34.474667-83.285333 48.737524 48.737524 0 0 0-34.474667-14.287238H146.236952A146.212571 146.212571 0 0 0 0 292.400762v585.289143A146.358857 146.358857 0 0 0 146.236952 1024h584.996572a146.212571 146.212571 0 0 0 146.236952-146.310095V633.807238a48.786286 48.786286 0 0 0-48.761905-48.761905zM146.261333 926.45181a48.737524 48.737524 0 0 1-48.761904-48.761905v-174.128762l141.409523-141.458286a38.497524 38.497524 0 0 1 53.126096 0l154.526476 154.624 209.627428 209.724953H146.236952z m633.734096-48.761905c-0.073143 9.337905-3.145143 18.383238-8.777143 25.843809l-219.843048-220.94019 34.133333-34.133334a37.546667 37.546667 0 0 1 53.613715 0l140.873143 141.897143V877.714286zM1009.615238 160.231619L863.329524 13.897143a48.737524 48.737524 0 0 0-16.091429-10.24c-11.849143-4.87619-25.161143-4.87619-37.059047 0a48.761905 48.761905 0 0 0-16.067048 10.24l-146.236952 146.334476a49.005714 49.005714 0 0 0 69.217523 69.241905l62.902858-63.390476v272.627809a48.761905 48.761905 0 1 0 97.475047 0V166.083048l62.902857 63.390476a48.737524 48.737524 0 0 0 69.217524 0 48.761905 48.761905 0 0 0 0-69.241905z"></path></svg>',this.tag="button";}return t.prototype.getValue=function(t){return ""},t.prototype.isActive=function(t){return !1},t.prototype.isDisabled=function(t){return La$2(t)},t.prototype.getMenuConfig=function(t){return t.getMenuConfig("uploadImage")},t.prototype.exec=function(t,e){var n=this.getMenuConfig(t),o=n.allowedFileTypes,u=void 0===o?[]:o,a=n.customBrowseAndUpload;if(a)a((function(e,n,o){return Ia$2(t,e,n,o)}));else {var c="";u.length>0&&(c='accept="'+u.join(", ")+'"');var f=$$6("body"),s=$$6('<input type="file" '+c+" multiple/>");s.hide(),f.append(s),s.click(),s.on("change",(function(){var e=s[0].files;fa$1(t,e);}));}},t}();var da$1={menus:[{key:"uploadImage",factory:function(){return new va$1},config:{server:"",fieldName:"wangeditor-uploaded-image",maxFileSize:2097152,maxNumberOfFiles:100,allowedFileTypes:["image/*"],meta:{},metaWithUrl:!1,withCredentials:!1,timeout:1e4,onBeforeUpload:function(t){return t},onProgress:function(t){},onSuccess:function(t,e){},onFailed:function(t,e){console.error("'"+t.name+"' upload failed",e);},onError:function(t,e,n){console.error("'"+t.name+"' upload error",n);},base64LimitSize:0}}],editorPlugin:function(t){var e=t.insertData,n=t;return n.insertData=function(r){if(La$2(n))e(r);else if(r.getData("text/plain"))e(r);else {var i=r.files;if(i.length<=0)e(r);else Array.prototype.slice.call(i).some((function(t){return "image"===function(t,e){var n="function"==typeof Symbol&&t[Symbol.iterator];if(!n)return t;var r,o,i=n.call(t),u=[];try{for(;(void 0===e||e-- >0)&&!(r=i.next()).done;)u.push(r.value);}catch(t){o={error:t};}finally{try{r&&!r.done&&(n=i.return)&&n.call(i);}finally{if(o)throw o.error}}return u}(t.type.split("/"),1)[0]}))?fa$1(t,i):e(r);}},n}};

sp$1("en",{highLightModule:{selectLang:"Language"}}),sp$1("zh-CN",{highLightModule:{selectLang:"选择语言"}});var l="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function u(e){var t={exports:{}};return e(t,t.exports),t.exports}var c,d,p=function(e){return e&&e.Math==Math&&e},g=p("object"==typeof globalThis&&globalThis)||p("object"==typeof window&&window)||p("object"==typeof self&&self)||p("object"==typeof l&&l)||function(){return this}()||Function("return this")(),f=Object.defineProperty,b=function(e,t){try{f(g,e,{value:t,configurable:!0,writable:!0});}catch(n){g[e]=t;}return t},h=g["__core-js_shared__"]||b("__core-js_shared__",{}),m=u((function(e){(e.exports=function(e,t){return h[e]||(h[e]=void 0!==t?t:{})})("versions",[]).push({version:"3.19.3",mode:"global",copyright:"© 2021 Denis Pushkarev (zloirock.ru)"});})),y=Function.prototype,E=y.bind,v=y.call,S=E&&E.bind(v),w=E?function(e){return e&&S(v,e)}:function(e){return e&&function(){return v.apply(e,arguments)}},k=g.TypeError,A=function(e){if(null==e)throw k("Can't call method on "+e);return e},x=g.Object,T=function(e){return x(A(e))},_=w({}.hasOwnProperty),O=Object.hasOwn||function(e,t){return _(T(e),t)},I=0,R=Math.random(),N=w(1..toString),L=function(e){return "Symbol("+(void 0===e?"":e)+")_"+N(++I+R,36)},P=function(e){return "function"==typeof e},C=function(e){return P(e)?e:void 0},F=function(e,t){return arguments.length<2?C(g[e]):g[e]&&g[e][t]},D=F("navigator","userAgent")||"",$=g.process,M=g.Deno,B=$&&$.versions||M&&M.version,U=B&&B.v8;U&&(d=(c=U.split("."))[0]>0&&c[0]<4?1:+(c[0]+c[1])),!d&&D&&(!(c=D.match(/Edge\/(\d+)/))||c[1]>=74)&&(c=D.match(/Chrome\/(\d+)/))&&(d=+c[1]);var j=d,z=function(e){try{return !!e()}catch(e){return !0}},G=!!Object.getOwnPropertySymbols&&!z((function(){var e=Symbol();return !String(e)||!(Object(e)instanceof Symbol)||!Symbol.sham&&j&&j<41})),H=G&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,q=m("wks"),Y=g.Symbol,X=Y&&Y.for,W=H?Y:Y&&Y.withoutSetter||L,Z=function(e){if(!O(q,e)||!G&&"string"!=typeof q[e]){var t="Symbol."+e;G&&O(Y,e)?q[e]=Y[e]:q[e]=H&&X?X(t):W(t);}return q[e]},V={};V[Z("toStringTag")]="z";var K="[object z]"===String(V),J=!z((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),Q=function(e){return "object"==typeof e?null!==e:P(e)},ee=g.document,te=Q(ee)&&Q(ee.createElement),ne=function(e){return te?ee.createElement(e):{}},ae=!J&&!z((function(){return 7!=Object.defineProperty(ne("div"),"a",{get:function(){return 7}}).a})),re=g.String,ie=g.TypeError,se=function(e){if(Q(e))return e;throw ie(re(e)+" is not an object")},oe=Function.prototype.call,le=oe.bind?oe.bind(oe):function(){return oe.apply(oe,arguments)},ue=w({}.isPrototypeOf),ce=g.Object,de=H?function(e){return "symbol"==typeof e}:function(e){var t=F("Symbol");return P(t)&&ue(t.prototype,ce(e))},pe=g.String,ge=function(e){try{return pe(e)}catch(e){return "Object"}},fe=g.TypeError,be=function(e){if(P(e))return e;throw fe(ge(e)+" is not a function")},he=function(e,t){var n=e[t];return null==n?void 0:be(n)},me=g.TypeError,ye=g.TypeError,Ee=Z("toPrimitive"),ve=function(e,t){if(!Q(e)||de(e))return e;var n,a=he(e,Ee);if(a){if(void 0===t&&(t="default"),n=le(a,e,t),!Q(n)||de(n))return n;throw ye("Can't convert object to primitive value")}return void 0===t&&(t="number"),function(e,t){var n,a;if("string"===t&&P(n=e.toString)&&!Q(a=le(n,e)))return a;if(P(n=e.valueOf)&&!Q(a=le(n,e)))return a;if("string"!==t&&P(n=e.toString)&&!Q(a=le(n,e)))return a;throw me("Can't convert object to primitive value")}(e,t)},Se=function(e){var t=ve(e,"string");return de(t)?t:t+""},we=g.TypeError,ke=Object.defineProperty,Ae={f:J?ke:function(e,t,n){if(se(e),t=Se(t),se(n),ae)try{return ke(e,t,n)}catch(e){}if("get"in n||"set"in n)throw we("Accessors not supported");return "value"in n&&(e[t]=n.value),e}},xe=function(e,t){return {enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}},Te=J?function(e,t,n){return Ae.f(e,t,xe(1,n))}:function(e,t,n){return e[t]=n,e},_e=w(Function.toString);P(h.inspectSource)||(h.inspectSource=function(e){return _e(e)});var Oe,Ie,Re,Ne=h.inspectSource,Le=g.WeakMap,Pe=P(Le)&&/native code/.test(Ne(Le)),Ce=m("keys"),Fe=function(e){return Ce[e]||(Ce[e]=L(e))},De={},$e=g.TypeError,Me=g.WeakMap;if(Pe||h.state){var Be=h.state||(h.state=new Me),Ue=w(Be.get),je=w(Be.has),ze=w(Be.set);Oe=function(e,t){if(je(Be,e))throw new $e("Object already initialized");return t.facade=e,ze(Be,e,t),t},Ie=function(e){return Ue(Be,e)||{}},Re=function(e){return je(Be,e)};}else {var Ge=Fe("state");De[Ge]=!0,Oe=function(e,t){if(O(e,Ge))throw new $e("Object already initialized");return t.facade=e,Te(e,Ge,t),t},Ie=function(e){return O(e,Ge)?e[Ge]:{}},Re=function(e){return O(e,Ge)};}var He={set:Oe,get:Ie,has:Re,enforce:function(e){return Re(e)?Ie(e):Oe(e,{})},getterFor:function(e){return function(t){var n;if(!Q(t)||(n=Ie(t)).type!==e)throw $e("Incompatible receiver, "+e+" required");return n}}},qe=Function.prototype,Ye=J&&Object.getOwnPropertyDescriptor,Xe=O(qe,"name"),We={EXISTS:Xe,PROPER:Xe&&"something"===function(){}.name,CONFIGURABLE:Xe&&(!J||J&&Ye(qe,"name").configurable)},Ze=u((function(e){var t=We.CONFIGURABLE,n=He.get,a=He.enforce,r=String(String).split("String");(e.exports=function(e,n,i,s){var o,l=!!s&&!!s.unsafe,u=!!s&&!!s.enumerable,c=!!s&&!!s.noTargetGet,d=s&&void 0!==s.name?s.name:n;P(i)&&("Symbol("===String(d).slice(0,7)&&(d="["+String(d).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!O(i,"name")||t&&i.name!==d)&&Te(i,"name",d),(o=a(i)).source||(o.source=r.join("string"==typeof d?d:""))),e!==g?(l?!c&&e[n]&&(u=!0):delete e[n],u?e[n]=i:Te(e,n,i)):u?e[n]=i:b(n,i);})(Function.prototype,"toString",(function(){return P(this)&&n(this).source||Ne(this)}));})),Ve=w({}.toString),Ke=w("".slice),Je=function(e){return Ke(Ve(e),8,-1)},Qe=Z("toStringTag"),et=g.Object,tt="Arguments"==Je(function(){return arguments}()),nt=K?Je:function(e){var t,n,a;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=function(e,t){try{return e[t]}catch(e){}}(t=et(e),Qe))?n:tt?Je(t):"Object"==(a=Je(t))&&P(t.callee)?"Arguments":a},at=K?{}.toString:function(){return "[object "+nt(this)+"]"};K||Ze(Object.prototype,"toString",at,{unsafe:!0});var rt,it,st={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},ot=ne("span").classList,lt=ot&&ot.constructor&&ot.constructor.prototype,ut=lt===Object.prototype?void 0:lt,ct=w(w.bind),dt=g.Object,pt=w("".split),gt=z((function(){return !dt("z").propertyIsEnumerable(0)}))?function(e){return "String"==Je(e)?pt(e,""):dt(e)}:dt,ft=Math.ceil,bt=Math.floor,ht=function(e){var t=+e;return t!=t||0===t?0:(t>0?bt:ft)(t)},mt=Math.min,yt=function(e){return e>0?mt(ht(e),9007199254740991):0},Et=function(e){return yt(e.length)},vt=Array.isArray||function(e){return "Array"==Je(e)},St=function(){},wt=[],kt=F("Reflect","construct"),At=/^\s*(?:class|function)\b/,xt=w(At.exec),Tt=!At.exec(St),_t=function(e){if(!P(e))return !1;try{return kt(St,wt,e),!0}catch(e){return !1}},Ot=!kt||z((function(){var e;return _t(_t.call)||!_t(Object)||!_t((function(){e=!0;}))||e}))?function(e){if(!P(e))return !1;switch(nt(e)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return !1}return Tt||!!xt(At,Ne(e))}:_t,It=Z("species"),Rt=g.Array,Nt=function(e,t){return new(function(e){var t;return vt(e)&&(t=e.constructor,(Ot(t)&&(t===Rt||vt(t.prototype))||Q(t)&&null===(t=t[It]))&&(t=void 0)),void 0===t?Rt:t}(e))(0===t?0:t)},Lt=w([].push),Pt=function(e){var t=1==e,n=2==e,a=3==e,r=4==e,i=6==e,s=7==e,o=5==e||i;return function(l,u,c,d){for(var p,g,f=T(l),b=gt(f),h=function(e,t){return be(e),void 0===t?e:ct?ct(e,t):function(){return e.apply(t,arguments)}}(u,c),m=Et(b),y=0,E=d||Nt,v=t?E(l,m):n||s?E(l,0):void 0;m>y;y++)if((o||y in b)&&(g=h(p=b[y],y,f),e))if(t)v[y]=g;else if(g)switch(e){case 3:return !0;case 5:return p;case 6:return y;case 2:Lt(v,p);}else switch(e){case 4:return !1;case 7:Lt(v,p);}return i?-1:a||r?r:v}},Ct={forEach:Pt(0),map:Pt(1),filter:Pt(2),some:Pt(3),every:Pt(4),find:Pt(5),findIndex:Pt(6),filterReject:Pt(7)}.forEach,Ft=!!(it=[]["forEach"])&&z((function(){it.call(null,rt||function(){throw 1},1);}))?[].forEach:function(e){return Ct(this,e,arguments.length>1?arguments[1]:void 0)},Dt=function(e){if(e&&e.forEach!==Ft)try{Te(e,"forEach",Ft);}catch(t){e.forEach=Ft;}};for(var $t in st)st[$t]&&Dt(g[$t]&&g[$t].prototype);Dt(ut);var Mt={}.propertyIsEnumerable,Bt=Object.getOwnPropertyDescriptor,Ut={f:Bt&&!Mt.call({1:2},1)?function(e){var t=Bt(this,e);return !!t&&t.enumerable}:Mt},jt=function(e){return gt(A(e))},zt=Object.getOwnPropertyDescriptor,Gt={f:J?zt:function(e,t){if(e=jt(e),t=Se(t),ae)try{return zt(e,t)}catch(e){}if(O(e,t))return xe(!le(Ut.f,e,t),e[t])}},Ht=Math.max,qt=Math.min,Yt=function(e,t){var n=ht(e);return n<0?Ht(n+t,0):qt(n,t)},Xt=function(e){return function(t,n,a){var r,i=jt(t),s=Et(i),o=Yt(a,s);if(e&&n!=n){for(;s>o;)if((r=i[o++])!=r)return !0}else for(;s>o;o++)if((e||o in i)&&i[o]===n)return e||o||0;return !e&&-1}},Wt={includes:Xt(!0),indexOf:Xt(!1)}.indexOf,Zt=w([].push),Vt=function(e,t){var n,a=jt(e),r=0,i=[];for(n in a)!O(De,n)&&O(a,n)&&Zt(i,n);for(;t.length>r;)O(a,n=t[r++])&&(~Wt(i,n)||Zt(i,n));return i},Kt=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],Jt=Kt.concat("length","prototype"),Qt={f:Object.getOwnPropertyNames||function(e){return Vt(e,Jt)}},en={f:Object.getOwnPropertySymbols},tn=w([].concat),nn=F("Reflect","ownKeys")||function(e){var t=Qt.f(se(e)),n=en.f;return n?tn(t,n(e)):t},an=function(e,t){for(var n=nn(t),a=Ae.f,r=Gt.f,i=0;i<n.length;i++){var s=n[i];O(e,s)||a(e,s,r(t,s));}},rn=/#|\.prototype\./,sn=function(e,t){var n=ln[on(e)];return n==cn||n!=un&&(P(t)?z(t):!!t)},on=sn.normalize=function(e){return String(e).replace(rn,".").toLowerCase()},ln=sn.data={},un=sn.NATIVE="N",cn=sn.POLYFILL="P",dn=sn,pn=Gt.f,gn=function(e,t){var n,a,r,i,s,o=e.target,l=e.global,u=e.stat;if(n=l?g:u?g[o]||b(o,{}):(g[o]||{}).prototype)for(a in t){if(i=t[a],r=e.noTargetGet?(s=pn(n,a))&&s.value:n[a],!dn(l?a:o+(u?".":"#")+a,e.forced)&&void 0!==r){if(typeof i==typeof r)continue;an(i,r);}(e.sham||r&&r.sham)&&Te(i,"sham",!0),Ze(n,a,i,e);}},fn=Object.keys||function(e){return Vt(e,Kt)},bn=Object.assign,hn=Object.defineProperty,mn=w([].concat),yn=!bn||z((function(){if(J&&1!==bn({b:1},bn(hn({},"a",{enumerable:!0,get:function(){hn(this,"b",{value:3,enumerable:!1});}}),{b:2})).b)return !0;var e={},t={},n=Symbol(),a="abcdefghijklmnopqrst";return e[n]=7,a.split("").forEach((function(e){t[e]=e;})),7!=bn({},e)[n]||fn(bn({},t)).join("")!=a}))?function(e,t){for(var n=T(e),a=arguments.length,r=1,i=en.f,s=Ut.f;a>r;)for(var o,l=gt(arguments[r++]),u=i?mn(fn(l),i(l)):fn(l),c=u.length,d=0;c>d;)o=u[d++],J&&!le(s,l,o)||(n[o]=l[o]);return n}:bn;gn({target:"Object",stat:!0,forced:Object.assign!==yn},{assign:yn});var En=u((function(e){var t=function(e){var t=/\blang(?:uage)?-([\w-]+)\b/i,n=0,a={},r={manual:e.Prism&&e.Prism.manual,disableWorkerMessageHandler:e.Prism&&e.Prism.disableWorkerMessageHandler,util:{encode:function e(t){return t instanceof i?new i(t.type,e(t.content),t.alias):Array.isArray(t)?t.map(e):t.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/\u00a0/g," ")},type:function(e){return Object.prototype.toString.call(e).slice(8,-1)},objId:function(e){return e.__id||Object.defineProperty(e,"__id",{value:++n}),e.__id},clone:function e(t,n){var a,i;switch(n=n||{},r.util.type(t)){case"Object":if(i=r.util.objId(t),n[i])return n[i];for(var s in a={},n[i]=a,t)t.hasOwnProperty(s)&&(a[s]=e(t[s],n));return a;case"Array":return i=r.util.objId(t),n[i]?n[i]:(a=[],n[i]=a,t.forEach((function(t,r){a[r]=e(t,n);})),a);default:return t}},getLanguage:function(e){for(;e&&!t.test(e.className);)e=e.parentElement;return e?(e.className.match(t)||[,"none"])[1].toLowerCase():"none"},currentScript:function(){if("undefined"==typeof document)return null;if("currentScript"in document)return document.currentScript;try{throw new Error}catch(a){var e=(/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(a.stack)||[])[1];if(e){var t=document.getElementsByTagName("script");for(var n in t)if(t[n].src==e)return t[n]}return null}},isActive:function(e,t,n){for(var a="no-"+t;e;){var r=e.classList;if(r.contains(t))return !0;if(r.contains(a))return !1;e=e.parentElement;}return !!n}},languages:{plain:a,plaintext:a,text:a,txt:a,extend:function(e,t){var n=r.util.clone(r.languages[e]);for(var a in t)n[a]=t[a];return n},insertBefore:function(e,t,n,a){var i=(a=a||r.languages)[e],s={};for(var o in i)if(i.hasOwnProperty(o)){if(o==t)for(var l in n)n.hasOwnProperty(l)&&(s[l]=n[l]);n.hasOwnProperty(o)||(s[o]=i[o]);}var u=a[e];return a[e]=s,r.languages.DFS(r.languages,(function(t,n){n===u&&t!=e&&(this[t]=s);})),s},DFS:function e(t,n,a,i){i=i||{};var s=r.util.objId;for(var o in t)if(t.hasOwnProperty(o)){n.call(t,o,t[o],a||o);var l=t[o],u=r.util.type(l);"Object"!==u||i[s(l)]?"Array"!==u||i[s(l)]||(i[s(l)]=!0,e(l,n,o,i)):(i[s(l)]=!0,e(l,n,null,i));}}},plugins:{},highlightAll:function(e,t){r.highlightAllUnder(document,e,t);},highlightAllUnder:function(e,t,n){var a={callback:n,container:e,selector:'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'};r.hooks.run("before-highlightall",a),a.elements=Array.prototype.slice.apply(a.container.querySelectorAll(a.selector)),r.hooks.run("before-all-elements-highlight",a);for(var i,s=0;i=a.elements[s++];)r.highlightElement(i,!0===t,a.callback);},highlightElement:function(n,a,i){var s=r.util.getLanguage(n),o=r.languages[s];n.className=n.className.replace(t,"").replace(/\s+/g," ")+" language-"+s;var l=n.parentElement;l&&"pre"===l.nodeName.toLowerCase()&&(l.className=l.className.replace(t,"").replace(/\s+/g," ")+" language-"+s);var u={element:n,language:s,grammar:o,code:n.textContent};function c(e){u.highlightedCode=e,r.hooks.run("before-insert",u),u.element.innerHTML=u.highlightedCode,r.hooks.run("after-highlight",u),r.hooks.run("complete",u),i&&i.call(u.element);}if(r.hooks.run("before-sanity-check",u),(l=u.element.parentElement)&&"pre"===l.nodeName.toLowerCase()&&!l.hasAttribute("tabindex")&&l.setAttribute("tabindex","0"),!u.code)return r.hooks.run("complete",u),void(i&&i.call(u.element));if(r.hooks.run("before-highlight",u),u.grammar)if(a&&e.Worker){var d=new Worker(r.filename);d.onmessage=function(e){c(e.data);},d.postMessage(JSON.stringify({language:u.language,code:u.code,immediateClose:!0}));}else c(r.highlight(u.code,u.grammar,u.language));else c(r.util.encode(u.code));},highlight:function(e,t,n){var a={code:e,grammar:t,language:n};return r.hooks.run("before-tokenize",a),a.tokens=r.tokenize(a.code,a.grammar),r.hooks.run("after-tokenize",a),i.stringify(r.util.encode(a.tokens),a.language)},tokenize:function(e,t){var n=t.rest;if(n){for(var a in n)t[a]=n[a];delete t.rest;}var r=new l;return u(r,r.head,e),o(e,r,t,r.head,0),function(e){var t=[],n=e.head.next;for(;n!==e.tail;)t.push(n.value),n=n.next;return t}(r)},hooks:{all:{},add:function(e,t){var n=r.hooks.all;n[e]=n[e]||[],n[e].push(t);},run:function(e,t){var n=r.hooks.all[e];if(n&&n.length)for(var a,i=0;a=n[i++];)a(t);}},Token:i};function i(e,t,n,a){this.type=e,this.content=t,this.alias=n,this.length=0|(a||"").length;}function s(e,t,n,a){e.lastIndex=t;var r=e.exec(n);if(r&&a&&r[1]){var i=r[1].length;r.index+=i,r[0]=r[0].slice(i);}return r}function o(e,t,n,a,l,d){for(var p in n)if(n.hasOwnProperty(p)&&n[p]){var g=n[p];g=Array.isArray(g)?g:[g];for(var f=0;f<g.length;++f){if(d&&d.cause==p+","+f)return;var b=g[f],h=b.inside,m=!!b.lookbehind,y=!!b.greedy,E=b.alias;if(y&&!b.pattern.global){var v=b.pattern.toString().match(/[imsuy]*$/)[0];b.pattern=RegExp(b.pattern.source,v+"g");}for(var S=b.pattern||b,w=a.next,k=l;w!==t.tail&&!(d&&k>=d.reach);k+=w.value.length,w=w.next){var A=w.value;if(t.length>e.length)return;if(!(A instanceof i)){var x,T=1;if(y){if(!(x=s(S,k,e,m)))break;var _=x.index,O=x.index+x[0].length,I=k;for(I+=w.value.length;_>=I;)I+=(w=w.next).value.length;if(k=I-=w.value.length,w.value instanceof i)continue;for(var R=w;R!==t.tail&&(I<O||"string"==typeof R.value);R=R.next)T++,I+=R.value.length;T--,A=e.slice(k,I),x.index-=k;}else if(!(x=s(S,0,A,m)))continue;_=x.index;var N=x[0],L=A.slice(0,_),P=A.slice(_+N.length),C=k+A.length;d&&C>d.reach&&(d.reach=C);var F=w.prev;if(L&&(F=u(t,F,L),k+=L.length),c(t,F,T),w=u(t,F,new i(p,h?r.tokenize(N,h):N,E,N)),P&&u(t,w,P),T>1){var D={cause:p+","+f,reach:C};o(e,t,n,w.prev,k,D),d&&D.reach>d.reach&&(d.reach=D.reach);}}}}}}function l(){var e={value:null,prev:null,next:null},t={value:null,prev:e,next:null};e.next=t,this.head=e,this.tail=t,this.length=0;}function u(e,t,n){var a=t.next,r={value:n,prev:t,next:a};return t.next=r,a.prev=r,e.length++,r}function c(e,t,n){for(var a=t.next,r=0;r<n&&a!==e.tail;r++)a=a.next;t.next=a,a.prev=t,e.length-=r;}if(e.Prism=r,i.stringify=function e(t,n){if("string"==typeof t)return t;if(Array.isArray(t)){var a="";return t.forEach((function(t){a+=e(t,n);})),a}var i={type:t.type,content:e(t.content,n),tag:"span",classes:["token",t.type],attributes:{},language:n},s=t.alias;s&&(Array.isArray(s)?Array.prototype.push.apply(i.classes,s):i.classes.push(s)),r.hooks.run("wrap",i);var o="";for(var l in i.attributes)o+=" "+l+'="'+(i.attributes[l]||"").replace(/"/g,"&quot;")+'"';return "<"+i.tag+' class="'+i.classes.join(" ")+'"'+o+">"+i.content+"</"+i.tag+">"},!e.document)return e.addEventListener?(r.disableWorkerMessageHandler||e.addEventListener("message",(function(t){var n=JSON.parse(t.data),a=n.language,i=n.code,s=n.immediateClose;e.postMessage(r.highlight(i,r.languages[a],a)),s&&e.close();}),!1),r):r;var d=r.util.currentScript();function p(){r.manual||r.highlightAll();}if(d&&(r.filename=d.src,d.hasAttribute("data-manual")&&(r.manual=!0)),!r.manual){var g=document.readyState;"loading"===g||"interactive"===g&&d&&d.defer?document.addEventListener("DOMContentLoaded",p):window.requestAnimationFrame?window.requestAnimationFrame(p):window.setTimeout(p,16);}return r}("undefined"!=typeof window?window:"undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope?self:{});
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */e.exports&&(e.exports=t),void 0!==l&&(l.Prism=t),t.languages.markup={comment:{pattern:/<!--(?:(?!<!--)[\s\S])*?-->/,greedy:!0},prolog:{pattern:/<\?[\s\S]+?\?>/,greedy:!0},doctype:{pattern:/<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,greedy:!0,inside:{"internal-subset":{pattern:/(^[^\[]*\[)[\s\S]+(?=\]>$)/,lookbehind:!0,greedy:!0,inside:null},string:{pattern:/"[^"]*"|'[^']*'/,greedy:!0},punctuation:/^<!|>$|[[\]]/,"doctype-tag":/^DOCTYPE/i,name:/[^\s<>'"]+/}},cdata:{pattern:/<!\[CDATA\[[\s\S]*?\]\]>/i,greedy:!0},tag:{pattern:/<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,greedy:!0,inside:{tag:{pattern:/^<\/?[^\s>\/]+/,inside:{punctuation:/^<\/?/,namespace:/^[^\s>\/:]+:/}},"special-attr":[],"attr-value":{pattern:/=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,inside:{punctuation:[{pattern:/^=/,alias:"attr-equals"},/"|'/]}},punctuation:/\/?>/,"attr-name":{pattern:/[^\s>\/]+/,inside:{namespace:/^[^\s>\/:]+:/}}}},entity:[{pattern:/&[\da-z]{1,8};/i,alias:"named-entity"},/&#x?[\da-f]{1,8};/i]},t.languages.markup.tag.inside["attr-value"].inside.entity=t.languages.markup.entity,t.languages.markup.doctype.inside["internal-subset"].inside=t.languages.markup,t.hooks.add("wrap",(function(e){"entity"===e.type&&(e.attributes.title=e.content.replace(/&amp;/,"&"));})),Object.defineProperty(t.languages.markup.tag,"addInlined",{value:function(e,n){var a={};a["language-"+n]={pattern:/(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,lookbehind:!0,inside:t.languages[n]},a.cdata=/^<!\[CDATA\[|\]\]>$/i;var r={"included-cdata":{pattern:/<!\[CDATA\[[\s\S]*?\]\]>/i,inside:a}};r["language-"+n]={pattern:/[\s\S]+/,inside:t.languages[n]};var i={};i[e]={pattern:RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g,(function(){return e})),"i"),lookbehind:!0,greedy:!0,inside:r},t.languages.insertBefore("markup","cdata",i);}}),Object.defineProperty(t.languages.markup.tag,"addAttribute",{value:function(e,n){t.languages.markup.tag.inside["special-attr"].push({pattern:RegExp(/(^|["'\s])/.source+"(?:"+e+")"+/\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,"i"),lookbehind:!0,inside:{"attr-name":/^[^\s=]+/,"attr-value":{pattern:/=[\s\S]+/,inside:{value:{pattern:/(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,lookbehind:!0,alias:[n,"language-"+n],inside:t.languages[n]},punctuation:[{pattern:/^=/,alias:"attr-equals"},/"|'/]}}}});}}),t.languages.html=t.languages.markup,t.languages.mathml=t.languages.markup,t.languages.svg=t.languages.markup,t.languages.xml=t.languages.extend("markup",{}),t.languages.ssml=t.languages.xml,t.languages.atom=t.languages.xml,t.languages.rss=t.languages.xml,function(e){var t=/(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;e.languages.css={comment:/\/\*[\s\S]*?\*\//,atrule:{pattern:/@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,inside:{rule:/^@[\w-]+/,"selector-function-argument":{pattern:/(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,lookbehind:!0,alias:"selector"},keyword:{pattern:/(^|[^\w-])(?:and|not|only|or)(?![\w-])/,lookbehind:!0}}},url:{pattern:RegExp("\\burl\\((?:"+t.source+"|"+/(?:[^\\\r\n()"']|\\[\s\S])*/.source+")\\)","i"),greedy:!0,inside:{function:/^url/i,punctuation:/^\(|\)$/,string:{pattern:RegExp("^"+t.source+"$"),alias:"url"}}},selector:{pattern:RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|"+t.source+")*(?=\\s*\\{)"),lookbehind:!0},string:{pattern:t,greedy:!0},property:{pattern:/(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,lookbehind:!0},important:/!important\b/i,function:{pattern:/(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,lookbehind:!0},punctuation:/[(){};:,]/},e.languages.css.atrule.inside.rest=e.languages.css;var n=e.languages.markup;n&&(n.tag.addInlined("style","css"),n.tag.addAttribute("style","css"));}(t),t.languages.clike={comment:[{pattern:/(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,lookbehind:!0,greedy:!0},{pattern:/(^|[^\\:])\/\/.*/,lookbehind:!0,greedy:!0}],string:{pattern:/(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,greedy:!0},"class-name":{pattern:/(\b(?:class|interface|extends|implements|trait|instanceof|new)\s+|\bcatch\s+\()[\w.\\]+/i,lookbehind:!0,inside:{punctuation:/[.\\]/}},keyword:/\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,boolean:/\b(?:true|false)\b/,function:/\b\w+(?=\()/,number:/\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,operator:/[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,punctuation:/[{}[\];(),.:]/},t.languages.javascript=t.languages.extend("clike",{"class-name":[t.languages.clike["class-name"],{pattern:/(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:prototype|constructor))/,lookbehind:!0}],keyword:[{pattern:/((?:^|\})\s*)catch\b/,lookbehind:!0},{pattern:/(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,lookbehind:!0}],function:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,number:/\b(?:(?:0[xX](?:[\dA-Fa-f](?:_[\dA-Fa-f])?)+|0[bB](?:[01](?:_[01])?)+|0[oO](?:[0-7](?:_[0-7])?)+)n?|(?:\d(?:_\d)?)+n|NaN|Infinity)\b|(?:\b(?:\d(?:_\d)?)+\.?(?:\d(?:_\d)?)*|\B\.(?:\d(?:_\d)?)+)(?:[Ee][+-]?(?:\d(?:_\d)?)+)?/,operator:/--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/}),t.languages.javascript["class-name"][0].pattern=/(\b(?:class|interface|extends|implements|instanceof|new)\s+)[\w.\\]+/,t.languages.insertBefore("javascript","keyword",{regex:{pattern:/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,lookbehind:!0,greedy:!0,inside:{"regex-source":{pattern:/^(\/)[\s\S]+(?=\/[a-z]*$)/,lookbehind:!0,alias:"language-regex",inside:t.languages.regex},"regex-delimiter":/^\/|\/$/,"regex-flags":/^[a-z]+$/}},"function-variable":{pattern:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,alias:"function"},parameter:[{pattern:/(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,lookbehind:!0,inside:t.languages.javascript},{pattern:/(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,lookbehind:!0,inside:t.languages.javascript},{pattern:/(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,lookbehind:!0,inside:t.languages.javascript},{pattern:/((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,lookbehind:!0,inside:t.languages.javascript}],constant:/\b[A-Z](?:[A-Z_]|\dx?)*\b/}),t.languages.insertBefore("javascript","string",{hashbang:{pattern:/^#!.*/,greedy:!0,alias:"comment"},"template-string":{pattern:/`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,greedy:!0,inside:{"template-punctuation":{pattern:/^`|`$/,alias:"string"},interpolation:{pattern:/((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,lookbehind:!0,inside:{"interpolation-punctuation":{pattern:/^\$\{|\}$/,alias:"punctuation"},rest:t.languages.javascript}},string:/[\s\S]+/}}}),t.languages.markup&&(t.languages.markup.tag.addInlined("script","javascript"),t.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,"javascript")),t.languages.js=t.languages.javascript,function(){if(void 0!==t&&"undefined"!=typeof document){Element.prototype.matches||(Element.prototype.matches=Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector);var e={js:"javascript",py:"python",rb:"ruby",ps1:"powershell",psm1:"powershell",sh:"bash",bat:"batch",h:"c",tex:"latex"},n="data-src-status",a="loading",r="loaded",i='pre[data-src]:not([data-src-status="loaded"]):not([data-src-status="loading"])',s=/\blang(?:uage)?-([\w-]+)\b/i;t.hooks.add("before-highlightall",(function(e){e.selector+=", "+i;})),t.hooks.add("before-sanity-check",(function(s){var o=s.element;if(o.matches(i)){s.code="",o.setAttribute(n,a);var u=o.appendChild(document.createElement("CODE"));u.textContent="Loading…";var c=o.getAttribute("data-src"),d=s.language;if("none"===d){var p=(/\.(\w+)$/.exec(c)||[,"none"])[1];d=e[p]||p;}l(u,d),l(o,d);var g=t.plugins.autoloader;g&&g.loadLanguages(d);var f=new XMLHttpRequest;f.open("GET",c,!0),f.onreadystatechange=function(){var e,a;4==f.readyState&&(f.status<400&&f.responseText?(o.setAttribute(n,r),u.textContent=f.responseText,t.highlightElement(u)):(o.setAttribute(n,"failed"),f.status>=400?u.textContent=(e=f.status,a=f.statusText,"✖ Error "+e+" while fetching file: "+a):u.textContent="✖ Error: File does not exist or is empty"));},f.send(null);}})),t.plugins.fileHighlight={highlight:function(e){for(var n,a=(e||document).querySelectorAll(i),r=0;n=a[r++];)t.highlightElement(n);}};var o=!1;t.fileHighlight=function(){o||(console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead."),o=!0),t.plugins.fileHighlight.highlight.apply(this,arguments);};}function l(e,t){var n=e.className;n=n.replace(s," ")+" language-"+t,e.className=n.replace(/\s+/g," ").trim();}}();}));!function(e){var t=e.util.clone(e.languages.javascript),n=/(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source,a=/(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source,r=/(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;function i(e,t){return e=e.replace(/<S>/g,(function(){return n})).replace(/<BRACES>/g,(function(){return a})).replace(/<SPREAD>/g,(function(){return r})),RegExp(e,t)}r=i(r).source,e.languages.jsx=e.languages.extend("markup",t),e.languages.jsx.tag.pattern=i(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source),e.languages.jsx.tag.inside.tag.pattern=/^<\/?[^\s>\/]*/i,e.languages.jsx.tag.inside["attr-value"].pattern=/=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/i,e.languages.jsx.tag.inside.tag.inside["class-name"]=/^[A-Z]\w*(?:\.[A-Z]\w*)*$/,e.languages.jsx.tag.inside.comment=t.comment,e.languages.insertBefore("inside","attr-name",{spread:{pattern:i(/<SPREAD>/.source),inside:e.languages.jsx}},e.languages.jsx.tag),e.languages.insertBefore("inside","special-attr",{script:{pattern:i(/=<BRACES>/.source),inside:{"script-punctuation":{pattern:/^=(?=\{)/,alias:"punctuation"},rest:e.languages.jsx},alias:"language-javascript"}},e.languages.jsx.tag);var s=function(e){return e?"string"==typeof e?e:"string"==typeof e.content?e.content:e.content.map(s).join(""):""},o=function(t){for(var n=[],a=0;a<t.length;a++){var r=t[a],i=!1;if("string"!=typeof r&&("tag"===r.type&&r.content[0]&&"tag"===r.content[0].type?"</"===r.content[0].content[0].content?n.length>0&&n[n.length-1].tagName===s(r.content[0].content[1])&&n.pop():"/>"===r.content[r.content.length-1].content||n.push({tagName:s(r.content[0].content[1]),openedBraces:0}):n.length>0&&"punctuation"===r.type&&"{"===r.content?n[n.length-1].openedBraces++:n.length>0&&n[n.length-1].openedBraces>0&&"punctuation"===r.type&&"}"===r.content?n[n.length-1].openedBraces--:i=!0),(i||"string"==typeof r)&&n.length>0&&0===n[n.length-1].openedBraces){var l=s(r);a<t.length-1&&("string"==typeof t[a+1]||"plain-text"===t[a+1].type)&&(l+=s(t[a+1]),t.splice(a+1,1)),a>0&&("string"==typeof t[a-1]||"plain-text"===t[a-1].type)&&(l=s(t[a-1])+l,t.splice(a-1,1),a--),t[a]=new e.Token("plain-text",l,null,l);}r.content&&"string"!=typeof r.content&&o(r.content);}};e.hooks.add("after-tokenize",(function(e){"jsx"!==e.language&&"tsx"!==e.language||o(e.tokens);}));}(Prism),function(e){e.languages.typescript=e.languages.extend("javascript",{"class-name":{pattern:/(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,lookbehind:!0,greedy:!0,inside:null},builtin:/\b(?:string|Function|any|number|boolean|Array|symbol|console|Promise|unknown|never)\b/}),e.languages.typescript.keyword.push(/\b(?:abstract|as|declare|implements|is|keyof|readonly|require)\b/,/\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,/\btype\b(?=\s*(?:[\{*]|$))/),delete e.languages.typescript.parameter;var t=e.languages.extend("typescript",{});delete t["class-name"],e.languages.typescript["class-name"].inside=t,e.languages.insertBefore("typescript","function",{decorator:{pattern:/@[$\w\xA0-\uFFFF]+/,inside:{at:{pattern:/^@/,alias:"operator"},function:/^[\s\S]+/}},"generic-function":{pattern:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,greedy:!0,inside:{function:/^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,generic:{pattern:/<[\s\S]+/,alias:"class-name",inside:t}}}}),e.languages.ts=e.languages.typescript;}(Prism),Prism.languages.markup={comment:{pattern:/<!--(?:(?!<!--)[\s\S])*?-->/,greedy:!0},prolog:{pattern:/<\?[\s\S]+?\?>/,greedy:!0},doctype:{pattern:/<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,greedy:!0,inside:{"internal-subset":{pattern:/(^[^\[]*\[)[\s\S]+(?=\]>$)/,lookbehind:!0,greedy:!0,inside:null},string:{pattern:/"[^"]*"|'[^']*'/,greedy:!0},punctuation:/^<!|>$|[[\]]/,"doctype-tag":/^DOCTYPE/i,name:/[^\s<>'"]+/}},cdata:{pattern:/<!\[CDATA\[[\s\S]*?\]\]>/i,greedy:!0},tag:{pattern:/<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,greedy:!0,inside:{tag:{pattern:/^<\/?[^\s>\/]+/,inside:{punctuation:/^<\/?/,namespace:/^[^\s>\/:]+:/}},"special-attr":[],"attr-value":{pattern:/=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,inside:{punctuation:[{pattern:/^=/,alias:"attr-equals"},/"|'/]}},punctuation:/\/?>/,"attr-name":{pattern:/[^\s>\/]+/,inside:{namespace:/^[^\s>\/:]+:/}}}},entity:[{pattern:/&[\da-z]{1,8};/i,alias:"named-entity"},/&#x?[\da-f]{1,8};/i]},Prism.languages.markup.tag.inside["attr-value"].inside.entity=Prism.languages.markup.entity,Prism.languages.markup.doctype.inside["internal-subset"].inside=Prism.languages.markup,Prism.hooks.add("wrap",(function(e){"entity"===e.type&&(e.attributes.title=e.content.replace(/&amp;/,"&"));})),Object.defineProperty(Prism.languages.markup.tag,"addInlined",{value:function(e,t){var n={};n["language-"+t]={pattern:/(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,lookbehind:!0,inside:Prism.languages[t]},n.cdata=/^<!\[CDATA\[|\]\]>$/i;var a={"included-cdata":{pattern:/<!\[CDATA\[[\s\S]*?\]\]>/i,inside:n}};a["language-"+t]={pattern:/[\s\S]+/,inside:Prism.languages[t]};var r={};r[e]={pattern:RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g,(function(){return e})),"i"),lookbehind:!0,greedy:!0,inside:a},Prism.languages.insertBefore("markup","cdata",r);}}),Object.defineProperty(Prism.languages.markup.tag,"addAttribute",{value:function(e,t){Prism.languages.markup.tag.inside["special-attr"].push({pattern:RegExp(/(^|["'\s])/.source+"(?:"+e+")"+/\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,"i"),lookbehind:!0,inside:{"attr-name":/^[^\s=]+/,"attr-value":{pattern:/=[\s\S]+/,inside:{value:{pattern:/(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,lookbehind:!0,alias:[t,"language-"+t],inside:Prism.languages[t]},punctuation:[{pattern:/^=/,alias:"attr-equals"},/"|'/]}}}});}}),Prism.languages.html=Prism.languages.markup,Prism.languages.mathml=Prism.languages.markup,Prism.languages.svg=Prism.languages.markup,Prism.languages.xml=Prism.languages.extend("markup",{}),Prism.languages.ssml=Prism.languages.xml,Prism.languages.atom=Prism.languages.xml,Prism.languages.rss=Prism.languages.xml,Prism.languages.go=Prism.languages.extend("clike",{string:{pattern:/(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,greedy:!0},keyword:/\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,boolean:/\b(?:_|iota|nil|true|false)\b/,number:/(?:\b0x[a-f\d]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[-+]?\d+)?)i?/i,operator:/[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,builtin:/\b(?:bool|byte|complex(?:64|128)|error|float(?:32|64)|rune|string|u?int(?:8|16|32|64)?|uintptr|append|cap|close|complex|copy|delete|imag|len|make|new|panic|print(?:ln)?|real|recover)\b/}),delete Prism.languages.go["class-name"],function(e){var t=/\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/,n=[{pattern:/\b(?:false|true)\b/i,alias:"boolean"},{pattern:/(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,greedy:!0,lookbehind:!0},{pattern:/(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,greedy:!0,lookbehind:!0},/\b(?:null)\b/i,/\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/],a=/\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i,r=/<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/,i=/[{}\[\](),:;]/;e.languages.php={delimiter:{pattern:/\?>$|^<\?(?:php(?=\s)|=)?/i,alias:"important"},comment:t,variable:/\$+(?:\w+\b|(?=\{))/i,package:{pattern:/(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,lookbehind:!0,inside:{punctuation:/\\/}},"class-name-definition":{pattern:/(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,lookbehind:!0,alias:"class-name"},"function-definition":{pattern:/(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,lookbehind:!0,alias:"function"},keyword:[{pattern:/(\(\s*)\b(?:bool|boolean|int|integer|float|string|object|array)\b(?=\s*\))/i,alias:"type-casting",greedy:!0,lookbehind:!0},{pattern:/([(,?]\s*)\b(?:bool|int|float|string|object|array(?!\s*\()|mixed|self|static|callable|iterable|(?:null|false)(?=\s*\|))\b(?=\s*\$)/i,alias:"type-hint",greedy:!0,lookbehind:!0},{pattern:/([(,?]\s*[\w|]\|\s*)(?:null|false)\b(?=\s*\$)/i,alias:"type-hint",greedy:!0,lookbehind:!0},{pattern:/(\)\s*:\s*(?:\?\s*)?)\b(?:bool|int|float|string|object|void|array(?!\s*\()|mixed|self|static|callable|iterable|(?:null|false)(?=\s*\|))\b/i,alias:"return-type",greedy:!0,lookbehind:!0},{pattern:/(\)\s*:\s*(?:\?\s*)?[\w|]\|\s*)(?:null|false)\b/i,alias:"return-type",greedy:!0,lookbehind:!0},{pattern:/\b(?:bool|int|float|string|object|void|array(?!\s*\()|mixed|iterable|(?:null|false)(?=\s*\|))\b/i,alias:"type-declaration",greedy:!0},{pattern:/(\|\s*)(?:null|false)\b/i,alias:"type-declaration",greedy:!0,lookbehind:!0},{pattern:/\b(?:parent|self|static)(?=\s*::)/i,alias:"static-context",greedy:!0},{pattern:/(\byield\s+)from\b/i,lookbehind:!0},/\bclass\b/i,{pattern:/((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:__halt_compiler|abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|namespace|match|new|or|parent|print|private|protected|public|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield)\b/i,lookbehind:!0}],"argument-name":{pattern:/([(,]\s+)\b[a-z_]\w*(?=\s*:(?!:))/i,lookbehind:!0},"class-name":[{pattern:/(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,greedy:!0,lookbehind:!0},{pattern:/(\|\s*)\b[a-z_]\w*(?!\\)\b/i,greedy:!0,lookbehind:!0},{pattern:/\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,greedy:!0},{pattern:/(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,alias:"class-name-fully-qualified",greedy:!0,lookbehind:!0,inside:{punctuation:/\\/}},{pattern:/(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,alias:"class-name-fully-qualified",greedy:!0,inside:{punctuation:/\\/}},{pattern:/(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,alias:"class-name-fully-qualified",greedy:!0,lookbehind:!0,inside:{punctuation:/\\/}},{pattern:/\b[a-z_]\w*(?=\s*\$)/i,alias:"type-declaration",greedy:!0},{pattern:/(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,alias:["class-name-fully-qualified","type-declaration"],greedy:!0,inside:{punctuation:/\\/}},{pattern:/\b[a-z_]\w*(?=\s*::)/i,alias:"static-context",greedy:!0},{pattern:/(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,alias:["class-name-fully-qualified","static-context"],greedy:!0,inside:{punctuation:/\\/}},{pattern:/([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,alias:"type-hint",greedy:!0,lookbehind:!0},{pattern:/([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,alias:["class-name-fully-qualified","type-hint"],greedy:!0,lookbehind:!0,inside:{punctuation:/\\/}},{pattern:/(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,alias:"return-type",greedy:!0,lookbehind:!0},{pattern:/(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,alias:["class-name-fully-qualified","return-type"],greedy:!0,lookbehind:!0,inside:{punctuation:/\\/}}],constant:n,function:{pattern:/(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,lookbehind:!0,inside:{punctuation:/\\/}},property:{pattern:/(->\s*)\w+/,lookbehind:!0},number:a,operator:r,punctuation:i};var s={pattern:/\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,lookbehind:!0,inside:e.languages.php},o=[{pattern:/<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,alias:"nowdoc-string",greedy:!0,inside:{delimiter:{pattern:/^<<<'[^']+'|[a-z_]\w*;$/i,alias:"symbol",inside:{punctuation:/^<<<'?|[';]$/}}}},{pattern:/<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,alias:"heredoc-string",greedy:!0,inside:{delimiter:{pattern:/^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,alias:"symbol",inside:{punctuation:/^<<<"?|[";]$/}},interpolation:s}},{pattern:/`(?:\\[\s\S]|[^\\`])*`/,alias:"backtick-quoted-string",greedy:!0},{pattern:/'(?:\\[\s\S]|[^\\'])*'/,alias:"single-quoted-string",greedy:!0},{pattern:/"(?:\\[\s\S]|[^\\"])*"/,alias:"double-quoted-string",greedy:!0,inside:{interpolation:s}}];e.languages.insertBefore("php","variable",{string:o,attribute:{pattern:/#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,greedy:!0,inside:{"attribute-content":{pattern:/^(#\[)[\s\S]+(?=\]$)/,lookbehind:!0,inside:{comment:t,string:o,"attribute-class-name":[{pattern:/([^:]|^)\b[a-z_]\w*(?!\\)\b/i,alias:"class-name",greedy:!0,lookbehind:!0},{pattern:/([^:]|^)(?:\\?\b[a-z_]\w*)+/i,alias:["class-name","class-name-fully-qualified"],greedy:!0,lookbehind:!0,inside:{punctuation:/\\/}}],constant:n,number:a,operator:r,punctuation:i}},delimiter:{pattern:/^#\[|\]$/,alias:"punctuation"}}}}),e.hooks.add("before-tokenize",(function(t){if(/<\?/.test(t.code)){e.languages["markup-templating"].buildPlaceholders(t,"php",/<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/gi);}})),e.hooks.add("after-tokenize",(function(t){e.languages["markup-templating"].tokenizePlaceholders(t,"php");}));}(Prism),Prism.languages.c=Prism.languages.extend("clike",{comment:{pattern:/\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,greedy:!0},"class-name":{pattern:/(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,lookbehind:!0},keyword:/\b(?:__attribute__|_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|asm|typeof|inline|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|union|unsigned|void|volatile|while)\b/,function:/\b[a-z_]\w*(?=\s*\()/i,number:/(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,operator:/>>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/}),Prism.languages.insertBefore("c","string",{macro:{pattern:/(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,lookbehind:!0,greedy:!0,alias:"property",inside:{string:[{pattern:/^(#\s*include\s*)<[^>]+>/,lookbehind:!0},Prism.languages.c.string],comment:Prism.languages.c.comment,"macro-name":[{pattern:/(^#\s*define\s+)\w+\b(?!\()/i,lookbehind:!0},{pattern:/(^#\s*define\s+)\w+\b(?=\()/i,lookbehind:!0,alias:"function"}],directive:{pattern:/^(#\s*)[a-z]+/,lookbehind:!0,alias:"keyword"},"directive-hash":/^#/,punctuation:/##|\\(?=[\r\n])/,expression:{pattern:/\S[\s\S]*/,inside:Prism.languages.c}}},constant:/\b(?:__FILE__|__LINE__|__DATE__|__TIME__|__TIMESTAMP__|__func__|EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|stdin|stdout|stderr)\b/}),delete Prism.languages.c.boolean,Prism.languages.python={comment:{pattern:/(^|[^\\])#.*/,lookbehind:!0},"string-interpolation":{pattern:/(?:f|rf|fr)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,greedy:!0,inside:{interpolation:{pattern:/((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,lookbehind:!0,inside:{"format-spec":{pattern:/(:)[^:(){}]+(?=\}$)/,lookbehind:!0},"conversion-option":{pattern:/![sra](?=[:}]$)/,alias:"punctuation"},rest:null}},string:/[\s\S]+/}},"triple-quoted-string":{pattern:/(?:[rub]|rb|br)?("""|''')[\s\S]*?\1/i,greedy:!0,alias:"string"},string:{pattern:/(?:[rub]|rb|br)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,greedy:!0},function:{pattern:/((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,lookbehind:!0},"class-name":{pattern:/(\bclass\s+)\w+/i,lookbehind:!0},decorator:{pattern:/(^[\t ]*)@\w+(?:\.\w+)*/im,lookbehind:!0,alias:["annotation","punctuation"],inside:{punctuation:/\./}},keyword:/\b(?:and|as|assert|async|await|break|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,builtin:/\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,boolean:/\b(?:True|False|None)\b/,number:/\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?\b/i,operator:/[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,punctuation:/[{}[\];(),.:]/},Prism.languages.python["string-interpolation"].inside.interpolation.inside.rest=Prism.languages.python,Prism.languages.py=Prism.languages.python,function(e){var t=/\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/,n=/(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source,a={pattern:RegExp(n+/[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),lookbehind:!0,inside:{namespace:{pattern:/^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,inside:{punctuation:/\./}},punctuation:/\./}};e.languages.java=e.languages.extend("clike",{"class-name":[a,{pattern:RegExp(n+/[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source),lookbehind:!0,inside:a.inside}],keyword:t,function:[e.languages.clike.function,{pattern:/(::\s*)[a-z_]\w*/,lookbehind:!0}],number:/\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,operator:{pattern:/(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,lookbehind:!0}}),e.languages.insertBefore("java","string",{"triple-quoted-string":{pattern:/"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,greedy:!0,alias:"string"}}),e.languages.insertBefore("java","class-name",{annotation:{pattern:/(^|[^.])@\w+(?:\s*\.\s*\w+)*/,lookbehind:!0,alias:"punctuation"},generics:{pattern:/<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,inside:{"class-name":a,keyword:t,punctuation:/[<>(),.:]/,operator:/[?&|]/}},namespace:{pattern:RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g,(function(){return t.source}))),lookbehind:!0,inside:{punctuation:/\./}}});}(Prism),function(e){var t=/\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char8_t|char16_t|char32_t|class|compl|concept|const|consteval|constexpr|constinit|const_cast|continue|co_await|co_return|co_yield|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int8_t|int16_t|int32_t|int64_t|uint8_t|uint16_t|uint32_t|uint64_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/,n=/\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g,(function(){return t.source}));e.languages.cpp=e.languages.extend("c",{"class-name":[{pattern:RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g,(function(){return t.source}))),lookbehind:!0},/\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,/\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,/\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/],keyword:t,number:{pattern:/(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,greedy:!0},operator:/>>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,boolean:/\b(?:true|false)\b/}),e.languages.insertBefore("cpp","string",{module:{pattern:RegExp(/(\b(?:module|import)\s+)/.source+"(?:"+/"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source+"|"+/<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g,(function(){return n}))+")"),lookbehind:!0,greedy:!0,inside:{string:/^[<"][\s\S]+/,operator:/:/,punctuation:/\./}},"raw-string":{pattern:/R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,alias:"string",greedy:!0}}),e.languages.insertBefore("cpp","keyword",{"generic-function":{pattern:/\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,inside:{function:/^\w+/,generic:{pattern:/<[\s\S]+/,alias:"class-name",inside:e.languages.cpp}}}}),e.languages.insertBefore("cpp","operator",{"double-colon":{pattern:/::/,alias:"punctuation"}}),e.languages.insertBefore("cpp","class-name",{"base-clause":{pattern:/(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,lookbehind:!0,greedy:!0,inside:e.languages.extend("cpp",{})}}),e.languages.insertBefore("inside","double-colon",{"class-name":/\b[a-z_]\w*\b(?!\s*::)/i},e.languages.cpp["base-clause"]);}(Prism),function(e){function t(e,t){return e.replace(/<<(\d+)>>/g,(function(e,n){return "(?:"+t[+n]+")"}))}function n(e,n,a){return RegExp(t(e,n),a||"")}function a(e,t){for(var n=0;n<t;n++)e=e.replace(/<<self>>/g,(function(){return "(?:"+e+")"}));return e.replace(/<<self>>/g,"[^\\s\\S]")}var r="bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void",i="class enum interface record struct",s="add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)",o="abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield";function l(e){return "\\b(?:"+e.trim().replace(/ /g,"|")+")\\b"}var u=l(i),c=RegExp(l(r+" "+i+" "+s+" "+o)),d=l(i+" "+s+" "+o),p=l(r+" "+i+" "+o),g=a(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source,2),f=a(/\((?:[^()]|<<self>>)*\)/.source,2),b=/@?\b[A-Za-z_]\w*\b/.source,h=t(/<<0>>(?:\s*<<1>>)?/.source,[b,g]),m=t(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source,[d,h]),y=/\[\s*(?:,\s*)*\]/.source,E=t(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source,[m,y]),v=t(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source,[g,f,y]),S=t(/\(<<0>>+(?:,<<0>>+)+\)/.source,[v]),w=t(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source,[S,m,y]),k={keyword:c,punctuation:/[<>()?,.:[\]]/},A=/'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source,x=/"(?:\\.|[^\\"\r\n])*"/.source,T=/@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;e.languages.csharp=e.languages.extend("clike",{string:[{pattern:n(/(^|[^$\\])<<0>>/.source,[T]),lookbehind:!0,greedy:!0},{pattern:n(/(^|[^@$\\])<<0>>/.source,[x]),lookbehind:!0,greedy:!0},{pattern:RegExp(A),greedy:!0,alias:"character"}],"class-name":[{pattern:n(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source,[m]),lookbehind:!0,inside:k},{pattern:n(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source,[b,w]),lookbehind:!0,inside:k},{pattern:n(/(\busing\s+)<<0>>(?=\s*=)/.source,[b]),lookbehind:!0},{pattern:n(/(\b<<0>>\s+)<<1>>/.source,[u,h]),lookbehind:!0,inside:k},{pattern:n(/(\bcatch\s*\(\s*)<<0>>/.source,[m]),lookbehind:!0,inside:k},{pattern:n(/(\bwhere\s+)<<0>>/.source,[b]),lookbehind:!0},{pattern:n(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source,[E]),lookbehind:!0,inside:k},{pattern:n(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source,[w,p,b]),inside:k}],keyword:c,number:/(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:ul|lu|[dflmu])?\b/i,operator:/>>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,punctuation:/\?\.?|::|[{}[\];(),.:]/}),e.languages.insertBefore("csharp","number",{range:{pattern:/\.\./,alias:"operator"}}),e.languages.insertBefore("csharp","punctuation",{"named-parameter":{pattern:n(/([(,]\s*)<<0>>(?=\s*:)/.source,[b]),lookbehind:!0,alias:"punctuation"}}),e.languages.insertBefore("csharp","class-name",{namespace:{pattern:n(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source,[b]),lookbehind:!0,inside:{punctuation:/\./}},"type-expression":{pattern:n(/(\b(?:default|typeof|sizeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source,[f]),lookbehind:!0,alias:"class-name",inside:k},"return-type":{pattern:n(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source,[w,m]),inside:k,alias:"class-name"},"constructor-invocation":{pattern:n(/(\bnew\s+)<<0>>(?=\s*[[({])/.source,[w]),lookbehind:!0,inside:k,alias:"class-name"},"generic-method":{pattern:n(/<<0>>\s*<<1>>(?=\s*\()/.source,[b,g]),inside:{function:n(/^<<0>>/.source,[b]),generic:{pattern:RegExp(g),alias:"class-name",inside:k}}},"type-list":{pattern:n(/\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source,[u,h,b,w,c.source,f,/\bnew\s*\(\s*\)/.source]),lookbehind:!0,inside:{"record-arguments":{pattern:n(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source,[h,f]),lookbehind:!0,greedy:!0,inside:e.languages.csharp},keyword:c,"class-name":{pattern:RegExp(w),greedy:!0,inside:k},punctuation:/[,()]/}},preprocessor:{pattern:/(^[\t ]*)#.*/m,lookbehind:!0,alias:"property",inside:{directive:{pattern:/(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,lookbehind:!0,alias:"keyword"}}}});var _=x+"|"+A,O=t(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source,[_]),I=a(t(/[^"'/()]|<<0>>|\(<<self>>*\)/.source,[O]),2),R=/\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source,N=t(/<<0>>(?:\s*\(<<1>>*\))?/.source,[m,I]);e.languages.insertBefore("csharp","class-name",{attribute:{pattern:n(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source,[R,N]),lookbehind:!0,greedy:!0,inside:{target:{pattern:n(/^<<0>>(?=\s*:)/.source,[R]),alias:"keyword"},"attribute-arguments":{pattern:n(/\(<<0>>*\)/.source,[I]),inside:e.languages.csharp},"class-name":{pattern:RegExp(m),inside:{punctuation:/\./}},punctuation:/[:,]/}}});var L=/:[^}\r\n]+/.source,P=a(t(/[^"'/()]|<<0>>|\(<<self>>*\)/.source,[O]),2),C=t(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source,[P,L]),F=a(t(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source,[_]),2),D=t(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source,[F,L]);function $(t,a){return {interpolation:{pattern:n(/((?:^|[^{])(?:\{\{)*)<<0>>/.source,[t]),lookbehind:!0,inside:{"format-string":{pattern:n(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source,[a,L]),lookbehind:!0,inside:{punctuation:/^:/}},punctuation:/^\{|\}$/,expression:{pattern:/[\s\S]+/,alias:"language-csharp",inside:e.languages.csharp}}},string:/[\s\S]+/}}e.languages.insertBefore("csharp","string",{"interpolation-string":[{pattern:n(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source,[C]),lookbehind:!0,greedy:!0,inside:$(C,P)},{pattern:n(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source,[D]),lookbehind:!0,greedy:!0,inside:$(D,F)}]});}(Prism),Prism.languages.dotnet=Prism.languages.cs=Prism.languages.csharp,Prism.languages["visual-basic"]={comment:{pattern:/(?:['‘’]|REM\b)(?:[^\r\n_]|_(?:\r\n?|\n)?)*/i,inside:{keyword:/^REM/i}},directive:{pattern:/#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:[^\S\r\n]_[^\S\r\n]*(?:\r\n?|\n)|.)+/i,alias:"comment",greedy:!0},string:{pattern:/\$?["“”](?:["“”]{2}|[^"“”])*["“”]C?/i,greedy:!0},date:{pattern:/#[^\S\r\n]*(?:\d+([/-])\d+\1\d+(?:[^\S\r\n]+(?:\d+[^\S\r\n]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[^\S\r\n]*(?:AM|PM))?))?|\d+[^\S\r\n]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[^\S\r\n]*(?:AM|PM))?)[^\S\r\n]*#/i,alias:"builtin"},number:/(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:U?[ILS]|[FRD])?/i,boolean:/\b(?:True|False|Nothing)\b/i,keyword:/\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Currency|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|Type|TypeOf|U(?:Integer|Long|Short)|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Until|Xor)\b/i,operator:[/[+\-*/\\^<=>&#@$%!]/,{pattern:/([^\S\r\n])_(?=[^\S\r\n]*[\r\n])/,lookbehind:!0}],punctuation:/[{}().,:?]/},Prism.languages.vb=Prism.languages["visual-basic"],Prism.languages.vba=Prism.languages["visual-basic"],Prism.languages.sql={comment:{pattern:/(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,lookbehind:!0},variable:[{pattern:/@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,greedy:!0},/@[\w.$]+/],string:{pattern:/(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,greedy:!0,lookbehind:!0},function:/\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,keyword:/\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:_INSERT|COL)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:S|ING)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,boolean:/\b(?:TRUE|FALSE|NULL)\b/i,number:/\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,operator:/[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|IN|ILIKE|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,punctuation:/[;[\]()`,.]/},function(e){e.languages.ruby=e.languages.extend("clike",{comment:[/#.*/,{pattern:/^=begin\s[\s\S]*?^=end/m,greedy:!0}],"class-name":{pattern:/(\b(?:class)\s+|\bcatch\s+\()[\w.\\]+/i,lookbehind:!0,inside:{punctuation:/[.\\]/}},keyword:/\b(?:alias|and|BEGIN|begin|break|case|class|def|define_method|defined|do|each|else|elsif|END|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|protected|private|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/});var t={pattern:/#\{[^}]+\}/,inside:{delimiter:{pattern:/^#\{|\}$/,alias:"tag"},rest:e.languages.ruby}};delete e.languages.ruby.function,e.languages.insertBefore("ruby","keyword",{regex:[{pattern:RegExp(/%r/.source+"(?:"+[/([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,/\((?:[^()\\]|\\[\s\S])*\)/.source,/\{(?:[^#{}\\]|#(?:\{[^}]+\})?|\\[\s\S])*\}/.source,/\[(?:[^\[\]\\]|\\[\s\S])*\]/.source,/<(?:[^<>\\]|\\[\s\S])*>/.source].join("|")+")"+/[egimnosux]{0,6}/.source),greedy:!0,inside:{interpolation:t}},{pattern:/(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,lookbehind:!0,greedy:!0,inside:{interpolation:t}}],variable:/[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,symbol:{pattern:/(^|[^:]):[a-zA-Z_]\w*(?:[?!]|\b)/,lookbehind:!0},"method-definition":{pattern:/(\bdef\s+)[\w.]+/,lookbehind:!0,inside:{function:/\w+$/,rest:e.languages.ruby}}}),e.languages.insertBefore("ruby","number",{builtin:/\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Stat|Fixnum|Float|Hash|Integer|IO|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|String|Struct|TMS|Symbol|ThreadGroup|Thread|Time|TrueClass)\b/,constant:/\b[A-Z]\w*(?:[?!]|\b)/}),e.languages.ruby.string=[{pattern:RegExp(/%[qQiIwWxs]?/.source+"(?:"+[/([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,/\((?:[^()\\]|\\[\s\S])*\)/.source,/\{(?:[^#{}\\]|#(?:\{[^}]+\})?|\\[\s\S])*\}/.source,/\[(?:[^\[\]\\]|\\[\s\S])*\]/.source,/<(?:[^<>\\]|\\[\s\S])*>/.source].join("|")+")"),greedy:!0,inside:{interpolation:t}},{pattern:/("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,greedy:!0,inside:{interpolation:t}},{pattern:/<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,alias:"heredoc-string",greedy:!0,inside:{delimiter:{pattern:/^<<[-~]?[a-z_]\w*|[a-z_]\w*$/i,alias:"symbol",inside:{punctuation:/^<<[-~]?/}},interpolation:t}},{pattern:/<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,alias:"heredoc-string",greedy:!0,inside:{delimiter:{pattern:/^<<[-~]?'[a-z_]\w*'|[a-z_]\w*$/i,alias:"symbol",inside:{punctuation:/^<<[-~]?'|'$/}}}}],e.languages.rb=e.languages.ruby;}(Prism),Prism.languages.swift={comment:{pattern:/(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,lookbehind:!0,greedy:!0},"string-literal":[{pattern:RegExp(/(^|[^"#])/.source+"(?:"+/"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source+"|"+/"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source+")"+/(?!["#])/.source),lookbehind:!0,greedy:!0,inside:{interpolation:{pattern:/(\\\()(?:[^()]|\([^()]*\))*(?=\))/,lookbehind:!0,inside:null},"interpolation-punctuation":{pattern:/^\)|\\\($/,alias:"punctuation"},punctuation:/\\(?=[\r\n])/,string:/[\s\S]+/}},{pattern:RegExp(/(^|[^"#])(#+)/.source+"(?:"+/"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source+"|"+/"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source+")\\2"),lookbehind:!0,greedy:!0,inside:{interpolation:{pattern:/(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,lookbehind:!0,inside:null},"interpolation-punctuation":{pattern:/^\)|\\#+\($/,alias:"punctuation"},string:/[\s\S]+/}}],directive:{pattern:RegExp(/#/.source+"(?:"+/(?:elseif|if)\b/.source+"(?:[ \t]*"+/(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source+")+|"+/(?:else|endif)\b/.source+")"),alias:"property",inside:{"directive-name":/^#\w+/,boolean:/\b(?:true|false)\b/,number:/\b\d+(?:\.\d+)*\b/,operator:/!|&&|\|\||[<>]=?/,punctuation:/[(),]/}},literal:{pattern:/#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,alias:"constant"},"other-directive":{pattern:/#\w+\b/,alias:"property"},attribute:{pattern:/@\w+/,alias:"atrule"},"function-definition":{pattern:/(\bfunc\s+)\w+/,lookbehind:!0,alias:"function"},label:{pattern:/\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,lookbehind:!0,alias:"important"},keyword:/\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,boolean:/\b(?:true|false)\b/,nil:{pattern:/\bnil\b/,alias:"constant"},"short-argument":/\$\d+\b/,omit:{pattern:/\b_\b/,alias:"keyword"},number:/\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,"class-name":/\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,function:/\b[a-z_]\w*(?=\s*\()/i,constant:/\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,operator:/[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,punctuation:/[{}[\]();,.:\\]/},Prism.languages.swift["string-literal"].forEach((function(e){e.inside.interpolation.inside=Prism.languages.swift;})),function(e){var t="\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b",n={pattern:/(^(["']?)\w+\2)[ \t]+\S.*/,lookbehind:!0,alias:"punctuation",inside:null},a={bash:n,environment:{pattern:RegExp("\\$"+t),alias:"constant"},variable:[{pattern:/\$?\(\([\s\S]+?\)\)/,greedy:!0,inside:{variable:[{pattern:/(^\$\(\([\s\S]+)\)\)/,lookbehind:!0},/^\$\(\(/],number:/\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,operator:/--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,punctuation:/\(\(?|\)\)?|,|;/}},{pattern:/\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,greedy:!0,inside:{variable:/^\$\(|^`|\)$|`$/}},{pattern:/\$\{[^}]+\}/,greedy:!0,inside:{operator:/:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,punctuation:/[\[\]]/,environment:{pattern:RegExp("(\\{)"+t),lookbehind:!0,alias:"constant"}}},/\$(?:\w+|[#?*!@$])/],entity:/\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|x[0-9a-fA-F]{1,2}|u[0-9a-fA-F]{4}|U[0-9a-fA-F]{8})/};e.languages.bash={shebang:{pattern:/^#!\s*\/.*/,alias:"important"},comment:{pattern:/(^|[^"{\\$])#.*/,lookbehind:!0},"function-name":[{pattern:/(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,lookbehind:!0,alias:"function"},{pattern:/\b[\w-]+(?=\s*\(\s*\)\s*\{)/,alias:"function"}],"for-or-select":{pattern:/(\b(?:for|select)\s+)\w+(?=\s+in\s)/,alias:"variable",lookbehind:!0},"assign-left":{pattern:/(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,inside:{environment:{pattern:RegExp("(^|[\\s;|&]|[<>]\\()"+t),lookbehind:!0,alias:"constant"}},alias:"variable",lookbehind:!0},string:[{pattern:/((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,lookbehind:!0,greedy:!0,inside:a},{pattern:/((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,lookbehind:!0,greedy:!0,inside:{bash:n}},{pattern:/(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,lookbehind:!0,greedy:!0,inside:a},{pattern:/(^|[^$\\])'[^']*'/,lookbehind:!0,greedy:!0},{pattern:/\$'(?:[^'\\]|\\[\s\S])*'/,greedy:!0,inside:{entity:a.entity}}],environment:{pattern:RegExp("\\$?"+t),alias:"constant"},variable:a.variable,function:{pattern:/(^|[\s;|&]|[<>]\()(?:add|apropos|apt|aptitude|apt-cache|apt-get|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,lookbehind:!0},keyword:{pattern:/(^|[\s;|&]|[<>]\()(?:if|then|else|elif|fi|for|while|in|case|esac|function|select|do|done|until)(?=$|[)\s;|&])/,lookbehind:!0},builtin:{pattern:/(^|[\s;|&]|[<>]\()(?:\.|:|break|cd|continue|eval|exec|exit|export|getopts|hash|pwd|readonly|return|shift|test|times|trap|umask|unset|alias|bind|builtin|caller|command|declare|echo|enable|help|let|local|logout|mapfile|printf|read|readarray|source|type|typeset|ulimit|unalias|set|shopt)(?=$|[)\s;|&])/,lookbehind:!0,alias:"class-name"},boolean:{pattern:/(^|[\s;|&]|[<>]\()(?:true|false)(?=$|[)\s;|&])/,lookbehind:!0},"file-descriptor":{pattern:/\B&\d\b/,alias:"important"},operator:{pattern:/\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,inside:{"file-descriptor":{pattern:/^\d/,alias:"important"}}},punctuation:/\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,number:{pattern:/(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,lookbehind:!0}},n.inside=e.languages.bash;for(var r=["comment","function-name","for-or-select","assign-left","string","environment","function","keyword","builtin","boolean","file-descriptor","operator","punctuation","number"],i=a.variable[1].inside,s=0;s<r.length;s++)i[r[s]]=e.languages.bash[r[s]];e.languages.shell=e.languages.bash;}(Prism),function(e){var t=/(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;function n(e){return e=e.replace(/<inner>/g,(function(){return t})),RegExp(/((?:^|[^\\])(?:\\{2})*)/.source+"(?:"+e+")")}var a=/(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source,r=/\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g,(function(){return a})),i=/\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;e.languages.markdown=e.languages.extend("markup",{}),e.languages.insertBefore("markdown","prolog",{"front-matter-block":{pattern:/(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,lookbehind:!0,greedy:!0,inside:{punctuation:/^---|---$/,"font-matter":{pattern:/\S+(?:\s+\S+)*/,alias:["yaml","language-yaml"],inside:e.languages.yaml}}},blockquote:{pattern:/^>(?:[\t ]*>)*/m,alias:"punctuation"},table:{pattern:RegExp("^"+r+i+"(?:"+r+")*","m"),inside:{"table-data-rows":{pattern:RegExp("^("+r+i+")(?:"+r+")*$"),lookbehind:!0,inside:{"table-data":{pattern:RegExp(a),inside:e.languages.markdown},punctuation:/\|/}},"table-line":{pattern:RegExp("^("+r+")"+i+"$"),lookbehind:!0,inside:{punctuation:/\||:?-{3,}:?/}},"table-header-row":{pattern:RegExp("^"+r+"$"),inside:{"table-header":{pattern:RegExp(a),alias:"important",inside:e.languages.markdown},punctuation:/\|/}}}},code:[{pattern:/((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,lookbehind:!0,alias:"keyword"},{pattern:/^```[\s\S]*?^```$/m,greedy:!0,inside:{"code-block":{pattern:/^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,lookbehind:!0},"code-language":{pattern:/^(```).+/,lookbehind:!0},punctuation:/```/}}],title:[{pattern:/\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,alias:"important",inside:{punctuation:/==+$|--+$/}},{pattern:/(^\s*)#.+/m,lookbehind:!0,alias:"important",inside:{punctuation:/^#+|#+$/}}],hr:{pattern:/(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,lookbehind:!0,alias:"punctuation"},list:{pattern:/(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,lookbehind:!0,alias:"punctuation"},"url-reference":{pattern:/!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,inside:{variable:{pattern:/^(!?\[)[^\]]+/,lookbehind:!0},string:/(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,punctuation:/^[\[\]!:]|[<>]/},alias:"url"},bold:{pattern:n(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),lookbehind:!0,greedy:!0,inside:{content:{pattern:/(^..)[\s\S]+(?=..$)/,lookbehind:!0,inside:{}},punctuation:/\*\*|__/}},italic:{pattern:n(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),lookbehind:!0,greedy:!0,inside:{content:{pattern:/(^.)[\s\S]+(?=.$)/,lookbehind:!0,inside:{}},punctuation:/[*_]/}},strike:{pattern:n(/(~~?)(?:(?!~)<inner>)+\2/.source),lookbehind:!0,greedy:!0,inside:{content:{pattern:/(^~~?)[\s\S]+(?=\1$)/,lookbehind:!0,inside:{}},punctuation:/~~?/}},"code-snippet":{pattern:/(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,lookbehind:!0,greedy:!0,alias:["code","keyword"]},url:{pattern:n(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),lookbehind:!0,greedy:!0,inside:{operator:/^!/,content:{pattern:/(^\[)[^\]]+(?=\])/,lookbehind:!0,inside:{}},variable:{pattern:/(^\][ \t]?\[)[^\]]+(?=\]$)/,lookbehind:!0},url:{pattern:/(^\]\()[^\s)]+/,lookbehind:!0},string:{pattern:/(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,lookbehind:!0}}}}),["url","bold","italic","strike"].forEach((function(t){["url","bold","italic","strike","code-snippet"].forEach((function(n){t!==n&&(e.languages.markdown[t].inside.content.inside[n]=e.languages.markdown[n]);}));})),e.hooks.add("after-tokenize",(function(e){"markdown"!==e.language&&"md"!==e.language||function e(t){if(t&&"string"!=typeof t)for(var n=0,a=t.length;n<a;n++){var r=t[n];if("code"===r.type){var i=r.content[1],s=r.content[3];if(i&&s&&"code-language"===i.type&&"code-block"===s.type&&"string"==typeof i.content){var o=i.content.replace(/\b#/g,"sharp").replace(/\b\+\+/g,"pp"),l="language-"+(o=(/[a-z][\w-]*/i.exec(o)||[""])[0].toLowerCase());s.alias?"string"==typeof s.alias?s.alias=[s.alias,l]:s.alias.push(l):s.alias=[l];}}else e(r.content);}}(e.tokens);})),e.hooks.add("wrap",(function(t){if("code-block"===t.type){for(var n="",a=0,r=t.classes.length;a<r;a++){var i=t.classes[a],u=/language-(.+)/.exec(i);if(u){n=u[1];break}}var c=e.languages[n];if(c)t.content=e.highlight(function(e){var t=e.replace(s,"");return t=t.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi,(function(e,t){var n;if("#"===(t=t.toLowerCase())[0])return n="x"===t[1]?parseInt(t.slice(2),16):Number(t.slice(1)),l(n);var a=o[t];return a||e}))}(t.content),c,n);else if(n&&"none"!==n&&e.plugins.autoloader){var d="md-"+(new Date).valueOf()+"-"+Math.floor(1e16*Math.random());t.attributes.id=d,e.plugins.autoloader.loadLanguages(n,(function(){var t=document.getElementById(d);t&&(t.innerHTML=e.highlight(t.textContent,e.languages[n],n));}));}}}));var s=RegExp(e.languages.markup.tag.pattern.source,"gi"),o={amp:"&",lt:"<",gt:">",quot:'"'},l=String.fromCodePoint||String.fromCharCode;e.languages.md=e.languages.markdown;}(Prism),Prism.languages.lua={comment:/^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,string:{pattern:/(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,greedy:!0},number:/\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,keyword:/\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,function:/(?!\d)\w+(?=\s*(?:[({]))/,operator:[/[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/,{pattern:/(^|[^.])\.\.(?!\.)/,lookbehind:!0}],punctuation:/[\[\](){},;]|\.+|:+/},Prism.languages.groovy=Prism.languages.extend("clike",{string:[{pattern:/("""|''')(?:[^\\]|\\[\s\S])*?\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,greedy:!0},{pattern:/(["'/])(?:\\.|(?!\1)[^\\\r\n])*\1/,greedy:!0}],keyword:/\b(?:as|def|in|abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,number:/\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,operator:{pattern:/(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,lookbehind:!0},punctuation:/\.+|[{}[\];(),:$]/}),Prism.languages.insertBefore("groovy","string",{shebang:{pattern:/#!.+/,alias:"comment"}}),Prism.languages.insertBefore("groovy","punctuation",{"spock-block":/\b(?:setup|given|when|then|and|cleanup|expect|where):/}),Prism.languages.insertBefore("groovy","function",{annotation:{pattern:/(^|[^.])@\w+/,lookbehind:!0,alias:"punctuation"}}),Prism.hooks.add("wrap",(function(e){if("groovy"===e.language&&"string"===e.type){var t=e.content[0];if("'"!=t){var n=/([^\\])(?:\$(?:\{.*?\}|[\w.]+))/;"$"===t&&(n=/([^\$])(?:\$(?:\{.*?\}|[\w.]+))/),e.content=e.content.replace(/&lt;/g,"<").replace(/&amp;/g,"&"),e.content=Prism.highlight(e.content,{expression:{pattern:n,lookbehind:!0,inside:Prism.languages.groovy}}),e.classes.push("/"===t?"regex":"gstring");}}}));var vn=["comment","prolog","doctype","cdata","punctuation","namespace","property","tag","boolean","number","constant","symbol","deleted","selector","attr-name","string","builtin","inserted","operator","entity","url","string","atrule","attr-value","keyword","function","class-name","regex","important","variable","bold","italic","entity","char"];function Sn(e){return "string"==typeof e?e.length:"string"==typeof e.content?e.content.length:e.content.reduce((function(e,t){return e+Sn(t)}),0)}var wn,kn=g.String,An=function(e){if("Symbol"===nt(e))throw TypeError("Cannot convert a Symbol value to a string");return kn(e)},xn=function(){var e=se(this),t="";return e.global&&(t+="g"),e.ignoreCase&&(t+="i"),e.multiline&&(t+="m"),e.dotAll&&(t+="s"),e.unicode&&(t+="u"),e.sticky&&(t+="y"),t},Tn=g.RegExp,_n=z((function(){var e=Tn("a","y");return e.lastIndex=2,null!=e.exec("abcd")})),On=_n||z((function(){return !Tn("a","y").sticky})),In={BROKEN_CARET:_n||z((function(){var e=Tn("^r","gy");return e.lastIndex=2,null!=e.exec("str")})),MISSED_STICKY:On,UNSUPPORTED_Y:_n},Rn=J?Object.defineProperties:function(e,t){se(e);for(var n,a=jt(t),r=fn(t),i=r.length,s=0;i>s;)Ae.f(e,n=r[s++],a[n]);return e},Nn=F("document","documentElement"),Ln=Fe("IE_PROTO"),Pn=function(){},Cn=function(e){return "<script>"+e+"<\/script>"},Fn=function(e){e.write(Cn("")),e.close();var t=e.parentWindow.Object;return e=null,t},Dn=function(){try{wn=new ActiveXObject("htmlfile");}catch(e){}var e,t;Dn="undefined"!=typeof document?document.domain&&wn?Fn(wn):((t=ne("iframe")).style.display="none",Nn.appendChild(t),t.src=String("javascript:"),(e=t.contentWindow.document).open(),e.write(Cn("document.F=Object")),e.close(),e.F):Fn(wn);for(var n=Kt.length;n--;)delete Dn.prototype[Kt[n]];return Dn()};De[Ln]=!0;var $n,Mn,Bn=Object.create||function(e,t){var n;return null!==e?(Pn.prototype=se(e),n=new Pn,Pn.prototype=null,n[Ln]=e):n=Dn(),void 0===t?n:Rn(n,t)},Un=g.RegExp,jn=z((function(){var e=Un(".","s");return !(e.dotAll&&e.exec("\n")&&"s"===e.flags)})),zn=g.RegExp,Gn=z((function(){var e=zn("(?<a>b)","g");return "b"!==e.exec("b").groups.a||"bc"!=="b".replace(e,"$<a>c")})),Hn=He.get,qn=m("native-string-replace",String.prototype.replace),Yn=RegExp.prototype.exec,Xn=Yn,Wn=w("".charAt),Zn=w("".indexOf),Vn=w("".replace),Kn=w("".slice),Jn=(Mn=/b*/g,le(Yn,$n=/a/,"a"),le(Yn,Mn,"a"),0!==$n.lastIndex||0!==Mn.lastIndex),Qn=In.BROKEN_CARET,ea=void 0!==/()??/.exec("")[1];(Jn||ea||Qn||jn||Gn)&&(Xn=function(e){var t,n,a,r,i,s,o,l=this,u=Hn(l),c=An(e),d=u.raw;if(d)return d.lastIndex=l.lastIndex,t=le(Xn,d,c),l.lastIndex=d.lastIndex,t;var p=u.groups,g=Qn&&l.sticky,f=le(xn,l),b=l.source,h=0,m=c;if(g&&(f=Vn(f,"y",""),-1===Zn(f,"g")&&(f+="g"),m=Kn(c,l.lastIndex),l.lastIndex>0&&(!l.multiline||l.multiline&&"\n"!==Wn(c,l.lastIndex-1))&&(b="(?: "+b+")",m=" "+m,h++),n=new RegExp("^(?:"+b+")",f)),ea&&(n=new RegExp("^"+b+"$(?!\\s)",f)),Jn&&(a=l.lastIndex),r=le(Yn,g?n:l,m),g?r?(r.input=Kn(r.input,h),r[0]=Kn(r[0],h),r.index=l.lastIndex,l.lastIndex+=r[0].length):l.lastIndex=0:Jn&&r&&(l.lastIndex=l.global?r.index+r[0].length:a),ea&&r&&r.length>1&&le(qn,r[0],n,(function(){for(i=1;i<arguments.length-2;i++)void 0===arguments[i]&&(r[i]=void 0);})),r&&p)for(r.groups=s=Bn(null),i=0;i<p.length;i++)s[(o=p[i])[0]]=r[o[1]];return r});var ta=Xn;gn({target:"RegExp",proto:!0,forced:/./.exec!==ta},{exec:ta});var na=Function.prototype,aa=na.apply,ra=na.bind,ia=na.call,sa="object"==typeof Reflect&&Reflect.apply||(ra?ia.bind(aa):function(){return ia.apply(aa,arguments)}),oa=Z("species"),la=RegExp.prototype,ua=Z("match"),ca=g.TypeError,da=Z("species"),pa=function(e,t){var n,a=se(e).constructor;return void 0===a||null==(n=se(a)[da])?t:function(e){if(Ot(e))return e;throw ca(ge(e)+" is not a constructor")}(n)},ga=w("".charAt),fa=w("".charCodeAt),ba=w("".slice),ha=function(e){return function(t,n){var a,r,i=An(A(t)),s=ht(n),o=i.length;return s<0||s>=o?e?"":void 0:(a=fa(i,s))<55296||a>56319||s+1===o||(r=fa(i,s+1))<56320||r>57343?e?ga(i,s):a:e?ba(i,s,s+2):r-56320+(a-55296<<10)+65536}},ma={codeAt:ha(!1),charAt:ha(!0)}.charAt,ya=function(e,t,n){return t+(n?ma(e,t).length:1)},Ea=g.Array,va=Math.max,Sa=function(e,t,n){for(var a,r,i,s,o=Et(e),l=Yt(t,o),u=Yt(void 0===n?o:n,o),c=Ea(va(u-l,0)),d=0;l<u;l++,d++)a=c,r=d,i=e[l],s=void 0,(s=Se(r))in a?Ae.f(a,s,xe(0,i)):a[s]=i;return c.length=d,c},wa=g.TypeError,ka=function(e,t){var n=e.exec;if(P(n)){var a=le(n,e,t);return null!==a&&se(a),a}if("RegExp"===Je(e))return le(ta,e,t);throw wa("RegExp#exec called on incompatible receiver")},Aa=In.UNSUPPORTED_Y,xa=Math.min,Ta=[].push,_a=w(/./.exec),Oa=w(Ta),Ia=w("".slice);!function(e,t,n,a){var r=Z(e),i=!z((function(){var t={};return t[r]=function(){return 7},7!=""[e](t)})),s=i&&!z((function(){var t=!1,n=/a/;return "split"===e&&((n={}).constructor={},n.constructor[oa]=function(){return n},n.flags="",n[r]=/./[r]),n.exec=function(){return t=!0,null},n[r](""),!t}));if(!i||!s||n){var o=w(/./[r]),l=t(r,""[e],(function(e,t,n,a,r){var s=w(e),l=t.exec;return l===ta||l===la.exec?i&&!r?{done:!0,value:o(t,n,a)}:{done:!0,value:s(n,t,a)}:{done:!1}}));Ze(String.prototype,e,l[0]),Ze(la,r,l[1]);}a&&Te(la[r],"sham",!0);}("split",(function(e,t,n){var a;return a="c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1).length||2!="ab".split(/(?:ab)*/).length||4!=".".split(/(.?)(.?)/).length||".".split(/()()/).length>1||"".split(/.?/).length?function(e,n){var a,r,i=An(A(this)),s=void 0===n?4294967295:n>>>0;if(0===s)return [];if(void 0===e)return [i];if(!Q(a=e)||!(void 0!==(r=a[ua])?r:"RegExp"==Je(a)))return le(t,i,e,s);for(var o,l,u,c=[],d=(e.ignoreCase?"i":"")+(e.multiline?"m":"")+(e.unicode?"u":"")+(e.sticky?"y":""),p=0,g=new RegExp(e.source,d+"g");(o=le(ta,g,i))&&!((l=g.lastIndex)>p&&(Oa(c,Ia(i,p,o.index)),o.length>1&&o.index<i.length&&sa(Ta,c,Sa(o,1)),u=o[0].length,p=l,c.length>=s));)g.lastIndex===o.index&&g.lastIndex++;return p===i.length?!u&&_a(g,"")||Oa(c,""):Oa(c,Ia(i,p)),c.length>s?Sa(c,0,s):c}:"0".split(void 0,0).length?function(e,n){return void 0===e&&0===n?[]:le(t,this,e,n)}:t,[function(t,n){var r=A(this),i=null==t?void 0:he(t,e);return i?le(i,t,r,n):le(a,An(r),t,n)},function(e,r){var i=se(this),s=An(e),o=n(a,i,s,r,a!==t);if(o.done)return o.value;var l=pa(i,RegExp),u=i.unicode,c=(i.ignoreCase?"i":"")+(i.multiline?"m":"")+(i.unicode?"u":"")+(Aa?"g":"y"),d=new l(Aa?"^(?:"+i.source+")":i,c),p=void 0===r?4294967295:r>>>0;if(0===p)return [];if(0===s.length)return null===ka(d,s)?[s]:[];for(var g=0,f=0,b=[];f<s.length;){d.lastIndex=Aa?0:f;var h,m=ka(d,Aa?Ia(s,f):s);if(null===m||(h=xa(yt(d.lastIndex+(Aa?f:0)),s.length))===g)f=ya(s,f,u);else {if(Oa(b,Ia(s,g,f)),b.length===p)return b;for(var y=1;y<=m.length-1;y++)if(Oa(b,m[y]),b.length===p)return b;f=g=h;}}return Oa(b,Ia(s,g)),b}]}),!!z((function(){var e=/(?:)/,t=e.exec;e.exec=function(){return t.apply(this,arguments)};var n="ab".split(e);return 2!==n.length||"a"!==n[0]||"b"!==n[1]})),Aa),gn({global:!0},{globalThis:g}),attr&&($$6.fn.attr=attr);var Ra=We.PROPER,Na=RegExp.prototype,La=Na.toString,Pa=w(xn),Ca=z((function(){return "/a/b"!=La.call({source:"a",flags:"b"})})),Fa=Ra&&"toString"!=La.name;(Ca||Fa)&&Ze(RegExp.prototype,"toString",(function(){var e=se(this),t=An(e.source),n=e.flags;return "/"+t+"/"+An(void 0===n&&ue(Na,e)&&!("flags"in Na)?Pa(e):n)}),{unsafe:!0});var Da=function(){function e(){this.title=cp$1("highLightModule.selectLang"),this.iconSvg='<svg viewBox="0 0 1024 1024"><path d="M64 64v896h896V64H64z m487.6 698.8c0 87.2-51.2 127-125.8 127-67.4 0-106.4-34.8-126.4-77l68.6-41.4c13.2 23.4 25.2 43.2 54.2 43.2 27.6 0 45.2-10.8 45.2-53V475.4h84.2v287.4z m199.2 127c-78.2 0-128.8-37.2-153.4-86l68.6-39.6c18 29.4 41.6 51.2 83 51.2 34.8 0 57.2-17.4 57.2-41.6 0-28.8-22.8-39-61.4-56l-21-9c-60.8-25.8-101-58.4-101-127 0-63.2 48.2-111.2 123.2-111.2 53.6 0 92 18.6 119.6 67.4L800 580c-14.4-25.8-30-36-54.2-36-24.6 0-40.2 15.6-40.2 36 0 25.2 15.6 35.4 51.8 51.2l21 9c71.6 30.6 111.8 62 111.8 132.4 0 75.6-59.6 117.2-139.4 117.2z"></path></svg>',this.tag="select",this.width=95,this.selectPanelWidth=115;}return e.prototype.getOptions=function(e){var t=[],n=e.getMenuConfig("codeSelectLang").codeLangs,a=void 0===n?[]:n;t.push({text:"plain text",value:""}),a.forEach((function(e){var n=e.text,a=e.value;t.push({text:n,value:a});}));var r=this.getValue(e);return t.forEach((function(e){e.value===r?e.selected=!0:delete e.selected;})),t},e.prototype.isActive=function(e){return !1},e.prototype.getValue=function(e){var t=this.getSelectCodeElem(e);if(null==t)return "";if(!Element$1.isElement(t))return "";var n=t.language.toString(),a=e.getMenuConfig("codeSelectLang").codeLangs;return (void 0===a?[]:a).some((function(e){return e.value===n}))?n:""},e.prototype.isDisabled=function(e){return null==e.selection||!this.getSelectCodeElem(e)},e.prototype.exec=function(e,n){if(null!=this.getSelectCodeElem(e)){var a={language:n.toString()};Transforms.setNodes(e,a,{match:function(e){return ol$1.checkNodeType(e,"code")}});}},e.prototype.getSelectCodeElem=function(e){var n=ol$1.getSelectedNodeByType(e,"code");if(null==n)return null;var a=ol$1.getParentNode(e,n);return Element$1.isElement(a)?"pre"!==a.type?null:n:null},e}();var $a={renderStyle:function(e,t){var n=e,a=t,r="";return vn.forEach((function(e){n[e]&&(r=e);})),r&&function(e,t){null==e.data&&(e.data={});var n=e.data;null==n.props&&(n.props={}),Object.assign(n.props,{className:t});}(a,r="token "+r),a},parseStyleHtml:function(e,n,r){var s=$$6(e);if(!Element$1.isElement(n))return n;if("code"!==ol$1.getNodeType(n))return n;var o=n,l=s.attr("class")||"";return 0===l.indexOf("language-")?o.language=l.split("-")[1]||"":o.language=l.toLowerCase(),o},menus:[{key:"codeSelectLang",factory:function(){return new Da},config:{codeLangs:[{text:"CSS",value:"css"},{text:"HTML",value:"html"},{text:"XML",value:"xml"},{text:"Javascript",value:"javascript"},{text:"Typescript",value:"typescript"},{text:"JSX",value:"jsx"},{text:"Go",value:"go"},{text:"PHP",value:"php"},{text:"C",value:"c"},{text:"Python",value:"python"},{text:"Java",value:"java"},{text:"C++",value:"cpp"},{text:"C#",value:"csharp"},{text:"Visual Basic",value:"visual-basic"},{text:"SQL",value:"sql"},{text:"Ruby",value:"ruby"},{text:"Swift",value:"swift"},{text:"Bash",value:"bash"},{text:"Lua",value:"lua"},{text:"Groovy",value:"groovy"},{text:"Markdown",value:"markdown"}]}}],elemsToHtml:[{type:"code",elemToHtml:function(e,t){var n=e.language,a=void 0===n?"":n;return "<code "+(a?'class="language-'+a+'"':"")+">"+t+"</code>"}}]},Ma=/"/g,Ba=w("".replace);gn({target:"String",proto:!0,forced:function(e){return z((function(){var t=""[e]('"');return t!==t.toLowerCase()||t.split('"').length>3}))}("anchor")},{anchor:function(e){return t="a",n="name",a=e,r=An(A(this)),i="<"+t,""!==n&&(i+=" "+n+'="'+Ba(An(a),Ma,"&quot;")+'"'),i+">"+r+"</"+t+">";var t,n,a,r,i;}});var Ua=function(e){var n,a,r,i=function(e,t){var n="function"==typeof Symbol&&e[Symbol.iterator];if(!n)return e;var a,r,i=n.call(e),s=[];try{for(;(void 0===t||t-- >0)&&!(a=i.next()).done;)s.push(a.value);}catch(e){r={error:e};}finally{try{a&&!a.done&&(n=i.return)&&n.call(i);}finally{if(r)throw r.error}}return s}(e,2),s=i[0],l=i[1],u=[],c=function(e){if(!Text.isText(e))return null;var n=ol$1.getParentNode(null,e);if(n&&"code"===ol$1.getNodeType(n)){var a=ol$1.getParentNode(null,n);if(a&&"pre"===ol$1.getNodeType(a))return n}return null}(s);if(null==c)return u;var d=c.language,p=void 0===d?"":d;if(!p)return u;var g=function(e,t){if(!t)return [];var n=En.languages[t];return n?En.tokenize(e.text,n):[]}(s,p),f=0;try{for(var b=
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function(e){var t="function"==typeof Symbol&&Symbol.iterator,n=t&&e[t],a=0;if(n)return n.call(e);if(e&&"number"==typeof e.length)return {next:function(){return e&&a>=e.length&&(e=void 0),{value:e&&e[a++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")}(g),h=b.next();!h.done;h=b.next()){var m=h.value,y=f+Sn(m);"string"!=typeof m&&u.push(((r={})[m.type]=!0,r.anchor={path:l,offset:f},r.focus={path:l,offset:y},r)),f=y;}}catch(e){n={error:e};}finally{try{h&&!h.done&&(a=b.return)&&a.call(b);}finally{if(n)throw n.error}}return u};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * @description Editor View class
 * @author wangfupeng
 */
var Boot = /** @class */ (function () {
    function Boot() {
        throw new Error('不能实例化\nCan not construct a instance');
    }
    Boot.setEditorConfig = function (newConfig) {
        if (newConfig === void 0) { newConfig = {}; }
        this.editorConfig = __assign(__assign({}, this.editorConfig), newConfig);
    };
    Boot.setSimpleEditorConfig = function (newConfig) {
        if (newConfig === void 0) { newConfig = {}; }
        this.simpleEditorConfig = __assign(__assign({}, this.simpleEditorConfig), newConfig);
    };
    Boot.setToolbarConfig = function (newConfig) {
        if (newConfig === void 0) { newConfig = {}; }
        this.toolbarConfig = __assign(__assign({}, this.toolbarConfig), newConfig);
    };
    Boot.setSimpleToolbarConfig = function (newConfig) {
        if (newConfig === void 0) { newConfig = {}; }
        this.simpleToolbarConfig = __assign(__assign({}, this.simpleToolbarConfig), newConfig);
    };
    Boot.registerPlugin = function (plugin) {
        this.plugins.push(plugin);
    };
    // 注册 menu
    // TODO 可在注册时传入配置，在开发文档中说明
    Boot.registerMenu = function (menuConf, customConfig) {
        ll$1(menuConf, customConfig);
    };
    // 注册 renderElem
    Boot.registerRenderElem = function (renderElemConf) {
        rd$1(renderElemConf);
    };
    // 注册 renderStyle
    Boot.registerRenderStyle = function (fn) {
        td$1(fn);
    };
    // 注册 elemToHtml
    Boot.registerElemToHtml = function (elemToHtmlConf) {
        kl$1(elemToHtmlConf);
    };
    // 注册 styleToHtml
    Boot.registerStyleToHtml = function (fn) {
        xl$1(fn);
    };
    // 注册 preParseHtml
    Boot.registerPreParseHtml = function (preParseHtmlConf) {
        hc$1(preParseHtmlConf);
    };
    // 注册 parseElemHtml
    Boot.registerParseElemHtml = function (parseElemHtmlConf) {
        yc$1(parseElemHtmlConf);
    };
    // 注册 parseStyleHtml
    Boot.registerParseStyleHtml = function (fn) {
        gc$1(fn);
    };
    // 注册 module
    Boot.registerModule = function (module) {
        registerModule(module);
    };
    // editor 配置
    Boot.editorConfig = {};
    Boot.simpleEditorConfig = {};
    //toolbar 配置
    Boot.toolbarConfig = {};
    Boot.simpleToolbarConfig = {};
    // 注册插件
    Boot.plugins = [];
    return Boot;
}());

/**
 * @description 注册 module
 * @author wangfupeng
 */
function registerModule(module) {
    var menus = module.menus, renderElems = module.renderElems, renderStyle = module.renderStyle, elemsToHtml = module.elemsToHtml, styleToHtml = module.styleToHtml, preParseHtml = module.preParseHtml, parseElemsHtml = module.parseElemsHtml, parseStyleHtml = module.parseStyleHtml, editorPlugin = module.editorPlugin;
    if (menus) {
        menus.forEach(function (menu) { return Boot.registerMenu(menu); });
    }
    if (renderElems) {
        renderElems.forEach(function (renderElemConf) { return Boot.registerRenderElem(renderElemConf); });
    }
    if (renderStyle) {
        Boot.registerRenderStyle(renderStyle);
    }
    if (elemsToHtml) {
        elemsToHtml.forEach(function (elemToHtmlConf) { return Boot.registerElemToHtml(elemToHtmlConf); });
    }
    if (styleToHtml) {
        Boot.registerStyleToHtml(styleToHtml);
    }
    if (preParseHtml) {
        preParseHtml.forEach(function (conf) { return Boot.registerPreParseHtml(conf); });
    }
    if (parseElemsHtml) {
        parseElemsHtml.forEach(function (parseElemHtmlConf) { return Boot.registerParseElemHtml(parseElemHtmlConf); });
    }
    if (parseStyleHtml) {
        Boot.registerParseStyleHtml(parseStyleHtml);
    }
    if (editorPlugin) {
        Boot.registerPlugin(editorPlugin);
    }
}

/**
 * @description register builtin modules
 * @author wangfupeng
 */
Gd.forEach(function (module) { return registerModule(module); });
registerModule(Fi$2);
registerModule(yi$2);
registerModule(Qa);
registerModule(da$1);
registerModule($a);

/**
 * @description svg tag
 * @author wangfupeng
 */
/**
 * 【注意】svg 字符串的长度 ，否则会导致代码体积过大
 * 尽量选择 https://www.iconfont.cn/collections/detail?spm=a313x.7781069.0.da5a778a4&cid=20293
 * 找不到再从 iconfont.com 搜索
 */
// 缩进 right
var INDENT_RIGHT_SVG = '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z"></path></svg>';
// 左对齐
var JUSTIFY_LEFT_SVG = '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>';
// 图片
var IMAGE_SVG = '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>';
// plus
var MORE_SVG = '<svg viewBox="0 0 1024 1024"><path d="M204.8 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path><path d="M505.6 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path><path d="M806.4 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path></svg>';
// 视频
var VIDEO_SVG = '<svg viewBox="0 0 1024 1024"><path d="M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z"></path></svg>';

/**
 * @description toolbar 配置
 * @author wangfupeng
 */
function genDefaultToolbarKeys() {
    return [
        'headerSelect',
        // 'header1',
        // 'header2',
        // 'header3',
        'blockquote',
        '|',
        'bold',
        'underline',
        'italic',
        {
            key: 'group-more-style',
            title: cp$1('editor.more'),
            iconSvg: MORE_SVG,
            menuKeys: ['through', 'code', 'sup', 'sub', 'clearStyle'],
        },
        'color',
        'bgColor',
        '|',
        'fontSize',
        'fontFamily',
        'lineHeight',
        '|',
        'bulletedList',
        'numberedList',
        'todo',
        {
            key: 'group-justify',
            title: cp$1('editor.justify'),
            iconSvg: JUSTIFY_LEFT_SVG,
            menuKeys: ['justifyLeft', 'justifyRight', 'justifyCenter', 'justifyJustify'],
        },
        {
            key: 'group-indent',
            title: cp$1('editor.indent'),
            iconSvg: INDENT_RIGHT_SVG,
            menuKeys: ['indent', 'delIndent'],
        },
        '|',
        'emotion',
        'insertLink',
        // 'editLink',
        // 'unLink',
        // 'viewLink',
        {
            key: 'group-image',
            title: cp$1('editor.image'),
            iconSvg: IMAGE_SVG,
            menuKeys: ['insertImage', 'uploadImage'],
        },
        // 'deleteImage',
        // 'editImage',
        // 'viewImageLink',
        {
            key: 'group-video',
            title: cp$1('editor.video'),
            iconSvg: VIDEO_SVG,
            menuKeys: ['insertVideo', 'uploadVideo'],
        },
        // 'deleteVideo',
        'insertTable',
        'codeBlock',
        // 'codeSelectLang',
        'divider',
        // 'deleteTable',
        '|',
        'undo',
        'redo',
        '|',
        'fullScreen',
    ];
}
function genSimpleToolbarKeys() {
    return [
        'blockquote',
        'header1',
        'header2',
        'header3',
        '|',
        'bold',
        'underline',
        'italic',
        'through',
        'color',
        'bgColor',
        'clearStyle',
        '|',
        'bulletedList',
        'numberedList',
        'todo',
        'justifyLeft',
        'justifyRight',
        'justifyCenter',
        '|',
        'insertLink',
        {
            key: 'group-image',
            title: cp$1('editor.image'),
            iconSvg: IMAGE_SVG,
            menuKeys: ['insertImage', 'uploadImage'],
        },
        'insertVideo',
        'insertTable',
        'codeBlock',
        '|',
        'undo',
        'redo',
        '|',
        'fullScreen',
    ];
}

/**
 * @description hoverbar 配置
 * @author wangfupeng
 */
var COMMON_HOVERBAR_KEYS = {
    // key 即 element type
    link: {
        menuKeys: ['editLink', 'unLink', 'viewLink'],
    },
    image: {
        menuKeys: [
            'imageWidth30',
            'imageWidth50',
            'imageWidth100',
            'editImage',
            'viewImageLink',
            'deleteImage',
        ],
    },
    pre: {
        menuKeys: ['enter', 'codeBlock', 'codeSelectLang'],
    },
    table: {
        menuKeys: [
            'enter',
            'tableHeader',
            'tableFullWidth',
            'insertTableRow',
            'deleteTableRow',
            'insertTableCol',
            'deleteTableCol',
            'deleteTable',
        ],
    },
    divider: {
        menuKeys: ['enter'],
    },
    video: {
        menuKeys: ['enter', 'editVideoSize'],
    },
};
function genDefaultHoverbarKeys() {
    return __assign(__assign({}, COMMON_HOVERBAR_KEYS), { 
        // 也可以自定义 match 来匹配元素，此时 key 就随意了
        text: {
            menuKeys: [
                'headerSelect',
                'insertLink',
                'bulletedList',
                '|',
                'bold',
                'through',
                'color',
                'bgColor',
                'clearStyle',
            ],
        } });
}
function genSimpleHoverbarKeys() {
    return COMMON_HOVERBAR_KEYS;
}

/**
 * @description 获取编辑器默认配置
 * @author wangfupeng
 */
function getDefaultEditorConfig() {
    return {
        hoverbarKeys: genDefaultHoverbarKeys(),
    };
}
function getSimpleEditorConfig() {
    return {
        hoverbarKeys: genSimpleHoverbarKeys(),
    };
}
function getDefaultToolbarConfig() {
    return {
        toolbarKeys: genDefaultToolbarKeys(),
    };
}
function getSimpleToolbarConfig() {
    return {
        toolbarKeys: genSimpleToolbarKeys(),
    };
}

/**
 * @description set default config
 * @author wangfupeng
 */
var defaultEditorConfig = getDefaultEditorConfig();
Boot.setEditorConfig(__assign(__assign({}, defaultEditorConfig), { decorate: Ua }));
var simpleEditorConfig = getSimpleEditorConfig();
Boot.setSimpleEditorConfig(__assign(__assign({}, simpleEditorConfig), { decorate: Ua }));
var defaultToolbarConfig = getDefaultToolbarConfig();
Boot.setToolbarConfig(defaultToolbarConfig);
var simpleToolbarConfig = getSimpleToolbarConfig();
Boot.setSimpleToolbarConfig(simpleToolbarConfig);

/**
 * @description create
 * @author wangfupeng
 */
/**
 * 创建 editor 实例
 */
function createEditor(option) {
    if (option === void 0) { option = {}; }
    var _a = option.selector, selector = _a === void 0 ? '' : _a, _b = option.content, content = _b === void 0 ? [] : _b, html = option.html, _c = option.config, config = _c === void 0 ? {} : _c, _d = option.mode, mode = _d === void 0 ? 'default' : _d;
    var globalConfig = mode === 'simple' ? Boot.simpleEditorConfig : Boot.editorConfig;
    // 单独处理 hoverbarKeys
    var newHoverbarKeys = __assign(__assign({}, (globalConfig.hoverbarKeys || {})), (config.hoverbarKeys || {}));
    var editor = nh({
        selector: selector,
        config: __assign(__assign(__assign({}, globalConfig), config), { hoverbarKeys: newHoverbarKeys }),
        content: content,
        html: html,
        plugins: Boot.plugins,
    });
    return editor;
}
/**
 * 创建 toolbar 实例
 */
function createToolbar(option) {
    var selector = option.selector, editor = option.editor, _a = option.config, config = _a === void 0 ? {} : _a, _b = option.mode, mode = _b === void 0 ? 'default' : _b;
    if (!selector) {
        throw new Error("Cannot find 'selector' when create toolbar");
    }
    var globalConfig = mode === 'simple' ? Boot.simpleToolbarConfig : Boot.toolbarConfig;
    var toolbar = lh(editor, {
        selector: selector,
        config: __assign(__assign({}, globalConfig), config),
    });
    return toolbar;
}

/**
 * @description editor entry
 * @author wangfupeng
 */
var index = {};

export { Boot, ol$1 as DomEditor, Editor as SlateEditor, Element$1 as SlateElement, Location as SlateLocation, Node$1 as SlateNode, Path as SlatePath, Point as SlatePoint, Range as SlateRange, Text as SlateText, Transforms as SlateTransforms, sh as Toolbar, createEditor, createToolbar, gh as createUploader, index as default, Ud as genModalButtonElems, zd$1 as genModalInputElems, Hd$1 as genModalTextareaElems, sp$1 as i18nAddResources, lp$1 as i18nChangeLanguage, up$1 as i18nGetResources, cp$1 as t };
